/**
 * @ngdoc overview
 * @name app.authentication
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.authentication', [])
        .config(configuration)
        .config(authentication);

    function authentication($authProvider){
        $authProvider.google({
            clientId: '146379198005-916tvuu5tgv19rpink6m0i8gmlgtinbn.apps.googleusercontent.com',
            scope: 'https://www.googleapis.com/auth/analytics.readonly',
            responseType: 'code',
            url:'/api/auth/google_analytics/',
            redirectUri: window.location.origin
        });
    }

    /* @ngInject */
    function configuration($stateProvider){
        $stateProvider
            .state('login', {
                    url:'/login',
                    bgBackgroundClass: 'loginBackground',
                    views:{
                        '@': {
                            templateUrl:'app/authentication/auth.html',
                            controller:'Authentication as vm'
                        }
                    }
                }
            );
    }

}());

/**
 * @ngdoc overview
 * @name app.common
 * @description Host of all the cross cutting source
 */

(function(){

  'use strict';

  angular.module('app.common', [

  ]);

}());

/**
 * Created by immadimtiaz on 12/10/16.
 */
'use strict';

angular.module('app.core', [
    'ngMessages',
    'ngAnimate',
    'restangular',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngCookies',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'LocalStorageModule',
    'ngFileSaver',
    'angularMoment',
    'ngBootstrap',
    'selectize',
    'uiCropper',
    'angularSpectrumColorpicker',
    'ui.validate',
    'satellizer',
    'ngFileUpload',
    'infinite-scroll',
    'angucomplete-alt',
    'angularMoment'
]);
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('app.dashboard', [
        'app.dashboard.website',
        'app.dashboard.user',
        'app.dashboard.products',
        'app.dashboard.businessPartner',
        'app.dashboard.tradeBook',
        'app.dashboard.localTradeBook',
        'app.dashboard.settings',
        'app.dashboard.modals',
        'app.dashboard.pricing',
        'app.dashboard.manifest',
        'app.dashboard.documentCreator',
        'app.dashboard.shipping',
        'app.dashboard.currencyExchange',
        'app.dashboard.accounts',
        'app.dashboard.inventory'
    ]).config(routeConfig);



    /** @ngInject */
    function routeConfig($stateProvider, baSidebarServiceProvider){
        baSidebarServiceProvider.addStaticItem({
            title: 'Dashboard',
            priority: 1,
            icon: 'ion-ios-pulse-strong',
            stateRef: 'dashboard.main'
        });
        baSidebarServiceProvider.addStaticItem({
            title: 'Products',
            icon: 'ion-bag',
            priority: 2,
            subMenu: [
                {
                    title: 'Categories',
                    stateRef: 'dashboard.productsCategories'
                },
                {
                    title: 'Products',
                    stateRef: 'dashboard.products'
                },
                {
                    title: 'Product Items',
                    stateRef: 'dashboard.productsItems'
                },
                {
                    title: 'Keywords',
                    stateRef: 'dashboard.productKeywords'
                }

            ]
        });

        baSidebarServiceProvider.addStaticItem({
            title: 'Manifest',
            priority: 3,
            icon: 'ion-android-clipboard',
            stateRef: 'dashboard.manifestDashboard'
        });

        baSidebarServiceProvider.addStaticItem({
            title: 'Pricing',
            priority: 4,
            icon: 'ion-arrow-graph-up-right',
            stateRef: 'dashboard.pricing.dashboard'
        });
        baSidebarServiceProvider.addStaticItem({
            title: 'Business Partner',
            priority: 5,
            icon: 'ion-ios-people',
            stateRef: 'dashboard.businessPartner'
        });
        baSidebarServiceProvider.addStaticItem({
            title: 'Inventory',
            priority: 6,
            icon: 'ion-clipboard',
            stateRef: 'dashboard.inventory.dashboard'
        });
        // baSidebarServiceProvider.addStaticItem({
        //     title: 'Trade Book',
        //     icon: 'ion-social-usd',
        //     stateRef: 'dashboard.tradeDashboard'
        // });
        baSidebarServiceProvider.addStaticItem({
            title: 'Local Trade Book',
            priority: 8,
            icon: 'ion-social-usd',
            stateRef: 'dashboard.localTradeBook'
        });


        baSidebarServiceProvider.addStaticItem({
            title: 'Accounts',
            priority: 9,
            icon: 'ion-calculator',
            stateRef: 'dashboard.accounts.main'
        });
        baSidebarServiceProvider.addStaticItem({
            title: 'Website',
            priority: 10,
            icon: 'ion-ios-monitor',
            stateRef: 'dashboard.website'
        });
        baSidebarServiceProvider.addStaticItem({
            title: 'Shipment',
            priority: 11,
            icon: 'ion-android-boat',
            stateRef: 'dashboard.shipping'
        });
        baSidebarServiceProvider.addStaticItem({
            title: 'Document Creator',
            priority: 12,
            icon: 'ion-android-document',
            stateRef: 'dashboard.documentCreator'
        });

        // baSidebarServiceProvider.addStaticItem({
        //     title: 'Settings',
        //     icon: 'ion-android-settings',
        //     stateRef: 'dashboard.settings'
        // });




        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                abstract: true,
                title:'Dashboard',
                views: {
                    '@': {
                        templateUrl:'app/dashboard/shell/shell.html'
                    }
                },
                resolve:{
                    userData: function(authentication){
                        return authentication.getUserData();
                    }
                }
            })
            .state('dashboard.main', {
                url: '/main',
                title:'Dashboard',
                pageHeader:{
                    subTitle: 'Business',
                    title:'Dashboard',
                    headerAnchor: [

                    ]
                },
                resolve:{
                  completeReport: function(dashboard, loaderModal){
                      loaderModal.open();
                      return dashboard.getCompleteDashboardReport().then(function(res){
                         return res.data;
                      }).finally(function(){
                          loaderModal.close();
                      });
                  }
                },
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/dashboard.html',
                        controller: 'Dashboard as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.landing', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('landing', {
                nodashBackground: true,
                url: '/landing',
                views: {
                    '@': {
                        templateUrl:'app/landing/shell/shell.html'
                    },
                    'header@landing':{
                        templateUrl:'app/landing/shell/header.html'
                    }
                }
            })
            .state('landing.home', {
                url: '/home',
                nodashBackground: true,
                title:'Home',
                views: {
                    'content@landing':{
                        templateUrl:'app/landing/home/home.html',
                        controller: 'homeCtrl as vm'
                    }
                }
            });
    }

})();

/**
 * @ngdoc overview
 * @name app.modal
 * @description < description placeholder >
 */

(function(){

  'use strict';

  angular
    .module('app.modal', [])
    .config(configuration);

  /* @ngInject */
  function configuration($stateProvider){

    //add your state mappings here
    //$stateProvider
    //  .state('Welcome', {
    //    url:'/welcome',
    //    templateUrl:'src/welcome/welcome.html',
    //    controller: 'WelcomeCtrl as vm'
    //  }
    //);
  }

}());

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.dashboard.modals', [])

})();

(function () {
  'use strict';

  // angular.module('app.pages', [
  //   'app.pages.dashboard'
  // ]);
      // .config(routeConfig);

  // /** @ngInject */
  // function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
  //   $urlRouterProvider.otherwise('/dashboard');
  //
  //   baSidebarServiceProvider.addStaticItem({
  //     title: 'Pages',
  //     icon: 'ion-document',
  //     subMenu: [{
  //       title: 'Sign In',
  //       fixedHref: 'auth.html',
  //       blank: true
  //     }, {
  //       title: 'Sign Up',
  //       fixedHref: 'reg.html',
  //       blank: true
  //     }, {
  //       title: 'User Profile',
  //       stateRef: 'profile'
  //     }, {
  //       title: '404 Page',
  //       fixedHref: '404.html',
  //       blank: true
  //     }]
  //   });
  //   baSidebarServiceProvider.addStaticItem({
  //     title: 'Menu Level 1',
  //     icon: 'ion-ios-more',
  //     subMenu: [{
  //       title: 'Menu Level 1.1',
  //       disabled: true
  //     }, {
  //       title: 'Menu Level 1.2',
  //       subMenu: [{
  //         title: 'Menu Level 1.2.1',
  //         disabled: true
  //       }]
  //     }]
  //   });
  // }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'app.theme.components'
  ]);

})();

/**
 * Created by immadimtiaz on 12/10/16.
 */
/**
 * Created by immadimtiaz on 12/10/16.
 */
'use strict';

angular.module('app.widgets', [
    'app.widgets.ui',
    'app.widgets.components',
    'app.widgets.form',
    'app.widgets.tables',
    'app.widgets.charts',
    'app.widgets.maps',
    'app.widgets.profile'
]);
(function () {
    'use strict';

    angular.module('app.dashboard.accounts', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('dashboard.accounts', {
                url: '/accounts',
                abstract: true,
                title: 'Accounts',
                views: {
                    'content@dashboard': {
                        template: '<div ui-view="content"></div>'
                    }
                }
            })
            .state('dashboard.accounts.main', {
                url: '/accounts',
                title: 'Accounts',
                views:{
                    'content@dashboard.accounts':{
                        templateUrl:'app/dashboard/accounts/dashboard.html',
                        controller: 'AccountDashboard as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Accounts',
                    title:'Dashboard',
                    headerAnchor: [
                        {
                            text: 'Commission Flow',
                            state: 'dashboard.accounts.taccounts'
                        },
                        {
                            text: 'Invoices',
                            state: 'dashboard.accounts.invoice'
                        }
                    ]
                }
            })

            .state('dashboard.accounts.invoice',{
                url:'/invoice',
                views:{
                    'content@dashboard.accounts':{
                        templateUrl:'app/dashboard/accounts/invoice/invoice.html',
                        controller: 'Invoice as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Invoices',
                    title:'Manager',
                    back: true
                }
            })

            .state('dashboard.accounts.invoiceForm',{
                url:'/:fileId/:invoiceId',
                views:{
                    'content@dashboard.accounts':{
                        templateUrl:'app/dashboard/accounts/invoice/invoiceForm.html',
                        controller: 'InvoiceForm as vm'
                    }
                },
                pageHeader:{
                    goBack: true
                },
                resolve:{
                    invoice: function(accounts, $stateParams, loaderModal, $rootScope){
                        loaderModal.open();
                        return accounts.getInvoiceObj($stateParams.fileId, $stateParams.invoiceId).then(function(response){
                            loaderModal.close();
                            if($stateParams.invoiceId === 'new'){
                                $rootScope.headerTitle = 'New Invoice';
                                $rootScope.headerSubTitle = 'File Id ' + $stateParams.fileId ;

                            }
                            else{
                                $rootScope.headerSubTitle = 'File Id ' + $stateParams.fileId ;
                                $rootScope.headerTitle = 'Invoice No. ' + $stateParams.invoiceId;
                            }

                            return response.invoiceObj;
                        });
                    }
                },
            })

            .state('dashboard.accounts.taccounts',{
                url:'/commissionFlow',
                views:{
                    'content@dashboard.accounts':{
                        templateUrl:'app/dashboard/accounts/taccounts/taccounts.html',
                        controller: 'TAccounts as vm'
                    }
                }
            });
    }
})();
/**
 * @ngdoc overview
 * @name app.businessPartner
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.businessPartner', [])
        .config(configuration);

    /* @ngInject */
    function configuration($stateProvider){
        $stateProvider
            .state('dashboard.businessPartner', {
                url:'/businessPartner',
                subNav: true,
                subNavTitle: 'Business Partner',
                views:{
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/businessPartner/businessPartner.html',
                        controller: 'BusinessPartner as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Business'
                },
                resolve: {
                    'allBusiness': function(businessPartner, loaderModal, $state){
                        if($state.current.name==='dashboard.businessPartner.form'){
                            return [];
                        }
                        else{
                            loaderModal.open();

                            return businessPartner.getBusinessPartnerList(businessPartner.getBusinessPartnerListIndex()).then(function(res){
                                loaderModal.close();
                                return res.businessList;
                            });
                        }
                    }
                }
            })
            .state('dashboard.businessPartner.report', {
                url:'/report/:id',
                views:{
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/businessPartner/report/businessReport.html',
                        controller: 'BusinessReport as vm'
                    }
                },
                resolve:{
                    'businessReport': function(businessPartner, $stateParams){
                        return businessPartner.getBusinessReport($stateParams.id).then(function(res){
                            return res.businessReport;
                        })
                    }
                }

            })
            .state('dashboard.businessPartner.form', {
                url:'/form/:id',
                views:{
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/businessPartner/businessPartnerForm.html',
                        controller: 'BusinessPartner as vm'
                    }
                }
            });

    }

}());

(function () {
    'use strict';

    angular.module('app.dashboard.currencyExchange', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('dashboard.currencyExchange', {
                url: '/currency',
                abstract: true,
                title: 'Currency Exchange',
                views: {
                    'content@dashboard': {
                        template: '<div ui-view="content"></div>'
                    }
                }
            })
            .state('dashboard.currencyExchange.dashboard',{
                url:'/exchange/:currencyIn/:currencyOut',
                views:{
                    'content@dashboard.currencyExchange':{
                        templateUrl:'app/dashboard/currencyExchange/currencyDashboard.html',
                        controller: 'CurrencyDashboard as vm'

                    }
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('app.dashboard.documentCreator', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.documentCreator', {
                url: '/documentCreator',
                title: 'Document Creator',
                views: {
                    'content@dashboard': {
                        templateUrl: 'app/dashboard/documentCreator/documentCreator.html',
                        controller: 'DocumentCreator as vm'
                    }
                },
            });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard.localTradeBook', [])
        .config(configuration);

    function configuration(){
        $stateProvider
            .state('dashboard.internalTradeBook', {
                url:'/tradeBook',
                subNav: true,
                subNavTitle: 'Internal Trade Book',
                pageHeader:{
                    subTitle: 'Business',
                    title:'Internal Trade',
                    headerAnchor: [
                        {
                            text: 'Add New Internal Trade',
                            state: 'dashboard.transaction({id:"new"})'
                        }
                    ]
                },
                views:
                {
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/tradeBook/tradeBook.html',
                        controller: 'TradeBook as vm'
                    }
                }
            })
    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.inventory', [])
        .config(routeConfig);

    function routeConfig($stateProvider, baSidebarServiceProvider) {
        $stateProvider
            .state('dashboard.inventory', {
                url: '/inventory',
                abstract: true,
                title: 'Inventory',
                views: {
                    'content@dashboard': {
                        template: '<div ui-view="content"></div>'
                    }
                }
            })
            .state('dashboard.inventory.dashboard', {
                url: '/summary',
                title:'Inventory Dashboard',
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/inventoryDashboard.html',
                        controller: 'InventoryDashboard as vm'
                    }
                },
                resolve: {
                    dashboardData: function (inventory) {
                        return inventory.getDashboardData().then(function(res){
                            return res.data
                        });
                    }
                },
                pageHeader:{
                    subTitle: 'Inventory',
                    title:'Dashboard',
                    headerAnchor: [
                        {
                            text: 'Warehouses',
                            state: 'dashboard.inventory.warehouses'
                        },
                        {
                            text: 'Inventory Record Book',
                            state: 'dashboard.inventory.inventoryTransactions'
                        }
                    ]
                }
            })
            .state('dashboard.inventory.warehouses',{
                url: '/warehouses',
                title: 'Warehouses',
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/warehouses.html',
                        controller:'Warehouses as vm'
                    }
                },
                resolve:{
                    allWarehouses: function($rootScope, $stateParams, inventory){
                        return inventory.getWarehouseList().then(function(res){
                            return res.list;
                        })
                    }
                },
                pageHeader:{
                    subTitle: 'All',
                    title:'Warehouses',
                    headerAnchor: [
                        {
                            text: 'Add New Warehouse',
                            state: 'dashboard.inventory.warehousesForm({id:"new"})'
                        }
                    ],
                    goBack: true
                }
            })
            .state('dashboard.inventory.warehousesLotReport',{
                url: '/warehouses',
                title: 'Warehouses Lot Report',
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/warehouseLotReport.html',
                        controller:'Wareh as vm'
                    }
                },
                resolve:{

                },
                pageHeader:{
                    goBack: true
                }
            })
            .state('dashboard.inventory.warehousesForm',{
                url: '/warehouse/:id',
                title: 'Warehouses',
                pageHeader:{
                    goBack: true
                },
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/warehouseForm.html',
                        controller:'WarehouseForm as vm'
                    }
                },
                resolve:{
                    warehouseObj: function($rootScope, $stateParams, inventory){
                        if($stateParams.id === 'new'){
                            $rootScope.headerSubTitle = 'Add New';
                            $rootScope.headerTitle = 'Warehouse';
                            return inventory.getNewWarehouseObj();
                        }
                        else{
                            return inventory.getWarehouseDetails($stateParams.id, false).then(function(res){
                                if(res.success){
                                    return res.warehouseObj;
                                }
                            })
                        }
                    }
                }

            })
            .state('dashboard.inventory.warehouseDetails',{
                url: '/warehouseDetails/:id',
                title: 'Warehouses',
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/warehouseDetails.html',
                        controller:'WarehousesDetails as vm'
                    }
                },
                pageHeader:{
                    goBack: true
                },
                resolve:{
                    warehouseObj: function($rootScope, $stateParams, inventory){
                        return inventory.getWarehouseDetails($stateParams.id, true).then(function(res){
                            if(res.success){
                                $rootScope.headerSubTitle = 'Warehouse';
                                $rootScope.headerTitle = res.warehouseObj.name;
                                return res.warehouseObj;
                            }
                        })
                    }
                }

            })
            .state('dashboard.inventory.inventoryTransactionForm', {
                url: '/inventoryForm/:id',
                title: 'Inventory Transaction',
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/inventoryTransactionForm.html',
                        controller:'InventoryTransactionForm as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Inventory',
                    title:'Dashboard',
                    goBack:true
                },
                resolve:{
                    inventoryRecord: function($stateParams, inventory, loaderModal){
                        if($stateParams.id==='new'){
                            return inventory.getNewInventoryRecordObj();
                        }
                        else{
                            return inventory.getInventoryRecord($stateParams.id).then(function(res){
                                if(res.success){
                                    return res.recordObj;
                                }
                            })
                        }
                    }
                }
            })
            .state('dashboard.inventory.inventoryTransactions', {
                url: '/inventoryTransactions',
                title: 'Inventory Transactions',
                views:{
                    'content@dashboard.inventory':{
                        templateUrl:'app/dashboard/inventory/inventoryTransactions.html',
                        controller:'InventoryTransactions as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Inventory',
                    title:'Record Book',
                    headerAnchor: [
                        {
                            text: 'Add New Inventory Record',
                            state: 'dashboard.inventory.inventoryTransactionForm({id: "new"})'
                        }
                    ],
                    goBack:true
                }
            });
    }


})();
(function () {
    'use strict';

    angular
        .module('app.dashboard.localTradeBook', [])
        .config(configuration);

    function configuration($stateProvider){
        $stateProvider
            .state('dashboard.localTradeBook', {
                url:'/localTradeBook',
                subNav: true,
                subNavTitle: 'Trade Book',
                pageHeader:{
                    subTitle: 'Business',
                    title:'Local Trade Book',
                    headerAnchor: [
                        {
                            text: 'Add New Local Transaction',
                            state: 'dashboard.localTransactionForm({id:"new"})'
                        }
                    ]
                },
                views:
                {
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/localTradeBook/localTradeBook.html',
                        controller: 'LocalTradeBook as vm'
                    }
                }
            })
            .state('dashboard.localTransactionForm', {
                url: '/localTrade/:id',
                title:'Local Trade',
                pageHeader:{
                    subTitle: 'Add New',
                    title:'Local Transaction',
                    goBack: true
                },
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/localTradeBook/transaction/localTradebookForm.html',
                        controller:'LocalTradeBookForm as vm'
                    }
                },
                resolve: {
                    localTrade : function(localTradeBook, $stateParams){
                        if($stateParams.id==='new'){
                            return localTradeBook.getNewLocalTrade();
                        }
                        else{
                            return localTradeBook.getTransactionDetail($stateParams.id, false).then(function(res){
                                return res.localTrade;
                            })
                        }
                    }
                }
            })
            .state('dashboard.localTransactionView',{
                url:'/localTradeView/:fileId',
                title: 'Local Trade',
                views:{
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/localTradeBook/transaction/localTransactionView.html',
                        controller: 'LocalTradeBookView as vm'
                    }
                },
                resolve: {
                    localTrade : function(localTradeBook, $stateParams, loaderModal){
                        loaderModal.open();
                        return localTradeBook.getTransactionDetail($stateParams.fileId, false)
                            .then(function(res){
                                loaderModal.close();
                                return res.localTrade;
                            })
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.manifest', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider){

        $stateProvider
            .state('dashboard.manifest', {
                url: '/manifest',
                title:'Manifest',
                pageHeader:{
                    subTitle: 'Port',
                    title:'Manifest'
                },
                views: {
                    'content@dashboard':{
                        controller: 'Manifest as vm',
                        templateUrl:'app/dashboard/manifest/manifest.html'
                    }
                }
            })
            .state('dashboard.manifestDashboard', {
                url: '/manifestReport',
                title:'Manifest Report',
                pageHeader:{
                    subTitle: 'Manifest',
                    title:'Report'
                },
                views:{
                    'content@dashboard':{
                        controller: 'ManifestDashboard as vm',
                        templateUrl:'app/dashboard/manifest/manifestDashboard.html'
                    }
                }
            });

    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.pricing', [
        'app.dashboard.pricing.items'
    ]).config(routeConfigPricing);

    angular.module('app.dashboard.pricing.items',
        []).config(routeConfigPricingItems);

    /** @ngInject */
    function routeConfigPricing($stateProvider){
        $stateProvider
            .state('dashboard.pricing', {
                url: '',
                abstract: true,
                title:'Pricing',
                views: {
                    'content@dashboard':{
                        template:'<div ui-view="pricing"></div>'
                    }
                }
            });
    }


    /** @ngInject */
    function routeConfigPricingItems($stateProvider, $urlRouterProvider){
        $stateProvider
            .state('dashboard.pricing.dashboard', {
                url: '/pricing',
                title:'Pricing Dashboard',
                views: {
                    'pricing@dashboard.pricing':{
                        templateUrl:'app/dashboard/pricing/pricing.html',
                        controller: 'Pricing as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Product',
                    title:'Pricing'
                },
                resolve:{
                    'allProductPriceSummary': function(pricing, loaderModal){
                        loaderModal.open();
                        return pricing.getAllProductPriceSummary().then(function(res){
                            loaderModal.close();
                            return res.data.priceSummary;
                        });
                    }
                }
            })
            .state('dashboard.pricing.market',{
                url:'/market',
                title: 'Price Market',
                pageHeader:{
                    subTitle: 'Add',
                    title: 'Price Market'
                },
                views:{
                    'pricing@dashboard.pricing':{
                        templateUrl: 'app/dashboard/pricing/priceMarket.html',
                        controller: 'PriceMarket as vm'
                    }
                },
                resolve:{
                    'allMarkets': function(pricing, loaderModal){
                        loaderModal.open();
                        return pricing.getAllPriceMarkets().then(function(response){
                            loaderModal.close();
                            return (response.data.pricingMarket);
                        });
                    }
                }

            })
            .state('dashboard.pricing.productItems', {
                url: 'pricing/products',
                title:'Pricing ',
                pageHeader:{
                    subTitle: 'Add',
                    title:'Product Price'
                },
                resolve:{
                    'allPriceItems': function(pricing, loaderModal, utilities){
                        loaderModal.open();
                        var dateRange = utilities.todayDateRange();
                        return pricing.getAllProductItemPrice(dateRange).then(function(res){
                            loaderModal.close();
                            return res.data.allPrices;
                        })
                    }
                },
                views: {
                    'pricing@dashboard.pricing':{
                        templateUrl:'app/dashboard/pricing/productPricing.html',
                        controller:'ProductPricing as vm'
                    }
                }
            })
            .state('dashboard.pricing.priceAnalytics', {
                url: 'pricing/analytics/:productItemId',
                title:'Pricing Analytics',
                views: {
                    'pricing@dashboard.pricing':{
                        templateUrl:'app/dashboard/pricing/priceAnalytics.html',
                        controller:'PriceAnalytics as vm'
                    }
                }
            });

        $urlRouterProvider.when('/pricing','/pricing/market');
    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.products', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, baSidebarServiceProvider){
        $stateProvider
            .state('dashboard.products', {
                url: '/products',
                title:'Products',
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/products/products.html',
                        controller: 'Products as vm'
                    }
                },
                resolve: {
                    'allProducts': function(product, loaderModal){
                        loaderModal.open();
                        return product.getAllProductList().then(function(success){
                            loaderModal.close();
                            return success.allProducts;
                        })
                    }
                },
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Products'
                }

            })
            .state('dashboard.productsCategories', {
                url: '/categories',
                title:'Products Categories',
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/products/productCategories.html',
                        controller: 'ProductCategories as vm'
                    }
                },
                resolve: {
                    'allCategories': function(product, loaderModal){
                        loaderModal.open();
                        return product.getAllProductCategories().then(function(success){
                            loaderModal.close();
                            return success.allCategories;
                        })
                    }
                },
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Product Categories'
                }

            })
            .state('dashboard.productsItems', {
                url: '/productItems',
                title:'Product Items',
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/products/productItems.html',
                        controller: 'ProductItems as vm'
                    }
                },
                resolve: {
                    'allProductItems': function(product, loaderModal){
                        loaderModal.open();
                        return product.getAllProductItems().then(function(res){
                            loaderModal.close();
                            return res.data.productItems;
                        })
                    }
                },
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Product Items'
                }

            })
            .state('dashboard.productPriceAnalytics', {
                url: '/productPrice/:productItemId',
                title:'Product Price Report',
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/products/priceAnalytics.html',
                        controller: 'ProductPriceAnalytics as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Product',
                    title:'Price Report'
                }

            })

            .state('dashboard.productSpecification', {
                url:'/productSpecification/:categoryId',
                title: 'Product Specification',
                views:{
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/products/productSpecification.html',
                        controller: 'ProductSpecification as vm'
                    }
                },
                resolve: {
                    'specificationData': function(product, loaderModal, $stateParams){
                        loaderModal.open();
                        return product.getProductCategorySpecification($stateParams.categoryId).then(function(success){
                            loaderModal.close();
                            return success.data;
                        }).finally(function(){
                            loaderModal.close();
                        });
                    }
                },
                pageHeader:{
                    subTitle: 'Category',
                    title:'Specification'
                }

            })

            .state('dashboard.productKeywords', {
                url: '/productKeywords',
                title:'Product Keywords',
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/products/productKeyword.html',
                        controller: 'ProductKeyword as vm'
                    }
                },
                resolve: {
                    allKeywords: function (product, loaderModal, apiEndPoints, crud) {
                        loaderModal.open();
                        return product.getAllKeywords().then(function(res){
                            loaderModal.close();
                            return res.data.keywords;
                        });
                    }
                },
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Product Keywords'
                }

            });
    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.settings', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider){
        // $urlRouterProvider.when('/dashboard/settings/','/dashboard/settings/transactionStatus');
        $stateProvider
            .state('dashboard.settings', {
                url: '/settings',
                title:'Settings',
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Settings'
                },
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/settings/settings.html',
                        controller: 'settings as vm'
                    }
                }
            });


            // .state('dashboard.settings.transactionStatus',{
            //     url:'/transactionStatus',
            //     title: 'Transaction Status',
            //     views:{
            //         'content@dashboard.settings':{
            //             templateUrl:'app/dashboard/settings/appDropDowns/appDropDown.html',
            //             controller: 'appDropDown as vm'
            //         }
            //     },
            //     resolve:{
            //         list: function(settings, apiEndPoints, crud){
            //             return settings.dropDown[crud.READ](apiEndPoints.dropDown.transactionStatus).then(function(response){
            //                 return response.list;
            //             });
            //         },
            //         endPoint: function(apiEndPoints){
            //             return apiEndPoints.dropDown.transactionStatus;
            //         },
            //         page: function(modalTemplates){
            //             return modalTemplates.CR_UP_BASIC_DROP_DOWN;
            //         }
            //     }
            // })
            // .state('dashboard.settings.bpTypes',{
            //     url:'/bpTypes',
            //     title: 'Business Partner Type',
            //     views:{
            //         'content@dashboard.settings':{
            //             templateUrl:'app/dashboard/settings/appDropDowns/appDropDown.html',
            //             controller: 'appDropDown as vm'
            //         }
            //     },
            //     resolve:{
            //         list: function(settings, apiEndPoints, crud){
            //             return settings.dropDown[crud.READ](apiEndPoints.dropDown.businessType).then(function(response){
            //                 return response.list;
            //             });
            //         },
            //         endPoint: function(apiEndPoints){
            //             return apiEndPoints.dropDown.businessType;
            //         },
            //         page: function(modalTemplates){
            //             return modalTemplates.CR_UP_BASIC_DROP_DOWN;
            //         }
            //     }
            // })
            // .state('dashboard.settings.contractTypes',{
            //     url:'/contractTypes',
            //     title: 'Transaction Contract Type',
            //     views:{
            //         'content@dashboard.settings':{
            //             templateUrl:'app/dashboard/settings/appDropDowns/appDropDown.html',
            //             controller: 'appDropDown as vm'
            //         }
            //     },
            //     resolve:{
            //         list: function(settings, apiEndPoints, crud){
            //             return settings.dropDown[crud.READ](apiEndPoints.dropDown.contractType).then(function(response){
            //                 return response.list;
            //             });
            //         },
            //         endPoint: function(apiEndPoints){
            //             return apiEndPoints.dropDown.contractType;
            //         },
            //         page: function(modalTemplates){
            //             return modalTemplates.CR_UP_BASIC_DROP_DOWN;
            //         }
            //     }
            // })
            // .state('dashboard.settings.designation',{
            //     url:'/contractTypes',
            //     title: 'User Designation',
            //     views:{
            //         'content@dashboard.settings':{
            //             templateUrl:'app/dashboard/settings/appDropDowns/appDropDown.html',
            //             controller: 'appDropDown as vm'
            //         }
            //     },
            //     resolve:{
            //         list: function(settings, apiEndPoints, crud){
            //             return settings.dropDown[crud.READ](apiEndPoints.dropDown.designation).then(function(response){
            //                 return response.list;
            //             });
            //         },
            //         endPoint: function(apiEndPoints){
            //             return apiEndPoints.dropDown.designation;
            //         },
            //         page: function(modalTemplates){
            //             return modalTemplates.CR_UP_BASIC_DROP_DOWN;
            //         }
            //     }
            // })
            // .state('dashboard.settings.contactType',{
            //     url:'/contactTypes',
            //     title: 'Contact Type',
            //     views:{
            //         'content@dashboard.settings':{
            //             templateUrl:'app/dashboard/settings/appDropDowns/appDropDown.html',
            //             controller: 'appDropDown as vm'
            //         }
            //     },
            //     resolve:{
            //         list: function(settings, apiEndPoints, crud){
            //             return settings.dropDown[crud.READ](apiEndPoints.dropDown.contactType).then(function(response){
            //                 return response.list;
            //             });
            //         },
            //         endPoint: function(apiEndPoints){
            //             return apiEndPoints.dropDown.contactType;
            //         },
            //         page: function(modalTemplates){
            //             return modalTemplates.CR_UP_BASIC_DROP_DOWN;
            //         }
            //     }
            // });

    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.shipping', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.shipping', {
                url: '/shipment',
                title: 'Shipment',
                views: {
                    'content@dashboard': {
                        templateUrl: 'app/dashboard/shipping/shipping.html',
                        controller: 'Shipping as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Shipment Module',
                    title:'Shipment',
                    headerAnchor: [
                        {
                            text: 'Shipping Ports',
                            state: 'dashboard.shipping.ports'
                        },
                        {
                            text: 'Shipping Lines',
                            state: 'dashboard.shipping.lines'
                        },
                        {
                            text: 'Shipping Vessel',
                            state: 'dashboard.shipping.vessel'
                        }

                    ]
                }
            })

            .state('dashboard.shipping.ports', {
                url:'/ports',
                title: 'Ports',
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/shipping/ports.html',
                        controller: 'Ports as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'All Shipment',
                    title:'Ports',
                    headerAnchor: [
                        {
                            text: 'Add New Shipping Port',
                            state: 'dashboard.shipping.ports.form({id:"new"})'
                        }
                    ]
                }
            })
            .state('dashboard.shipping.ports.form', {
                url:'/:id',
                title: 'Ports',
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/shipping/portForm.html',
                        controller: 'Ports as vm'
                    }
                },
                pageHeader:{
                    goBack: true,
                    subTitle: 'Shipping',
                    title:'Port'
                }
            })

            .state('dashboard.shipping.lines',{
                url:'/shippingLine',
                title: 'Shipping Line',
                views:{
                    'content@dashboard': {
                        templateUrl: 'app/dashboard/shipping/shippingLine.html',
                        controller: 'ShippingLine as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'All',
                    title:'Shipping Line',
                    goBack: true,
                    headerAnchor: [
                        {
                            text: 'Add New Shipping Line',
                            state: 'dashboard.shipping.lines.form({id:"new"})'
                        }
                    ]
                }
            })
            .state('dashboard.shipping.lines.form', {
                url: '/:id',
                title: 'Shipping Line',
                views:{
                    'content@dashboard': {
                        templateUrl: 'app/dashboard/shipping/shippingLineForm.html',
                        controller: 'ShippingLineForm as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Add New',
                    title:'Shipping Line',
                    goBack: true
                }
            })
            .state('dashboard.shipping.vessel', {
                url: 'vessel',
                views:{
                    'content@dashboard': {
                        templateUrl: 'app/dashboard/shipping/vessel.html',
                        controller: 'Vessel as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'All',
                    title:'Shipping Vessel',
                    headerAnchor: [
                        {
                            text: 'Add New Shipping Vessel',
                            state: 'dashboard.shipping.vessel.form({id:"new"})'
                        }
                    ],
                    back: true
                }


            })
            .state('dashboard.shipping.vessel.form', {
                url: '/:id',
                title: 'Shipping Vessel',
                views:{
                    'content@dashboard': {
                        templateUrl: 'app/dashboard/shipping/vesselForm.html',
                        controller: 'VesselForm as vm'
                    }
                }
            })
        ;
    }
})();
/**
 * @ngdoc overview
 * @name app.dashboard.tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.tradeBook', [])
        .config(configuration);

    /* @ngInject */
    function configuration($stateProvider){

        $stateProvider
            .state('dashboard.tradeDashboard', {
                url:'/tradeDashboard',
                subNav: true,
                subNavTitle: 'Trade Book',
                pageHeader:{
                    subTitle: 'Dashboard',
                    title:'International Trades',
                    headerAnchor: [
                        {
                            text: 'Add New Transaction',
                            state: 'dashboard.transaction({id:"new"})'
                        },
                        {
                            text: 'Trade Book',
                            state: 'dashboard.tradeBook'
                        }
                    ]
                },
                views:
                {
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/tradeBook/tradeDashboard/tradeDashboard.html',
                        controller: 'TradeDashboard as vm'
                    }
                },
                resolve:{
                    dashboardData: function(tradeBook, $stateParams, loaderModal, $rootScope){
                        loaderModal.open();
                        return tradeBook.getTradebookDashbordData().then(function(response){
                            loaderModal.close();
                            return response.dashboardData
                        });
                    }
                }
            })
            .state('dashboard.tradeBook', {
                url:'/tradeBook',
                subNav: true,
                subNavTitle: 'Trade Book',
                pageHeader:{
                    subTitle: 'Business',
                    title:'Trade Book',
                    headerAnchor: [
                        {
                            text: 'Add New Transaction',
                            state: 'dashboard.transaction({id:"new"})'
                        }
                    ]
                },
                views:
                {
                    'content@dashboard':{
                        templateUrl: 'app/dashboard/tradeBook/tradeBook.html',
                        controller: 'TradeBook as vm'
                    }
                },
                resolve:{
                    pageType: function(){
                        return 'tradeBook';
                    }
                }
            })
            .state('dashboard.transaction', {
                url: '/trade/:id',
                title:'Trade',
                pageHeader:{
                    subTitle: 'Add New',
                    title:'Transaction',
                    goBack: true
                },
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/tradeBook/transaction/transaction.html',
                        controller:'Transaction as vm'
                    }
                }
            })
            .state('dashboard.transactionView', {
                url:'/tradeView/:id',
                title: 'Trade',
                resolve:{
                    trade: function(tradeBook, $stateParams, loaderModal, $rootScope){
                        loaderModal.open();
                        return tradeBook.getTransactionDetail($stateParams.id, true).then(function(response){
                            loaderModal.close();
                            $rootScope.headerTitle = response.transaction.basic.fileNo;
                            return response.transaction
                        });
                    }
                },
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/tradeBook/transaction/transactionView.html',
                        controller: 'TransactionView as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'File No',
                    goBack: true
                }
            })
            .state('dashboard.internationalTradeAnalytics', {
                url:'/tradeAnalytics',
                title: 'Business Analytics',
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/tradeBook/businessAnalytics/businessAnalytics.html',
                        controller: 'TradeBusinessAnalytics as vm'
                    }
                },
                pageHeader:{
                    title: 'International Trade',
                    subTitle: 'Business Analytics',
                    goBack: true
                }
            })
            .state('dashboard.transactionList', {
                url:'/tradeReport/:reportType',
                title: 'Trade',
                resolve: {
                    reportType: function($stateParams){
                        return $stateParams.reportType;
                    },
                    data: function(tradeBook,loaderModal, $stateParams){
                        loaderModal.open();
                        return tradeBook.getTransactionList({}, $stateParams.reportType).then(function(res){
                            loaderModal.close();
                            return res
                        });
                    }

                },
                views:{
                    'content@dashboard':{
                        templateUrl:'app/dashboard/tradeBook/tradeList.html',
                        controller: 'TradeList as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'File No',
                    goBack: true
                },
            })

        ;

    }

}());

(function () {
    'use strict';

    angular.module('app.dashboard.user', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider){

        $stateProvider
            .state('dashboard.user', {
                url: '/user',
                abstract:true,
                title:'User Management',
                views: {
                    'content@dashboard':{
                        template:'<div ui-view="content"></div>'
                    }
                }
            })
            .state('dashboard.user.list',{
                url:'/all',
                pageHeader:{
                    subTitle: 'Manage',
                    title:'Users'
                },
                views:{
                    'content@dashboard.user':{
                        templateUrl:'app/dashboard/user/allUsers.html',
                        controller: 'User as vm'

                    }
                },
                resolve:{
                    allUsers: function(user){
                        return user.getAllUserProfile().then(function(response){
                            console.log(response);
                            return response.list;
                        })
                    }
                }
            })
            .state('dashboard.user.profile', {
                url: '/profile/:id',
                title:'User Profile',
                views: {
                    'content@dashboard.user':{
                        templateUrl:'app/dashboard/user/profile/profile.html',
                        controller:'ProfilePage as vm'
                    }
                },
                resolve:{
                    userProfile: function(user, $stateParams){
                        if($stateParams.id === 'new'){
                            return user.getNewUserObj()
                        }
                        else{
                            return user.getUserProfile($stateParams.id).then(function(response){
                                return response.user;
                            })
                        }
                    }
                }
            });

            $urlRouterProvider.when('/user','/user/all');
    }

})();

(function () {
    'use strict';

    angular.module('app.dashboard.website', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider){



        $stateProvider
            .state('dashboard.website', {
                url: '/website',
                title:'Website Managment',
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/website/website.html',
                        controller:'Website as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Website',
                    title:'Dashboard'
                },
                resolve:{
                    dashboard: function(website, loaderModal){
                        loaderModal.open();
                        return website.getWebsiteDashboard().then(function(res){
                            loaderModal.close();
                            return res.dashboardData;
                        })
                    }
                }
            })

            .state('dashboard.websiteBlog', {
                url: '/research',
                title:'Website Research',
                views: {
                    'content@dashboard':{
                        templateUrl:'app/dashboard/website/blog.html',
                        controller: 'Blog as vm'
                    }
                },
                pageHeader:{
                    subTitle: 'Research',
                    title:'Manager'
                }
            })

        ;
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts', [
      'app.widgets.charts.amCharts',
      'app.widgets.charts.chartJs',
      'app.widgets.charts.chartist',
      'app.widgets.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view></div>',
          title: 'Charts',
          // sidebarMeta: {
          //   icon: 'ion-stats-bars',
          //   order: 150,
          // },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.components', [
    'app.widgets.components.mail',
    'app.widgets.components.timeline',
    'app.widgets.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view></ui-view>',
          abstract: true,
          title: 'Components',
          // sidebarMeta: {
          //   icon: 'ion-gear-a',
          //   order: 100,
          // },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.form', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view></ui-view>',
          abstract: true,
          title: 'Form Elements',
          // sidebarMeta: {
          //   icon: 'ion-compose',
          //   order: 250,
          // },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          // sidebarMeta: {
          //   order: 0,
          // },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          // sidebarMeta: {
          //   order: 100,
          // },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          // sidebarMeta: {
          //   order: 200,
          // },
        });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          templateUrl: 'app/pages/maps/maps.html',
          abstract: true,
          title: 'Maps',
          // sidebarMeta: {
          //   icon: 'ion-ios-location-outline',
          //   order: 500,
          // },
        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/pages/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps',
          // sidebarMeta: {
          //   order: 0,
          // },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/pages/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps',
          sidebarMeta: {
            order: 200,
          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/pages/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          // sidebarMeta: {
          //   icon: 'ion-grid',
          //   order: 300,
          // },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui', [
    'app.widgets.ui.typography',
    'app.widgets.ui.buttons',
    'app.widgets.ui.icons',
    'app.widgets.ui.modals',
    'app.widgets.ui.grid',
    'app.widgets.ui.alerts',
    'app.widgets.ui.progressBars',
    'app.widgets.ui.notifications',
    'app.widgets.ui.tabs',
    'app.widgets.ui.slider',
    'app.widgets.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view></ui-view>',
          abstract: true,
          title: 'UI Features',
          // sidebarMeta: {
          //   icon: 'ion-android-laptop',
          //   order: 200,
          // },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.chartJs', [])
      .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartJs', {
          url: '/chartJs',
          templateUrl: 'app/pages/charts/chartJs/chartJs.html',
          title: 'Chart.js',
          sidebarMeta: {
            order: 200,
          },
        });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      colours: [ layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
      responsive: true,
      scaleFontColor: layoutColors.defaultText,
      scaleLineColor: layoutColors.border,
      pointLabelFontColor: layoutColors.defaultText
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
  }

})();
/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

/**
 * @ngdoc controller
 * @name app.authentication.controller:Authentication
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.authentication')
        .controller('Authentication', Authentication);

    /* @ngInject */
    function Authentication(authentication,$state){
        var vm = this;
        init();
        function init(){
            vm.username = '';
            vm.password = '';
            vm.login = login;
        }

        function login(form, username, password){
            if(form.$valid){
                authentication.login(form, username, password);
            }
        }
    }

}());

(function () {
    'use strict';
    angular.module('app.dashboard')
        .controller('Dashboard', Dashboard);

    function Dashboard(completeReport, $state, baSidebarService, $timeout, $filter) {
        var vm = this;
        _init();

        function _init(){
            vm.completeReport=completeReport;
            vm.shipmentTracking = completeReport.trackingData;
            vm.allArrived = _.filter(vm.shipmentTracking , function(ship) { return ship.destinationReached; });
            vm.refreshCurrentDollarRate = refreshCurrentDollarRate;
            vm.goToCurrencyDashboard = goToCurrencyDashboard;
            vm.invertSideBar = invertSideBar;
            prepareDashboard();
        }

        function prepareDashboard(){

        }

        function refreshCurrentDollarRate(){

        }

        function invertSideBar(collapse){
            console.log('hello');
            baSidebarService.setMenuCollapsed(collapse);
        }

        function goToCurrencyDashboard(currencyIn, currencyOut){
            $state.go('dashboard.currencyExchange.dashboard',  {'currencyIn': currencyIn, 'currencyOut': currencyOut});
        }

        function initialize() {


            L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
            var map = L.map(document.getElementById('leaflet-map'),  {
                zoomControl:true
            }).setView([24.8, 67.0], 2);
            L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            }).addTo(map);

            _.forEach(vm.shipmentTracking, function(ship){
                console.log(ship);
                var latitude = $filter('latLong')(ship.latitude);
                var longitude = $filter('latLong')(ship.longitude);
                L.marker([longitude, latitude]).addTo(map)
                    .bindPopup('<div class="cursor-pointer" onclick="goToTransactionView('+ship.fileId+')"><div class="fileId">File Id <a>'+ship.fileId+'</a></div>' +
                        '<div class="contractId">Contract Id <a>'+ship.contractId+'</a></div>' +
                        '<div class="seller">Seller <a>'+ ship.seller +'</a></div></div>'+
                        '<div class="seller">Product <a>'+ ship.product +'</a></div></div>'+
                        '<div class="buyer">Buyer <a>'+ ship.buyer +'</a></div></div>'+
                        '<div class="blNo">Shipping Line <a>'+(ship.shippingLine ? ship.shippingLine : 'NA')+'</a></div>'+
                        '<div class="blNo">B/L No. <a>'+(ship.bl ? ship.bl : 'NA')+'</a></div>'+
                        '<div class="vessel">Vessel Name <a>'+(ship.vesselName ? ship.vesselName : 'NA')+'</a></div></div>'+
                        '<div class="dest">Destination <a>'+ ship.portDestination +'</a></div></div>'+
                        '<div class="cont">Containers <a>'+ ship.containers +'</a></div></div>');
            })

        }


        $timeout(function(){
            initialize();
        }, 100);
    }

})();

function goToTransactionView(fileId){
    var win = window.open(window.location.origin+'/#!/dashboard/tradeView/'+fileId, '_blank');
    win.focus();
}

/**
 * @ngdoc controller
 * @name app.modal.controller:ChangePassword
 * @description < description placeholder >
 */

(function(){

  'use strict';

	angular
		.module('app.modal')
		.controller('ChangePasswordModal', ChangePassword);

  /* @ngInject */
	function ChangePassword(userId, $modalInstance, inputFields,setup){
		var vm = this;
        init();
        function init(){
            vm.passwordDetails = {
                newPassword: '',
                confirmPassword: '',
                userId: userId
            };
            vm.inputFields = inputFields;
            vm.submitChangePassword = submitChangePassword
        }

        function submitChangePassword(form){
            console.log(form);
            if(form.$valid){

                setup.changePasswordForUser(vm.passwordDetails).then(function(res){
                    if(res.data.success){

                    }
                    $modalInstance.close();
                });
            }
        }



		vm.testFunction = testFunction;

    /////////////////////

    /**
     * @ngdoc method
     * @name testFunction
     * @param {number} num number is the number of the number
     * @methodOf app.modal.controller:ChangePassword
     * @description
     * My Description rules
     */
    function testFunction(num){
			console.info('This is a test function');
		}
	}

}());

/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.accounts')
        .controller('AccountDashboard', AccountDashboard);

    /* @ngInject */
    function AccountDashboard(appFormats, utilities, $filter, loaderModal, $stateParams, currencyExchange) {
        var vm = this;
        _init();

        function _init(){

        }
    }
})();
/**
 * @ngdoc controller
 * @name app.businessPartner.controller:AddBusinessPartner
 * @description < description placeholder >
 */

(function(){

  'use strict';

	angular
		.module('app.dashboard.businessPartner')
		.controller('AddBusinessPartner', AddBusinessPartner);

  /* @ngInject */
	function AddBusinessPartner(toastr,$stateParams,bpTypes,contractTypes, originConfig, businessPartner, $state, appFormats){
		var vm = this;
        init();

        function init(){
            vm.appFormats = appFormats;
            vm.possibleBPTypes= bpTypes;
            vm.buyerContractTypes=contractTypes;
            vm.businessPartner = {};
            vm.editMode = false;
            vm.singleConfig = originConfig;
            vm.saveBusinessPartner = saveBusinessPartner;
            vm.updateBusinessPartner = updateBusinessPartner;
            initializeBusinessPartner();



        }

        function initializeBusinessPartner(){
            if($stateParams.operation){
                if(businessPartner.getBusinessPartner()){
                    vm.businessPartner.general=businessPartner.getBusinessPartner().gen[0];
                    vm.editMode = true;
                }
                else{
                    $state.go('shell.businessPartner.view',{id:$stateParams.id});
                }
            }
            else{
                vm.businessPartner.general = {
                    bp_Name:'',
                    bp_website:'',
                    bp_isBuyer:false,
                    bp_isSupplier:false,
                    bp_isBroker:false,
                    bp_isShipper:false,
                    bp_onDoniContact:false,
                    bp_credibilityIndex:0,
                    bp_country:'',
                    bp_address: ''
                };
            }
        }

        function saveBusinessPartner(){
            if(!vm.businessPartnerForm.$invalid){
                var bp = vm.businessPartner.general;
                console.log(bp);
                if(!(bp.bp_isBroker || bp.bp_isShipper || bp.bp_isBuyer || bp.bp_isSeller)){
                    toastr.error('Business partner should have one type', 'Error');
                    return;
                }
                businessPartner.addBusinessPartner(vm.businessPartner.general,function(response){
                    if (response.success) {
                        $state.go('shell.businessPartner.view',{id:response.data});
                    }
                });
            }
            else{
                toastr.error("Incorrect fields entered", 'Error');
            }

        }

        function updateBusinessPartner(){
            if(!vm.businessPartnerForm.$invalid){
                var bp = vm.businessPartner.general;
                console.log(bp);
                if(!(bp.bp_isBroker || bp.bp_isShipper || bp.bp_isBuyer || bp.bp_isSeller)){
                    toastr.error('Business partner should have one type', 'Error');
                    return;
                }
                businessPartner.updateBusinessPartner(vm.businessPartner.general,function(response){
                    if (response.success) {
                        $state.go('shell.businessPartner.view',{id:vm.businessPartner.general.bp_ID});
                    }
                });
            }
            else{
                toastr.error("Incorrect fields entered", 'Error');
            }
        }







    /////////////////////

    /**
     * @ngdoc method
     * @name testFunction
     * @param {number} num number is the number of the number
     * @methodOf app.businessPartner.controller:AddBusinessPartner
     * @description
     * My Description rules
     */

	}

}());

/**
 * @ngdoc controller
 * @name app.businessPartner.controller:BusinessPartner
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.businessPartner')
        .controller('BusinessPartner', BusinessPartner);

    /* @ngInject */
    function BusinessPartner(authentication, $state, $stateParams, $q, businessPartner, dropDownConfig, $filter,
                             deModal, $scope, allBusiness, toastr, loaderModal, $timeout){
        var vm = this;
        init();

        /////////////////////

        /**
         * @ngdoc method
         * @name testFunction
         * @param {number} num number is the number of the number
         * @methodOf app.businessPartner.controller:BusinessPartner
         * @description
         * My Description rules
         */
        function init(){
            vm.showForm = false;
            vm.selectedBPTypes = [];
            vm.selectedOrigin = [];
            vm.bpToRemove = [];
            vm.searchBusinessPartner = '';
            vm.goToBusinessReport = goToBusinessReport;
            vm.allBusiness = allBusiness.list;
            vm.allBusinessCount = allBusiness.count;
            console.log(allBusiness);

            vm.cancel = cancel;
            vm.onBpTypesSelectedChanged = onBpTypesSelectedChanged;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;

            vm.addBusinessPartner = addBusinessPartner;
            vm.editBusinessPartner = editBusinessPartner;
            vm.addBusinessContact = addBusinessContact;
            vm.addBusinessBank = addBusinessBank;
            vm.addContactPerson = addContactPerson;
            vm.addBusinessAddress = addBusinessAddress;
            vm.isPrimaryChange = isPrimaryChange;

            vm.deleteBusinessPartner = deleteBusinessPartner;
            vm.removeBusinessLocation = removeBusinessLocation;
            vm.removeBusinessBank = removeBusinessBank;
            vm.removeContactPerson = removeContactPerson;
            vm.removeBusinessContact = removeBusinessContact;
            vm.removeBusinessBank = removeBusinessBank;

            vm.onCountryDropDownChange = onCountryDropDownChange;
            vm.userData = authentication.getUserData().data;
            vm.deleteRights = vm.userData.businessAdmin;


            vm.uploadBusinessLogo = uploadBusinessLogo;
            vm.removeBusinessLogo = removeBusinessLogo;
            vm.getFile = getFile;

            vm.tableHeadings = [
                {name: 'Name', stSort:'', stPlaceholder:''},
                {name:'Contact Person', stSort:'bp_Cont_fullName', stPlaceholder:''},
                {name:'Origin', stSort:'bp_Cont_fullName', stPlaceholder:''},
                {name:'Type', stSort:'bp_Cont_fullName', stPlaceholder:''},
                {name:'Last Transaction On', stSort:'bp_Cont_fullName', stPlaceholder:''},
                {name:'Actions'}
            ];

            vm.saveBusiness = saveBusiness;
            vm.onSaveBusinessCallBack = onSaveBusinessCallBack;
            vm.onSaveBusinessBank = onSaveBusinessBank;
            vm.saveBusinessLocations = saveBusinessLocations;
            vm.saveBusinessContactPersons = saveBusinessContactPersons;
            vm.saveBusinessContactNumbers = saveBusinessContactNumbers;
            vm.saveBusinessBanks = saveBusinessBanks;
            vm.onBpTypesSelectedChanged = onBpTypesSelectedChanged;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;
            vm.setCurrentIndex = setCurrentIndex;

            vm.alphabet = "abcdefghijklmnopqrstuvwxyz".toUpperCase().split("");
            vm.currentIndex = businessPartner.getBusinessPartnerListIndex();

            if($state.current.name==='dashboard.businessPartner.form'){
                if($stateParams.id==='new'){
                    vm.business = businessPartner.getNewBusinessObj();
                    vm.businessLogo = $filter('businessLogo')(vm.business.logo);

                }
                else{
                    loaderModal.open();
                    businessPartner.getBusinessComplete($stateParams.id).then(function(res){
                        vm.business = angular.copy(res.business);

                        loaderModal.close();
                        vm.businessLogo = $filter('businessLogo')(vm.business.logo);
                    });



                }
            }

            vm.countryConfig = {};
            vm.bankCountryConfig = {};
            vm.countryOptions = {};
            vm.stateConfig = {};
            vm.cityConfig = {};
            vm.bpTypeConfig = {};
            vm.bpTypeOptions = {};
            vm.contactTypeConfig = {};
            vm.contactTypeOptions = {};

            dropDownConfig.prepareByTypesDropDown(vm.bpTypeConfig, vm.bpTypeOptions);
            dropDownConfig.prepareContactNumberTypeDropDown(vm.contactTypeConfig, vm.contactTypeOptions);
            dropDownConfig.prepareCountryDropDown(vm.countryConfig, vm.countryOptions, onCountryDropDownChange, 1);
            dropDownConfig.prepareCountryDropDown(vm.bankCountryConfig, vm.countryOptions, onBankCountryDropDownChange, 1);
            dropDownConfig.prepareRegionDropDown(vm.stateConfig, null, null, onRegionDropDownChange);
            dropDownConfig.prepareCityDropDown(vm.cityConfig, null, null, null, 1);



        }

        function deleteBusinessPartner(business){
            businessPartner.deleteBusinessPartner(business.bpId).then(function(res){
                if(res.success){
                    var index = _.findIndex(vm.allBusiness, function(bp){
                       return (bp.bp_id ===  business.bp_id);
                    });
                    vm.allBusiness.splice(index, 1);
                    toastr.success(res.message);
                }
                else{
                    toastr.error(res.message);
                }
            })
        }

        function setCurrentIndex(alpha){
            loaderModal.open();
            vm.currentIndex = alpha;
            businessPartner.getBusinessPartnerList(vm.currentIndex).then(function(res){
                loaderModal.close();
                vm.allBusiness = res.businessList.list;
                vm.allBusinessCount = res.businessList.count;
                businessPartner.setBusinessPartnerListIndex(vm.currentIndex);
                filterChanged()
            });
        }

        function onSaveBusinessBank(response){
            $state.go('dashboard.businessPartner');
        }

        function onSaveBusinessCallBack(response){
            vm.business.bpId = response.bpId;
        }

        function saveBusiness(imagesData, business, form){
                        if(!business.bpId){
                return businessPartner.addBusinessBasic(imagesData, business);
            }
            else{
                return businessPartner.updateBusinessBasic(imagesData, business);
            }
        }

        function saveBusinessLocations(business){
            var locations = angular.copy(business.locations);
            angular.forEach(locations, function(value, key){
                delete value['stateOptions'];
                delete value['cityOptions'];
            });
            if(business.locations.length === 0){
                toastr.error('Business must have atleast one locations');
                var promise =  $q.defer();
                return promise.promise;
            }
            return businessPartner.saveBusinessLocations(business.bpId, locations)
        }

        function saveBusinessContactPersons(business){
            var contactPersons = angular.copy(business.contactPersons);
            return businessPartner.saveBusinessContactPersons(business.bpId, contactPersons)
        }

        function saveBusinessContactNumbers(business){
            var contacts = angular.copy(business.contacts);
            return businessPartner.saveBusinessContacts(business.bpId, contacts)
        }

        function saveBusinessBanks(business){
            console.log('hello');
            var banks = angular.copy(business.banks);
            return businessPartner.saveBusinessBanks(business.bpId, banks);
        }

        function onRegionDropDownChange(value){
            if(value){
                angular.forEach(vm.business.locations, function(location, key){
                    if(location.state === value){
                        if(value === ''){
                           location.city = null;
                        }
                        else{
                            dropDownConfig.prepareCityDropDown(null,  location.cityOptions, location.country, value);
                        }
                    }
                });
            }
        }

        function onBankCountryDropDownChange(value){
            if(value){
                angular.forEach(vm.business.banks, function(bank, key){
                    if(bank.accountCountry === value){
                        bank.cityOptions.list = [];
                        if(value === ''){
                            bank.city = null;
                        }
                        else{
                            dropDownConfig.prepareCityDropDown(null,  bank.cityOptions, value, null);
                        }
                    }
                });
            }
        }

        function onCountryDropDownChange(value){
            if(value){
                angular.forEach(vm.business.locations, function(location, key){
                    if(location.country === value){
                        location.stateOptions.list = [];
                        if(value === ''){
                            location.state = null;
                        }
                        else{
                            dropDownConfig.prepareRegionDropDown(null,  location.stateOptions, value, null);
                            dropDownConfig.prepareCityDropDown(null,  location.cityOptions, value, null);
                        }

                    }
                });
            }
            else{
                location.state = '';
            }
        }

        function isPrimaryChange(list, row, value, attr){
            if(!value){
                toastr.error('One instance must be primary');
                row[attr] = true;
            }
            else{
                if(value){
                    angular.forEach(list, function(obj, key){
                        obj[attr] = false;
                    });
                    row[attr] = true;
                }
            }
        }

        function goToBusinessReport(businessId){
            $state.go('dashboard.businessPartner.report', {'id': businessId})
        }


        function addBusinessAddress(business){
            business.locations.push(businessPartner.getNewBusinessAddressObj(business));
        }

        function addBusinessBank(business){
            business.banks.push(businessPartner.getNewBusinessBankObj());
        }

        function addContactPerson(business){
            business.contactPersons.push(businessPartner.getNewBusinessContactPersonObj());
        }

        function addBusinessContact(business){
            business.contacts.push(businessPartner.getNewBusinessContactObj());
        }

        function removeBusinessLocation(locations, location){
            var index = locations.indexOf(location);
            locations.splice(index,1);
            if(locations.length == 1){
                locations[0].isPrimary = true;
            }
        }

        function removeContactPerson(contactPersons, contactPerson){
            var index = contactPersons.indexOf(contactPerson);
            contactPersons.splice(index,1);
            if(contactPersons.length == 1){
                contactPersons[0].isPrimary = true;
            }
        }

        function removeBusinessContact(contacts, contact){
            var index = contacts.indexOf(contact);
            contacts.splice(index,1);
        }

        function removeBusinessBank(banks, bank){
            var index = banks.indexOf(bank);
            banks.splice(index,1);
        }

        function onBpTypesSelectedChanged(selectedList){
            vm.selectedBPTypes = _.map(selectedList, 'id');
            filterChanged();
        }

        function onCountrySelectedChanged(selectedList){
            vm.selectedOrigin = _.map(selectedList, 'code');
            filterChanged();
        }

        function filterChanged(){
            vm.businessToRemove = [];
            angular.forEach(vm.allBusiness,function(business,key){
                var intersection = _.intersection(vm.selectedBPTypes, business.bpTypeId);
                var removeBusiness = false;
                removeBusiness = removeBusiness || (intersection.length == 0);
                removeBusiness = removeBusiness || (vm.selectedOrigin.indexOf(business.countryCode)<=-1);
                if(removeBusiness){
                    vm.businessToRemove.push(business.bpId);
                }
            });
        }

        function uploadBusinessLogo(){
            var fileInput = document.getElementById('uploadBusinessLogo');
            $timeout(function(){
                fileInput.click();
            });
        }

        function removeBusinessLogo(){
            vm.business.logo = null;
            vm.imagesData = null;
            vm.businessLogo = $filter('businessLogo')(vm.business.logo);
        }

        function getFile(picture){
            deModal.getFile(picture, $scope, null, null, null, function(imagesData){
                vm.businessLogo = imagesData.croppedImage;
                vm.imagesData = imagesData;
            });

        }




        function addBusinessPartner(){
            $state.go('dashboard.businessPartner.form', {'id': 'new'});

        }

        function editBusinessPartner(business){
            $state.go('dashboard.businessPartner.form', {'id': business.bpId});

        }

        function cancel(){
            $state.go('dashboard.businessPartner');
        }


    }

}());

/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.currencyExchange')
        .controller('CurrencyDashboard', CurrencyDashboard);

    /* @ngInject */
    function CurrencyDashboard(appFormats, utilities, $filter, loaderModal, $stateParams, currencyExchange) {
        var vm = this;
        _init();

        function _init(){
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.chartValues = ['value'];
            vm.chartType = 'line';
            vm.currencyDashboardData = {};
            vm.graphData = [];
            vm.showGraph=true;
            vm.dateRange = utilities.initialDateRange();
            onDateRangeChanged(vm.dateRange, true);
        }

        function onDateRangeChanged(dateRange, firstTime){
            vm.dateRange = dateRange;
            getCurrencyExchangeDashboardData(dateRange, $stateParams.currencyIn, $stateParams.currencyOut);
        }

        function getCurrencyExchangeDashboardData(dateRange, currencyIn, currencyOut){
            vm.showGraph = false;
            loaderModal.open();
            currencyExchange.getDashboardData(dateRange, currencyIn, currencyOut).then(function(res){
                if(res.success){
                    vm.currencyDashboardData = res.data;
                    vm.graphData = utilities.prepareGraphData(vm.currencyDashboardData.graphData);
                    console.log(vm.graphData);
                    vm.showGraph = true;
                    loaderModal.close();
                }
            })
        }

    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.documentCreator')
        .controller('DocumentCreator', DocumentCreator);

    function DocumentCreator(documentExporter) {
        var vm = this;
        _init();

        function _init(){
            vm.documentContent = '';
            vm.exportDocumentToPDF = exportDocumentToPDF;
            vm.createA4Document = createA4Document;
        }

        function createA4Document(content){
            documentExporter.createA4Document();
        }

        function exportDocumentToPDF(){
            var doc = document.getElementById('document')
            html2canvas(doc, {
                onrendered: function (canvas) {
                    console.log(canvas);
                    var data = canvas.toDataURL();
                    var docDefinition = {
                        content: [{
                            image: data,
                            width: 500,
                        }]
                    };
                    pdfMake.createPdf(docDefinition).download("Score_Details.pdf");
                }
            });
        }
    }

})();

/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('InventoryDashboard', InventoryDashboard);

    /* @ngInject */
    function InventoryDashboard(dashboardData, baConfig, utilities, $filter, loaderModal, $stateParams) {
        var vm = this;
        _init();

        function _init(){
            vm.dashboardColors = baConfig;
            vm.dashboardData = dashboardData;
            vm.allWarehouses = vm.dashboardData.allWarehouse;
        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('InventoryTransactionForm', InventoryTransactionForm);

    /* @ngInject */
    function InventoryTransactionForm(inventoryRecord, appFormats, inventory, $stateParams, toastr,
                                      $filter, loaderModal, $state, dropDownConfig, $scope) {
        var vm = this;
        _init();

        function _init(){
            vm.isNew = ($stateParams.id === 'new');
            vm.totalWeight = 0.00;
            vm.appFormats = appFormats;
            vm.productConfig = {};
            vm.productOptions = {};
            vm.warehouseConfig = {};
            vm.warehouseOptions = {};
            vm.businessConfig = {};
            vm.businessOptions = {};
            dropDownConfig.prepareWarehouseDropDown(vm.warehouseConfig, vm.warehouseOptions);
            dropDownConfig.prepareBusinessDropDown(vm.businessConfig, vm.businessOptions, 'Local Trader');
            dropDownConfig.prepareProductDropDown(vm.productConfig, vm.productOptions);
            vm.inventoryRecordId = $stateParams.id;
            vm.inventoryRecord = inventoryRecord;
            vm.getNewInventoryTruckObj = inventory.getNewInventoryTruckObj;
            vm.saveTruckInInventoryRecord = inventory.saveTruckInInventoryRecord;
            vm.saveInventoryRecord = saveInventoryRecord;
            vm.inventoryTruckCallback = inventoryTruckCallback;
            vm.removeTruck = removeTruck;
            vm.cancel = cancel;

            $scope.$watch('vm.inventoryRecord.trucks', function(newVal, oldVal){
                vm.totalWeight = _.sumBy(newVal, function(truck) { return parseFloat(truck.weightInKg); });
            }, true)
        }

        function removeTruck(truck, inventoryRecord){
            var truckIndex = vm.inventoryRecord.trucks.indexOf(truck);
            inventoryRecord.removedTrucks = (inventoryRecord.removedTrucks) ? inventoryRecord.removedTrucks : []
            if(truck.id!=='new'){
                inventoryRecord.removedTrucks.push(truck.id);
            }
            vm.inventoryRecord.trucks.splice(truckIndex,1);
        }



        function saveInventoryRecord(inventoryRecordForm, inventoryRecord){
            if(inventoryRecordForm.$valid){
                if(inventoryRecord.trucks.length === 0){
                    toastr.error('Please enter atleast one truck detail!', 'Error')
                }
                else{
                    loaderModal.open();
                    var inventorySaveMethod = (vm.isNew) ? inventory.createInventoryRecord : inventory.updateInventoryRecord;
                    inventorySaveMethod(inventoryRecord).then(inventoryRecordSuccessCallback)
                }
            }
            else{
                console.log(inventoryRecordForm);
                toastr.error('Please enter missing fields', 'Error')
            }

        }

        function inventoryRecordSuccessCallback(response){
            if(response.success){
                toastr.success(response.message, 'Success');
                $state.go('dashboard.inventory.inventoryTransactions');
            }
            else{
                toastr.error(response.message, 'Error');
            }
            loaderModal.close()
        }

        function inventoryTruckCallback(inventoryTruckObj){
            if(inventoryTruckObj.id === 'new'){
                vm.inventoryRecord.trucks.push(inventoryTruckObj);
            }
            else{
                var truck = _.find(vm.inventoryRecord.trucks, function(truck){
                    return truck.id === inventoryTruckObj.id;
                });
                var truckIndex = vm.inventoryRecord.trucks.indexOf(truck);
                vm.inventoryRecord.trucks[truckIndex]=inventoryTruckObj;
            }
        }

        function cancel(){
            $state.go('dashboard.inventory.inventoryTransactions');
        }

    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('InventoryTransactions', InventoryTransaction);

    /* @ngInject */
    function InventoryTransaction(appFormats, utilities, $filter, $state, inventory, loaderModal) {
        var vm = this;
        _init();

        function _init(){
            vm.appFormats = appFormats;
            vm.inventoryRecords = [];
            vm.filteredRecords = [];
            vm.selectedProductID = [];
            vm.selectedWarehouseID = [];
            vm.selectedLocalTraderID = [];
            vm.weightInFlow = 0.00;
            vm.weightOutFlow = 0.00;
            vm.trucksInFlow = 0.00;
            vm.trucksOutFlow = 0.00;
            vm.weightDifferance = 0.00;
            vm.editRecord = editRecord;
            vm.dateRange = utilities.initialDateRange(30);
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.onWarehouseSelectedChanged = onWarehouseSelectedChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.onLocalTradeSelectedChanged = onLocalTradeSelectedChanged;
            onDateRangeChanged(vm.dateRange, true)
        }

        function filterChanged(allRecords, firstTime){
            var recordsToRemove = [];
            if(!firstTime){
                angular.forEach(allRecords,function(record,key){
                    var removeRecord = false;
                    removeRecord = (vm.selectedProductID.indexOf(record.product__id)<=-1);
                    removeRecord = removeRecord ||((vm.selectedWarehouseID.indexOf(record.warehouse__id))<=-1);
                    removeRecord = removeRecord || (vm.selectedLocalTraderID.indexOf(record.transaction_business__bp_id)<=-1);
                    if(removeRecord){
                        recordsToRemove.push(record.id);
                    }
                    vm.filteredRecords = $filter('selectedRows')(allRecords, recordsToRemove, 'id');
                });
            }
            else{
                vm.filteredRecords = allRecords;
            }
            calculateStats(vm.filteredRecords);
        }

        function calculateStats(filteredRecords){
            vm.weightInFlow = 0.00;
            vm.weightOutFlow = 0.00;
            vm.trucksInFlow = 0.00;
            vm.trucksOutFlow = 0.00;
            vm.weightDifferance = 0.00;
            _.forEach(filteredRecords, function(value){
                if(value.positive){
                    vm.weightInFlow += value.total_weight_in_kgs;
                    vm.trucksInFlow += value.total_trucks
                }
                else{
                    vm.weightOutFlow += value.total_weight_in_kgs;
                    vm.trucksOutFlow += value.total_trucks
                }
                vm.weightDifferance = vm.weightInFlow - vm.weightOutFlow;

            })
        }

        function onLocalTradeSelectedChanged(selectedList, initialized){
            vm.selectedLocalTraderID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.inventoryRecords);
            }
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.inventoryRecords);
            }

        }

        function onWarehouseSelectedChanged(selectedList, initialized){
            vm.selectedWarehouseID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.inventoryRecords);
            }
        }

        function onDateRangeChanged(dateRange, firstTime){
            loaderModal.open();
            inventory.getInventoryRecordList(dateRange).then(function(res){
                loaderModal.close();
                vm.inventoryRecords =  res.list;
                filterChanged(vm.inventoryRecords, firstTime);
            });
        }



        function editRecord(id){
            $state.go('dashboard.inventory.inventoryTransactionForm', {id:id})
        }


    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('WarehousesDetails', WarehousesDetails);

    /* @ngInject */
    function WarehousesDetails(appFormats, inventory, $filter, loaderModal, $state, warehouseObj) {
        var vm = this;
        _init();

        function _init(){
            vm.appFormats = appFormats;
            vm.warehouseObj = warehouseObj;
            vm.editWarehouseDetails = editWarehouseDetails;
            vm.changeCurrentWarehouseRent = inventory.changeCurrentWarehouseRent;
            vm.onrentSaveCallBack = onRentSaveCallBack;
            vm.backToWarehouseList = backToWarehouseList;
        }

        function backToWarehouseList(){
            $state.go('dashboard.inventory.warehouses');
        }

        function onRentSaveCallBack(res){
            vm.warehouseObj.rentList = res.rentList;
        }


        function editWarehouseDetails(id){
            $state.go('dashboard.inventory.warehousesForm', {'id': id})
        }
    }
})();



/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('WarehouseForm', WarehouseForm);

    /* @ngInject */
    function WarehouseForm(appFormats, warehouseObj,  $state, inventory, loaderModal, $stateParams, toastr) {
        var vm = this;
        _init();

        function _init(){
            vm.isNew = ($stateParams.id === 'new');
            vm.warehouseObj = warehouseObj;
            vm.saveWarehouse = saveWarehouse;
            vm.cancel = cancel;
        }

        function cancel(){
            $state.go('dashboard.inventory.warehouses');
        }

        function saveWarehouse(newWarehouse, warehouseFormObj, warehouseObj){
            if(warehouseFormObj.$valid){
                loaderModal.open();
                var inventoryMethod = (newWarehouse) ? inventory.createWarehouse : inventory.updateWarehouse;
                inventoryMethod(warehouseObj).then(function(res){
                    if(res.success){
                        toastr.success(res.message);
                    }
                    else{
                        toastr.error(res.message, 'Error');
                    }
                    loaderModal.close();
                    $state.go('dashboard.inventory.warehouseDetails', {
                        id: res.id
                    });
                })
            }
            else{
                toastr.error('Please enter missing or incorrect fields! ', 'Error');
            }
        }
    }
})();
(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('WarehousesLotReport', WarehousesLotReport);

    /* @ngInject */
    function WarehousesLotReport(appFormats, utilities, $filter, loaderModal, $state, allWarehouses) {
        var vm = this;
        _init();

        function _init(){
            vm.allWarehouses = allWarehouses;
            vm.goToWarehouseDetails = goToWarehouseDetails;
            vm.goToWarehouseReport = goToWarehouseReport;
        }

        function goToWarehouseDetails(id){
            $state.go('dashboard.inventory.warehouseDetails', {'id':id})
        }

        function goToWarehouseReport(id){

        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('WarehousesRentForm', WarehousesRentForm);

    /* @ngInject */
    function WarehousesRentForm($scope, $uibModalInstance, warehouseId, toastr, inventory, callback) {
        var vm = this;
        _init();

        function _init(){
            vm.warehouseId = warehouseId;
            vm.saveNewCurrentRent = saveNewCurrentRent;
        }

        function saveNewCurrentRent(warehouseRentForm, warehouseId, warehouseObj){
            if(warehouseRentForm.$valid){
                inventory.saveNewWarehouseRent(warehouseId, warehouseObj).then(function(res){
                    if(res.success){
                        toastr.success(res.message);
                        $uibModalInstance.close(res);
                    }
                    else{
                        toastr.error(res.message);
                    }
                });
            }else{
                toastr.error('Please enter missing fields', 'Error');
            }
        }

        function goToWarehouseDetails(id){
            $state.go('dashboard.inventory.warehouseDetails', {'id':id})
        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .controller('Warehouses', Warehouses);

    /* @ngInject */
        function Warehouses(appFormats, utilities, $filter, loaderModal, $state, allWarehouses) {
        var vm = this;
        _init();

        function _init(){
            vm.allWarehouses = allWarehouses;
            vm.goToWarehouseDetails = goToWarehouseDetails
        }

        function goToWarehouseDetails(id){
            $state.go('dashboard.inventory.warehouseDetails', {'id':id})
        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.localTradeBook')
        .controller('LocalTradeBook', LocalTradeBook);

    /* @ngInject */
    function LocalTradeBook(localTradeBook, documentExporter, appFormats, utilities, $filter, loaderModal) {
        var vm = this;
        _init();

        function _init(){
            vm.dateRange = utilities.initialDateRange(30);
            vm.allTransactions = [];
            vm.columnHeader = [];
            onDateRangeChanged(vm.dateRange, true);

        }

        function filterChanged(allTransactions, firstTime){

        }


        function onDateRangeChanged(dateRange, firstTime){
            loaderModal.open();
                localTradeBook.getTransactionList(dateRange, 'localTradeBook').then(function(res){
                if(res.success){
                    vm.allTransactions = res.transactions;
                    vm.columnHeader = res.columnHeader;
                    console.log(vm.allTransactions);
                    filterChanged(vm.allTransactions , firstTime);
                    loaderModal.close();
                }
            });
        }
    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.manifest')
        .controller('Manifest', manifest);

    function manifest($state, $stateParams, $filter, loaderModal, utilities, manifest, dropDownConfig,
                      toastr, appConstants, documentExporter){
        var vm = this;
        _init();

        function _init(){
            vm.hidePaging = false;
            vm.unpagedView = unpagedView;
            vm.currentPage = 1;
            vm.itemsPerPage = 10;
            vm.appConstants = appConstants;
            vm.exportToExcel = exportToExcel;
            vm.exportToPDF = exportToPDF;
            vm.addNewManifestItem = addManifestItem;
            vm.editManifestItem = editManifestItem;
            vm.saveManifestItem = saveManifestItem;
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.onBuyersSelectedChanged = onBuyersSelectedChanged;
            vm.onSellersSelectedChanged = onSellersSelectedChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.deleteManifestItem = deleteManifestItem;
            vm.pageChanged = pageChanged;
            vm.cancel = cancel;
            vm.quantityMetricConfig = {};
            vm.quantityMetricOptions = {};
            vm.productConfig = {};
            vm.productOptions = {};
            vm.buyerConfig = {};
            vm.buyerOptions = {};
            vm.sellerConfig = {};
            vm.sellerOptions = {};
            vm.selectedBuyerID = [];
            vm.selectedSellerID = [];
            vm.selectedProductID = [];
            vm.dateRange = utilities.lastThirtyDaysDateRange();
            dropDownConfig.preparePriceMetricConfig(vm.quantityMetricConfig, vm.quantityMetricOptions);
            dropDownConfig.prepareProductDropDown(vm.productConfig, vm.productOptions);
            dropDownConfig.prepareBusinessDropDown(vm.buyerConfig, vm.buyerOptions, 'Buyer');
            dropDownConfig.prepareBusinessDropDown(vm.sellerConfig, vm.sellerOptions, 'Seller');
            vm.allManifestItems = [];
            vm.allManifestList = [];
            vm.displayList = [];
            vm.columnHeader=[
                'Date',
                'Buyer',
                'Seller',
                'Product',
                'Origin (Seller Country)',
                'Quantity(FCL)',
                'Container No.'
            ];
            vm.columnKeys = [
                'date',
                'buyerName',
                'sellerName',
                'productName',
                'sellerCountry',
                'quantity',
                'containerNo'
            ];
            getManifestItems(vm.dateRange);
        }

        function pageChanged(){
            setPagingData(vm.currentPage, vm.allManifestList, vm.itemsPerPage);
        }

        function unpagedView(list, flag){
            vm.hidePaging = !flag;
            vm.displayList = (vm.hidePaging) ? list : vm.pagedData;

        }

        function setPagingData(page, list, itemsPerPage) {
            vm.totalItems = list.length;
            vm.currentPage = page;
            vm.pagedData = list.slice((page - 1) * itemsPerPage, page * itemsPerPage);
            vm.displayList = vm.pagedData;
        }


        function filterChanged(){
            vm.currentPage = 1;
            vm.manifestItemsToRemove = [];
            angular.forEach(vm.allManifestItems,function(manifestItem,key){
                var removeManifestItem;
                removeManifestItem = ((vm.selectedBuyerID.indexOf(manifestItem.buyerId)<=-1) || (vm.selectedSellerID.indexOf(manifestItem.sellerId)<=-1));
                removeManifestItem = removeManifestItem || (vm.selectedProductID.indexOf(manifestItem.productId)<=-1);
                if(removeManifestItem){
                    vm.manifestItemsToRemove.push(manifestItem.id);
                }
            });
            vm.allManifestList = $filter('selectedRows')(vm.allManifestItems, vm.manifestItemsToRemove, 'id');
            vm.totalQuantity = _.sumBy(vm.allManifestList, function(item) { return item.quantity; });
            if(!vm.hidePaging){
                setPagingData(vm.currentPage, vm.allManifestList, vm.itemsPerPage);
            }
        }

        function onBuyersSelectedChanged(selectedList, initialized){
            vm.selectedBuyerID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged();
            }

        }

        function onSellersSelectedChanged(selectedList, initialized){
            vm.selectedSellerID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged();
            }
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged();
            }
        }

        function onDateRangeChanged(dateRange){
            vm.currentPage = 1;
            vm.dateRange = dateRange;
            getManifestItems(dateRange);
        }

        function getManifestItems(dateRange){
            loaderModal.open();
            manifest.getAllManifestItems(dateRange).then(function(res){
                vm.allManifestItems = res.manifestItems;
                vm.allManifestList = angular.copy(vm.allManifestItems);
                vm.totalQuantity = _.sumBy(vm.allManifestList, function(item) { return item.quantity; });
                setPagingData(vm.currentPage, vm.allManifestList, vm.itemsPerPage);
                loaderModal.close();
            }, function(err){
                loaderModal.close();
            });
        }

        function editManifestItem(manifestItem){
            vm.manifestItem = manifestItem;
            vm.showForm = true;
        }

        function saveManifestItem(manifestItem, form, addMore){
            if(form.$valid){
                if(manifestItem.id){
                    manifest.updateManifestItem(manifestItem).then(function(response){
                        if(response.success){
                            var index = vm.allManifestItems.indexOf(manifestItem);
                            vm.allManifestItems[index] = response.item;
                            toastr.success(response.message);
                            vm.showForm = false;
                        }
                        else{
                            toastr.error(response.message);
                        }
                    })
                }
                else{
                    manifest.addManifestItem(manifestItem).then(function(response){
                        if(response.success){
                            toastr.success(response.message);
                            if(addMore){
                                vm.manifestItem = manifest.getNewManifestItemObj(manifestItem.date);
                                utilities.resetFormValidation(form);
                            }
                            else {
                                vm.cancel();
                            }
                        }
                    })
                }
            }
            else{
                toastr.error('Please enter required missing fields.');
            }

        }

        function deleteManifestItem(item){
            manifest.deleteManifestItem(item.id).then(function(response){
               if(response.success){
                   var index = vm.allManifestItems.indexOf(item);
                   vm.allManifestItems.splice(index, 1);
                   toastr.success(response.message);
               }
               else{
                   toastr.error(response.message);
               }
            });
        }

        function cancel(){
            vm.showForm = false;
            $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
            });
        }

        function addManifestItem(){
            vm.showForm = true;
            vm.manifestItem = manifest.getNewManifestItemObj();
        }

        function exportToPDF(manifestList){
            documentExporter.printPDF(angular.copy(vm.columnHeader), angular.copy(vm.columnKeys), manifestList);
        }

        function exportToExcel(manifestList, dateRange){
            documentExporter.getTableInExcelSheet(angular.copy(vm.columnHeader), angular.copy(vm.columnKeys), manifestList, 'Manifest');
        }
    }

})();

(function () {
    'use strict';
    angular.module('app.dashboard.manifest')
        .controller('ManifestDashboard', manifestDashboard);

    function manifestDashboard($state, $timeout, baConfig, manifest, utilities, loaderModal) {
        var vm = this;
        _init();

        function _init() {
            vm.graphData = [];
            vm.chartValues = ['quantity'];
            vm.selectedBuyerID = [];
            vm.selectedSellerID = [];
            vm.selectedProductID = [];
            vm.dateRange = utilities.lastThirtyDaysDateRange();
            vm.transparent = baConfig.theme.blur;
            vm.dashboardColors = baConfig;
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.goToManifestItems = goToManifestItems;
            vm.onBuyersSelectedChanged = onBuyersSelectedChanged;
            vm.onSellersSelectedChanged = onSellersSelectedChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            onDateRangeChanged(vm.dateRange);

        }

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round'
                });
            });
        }

        function onBuyersSelectedChanged(selectedList, initialized){
            vm.selectedBuyerID = _.map(selectedList, 'id');
            if(!initialized){
                getManifestAnalytics(vm.dateRange, vm.selectedBuyerID, vm.selectedSellerID, vm.selectedProductID);
            }
        }

        function onSellersSelectedChanged(selectedList, initialized){
            vm.selectedSellerID = _.map(selectedList, 'id');
            if(!initialized) {
                getManifestAnalytics(vm.dateRange, vm.selectedBuyerID, vm.selectedSellerID, vm.selectedProductID);
            }
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized) {
                getManifestAnalytics(vm.dateRange, vm.selectedBuyerID, vm.selectedSellerID, vm.selectedProductID);
            }
        }

        function goToManifestItems(){
            $state.go('dashboard.manifest');
        }

        function onDateRangeChanged(dateRange){
            vm.dateRange = dateRange;
            getManifestAnalytics(dateRange, vm.selectedBuyerID, vm.selectedSellerID, vm.selectedProductID);

        }

        function getManifestAnalytics(dateRange, selectedBuyerId, selectedSellerId, selectedProductId){
            loaderModal.open();
            vm.showCharts = false;
            manifest.getManifestDashboardReport(dateRange, selectedBuyerId, selectedSellerId, selectedProductId).then(function(res){
                vm.graphData = utilities.prepareGraphData(res.graphData);
                vm.sumData = res.sumData;
                vm.showCharts = true;
                $timeout(function () {
                    loadPieCharts();
                }, 100);
                loaderModal.close();
            });
        }
    }

})();
(function() {

    'use strict';

    angular
        .module('app.dashboard.pricing')
        .controller('PriceAnalytics', PriceAnalytics);

    /* @ngInject */
    function PriceAnalytics(appFormats, utilities, $filter, loaderModal, $stateParams, pricing) {
        var vm = this;
        _init();

        function _init(){
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.chartValues = ['importVolume', 'intUsdPmt', 'intPkrPkg', 'localPkrPkg', 'localUsdPmt'];
            vm.chartType = 'line';
            vm.priceAnalyticsData = {};
            vm.graphData = [];
            vm.showGraph=true;
            vm.dateRange = utilities.initialDateRange();
            onDateRangeChanged(vm.dateRange);
        }

        function onDateRangeChanged(dateRange){
            vm.dateRange = dateRange;
            getPriceAnalyticsData(dateRange, $stateParams.productItemId);
        }

        function getPriceAnalyticsData(dateRange, productItemId){
            vm.showGraph = false;
            loaderModal.open();
            pricing.getProductPricingAnalytics(dateRange, productItemId).then(function(res){
                loaderModal.close();
                if(res.success){
                    vm.priceAnalyticsData = res.data;
                    console.log(vm.priceAnalyticsData.graphData);
                    vm.graphData = utilities.prepareGraphData(vm.priceAnalyticsData.graphData);
                    vm.totalVolume = vm.priceAnalyticsData.totalVolume;
                    vm.showGraph = true;
                }

            })
        }

    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.pricing')
        .controller('PriceMarket', priceMarket);

    function priceMarket(allMarkets, dropDownConfig, pricing, $stateParams, toastr, $state){
        var vm = this;
        _init();

        function _init(){
            vm.isNewPriceMarket = ($stateParams.id === 'new');
            vm.showForm = false;
            vm.allMarkets = allMarkets;
            vm.isInternational = true;
            vm.currencyConfig = {};
            vm.currencyOptions = {};
            vm.countryConfig = {};
            vm.countryOptions = {};

            vm.addPriceMarket = addPriceMarket;
            vm.editPriceMarket = editPriceMarket;
            dropDownConfig.prepareCountryDropDown(vm.countryConfig, vm.countryOptions, 1);
            dropDownConfig.prepareCurrencyDropDown(vm.currencyConfig, vm.currencyOptions);
            vm.onInternationalChange = onInternationalChange;
            vm.addNewPriceMarket = addNewPriceMarket;
            vm.updatePriceMarket = updatePriceMarket;
            vm.cancelPriceMarket = cancelPriceMarket;
        }

        function addPriceMarket(){
            vm.showForm = false;
            vm.priceMarket = pricing.getNewPriceMarkets();
            vm.showForm = true;

        }

        function editPriceMarket(row){
            vm.showForm = false;
            vm.priceMarket = row;
            vm.showForm = true;
        }

        function successCallBack(response, successMsg, update){
            if(response.success){
                if(update){
                    var obj = response.obj;
                    var market = _.find(vm.allMarkets, function(market){
                        return market.id == obj.id;
                    });
                    var index = _.indexOf(vm.allMarkets, market);
                    vm.allMarkets[index] = obj;
                    vm.showForm = false;
                }
                else{
                    vm.allMarkets.push(response.obj);
                    vm.showForm = false;
                }
                toastr.success(successMsg);
            }
            else{
                toastr.error(response.message)
            }
        }

        function onInternationalChange(isInternational, priceMarket){
            if(isInternational){
                priceMarket.country = null;
            }
        }

        function getPriceMarket(priceMarketId){
            return pricing.getPriceMarket(priceMarketId);
        }

        function cancelPriceMarket(){
            vm.priceMarket = {};
            vm.showForm = false;
        }

        function addNewPriceMarket(priceMarket){
            pricing.addPriceMarket(priceMarket, successCallBack);
        }

        function updatePriceMarket(priceMarket){
            pricing.updatePriceMarket(priceMarket, successCallBack);
        }
    }

})();

(function () {
    'use strict';
    angular.module('app.dashboard.pricing')
        .controller('Pricing', pricing);

    function pricing($state, allProductPriceSummary, appConstants, appFormats){
        var vm = this;
        _init();

        function _init(){
            vm.allProductPriceSummary = allProductPriceSummary;
            vm.appConstants = appConstants;
            vm.appFormats = appFormats;
            vm.selectedProductID = [];
            vm.selectedCountry = [];
            vm.addProductPricing = addProductPricing;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;
            vm.productPriceReport = productPriceReport;
        }

        function productPriceReport(productItemId){
            $state.go('dashboard.pricing.priceAnalytics', {'productItemId': productItemId});
        }

        function filterChanged(){
            vm.priceSummaryToRemove = [];
            angular.forEach(vm.allProductPriceSummary, function(summaryItem,key){
                var removeTransaction = false;
                removeTransaction = removeTransaction || (vm.selectedProductID.indexOf(summaryItem.productId)<=-1);
                removeTransaction = removeTransaction || (vm.selectedCountry.indexOf(summaryItem.productOriginName)<=-1);
                if(removeTransaction){
                    vm.priceSummaryToRemove.push(summaryItem.productItemId);
                }
            });
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged();
            }
        }

        function onCountrySelectedChanged(selectedList, initialized){
            vm.selectedCountry = _.map(selectedList, 'name');
            if(!initialized){
                filterChanged();
            }
        }

        function addProductPricing(stateName){
            $state.go(stateName);
        }
    }

})();
(function () {
    'use strict';
    angular.module('app.dashboard.pricing')
        .controller('ProductPricing', ProductPricing);

    function ProductPricing(pricing, dropDownConfig, toastr, allPriceItems, appFormats, utilities, loaderModal){
        var vm = this;
        _init();

        function _init(){
            vm.priceItemsToRemove = [];
            vm.showForm = false;
            vm.dateRange = utilities.todayDateRange();
            vm.appFormats = appFormats;
            vm.allPriceItems = allPriceItems;
            vm.marketPriceObj = pricing.getNewMarketPriceObj();
            vm.currentCurrency = 'USD';
            vm.currentMetric = 'FCL';
            vm.productItemConfig = {};
            vm.productItemOptions = {};
            vm.priceMarketConfig = {};
            vm.priceMarketOptions = {};
            vm.shipmentMonthConfig = {};
            vm.shipmentMonthOptions = {};
            vm.priceMetricConfig = {};
            vm.priceMetricOptions = {};
            vm.selectedPriceMarketID = [];
            vm.selectedCountry = [];
            vm.selectedProductID = [];
            vm.time = new Date();
            dropDownConfig.prepareShipmentMonthDropDown(vm.shipmentMonthConfig, vm.shipmentMonthOptions);
            dropDownConfig.prepareProductItemDropDown(vm.productItemConfig, vm.productItemOptions, true);
            dropDownConfig.preparePriceMarketDropDown(vm.priceMarketConfig, vm.priceMarketOptions, onPriceMarketChange);
            dropDownConfig.preparePriceMetricConfig(vm.priceMetricConfig, vm.priceMetricOptions);
            vm.openDatePicker = function() {
                vm.dateOpened = true;
            };
            vm.currentMetric = 'FCL';
            vm.addMarketPriceItemObj = addMarketPriceItemObj;
            vm.addMarketPrice = addMarketPrice;
            vm.editProductItemPrice = editProductItemPrice;
            vm.updateMarketPrice = updateMarketPrice;
            vm.deleteMarketPrice = deleteMarketPrice;
            vm.onPriceMarketChange = onPriceMarketChange;
            vm.removeMarketPriceItemObj = removeMarketPriceItemObj;
            vm.currentValueChange = currentValueChange;
            vm.addNewProductItemPrice = addNewProductItemPrice;
            vm.cancel = cancel;
            vm.toggleDetailDisplay = toggleDetailDisplay;
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.onPriceMarketSelectedChanged = onPriceMarketSelectedChanged;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;
            vm.onPriceDateChange = onPriceDateChange;
        }

        function filterChanged(){
            vm.priceItemsToRemove = [];
            angular.forEach(vm.allPriceItems,function(priceItem,key){
                var removeTransaction = false;
                removeTransaction = removeTransaction || (vm.selectedProductID.indexOf(priceItem.productId)<=-1);
                removeTransaction = removeTransaction || (vm.selectedPriceMarketID.indexOf(priceItem.priceMarketId)<=-1);
                removeTransaction = removeTransaction || (vm.selectedCountry.indexOf(priceItem.productOriginName)<=-1);
                if(removeTransaction){
                    vm.priceItemsToRemove.push(priceItem.id);
                }
            });
        }

        function onPriceDateChange(){
            var priceTime = new Date(vm.marketPriceObj.priceTime);
            priceTime = priceTime.toUTCString();
            angular.forEach(vm.marketPriceObj.priceItems, function(val, key){
                val.shipmentMonths = [];
            });
            dropDownConfig.prepareShipmentMonthDropDown(vm.shipmentMonthConfig, vm.shipmentMonthOptions, priceTime);

        }

        function editProductItemPrice(row){
            vm.showForm=false;
            vm.marketPriceObj = row;
            vm.shipmentMonthConfig = {};
            vm.shipmentMonthOptions = {};
            dropDownConfig.prepareShipmentMonthDropDown(vm.shipmentMonthConfig, vm.shipmentMonthOptions, row.priceTime);
            vm.showForm=true;
        }

        function onProductsSelectedChanged(selectedList){
            vm.selectedProductID = _.map(selectedList, 'id');
            filterChanged();
        }

        function onCountrySelectedChanged(selectedList){
            vm.selectedCountry = _.map(selectedList, 'name');
            filterChanged();
        }

        function onPriceMarketSelectedChanged(selectedList){
            vm.selectedPriceMarketID = _.map(selectedList, 'id');
            filterChanged();
        }

        function onDateRangeChanged(dateRange){
            loaderModal.open();
            return pricing.getAllProductItemPrice(dateRange).then(function(res){
                loaderModal.close();
                vm.allPriceItems = res.data.allPrices;
            })
        }

        function toggleDetailDisplay(row){
            row.showDetails = !row.showDetails;
        }

        function addNewProductItemPrice(){
            vm.showForm = true;
        }

        function cancel(){
            vm.showForm = false;
            vm.marketPriceObj = pricing.getNewMarketPriceObj();
        }

        function currentValueChange(marketPriceObj, price, currentValue){
            if(currentValue){
                angular.forEach(marketPriceObj.priceItems, function(value, key){
                    value.currentValue = (price === value);
                });
            }
            else{
                price.currentValue=true;
                toastr.error('Must have one price item as current market value.')
            }
        }

        function addMarketPrice(form, marketPriceObj, addAnother){
            if(form.$valid){
                pricing.addProductItemPrice(marketPriceObj, function(res){
                   if(res.success){
                       if(!addAnother){
                           toastr.success(res.message);
                           onDateRangeChanged(vm.dateRange);
                           cancel();
                       }
                       else{
                           toastr.success(res.message);
                           vm.marketPriceObj = pricing.getNewMarketPriceObj();
                           utilities.resetFormValidation(form);
                       }

                   }
                });
            }
            else{
                toastr.error('Please enter missing fields.','Invalid Form')
            }
        }

        function updateMarketPrice(form, marketPriceObj){
            if(form.$valid){
                pricing.updateProductItemPrice(marketPriceObj, function(res){
                    if(res.success){
                        var item = _.find(vm.allPriceItems, function(priceItem){
                            return priceItem.id == res.obj.id;
                        });
                        var index = _.indexOf(vm.allPriceItems, item);
                        vm.allPriceItems[index] = res.obj;
                        cancel();
                        toastr.success(res.message);
                    }
                })
            }
            else{
                toastr.error('Please enter missing fields.','Invalid Form')
            }
        }

        function deleteMarketPrice(marketPriceObj){
            loaderModal.open();
            pricing.deleteProductItemPrice(marketPriceObj).then(function(res){
                if(res.success){
                    var deletedPriceItem = _.find(vm.allPriceItems, function(item){
                        return item.id = marketPriceObj.id
                    });
                    var index = _.indexOf(vm.allPriceItems, deletedPriceItem);
                    if (index !== -1){
                        vm.allPriceItems.splice(index,1);
                        toastr.success(res.message);
                    }
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            });

        }

        function addMarketPriceItemObj(marketPriceObj){
            marketPriceObj.priceItems.push(pricing.getNewMarketPriceItemObj())
        }

        function onPriceMarketChange(priceMarketValue){
            if(priceMarketValue){
                vm.marketItem = _.find(vm.priceMarketOptions.list, function(market){
                    return market.id == priceMarketValue;
                });
                vm.currentCurrency = vm.marketItem.currency;
            }
            else{
                vm.currentCurrency = 'USD';
            }
        }

        function removeMarketPriceItemObj(marketPriceObj, price){
            if(marketPriceObj.priceItems.length!==1){
                var index = _.findIndex(marketPriceObj.priceItems, price);
                marketPriceObj.priceItems.splice(index,1);
                if(marketPriceObj.priceItems.length==1){
                    marketPriceObj.priceItems[0].currentValue=true;
                }
            }
            else{
                toastr.error('Market Price must have atleast one price item.')
            }

        }
    }

})();

(function () {
    'use strict';
    angular.module('app.dashboard.products')
        .controller('ProductPriceAnalytics', productPriceAnalytics);

    function productPriceAnalytics($stateParams, utilities, product){
        var vm = this;
        _init();
        function _init() {
            vm.productItemId = $stateParams.productItemId;
            console.log(vm.productItemId);
            vm.dateRange = utilities.lastThirtyDaysDateRange();
            vm.onDateRangeChanged = onDateRangeChanged;
            getPriceReport(vm.dateRange, vm.productItemId);

        }

        function onDateRangeChanged(dateRange){
            vm.dateRange = dateRange;
            getPriceReport(dateRange, vm.productItemId);
        }


        function getPriceReport(dateRange, productItemId){
            product.getPriceReport(dateRange, productItemId);
        }
    }
})();

(function () {
    'use strict';
    angular.module('app.dashboard.products')
        .controller('ProductCategories', productCategories);

    function productCategories(allCategories, $state, product, toastr){
        var vm = this;
        _init();

        function _init(){
            vm.showform = true;
            vm.allCategories = allCategories;
            vm.categoryObj = product.getNewProductCategoryObj();
            vm.addNewCategory = addNewCategory;
            vm.addCategory = addCategory;
            vm.updateCategory = updateCategory;
            vm.editCategory = editCategory;
            vm.cancel = cancel;
            vm.specification = specification;

        }

        function specification(categoryId){
            $state.go('dashboard.productSpecification', {'categoryId': categoryId});
        }

        function updateCategory(form, categoryObj){
            if(form.$valid){
                product.updateProductCategory(categoryObj, function(res){
                    if(res.success){
                        var item = _.find(vm.allCategories, function(cat){
                            return cat.id == res.obj.id;
                        });
                        var index = _.indexOf(vm.allCategories, item);
                        vm.allCategories[index] = res.obj;
                        cancel();
                        toastr.success(res.message);
                    }
                    else{
                        toastr.error(res.message);
                    }
                })
            }
            else{
                toastr.error('Please provide a category name', 'Invalid form')
            }
        }

        function editCategory(row){
            vm.showForm = false;
            vm.categoryObj = angular.copy(row);
            vm.showForm = true;
        }

        function addCategory(form, categoryObj){
            if(form.$valid){
                product.addProductCategory(categoryObj, function(res){
                    if(res.success){
                        vm.allCategories.push(res.obj);
                        toastr.success(res.message);
                        cancel();
                    }
                    else{
                        toastr.error(res.message);
                    }
                })
            }
            else{
                toastr.error('Please provide a category name', 'Invalid form')
            }
        }

        function cancel(){
            vm.categoryObj = product.getNewProductCategoryObj();
            vm.showForm = false;
        }

        function addNewCategory(){
            vm.categoryObj = product.getNewProductCategoryObj();
            vm.showForm = true;
        }
    }

})();

(function () {
    'use strict';
    angular.module('app.dashboard.products')
        .controller('ProductItems', productItems);

    function productItems(product, $state, dropDownConfig, appConstants, allProductItems, toastr, loaderModal){
        var vm = this;
        _init();

        function _init(){
            vm.allProductItems = allProductItems;
            vm.productItemToRemove = [];
            vm.selectedProductID = [];
            vm.selectedCountry = [];
            vm.showForm = false;
            vm.cancel = cancel;
            vm.productItem = product.getProductObj();
            vm.appConstants = appConstants;
            vm.keywordConfig = {};
            vm.keywordOptions = {};
            vm.originConfig = {};
            vm.originOptions = {};
            vm.editProductItem = editProductItem;
            vm.addNewProductItem = addNewProductItem;
            vm.addProductItem = addProductItem;
            vm.updateProductItem = updateProductItem;
            vm.displayPriceOnWebsite = displayPriceOnWebsite;
            vm.specsConfig = [];
            vm.productConfig = {};
            vm.productOptions = {};
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;
            dropDownConfig.prepareProductOriginDropDown(vm.originConfig, vm.originOptions, null);
            dropDownConfig.prepareKeywordDropDown(vm.keywordConfig, vm.keywordOptions, null);
            dropDownConfig.prepareProductDropDown(vm.productConfig, vm.productOptions, vm.originConfig, vm.originOptions,
                vm.keywordConfig, vm.keywordOptions, onProductChange);

        }

        function onProductChange(productOriginConfig, productOriginOptions, keywordConfig, keywordOptions, value, callback){
            if(value){
                dropDownConfig.prepareProductOriginDropDown(productOriginConfig, productOriginOptions, value, function(){
                    dropDownConfig.prepareKeywordDropDown(keywordConfig, keywordOptions, value, callback);
                });
            }
            else{
                vm.productItem.origin = null;
                vm.productItem.keywords = null;
            }
        }

        function addProductItem(form, productItem){
            loaderModal.open();
            product.addProductItem(productItem, function(res){
                if(res.success){
                    vm.allProductItems.push(res.obj);
                    vm.productItem = product.getProductObj();
                    vm.showForm = false;
                    toastr.success('Product item added successfully.');
                }
                loaderModal.close();
            });
        }

        function cancel(){
            vm.productItemObj = product.getProductObj();
            vm.showForm=false;

        }

        function updateProductItem(form, productItem){
            loaderModal.open();
            product.updateProductItem(productItem, function(res){
                if(res.success){
                    var obj = res.obj;
                    var item = _.find(vm.allProductItems, function(prodItem){
                        return prodItem.id == obj.id;
                    });
                    var index = _.indexOf(vm.allProductItems, item);
                    vm.allProductItems[index] = obj;
                    vm.productItem = product.getProductObj();
                    vm.showForm = false;
                    toastr.success('Product item updated successfully.');
                    loaderModal.close();
                }
            });
        }

        function editProductItem(row){
            vm.showForm=false;
            onProductChange(vm.originConfig, vm.originOptions, vm.keywordConfig, vm.keywordOptions, row.productId, function(){
                vm.productItem=row;
                vm.showForm=true;
            });
        }

        function displayPriceOnWebsite(row){
            loaderModal.open()
            product.productItemPriceOnWebsite(row.id, !row.priceOnWebsite).then(function(res){
                if(res.success){
                    row.priceOnWebsite = !row.priceOnWebsite;
                    toastr.success(res.message);
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            })
        }

        function addNewProductItem(){
            vm.showForm = false;
            vm.productItem = product.getNewProductItem();
            vm.showForm = true;
        }

        function filterChanged(){
            vm.productItemToRemove = [];
            angular.forEach(vm.allProductItems, function(item,key){
                var removeProductItem = false;
                removeProductItem = removeProductItem || (vm.selectedProductID.indexOf(item.productId)<=-1);
                removeProductItem = removeProductItem || (vm.selectedCountry.indexOf(item.productOriginName)<=-1);
                if(removeProductItem){
                    vm.productItemToRemove.push(item.id);
                }
            });
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged();
            }
        }

        function onCountrySelectedChanged(selectedList, initialized){
            vm.selectedCountry = _.map(selectedList, 'name');
            console.log(vm.selectedCountry)
            if(!initialized){
                filterChanged();
            }
        }
    }

})();
(function () {
    'use strict';
    angular.module('app.dashboard.products')
        .controller('ProductKeyword', productKeyword);

    function productKeyword(allKeywords, $state, product, dropDownConfig, toastr){
        var vm = this;
        _init();

        function _init(){
            vm.allKeywords = allKeywords;
            vm.categoryConfig = {};
            vm.categoryOptions = {};
            dropDownConfig.prepareProductCategoryDropDown(vm.categoryConfig, vm.categoryOptions);
            vm.keywordObj = product.getNewKeywordObj();
            vm.showForm = false;
            vm.addNewKeyword = addNewKeyword;
            vm.addKeyword = addKeyword;
            vm.editKeyword = editKeyword;
            vm.updateKeyword = updateKeyword;
            vm.cancel = cancel;

        }

        function addNewKeyword(){
            vm.keywordObj=product.getNewKeywordObj();
            vm.showForm = true;
        }

        function addKeyword(form, keywordObj){
            if(form.$valid){
                product.addProductKeyword(keywordObj, function(res){
                    if(res.success) {
                        vm.allKeywords.push(res.obj);
                        cancel();
                        toastr.success(res.message)
                    }
                    else{
                        toastr.error(res.message);
                    }
                })
            }
            else{
                toastr.error('Please fill missing fields.', 'Incomplete form')
            }

        }

        function editKeyword(row){
            vm.keywordObj = row;
            vm.showForm=true;
        }

        function updateKeyword(form, keywordObj){
            if(form.$valid){
                product.updateProductKeyword(keywordObj, function(res){
                    if(res.success){
                        var obj = res.obj;
                        var item = _.find(vm.allKeywords, function(keyword){
                            return keyword.id == obj.id;
                        });
                        var index = _.indexOf(vm.allKeywords, item);
                        vm.allKeywords[index] = obj;
                        cancel();
                        toastr.success(res.message)
                    }
                    else{
                        toastr.error(res.message);
                    }
                })
            }
            else{
                toastr.error('Please fill missing fields.', 'Incomplete form')
            }
        }

        function cancel(){
            vm.keywordObj = product.getNewKeywordObj();
            vm.showForm=false;
        }
    }

})();

/**
 * Created by immadimtiaz on 5/4/17.
 */
(function () {
    'use strict';
    angular.module('app.dashboard.products')
        .controller('ProductSpecification', productSpecification);

    function productSpecification($state, product, toastr, specificationData) {
        var vm = this;
        _init();

        function _init(){
            vm.categoryName = specificationData.categoryName;
            vm.specificationData = specificationData;
            vm.addSpecificationItem = addSpecificationItem;
            if(vm.specificationData.specs.length === 0){
                vm.specificationData.specs.push(getEmptySpecs());
            }
            vm.removeSpecItem = removeSpecItem;
            vm.saveSpecs = saveSpecs;
            vm.cancel = cancel;
            vm.specsTypes = [
                {'name': 'Text', 'value': 'text'},
                {'name': 'Percentage', 'value': 'Percentage'}
            ]
        }

        function saveSpecs(specsForm, specificationData){
            if(specsForm.$valid){
                product.saveProductCategorySpecification(specificationData).then(function(res){
                    if(res.success){
                        toastr.success(res.message);
                        cancel();
                    }
                    else{
                        toastr.error(res.message);
                    }
                })
            }
            else{
                toastr.error('Please enter missing fields');
            }
        }

        function cancel(){
            $state.go('dashboard.productsCategories');
        }

        function getEmptySpecs(){
            return {
                'name': null,
                'type': null
            }
        }

        function removeSpecItem(specList, spec){
            if(specList.length!==1){
                var index = _.findIndex(specList, spec);
                specList.splice(index,1);
            }
            else{
                toastr.error('Category specification must have at least one spec item.')
            }
        }

        function addSpecificationItem(){
            vm.specificationData.specs.push(getEmptySpecs());
        }


    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.products')
        .controller('Products', products);

    function products(fileReader, product, allProducts, $scope, appConstants, $filter, dropDownConfig, loaderModal,
                      deModal, toastr, $state, $stateParams){
        var vm = this;
        _init();

        function _init(){
            vm.showForm = false;
            vm.productObj = product.getProductObj();
            vm.allProducts = allProducts;
            vm.appConstants = appConstants;
            vm.addStepTitle = [
                'Add New Product',
                'Add Product Origins'
            ];
            vm.updateStepTitle = [
                'Update Product',
                'Update Product Origins'
            ];
            vm.categoryConfig = {};
            vm.categoryOptions = {};
            vm.countryConfig = {};
            vm.countryOptions = {};
            vm.cancel = cancel;
            vm.addNewProduct = addNewProduct;
            vm.editProduct = editProduct;
            vm.deleteProduct = deleteProduct;
            vm.uploadProductImage = uploadProductImage;
            vm.removeProductPicture = removeProductPicture;
            vm.getFile = getFile;
            vm.saveProduct = saveProduct;
            vm.onSaveProductCallback = onSaveProductCallback;
            vm.saveProductOrigin = saveProductOrigin;
            vm.onSaveProductOriginCallback = onSaveProductOriginCallback;
            vm.displayOnWebsite = displayOnWebsite;
            vm.loadRelatedProducts = loadRelatedProducts;
            dropDownConfig.prepareProductCategoryDropDown(vm.categoryConfig, vm.categoryOptions);
            dropDownConfig.prepareCountryDropDown(vm.countryConfig, vm.countryOptions);
        }

        function loadRelatedProducts(query, productId){
            return product.loadRelatedProducts(query, productId);
        }

        function displayOnWebsite(prod){
            loaderModal.open();
            product.displayOnWebsite(prod.info.id, !prod.info.onWebsite).then(function(res){
                if(res.success){
                    toastr.success(res.message);
                    prod.info.onWebsite = !prod.info.onWebsite;
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            }, function(err){
                toastr.error('Some Error occurred');
                loaderModal.close();
            });
        }

        function cancel(){
            $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
            });
        }


        function addNewProduct(){
            vm.action='add';
            vm.showForm = false;
            vm.stepTitle = vm.addStepTitle;
            vm.productObj = product.getProductObj();
            vm.productImage = $filter('productPicture')(vm.productObj.info.image);
            vm.noPicture = (vm.productImage === null);
            vm.showForm = true;
        }

        function editProduct(product){
            vm.action='update';
            vm.showForm = false;
            vm.stepTitle = vm.updateStepTitle;
            vm.productObj = product;
            vm.productImage = $filter('productPicture')(vm.productObj.info.image);
            vm.noPicture = (vm.productImage === null);
            vm.showForm = true;
        }

        function saveProduct(productObj, images){
            console.log(productObj);
            if(productObj.id){
                return product.updateProduct(productObj, images);
            }
            else{
                return product.addProduct(productObj, images);
            }
        }

        function onSaveProductCallback(response){
            if(response.success){
                vm.productObj.id = response.id;
                vm.productObj.info.id = response.id;
            }
        }

        function saveProductOrigin(productObj){
            return product.saveProductOrigin(productObj);
        }

        function onSaveProductOriginCallback(response){
            $state.transitionTo($state.current, $stateParams, {
                reload: true,
                inherit: false,
                notify: true
            });
        }

        function deleteProduct(allProducts, prod){
            product.deleteProduct(prod.id).then(function(res){
                if(res.success){
                    var index = allProducts.indexOf(prod);
                    allProducts.splice(index, 1);
                    toastr.success(res.message);
                }
                else{
                    toastr.error(res.message);
                }
            })
        }


        function uploadProductImage(){
            var fileInput = document.getElementById('uploadProductFile');
            fileInput.click();
        }

        function getFile(picture){
            deModal.getFile(picture, $scope, 1.2, [{w: 400,h: 400}], {width:400, height:400}, function(imagesData){
                vm.productImage = imagesData.croppedImage;
                vm.imagesData = imagesData;
            });
        }

        function removeProductPicture() {
            vm.noPicture = true;
            vm.productImage = null;
        }
    }

})();
(function () {
    'use strict';
    angular.module('app.dashboard.settings')
        .controller('settings', settings);

    function settings($state, user, inputFields, utilities, toastr, settings, appFormats, modalTemplates, crud, deModal,
                      apiEndPoints, businessPartner, loaderModal){
        var vm = this;
        _init();

        function _init(){
            vm.inputFields = inputFields;
            vm.passwordDetails = settings.getChangePasswordObj();
            vm.changePasswordSubmit = changePasswordSubmit;
            vm.appFormats = appFormats;
            vm.page = modalTemplates.CR_UP_BASIC_DROP_DOWN;
            vm.appDropDownList = [];
            vm.title = $state.current.title;
            vm.addDropDown = addDropDown;
            vm.openDropDownModal = openDropDownModal;
            vm.modalController = modalController;
            vm.getDropDownList = getDropDownList;
            vm.saveBusinessSettings = saveBusinessSettings;
            vm.getBusinessSettings = getBusinessSettings;
            vm.appDropDowns = [
                {
                    'title': 'Business Partner Type',
                    'endPoint': apiEndPoints.dropDown.businessType
                },
                {
                    'title': 'Contract Type',
                    'endPoint': apiEndPoints.dropDown.contractType
                },
                {
                    'title': 'Contact Type',
                    'endPoint': apiEndPoints.dropDown.contactType
                },
                {
                    'title': 'Designation',
                    'endPoint': apiEndPoints.dropDown.designation
                },
                {
                    'title': 'Transaction Status',
                    'endPoint': apiEndPoints.dropDown.transactionStatus
                },
                {
                    'title': 'Packaging',
                    'endPoint': apiEndPoints.dropDown.packaging
                },
                {
                    'title': 'Commission Type',
                    'endPoint': apiEndPoints.dropDown.commissionType
                }
            ];

            getDropDownList(vm.appDropDowns[0]);
        }

        function changePasswordSubmit(passwordForm, passwordObj){
            if(passwordForm.$valid){
                user.changePassword(passwordObj).then(function(res){
                    if(res.success){
                        toastr.success(res.message);
                        vm.passwordDetails = settings.getChangePasswordObj();
                        utilities.resetFormValidation(passwordForm);
                    }
                    else{
                        toastr.error(res.message);
                        vm.passwordDetails = settings.getChangePasswordObj();
                        utilities.resetFormValidation(passwordForm);
                    }
                })
            }
        }

        function getDropDownList(dropDown){
            vm.activedropDown = dropDown;
            return settings.dropDown[crud.READ](dropDown.endPoint).then(function(response){
                dropDown.list =  response.list;
            });
        }

        function openDropDownModal(title, endPoint, page, size, controller, name, id){
            var resolve = {
                endPoint: function() {
                    return endPoint;
                },
                title: function(){
                    return title;
                },
                name: function(){
                    return name;
                },
                id: function(){
                    return id
                }
            };
            vm.dropDownModal = deModal.openModal(page, size, controller, resolve);
        }

        function modalController($scope, title, endPoint, name, id){
            $scope.title = title;
            $scope.endPoint = endPoint;
            $scope.name = name;
            $scope.id = id;
            $scope.saveDropDown = ($scope.id) ? editDropDown : addDropDown;
        }

        function editDropDown(endPoint, name, id){
            settings.dropDown[crud.UPDATE](endPoint, name, id).then(function(response){
                if(response.success){
                    toastr.success(response.message);
                    var dropdown = _.find(vm.activedropDown.list,function(item){
                        return item.id = id;
                    });
                    dropdown.name = name;
                    deModal.dismissModal(vm.dropDownModal);
                }
                else{
                    toastr.error(response.message);
                    deModal.dismissModal(vm.dropDownModal);
                }
            });
        }

        function addDropDown(endPoint, name, id){
            settings.dropDown[crud.CREATE](endPoint, name).then(function(response){
                if(response.success){
                    toastr.success(response.message);
                    vm.activedropDown.list.push(response.obj);
                    deModal.dismissModal();
                }
                else{
                    toastr.error(response.message);
                    deModal.dismissModal();
                }
            });
        }

        function getBusinessSettings(){
            loaderModal.open();
            businessPartner.getBusinessSettings().then(function(response){
                vm.businessSettings = response.business
                loaderModal.close();
            })

        }

        function saveBusinessSettings(form, obj){
            if(form.$valid){
                loaderModal.open();
                businessPartner.saveBusinessSettings(obj).then(function(response){
                   if(response.success){
                       toastr.success(response.message);
                       loaderModal.close()
                   }
                   else{
                       toastr.error(response.message);
                       loaderModal.close();
                   }
                });
            }
            else{
                toastr.error('Please enter form correctly', 'Invalid Form')
            }
        }


    }

})();
(function () {
    'use strict';
    angular.module('app.dashboard.shipping')
        .controller('Ports', Ports);

    function Ports($state, shipping, toastr, loaderModal, dropDownConfig, $stateParams) {
        var vm = this;
        _init();


        function deletePort(portItem, portList){
            var index = portList.indexOf(portItem);
            shipping.deleteShippingPort(portItem.id).then(function(response){
                if(response.success){
                    portList.splice(index,1);
                    toastr.success(response.message);
                }
            })
        }

        function editPortItem(){

        }

        function goToShipmentPortForm(state, portId){
            $state.go(state, {'id':portId});
        }

        function _init(){
            vm.portsList = [];
            vm.heading = [
                'LO Code',
                'Name',
                'Country',
                'Contact No',
                'website',
                'Added By',
                'Actions'
            ];

            vm.countryOptions = {};
            vm.countryConfig = {};
            vm.portObj = {};

            if($state.current.name==='dashboard.shipping.ports'){
                vm.portsList = shipping.shippingPortList();
                // if(vm.portsList.length===0){
                loaderModal.open();
                shipping.getShippingPortList().then(function(res){
                    shipping.setShippingPortList(res.allPorts);
                    vm.portsList = res.allPorts;
                    loaderModal.close();
                });
                // }
            }
            else{
                dropDownConfig.prepareCountryDropDown(vm.countryConfig, vm.countryOptions, null, 1);
                if($stateParams.id === 'new'){
                    vm.portObj = shipping.getNewPortItemObj();
                }
                else{
                    shipping.getPortItemObj($stateParams.id).then(function(res){
                        vm.portObj = res.portObj;
                    })
                }

            }

            vm.addPort = addPort;
            vm.updatePort = updatePort;
            vm.deletePort = deletePort;
            vm.goToShipmentPortForm = goToShipmentPortForm;
            vm.cancel = cancel;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;
        }

        function filterChanged(){
            vm.portsToRemove = [];
            angular.forEach(vm.portsList, function(portItem,key){
                var removePort = false;
                removePort = (vm.selectedCountry.indexOf(portItem.country)<=-1);
                if(removePort){
                    vm.portsToRemove.push(portItem.id);
                }
            });
        }

        function onCountrySelectedChanged(selectedList, initialized){
            vm.selectedCountry = _.map(selectedList, 'name');
            if(!initialized) {
                filterChanged();
            }
        }

        function addPort(portForm, portObj){
            if(portForm.$valid){
                shipping.addShippingPort(portObj).then(function(res){
                    if(res.success){
                        // shipping.addPortToPortList(res.portObj);
                        toastr.success(res.message);
                        $state.go('dashboard.shipping.ports');
                    }
                    else{

                        toastr.error(res.message);
                    }
                });
            }
        }

        function updatePort(portForm, portObj){
            if(portForm.$valid){
                shipping.updateShippingPort(portObj).then(function(res){
                    if(res.success){
                        toastr.success(res.message);
                        $state.go('dashboard.shipping.ports');
                    }
                    else{

                        toastr.error(res.message);
                    }
                })
            }

        }

        function cancel(){
            $state.go('dashboard.shipping.ports')
        }
    }

})();


(function () {
    'use strict';
    angular.module('app.dashboard.shipping')
        .controller('Shipping', Shipping);

    function Shipping($state) {
        var vm = this;
        _init();

        function goToShippingPorts(state){
            $state.go(state);
        }

        function _init(){
            vm.goToShippingPorts = goToShippingPorts;
        }


    }

})();

(function () {
    'use strict';
    angular.module('app.dashboard.shipping')
        .controller('ShippingLine', ShippingLine);

    function ShippingLine($state, shipping, toastr, loaderModal, dropDownConfig, $stateParams) {
        var vm = this;
        _init();

        function _init() {
            vm.shippingLineList = [];
            vm.deleteCallback = deleteCallback;
            getShippingLineList();
        }

        function deleteCallback(id){
            var index = _.findIndex(vm.shippingLineList, function(line) { return line.id === id; });
            vm.shippingLineList.splice(index,1);
        }

        function getShippingLineList(){
            loaderModal.open();
            shipping.getShippingLineList().then(function(res){
                if(res.success){
                    vm.shippingLineList = res.list;
                    loaderModal.close();
                }
            })
        }
    }
})();

(function () {
    'use strict';
    angular.module('app.dashboard.shipping')
        .controller('ShippingLineForm', ShippingLineForm);

    function ShippingLineForm($state, shipping, toastr, loaderModal, $filter, $stateParams, fileReader, $scope,
                              deModal, utilities) {
        var vm = this;
        _init();



        function saveShippingLine(formObj, lineObj, imagesData, addAnother){

            function saveShippingLineCallBack(res){

                if(res.success){
                    toastr.success('Created Successfully',res.message);
                    if(addAnother){
                        vm.shippingObj = shipping.getNewShippingLineObj();
                        vm.shippingLineLogo = $filter('shippingLineLogo')(vm.shippingObj.logo);
                        utilities.resetFormValidation(formObj);
                    }
                    else{
                        cancel();
                    }

                }
                else{
                    toastr.error('Updated Successfully', res.message);
                }
                loaderModal.close();
            }

            if(formObj.$valid){
                loaderModal.open();
                if(lineObj.id){

                    shipping.updateShippingLine(lineObj, imagesData).then(saveShippingLineCallBack);
                }
                else{
                    shipping.addShippingLine(lineObj, imagesData).then(saveShippingLineCallBack);
                }
            }
            else{
                toastr.error('Please Enter Missing Fields', 'Incomplete Form');
            }
        }

        function removeLogo() {
            vm.noLogo = true;
            vm.shippingObj.logo = null;
            vm.shippingLineLogo = $filter('shippingLineLogo')(vm.shippingObj.logo);
        }

        function uploadLogo() {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        }

        function getFile(picture){
            fileReader.readAsDataUrl(picture, $scope)
                .then(function (result) {
                    deModal.openImageCropper(result, null, null, {width:200, height:200},
                        function(imagesData){
                            vm.shippingLineLogo = imagesData.croppedImage;
                            vm.imagesData = imagesData;
                        });
                    // vm.picture = result;
                });
        }

        function cancel(){
            try {
                $state.go($state.current.prevState, $state.current.prevParam);
            }
            catch(err) {
                $state.go('dashboard.main');
            }
        }


        function getShippingLineObj(id){
            loaderModal.open();
            shipping.getShippingLineObj(id).then(function(res){
                if(res.success){
                    vm.shippingObj = res.shippingLineObj;
                    vm.shippingLineLogo = $filter('shippingLineLogo')(vm.shippingObj.logo);
                }
                loaderModal.close();
            });

        }

        function _init() {
            vm.isNew = ($stateParams.id === 'new');
            vm.getFile = getFile;
            vm.saveShippingLine = saveShippingLine;
            vm.cancel = cancel;
            vm.removeLogo = removeLogo;
            vm.uploadLogo = uploadLogo;

            if(vm.isNew){
                vm.shippingObj = shipping.getNewShippingLineObj();
                vm.shippingLineLogo = $filter('shippingLineLogo')(vm.shippingObj.logo);
            }
            else{
                getShippingLineObj($stateParams.id)
            }




        }
    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.shipping')
        .controller('Vessel', Vessel);

    function Vessel($state, shipping, toastr, loaderModal, dropDownConfig, $stateParams) {
        var vm = this;
        _init();

        function _init(){
            vm.searchOptions = [
                {name: 'IMO Number', id: 'imo_number'},
                {name: 'MMSI Number', id: 'mmsi_number'},
                {name: 'Vessel Name', id: 'vessel_name'},
                {name: 'Shipping Line', id: 'line'}
            ];
            vm.searchTypeConfig = dropDownConfig.getBasicDropDownConfig(false);
            vm.getVesselList = getVesselList;
            vm.vesselList = [];
            vm.searchObj = {
                query: '',
                queryType: 'imo_number'
            }
            // getVesselList();
        }

        function searchVessel(searchObj){

        }

        function getVesselList(searchObj){
            loaderModal.open();
            shipping.getShippingVesselList(searchObj).then(function(res){
                vm.vesselList = res.list;
                loaderModal.close();

            });
        }
    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.shipping')
        .controller('VesselForm', VesselForm);

    function VesselForm($state, shipping, toastr, loaderModal, dropDownConfig, $stateParams) {
        var vm = this;
        _init();

        function _init() {
            vm.isNew = ($stateParams.id === 'new');
            vm.vesselObj = {};
            vm.saveShippingVessel = saveShippingVessel;
            vm.shippingLineConfig = {};
            vm.shippingLineOptions = {};
            vm.cancel = cancel;

            dropDownConfig.prepareShippingLineConfig(vm.shippingLineConfig, vm.shippingLineOptions);

            if(vm.isNew){
                vm.vesselObj = shipping.getNewShippingVesselObj();
            }
            else{
                shipping.getShippingVesselObj($stateParams.id).then(function(res){
                    vm.vesselObj = res.vesselObj;
                });
            }
        }

        function saveShippingVessel(vesselForm, vesselObj){
            function successCallback(res){
                if(res.success){
                    toastr.success(res.message);
                    cancel();
                }
                else{
                    toastr.error(res.message);
                }
            }

            if(vesselForm.$valid){
                if(vm.isNew){
                    shipping.createShippingVesselObj(vesselObj).then(successCallback);
                }
                else{
                    shipping.updateShippingVesselObj(vesselObj).then(successCallback);
                }
            }
            else{
                toastr.error('Please enter mandatory fields!')
            }
        }

        function cancel(){
            try {
                $state.go($state.current.prevState, $state.current.prevParam);
            }
            catch(err) {
                $state.go('dashboard.main');
            }
        }
    }
})();

(function() {

    'use strict';

    angular
        .module('app.dashboard.tradeBook')
        .controller('TradeList', tradeList);

    /* @ngInject */
    function tradeList(reportType, data, $filter) {
        var vm = this;
        init();
        function init(){
            vm.reportType = reportType;
            vm.transactions = data.transactions;
            vm.columnHeader = data.columnHeader;
            vm.onBuyersSelectedChanged = onBuyersSelectedChanged;
            vm.onSellersSelectedChanged = onSellersSelectedChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;

        }

        function filterChanged(allTransactions, firstTime){
            vm.tranToRemove = [];
            if(!firstTime){
                angular.forEach(allTransactions,function(transaction,key){
                    var removeTransaction = false;
                    removeTransaction = (vm.selectedBuyerID.indexOf(transaction.buyerId)<=-1);
                    removeTransaction = removeTransaction ||((vm.selectedSellerID.indexOf(transaction.sellerId))<=-1);
                    removeTransaction = removeTransaction || (vm.selectedProductID.indexOf(transaction.productItemId)<=-1);
                    // removeTransaction = removeTransaction || (vm.selectedTranStatus.indexOf(transaction.status)<=-1);
                    if(removeTransaction){
                        vm.tranToRemove.push(transaction.id);
                    }
                    vm.transactions = $filter('selectedRows')(allTransactions, vm.tranToRemove, 'id');
                });
            }
            else{
                vm.transactions = allTransactions;
            }
        }



        function onBuyersSelectedChanged(selectedList, initialized){
            vm.selectedBuyerID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.transactions);
            }

        }

        function onSellersSelectedChanged(selectedList, initialized){
            vm.selectedSellerID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.transactions);
            }
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.transactions);
            }
        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.tradeBook')
        .controller('TradeBook', tradeBook);

    /* @ngInject */
    function tradeBook(tradeBook,documentExporter, appFormats, utilities, $filter, loaderModal, pageType){
        var vm = this;
        init();
        /////////////////////
        /**
         * @ngdoc method
         * @name testFunction
         * @param {number} num number is the number of the number
         * @methodOf app.dashboard.tradeBook.controller:tradeBook
         * @description
         * My Description rules
         */
        function init(){
            vm.currentPage = 1;
            vm.itemsPerPage = 10;
            vm.searchTransaction = '';
            vm.dateRange = utilities.initialDateRange(30);
            vm.appFormats = appFormats;
            vm.columnHeader = [];
            vm.dateFilter = [];
            vm.selectedBuyerID = [];
            vm.selectedSellerID = [];
            vm.selectedProductID = [];
            vm.selectedCountries = [];
            vm.selectedTranStatus = [];
            vm.allTransactions = [];
            vm.allTransactionsList = [];
            vm.pageType = pageType;
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.onBuyersSelectedChanged = onBuyersSelectedChanged;
            vm.onSellersSelectedChanged = onSellersSelectedChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.onTranStatusSelectedChanged = onTranStatusSelectedChanged;
            vm.filterChanged = filterChanged;
            onDateRangeChanged(vm.dateRange, true);

            vm.headingclass = ['dateColumn','fileId','dropDownCol2','dropDownCol2','','','dropDownCol2','','dateColumn2','dateColumn',''];


            vm.headerAnchor = [
                {
                    text: 'Add new Transaction',
                    state: 'shell.tradeBook.Transaction({tran:"new"})'
                }
            ];

        }



        function onDateRangeChanged(dateRange, firstTime){
            loaderModal.open();
            tradeBook.getTransactionList(dateRange, 'tradeBook').then(function(res){
                if(res.success){
                    vm.allTransactions = res.transactions;
                    vm.columnHeader = res.columnHeader;
                    filterChanged(vm.allTransactions , firstTime);
                    loaderModal.close();
                }
            });
        }

        function filterChanged(allTransactions, firstTime){
            vm.tranToRemove = [];
            if(!firstTime){
                angular.forEach(allTransactions,function(transaction,key){
                    var removeTransaction = false;
                    removeTransaction = (vm.selectedBuyerID.indexOf(transaction.buyerId)<=-1);
                    removeTransaction = removeTransaction ||((vm.selectedSellerID.indexOf(transaction.sellerId))<=-1);
                    removeTransaction = removeTransaction || (vm.selectedProductID.indexOf(transaction.productItemId)<=-1);
                    removeTransaction = removeTransaction || (vm.selectedTranStatus.indexOf(transaction.status)<=-1);
                    console.log(transaction.status)
                    if(removeTransaction){
                        vm.tranToRemove.push(transaction.id);
                    }
                    vm.allTransactionsList = $filter('selectedRows')(allTransactions, vm.tranToRemove, 'id');
                });
            }
            else{
                vm.allTransactionsList = allTransactions;
            }
        }



        function onBuyersSelectedChanged(selectedList, initialized){
            vm.selectedBuyerID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.allTransactions);
            }

        }

        function onSellersSelectedChanged(selectedList, initialized){
            vm.selectedSellerID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.allTransactions);
            }
        }

        function onProductsSelectedChanged(selectedList, initialized){
            vm.selectedProductID = _.map(selectedList, 'id');
            if(!initialized){
                filterChanged(vm.allTransactions);
            }
        }

        function onTranStatusSelectedChanged(selectedList, initialized){
            vm.selectedTranStatus = _.map(selectedList, 'name');
            if(!initialized){
                filterChanged(vm.allTransactions);
            }


        }

    }

}());

(function () {
    'use strict';
    angular.module('app.dashboard.user')
        .controller('User', User);

    function User(allUsers, appFormats, $state, user, loaderModal, toastr){
        var vm = this;
        _init();

        function _init(){
            vm.showForm = false;
            vm.allUsers = allUsers;
            vm.appFormats = appFormats;
            vm.addNewUser = addNewUser;
            vm.editUser = editUser;
            vm.setUserActive = setUserActive;
            vm.setUserReadOnly = setUserReadOnly;

        }

        function editUser(userId){
            $state.go('dashboard.user.profile', {id:userId});
        }

        function setUserActive(user_obj){
            loaderModal.open();
            user.changeUserActive(user_obj.id, user_obj.active).then(function(response){
                if(response.success){
                    user_obj.active = !user_obj.active;
                    toastr.success(response.message);
                    loaderModal.close();
                }
            });

        }

        function setUserReadOnly(user_obj){
            loaderModal.open();
            user.changeUserReadOnly(user_obj.id, user_obj.readOnly).then(function(response){
                if(response.success){
                    user_obj.readOnly = !user_obj.readOnly;
                    toastr.success(response.message);
                    loaderModal.close();
                }
            });
        }

        function addNewUser(){
           $state.go('dashboard.user.profile', {id: 'new'});
        }
    }

})();

(function () {
    'use strict';
    angular.module('app.dashboard.website')
        .controller('Blog', blog);

    function blog(deModal, website, loaderModal, $filter, $scope, toastr, utilities){
        var vm = this;
        _init();
        function _init(){

            vm.researchList = [];
            vm.addNewResearch = addNewResearch;
            vm.uploadResearchImage = uploadResearchImage;
            vm.removeResearchImage = removeResearchImage;
            vm.saveResearch = saveResearch;
            vm.editResearch = editResearch;
            vm.deleteResearch = deleteResearch;
            vm.displayResearchOnWeb = displayResearchOnWeb;
            vm.getFile = getFile;
            vm.loadTags = loadTags;
            vm.researchObj = website.getNewResearchObj();
            vm.blogImage = $filter('itemImage')(vm.researchObj.image);
            vm.cancel = cancel;
            getAllResearch();

        }

        function loadTags(query){
            return website.getResearchTags(query)
        }

        function uploadResearchImage(){
            var fileInput = document.getElementById('uploadResearchFile');
            fileInput.click();
        }

        function getFile(picture){
            deModal.getFile(picture, $scope, 1.5, [{w: 800,h: 400}], {width:800, height:400}, function(imagesData){
                vm.blogImage = imagesData.croppedImage;
                vm.imagesData = imagesData;
                vm.noPicture = false;
            });
        }

        function removeResearchImage(){
            vm.noPicture = true;
            vm.researchObj.image = null;
            vm.blogImage = $filter('itemImage')(vm.researchObj.image);
        }

        function saveResearch(form, researchObj, images, draft){
            if(form.$valid){
                loaderModal.open();
                researchObj.isDraft = draft;
                if(researchObj.id){
                    return website.updateResearch(researchObj, images).then(function(res){
                        if(res.success){
                            var research = findResearchInResearchList(vm.researchList, researchObj.id);
                            var index = vm.researchList.indexOf(research);
                            vm.researchList[index] = res.researchObj;
                            toastr.success(res.message);
                            cancel(form);
                        }
                        else{
                            toastr.error(res.message);
                        }
                        loaderModal.close();
                    });
                }
                else{
                    return website.addResearch(researchObj, images).then(function(res){
                        if(res.success){
                            vm.researchList.push(res.researchObj);
                            toastr.success(res.message);
                            cancel(form);
                        }
                        else{
                            toastr.error(res.message);
                        }
                        loaderModal.close();
                    });
                }
            }
            else{
                toastr.error('Please enter missing fields');
            }

        }

        function editResearch(researchId){
            loaderModal.open();
            website.getCompleteResearch(researchId).then(function(res){
                vm.researchObj = res.researchObj;
                vm.blogImage = vm.researchObj.image;
                vm.noPicture = false;
                loaderModal.close();
                vm.showForm = true;
            });
        }

        function findResearchInResearchList(researchList, researchId){
            return _.find(researchList, function(research) { return research.id ==  researchId; });
        }

        function displayResearchOnWeb(researchId){
            loaderModal.open();
            website.displayResearchOnWebsite(researchId).then(function(res){
                if(res.success){
                    var research = findResearchInResearchList(vm.researchList, researchId);
                    var index = vm.researchList.indexOf(research);
                    vm.researchList[index] = res.researchObj;
                    toastr.success(res.message);
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            });
        }

        function deleteResearch(researchId){
            loaderModal.open();
            website.deleteResearch(researchId).then(function(res){
                if(res.success){
                    toastr.success(res.message);
                    var research = findResearchInResearchList(vm.researchList, researchId);
                    var index = vm.researchList.indexOf(research);
                    vm.researchList.splice(index, 1)
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            });
        }

        function addNewResearch(){
            vm.showForm = true;
            vm.researchObj = website.getNewResearchObj();
        }

        function cancel(form){
            vm.showForm=false;
            vm.researchObj = website.getNewResearchObj();
            utilities.resetFormValidation(form);
        }






        function getAllResearch(){
            loaderModal.open();
            website.getResearchList().then(function(res){
                vm.researchList = res.researchList;
                loaderModal.close();
            })
        }
    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.website')
        .controller('Website', website);

    function website($state, utilities, dashboard, authentication){
        var vm = this;
        _init();
        function _init() {
            vm.dashboardData = dashboard;
            vm.trafficChartData = [];
            vm.mapData = [];
            vm.trafficChartValues = ['newUsers', 'visits']
            vm.goToWebsiteBlogs = goToWebsiteBlogs;
            vm.connectGoogleAnalytics = connectGoogleAnalytics;
            if(vm.dashboardData.googleAnalyticsConnected) {
                vm.mapData = vm.dashboardData.data.trafficCountryChartData;
                vm.cardsTotalData = vm.dashboardData.data.cardsTotalData;
                vm.trafficChartData = utilities.prepareGraphData(vm.dashboardData.data.trafficChartData);
            }
        }

        function goToWebsiteBlogs(){
            $state.go('dashboard.websiteBlog');
        }

        function connectGoogleAnalytics(){
            authentication.authenticate('google', function(){
                $state.reload();
            });
        }


    }
})();
(function () {
    'use strict';
    angular.module('app.landing')
        .controller('homeCtrl', homeCtrl);

    function homeCtrl(){
        var vm = this;
        _init();

        function _init(){
            vm.slides = [
                {
                   image: 'http://10pearls.com/wp-content/themes/10pearls-2014/images/slider2016-intro-art.png'
                },
                {
                    image: 'http://10pearls.com/wp-content/themes/10pearls-2014/images/slider2016-staff-acceleration.jpg'
                }
            ]
        }
    }

})();

/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.accounts')
        .controller('Invoice', Invoice);

    /* @ngInject */
    function Invoice(appFormats, utilities, $filter, loaderModal, $stateParams) {
        var vm = this;
        _init();

        function _init(){

        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.accounts')
        .controller('InvoiceForm', InvoiceForm);

    /* @ngInject */
    function InvoiceForm($filter, utilities, accounts, $stateParams, $scope, $state, invoice, toastr) {
        var vm = this;
        _init();

        function _init(){
            vm.fileId = $stateParams.fileId;
            vm.invoiceId = $stateParams.invoiceId;
            vm.invoiceObj = invoice;
            vm.createInvoice = createInvoice;
            vm.updateInvoice = updateInvoice;
            vm.invoiceObj.invoiceAmount = calculateInvoiceTotal(vm.invoiceObj.invoiceItems);
            vm.convertToDecimal = convertToDecimal;
            vm.cancel = cancel;
            initializeWatcher();
        }

        function convertToDecimal(item){
            if(item.amount) {
                item.amount = $filter('number')(item.amount, 2);
            }
        }

        function cancel(fileId){
            $state.go('dashboard.transactionView', {'id': fileId});
        }

        function onSuccessInvoice(res){
            if(res.success){
                toastr.success(res.message);
                cancel(vm.fileId);
            }
        }

        function updateInvoice(fileId, invoiceObj){
            accounts.updateInvoice(fileId, invoiceObj, onSuccessInvoice)
        }

        function createInvoice(fileId, invoiceObj){
            accounts.createInvoice(fileId, invoiceObj, onSuccessInvoice)
        }

        function initializeWatcher(){
            $scope.$watch('vm.invoiceObj.invoiceItems', function(newVal, oldVal){
                vm.invoiceObj.invoiceAmount = calculateInvoiceTotal(newVal);
            }, true);

            $scope.$watch('vm.invoiceObj.currencyRate', function(newVal, oldVal){
                if(newVal){
                    var searchStr = vm.invoiceObj.currency+ ' ' + oldVal;
                    var replaceStr = vm.invoiceObj.currency+ ' ' + newVal;
                    angular.forEach(vm.invoiceObj.invoiceItems, function(val, key){
                        if(val.name.indexOf(searchStr) > -1){
                            val.name = val.name.replace(searchStr, replaceStr);
                            val.amount = utilities.evalMathExpressionInString(val.name);
                        }
                    })
                }

            })
        }

        function calculateInvoiceTotal(invoiceItems){
            var total = _.sumBy(invoiceItems, function(item){
                if(item.amount === ''){
                    return 0.00
                }
                return parseFloat(item.amount);
            });
            return total;
        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.accounts')
        .controller('CommissionFlow', CommissionFlow);

    /* @ngInject */
    function CommissionFlow(appFormats, utilities, $filter, loaderModal, $stateParams, currencyExchange) {
        var vm = this;
        _init();

        function _init(){

        }
    }
})();
/**
 * @ngdoc controller
 * @name app.businessPartner.controller:AddBusinessPartner
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.businessPartner')
        .controller('BusinessReport', BusinessReport);

    /* @ngInject */
    function BusinessReport(toastr, businessPartner, $state, appFormats, businessReport) {
        var vm = this;
        _init();

        function _init(){
            console.log(businessReport);
        }
    }
})();

/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.localTradeBook')
        .controller('LocalTradeBookForm', LocalTradeBookForm);

    /* @ngInject */
    function LocalTradeBookForm(tradeBook, dropDownConfig, $state, paymentTerms, toastr,
                                loaderModal, authentication, $stateParams, localTrade, localTradeBook) {
        var vm = this;
        _init();

        function _init(){
            vm.isNew = ($stateParams.id === 'new');
            vm.buyerConfig = {};
            vm.buyerOptions = {};
            vm.sellerConfig = {};
            vm.sellerOptions = {};
            vm.productItemConfig = {};
            vm.productItemOptions = {};
            vm.quantityMetricConfig = {};
            vm.quantityMetricOptions = {};
            vm.userData = authentication.getUserData();
            vm.currency = vm.userData.data.currency;
            vm.internationalTradeConfig = {};
            vm.internationalTradeOptions = {};
            vm.localTradeConfig = {};
            vm.localTradeOptions = {};
            vm.paymentTerms = paymentTerms;

            dropDownConfig.prepareBusinessDropDown(vm.buyerConfig, vm.buyerOptions, 'Local Buyer');
            dropDownConfig.prepareBusinessDropDown(vm.sellerConfig, vm.sellerOptions, 'Local Seller');
            dropDownConfig.prepareProductItemDropDown(vm.productItemConfig, vm.productItemOptions);
            dropDownConfig.preparePriceMetricConfig(vm.quantityMetricConfig, vm.quantityMetricOptions);
            dropDownConfig.prepareInternationalFileIdAutoComplete(vm.internationalTradeConfig, vm.internationalTradeOptions, true);
            dropDownConfig.prepareLocalTradeConfig(vm.localTradeConfig, vm.localTradeOptions, true);

            vm.localTransaction = localTrade;
            vm.saveLocalTrade = saveLocalTrade;
            vm.cancel = cancel;
        }

        function saveLocalTradeCallBack(res){
            if(res.success){
                toastr.success(res.message, 'Success');
                $state.go('dashboard.localTradeBook');
            }
            else{
                toastr.error(res.message, 'Error');
            }

        }

        function cancel(){
            $state.go('dashboard.localTradeBook');
        }

        function saveLocalTrade(localTradeForm, trade){
            if(vm.isNew){
                localTradeBook.addLocalTrade(trade).then(saveLocalTradeCallBack);
            }
            else{
                localTradeBook.updateLocalTrade(trade).then(saveLocalTradeCallBack);
            }
        }
    }
})();
/**
 * @ngdoc controller
 * @name app.dashboard.tradeBook.controller:tradeBook
 * @description < description placeholder >
 */

(function() {

    'use strict';

    angular
        .module('app.dashboard.localTradeBook')
        .controller('LocalTradeBookView', LocalTradeBookView);

    /* @ngInject */
    function LocalTradeBookView(localTrade, documentExporter, appFormats, appConstants, $state, deModal, loaderModal) {
        var vm = this;
        _init();

        function _init(){
            vm.transaction = localTrade;
            vm.appFormats = appFormats;
            vm.appConstants = appConstants;
            vm.addingDocument = false;
            vm.editTransactionDetails = editTransactionDetails;
            vm.changeCompleteStatus = changeCompleteStatus;
            vm.addLocalPayment = addLocalPayment;


        }

        function changeCompleteStatus(completeObj, transactionId){
            deModal.openTransactionCompleteModel(completeObj, transactionId, function(completeObj){
                loaderModal.open();
                tradeBook.changeCompleteStatus(transactionId, completeObj).then(function(res){
                    if(res.success){
                        vm.transaction = res.transactionObj;
                        toastr.success(res.message)
                    }
                    else{
                        toastr.error(res.message);
                    }
                    loaderModal.close();
                });

            });

        }


        function addLocalPayment(fileNo){
            deModal.openLocalTransactionPaymentModal(fileNo)
        }

        function editTransactionDetails(fileNo){
            $state.go('dashboard.localTransactionForm', {
                'id': fileNo
            });
        }
    }
})();


(function () {
    'use strict';
    angular.module('app.dashboard.settings')
        .controller('appDropDown', appDropDown);

    function appDropDown(appFormats, list, endPoint, page, settings, crud, $state, deModal){
        var vm = this;
        _init();

        function _init(){
            vm.appFormats = appFormats;
            vm.page = page;
            vm.list = list;
            vm.endPoint = endPoint;
            vm.title = $state.current.title;
            vm.addDropDown = addDropDown;
            vm.openAddDropDownModal = openAddDropDownModal;
            vm.modalController = modalController;
        }

        function openAddDropDownModal(title, endPoint, page, size, controller){
            var resolve = {
                endPoint: function() {
                    return endPoint;
                },
                title: function(){
                    return title;
                }
            };
            deModal.openModal(page, size, controller, resolve);
        }

        function modalController($scope, title, endPoint){
            $scope.title = title;
            $scope.endPoint = endPoint;
            $scope.name;
            $scope.addDropDown = addDropDown
        }

        function addDropDown(endPoint, name){
            settings.dropDown[crud.CREATE](endPoint, name).then(function(response){
                vm.list.push(response.obj);
                // deModal.dismiss();
            }, function(error){
                // deModal.dismiss();
            });
        }


    }

})();
(function() {

    'use strict';

    angular
        .module('app.dashboard.tradeBook')
        .controller('TradeBusinessAnalytics', TradeBusinessAnalytics);


    /* @ngInject */
    function TradeBusinessAnalytics(baConfig, tradeBook, $filter, appFormats, utilities){
        var vm = this;
        init();

        /////////////////////

        /**
         * @ngdoc method
         * @name testFunction
         * @param {number} num number is the number of the number
         * @methodOf app.dashboard.controller:Dashboard
         * @description
         * My Description rules
         */
        function init(){
            vm.dateRange = utilities.initialDateRange(30);
            vm.timeDrillBy = 'day';
            vm.productSalesAnalytics = [];
            vm.allTransactions = [];
            vm.totalVolume = 0;
            vm.totalQuantity = 0;
            vm.totalNetCommission = 0;
            vm.selectedBuyerID = [];
            vm.selectedSellerID = [];
            vm.selectedProductID = [];
            vm.selectedCountries = [];
            vm.selectedTranStatus = [];
            vm.dateLabels = [];
            vm.timeDrillOptions = {};
            vm.timeDrillConfig = {};
            vm.getTransactionAnalytics = getTransactionAnalytics;
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.showTradeBarCharts = true;
            vm.showPie = true;
            vm.onDateRangeChanged = onDateRangeChanged;
            vm.onBuyersSelectedChanged = onBuyersSelectedChanged;
            vm.onSellersSelectedChanged = onSellersSelectedChanged;
            vm.onProductsSelectedChanged = onProductsSelectedChanged;
            vm.onCountrySelectedChanged = onCountrySelectedChanged;
            vm.onTranStatusSelectedChanged = onTranStatusSelectedChanged;

            vm.seriesBarCharts = ['Quantity (MT)','Volume ($)','Net Commission ($)'];
            vm.dataBarChars = undefined;
            // vm.timeDrillChanged = timeDrillChanged;
            vm.onDateRangeChanged(vm.dateRange);
            vm.sellerList = [];
            vm.buyerList = [];
            vm.curBuyer = 0;
            vm.curSeller = 0;
            vm.nextBusinessPartner = nextBusinessPartner;
            vm.preBusinessPartner = preBusinessPartner;

        }


        function nextBusinessPartner(type, bpList){
            if((bpList.length-1) !== (vm['cur'+type])){
                vm['cur'+type] += 1;
            }
        }

        function preBusinessPartner(type){
            if(vm['cur'+type]!==0){
                vm['cur'+type] -= 1;
            }
        }


        function onDateRangeChanged(dateRange, firstTime){
            // vm.getProductSalesAnalytics(dateRange);
            vm.getTransactionAnalytics(dateRange, firstTime);
        }

        // function getProductSalesAnalytics(dateRange){
        //     var startDate = new Date(dateRange.startDate);
        //     var endDate = new Date(dateRange.endDate);
        //     product.productSalesAnalytics(startDate,endDate).then(function(res){
        //         vm.productSalesAnalytics = res.data.productSalesAnalytics;
        //         vm.productsVolume = _.map(vm.productSalesAnalytics,'volume');
        //         vm.productsQuantity = _.map(vm.productSalesAnalytics,'quantity');
        //         vm.productsNetCommission = _.map(vm.productSalesAnalytics,'netCommission');
        //         vm.products = _.map(vm.productSalesAnalytics,'productName');
        //     });
        // }



        function getTransactionAnalytics(dateRange, firstTime){
            tradeBook.getTradeBusinessAnalytics(dateRange).then(function(res){
                vm.allTransactions = res.data.transactions;
                filterChanged(firstTime);
            });

        }

        function filterChanged(firstTime){
            var filteredData = [];
            if(!firstTime){
                vm.tranToRemove = [];
                angular.forEach(vm.allTransactions,function(transaction,key){
                    var removeTransaction = false;
                    removeTransaction = (vm.selectedBuyerID.indexOf(transaction.tr_bpBuyerID)<=-1);
                    removeTransaction = removeTransaction ||((vm.selectedSellerID.indexOf(transaction.tr_bpSellerID))<=-1);
                    removeTransaction = removeTransaction || (vm.selectedProductID.indexOf(transaction.tr_productID)<=-1);
                    removeTransaction = removeTransaction || (vm.selectedCountries.indexOf(transaction.origin)<=-1);
                    if(removeTransaction){
                        vm.tranToRemove.push(transaction.tr_transactionID);
                    }
                });
                filteredData = $filter('selectedRows')(vm.allTransactions,vm.tranToRemove,'tr_transactionID');
            }
            else{
                filteredData =  vm.allTransactions;
            }


            // calculateAnalytics(filteredData);
            // timeDrillChanged(vm.timeDrillBy,filteredData);
        }

        function calculateAnalytics(filteredData){
            var groupByBuyer = (_.groupBy(filteredData,'tr_bpBuyerID'));
            groupByBuyer =  _.orderBy(groupByBuyer, ['length'], ['desc']);
            var groupBySeller = (_.groupBy(filteredData,'tr_bpSellerID'));
            groupBySeller =  _.orderBy(groupBySeller, ['length'], ['desc']);
            var buyerList = [];
            for(var buyer in groupByBuyer){
                var buyerDetails = {};
                buyerDetails['transactions'] = groupByBuyer[buyer].length;
                buyerDetails['bp_buyer_id'] = groupByBuyer[buyer][0]['tr_bpBuyerID'];
                buyerDetails['name'] = groupByBuyer[buyer][0]['buyer'];
                buyerDetails['quantity'] = 0;
                buyerDetails['volume'] = 0;
                buyerDetails['commission'] = 0;
                for(var tran in  groupByBuyer[buyer]){
                    buyerDetails['quantity'] += groupByBuyer[buyer][tran]['quantity'];
                    var comm = 0;
                    if(groupByBuyer[buyer][tran]['commission'] !== 'Not Entered'){
                        comm = parseInt((groupByBuyer[buyer][tran]['commission']).replace('$',''));
                    }
                    buyerDetails['volume'] += groupByBuyer[buyer][tran]['quantity'] * groupByBuyer[buyer][tran]['rate'];
                    buyerDetails['commission'] += comm;
                }
                buyerList.push(buyerDetails)
            }
            var sellerList = [];
            for(var seller in groupBySeller){
                var sellerDetails = {};
                sellerDetails['transactions'] = groupBySeller[seller].length;
                sellerDetails['bp_seller_id'] = groupBySeller[seller][0]['tr_bpSellerID'];
                sellerDetails['name'] = groupBySeller[seller][0]['seller'];
                sellerDetails['quantity'] = 0;
                sellerDetails['volume'] = 0;
                sellerDetails['commission'] = 0;
                for(var tran in groupBySeller[seller]){
                    sellerDetails['quantity'] += groupBySeller[seller][tran]['quantity'];
                    var comm = 0;
                    if(groupBySeller[seller][tran]['commission'] !== 'Not Entered'){
                        comm = parseInt((groupBySeller[seller][tran]['commission']).replace('$',''));
                    }
                    sellerDetails['volume'] += groupBySeller[seller][tran]['quantity']*groupBySeller[seller][tran]['rate'];
                    sellerDetails['commission'] += comm;
                }
                sellerList.push(sellerDetails)
            }
            vm.sellerList = _.orderBy(sellerList, ['commission'], ['desc']);
            vm.buyerList = _.orderBy(buyerList, ['commission'], ['desc']);
            vm.curBuyer = 0;
            vm.curSeller = 0;
            vm.totalVolume = _.sumBy(filteredData, function(tran) {
                return (tran.quantity * tran.rate);
            });
            vm.totalQuantity = _.sumBy(filteredData, function(tran) {
                return (tran.quantity);
            });
            vm.totalNetCommission = _.sumBy(filteredData, function(tran) {
                if(tran.commission === 'Not Entered'){
                    return 0;
                }
                else{
                    tran.commission = tran.commission.replace('$','');
                    return (parseInt(tran.commission));
                }
            });
        }

        function onBuyersSelectedChanged(selectedList){
            vm.selectedBuyerID = _.map(selectedList, 'bp_ID');
            filterChanged();
        }

        function onSellersSelectedChanged(selectedList){
            vm.selectedSellerID = _.map(selectedList, 'bp_ID');
            filterChanged();
        }

        function onProductsSelectedChanged(selectedList){
            vm.selectedProductID = _.map(selectedList, 'id');
            filterChanged();
        }

        function onCountrySelectedChanged(selectedList) {
            vm.selectedCountries = _.map(selectedList, 'origin_name');
            filterChanged();
        }

        function onTranStatusSelectedChanged(selectedList){
            vm.selectedTranStatus = _.map(selectedList, 'text');
            filterChanged();
        }

    }

})();
(function() {

    'use strict';

    angular
        .module('app.dashboard.tradeBook')
        .controller('TradeDashboard', TradeDashboard);

    /* @ngInject */
    function TradeDashboard(tradeBook, dashboardData, baConfig, $timeout, $filter, authentication) {
        var vm = this;
        _init();

        function _init(){
            vm.dashboardData = dashboardData;
            vm.dashboardColors = baConfig;
            vm.hasBusinessAnalytics =
            vm.multiBarData = {
                labels: ['1 Year', '6 Months', '30 Days', '7 Days'],
                series: [
                    { "name": "New Trades", "data": vm.dashboardData.multiBar.newTrades },
                    { "name": "Completed", "data": vm.dashboardData.multiBar.completeTrades },
                    { "name": "Washout", "data": vm.dashboardData.multiBar.washoutTrades },
                    { "name": "Buyer Contract", "data": vm.dashboardData.multiBar.buyerContractTrades },
                    { "name": "Arrived Not Completed", "data": vm.dashboardData.multiBar.arrivedTrades }
                ]
            };

            vm.multiBarOptions = {
                fullWidth: true,
                plugins: [
                    Chartist.plugins.legend()
                ],
                height: "400px",
                stackBars: true,
                axisX: {
                    labelInterpolationFnc: function (value) {
                        return value.split(/\s+/).map(function (word) {
                            return word[0];
                        }).join('');
                    }
                }
            };

            vm.multiBarResponsive = [
                // Options override for media > 400px
                ['screen and (min-width: 400px)', {
                    reverseData: true,
                    horizontalBars: true,
                    axisX: {
                        labelInterpolationFnc: Chartist.noop
                    }
                }],
                // Options override for media > 800px
                ['screen and (min-width: 800px)', {
                    stackBars: false,
                    seriesBarDistance: 10
                }],
                // Options override for media > 1000px
                ['screen and (min-width: 1000px)', {
                    reverseData: false,
                    horizontalBars: false,
                    seriesBarDistance: 15
                }]
            ];

            $timeout(function () {
                loadPieCharts();
                new Chartist.Bar('#multi-bar', vm.multiBarData, vm.multiBarOptions, vm.multiBarResponsive)
            }, 100);

            vm.showTrades = showTrades

        }

        function showTrades(pageType, heading){
            tradeBook.openTradeBookModal(pageType, heading);
        }

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round'
                });
            });
        }

    }
})();
(function () {
    'use strict';
    angular.module('app.dashboard.tradeBook')
        .controller('Transaction', transaction);

    function transaction(dropDownConfig, tradeBook, $scope, deModal, $rootScope, toastr, $state, loaderModal, $stateParams){
        console.log('hello');
        var vm = this;
        _init();

        function _init(){
            vm.quantityMetricConfig = {};
            vm.quantityMetricOptions = {};
            vm.isNew = ($stateParams.id === 'new');
            vm.productConfig = {};
            vm.productOptions = {};
            vm.packagingConfig = {};
            vm.packagingOptions = {};
            vm.buyerConfig = {};
            vm.buyerOptions = {};
            vm.sellerConfig = {};
            vm.sellerOptions = {};
            vm.productItemConfig = {};
            vm.productItemOptions = {};
            vm.commissionTypeConfig = {};
            vm.commissionTypeOptions = {};
            vm.brokerConfig = {};
            vm.brokerOptions = {};
            vm.primaryFileConfig = {};
            vm.primaryFileOptions = {};
            vm.partialShipConfig = {};
            vm.partialShipOptions = {};
            dropDownConfig.prepareCommissionTypeConfig(vm.commissionTypeConfig, vm.commissionTypeOptions);
            dropDownConfig.preparePackagingConfig(vm.packagingConfig, vm.packagingOptions);
            dropDownConfig.prepareProductItemDropDown(vm.productItemConfig, vm.productItemOptions);
            dropDownConfig.preparePriceMetricConfig(vm.quantityMetricConfig, vm.quantityMetricOptions);
            dropDownConfig.prepareProductDropDown(vm.productConfig, vm.productOptions);
            dropDownConfig.prepareBusinessDropDown(vm.buyerConfig, vm.buyerOptions, 'Buyer');
            dropDownConfig.prepareBusinessDropDown(vm.sellerConfig, vm.sellerOptions, 'Seller');
            dropDownConfig.prepareBusinessDropDown(vm.brokerConfig, vm.brokerOptions, 'Broker');
            dropDownConfig.prepareInternationalFileIdAutoComplete(vm.primaryFileConfig, vm.primaryFileOptions);
            dropDownConfig.prepareInternationalFileIdAutoComplete(vm.partialShipConfig, vm.partialShipOptions);

            console.log(vm.partialShipConfig, vm.partialShipOptions);


            vm.cancel = cancel;
            vm.addTransaction = addTransaction;
            vm.updateTransaction = updateTransaction;
            vm.changeProductSpecs = changeProductSpecs;



            if(vm.isNew){
                vm.transaction = tradeBook.getNewTransaction();
                vm.showForm = true;
            }
            else{
                loaderModal.open();
                tradeBook.getTransactionDetail($stateParams.id, null).then(function(res){
                    $rootScope.headerSubTitle = 'File Id ' + $stateParams.id ;
                    $rootScope.headerTitle = 'Edit Transaction';
                    vm.transaction = res.transaction;
                    vm.showForm = true;
                    loaderModal.close();
                })
            }

        }

        function getPrimaryTrade(filter){
            console.log(filter);
        }



        function cancel(){
            $state.go('dashboard.tradeBook');
        }

        function onSuccessFullSave(id){
            $state.go('dashboard.transactionView', {'id': id});
        }

        function addTransaction(transactionForm, transactionObj){
            if(transactionForm.$valid || true){
                tradeBook.addTransaction(transactionObj).then(function(response){
                    if(response.success){
                        toastr.success(response.message);
                        onSuccessFullSave(response.fileId);
                    }
                    else{
                        toastr.error(response.message);
                    }
                })
            }
            else{
                toastr.error('Please enter missing fields');
            }
        }

        function updateTransaction(transactionForm, transactionObj){
                if(transactionForm.$valid || true){
                    tradeBook.updateTransaction(transactionObj).then(function(response){
                        if(response.success){
                            onSuccessFullSave(response.fileId);
                            toastr.success(response.message);
                        }
                        else{
                            toastr.error(response.message);
                        }
                    })
                }
                else{
                    toastr.error('Please enter missing fields');
                }
        }

        function changeProductSpecs(){
            deModal.openProductSpecificationModal(vm.transaction.productSpecification, function(productSpecs){
                vm.transaction.productSpecification = productSpecs;
                console.log(vm.transaction);
            });
        }


    }

})();


(function() {

    'use strict';

    angular
        .module('app.dashboard.tradeBook')
        .controller('TransactionView', transactionView);

    /* @ngInject */
    function transactionView(Upload, tradeBook, toastr, deModal, apiEndPoints, trade, utilities,
                             appConstants, appFormats, $state, shipmentStatus, dropDownConfig, shipping, loaderModal){
        var vm = this;
        _init();

        function _init(){
            vm.appConstants = appConstants;

            //shipment Form
            vm.showNotShippedForm = false;
            vm.showApprobationRecievedForm = false;
            vm.showShippedForm = false;
            vm.showArrivedAtPort = false;
            vm.loadVessel = loadVessel;
            vm.cancelShipmentForm = cancelShipmentForm;

            vm.shipperConfig = {};
            vm.shipperOptions = {};


            vm.shippingLineConfig = {};
            vm.shippingLineOptions = {};
            vm.portConfig = {};
            vm.portOptions = {};

            dropDownConfig.prepareShippingLineConfig(vm.shippingLineConfig, vm.shippingLineOptions);
            dropDownConfig.prepareShippingPortConfig(vm.portConfig, vm.portOptions);
            dropDownConfig.prepareBusinessDropDown(vm.shipperConfig, vm.shipperOptions, 'Shipper');


            vm.appFormats = appFormats;
            vm.shipmentStatus = shipmentStatus;
            vm.addingNote=false;
            vm.updateNote=false;
            vm.transactionId = trade.id;
            console.log(vm.transactionId);
            vm.transaction = trade;
            vm.showDocument = false;
            vm.documentAdding = false;
            vm.addingDocument = false;
            vm.newDocumentName = '';
            vm.noteText = '';
            vm.addNewDocument = addNewDocument;
            vm.uploadTradeDocument = uploadTradeDocument;
            vm.cancelDocumentUpload = cancelDocumentUpload;
            vm.editTradeNote = editTradeNote;
            vm.deleteTradeNote = deleteTradeNote;
            vm.addTradeNote = addTradeNote;
            vm.deleteTradeDoc = deleteTradeDoc;
            vm.downloadTradeDoc = downloadTradeDoc;
            vm.editTransactionDetails = editTransactionDetails;
            vm.createWatsappCopy = createWatsappCopy;
            vm.activateShipmentStatus = activateShipmentStatus;

            vm.editNotShipped = editNotShipped;
            vm.editApprobationReceived = editApprobationReceived;
            vm.editShipped = editShipped;
            vm.editArrivedAtPort = editArrivedAtPort;

            vm.loadPorts = loadPorts;

            vm.createTransactionInvoice = createTransactionInvoice;
            vm.activateShipment = activateShipment;
            vm.changeCompleteStatus = changeCompleteStatus;
            vm.showTradeCashFlow = showTradeCashFlow;
            vm.goToInvoice = goToInvoice;

            vm.productConfig = {};
            vm.productOptions = {};
        }

        function showTradeCashFlow(fileId){
            deModal.openTransactionCashFlowModal(fileId, function(fileId){

            });
        }

        function createTransactionInvoice(fileId){
            $state.go('dashboard.accounts.invoiceForm',{
                'fileId': fileId,
                'invoiceId': 'new'
            })
        }

        function loadVessel(query){
            return shipping.getVesselTags(query).then(function(res){
                return res.data
            });
        }

        function loadPorts(query){
            return shipping.getPortTags(query).then(function(res){
                return res.data

            });
        }

        function goToInvoice(fileId, invoiceId){
            $state.go('dashboard.accounts.invoiceForm', {fileId: fileId, invoiceId: invoiceId})
        }

        function cancelShipmentForm(flag){
            vm[flag] = false;
        }

        function changeCompleteStatus(completeObj, transactionId){
            deModal.openTransactionCompleteModel(completeObj, transactionId, function(completeObj){
                loaderModal.open();
                tradeBook.changeCompleteStatus(transactionId, completeObj).then(function(res){
                    if(res.success){
                        vm.transaction = res.transactionObj;
                        toastr.success(res.message)
                    }
                    else{
                        toastr.error(res.message);
                    }
                    loaderModal.close();
                });

            });

        }

        function activateShipmentStatus(shipmentStatus, status, transactionId){
            loaderModal.open();
            tradeBook.activateShipmentStatus(shipmentStatus, status, transactionId).then(function(res){
                if(res.success){
                    vm.transaction = res.transactionObj;
                    toastr.success(res.message, 'Shipment Status Updated');
                }
                else{
                    toastr.error(res.message,'Error Changing Shipment Status');
                }
                loaderModal.close();
            });
        }


        function onSuccessForm(boolean, res){
            if(res.success){
                vm.transaction = res.transactionObj;
                toastr.success(res.message, 'Shipment Information Updated!');
                cancelShipmentForm(boolean);
            }
            else{
                toastr.error();
            }

        }

        function editNotShipped(formObj, dataObj, transactionId){
            loaderModal.open();
            tradeBook.updateNotShippedInfo(dataObj, transactionId).then(function(res){
                loaderModal.close();
                onSuccessForm('showNotShippedForm', res);
            });
        }


        function editApprobationReceived(formObj, dataObj, transactionId){
            loaderModal.open();
            tradeBook.updateApprobationReceivedInfo(dataObj, transactionId).then(function(res){

                loaderModal.close();
                onSuccessForm('showApprobationRecievedForm', res);
            });
        }

        function editShipped(formObj, dataObj, transactionId){
            loaderModal.open();
            tradeBook.updateShippedInfo(dataObj, transactionId).then(function(res){
                loaderModal.close();
                onSuccessForm('showShippedForm', res);
            });
        }

        function editArrivedAtPort(formObj, arrivedObj, transactionObj, transactionId){
            var expectedCommission = null;
            console.log(arrivedObj);
            loaderModal.open();
            return tradeBook.updateArrivedAtPortInfo(arrivedObj, transactionId, expectedCommission).then(function(res){
                loaderModal.close();
                onSuccessForm('showArrivedAtPort', res);

            });
        }


        function activateShipment(){

        }


        function createWatsappCopy(transaction){

        }

        function editTransactionDetails(transactionId){
            $state.go('dashboard.transaction', {id: transactionId});
        }

        function openTradeDoc(){

        }

        function downloadTradeDoc(docId, fileName, fileType){
            tradeBook.downloadTradeDocument(docId, fileName, fileType);
        }

        function deleteTradeDoc(docId){
            loaderModal.open();
            tradeBook.deleteTransactionDocument(docId).then(function(res){
                if(res.success){
                    toastr.success(res.message);
                    var index = _.findIndex(vm.transaction.files, function(doc){
                        return doc.id = doc.fileId;
                    });
                    vm.transaction.files.splice(index, 1);
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            })
        }

        function uploadTradeDocument(file, errFiles){
            if(vm.newDocumentName === ''){
                toastr.error('Please enter document name', 'Error');
                return;
            }
            var extension = file.name.split('.');
            var ext = extension[extension.length - 1];
            if(file){
                loaderModal.open();
                file.upload = Upload.upload({
                    url: 'api/'+apiEndPoints.transaction.main + '/' + apiEndPoints.transaction.document + '/',
                    data: {
                        file: file,
                        name: vm.newDocumentName+'.'+ext,
                        tradeId: vm.transactionId,
                        extension: ext
                    }
                });

                file.upload.then(function (response) {
                    loaderModal.close();
                    if(response.data.success){
                        vm.addingDocument = false;
                        vm.transaction.files.push(response.data.fileObj);

                    }
                });
            }
        }

        function editTradeNote(noteText, note){
            vm.noteText = noteText;
            note.editing = true;
            vm.updateNote = true;
        }

        function deleteTradeNote(tradeId, noteId, note, noteList){
            loaderModal.open();
            return tradeBook.deleteTradeNote(tradeId, noteId).then(function(res){
                if(res.success){
                    var index = _.indexOf(noteList, note);
                    noteList.splice(index, 1);
                    toastr.success(res.message, 'Note Deleted');
                }
                else{
                    toastr.error(res.message);
                }
                loaderModal.close();
            });

        };

        function addTradeNote(tradeId, note, noteList, formObj){
            if(formObj.$valid){
                if(note === ''){
                    toastr.error('Please add a note');
                }
                else{

                    vm.addingNote = false;
                    if(!vm.updateNote){
                        loaderModal.open();
                        tradeBook.addTradeNote(tradeId, note).then(function(res){
                            if(res.success){
                                toastr.success(res.message, 'Note Added');
                                noteList.push(res.note);

                            }
                            else{
                                toastr.error(res.message);
                            }
                            vm.noteText = '';
                            utilities.resetFormValidation(formObj);
                            loaderModal.close();
                        })
                    }
                    else{
                        var noteEdited = _.find(noteList, function(n) { return (n.editing == true); });
                        var index = _.indexOf(noteList, noteEdited);
                        tradeBook.editTradeNote(tradeId, noteEdited.noteId, note).then(function(res){
                            loaderModal.open();
                            if(res.success){
                                vm.updateNote = false;
                                noteList[index] = res.note;
                                toastr.success(res.message, 'Note Updated')
                            }
                            else{
                                toastr.error(res.message);
                            }
                            vm.noteText = '';
                            utilities.resetFormValidation(formObj);
                            loaderModal.close();
                        })
                    }

                }
            }

        };

        function cancelDocumentUpload(){

        }

        function addNewDocument(){
            vm.addingDocument = true;
        }

    }


})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('app.dashboard.user')
        .controller('ProfilePage', ProfilePage);

    /** @ngInject */
    function ProfilePage(fileReader, authentication, $filter, deModal, userProfile,
                         utilities, dropDownConfig, toastr, $scope, user, $state, loaderModal) {
        var vm = this;
        _init();

        function _init(){
            vm.isCurrentUserSuperUser = authentication.currentUserIsSuperUser();
            vm.locationConfig = {};
            vm.locationOptions = {};
            vm.designationOptions = {};
            vm.designationConfig = {};
            vm.userProfile = userProfile;
            vm.cancel = cancel;
            vm.imagesData = null;
            vm.userData = authentication.getUserData();
            vm.picture = $filter('profilePicture')(userProfile.profilePic);
            vm.noPicture =  userProfile.profilePic ? true: false;
            vm.updateUser = updateUser;
            vm.addUser = addUser;
            vm.removePicture = removePicture;
            vm.uploadPicture = uploadPicture;
            vm.getFile = getFile;
            dropDownConfig.prepareBusinessLocationsDropDown(vm.locationConfig, vm.locationOptions);
            dropDownConfig.prepareDesignationDropDown(vm.designationConfig, vm.designationOptions);
        }

        function cancel(){
            try {
                $state.go($state.current.prevState, $state.current.prevParam);
            }
            catch(err) {
                $state.go('dashboard.main');
            }

        }

        function removePicture() {
            vm.noPicture = true;
            userProfile.profilePic = null;
            vm.picture = $filter('profilePicture')(userProfile.profilePic);
        }

        function uploadPicture() {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        }

        function addUser(form, userObj, images){
            if(form.$valid){
                loaderModal.open();
                user.addUserProfile(userObj, images).then(function(response){
                    if(response.success){
                        if(!vm.noPicture){
                            if(images){
                                user.addProfilePic(images, response.user_id).then(function(picResp){
                                    toastr.success(response.message,'Success');

                                });
                            }


                        }
                        else{
                            loaderModal.close();
                        }
                    }
                    else{
                        toastr.error(response.message);
                        utilities.goBackState();
                    }
                    cancel();
                    loaderModal.close();
                });
            }
            else{
                toastr.error('Please enter the missing fields', 'Invalid Form');
            }

        }

        function updateUser(form, userObj, images){
            if(form.$valid){
                loaderModal.open();
                user.updateUserProfile(userObj, images).then(function(response){
                    console.log(response);
                    if(response.success){
                        if(!vm.noPicture){
                            user.addProfilePic(images, response.user_id).then(function(picResp){
                                if(vm.userData.data.id === response.user_id){
                                    authentication.getUserData(true);
                                }
                                toastr.success(response.message,'Success');

                            });
                        }
                        else{
                            toastr.success(response.message,'Success');
                        }
                        cancel();
                        loaderModal.close();

                    }
                    else{
                        toastr.error(response.message);
                    }
                });
            }
            else {
                toastr.error('Please enter the missing fields', 'Invalid Form');
            }
        }

        function getFile(picture){
            fileReader.readAsDataUrl(picture, $scope)
                .then(function (result) {
                    deModal.openImageCropper(result, 1, [{w: 200,h: 200}, {w:100, h:100}], {width:100, height:100},
                        function(imagesData){
                            vm.picture = imagesData.croppedImage;
                            vm.imagesData = imagesData;
                        });
                    // vm.picture = result;
                });
        }


    }

})();

'use strict';

angular.module('app', [
  'app.core',
  'textAngularSetup',
  'app.common',
  'app.theme',
  'app.modal',
  'app.landing',
  'app.authentication',
  'app.dashboard',
  'app.widgets',
]);






/**
 * @ngdoc service
 * @name app.authentication.authentication
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.authentication').factory('authentication', authentication);


    function authentication(Restangular, apiEndPoints, $state, $http, $cookies, toastr, httpStatus, utilities,
                            $auth, localStorageService, loaderModal, baSidebarService){
        var authAPI = Restangular.all(apiEndPoints.authentication.basic);
        var loginApi = Restangular.all(apiEndPoints.login);
        var logOutApi = Restangular.all(apiEndPoints.logout);
        var userData = {};
        var sideBarDynamic = {
            userManagement: {
                title: 'User Management',
                icon: 'ion-android-contacts',
                stateRef: 'dashboard.user.list'
            },
            simpleTradeBook: {
                title: 'Trade Book',
                icon: 'ion-social-usd',
                stateRef: 'dashboard.tradeDashboard',
                priority: 7
            },
            optionTradeBook:{
                title: 'Trade Book',
                icon: 'ion-social-usd',
                priority: 7,
                subMenu: [
                    {
                        title: 'Dashboard',
                        stateRef: 'dashboard.tradeDashboard'
                    },
                    {
                        title: 'Business Analytics',
                        stateRef: 'dashboard.internationalTradeAnalytics'
                    },
                    {
                        title: 'Trade Book',
                        stateRef: 'dashboard.tradeBook'
                    }
                ]
            }


        }

        return {
            login: login,
            logout: logout,
            getUserData: getUserData,
            setUserData: setUserData,
            getUserBusinessId: getUserBusinessId,
            authenticate: authenticate,
            currentUserIsSuperUser: currentUserIsSuperUser,
            hasBusinessAnalyticsAccess: hasBusinessAnalyticsAccess
        };

        function authenticate(provider, callback){
            loaderModal.open();
            $auth.authenticate(provider).then(function(res){
                if(res.data.success){
                    toastr.success(res.message);
                    callback();
                }
                else{
                    toastr.error(res.data.message);
                }
                loaderModal.close();
            }, function(err){
                toastr.error('Unable to save your google analytics token');
            }).finally(function(){
                loaderModal.close();
            });
        }

        function getUserBusinessId(){
            return getUserData().data.businessId
        }

        function hasBusinessAnalyticsAccess(){
            return getUserData().data.rights.businessAnalytics
        }

        function currentUserIsSuperUser(){
            return getUserData().data.isSuperuser
        }

        function getUserData(update){
            if(_.isEmpty(userData) || update){
                return loginApi.customGET().then(function(response){
                    setUserData(response.userData);
                    return getUserData();
                });
            }
            return userData;
        }

        function setUserData(data){
            userData.data = data;
            var userManagement = data.rights.userManagement;
            var businessAnalytics = data.rights.businessAnalytics;
            if(userManagement){
                baSidebarService.addStaticItem({
                    title: 'User Management',
                    icon: 'ion-android-contacts',
                    stateRef: 'dashboard.user.list'
                });
            }
            if(!businessAnalytics){
                var alreadyAdded = baSidebarService.itemAlreadyInItems(sideBarDynamic['simpleTradeBook']);
                if(!alreadyAdded){
                    baSidebarService.addStaticItem(sideBarDynamic['simpleTradeBook']);
                }
            }
            else{
                var alreadyAdded = baSidebarService.itemAlreadyInItems(sideBarDynamic['optionTradeBook']);
                if(!alreadyAdded){
                    baSidebarService.addStaticItem(sideBarDynamic['optionTradeBook']);
                }
            }
        }

        function login(form, username, password){
            loginApi.post({
                'username':username,
                'password': password
            }).then(function(response){
                setUserData(response['userData']);
                $http.defaults.headers.post['X-CSRFToken'] = $cookies.get('csrftoken');
                $http.defaults.headers.put['X-CSRFToken'] = $cookies.get('csrftoken');
                var lastPage = localStorageService.get('lastState');
                if(lastPage && lastPage.stateOnLogin && lastPage.stateOnLogin !== "login"){
                    $state.go(lastPage.stateOnLogin,lastPage.stateParamsOnLogin);
                }
                else{
                    $state.go('dashboard.main');
                }

            }, function(error){
                if(error['data']==='INVALID_CREDENTIALS' && error['status'] === httpStatus.NOT_FOUND){
                    toastr.error('You username or password seems to be incorrect!','Invalid Credentials')
                }
                console.log(error);
            }).finally(function(){
                utilities.resetFormValidation(form)
            });
        }

        function logout(){
            logOutApi.post().then(function(response){
                if(response['success']){
                    var lastState = {
                        stateOnLogin: $state.current.name,
                        stateParamsOnLogin: $state.params
                    };
                    localStorageService.set('lastState',lastState);
                    $state.go('login')
                }
            });
        }
    }
}());

/**
 * @ngdoc service
 * @name app.common.documentExporter
 * @description < description placeholder >
 */

(function(){

  'use strict';

  angular
      .module('app.common')
      .factory('documentExporter', documentExporter);

  /* @ngInject */
  function documentExporter($filter, $timeout, appFormats, images){
    return {
      getTableInExcelSheet: getTableInExcelSheet,
      printPDF: printPDF,
      createA4Document: createA4Document
    };

    function getA4PDFSheet(content){
      var docDefinition = {

        pageSize: 'A4',

        header: {
          margin: [20, 10, 30, 0],
          columns: [
            {

              table: {
                widths: ['70%','35%'],

                body: [
                  [
                    { image: images.LOGO,

                      width: 180, height: 90,

                    },

                    {
                      alignment: 'right',
                      table: {

                        body: [
                          [{text:'Phone', border: [false, false, false, false], style: 'boldHeader'},
                            {text:'+92-21-32430152-5 (4 Lines)',  style: 'boldSubHeader', border: [false, false, false, false]}],

                          [{text:'Fax', border: [false, false, false, false], style: 'boldHeader'},
                            {text:'+92-21-3243213-32431366',  style: 'boldSubHeader', border: [false, false, false, false]}],
                          [{text:'Email', border: [false, false, false, false], style: 'boldHeader'},
                            {text:'info@doniGroup.com',  style: 'boldSubHeader', border: [false, false, false, false]}],
                          [{text:'Website', border: [false, false, false, false], style: 'boldHeader'},
                            {text:'www.doniGroup.com',  style: 'boldSubHeader', border: [false, false, false, false]}]
                        ]
                      }
                    }
                  ]
                ]
              },
              layout: 'noBorders'
            }

          ]
        },

        footer: {
          margin:[0,10,0,0],
          columns: [

            {
              table:{
                widths: ['10%', '30%', '60%'],
                body:[
                  [
                    {text:'', fillColor:'#3C3837', border: [false, false, false, false]},
                    {text:'', fillColor: '#E10915', border: [false, false, false, false], style:'redBox'},
                    {text:'', fillColor:'#3C3837', border: [false, false, false, false]}
                  ]

                ]
              }
            }
          ]
        },

        content: content,
        pageMargins: [40, 180, 20, 15],

        styles: {
          boldHeader: {
            fontSize: 10,
            alignment: 'left',
            bold: true
          },

          boldSubHeader:{
            fontSize: 10
          },

          redBox:{
          },

          subheader: {
            fontSize: 15,
            bold: true
          },
          quote: {
            italics: true
          },
          small: {
            fontSize: 8
          }
        }
      }

      return docDefinition;

    }


    function createA4Document(content){
      var a4Sheet = getA4PDFSheet([]);
      var doc = a4Sheet;
      pdfMake.createPdf(doc).open();
    }

    function printPDF(columnHeader, columnKeys, itemList){
      var tableRows = [columnHeader];
      var regexExp=/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
      angular.forEach(itemList, function(item,key){
        var row = [];
        angular.forEach(columnKeys, function(keyName,key){
          if(regexExp.test(item[keyName])){
            row.push($filter('date')(new Date(item[keyName]), appFormats.Date));
          }
          else{
            row.push(item[keyName]);
          }

        });
        tableRows.push(row)
      });
      var docDefinition = {
        pageSize: 'LEGAL',
        pageOrientation: 'landscape',
        pageMargins: [40, 80, 40, 60],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
            textAlign: 'center'
          },
          content:{
            fontSize: 12
          }
        },
        footer: function(currentPage, pageCount) {
          return currentPage.toString() + ' of ' + pageCount;
        },
        header: function(currentPage, pageCount) {
          // you can apply any logic and return any valid pdfmake element

          return {
            margin: 8,
            columns: [
              {
                table: {
                  widths: ['*', 'auto'],
                  headerRows: 1,
                  body: [
                    [
                      {
                        image: images.LOGO,
                        width: 120, height: 60,
                        border: [false, true, true, true],
                        style: 'header'
                      },
                    ]
                  ]
                },
                layout: 'noBorders'
              }

            ],

            alignment: (currentPage % 2) ? 'left' : 'right'
          };
        },
        content: {
          style: 'content',
          table: {
            body: tableRows
          }
        },
      };
      pdfMake.createPdf(docDefinition).open();
    }

    ////////////////////

    /**
     * @ngdoc
     * @name app.common.documentExporter#testFunction
     * @methodOf app.common.documentExporter
     *
     * @description < description placeholder >
     * @example
     * <pre>
     * documentExporter.testFunction(id);
     * </pre>
     * @param {int} entity id
     */
    function getTableInExcelSheet(headings, association, dataObject, fileName){
      var authData = dataObject;
      var headingObj = {};
      for(var heading in headings){
        headingObj[headings[heading]] = null;
      }
      var regexExp=/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
      var csvData = [];
      angular.forEach(dataObject, function (dataSet, key) {
        var tempHeading = angular.copy(headingObj);
        angular.forEach(association,function(ass,asskey){
          if(regexExp.test(dataSet[ass])){
            dataSet[ass] = $filter('date')(new Date(dataSet[ass]), appFormats.Date);
          }
          tempHeading[headings[asskey]] = dataSet[ass];
        });
        csvData.push(tempHeading);

      });
      exportCsv(csvData, true, fileName);
    }


    function exportCsv(JSONData, ShowLabel, csvFileName) {
      // console.log(ShowLabel, csvFileName);
      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;

      var CSV = '';

      //This condition will generate the Label/Header
      if (ShowLabel) {
        var labelRow = '';

        //This loop will extract the label from 1st index of on array
        for (var labelIndex in arrData[0]) {

          //Now convert each value to string and comma-seprated
          labelRow += labelIndex + ',';
        }

        labelRow = labelRow.slice(0, -1);

        //append Label row with line break
        CSV += labelRow + '\r\n';
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = '';

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {

          // To handle empty value undefined was showing.
          var columnValue = arrData[i][index] ? arrData[i][index] : '';
          row += '"' + columnValue + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
      }

      if (CSV === '') {
        return;
      }
      //Generate a file name
      var fileName = csvFileName + '.csv';
      //this will remove the blank-spaces from the title and replace it with an underscore
      //fileName += ReportTitle.replace(/ /g,"_");

      var blob = new Blob([CSV]);
      if (window.navigator.msSaveOrOpenBlob)  // IE hack; see http://msdn.microsoft.com/en-us/library/ie/hh779016.aspx
        window.navigator.msSaveBlob(blob, fileName);
      else
      {
        var a = window.document.createElement("a");
        a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
        a.download = fileName;
        document.body.appendChild(a);
        $timeout(function(){
          a.click();
        }); // IE: "Access is denied"; see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
        document.body.removeChild(a);
      }
    }
  }

}());

/**
 * @ngdoc service
 * @name app.common.dropDownConfig
 * @description < description placeholder >
 */

(function(){

  'use strict';

  angular
      .module('app.common')
      .factory('dropDownConfig', dropDownConfig);

  /* @ngInject */
  function dropDownConfig(Restangular, businessPartner, utilities, settings, apiEndPoints, crud, read, appConstants){
    return {

      getBasicDropDownConfig: getBasicDropDownConfig,

      contactTypeConfig: contactTypeConfig,
      prepareProductItemDropDown: prepareProductItemDropDown,
      prepareBusinessDropDown: prepareBusinessDropDown,
      getPackingConfig: getPackingConfig,
      getCommissionTypeConfig: getCommissionTypeConfig,
      getBpLocationConfig: getBpLocationConfig,
      prepareBusinessLocationsDropDown: prepareBusinessLocationsDropDown,
      prepareDesignationDropDown: prepareDesignationDropDown,
      prepareProductCategoryDropDown: prepareProductCategoryDropDown,
      prepareCountryDropDown: prepareCountryDropDown,
      prepareKeywordDropDown: prepareKeywordDropDown,
      prepareProductDropDown: prepareProductDropDown,
      prepareProductOriginDropDown: prepareProductOriginDropDown,
      prepareCurrencyDropDown: prepareCurrencyDropDown,
      preparePriceMarketDropDown: preparePriceMarketDropDown,
      prepareShipmentMonthDropDown: prepareShipmentMonthDropDown,
      preparePriceMetricConfig: preparePriceMetricConfig,
      prepareRegionDropDown: prepareRegionDropDown,
      prepareCityDropDown: prepareCityDropDown,
      prepareByTypesDropDown: prepareByTypesDropDown,
      prepareContactNumberTypeDropDown: prepareContactNumberTypeDropDown,
      preparePackagingConfig: preparePackagingConfig,
      prepareCommissionTypeConfig: prepareCommissionTypeConfig,

      prepareShippingLineConfig: prepareShippingLineConfig,
      prepareShippingPortConfig: prepareShippingPortConfig,
      prepareShippingVesselConfig: prepareShippingVesselConfig,
      prepareWarehouseDropDown: prepareWarehouseDropDown,
      prepareInternationalFileIdAutoComplete: prepareInternationalFileIdAutoComplete,
      prepareLocalTradeConfig: prepareLocalTradeConfig,

      prepareTimeDrillOptions: prepareTimeDrillOptions

    };

    function prepareTimeDrillOptions(timeDrillConfig, timeDrillOptions){
      function getTimeDrillOptions(){
        return [
          {text:'By Day', value: 'day', order:1},
          {text:'By Week', value:'week', order:2},
          {text:'By Month', value:'month', order:3},
          {text:'By Year', value:'year', order:4}
        ];
      }
      utilities.cloneIntoEmptyObject(timeDrillConfig, getBasicDropDownConfig());
      timeDrillOptions['onItemRemove'] = function(value, obj){
        var selectizeDropDown = this;
        var removedOption = _.find(timeDrillOptions, function(opt) { return opt.value == value; });
        timeDrillOptions.list.push(removedOption);
        selectizeDropDown.refreshItems();
      };
      utilities.cloneIntoEmptyObject(timeDrillOptions, getTimeDrillOptions());
    }

    function prepareInternationalFileIdAutoComplete(fileIdConfig, fileIdOptions, multiple){

      function fileItem(item, escape) {
        return '<div>' +
            '<span class="dropdownLabel">' + item.fileId + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ (item.contractId ? item.contractId : 'NA') + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.buyerName + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.sellerName + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ (item.blNo ? item.blNo : 'NA') + '</span>' +
            '</div>';
      }

      var config = {
        valueField: 'fileId',
        sortField: 'fileId',
        searchField: ['fileId', 'contractId', 'blNo', 'buyerName', 'sellerName'],
        render: {
          item: fileItem,
          option: fileItem
        },
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(fileIdOptions.list, function(line) { return line.fileId == value; });
          fileIdOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        }
      };
      if(!multiple){
        config['maxItems'] = 1
      }
      utilities.cloneIntoEmptyObject(fileIdConfig, config);
      settings.dropDownAPI.customGET(apiEndPoints.dropDown.transaction).then(function (response){
        return utilities.cloneIntoEmptyObject(fileIdOptions, response.transactionList);
      });
    }

    function prepareLocalTradeConfig(localTradeConfig, localTradeOptions, multiple){
      function fileItem(item, escape) {
        return '<div>' +
            '<span class="dropdownLabel">' + item.fileId + '</span>' +
            '<span class="dropdownCaption" ng-if="item.contractId">' + ' | '+ item.contractId + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.buyerName + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.sellerName + '</span>' +
            '</div>';
      }
      var config = {
        valueField: 'fileId',
        sortField: 'fileId',
        searchField: ['fileId', 'contractId', 'blNo'],
        render: {
          item: fileItem,
          option: fileItem
        },
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(fileIdOptions.list, function(line) { return line.fileId == value; });
          fileIdOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        }

      };
      if(!multiple){
        config['maxItems'] = 1
      }
      utilities.cloneIntoEmptyObject(localTradeConfig, config);
      settings.dropDownAPI.customGET(apiEndPoints.dropDown.localTrade).then(function (response){
        return utilities.cloneIntoEmptyObject(localTradeOptions, response.transactionList);
      });
    }


    function prepareShippingVesselConfig(){

    }

    function prepareShippingPortConfig(shippingPortConfig, shippingPortOptions){

      function shippingPortItem(item, escape){
        return '<div>' +
            '<span class="dropdownLabel">' + item.name + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.loCode  + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.country + '</span>' +
            '</div>';
      }

      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(shippingPortOptions.list, function(port) { return port.id == value; });
          shippingPortOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['name', 'loCode', 'country'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: shippingPortItem,
          option: shippingPortItem
        }
      };
      utilities.cloneIntoEmptyObject(shippingPortConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.ports).then(function (response){
        return utilities.cloneIntoEmptyObject(shippingPortOptions, response.list);
      });
    }


    function prepareShippingLineConfig(shippingLineConfig, shippingLineOptions){

      function shippingLineItem(item, escape){
        return '<div>' +
            '<span class="dropdownLabel">' + item.name + '</span>' +
            '<span class="dropdownCaption">' + ' | '+ item.codeName  + '</span>'
        '</div>';
      }

      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(shippingLineOptions.list, function(line) { return line.id == value; });
          shippingLineOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['name', 'codeName'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: shippingLineItem,
          option: shippingLineItem
        }
      };
      utilities.cloneIntoEmptyObject(shippingLineConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.shippingLine).then(function (response){
        return utilities.cloneIntoEmptyObject(shippingLineOptions, response.list);
      });
    }


    function preparePackagingConfig(packagingConfig, packagingOption){
      utilities.cloneIntoEmptyObject(packagingConfig, getBasicDropDownConfig());
      settings.dropDown[crud.READ](apiEndPoints.dropDown.packaging, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(packagingOption, response.list);
          });
    }

    function prepareCommissionTypeConfig(commissionTypeConfig, commissionTypeOptions){
      utilities.cloneIntoEmptyObject(commissionTypeConfig, getBasicDropDownConfig());
      settings.dropDown[crud.READ](apiEndPoints.dropDown.commissionType, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(commissionTypeOptions, response.list);
          });
    }

    function shipementMonthconfig(item, escape){
      return '<div>' +
          '<span class="dropdownLabel">' + item.month + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ item.year + '</span>' +
          '</div>';
    }

    function prepareContactNumberTypeDropDown(contactTypeConfig, contactTypeOptions){
      utilities.cloneIntoEmptyObject(contactTypeConfig, getBasicDropDownConfig());
      contactTypeConfig['onItemRemove'] = function(value, obj){
        var selectizeDropDown = this;
        var removedOption = _.find(contactTypeOptions.list, function(opt) { return opt.id == value; });
        contactTypeOptions.list.push(removedOption);
        selectizeDropDown.refreshItems();
      };
      settings.dropDown[crud.READ](apiEndPoints.dropDown.contactType, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(contactTypeOptions, response.list);
          });
    }

    function getBusinessItem(item, escape){
      var country = (!item.country) ? 'No Origin' : item.country;
      var pContact = (item.contactPerson === null)? 'No Primary Contact' : item.contactPerson;
      return '<div>' +
          '<span class="dropdownLabel">' + utilities.manageTextOverFlow(item.name, 20) + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ country + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ pContact + '</span>' +
          '</div>';

    }

    function getBusinessOption(item, escape){
      var country = (!item.country) ? 'No Origin' : item.country;
      var pContact = (item.contactPerson === null)? 'No Primary Contact' : item.contactPerson;
      return '<div>' +
          '<span class="dropdownLabel">' + item.name + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ country + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ pContact + '</span>' +
          '</div>';

    }

    function prepareBusinessDropDown(businessConfig, businessOptions, businessType){
      var config = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(businessOptions.list, function(business) { return business.id == value; });
          businessOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['name','contactPerson','country'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: getBusinessItem,
          option: getBusinessOption
        }
      };
      utilities.cloneIntoEmptyObject(businessConfig, config);
      settings.dropDown[crud.READ](apiEndPoints.dropDown.business, {'type': businessType})
          .then(function(response){
            return utilities.cloneIntoEmptyObject(businessOptions, response.list);
          });
    }

    function prepareByTypesDropDown(bpTypeConfig, bpTypeOptions){
      utilities.cloneIntoEmptyObject(bpTypeConfig, getBasicDropDownConfig(true, bpTypeOptions));
      settings.dropDown[crud.READ](apiEndPoints.dropDown.bpType, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(bpTypeOptions, response.list);
          });
    }

    function prepareWarehouseDropDown(warehouseConfig, warehouseOptions){
      utilities.cloneIntoEmptyObject(warehouseConfig, getBasicDropDownConfig(false, warehouseOptions));
      settings.dropDown[crud.READ](apiEndPoints.dropDown.warehouses, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(warehouseOptions, response.list);
          });
    }



    function prepareShipmentMonthDropDown(monthConfig, monthOptions, priceDate){
      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(monthOptions.list, function(month) { return month.startMonth == value; });
          monthOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'startMonth',
        sortField: 'startMonth',
        searchField: ['month', 'year'],
        create: false,
        persist: false,
        render:{
          item: shipementMonthconfig,
          option: shipementMonthconfig
        }
      };
      utilities.cloneIntoEmptyObject(monthConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.shipmentMonth, priceDate).then(function (response){
        return utilities.cloneIntoEmptyObject(monthOptions, response.list);
      });
    }


    function priceMarketOption(item, escape){
      return '<div>' +
          '<span class="dropdownLabel">' + item.origin + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ item.currency + '</span>' +
          '</div>';
    }


    function preparePriceMarketDropDown(priceMarketConfig, priceMarketOptions, onPriceMarketChange){
      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(priceMarketOptions.list, function(market) { return market.id == value; });
          priceMarketOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'id',
        sortField: 'origin',
        searchField: ['origin', 'currency'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: priceMarketOption,
          option: priceMarketOption
        }
      };
      if(onPriceMarketChange){
        dropDown['onChange'] = onPriceMarketChange;
      }
      utilities.cloneIntoEmptyObject(priceMarketConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.priceMarket).then(function (response){
        return utilities.cloneIntoEmptyObject(priceMarketOptions, response.list);
      });
    }



    function productItemItem(item, escape) {
      var keywords = (item.keywords === '')? 'No Keywords' : item.keywords;
      return '<div>' +
          '<span class="dropdownLabel">' + utilities.manageTextOverFlow(item.name, 20) + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ item.origin + '</span>' +
          '<span class="dropdownCaption" style="max-width: 80px;text-overflow: ellipsis">' + ' | '+utilities.manageTextOverFlow(keywords, 15)  + '</span>' +
          '</div>';
    }

    function productItemOption(item, escape) {
      var keywords = (item.keywords === '')? 'No Keywords' : item.keywords;
      return '<div>' +
          '<span class="dropdownLabel">' + item.name + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ item.origin + '</span>' +
          '<span class="dropdownCaption" style="max-width: 80px;text-overflow: ellipsis">' + ' | '+ keywords + '</span>' +
          '</div>';
    }


    function prepareProductItemDropDown(productItemConfig, productItemOptions, pricingOnWebsiteOnly){
      pricingOnWebsiteOnly = pricingOnWebsiteOnly ? pricingOnWebsiteOnly : false;
      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(productItemOptions.list, function(prod) { return prod.id == value; });
          productItemOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['name', 'origin', 'keywords'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: productItemItem,
          option: productItemOption
        }
      };
      utilities.cloneIntoEmptyObject(productItemConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.productItem, {'pricingOnWebsiteOnly': pricingOnWebsiteOnly})
          .then(function (response){
            return utilities.cloneIntoEmptyObject(productItemOptions, response.list);
          });
    }



    function currencyItem(item, escape) {
      var name = item.name;
      return '<div>' +
          '<span class="dropdownLabel">' + name + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ item.code + '</span>' +
          '</div>';
    }

    function prepareCurrencyDropDown(currencyConfig, currencyOptions){
      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(currencyOptions.list, function(opt) { return opt.code == value; });
          productOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'code',
        sortField: 'name',
        searchField: ['name'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: currencyItem,
          option: currencyItem
        }
      };
      utilities.cloneIntoEmptyObject(currencyConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.currency).then(function (response){
        return utilities.cloneIntoEmptyObject(currencyOptions, response.list);
      });
    }

    function prepareKeywordDropDown(keywordConfig, keywordOptions, productId, callback){
      var options = {};
      utilities.cloneIntoEmptyObject(keywordConfig, getBasicDropDownConfig(true, keywordOptions, 'id', 'name'));
      if(!productId) return;
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.productKeywords, productId).then(function (response) {
        utilities.cloneIntoEmptyObject(options, response.list);
        if(callback){
          callback();
        }
        return utilities.cloneIntoEmptyObject(keywordOptions, response.list);
      });
    }

    function prepareProductDropDown(productConfig, productOptions, productOriginConfig, productOriginOptions,
                                    keywordConfig, keywordOptions, onChangeCallBack){
      var dropDown = {
        onItemRemove: function(value, obj){
          var selectizeDropDown = this;
          var removedOption = _.find(productOptions.list, function(opt) { return opt.id == value; });
          productOptions.list.push(removedOption);
          selectizeDropDown.refreshItems();
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['name'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: productOption,
          option: productOption
        }
      };
      if(productOriginConfig){
        dropDown['onChange'] = function (value){
          onChangeCallBack(productOriginConfig, productOriginOptions, keywordConfig, keywordOptions, value);
        };
      }
      utilities.cloneIntoEmptyObject(productConfig, dropDown);
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.product).then(function (response){
        return utilities.cloneIntoEmptyObject(productOptions, response.list);
      });
    }

    function productOption(item, escape) {
      var name = item.name;
      return '<div>' +
          '<span class="dropdownLabel">' + name + '</span>' +
          '<span class="dropdownCaption">' + ' | '+ item.category + '</span>' +
          '</div>';
    }


    function prepareProductOriginDropDown(productOriginConfig, productOriginOptions, productId, callback){
      var options = {};
      var dropDown = {
        onItemRemove: function(value){
          var removedItem = _.find(options.list, function(opt) { return opt.code == value; });
          productOriginOptions.list.push(removedItem);
          var selectizeDropDown = this;
          selectizeDropDown.refreshItems();
        },
        maxItems: 1,
        valueField: 'code',
        sortField: 'name',
        searchField: ['name'],
        openOnFocus: true,
        closeOnSelect: true,
        create: false,
        persist: false,
        render: {
          item: countryItem,
          option: countryItem
        }
      };
      utilities.cloneIntoEmptyObject(productOriginConfig, dropDown);
      if(!productId) return;
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.productOrigin, productId).then(function (response){
        utilities.cloneIntoEmptyObject(options, response.list);
        utilities.cloneIntoEmptyObject(productOriginOptions, response.list);
        if(callback){
          callback();
        }
        return;

      });
    }

    function prepareRegionDropDown(regionConfig, regionOptions, countryCode, onChangeCallBack){
      if(regionConfig) {
        utilities.cloneIntoEmptyObject(regionConfig, getBasicDropDownConfig());
        if(onChangeCallBack){
          regionConfig['onChange'] = function (value){
            console.log(value);
            onChangeCallBack(value);
          };
        }
      }
      if(countryCode){
        settings.dropDown[crud.READ](apiEndPoints.dropDown.region, countryCode)
            .then(function(response){
              return utilities.cloneIntoEmptyObject(regionOptions, response.list);
            });
      }
    }

    function prepareCityDropDown(cityConfig, cityOptions, countryCode, regionCode){
      if(cityConfig){
        utilities.cloneIntoEmptyObject(cityConfig, getBasicDropDownConfig());
      }
      if(countryCode){
        settings.dropDown[crud.READ](apiEndPoints.dropDown.city, {'countryCode': countryCode, 'region': regionCode})
            .then(function(response){
              return utilities.cloneIntoEmptyObject(cityOptions, response.list);
            });
      }
    }

    function countryItem(item, escape) {
      var label = item.name;
      return '<div>' +
          '<img width="18" src="'+appConstants.STATIC_URL + item.image+'"/>'+
          '<span class="dropdownLabel">&nbsp;&nbsp;&nbsp;' + label + '</span>' +
          '</div>';
    }


    function prepareCountryDropDown(countryConfig, countryOption, onChangeCallBack, maxItems){
      var options = {};
      var config =  {
        onItemRemove: function(value){
          var removedItem = _.find(options.list, function(opt) { return opt.code == value; });
          countryOption.list.push(removedItem);
          var selectizeDropDown = this;
          selectizeDropDown.refreshItems();
        },
        valueField: 'code',
        sortField: 'name',
        searchField: ['name'],
        openOnFocus: true,
        closeOnSelect: true,
        create: false,
        persist: false,
        render: {
          item: countryItem,
          option: countryItem
        }
      };
      if(maxItems) config['maxItems'] = maxItems;
      if(onChangeCallBack){
        config['onChange'] = function (value, a, b, c){
          onChangeCallBack(value);
        };
      }
      utilities.cloneIntoEmptyObject(countryConfig, config);
      settings.dropDown[crud.READ](apiEndPoints.dropDown.country, read.DROP_DOWN)
          .then(function(response){
            utilities.cloneIntoEmptyObject(options, response.list);
            return utilities.cloneIntoEmptyObject(countryOption, response.list);
          });
    }

    function getCommissionTypeConfig(){
      return {
        options: [],
        create: true,
        sortField: 'text',
        valueField: 'text',
        labelField: 'text',
        maxItems:1
      };
    }

    function getPackingConfig(){
      return {
        options: [
          {text: 'Bulk'}, {text:'Bagged'}
        ],
        create: true,
        sortField: 'text',
        valueField: 'text',
        labelField: 'text',
        maxItems:1
      };
    }

    // multiple : boolean if you want a multi select
    function getBasicDropDownConfig(multiple, dropOptions, atrValue, atrLabel){
      var dropDown = {
        plugins: {
          'no-delete': {}
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['name'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: function(item, escape) {
            var name = item.name;
            return '<div>' +
                '<span class="dropdownLabel">' + name + '</span>' +
                '</div>';
          },
          option: function(item, escape) {
            var name = item.name;
            return '<div>' +
                '<span class="dropdownLabel">' + name + '</span>' +
                '</div>';
          }
        }
      };
      atrValue = (atrValue) ? atrValue : 'id';
      atrLabel = (atrLabel) ? atrLabel : 'name';

      if(multiple){
        delete dropDown['maxItems'];
        delete dropDown['plugins'];
        dropDown['onItemRemove'] = function(value, obj){
          var selectizeDropDown = this;
          var removedOption = {};
          removedOption[atrValue] = value;
          removedOption[atrLabel] = obj[0].innerText;
          if(dropOptions){
            dropOptions.list.push(removedOption);
          }
          selectizeDropDown.refreshItems();
        };

      }
      return dropDown;
    }





    function getBpLocationConfig(){
      var config = {
        plugins: {
          'no-delete': {}
        },
        valueField: 'id',
        sortField: 'name',
        searchField: ['address','city', 'state', 'country'],
        maxItems:1,
        create: false,
        persist: false,
        render: {
          item: function(item, escape) {
            var address = item.address;
            var city = item.city;
            var country = item.country;
            var state = item.state;
            return '<div>' +
                '<span class="dropdownLabel">' + address + '</span>' +
                '<span class="dropdownCaption">' + ' | '+ city + '</span>' +
                '<span class="dropdownCaption">' + ' | '+ country + '</span>' +
                '</div>';
          },
          option: function(item, escape) {
            var address = item.address;
            var city = item.city;
            var country = item.country;
            var state = item.state;
            return '<div class="item">' +
                '<span class="dropdownLabel">' + address + '</span>' +
                '<span class="dropdownCaption">' + ' | '+ city + '</span>' +
                '<span class="dropdownCaption">' + ' | '+ country + '</span>' +
                '</div>';
          }
        }
      };
      return config;
    }

    function prepareBusinessLocationsDropDown(locationConfig, locationOptions){
      utilities.cloneIntoEmptyObject(locationConfig, getBpLocationConfig());
      businessPartner.getBusinessPartnerLocation('drop_down')
          .then(function(response){
            utilities.cloneIntoEmptyObject(locationOptions,response.locations)
          });
    }

    function prepareProductCategoryDropDown(catConfig, catOptions){
      utilities.cloneIntoEmptyObject(catConfig, getBasicDropDownConfig());
      return settings.dropDown[crud.READ](apiEndPoints.dropDown.productCategory).then(function (response) {
        return utilities.cloneIntoEmptyObject(catOptions, response.list);
      });
    }


    function preparePriceMetricConfig(priceMetricConfig, priceMetricOptions){
      utilities.cloneIntoEmptyObject(priceMetricConfig, getBasicDropDownConfig(false, priceMetricOptions));
      settings.dropDown[crud.READ](apiEndPoints.dropDown.priceMetric, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(priceMetricOptions, response.list);
          });
    }


    function prepareDesignationDropDown(designationConfig, designationOptions){
      utilities.cloneIntoEmptyObject(designationConfig, getBasicDropDownConfig());
      settings.dropDown[crud.READ](apiEndPoints.dropDown.designation, read.DROP_DOWN)
          .then(function(response){
            return utilities.cloneIntoEmptyObject(designationOptions, response.list);
          });
    }

    function contactTypeConfig(){
      return {
        plugins: {
          'no-delete': {}
        },
        valueField: 'text',
        labelField: 'text',
        options: [
          {
            "id":1,
            "text":"Fax Numbers"
          },
          {
            "id":2,
            "text": "Mobile"
          },
          {
            "id":3,
            "text": "Office"
          },
          {
            "id":4,
            "text": "Residential"
          }
        ],
        sortField: 'text',
        maxItems: 1
      };
    }
  }

}());

/**
 * @ngdoc service
 * @name app.common.filter
 * @description < description placeholder >
 */

(function(){

    'use strict';

    Date.prototype.addDays = function(days) {
        var dat = new Date(this.valueOf());
        dat.setDate(dat.getDate() + days);
        return dat;
    };

    Date.prototype.removeTime = function(){
            return moment(this).format('LL');
    };

    Date.prototype.addTimeZoneOffset = function() {
        var offset = this.getTimezoneOffset();
        var hour = offset/60;
        this.setHours(this.getHours()+hour);
        return this;
    };

    String.prototype.capitalizeFirstLetter = function() {
        return this.charAt(0).toUpperCase() + this.slice(1);
    }

}());


/**
 * @ngdoc object
 * @name app.core.constant:httpStatus
 * @description Commonly consumed HTTP Request Codes exposed as an injectable object
 * @example
 <pre>
 angular.module("someModule", [])
 .controller("some", controller);

 function controller(httpStatus, someService){
  var vm = this;
  someService.get().then(function(res){
    if(res.status === httpStatus.OK){
      vm.users = res.data;
    }
   })
  };
 </pre>
 */

(function(){



  'use strict';


  var origin = window.location.origin;

  var images = {
    LOGO: 'data:image/png;base64,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'
  };

  var crud = {
    CREATE: 'CREATE',
    DELETE: 'DELETE',
    UPDATE: 'UPDATE',
    READ: 'READ'
  };

  var appConstants = {
    STATIC_URL: 'https://donigroup.com/static',
    HOST: 'http://donigroup.com'
  };

  // var appConstants = {
  //   STATIC_URL: 'http://localhost:8000/static/',
  //   HOST: 'http://localhost:8000'
  // };

  var httpStatus = {
    /**
     * @ngdoc property
     * @name httpStatus.#OK
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 200
     */
    OK: 200,

    /**
     * @ngdoc property
     * @name httpStatus.#CREATED
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 201
     */
    CREATED: 201,

    /**
     * @ngdoc property
     * @name httpStatus.#ACCEPTED
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 202
     */
    ACCEPTED: 202,

    /**
     * @ngdoc property
     * @name httpStatus.#NO_CONTENT
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 204
     */
    NO_CONTENT: 204,

    /**
     * @ngdoc property
     * @name httpStatus.#BAD_REQUEST
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 400
     */
    BAD_REQUEST: 400,

    /**
     * @ngdoc property
     * @name httpStatus.#UNAUTHORIZED
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 401
     */
    UNAUTHORIZED: 401,

    /**
     * @ngdoc property
     * @name httpStatus.#FORBIDDEN
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 403
     */
    FORBIDDEN: 403,

    /**
     * @ngdoc property
     * @name httpStatus.#NOT_FOUND
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 404
     */
    NOT_FOUND: 404,

    /**
     * @ngdoc property
     * @name httpStatus.#METHOD_NOT_ALLOWED
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 405
     */
    METHOD_NOT_ALLOWED: 405,

    /**
     * @ngdoc property
     * @name httpStatus.#INTERNAL_SERVER_ERROR
     * @propertyOf app.core.constant:httpStatus
     * @returns {number}
     * 500
     */
    INTERNAL_SERVER_ERROR: 500,

    /**
     * @ngdoc property
     * @name httpStatus.#BAD_GATEWAY
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 502
     */
    BAD_GATEWAY: 502,

    /**
     * @ngdoc property
     * @name httpStatus.#SERVICE_UNAVAILABLE
     * @propertyOf app.core.constant:httpStatus
     * @returns {number} 503
     */
    SERVICE_UNAVAILABLE: 503
  };

  var appFormats = {
    ShipmentMonth: 'MMMM, yyyy',
    Date: 'MMM dd, yyyy',
    FullDate2: 'MMMM dd, yyyy',
    FullDate: 'MMMM D, YYYY',
    DateAsFilter: 'date:"dd-MMM-yyyy"',
    Time: 'MMM dd, yyyy hh:mm a ',
    DBDate:'yyyy-MM-dd HH:mm:ss',

  };

  var appTabFilter = {
    PRODUCTS: 'Products',
    PRODUCT_ITEMS: 'Product_Items',
    PRICE_MARKET: 'Price_Market',
    BP: 'Business_Partner',
    BUYER: 'Buyer',
    SELLER: 'Seller',
    SHIPPER: 'Shipper',
    BROKER: 'Broker',
    LOCAL_TRADER:'Local Trader',
    LOCAL_BUYER: 'Local Buyer',
    LOCAL_SELLER: 'Local Seller',
    TRANSACTION_STATUS: 'Transaction_Status',
    COUNTRY: 'Country',
    ORIGIN: 'Origin',
    CONTRACT_TYPES: 'Contract_Types',
    COMMISSION_TYPES: 'Commission_Types',
    USERS: 'Users',
    BP_TYPES: 'business_type'
  };

  var appEvents = {
    TransactionBasicChanged:  'TransactionBasicChanged'
  };

  var read = {
    ALL: 'all',
    DROP_DOWN:'drop_down'
  };

  var shipmentStatus = {
    NOT_SHIPPED: 'NOT_SHIPPED',
    APPROBATION_RECEIVED: 'APPROBATION_RECEIVED',
    SHIPPED: 'SHIPPED',
    ARRIVED_AT_PORT: 'ARRIVED_AT_PORT'
  };

  angular
      .module('app.common')
      .constant('images', images)
      .constant('httpStatus', httpStatus)
      .constant('crud',crud)
      .constant('appFormats',appFormats)
      .constant('appEvents', appEvents)
      .constant('appTabFilter', appTabFilter)
      .constant('read', read)
      .constant('appConstants', appConstants)
      .constant('shipmentStatus', shipmentStatus);

}());

(function () {
    'use strict';
    angular
        .module('app.common')
        .service('printPage', printPage);

    /* @ngInject */
    function printPage($window) {
        function print() {
            $('#body-wrap').addClass('print-preview');
            $window.print();
        }

        (function () {
            var beforePrint = function () {
                //console.log('Functionality to run before printing.');
            };
            var afterPrint = function () {
                $('#body-wrap').removeClass('print-preview');
            };

            if (window.matchMedia) {
                var mediaQueryList = window.matchMedia('print');
                mediaQueryList.addListener(function (mql) {
                    if (mql.matches) {
                        beforePrint();
                    } else {
                        afterPrint();
                    }
                });
            }

            window.onbeforeprint = beforePrint;
            window.onafterprint = afterPrint;
        }());
        return {
            print: print
        };
    }

}());

/**
 * @ngdoc service
 * @name app.common.routing
 * @description < description placeholder >
 */

(function(){

  'use strict';

	angular
		.module('app.common')
		.factory('routing', routing);

  /* @ngInject */
  function routing(localStorageService,$state){

        var recentItems = [];
        getRecentItemsFromLocalStorage();
        return {
            recentItems: recentItems,
            getRecentlyViewedItems: getRecentlyViewedItems,
            addRecentlyViewItems: addRecentlyViewItems,
            saveRecentItemsToLocalStorage: saveRecentItemsToLocalStorage,
            getRecentItemsFromLocalStorage: getRecentItemsFromLocalStorage,
            clearRecentItems:clearRecentItems
		};

        function getRecentlyViewedItems(){
            return recentItems;
        }

        function clearRecentItems(){
            recentItems.splice(0,recentItems.length);
            saveRecentItemsToLocalStorage();
        }

        function saveRecentItemsToLocalStorage(){
            localStorageService.set('recentItems',  _.uniqBy(recentItems, 'pageTitle' ));
        }

        function getRecentItemsFromLocalStorage(){
            var temp = localStorageService.get('recentItems');
            clearRecentItems();
            if(temp){
                angular.forEach(temp,function(val){
                    recentItems.push(val);
                });
            }
        }

        function addRecentlyViewItems(pageTitle){
            recentItems.push({
               pageTitle:pageTitle,
               pageStateName:  $state.current.name,
               pageStateParams: $state.params,
               time: new Date()
            });
            saveRecentItemsToLocalStorage();
        }


	}

}());

/**
 * @ngdoc object
 * @name app.core.constant:httpStatus
 * @description Commonly consumed HTTP Request Codes exposed as an injectable object
 * @example
 <pre>
 angular.module("someModule", [])
 .controller("some", controller);

 function controller(httpStatus, someService){
  var vm = this;
  someService.get().then(function(res){
    if(res.status === httpStatus.OK){
      vm.users = res.data;
    }
   })
  };
 </pre>
 */

(function(){

    'use strict';

    var apiEndPoints = {
        authentication: {
            basic:'auth',
            googleAnalytics: 'google_analytics',
        },
        login: 'login',
        logout: 'logout',
        user:'user',
        changePassword: 'changePassword',
        userReadOnlyStatus: 'userReadOnlyStatus',
        userActiveStatus: 'userActiveStatus',
        bp:{
            main:'business',
            list: 'list',
            basic:'basic',
            bank:'bank',
            location:'location',
            contactPerson:'contact_person',
            contactNumber:'contact_number',
            product:'product',
            self: 'self',
            report: 'report'
        },
        dashboard: {
            main:'dashboard',
            searchPageTop: 'search_top'
        },
        manifest: 'manifest',
        manifestDashboard: 'manifest/dashboard',
        transaction:{
            main:'transactions',
            dashboard: 'dashboard',
            businessAnalytics: 'businessAnalytics',
            list: 'list',
            basic: 'basic',
            commission: 'commission',
            contract: 'contract',
            document: 'document',
            note: 'note',
            secondary: 'secondary',
            shipmentStatus: 'shipmentStatus',
            completeStatus: 'completeStatus',
            washout: 'washout',
            cashFlow: 'cash_flow',
            arrivedAtPortInfo: 'arrived_at_port_info',
            notShippedInfo: 'not_shipped_info',
            shippedInfo: 'shipped_info',
            approbationReceivedInfo: 'approbation_received_info',
            dispute: 'dispute',
            analytics: 'businessAnalytics'

        },
        shipping:{
            main: 'shipping',
            ports: 'ports',
            shippingLine: 'line',
            shippingVessel: 'vessel',
            shippingVesselTag: 'vessel_tag',
            portTag: 'port_tag'
        },
        tabFilters: 'tabFilters',
        pricing: 'pricing',
        pricingSummary: 'summary',
        pricingMarket: 'price_market',
        productItem: 'product_item',
        productItemPriceOnWebsite: 'price_on_website',
        productPriceReport: 'price_report',
        dropDown:{
            main: 'dropDown',
            bpType: 'business_type',
            productItem: 'product_item',
            businessType: 'business_type',
            contactType: 'contact_type',
            contractType: 'contract_type',
            designation: 'designation',
            productKeywords: 'product_keywords',
            transactionStatus: 'transaction_status',
            productCategory: 'product_category',
            country: 'country',
            region: 'region',
            city: 'city',
            commissionType: 'commission_type',
            packaging: 'packaging',
            product: 'product_drop_down',
            productOrigin: 'product_origin',
            currency: 'currency',
            priceMarket: 'price_market',
            shipmentMonth: 'shipment_month',
            priceMetric: 'price_metric',
            business: 'business',
            shippingLine: 'shipping_line',
            ports: 'ports',
            vessel: 'vessel',
            warehouses: 'warehouses',
            transaction: 'transaction',
            localTrade: 'localTransaction'
        },
        product: 'product',
        productTags:'product_tags',
        productWebsiteStatus: 'website_status',
        productOrigin: 'origin',
        productKeywords: 'keywords',
        productCategory: 'category',
        productCategorySpecification:'category/specification',
        website:{
            basic: 'website',
            research: 'research',
            researchTags: 'research_tags',
            homeSlider: 'homeSlider',
            team: 'team',
            dashboard:'dashboard'
        },
        currencyExchange: {
            main:'currency_exchange',
            dashboard:'dashboard'
        },
        accounts: {
            main: 'accounts',
            dashboard: 'dashboard',
            commissionFlow: 'commission_flow',
            invoice: 'invoice'
        },
        notification:{
            main: 'notifications',
            unreadCount: 'api/unread_count',
            unreadList: 'api/unread_list'
        },
        inventory:{
            main: 'inventory',
            warehouse: 'warehouse',
            warehouseRent: 'warehouse_rent',
            dashboard: 'dashboard',
            transaction: 'transaction',
            warehouseProductReport: 'warehouse_product_report',
            warehouseBusinessReport: 'warehouse_business_report'
        },
        localTrade:{
            main:'local_trade',
            trade: 'trade',
            tradeStatus: 'trade/status',
            tradeList:'trade/list',
            dashboard: 'dashboard',
            deliverySlip: 'delivery_slip'
        }

    };

    angular
        .module('app.core')
        .constant('apiEndPoints', apiEndPoints)

}());



/**
 * @ngdoc overview
 * @name app.core
 * @description Filters for the Applications
 */

(function () {

    'use strict';

    angular.module('app.core')
        .filter('selectFilter', selectFilter)
        .filter('selectFilterDropDown', selectFilterDropDown)
        .filter('selectedRows', selectedRows)
        .filter('uniqueByAttribute', uniqueByAttribute)
        .filter('range', range)
        .filter('secondsToDateTime', secondsToDateTime)
        .filter('utcToLocal', utcToLocal)
        .filter('latLong', function(){
            return function(input){
                input = input.split(' ');
                var value = parseFloat(input[0]);
                var multiplier = 1;
                if (input[1] == 'S' || input[1] =='W'){
                    multiplier = -1;
                }
                return value*multiplier
            }
        })
        .filter('plusOrMinus', function(){
            return function(input){
                input = input ? input : 0;
                return input > 0 ? input : '-'+input
            }
        })
        .filter('usd', function(){
            return function(input){
                return 'US$ ' + input.toString();
            }
        })

        .filter('digitInString', function(){
            return function(input, key, reverse){
                var sorted =  _.sortBy(input, function(row){
                    var index = row[key].search('[a-zA-Z]');
                    var fileNo = (index == -1) ? row[key] : row[key].slice(0, index);
                    console.log(row[key],fileNo,index);
                    return parseInt(fileNo);
                });



                return (reverse) ? _.reverse(sorted) : sorted;

            }
        })

        .filter('weight', function() {
            return function(weight, precision) {
                if(weight===0){
                    return '0.0 <span class="titled">Kgs</span>'
                }
                if (isNaN(parseFloat(weight)) || !isFinite(weight)) return '-';
                if (typeof precision === 'undefined') precision = 1;
                var units = ['Kgs', 'MT', 'KMT'],
                    number = Math.floor(Math.log(weight) / Math.log(1000));

                number = (number < units.length) ? number : (units.length-1);
                return (weight / Math.pow(1000, Math.floor(number))).toFixed(precision) +  ' <span class="titled">' + units[number] + '</span>';
            }
        })
        .filter('percentage', ['$filter', function ($filter) {
            return function (input, decimals) {
                var number = (input > 1) ? input : input*100;
                return $filter('number')(number, decimals) + '%';
            };
        }])

        .filter('positive', function() {
            return function(input) {
                if (!input) {
                    return 0;
                }

                return Math.abs(input);
            };
        });



    function utcToLocal($filter) {
        return function (utcDateString, format) {
            console.log('hello', utcDateString);
            if (!utcDateString) {
                return;
            }

            // append 'Z' to the date string to indicate UTC time if the timezone isn't already specified
            if (utcDateString.indexOf('Z') === -1 && utcDateString.indexOf('+') === -1) {
                utcDateString += 'Z';
            }

            return $filter('date')(utcDateString, format);
        };
    }

    function secondsToDateTime() {
        return function(seconds) {
            return new Date(1970, 0, 1).setSeconds(seconds);
        };
    }

    function selectFilter(){

        return function(items, search, bind) {
            console.log(search, items, bind);
            if (!search) {
                return items;
            }
            return items.filter(function(element, index, array) {
                if(element[bind]){
                    return element[bind].toLowerCase().indexOf(search.toLowerCase())===0;
                }
            });

        };
    }

    function selectFilterDropDown(){
        return function(items, search, bind) {
            if (!search) {
                return items;
            }
            return items.filter(function(element, index, array) {
                if(element[bind]){
                    return element[bind].toLowerCase().indexOf(search.toLowerCase())===0;
                }
            });

        };
    }

    function uniqueByAttribute(){
        return function(items,attribute){
            return _.uniqBy(items, attribute );
        }
    }

    function selectedRows(){
        return function(rows,rowsToRemove,bind){
            if(!rowsToRemove || rowsToRemove.length === 0){
                return rows;
            }
            return rows.filter(function(element,index,array){
                if(element[bind]){
                    //return true;
                    return ((rowsToRemove.indexOf(element[bind])) <= -1)
                }
            });
        }
    }

    function range(){
        return function(input, total) {
            total = parseInt(total);
            for (var i=0; i<total; i++)
                input.push(i);
            return input;
        };
    }

}());

(function () {

    'use strict';

    angular.module('app.core')
        .config(corsHandler)
        .run(restInterceptors);


    function corsHandler($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
        $httpProvider.defaults.xsrfCookieName = 'csrftoken';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRFToken';
        $httpProvider.interceptors.push(function($cookies) {
            return {
                'request': function(config) {
                    config.headers['X-CSRFToken'] = $cookies.get('csrftoken');
                    return config;
                }
            };
        });
    }

    function restInterceptors(Restangular, httpStatus, $state, loaderModal, localStorageService, toastr) {

        Restangular.setErrorInterceptor(errorInterceptor);
        Restangular.addResponseInterceptor(responseInterceptor);
        Restangular.addFullRequestInterceptor(requestInterceptor);

        function requestInterceptor(element, operation, route, url, headers, params, httpConfig){
            var today = new Date();
            var timezoneHourDifference = (today.getTimezoneOffset()/60);
            var extendedHeader = {
                'Hour-Difference': timezoneHourDifference
            };
            return angular.extend(headers, extendedHeader);
        }


        function responseInterceptor(response,deffered,responseHandler){
            return response;
        }

        function errorInterceptor(response, deferred, responseHandler){
            if(response.status === httpStatus.FORBIDDEN) {
                var lastState = {
                    stateOnLogin: $state.current.name,
                    stateParamsOnLogin: $state.params
                };
                localStorageService.set('lastState',lastState);
                $state.go('login');
                loaderModal.close();
                return false;
            }
            if(response.status === httpStatus.UNAUTHORIZED) {
                console.log(response);
                toastr.error(response.data.error, response.data.title);
                loaderModal.close();
            }
            if(response.status === httpStatus.INTERNAL_SERVER_ERROR){
                if (response.config.url === '/api/login/') {
                    $state.go('login');
                    loaderModal.close();
                }
            }
        }

    }


}());

(function () {

    'use strict';

    angular.module('app.core')
        .config(['$qProvider', '$injector', function($qProvider, $injector){
            //$injector.invoke(['$qProvider', function($qProvider) {
              //  $qProvider.errorOnUnhandledRejections(false);
            //}]);
        }])
        .run(onApplicationRun);


    function onApplicationRun(){
        Selectize.define('no-delete', function(options) {
            this.deleteSelection = function() {};
        });
    }

}());

    /**
 * @ngdoc service
 * @name app.common.filter
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.core')
        .factory('tabFilter', filter);

    /* @ngInject */
    function filter(Restangular, apiEndPoints, settings, crud){

        var tabFilterAPI = Restangular.all(apiEndPoints.dropDown.main);
        return {
            getTabFilters: getTabFilters
        };

        ////////////////////

        /**
         * @ngdoc
         * @name app.common.filter#testFunction
         * @methodOf app.common.filter
         *
         * @description < description placeholder >
         * @example
         * <pre>
         * filter.testFunction(id);
         * </pre>
         * @param {int} entity id
         */

        function getTabFilters(endPoint, params){
            return settings.dropDown[crud.READ](endPoint, params, true);
        }

    }

}());

/*
 html2canvas 0.5.0-beta3 <http://html2canvas.hertzen.com>
 Copyright (c) 2016 Niklas von Hertzen

 Released under  License
 */

!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.html2canvas=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
    (function (global){
        /*! http://mths.be/punycode v1.2.4 by @mathias */
        ;(function(root) {

            /** Detect free variables */
            var freeExports = typeof exports == 'object' && exports;
            var freeModule = typeof module == 'object' && module &&
                module.exports == freeExports && module;
            var freeGlobal = typeof global == 'object' && global;
            if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
                root = freeGlobal;
            }

            /**
             * The `punycode` object.
             * @name punycode
             * @type Object
             */
            var punycode,

                /** Highest positive signed 32-bit float value */
                maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

                /** Bootstring parameters */
                base = 36,
                tMin = 1,
                tMax = 26,
                skew = 38,
                damp = 700,
                initialBias = 72,
                initialN = 128, // 0x80
                delimiter = '-', // '\x2D'

                /** Regular expressions */
                regexPunycode = /^xn--/,
                regexNonASCII = /[^ -~]/, // unprintable ASCII chars + non-ASCII chars
                regexSeparators = /\x2E|\u3002|\uFF0E|\uFF61/g, // RFC 3490 separators

                /** Error messages */
                errors = {
                    'overflow': 'Overflow: input needs wider integers to process',
                    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
                    'invalid-input': 'Invalid input'
                },

                /** Convenience shortcuts */
                baseMinusTMin = base - tMin,
                floor = Math.floor,
                stringFromCharCode = String.fromCharCode,

                /** Temporary variable */
                key;

            /*--------------------------------------------------------------------------*/

            /**
             * A generic error utility function.
             * @private
             * @param {String} type The error type.
             * @returns {Error} Throws a `RangeError` with the applicable error message.
             */
            function error(type) {
                throw RangeError(errors[type]);
            }

            /**
             * A generic `Array#map` utility function.
             * @private
             * @param {Array} array The array to iterate over.
             * @param {Function} callback The function that gets called for every array
             * item.
             * @returns {Array} A new array of values returned by the callback function.
             */
            function map(array, fn) {
                var length = array.length;
                while (length--) {
                    array[length] = fn(array[length]);
                }
                return array;
            }

            /**
             * A simple `Array#map`-like wrapper to work with domain name strings.
             * @private
             * @param {String} domain The domain name.
             * @param {Function} callback The function that gets called for every
             * character.
             * @returns {Array} A new string of characters returned by the callback
             * function.
             */
            function mapDomain(string, fn) {
                return map(string.split(regexSeparators), fn).join('.');
            }

            /**
             * Creates an array containing the numeric code points of each Unicode
             * character in the string. While JavaScript uses UCS-2 internally,
             * this function will convert a pair of surrogate halves (each of which
             * UCS-2 exposes as separate characters) into a single code point,
             * matching UTF-16.
             * @see `punycode.ucs2.encode`
             * @see <http://mathiasbynens.be/notes/javascript-encoding>
             * @memberOf punycode.ucs2
             * @name decode
             * @param {String} string The Unicode input string (UCS-2).
             * @returns {Array} The new array of code points.
             */
            function ucs2decode(string) {
                var output = [],
                    counter = 0,
                    length = string.length,
                    value,
                    extra;
                while (counter < length) {
                    value = string.charCodeAt(counter++);
                    if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                        // high surrogate, and there is a next character
                        extra = string.charCodeAt(counter++);
                        if ((extra & 0xFC00) == 0xDC00) { // low surrogate
                            output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                        } else {
                            // unmatched surrogate; only append this code unit, in case the next
                            // code unit is the high surrogate of a surrogate pair
                            output.push(value);
                            counter--;
                        }
                    } else {
                        output.push(value);
                    }
                }
                return output;
            }

            /**
             * Creates a string based on an array of numeric code points.
             * @see `punycode.ucs2.decode`
             * @memberOf punycode.ucs2
             * @name encode
             * @param {Array} codePoints The array of numeric code points.
             * @returns {String} The new Unicode string (UCS-2).
             */
            function ucs2encode(array) {
                return map(array, function(value) {
                    var output = '';
                    if (value > 0xFFFF) {
                        value -= 0x10000;
                        output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                        value = 0xDC00 | value & 0x3FF;
                    }
                    output += stringFromCharCode(value);
                    return output;
                }).join('');
            }

            /**
             * Converts a basic code point into a digit/integer.
             * @see `digitToBasic()`
             * @private
             * @param {Number} codePoint The basic numeric code point value.
             * @returns {Number} The numeric value of a basic code point (for use in
             * representing integers) in the range `0` to `base - 1`, or `base` if
             * the code point does not represent a value.
             */
            function basicToDigit(codePoint) {
                if (codePoint - 48 < 10) {
                    return codePoint - 22;
                }
                if (codePoint - 65 < 26) {
                    return codePoint - 65;
                }
                if (codePoint - 97 < 26) {
                    return codePoint - 97;
                }
                return base;
            }

            /**
             * Converts a digit/integer into a basic code point.
             * @see `basicToDigit()`
             * @private
             * @param {Number} digit The numeric value of a basic code point.
             * @returns {Number} The basic code point whose value (when used for
             * representing integers) is `digit`, which needs to be in the range
             * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
             * used; else, the lowercase form is used. The behavior is undefined
             * if `flag` is non-zero and `digit` has no uppercase form.
             */
            function digitToBasic(digit, flag) {
                //  0..25 map to ASCII a..z or A..Z
                // 26..35 map to ASCII 0..9
                return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
            }

            /**
             * Bias adaptation function as per section 3.4 of RFC 3492.
             * http://tools.ietf.org/html/rfc3492#section-3.4
             * @private
             */
            function adapt(delta, numPoints, firstTime) {
                var k = 0;
                delta = firstTime ? floor(delta / damp) : delta >> 1;
                delta += floor(delta / numPoints);
                for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
                    delta = floor(delta / baseMinusTMin);
                }
                return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
            }

            /**
             * Converts a Punycode string of ASCII-only symbols to a string of Unicode
             * symbols.
             * @memberOf punycode
             * @param {String} input The Punycode string of ASCII-only symbols.
             * @returns {String} The resulting string of Unicode symbols.
             */
            function decode(input) {
                // Don't use UCS-2
                var output = [],
                    inputLength = input.length,
                    out,
                    i = 0,
                    n = initialN,
                    bias = initialBias,
                    basic,
                    j,
                    index,
                    oldi,
                    w,
                    k,
                    digit,
                    t,
                    /** Cached calculation results */
                    baseMinusT;

                // Handle the basic code points: let `basic` be the number of input code
                // points before the last delimiter, or `0` if there is none, then copy
                // the first basic code points to the output.

                basic = input.lastIndexOf(delimiter);
                if (basic < 0) {
                    basic = 0;
                }

                for (j = 0; j < basic; ++j) {
                    // if it's not a basic code point
                    if (input.charCodeAt(j) >= 0x80) {
                        error('not-basic');
                    }
                    output.push(input.charCodeAt(j));
                }

                // Main decoding loop: start just after the last delimiter if any basic code
                // points were copied; start at the beginning otherwise.

                for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

                    // `index` is the index of the next character to be consumed.
                    // Decode a generalized variable-length integer into `delta`,
                    // which gets added to `i`. The overflow checking is easier
                    // if we increase `i` as we go, then subtract off its starting
                    // value at the end to obtain `delta`.
                    for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

                        if (index >= inputLength) {
                            error('invalid-input');
                        }

                        digit = basicToDigit(input.charCodeAt(index++));

                        if (digit >= base || digit > floor((maxInt - i) / w)) {
                            error('overflow');
                        }

                        i += digit * w;
                        t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

                        if (digit < t) {
                            break;
                        }

                        baseMinusT = base - t;
                        if (w > floor(maxInt / baseMinusT)) {
                            error('overflow');
                        }

                        w *= baseMinusT;

                    }

                    out = output.length + 1;
                    bias = adapt(i - oldi, out, oldi == 0);

                    // `i` was supposed to wrap around from `out` to `0`,
                    // incrementing `n` each time, so we'll fix that now:
                    if (floor(i / out) > maxInt - n) {
                        error('overflow');
                    }

                    n += floor(i / out);
                    i %= out;

                    // Insert `n` at position `i` of the output
                    output.splice(i++, 0, n);

                }

                return ucs2encode(output);
            }

            /**
             * Converts a string of Unicode symbols to a Punycode string of ASCII-only
             * symbols.
             * @memberOf punycode
             * @param {String} input The string of Unicode symbols.
             * @returns {String} The resulting Punycode string of ASCII-only symbols.
             */
            function encode(input) {
                var n,
                    delta,
                    handledCPCount,
                    basicLength,
                    bias,
                    j,
                    m,
                    q,
                    k,
                    t,
                    currentValue,
                    output = [],
                    /** `inputLength` will hold the number of code points in `input`. */
                    inputLength,
                    /** Cached calculation results */
                    handledCPCountPlusOne,
                    baseMinusT,
                    qMinusT;

                // Convert the input in UCS-2 to Unicode
                input = ucs2decode(input);

                // Cache the length
                inputLength = input.length;

                // Initialize the state
                n = initialN;
                delta = 0;
                bias = initialBias;

                // Handle the basic code points
                for (j = 0; j < inputLength; ++j) {
                    currentValue = input[j];
                    if (currentValue < 0x80) {
                        output.push(stringFromCharCode(currentValue));
                    }
                }

                handledCPCount = basicLength = output.length;

                // `handledCPCount` is the number of code points that have been handled;
                // `basicLength` is the number of basic code points.

                // Finish the basic string - if it is not empty - with a delimiter
                if (basicLength) {
                    output.push(delimiter);
                }

                // Main encoding loop:
                while (handledCPCount < inputLength) {

                    // All non-basic code points < n have been handled already. Find the next
                    // larger one:
                    for (m = maxInt, j = 0; j < inputLength; ++j) {
                        currentValue = input[j];
                        if (currentValue >= n && currentValue < m) {
                            m = currentValue;
                        }
                    }

                    // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
                    // but guard against overflow
                    handledCPCountPlusOne = handledCPCount + 1;
                    if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
                        error('overflow');
                    }

                    delta += (m - n) * handledCPCountPlusOne;
                    n = m;

                    for (j = 0; j < inputLength; ++j) {
                        currentValue = input[j];

                        if (currentValue < n && ++delta > maxInt) {
                            error('overflow');
                        }

                        if (currentValue == n) {
                            // Represent delta as a generalized variable-length integer
                            for (q = delta, k = base; /* no condition */; k += base) {
                                t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
                                if (q < t) {
                                    break;
                                }
                                qMinusT = q - t;
                                baseMinusT = base - t;
                                output.push(
                                    stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
                                );
                                q = floor(qMinusT / baseMinusT);
                            }

                            output.push(stringFromCharCode(digitToBasic(q, 0)));
                            bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                            delta = 0;
                            ++handledCPCount;
                        }
                    }

                    ++delta;
                    ++n;

                }
                return output.join('');
            }

            /**
             * Converts a Punycode string representing a domain name to Unicode. Only the
             * Punycoded parts of the domain name will be converted, i.e. it doesn't
             * matter if you call it on a string that has already been converted to
             * Unicode.
             * @memberOf punycode
             * @param {String} domain The Punycode domain name to convert to Unicode.
             * @returns {String} The Unicode representation of the given Punycode
             * string.
             */
            function toUnicode(domain) {
                return mapDomain(domain, function(string) {
                    return regexPunycode.test(string)
                        ? decode(string.slice(4).toLowerCase())
                        : string;
                });
            }

            /**
             * Converts a Unicode string representing a domain name to Punycode. Only the
             * non-ASCII parts of the domain name will be converted, i.e. it doesn't
             * matter if you call it with a domain that's already in ASCII.
             * @memberOf punycode
             * @param {String} domain The domain name to convert, as a Unicode string.
             * @returns {String} The Punycode representation of the given domain name.
             */
            function toASCII(domain) {
                return mapDomain(domain, function(string) {
                    return regexNonASCII.test(string)
                        ? 'xn--' + encode(string)
                        : string;
                });
            }

            /*--------------------------------------------------------------------------*/

            /** Define the public API */
            punycode = {
                /**
                 * A string representing the current Punycode.js version number.
                 * @memberOf punycode
                 * @type String
                 */
                'version': '1.2.4',
                /**
                 * An object of methods to convert from JavaScript's internal character
                 * representation (UCS-2) to Unicode code points, and back.
                 * @see <http://mathiasbynens.be/notes/javascript-encoding>
                 * @memberOf punycode
                 * @type Object
                 */
                'ucs2': {
                    'decode': ucs2decode,
                    'encode': ucs2encode
                },
                'decode': decode,
                'encode': encode,
                'toASCII': toASCII,
                'toUnicode': toUnicode
            };

            /** Expose `punycode` */
            // Some AMD build optimizers, like r.js, check for specific condition patterns
            // like the following:
            if (
                typeof define == 'function' &&
                typeof define.amd == 'object' &&
                define.amd
            ) {
                define('punycode', function() {
                    return punycode;
                });
            } else if (freeExports && !freeExports.nodeType) {
                if (freeModule) { // in Node.js or RingoJS v0.8.0+
                    freeModule.exports = punycode;
                } else { // in Narwhal or RingoJS v0.7.0-
                    for (key in punycode) {
                        punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
                    }
                }
            } else { // in Rhino or a web browser
                root.punycode = punycode;
            }

        }(this));

    }).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(_dereq_,module,exports){
    var log = _dereq_('./log');

    function restoreOwnerScroll(ownerDocument, x, y) {
        if (ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    }

    function cloneCanvasContents(canvas, clonedCanvas) {
        try {
            if (clonedCanvas) {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                clonedCanvas.getContext("2d").putImageData(canvas.getContext("2d").getImageData(0, 0, canvas.width, canvas.height), 0, 0);
            }
        } catch(e) {
            log("Unable to copy canvas content from", canvas, e);
        }
    }

    function cloneNode(node, javascriptEnabled) {
        var clone = node.nodeType === 3 ? document.createTextNode(node.nodeValue) : node.cloneNode(false);

        var child = node.firstChild;
        while(child) {
            if (javascriptEnabled === true || child.nodeType !== 1 || child.nodeName !== 'SCRIPT') {
                clone.appendChild(cloneNode(child, javascriptEnabled));
            }
            child = child.nextSibling;
        }

        if (node.nodeType === 1) {
            clone._scrollTop = node.scrollTop;
            clone._scrollLeft = node.scrollLeft;
            if (node.nodeName === "CANVAS") {
                cloneCanvasContents(node, clone);
            } else if (node.nodeName === "TEXTAREA" || node.nodeName === "SELECT") {
                clone.value = node.value;
            }
        }

        return clone;
    }

    function initNode(node) {
        if (node.nodeType === 1) {
            node.scrollTop = node._scrollTop;
            node.scrollLeft = node._scrollLeft;

            var child = node.firstChild;
            while(child) {
                initNode(child);
                child = child.nextSibling;
            }
        }
    }

    module.exports = function(ownerDocument, containerDocument, width, height, options, x ,y) {
        var documentElement = cloneNode(ownerDocument.documentElement, options.javascriptEnabled);
        var container = containerDocument.createElement("iframe");

        container.className = "html2canvas-container";
        container.style.visibility = "hidden";
        container.style.position = "fixed";
        container.style.left = "-10000px";
        container.style.top = "0px";
        container.style.border = "0";
        container.width = width;
        container.height = height;
        container.scrolling = "no"; // ios won't scroll without it
        containerDocument.body.appendChild(container);

        return new Promise(function(resolve) {
            var documentClone = container.contentWindow.document;

            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            container.contentWindow.onload = container.onload = function() {
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0) {
                        initNode(documentClone.documentElement);
                        clearInterval(interval);
                        if (options.type === "view") {
                            container.contentWindow.scrollTo(x, y);
                            if ((/(iPad|iPhone|iPod)/g).test(navigator.userAgent) && (container.contentWindow.scrollY !== y || container.contentWindow.scrollX !== x)) {
                                documentClone.documentElement.style.top = (-y) + "px";
                                documentClone.documentElement.style.left = (-x) + "px";
                                documentClone.documentElement.style.position = 'absolute';
                            }
                        }
                        resolve(container);
                    }
                }, 50);
            };

            documentClone.open();
            documentClone.write("<!DOCTYPE html><html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(ownerDocument, x, y);
            documentClone.replaceChild(documentClone.adoptNode(documentElement), documentClone.documentElement);
            documentClone.close();
        });
    };

},{"./log":13}],3:[function(_dereq_,module,exports){
// http://dev.w3.org/csswg/css-color/

    function Color(value) {
        this.r = 0;
        this.g = 0;
        this.b = 0;
        this.a = null;
        var result = this.fromArray(value) ||
            this.namedColor(value) ||
            this.rgb(value) ||
            this.rgba(value) ||
            this.hex6(value) ||
            this.hex3(value);
    }

    Color.prototype.darken = function(amount) {
        var a = 1 - amount;
        return  new Color([
            Math.round(this.r * a),
            Math.round(this.g * a),
            Math.round(this.b * a),
            this.a
        ]);
    };

    Color.prototype.isTransparent = function() {
        return this.a === 0;
    };

    Color.prototype.isBlack = function() {
        return this.r === 0 && this.g === 0 && this.b === 0;
    };

    Color.prototype.fromArray = function(array) {
        if (Array.isArray(array)) {
            this.r = Math.min(array[0], 255);
            this.g = Math.min(array[1], 255);
            this.b = Math.min(array[2], 255);
            if (array.length > 3) {
                this.a = array[3];
            }
        }

        return (Array.isArray(array));
    };

    var _hex3 = /^#([a-f0-9]{3})$/i;

    Color.prototype.hex3 = function(value) {
        var match = null;
        if ((match = value.match(_hex3)) !== null) {
            this.r = parseInt(match[1][0] + match[1][0], 16);
            this.g = parseInt(match[1][1] + match[1][1], 16);
            this.b = parseInt(match[1][2] + match[1][2], 16);
        }
        return match !== null;
    };

    var _hex6 = /^#([a-f0-9]{6})$/i;

    Color.prototype.hex6 = function(value) {
        var match = null;
        if ((match = value.match(_hex6)) !== null) {
            this.r = parseInt(match[1].substring(0, 2), 16);
            this.g = parseInt(match[1].substring(2, 4), 16);
            this.b = parseInt(match[1].substring(4, 6), 16);
        }
        return match !== null;
    };


    var _rgb = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;

    Color.prototype.rgb = function(value) {
        var match = null;
        if ((match = value.match(_rgb)) !== null) {
            this.r = Number(match[1]);
            this.g = Number(match[2]);
            this.b = Number(match[3]);
        }
        return match !== null;
    };

    var _rgba = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d?\.?\d+)\s*\)$/;

    Color.prototype.rgba = function(value) {
        var match = null;
        if ((match = value.match(_rgba)) !== null) {
            this.r = Number(match[1]);
            this.g = Number(match[2]);
            this.b = Number(match[3]);
            this.a = Number(match[4]);
        }
        return match !== null;
    };

    Color.prototype.toString = function() {
        return this.a !== null && this.a !== 1 ?
        "rgba(" + [this.r, this.g, this.b, this.a].join(",") + ")" :
        "rgb(" + [this.r, this.g, this.b].join(",") + ")";
    };

    Color.prototype.namedColor = function(value) {
        value = value.toLowerCase();
        var color = colors[value];
        if (color) {
            this.r = color[0];
            this.g = color[1];
            this.b = color[2];
        } else if (value === "transparent") {
            this.r = this.g = this.b = this.a = 0;
            return true;
        }

        return !!color;
    };

    Color.prototype.isColor = true;

// JSON.stringify([].slice.call($$('.named-color-table tr'), 1).map(function(row) { return [row.childNodes[3].textContent, row.childNodes[5].textContent.trim().split(",").map(Number)] }).reduce(function(data, row) {data[row[0]] = row[1]; return data}, {}))
    var colors = {
        "aliceblue": [240, 248, 255],
        "antiquewhite": [250, 235, 215],
        "aqua": [0, 255, 255],
        "aquamarine": [127, 255, 212],
        "azure": [240, 255, 255],
        "beige": [245, 245, 220],
        "bisque": [255, 228, 196],
        "black": [0, 0, 0],
        "blanchedalmond": [255, 235, 205],
        "blue": [0, 0, 255],
        "blueviolet": [138, 43, 226],
        "brown": [165, 42, 42],
        "burlywood": [222, 184, 135],
        "cadetblue": [95, 158, 160],
        "chartreuse": [127, 255, 0],
        "chocolate": [210, 105, 30],
        "coral": [255, 127, 80],
        "cornflowerblue": [100, 149, 237],
        "cornsilk": [255, 248, 220],
        "crimson": [220, 20, 60],
        "cyan": [0, 255, 255],
        "darkblue": [0, 0, 139],
        "darkcyan": [0, 139, 139],
        "darkgoldenrod": [184, 134, 11],
        "darkgray": [169, 169, 169],
        "darkgreen": [0, 100, 0],
        "darkgrey": [169, 169, 169],
        "darkkhaki": [189, 183, 107],
        "darkmagenta": [139, 0, 139],
        "darkolivegreen": [85, 107, 47],
        "darkorange": [255, 140, 0],
        "darkorchid": [153, 50, 204],
        "darkred": [139, 0, 0],
        "darksalmon": [233, 150, 122],
        "darkseagreen": [143, 188, 143],
        "darkslateblue": [72, 61, 139],
        "darkslategray": [47, 79, 79],
        "darkslategrey": [47, 79, 79],
        "darkturquoise": [0, 206, 209],
        "darkviolet": [148, 0, 211],
        "deeppink": [255, 20, 147],
        "deepskyblue": [0, 191, 255],
        "dimgray": [105, 105, 105],
        "dimgrey": [105, 105, 105],
        "dodgerblue": [30, 144, 255],
        "firebrick": [178, 34, 34],
        "floralwhite": [255, 250, 240],
        "forestgreen": [34, 139, 34],
        "fuchsia": [255, 0, 255],
        "gainsboro": [220, 220, 220],
        "ghostwhite": [248, 248, 255],
        "gold": [255, 215, 0],
        "goldenrod": [218, 165, 32],
        "gray": [128, 128, 128],
        "green": [0, 128, 0],
        "greenyellow": [173, 255, 47],
        "grey": [128, 128, 128],
        "honeydew": [240, 255, 240],
        "hotpink": [255, 105, 180],
        "indianred": [205, 92, 92],
        "indigo": [75, 0, 130],
        "ivory": [255, 255, 240],
        "khaki": [240, 230, 140],
        "lavender": [230, 230, 250],
        "lavenderblush": [255, 240, 245],
        "lawngreen": [124, 252, 0],
        "lemonchiffon": [255, 250, 205],
        "lightblue": [173, 216, 230],
        "lightcoral": [240, 128, 128],
        "lightcyan": [224, 255, 255],
        "lightgoldenrodyellow": [250, 250, 210],
        "lightgray": [211, 211, 211],
        "lightgreen": [144, 238, 144],
        "lightgrey": [211, 211, 211],
        "lightpink": [255, 182, 193],
        "lightsalmon": [255, 160, 122],
        "lightseagreen": [32, 178, 170],
        "lightskyblue": [135, 206, 250],
        "lightslategray": [119, 136, 153],
        "lightslategrey": [119, 136, 153],
        "lightsteelblue": [176, 196, 222],
        "lightyellow": [255, 255, 224],
        "lime": [0, 255, 0],
        "limegreen": [50, 205, 50],
        "linen": [250, 240, 230],
        "magenta": [255, 0, 255],
        "maroon": [128, 0, 0],
        "mediumaquamarine": [102, 205, 170],
        "mediumblue": [0, 0, 205],
        "mediumorchid": [186, 85, 211],
        "mediumpurple": [147, 112, 219],
        "mediumseagreen": [60, 179, 113],
        "mediumslateblue": [123, 104, 238],
        "mediumspringgreen": [0, 250, 154],
        "mediumturquoise": [72, 209, 204],
        "mediumvioletred": [199, 21, 133],
        "midnightblue": [25, 25, 112],
        "mintcream": [245, 255, 250],
        "mistyrose": [255, 228, 225],
        "moccasin": [255, 228, 181],
        "navajowhite": [255, 222, 173],
        "navy": [0, 0, 128],
        "oldlace": [253, 245, 230],
        "olive": [128, 128, 0],
        "olivedrab": [107, 142, 35],
        "orange": [255, 165, 0],
        "orangered": [255, 69, 0],
        "orchid": [218, 112, 214],
        "palegoldenrod": [238, 232, 170],
        "palegreen": [152, 251, 152],
        "paleturquoise": [175, 238, 238],
        "palevioletred": [219, 112, 147],
        "papayawhip": [255, 239, 213],
        "peachpuff": [255, 218, 185],
        "peru": [205, 133, 63],
        "pink": [255, 192, 203],
        "plum": [221, 160, 221],
        "powderblue": [176, 224, 230],
        "purple": [128, 0, 128],
        "rebeccapurple": [102, 51, 153],
        "red": [255, 0, 0],
        "rosybrown": [188, 143, 143],
        "royalblue": [65, 105, 225],
        "saddlebrown": [139, 69, 19],
        "salmon": [250, 128, 114],
        "sandybrown": [244, 164, 96],
        "seagreen": [46, 139, 87],
        "seashell": [255, 245, 238],
        "sienna": [160, 82, 45],
        "silver": [192, 192, 192],
        "skyblue": [135, 206, 235],
        "slateblue": [106, 90, 205],
        "slategray": [112, 128, 144],
        "slategrey": [112, 128, 144],
        "snow": [255, 250, 250],
        "springgreen": [0, 255, 127],
        "steelblue": [70, 130, 180],
        "tan": [210, 180, 140],
        "teal": [0, 128, 128],
        "thistle": [216, 191, 216],
        "tomato": [255, 99, 71],
        "turquoise": [64, 224, 208],
        "violet": [238, 130, 238],
        "wheat": [245, 222, 179],
        "white": [255, 255, 255],
        "whitesmoke": [245, 245, 245],
        "yellow": [255, 255, 0],
        "yellowgreen": [154, 205, 50]
    };

    module.exports = Color;

},{}],4:[function(_dereq_,module,exports){
    var Support = _dereq_('./support');
    var CanvasRenderer = _dereq_('./renderers/canvas');
    var ImageLoader = _dereq_('./imageloader');
    var NodeParser = _dereq_('./nodeparser');
    var NodeContainer = _dereq_('./nodecontainer');
    var log = _dereq_('./log');
    var utils = _dereq_('./utils');
    var createWindowClone = _dereq_('./clone');
    var loadUrlDocument = _dereq_('./proxy').loadUrlDocument;
    var getBounds = utils.getBounds;

    var html2canvasNodeAttribute = "data-html2canvas-node";
    var html2canvasCloneIndex = 0;

    function html2canvas(nodeList, options) {
        var index = html2canvasCloneIndex++;
        options = options || {};
        if (options.logging) {
            log.options.logging = true;
            log.options.start = Date.now();
        }

        options.async = typeof(options.async) === "undefined" ? true : options.async;
        options.allowTaint = typeof(options.allowTaint) === "undefined" ? false : options.allowTaint;
        options.removeContainer = typeof(options.removeContainer) === "undefined" ? true : options.removeContainer;
        options.javascriptEnabled = typeof(options.javascriptEnabled) === "undefined" ? false : options.javascriptEnabled;
        options.imageTimeout = typeof(options.imageTimeout) === "undefined" ? 10000 : options.imageTimeout;
        options.renderer = typeof(options.renderer) === "function" ? options.renderer : CanvasRenderer;
        options.strict = !!options.strict;

        if (typeof(nodeList) === "string") {
            if (typeof(options.proxy) !== "string") {
                return Promise.reject("Proxy must be used when rendering url");
            }
            var width = options.width != null ? options.width : window.innerWidth;
            var height = options.height != null ? options.height : window.innerHeight;
            return loadUrlDocument(absoluteUrl(nodeList), options.proxy, document, width, height, options).then(function(container) {
                return renderWindow(container.contentWindow.document.documentElement, container, options, width, height);
            });
        }

        var node = ((nodeList === undefined) ? [document.documentElement] : ((nodeList.length) ? nodeList : [nodeList]))[0];
        node.setAttribute(html2canvasNodeAttribute + index, index);
        return renderDocument(node.ownerDocument, options, node.ownerDocument.defaultView.innerWidth, node.ownerDocument.defaultView.innerHeight, index).then(function(canvas) {
            if (typeof(options.onrendered) === "function") {
                log("options.onrendered is deprecated, html2canvas returns a Promise containing the canvas");
                options.onrendered(canvas);
            }
            return canvas;
        });
    }

    html2canvas.CanvasRenderer = CanvasRenderer;
    html2canvas.NodeContainer = NodeContainer;
    html2canvas.log = log;
    html2canvas.utils = utils;

    var html2canvasExport = (typeof(document) === "undefined" || typeof(Object.create) !== "function" || typeof(document.createElement("canvas").getContext) !== "function") ? function() {
        return Promise.reject("No canvas support");
    } : html2canvas;

    module.exports = html2canvasExport;

    if (typeof(define) === 'function' && define.amd) {
        define('html2canvas', [], function() {
            return html2canvasExport;
        });
    }

    function renderDocument(document, options, windowWidth, windowHeight, html2canvasIndex) {
        return createWindowClone(document, document, windowWidth, windowHeight, options, document.defaultView.pageXOffset, document.defaultView.pageYOffset).then(function(container) {
            log("Document cloned");
            var attributeName = html2canvasNodeAttribute + html2canvasIndex;
            var selector = "[" + attributeName + "='" + html2canvasIndex + "']";
            document.querySelector(selector).removeAttribute(attributeName);
            var clonedWindow = container.contentWindow;
            var node = clonedWindow.document.querySelector(selector);
            var oncloneHandler = (typeof(options.onclone) === "function") ? Promise.resolve(options.onclone(clonedWindow.document)) : Promise.resolve(true);
            return oncloneHandler.then(function() {
                return renderWindow(node, container, options, windowWidth, windowHeight);
            });
        });
    }

    function renderWindow(node, container, options, windowWidth, windowHeight) {
        var clonedWindow = container.contentWindow;
        var support = new Support(clonedWindow.document);
        var imageLoader = new ImageLoader(options, support);
        var bounds = getBounds(node);
        var width = options.type === "view" ? windowWidth : documentWidth(clonedWindow.document);
        var height = options.type === "view" ? windowHeight : documentHeight(clonedWindow.document);
        var renderer = new options.renderer(width, height, imageLoader, options, document);
        var parser = new NodeParser(node, renderer, support, imageLoader, options);
        return parser.ready.then(function() {
            log("Finished rendering");
            var canvas;

            if (options.type === "view") {
                canvas = crop(renderer.canvas, {width: renderer.canvas.width, height: renderer.canvas.height, top: 0, left: 0, x: 0, y: 0});
            } else if (node === clonedWindow.document.body || node === clonedWindow.document.documentElement || options.canvas != null) {
                canvas = renderer.canvas;
            } else {
                canvas = crop(renderer.canvas, {width:  options.width != null ? options.width : bounds.width, height: options.height != null ? options.height : bounds.height, top: bounds.top, left: bounds.left, x: 0, y: 0});
            }

            cleanupContainer(container, options);
            return canvas;
        });
    }

    function cleanupContainer(container, options) {
        if (options.removeContainer) {
            container.parentNode.removeChild(container);
            log("Cleaned up container");
        }
    }

    function crop(canvas, bounds) {
        var croppedCanvas = document.createElement("canvas");
        var x1 = Math.min(canvas.width - 1, Math.max(0, bounds.left));
        var x2 = Math.min(canvas.width, Math.max(1, bounds.left + bounds.width));
        var y1 = Math.min(canvas.height - 1, Math.max(0, bounds.top));
        var y2 = Math.min(canvas.height, Math.max(1, bounds.top + bounds.height));
        croppedCanvas.width = bounds.width;
        croppedCanvas.height =  bounds.height;
        var width = x2-x1;
        var height = y2-y1;
        log("Cropping canvas at:", "left:", bounds.left, "top:", bounds.top, "width:", width, "height:", height);
        log("Resulting crop with width", bounds.width, "and height", bounds.height, "with x", x1, "and y", y1);
        croppedCanvas.getContext("2d").drawImage(canvas, x1, y1, width, height, bounds.x, bounds.y, width, height);
        return croppedCanvas;
    }

    function documentWidth (doc) {
        return Math.max(
            Math.max(doc.body.scrollWidth, doc.documentElement.scrollWidth),
            Math.max(doc.body.offsetWidth, doc.documentElement.offsetWidth),
            Math.max(doc.body.clientWidth, doc.documentElement.clientWidth)
        );
    }

    function documentHeight (doc) {
        return Math.max(
            Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight),
            Math.max(doc.body.offsetHeight, doc.documentElement.offsetHeight),
            Math.max(doc.body.clientHeight, doc.documentElement.clientHeight)
        );
    }

    function absoluteUrl(url) {
        var link = document.createElement("a");
        link.href = url;
        link.href = link.href;
        return link;
    }

},{"./clone":2,"./imageloader":11,"./log":13,"./nodecontainer":14,"./nodeparser":15,"./proxy":16,"./renderers/canvas":20,"./support":22,"./utils":26}],5:[function(_dereq_,module,exports){
    var log = _dereq_('./log');
    var smallImage = _dereq_('./utils').smallImage;

    function DummyImageContainer(src) {
        this.src = src;
        log("DummyImageContainer for", src);
        if (!this.promise || !this.image) {
            log("Initiating DummyImageContainer");
            DummyImageContainer.prototype.image = new Image();
            var image = this.image;
            DummyImageContainer.prototype.promise = new Promise(function(resolve, reject) {
                image.onload = resolve;
                image.onerror = reject;
                image.src = smallImage();
                if (image.complete === true) {
                    resolve(image);
                }
            });
        }
    }

    module.exports = DummyImageContainer;

},{"./log":13,"./utils":26}],6:[function(_dereq_,module,exports){
    var smallImage = _dereq_('./utils').smallImage;

    function Font(family, size) {
        var container = document.createElement('div'),
            img = document.createElement('img'),
            span = document.createElement('span'),
            sampleText = 'Hidden Text',
            baseline,
            middle;

        container.style.visibility = "hidden";
        container.style.fontFamily = family;
        container.style.fontSize = size;
        container.style.margin = 0;
        container.style.padding = 0;

        document.body.appendChild(container);

        img.src = smallImage();
        img.width = 1;
        img.height = 1;

        img.style.margin = 0;
        img.style.padding = 0;
        img.style.verticalAlign = "baseline";

        span.style.fontFamily = family;
        span.style.fontSize = size;
        span.style.margin = 0;
        span.style.padding = 0;

        span.appendChild(document.createTextNode(sampleText));
        container.appendChild(span);
        container.appendChild(img);
        baseline = (img.offsetTop - span.offsetTop) + 1;

        container.removeChild(span);
        container.appendChild(document.createTextNode(sampleText));

        container.style.lineHeight = "normal";
        img.style.verticalAlign = "super";

        middle = (img.offsetTop-container.offsetTop) + 1;

        document.body.removeChild(container);

        this.baseline = baseline;
        this.lineWidth = 1;
        this.middle = middle;
    }

    module.exports = Font;

},{"./utils":26}],7:[function(_dereq_,module,exports){
    var Font = _dereq_('./font');

    function FontMetrics() {
        this.data = {};
    }

    FontMetrics.prototype.getMetrics = function(family, size) {
        if (this.data[family + "-" + size] === undefined) {
            this.data[family + "-" + size] = new Font(family, size);
        }
        return this.data[family + "-" + size];
    };

    module.exports = FontMetrics;

},{"./font":6}],8:[function(_dereq_,module,exports){
    var utils = _dereq_('./utils');
    var getBounds = utils.getBounds;
    var loadUrlDocument = _dereq_('./proxy').loadUrlDocument;

    function FrameContainer(container, sameOrigin, options) {
        this.image = null;
        this.src = container;
        var self = this;
        var bounds = getBounds(container);
        this.promise = (!sameOrigin ? this.proxyLoad(options.proxy, bounds, options) : new Promise(function(resolve) {
            if (container.contentWindow.document.URL === "about:blank" || container.contentWindow.document.documentElement == null) {
                container.contentWindow.onload = container.onload = function() {
                    resolve(container);
                };
            } else {
                resolve(container);
            }
        })).then(function(container) {
            var html2canvas = _dereq_('./core');
            return html2canvas(container.contentWindow.document.documentElement, {type: 'view', width: container.width, height: container.height, proxy: options.proxy, javascriptEnabled: options.javascriptEnabled, removeContainer: options.removeContainer, allowTaint: options.allowTaint, imageTimeout: options.imageTimeout / 2});
        }).then(function(canvas) {
            return self.image = canvas;
        });
    }

    FrameContainer.prototype.proxyLoad = function(proxy, bounds, options) {
        var container = this.src;
        return loadUrlDocument(container.src, proxy, container.ownerDocument, bounds.width, bounds.height, options);
    };

    module.exports = FrameContainer;

},{"./core":4,"./proxy":16,"./utils":26}],9:[function(_dereq_,module,exports){
    function GradientContainer(imageData) {
        this.src = imageData.value;
        this.colorStops = [];
        this.type = null;
        this.x0 = 0.5;
        this.y0 = 0.5;
        this.x1 = 0.5;
        this.y1 = 0.5;
        this.promise = Promise.resolve(true);
    }

    GradientContainer.TYPES = {
        LINEAR: 1,
        RADIAL: 2
    };

// TODO: support hsl[a], negative %/length values
// TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
    GradientContainer.REGEXP_COLORSTOP = /^\s*(rgba?\(\s*\d{1,3},\s*\d{1,3},\s*\d{1,3}(?:,\s*[0-9\.]+)?\s*\)|[a-z]{3,20}|#[a-f0-9]{3,6})(?:\s+(\d{1,3}(?:\.\d+)?)(%|px)?)?(?:\s|$)/i;

    module.exports = GradientContainer;

},{}],10:[function(_dereq_,module,exports){
    function ImageContainer(src, cors) {
        this.src = src;
        this.image = new Image();
        var self = this;
        this.tainted = null;
        this.promise = new Promise(function(resolve, reject) {
            self.image.onload = resolve;
            self.image.onerror = reject;
            if (cors) {
                self.image.crossOrigin = "anonymous";
            }
            self.image.src = src;
            if (self.image.complete === true) {
                resolve(self.image);
            }
        });
    }

    module.exports = ImageContainer;

},{}],11:[function(_dereq_,module,exports){
    var log = _dereq_('./log');
    var ImageContainer = _dereq_('./imagecontainer');
    var DummyImageContainer = _dereq_('./dummyimagecontainer');
    var ProxyImageContainer = _dereq_('./proxyimagecontainer');
    var FrameContainer = _dereq_('./framecontainer');
    var SVGContainer = _dereq_('./svgcontainer');
    var SVGNodeContainer = _dereq_('./svgnodecontainer');
    var LinearGradientContainer = _dereq_('./lineargradientcontainer');
    var WebkitGradientContainer = _dereq_('./webkitgradientcontainer');
    var bind = _dereq_('./utils').bind;

    function ImageLoader(options, support) {
        this.link = null;
        this.options = options;
        this.support = support;
        this.origin = this.getOrigin(window.location.href);
    }

    ImageLoader.prototype.findImages = function(nodes) {
        var images = [];
        nodes.reduce(function(imageNodes, container) {
            switch(container.node.nodeName) {
                case "IMG":
                    return imageNodes.concat([{
                        args: [container.node.src],
                        method: "url"
                    }]);
                case "svg":
                case "IFRAME":
                    return imageNodes.concat([{
                        args: [container.node],
                        method: container.node.nodeName
                    }]);
            }
            return imageNodes;
        }, []).forEach(this.addImage(images, this.loadImage), this);
        return images;
    };

    ImageLoader.prototype.findBackgroundImage = function(images, container) {
        container.parseBackgroundImages().filter(this.hasImageBackground).forEach(this.addImage(images, this.loadImage), this);
        return images;
    };

    ImageLoader.prototype.addImage = function(images, callback) {
        return function(newImage) {
            newImage.args.forEach(function(image) {
                if (!this.imageExists(images, image)) {
                    images.splice(0, 0, callback.call(this, newImage));
                    log('Added image #' + (images.length), typeof(image) === "string" ? image.substring(0, 100) : image);
                }
            }, this);
        };
    };

    ImageLoader.prototype.hasImageBackground = function(imageData) {
        return imageData.method !== "none";
    };

    ImageLoader.prototype.loadImage = function(imageData) {
        if (imageData.method === "url") {
            var src = imageData.args[0];
            if (this.isSVG(src) && !this.support.svg && !this.options.allowTaint) {
                return new SVGContainer(src);
            } else if (src.match(/data:image\/.*;base64,/i)) {
                return new ImageContainer(src.replace(/url\(['"]{0,}|['"]{0,}\)$/ig, ''), false);
            } else if (this.isSameOrigin(src) || this.options.allowTaint === true || this.isSVG(src)) {
                return new ImageContainer(src, false);
            } else if (this.support.cors && !this.options.allowTaint && this.options.useCORS) {
                return new ImageContainer(src, true);
            } else if (this.options.proxy) {
                return new ProxyImageContainer(src, this.options.proxy);
            } else {
                return new DummyImageContainer(src);
            }
        } else if (imageData.method === "linear-gradient") {
            return new LinearGradientContainer(imageData);
        } else if (imageData.method === "gradient") {
            return new WebkitGradientContainer(imageData);
        } else if (imageData.method === "svg") {
            return new SVGNodeContainer(imageData.args[0], this.support.svg);
        } else if (imageData.method === "IFRAME") {
            return new FrameContainer(imageData.args[0], this.isSameOrigin(imageData.args[0].src), this.options);
        } else {
            return new DummyImageContainer(imageData);
        }
    };

    ImageLoader.prototype.isSVG = function(src) {
        return src.substring(src.length - 3).toLowerCase() === "svg" || SVGContainer.prototype.isInline(src);
    };

    ImageLoader.prototype.imageExists = function(images, src) {
        return images.some(function(image) {
            return image.src === src;
        });
    };

    ImageLoader.prototype.isSameOrigin = function(url) {
        return (this.getOrigin(url) === this.origin);
    };

    ImageLoader.prototype.getOrigin = function(url) {
        var link = this.link || (this.link = document.createElement("a"));
        link.href = url;
        link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
        return link.protocol + link.hostname + link.port;
    };

    ImageLoader.prototype.getPromise = function(container) {
        return this.timeout(container, this.options.imageTimeout)['catch'](function() {
            var dummy = new DummyImageContainer(container.src);
            return dummy.promise.then(function(image) {
                container.image = image;
            });
        });
    };

    ImageLoader.prototype.get = function(src) {
        var found = null;
        return this.images.some(function(img) {
            return (found = img).src === src;
        }) ? found : null;
    };

    ImageLoader.prototype.fetch = function(nodes) {
        this.images = nodes.reduce(bind(this.findBackgroundImage, this), this.findImages(nodes));
        this.images.forEach(function(image, index) {
            image.promise.then(function() {
                log("Succesfully loaded image #"+ (index+1), image);
            }, function(e) {
                log("Failed loading image #"+ (index+1), image, e);
            });
        });
        this.ready = Promise.all(this.images.map(this.getPromise, this));
        log("Finished searching images");
        return this;
    };

    ImageLoader.prototype.timeout = function(container, timeout) {
        var timer;
        var promise = Promise.race([container.promise, new Promise(function(res, reject) {
            timer = setTimeout(function() {
                log("Timed out loading image", container);
                reject(container);
            }, timeout);
        })]).then(function(container) {
            clearTimeout(timer);
            return container;
        });
        promise['catch'](function() {
            clearTimeout(timer);
        });
        return promise;
    };

    module.exports = ImageLoader;

},{"./dummyimagecontainer":5,"./framecontainer":8,"./imagecontainer":10,"./lineargradientcontainer":12,"./log":13,"./proxyimagecontainer":17,"./svgcontainer":23,"./svgnodecontainer":24,"./utils":26,"./webkitgradientcontainer":27}],12:[function(_dereq_,module,exports){
    var GradientContainer = _dereq_('./gradientcontainer');
    var Color = _dereq_('./color');

    function LinearGradientContainer(imageData) {
        GradientContainer.apply(this, arguments);
        this.type = GradientContainer.TYPES.LINEAR;

        var hasDirection = LinearGradientContainer.REGEXP_DIRECTION.test( imageData.args[0] ) ||
            !GradientContainer.REGEXP_COLORSTOP.test( imageData.args[0] );

        if (hasDirection) {
            imageData.args[0].split(/\s+/).reverse().forEach(function(position, index) {
                switch(position) {
                    case "left":
                        this.x0 = 0;
                        this.x1 = 1;
                        break;
                    case "top":
                        this.y0 = 0;
                        this.y1 = 1;
                        break;
                    case "right":
                        this.x0 = 1;
                        this.x1 = 0;
                        break;
                    case "bottom":
                        this.y0 = 1;
                        this.y1 = 0;
                        break;
                    case "to":
                        var y0 = this.y0;
                        var x0 = this.x0;
                        this.y0 = this.y1;
                        this.x0 = this.x1;
                        this.x1 = x0;
                        this.y1 = y0;
                        break;
                    case "center":
                        break; // centered by default
                    // Firefox internally converts position keywords to percentages:
                    // http://www.w3.org/TR/2010/WD-CSS2-20101207/colors.html#propdef-background-position
                    default: // percentage or absolute length
                        // TODO: support absolute start point positions (e.g., use bounds to convert px to a ratio)
                        var ratio = parseFloat(position, 10) * 1e-2;
                        if (isNaN(ratio)) { // invalid or unhandled value
                            break;
                        }
                        if (index === 0) {
                            this.y0 = ratio;
                            this.y1 = 1 - this.y0;
                        } else {
                            this.x0 = ratio;
                            this.x1 = 1 - this.x0;
                        }
                        break;
                }
            }, this);
        } else {
            this.y0 = 0;
            this.y1 = 1;
        }

        this.colorStops = imageData.args.slice(hasDirection ? 1 : 0).map(function(colorStop) {
            var colorStopMatch = colorStop.match(GradientContainer.REGEXP_COLORSTOP);
            var value = +colorStopMatch[2];
            var unit = value === 0 ? "%" : colorStopMatch[3]; // treat "0" as "0%"
            return {
                color: new Color(colorStopMatch[1]),
                // TODO: support absolute stop positions (e.g., compute gradient line length & convert px to ratio)
                stop: unit === "%" ? value / 100 : null
            };
        });

        if (this.colorStops[0].stop === null) {
            this.colorStops[0].stop = 0;
        }

        if (this.colorStops[this.colorStops.length - 1].stop === null) {
            this.colorStops[this.colorStops.length - 1].stop = 1;
        }

        // calculates and fills-in explicit stop positions when omitted from rule
        this.colorStops.forEach(function(colorStop, index) {
            if (colorStop.stop === null) {
                this.colorStops.slice(index).some(function(find, count) {
                    if (find.stop !== null) {
                        colorStop.stop = ((find.stop - this.colorStops[index - 1].stop) / (count + 1)) + this.colorStops[index - 1].stop;
                        return true;
                    } else {
                        return false;
                    }
                }, this);
            }
        }, this);
    }

    LinearGradientContainer.prototype = Object.create(GradientContainer.prototype);

// TODO: support <angle> (e.g. -?\d{1,3}(?:\.\d+)deg, etc. : https://developer.mozilla.org/docs/Web/CSS/angle )
    LinearGradientContainer.REGEXP_DIRECTION = /^\s*(?:to|left|right|top|bottom|center|\d{1,3}(?:\.\d+)?%?)(?:\s|$)/i;

    module.exports = LinearGradientContainer;

},{"./color":3,"./gradientcontainer":9}],13:[function(_dereq_,module,exports){
    var logger = function() {
        if (logger.options.logging && window.console && window.console.log) {
            Function.prototype.bind.call(window.console.log, (window.console)).apply(window.console, [(Date.now() - logger.options.start) + "ms", "html2canvas:"].concat([].slice.call(arguments, 0)));
        }
    };

    logger.options = {logging: false};
    module.exports = logger;

},{}],14:[function(_dereq_,module,exports){
    var Color = _dereq_('./color');
    var utils = _dereq_('./utils');
    var getBounds = utils.getBounds;
    var parseBackgrounds = utils.parseBackgrounds;
    var offsetBounds = utils.offsetBounds;

    function NodeContainer(node, parent) {
        this.node = node;
        this.parent = parent;
        this.stack = null;
        this.bounds = null;
        this.borders = null;
        this.clip = [];
        this.backgroundClip = [];
        this.offsetBounds = null;
        this.visible = null;
        this.computedStyles = null;
        this.colors = {};
        this.styles = {};
        this.backgroundImages = null;
        this.transformData = null;
        this.transformMatrix = null;
        this.isPseudoElement = false;
        this.opacity = null;
    }

    NodeContainer.prototype.cloneTo = function(stack) {
        stack.visible = this.visible;
        stack.borders = this.borders;
        stack.bounds = this.bounds;
        stack.clip = this.clip;
        stack.backgroundClip = this.backgroundClip;
        stack.computedStyles = this.computedStyles;
        stack.styles = this.styles;
        stack.backgroundImages = this.backgroundImages;
        stack.opacity = this.opacity;
    };

    NodeContainer.prototype.getOpacity = function() {
        return this.opacity === null ? (this.opacity = this.cssFloat('opacity')) : this.opacity;
    };

    NodeContainer.prototype.assignStack = function(stack) {
        this.stack = stack;
        stack.children.push(this);
    };

    NodeContainer.prototype.isElementVisible = function() {
        return this.node.nodeType === Node.TEXT_NODE ? this.parent.visible : (
            this.css('display') !== "none" &&
            this.css('visibility') !== "hidden" &&
            !this.node.hasAttribute("data-html2canvas-ignore") &&
            (this.node.nodeName !== "INPUT" || this.node.getAttribute("type") !== "hidden")
        );
    };

    NodeContainer.prototype.css = function(attribute) {
        if (!this.computedStyles) {
            this.computedStyles = this.isPseudoElement ? this.parent.computedStyle(this.before ? ":before" : ":after") : this.computedStyle(null);
        }

        return this.styles[attribute] || (this.styles[attribute] = this.computedStyles[attribute]);
    };

    NodeContainer.prototype.prefixedCss = function(attribute) {
        var prefixes = ["webkit", "moz", "ms", "o"];
        var value = this.css(attribute);
        if (value === undefined) {
            prefixes.some(function(prefix) {
                value = this.css(prefix + attribute.substr(0, 1).toUpperCase() + attribute.substr(1));
                return value !== undefined;
            }, this);
        }
        return value === undefined ? null : value;
    };

    NodeContainer.prototype.computedStyle = function(type) {
        return this.node.ownerDocument.defaultView.getComputedStyle(this.node, type);
    };

    NodeContainer.prototype.cssInt = function(attribute) {
        var value = parseInt(this.css(attribute), 10);
        return (isNaN(value)) ? 0 : value; // borders in old IE are throwing 'medium' for demo.html
    };

    NodeContainer.prototype.color = function(attribute) {
        return this.colors[attribute] || (this.colors[attribute] = new Color(this.css(attribute)));
    };

    NodeContainer.prototype.cssFloat = function(attribute) {
        var value = parseFloat(this.css(attribute));
        return (isNaN(value)) ? 0 : value;
    };

    NodeContainer.prototype.fontWeight = function() {
        var weight = this.css("fontWeight");
        switch(parseInt(weight, 10)){
            case 401:
                weight = "bold";
                break;
            case 400:
                weight = "normal";
                break;
        }
        return weight;
    };

    NodeContainer.prototype.parseClip = function() {
        var matches = this.css('clip').match(this.CLIP);
        if (matches) {
            return {
                top: parseInt(matches[1], 10),
                right: parseInt(matches[2], 10),
                bottom: parseInt(matches[3], 10),
                left: parseInt(matches[4], 10)
            };
        }
        return null;
    };

    NodeContainer.prototype.parseBackgroundImages = function() {
        return this.backgroundImages || (this.backgroundImages = parseBackgrounds(this.css("backgroundImage")));
    };

    NodeContainer.prototype.cssList = function(property, index) {
        var value = (this.css(property) || '').split(',');
        value = value[index || 0] || value[0] || 'auto';
        value = value.trim().split(' ');
        if (value.length === 1) {
            value = [value[0], isPercentage(value[0]) ? 'auto' : value[0]];
        }
        return value;
    };

    NodeContainer.prototype.parseBackgroundSize = function(bounds, image, index) {
        var size = this.cssList("backgroundSize", index);
        var width, height;

        if (isPercentage(size[0])) {
            width = bounds.width * parseFloat(size[0]) / 100;
        } else if (/contain|cover/.test(size[0])) {
            var targetRatio = bounds.width / bounds.height, currentRatio = image.width / image.height;
            return (targetRatio < currentRatio ^ size[0] === 'contain') ?  {width: bounds.height * currentRatio, height: bounds.height} : {width: bounds.width, height: bounds.width / currentRatio};
        } else {
            width = parseInt(size[0], 10);
        }

        if (size[0] === 'auto' && size[1] === 'auto') {
            height = image.height;
        } else if (size[1] === 'auto') {
            height = width / image.width * image.height;
        } else if (isPercentage(size[1])) {
            height =  bounds.height * parseFloat(size[1]) / 100;
        } else {
            height = parseInt(size[1], 10);
        }

        if (size[0] === 'auto') {
            width = height / image.height * image.width;
        }

        return {width: width, height: height};
    };

    NodeContainer.prototype.parseBackgroundPosition = function(bounds, image, index, backgroundSize) {
        var position = this.cssList('backgroundPosition', index);
        var left, top;

        if (isPercentage(position[0])){
            left = (bounds.width - (backgroundSize || image).width) * (parseFloat(position[0]) / 100);
        } else {
            left = parseInt(position[0], 10);
        }

        if (position[1] === 'auto') {
            top = left / image.width * image.height;
        } else if (isPercentage(position[1])){
            top =  (bounds.height - (backgroundSize || image).height) * parseFloat(position[1]) / 100;
        } else {
            top = parseInt(position[1], 10);
        }

        if (position[0] === 'auto') {
            left = top / image.height * image.width;
        }

        return {left: left, top: top};
    };

    NodeContainer.prototype.parseBackgroundRepeat = function(index) {
        return this.cssList("backgroundRepeat", index)[0];
    };

    NodeContainer.prototype.parseTextShadows = function() {
        var textShadow = this.css("textShadow");
        var results = [];

        if (textShadow && textShadow !== 'none') {
            var shadows = textShadow.match(this.TEXT_SHADOW_PROPERTY);
            for (var i = 0; shadows && (i < shadows.length); i++) {
                var s = shadows[i].match(this.TEXT_SHADOW_VALUES);
                results.push({
                    color: new Color(s[0]),
                    offsetX: s[1] ? parseFloat(s[1].replace('px', '')) : 0,
                    offsetY: s[2] ? parseFloat(s[2].replace('px', '')) : 0,
                    blur: s[3] ? s[3].replace('px', '') : 0
                });
            }
        }
        return results;
    };

    NodeContainer.prototype.parseTransform = function() {
        if (!this.transformData) {
            if (this.hasTransform()) {
                var offset = this.parseBounds();
                var origin = this.prefixedCss("transformOrigin").split(" ").map(removePx).map(asFloat);
                origin[0] += offset.left;
                origin[1] += offset.top;
                this.transformData = {
                    origin: origin,
                    matrix: this.parseTransformMatrix()
                };
            } else {
                this.transformData = {
                    origin: [0, 0],
                    matrix: [1, 0, 0, 1, 0, 0]
                };
            }
        }
        return this.transformData;
    };

    NodeContainer.prototype.parseTransformMatrix = function() {
        if (!this.transformMatrix) {
            var transform = this.prefixedCss("transform");
            var matrix = transform ? parseMatrix(transform.match(this.MATRIX_PROPERTY)) : null;
            this.transformMatrix = matrix ? matrix : [1, 0, 0, 1, 0, 0];
        }
        return this.transformMatrix;
    };

    NodeContainer.prototype.parseBounds = function() {
        return this.bounds || (this.bounds = this.hasTransform() ? offsetBounds(this.node) : getBounds(this.node));
    };

    NodeContainer.prototype.hasTransform = function() {
        return this.parseTransformMatrix().join(",") !== "1,0,0,1,0,0" || (this.parent && this.parent.hasTransform());
    };

    NodeContainer.prototype.getValue = function() {
        var value = this.node.value || "";
        if (this.node.tagName === "SELECT") {
            value = selectionValue(this.node);
        } else if (this.node.type === "password") {
            value = Array(value.length + 1).join('\u2022'); // jshint ignore:line
        }
        return value.length === 0 ? (this.node.placeholder || "") : value;
    };

    NodeContainer.prototype.MATRIX_PROPERTY = /(matrix|matrix3d)\((.+)\)/;
    NodeContainer.prototype.TEXT_SHADOW_PROPERTY = /((rgba|rgb)\([^\)]+\)(\s-?\d+px){0,})/g;
    NodeContainer.prototype.TEXT_SHADOW_VALUES = /(-?\d+px)|(#.+)|(rgb\(.+\))|(rgba\(.+\))/g;
    NodeContainer.prototype.CLIP = /^rect\((\d+)px,? (\d+)px,? (\d+)px,? (\d+)px\)$/;

    function selectionValue(node) {
        var option = node.options[node.selectedIndex || 0];
        return option ? (option.text || "") : "";
    }

    function parseMatrix(match) {
        if (match && match[1] === "matrix") {
            return match[2].split(",").map(function(s) {
                return parseFloat(s.trim());
            });
        } else if (match && match[1] === "matrix3d") {
            var matrix3d = match[2].split(",").map(function(s) {
                return parseFloat(s.trim());
            });
            return [matrix3d[0], matrix3d[1], matrix3d[4], matrix3d[5], matrix3d[12], matrix3d[13]];
        }
    }

    function isPercentage(value) {
        return value.toString().indexOf("%") !== -1;
    }

    function removePx(str) {
        return str.replace("px", "");
    }

    function asFloat(str) {
        return parseFloat(str);
    }

    module.exports = NodeContainer;

},{"./color":3,"./utils":26}],15:[function(_dereq_,module,exports){
    var log = _dereq_('./log');
    var punycode = _dereq_('punycode');
    var NodeContainer = _dereq_('./nodecontainer');
    var TextContainer = _dereq_('./textcontainer');
    var PseudoElementContainer = _dereq_('./pseudoelementcontainer');
    var FontMetrics = _dereq_('./fontmetrics');
    var Color = _dereq_('./color');
    var StackingContext = _dereq_('./stackingcontext');
    var utils = _dereq_('./utils');
    var bind = utils.bind;
    var getBounds = utils.getBounds;
    var parseBackgrounds = utils.parseBackgrounds;
    var offsetBounds = utils.offsetBounds;

    function NodeParser(element, renderer, support, imageLoader, options) {
        log("Starting NodeParser");
        this.renderer = renderer;
        this.options = options;
        this.range = null;
        this.support = support;
        this.renderQueue = [];
        this.stack = new StackingContext(true, 1, element.ownerDocument, null);
        var parent = new NodeContainer(element, null);
        if (options.background) {
            renderer.rectangle(0, 0, renderer.width, renderer.height, new Color(options.background));
        }
        if (element === element.ownerDocument.documentElement) {
            // http://www.w3.org/TR/css3-background/#special-backgrounds
            var canvasBackground = new NodeContainer(parent.color('backgroundColor').isTransparent() ? element.ownerDocument.body : element.ownerDocument.documentElement, null);
            renderer.rectangle(0, 0, renderer.width, renderer.height, canvasBackground.color('backgroundColor'));
        }
        parent.visibile = parent.isElementVisible();
        this.createPseudoHideStyles(element.ownerDocument);
        this.disableAnimations(element.ownerDocument);
        this.nodes = flatten([parent].concat(this.getChildren(parent)).filter(function(container) {
            return container.visible = container.isElementVisible();
        }).map(this.getPseudoElements, this));
        this.fontMetrics = new FontMetrics();
        log("Fetched nodes, total:", this.nodes.length);
        log("Calculate overflow clips");
        this.calculateOverflowClips();
        log("Start fetching images");
        this.images = imageLoader.fetch(this.nodes.filter(isElement));
        this.ready = this.images.ready.then(bind(function() {
            log("Images loaded, starting parsing");
            log("Creating stacking contexts");
            this.createStackingContexts();
            log("Sorting stacking contexts");
            this.sortStackingContexts(this.stack);
            this.parse(this.stack);
            log("Render queue created with " + this.renderQueue.length + " items");
            return new Promise(bind(function(resolve) {
                if (!options.async) {
                    this.renderQueue.forEach(this.paint, this);
                    resolve();
                } else if (typeof(options.async) === "function") {
                    options.async.call(this, this.renderQueue, resolve);
                } else if (this.renderQueue.length > 0){
                    this.renderIndex = 0;
                    this.asyncRenderer(this.renderQueue, resolve);
                } else {
                    resolve();
                }
            }, this));
        }, this));
    }

    NodeParser.prototype.calculateOverflowClips = function() {
        this.nodes.forEach(function(container) {
            if (isElement(container)) {
                if (isPseudoElement(container)) {
                    container.appendToDOM();
                }
                container.borders = this.parseBorders(container);
                var clip = (container.css('overflow') === "hidden") ? [container.borders.clip] : [];
                var cssClip = container.parseClip();
                if (cssClip && ["absolute", "fixed"].indexOf(container.css('position')) !== -1) {
                    clip.push([["rect",
                        container.bounds.left + cssClip.left,
                        container.bounds.top + cssClip.top,
                        cssClip.right - cssClip.left,
                        cssClip.bottom - cssClip.top
                    ]]);
                }
                container.clip = hasParentClip(container) ? container.parent.clip.concat(clip) : clip;
                container.backgroundClip = (container.css('overflow') !== "hidden") ? container.clip.concat([container.borders.clip]) : container.clip;
                if (isPseudoElement(container)) {
                    container.cleanDOM();
                }
            } else if (isTextNode(container)) {
                container.clip = hasParentClip(container) ? container.parent.clip : [];
            }
            if (!isPseudoElement(container)) {
                container.bounds = null;
            }
        }, this);
    };

    function hasParentClip(container) {
        return container.parent && container.parent.clip.length;
    }

    NodeParser.prototype.asyncRenderer = function(queue, resolve, asyncTimer) {
        asyncTimer = asyncTimer || Date.now();
        this.paint(queue[this.renderIndex++]);
        if (queue.length === this.renderIndex) {
            resolve();
        } else if (asyncTimer + 20 > Date.now()) {
            this.asyncRenderer(queue, resolve, asyncTimer);
        } else {
            setTimeout(bind(function() {
                this.asyncRenderer(queue, resolve);
            }, this), 0);
        }
    };

    NodeParser.prototype.createPseudoHideStyles = function(document) {
        this.createStyles(document, '.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + ':before { content: "" !important; display: none !important; }' +
            '.' + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER + ':after { content: "" !important; display: none !important; }');
    };

    NodeParser.prototype.disableAnimations = function(document) {
        this.createStyles(document, '* { -webkit-animation: none !important; -moz-animation: none !important; -o-animation: none !important; animation: none !important; ' +
            '-webkit-transition: none !important; -moz-transition: none !important; -o-transition: none !important; transition: none !important;}');
    };

    NodeParser.prototype.createStyles = function(document, styles) {
        var hidePseudoElements = document.createElement('style');
        hidePseudoElements.innerHTML = styles;
        document.body.appendChild(hidePseudoElements);
    };

    NodeParser.prototype.getPseudoElements = function(container) {
        var nodes = [[container]];
        if (container.node.nodeType === Node.ELEMENT_NODE) {
            var before = this.getPseudoElement(container, ":before");
            var after = this.getPseudoElement(container, ":after");

            if (before) {
                nodes.push(before);
            }

            if (after) {
                nodes.push(after);
            }
        }
        return flatten(nodes);
    };

    function toCamelCase(str) {
        return str.replace(/(\-[a-z])/g, function(match){
            return match.toUpperCase().replace('-','');
        });
    }

    NodeParser.prototype.getPseudoElement = function(container, type) {
        var style = container.computedStyle(type);
        if(!style || !style.content || style.content === "none" || style.content === "-moz-alt-content" || style.display === "none") {
            return null;
        }

        var content = stripQuotes(style.content);
        var isImage = content.substr(0, 3) === 'url';
        var pseudoNode = document.createElement(isImage ? 'img' : 'html2canvaspseudoelement');
        var pseudoContainer = new PseudoElementContainer(pseudoNode, container, type);

        for (var i = style.length-1; i >= 0; i--) {
            var property = toCamelCase(style.item(i));
            pseudoNode.style[property] = style[property];
        }

        pseudoNode.className = PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER;

        if (isImage) {
            pseudoNode.src = parseBackgrounds(content)[0].args[0];
            return [pseudoContainer];
        } else {
            var text = document.createTextNode(content);
            pseudoNode.appendChild(text);
            return [pseudoContainer, new TextContainer(text, pseudoContainer)];
        }
    };


    NodeParser.prototype.getChildren = function(parentContainer) {
        return flatten([].filter.call(parentContainer.node.childNodes, renderableNode).map(function(node) {
            var container = [node.nodeType === Node.TEXT_NODE ? new TextContainer(node, parentContainer) : new NodeContainer(node, parentContainer)].filter(nonIgnoredElement);
            return node.nodeType === Node.ELEMENT_NODE && container.length && node.tagName !== "TEXTAREA" ? (container[0].isElementVisible() ? container.concat(this.getChildren(container[0])) : []) : container;
        }, this));
    };

    NodeParser.prototype.newStackingContext = function(container, hasOwnStacking) {
        var stack = new StackingContext(hasOwnStacking, container.getOpacity(), container.node, container.parent);
        container.cloneTo(stack);
        var parentStack = hasOwnStacking ? stack.getParentStack(this) : stack.parent.stack;
        parentStack.contexts.push(stack);
        container.stack = stack;
    };

    NodeParser.prototype.createStackingContexts = function() {
        this.nodes.forEach(function(container) {
            if (isElement(container) && (this.isRootElement(container) || hasOpacity(container) || isPositionedForStacking(container) || this.isBodyWithTransparentRoot(container) || container.hasTransform())) {
                this.newStackingContext(container, true);
            } else if (isElement(container) && ((isPositioned(container) && zIndex0(container)) || isInlineBlock(container) || isFloating(container))) {
                this.newStackingContext(container, false);
            } else {
                container.assignStack(container.parent.stack);
            }
        }, this);
    };

    NodeParser.prototype.isBodyWithTransparentRoot = function(container) {
        return container.node.nodeName === "BODY" && container.parent.color('backgroundColor').isTransparent();
    };

    NodeParser.prototype.isRootElement = function(container) {
        return container.parent === null;
    };

    NodeParser.prototype.sortStackingContexts = function(stack) {
        stack.contexts.sort(zIndexSort(stack.contexts.slice(0)));
        stack.contexts.forEach(this.sortStackingContexts, this);
    };

    NodeParser.prototype.parseTextBounds = function(container) {
        return function(text, index, textList) {
            if (container.parent.css("textDecoration").substr(0, 4) !== "none" || text.trim().length !== 0) {
                if (this.support.rangeBounds && !container.parent.hasTransform()) {
                    var offset = textList.slice(0, index).join("").length;
                    return this.getRangeBounds(container.node, offset, text.length);
                } else if (container.node && typeof(container.node.data) === "string") {
                    var replacementNode = container.node.splitText(text.length);
                    var bounds = this.getWrapperBounds(container.node, container.parent.hasTransform());
                    container.node = replacementNode;
                    return bounds;
                }
            } else if(!this.support.rangeBounds || container.parent.hasTransform()){
                container.node = container.node.splitText(text.length);
            }
            return {};
        };
    };

    NodeParser.prototype.getWrapperBounds = function(node, transform) {
        var wrapper = node.ownerDocument.createElement('html2canvaswrapper');
        var parent = node.parentNode,
            backupText = node.cloneNode(true);

        wrapper.appendChild(node.cloneNode(true));
        parent.replaceChild(wrapper, node);
        var bounds = transform ? offsetBounds(wrapper) : getBounds(wrapper);
        parent.replaceChild(backupText, wrapper);
        return bounds;
    };

    NodeParser.prototype.getRangeBounds = function(node, offset, length) {
        var range = this.range || (this.range = node.ownerDocument.createRange());
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range.getBoundingClientRect();
    };

    function ClearTransform() {}

    NodeParser.prototype.parse = function(stack) {
        // http://www.w3.org/TR/CSS21/visuren.html#z-index
        var negativeZindex = stack.contexts.filter(negativeZIndex); // 2. the child stacking contexts with negative stack levels (most negative first).
        var descendantElements = stack.children.filter(isElement);
        var descendantNonFloats = descendantElements.filter(not(isFloating));
        var nonInlineNonPositionedDescendants = descendantNonFloats.filter(not(isPositioned)).filter(not(inlineLevel)); // 3 the in-flow, non-inline-level, non-positioned descendants.
        var nonPositionedFloats = descendantElements.filter(not(isPositioned)).filter(isFloating); // 4. the non-positioned floats.
        var inFlow = descendantNonFloats.filter(not(isPositioned)).filter(inlineLevel); // 5. the in-flow, inline-level, non-positioned descendants, including inline tables and inline blocks.
        var stackLevel0 = stack.contexts.concat(descendantNonFloats.filter(isPositioned)).filter(zIndex0); // 6. the child stacking contexts with stack level 0 and the positioned descendants with stack level 0.
        var text = stack.children.filter(isTextNode).filter(hasText);
        var positiveZindex = stack.contexts.filter(positiveZIndex); // 7. the child stacking contexts with positive stack levels (least positive first).
        negativeZindex.concat(nonInlineNonPositionedDescendants).concat(nonPositionedFloats)
            .concat(inFlow).concat(stackLevel0).concat(text).concat(positiveZindex).forEach(function(container) {
            this.renderQueue.push(container);
            if (isStackingContext(container)) {
                this.parse(container);
                this.renderQueue.push(new ClearTransform());
            }
        }, this);
    };

    NodeParser.prototype.paint = function(container) {
        try {
            if (container instanceof ClearTransform) {
                this.renderer.ctx.restore();
            } else if (isTextNode(container)) {
                if (isPseudoElement(container.parent)) {
                    container.parent.appendToDOM();
                }
                this.paintText(container);
                if (isPseudoElement(container.parent)) {
                    container.parent.cleanDOM();
                }
            } else {
                this.paintNode(container);
            }
        } catch(e) {
            log(e);
            if (this.options.strict) {
                throw e;
            }
        }
    };

    NodeParser.prototype.paintNode = function(container) {
        if (isStackingContext(container)) {
            this.renderer.setOpacity(container.opacity);
            this.renderer.ctx.save();
            if (container.hasTransform()) {
                this.renderer.setTransform(container.parseTransform());
            }
        }

        if (container.node.nodeName === "INPUT" && container.node.type === "checkbox") {
            this.paintCheckbox(container);
        } else if (container.node.nodeName === "INPUT" && container.node.type === "radio") {
            this.paintRadio(container);
        } else {
            this.paintElement(container);
        }
    };

    NodeParser.prototype.paintElement = function(container) {
        var bounds = container.parseBounds();
        this.renderer.clip(container.backgroundClip, function() {
            this.renderer.renderBackground(container, bounds, container.borders.borders.map(getWidth));
        }, this);

        this.renderer.clip(container.clip, function() {
            this.renderer.renderBorders(container.borders.borders);
        }, this);

        this.renderer.clip(container.backgroundClip, function() {
            switch (container.node.nodeName) {
                case "svg":
                case "IFRAME":
                    var imgContainer = this.images.get(container.node);
                    if (imgContainer) {
                        this.renderer.renderImage(container, bounds, container.borders, imgContainer);
                    } else {
                        log("Error loading <" + container.node.nodeName + ">", container.node);
                    }
                    break;
                case "IMG":
                    var imageContainer = this.images.get(container.node.src);
                    if (imageContainer) {
                        this.renderer.renderImage(container, bounds, container.borders, imageContainer);
                    } else {
                        log("Error loading <img>", container.node.src);
                    }
                    break;
                case "CANVAS":
                    this.renderer.renderImage(container, bounds, container.borders, {image: container.node});
                    break;
                case "SELECT":
                case "INPUT":
                case "TEXTAREA":
                    this.paintFormValue(container);
                    break;
            }
        }, this);
    };

    NodeParser.prototype.paintCheckbox = function(container) {
        var b = container.parseBounds();

        var size = Math.min(b.width, b.height);
        var bounds = {width: size - 1, height: size - 1, top: b.top, left: b.left};
        var r = [3, 3];
        var radius = [r, r, r, r];
        var borders = [1,1,1,1].map(function(w) {
            return {color: new Color('#A5A5A5'), width: w};
        });

        var borderPoints = calculateCurvePoints(bounds, radius, borders);

        this.renderer.clip(container.backgroundClip, function() {
            this.renderer.rectangle(bounds.left + 1, bounds.top + 1, bounds.width - 2, bounds.height - 2, new Color("#DEDEDE"));
            this.renderer.renderBorders(calculateBorders(borders, bounds, borderPoints, radius));
            if (container.node.checked) {
                this.renderer.font(new Color('#424242'), 'normal', 'normal', 'bold', (size - 3) + "px", 'arial');
                this.renderer.text("\u2714", bounds.left + size / 6, bounds.top + size - 1);
            }
        }, this);
    };

    NodeParser.prototype.paintRadio = function(container) {
        var bounds = container.parseBounds();

        var size = Math.min(bounds.width, bounds.height) - 2;

        this.renderer.clip(container.backgroundClip, function() {
            this.renderer.circleStroke(bounds.left + 1, bounds.top + 1, size, new Color('#DEDEDE'), 1, new Color('#A5A5A5'));
            if (container.node.checked) {
                this.renderer.circle(Math.ceil(bounds.left + size / 4) + 1, Math.ceil(bounds.top + size / 4) + 1, Math.floor(size / 2), new Color('#424242'));
            }
        }, this);
    };

    NodeParser.prototype.paintFormValue = function(container) {
        var value = container.getValue();
        if (value.length > 0) {
            var document = container.node.ownerDocument;
            var wrapper = document.createElement('html2canvaswrapper');
            var properties = ['lineHeight', 'textAlign', 'fontFamily', 'fontWeight', 'fontSize', 'color',
                'paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom',
                'width', 'height', 'borderLeftStyle', 'borderTopStyle', 'borderLeftWidth', 'borderTopWidth',
                'boxSizing', 'whiteSpace', 'wordWrap'];

            properties.forEach(function(property) {
                try {
                    wrapper.style[property] = container.css(property);
                } catch(e) {
                    // Older IE has issues with "border"
                    log("html2canvas: Parse: Exception caught in renderFormValue: " + e.message);
                }
            });
            var bounds = container.parseBounds();
            wrapper.style.position = "fixed";
            wrapper.style.left = bounds.left + "px";
            wrapper.style.top = bounds.top + "px";
            wrapper.textContent = value;
            document.body.appendChild(wrapper);
            this.paintText(new TextContainer(wrapper.firstChild, container));
            document.body.removeChild(wrapper);
        }
    };

    NodeParser.prototype.paintText = function(container) {
        container.applyTextTransform();
        var characters = punycode.ucs2.decode(container.node.data);
        var textList = (!this.options.letterRendering || noLetterSpacing(container)) && !hasUnicode(container.node.data) ? getWords(characters) : characters.map(function(character) {
            return punycode.ucs2.encode([character]);
        });

        var weight = container.parent.fontWeight();
        var size = container.parent.css('fontSize');
        var family = container.parent.css('fontFamily');
        var shadows = container.parent.parseTextShadows();

        this.renderer.font(container.parent.color('color'), container.parent.css('fontStyle'), container.parent.css('fontVariant'), weight, size, family);
        if (shadows.length) {
            // TODO: support multiple text shadows
            this.renderer.fontShadow(shadows[0].color, shadows[0].offsetX, shadows[0].offsetY, shadows[0].blur);
        } else {
            this.renderer.clearShadow();
        }

        this.renderer.clip(container.parent.clip, function() {
            textList.map(this.parseTextBounds(container), this).forEach(function(bounds, index) {
                if (bounds) {
                    this.renderer.text(textList[index], bounds.left, bounds.bottom);
                    this.renderTextDecoration(container.parent, bounds, this.fontMetrics.getMetrics(family, size));
                }
            }, this);
        }, this);
    };

    NodeParser.prototype.renderTextDecoration = function(container, bounds, metrics) {
        switch(container.css("textDecoration").split(" ")[0]) {
            case "underline":
                // Draws a line at the baseline of the font
                // TODO As some browsers display the line as more than 1px if the font-size is big, need to take that into account both in position and size
                this.renderer.rectangle(bounds.left, Math.round(bounds.top + metrics.baseline + metrics.lineWidth), bounds.width, 1, container.color("color"));
                break;
            case "overline":
                this.renderer.rectangle(bounds.left, Math.round(bounds.top), bounds.width, 1, container.color("color"));
                break;
            case "line-through":
                // TODO try and find exact position for line-through
                this.renderer.rectangle(bounds.left, Math.ceil(bounds.top + metrics.middle + metrics.lineWidth), bounds.width, 1, container.color("color"));
                break;
        }
    };

    var borderColorTransforms = {
        inset: [
            ["darken", 0.60],
            ["darken", 0.10],
            ["darken", 0.10],
            ["darken", 0.60]
        ]
    };

    NodeParser.prototype.parseBorders = function(container) {
        var nodeBounds = container.parseBounds();
        var radius = getBorderRadiusData(container);
        var borders = ["Top", "Right", "Bottom", "Left"].map(function(side, index) {
            var style = container.css('border' + side + 'Style');
            var color = container.color('border' + side + 'Color');
            if (style === "inset" && color.isBlack()) {
                color = new Color([255, 255, 255, color.a]); // this is wrong, but
            }
            var colorTransform = borderColorTransforms[style] ? borderColorTransforms[style][index] : null;
            return {
                width: container.cssInt('border' + side + 'Width'),
                color: colorTransform ? color[colorTransform[0]](colorTransform[1]) : color,
                args: null
            };
        });
        var borderPoints = calculateCurvePoints(nodeBounds, radius, borders);

        return {
            clip: this.parseBackgroundClip(container, borderPoints, borders, radius, nodeBounds),
            borders: calculateBorders(borders, nodeBounds, borderPoints, radius)
        };
    };

    function calculateBorders(borders, nodeBounds, borderPoints, radius) {
        return borders.map(function(border, borderSide) {
            if (border.width > 0) {
                var bx = nodeBounds.left;
                var by = nodeBounds.top;
                var bw = nodeBounds.width;
                var bh = nodeBounds.height - (borders[2].width);

                switch(borderSide) {
                    case 0:
                        // top border
                        bh = borders[0].width;
                        border.args = drawSide({
                                c1: [bx, by],
                                c2: [bx + bw, by],
                                c3: [bx + bw - borders[1].width, by + bh],
                                c4: [bx + borders[3].width, by + bh]
                            }, radius[0], radius[1],
                            borderPoints.topLeftOuter, borderPoints.topLeftInner, borderPoints.topRightOuter, borderPoints.topRightInner);
                        break;
                    case 1:
                        // right border
                        bx = nodeBounds.left + nodeBounds.width - (borders[1].width);
                        bw = borders[1].width;

                        border.args = drawSide({
                                c1: [bx + bw, by],
                                c2: [bx + bw, by + bh + borders[2].width],
                                c3: [bx, by + bh],
                                c4: [bx, by + borders[0].width]
                            }, radius[1], radius[2],
                            borderPoints.topRightOuter, borderPoints.topRightInner, borderPoints.bottomRightOuter, borderPoints.bottomRightInner);
                        break;
                    case 2:
                        // bottom border
                        by = (by + nodeBounds.height) - (borders[2].width);
                        bh = borders[2].width;
                        border.args = drawSide({
                                c1: [bx + bw, by + bh],
                                c2: [bx, by + bh],
                                c3: [bx + borders[3].width, by],
                                c4: [bx + bw - borders[3].width, by]
                            }, radius[2], radius[3],
                            borderPoints.bottomRightOuter, borderPoints.bottomRightInner, borderPoints.bottomLeftOuter, borderPoints.bottomLeftInner);
                        break;
                    case 3:
                        // left border
                        bw = borders[3].width;
                        border.args = drawSide({
                                c1: [bx, by + bh + borders[2].width],
                                c2: [bx, by],
                                c3: [bx + bw, by + borders[0].width],
                                c4: [bx + bw, by + bh]
                            }, radius[3], radius[0],
                            borderPoints.bottomLeftOuter, borderPoints.bottomLeftInner, borderPoints.topLeftOuter, borderPoints.topLeftInner);
                        break;
                }
            }
            return border;
        });
    }

    NodeParser.prototype.parseBackgroundClip = function(container, borderPoints, borders, radius, bounds) {
        var backgroundClip = container.css('backgroundClip'),
            borderArgs = [];

        switch(backgroundClip) {
            case "content-box":
            case "padding-box":
                parseCorner(borderArgs, radius[0], radius[1], borderPoints.topLeftInner, borderPoints.topRightInner, bounds.left + borders[3].width, bounds.top + borders[0].width);
                parseCorner(borderArgs, radius[1], radius[2], borderPoints.topRightInner, borderPoints.bottomRightInner, bounds.left + bounds.width - borders[1].width, bounds.top + borders[0].width);
                parseCorner(borderArgs, radius[2], radius[3], borderPoints.bottomRightInner, borderPoints.bottomLeftInner, bounds.left + bounds.width - borders[1].width, bounds.top + bounds.height - borders[2].width);
                parseCorner(borderArgs, radius[3], radius[0], borderPoints.bottomLeftInner, borderPoints.topLeftInner, bounds.left + borders[3].width, bounds.top + bounds.height - borders[2].width);
                break;

            default:
                parseCorner(borderArgs, radius[0], radius[1], borderPoints.topLeftOuter, borderPoints.topRightOuter, bounds.left, bounds.top);
                parseCorner(borderArgs, radius[1], radius[2], borderPoints.topRightOuter, borderPoints.bottomRightOuter, bounds.left + bounds.width, bounds.top);
                parseCorner(borderArgs, radius[2], radius[3], borderPoints.bottomRightOuter, borderPoints.bottomLeftOuter, bounds.left + bounds.width, bounds.top + bounds.height);
                parseCorner(borderArgs, radius[3], radius[0], borderPoints.bottomLeftOuter, borderPoints.topLeftOuter, bounds.left, bounds.top + bounds.height);
                break;
        }

        return borderArgs;
    };

    function getCurvePoints(x, y, r1, r2) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = (r1) * kappa, // control point offset horizontal
            oy = (r2) * kappa, // control point offset vertical
            xm = x + r1, // x-middle
            ym = y + r2; // y-middle
        return {
            topLeft: bezierCurve({x: x, y: ym}, {x: x, y: ym - oy}, {x: xm - ox, y: y}, {x: xm, y: y}),
            topRight: bezierCurve({x: x, y: y}, {x: x + ox,y: y}, {x: xm, y: ym - oy}, {x: xm, y: ym}),
            bottomRight: bezierCurve({x: xm, y: y}, {x: xm, y: y + oy}, {x: x + ox, y: ym}, {x: x, y: ym}),
            bottomLeft: bezierCurve({x: xm, y: ym}, {x: xm - ox, y: ym}, {x: x, y: y + oy}, {x: x, y:y})
        };
    }

    function calculateCurvePoints(bounds, borderRadius, borders) {
        var x = bounds.left,
            y = bounds.top,
            width = bounds.width,
            height = bounds.height,

            tlh = borderRadius[0][0] < width / 2 ? borderRadius[0][0] : width / 2,
            tlv = borderRadius[0][1] < height / 2 ? borderRadius[0][1] : height / 2,
            trh = borderRadius[1][0] < width / 2 ? borderRadius[1][0] : width / 2,
            trv = borderRadius[1][1] < height / 2 ? borderRadius[1][1] : height / 2,
            brh = borderRadius[2][0] < width / 2 ? borderRadius[2][0] : width / 2,
            brv = borderRadius[2][1] < height / 2 ? borderRadius[2][1] : height / 2,
            blh = borderRadius[3][0] < width / 2 ? borderRadius[3][0] : width / 2,
            blv = borderRadius[3][1] < height / 2 ? borderRadius[3][1] : height / 2;

        var topWidth = width - trh,
            rightHeight = height - brv,
            bottomWidth = width - brh,
            leftHeight = height - blv;

        return {
            topLeftOuter: getCurvePoints(x, y, tlh, tlv).topLeft.subdivide(0.5),
            topLeftInner: getCurvePoints(x + borders[3].width, y + borders[0].width, Math.max(0, tlh - borders[3].width), Math.max(0, tlv - borders[0].width)).topLeft.subdivide(0.5),
            topRightOuter: getCurvePoints(x + topWidth, y, trh, trv).topRight.subdivide(0.5),
            topRightInner: getCurvePoints(x + Math.min(topWidth, width + borders[3].width), y + borders[0].width, (topWidth > width + borders[3].width) ? 0 :trh - borders[3].width, trv - borders[0].width).topRight.subdivide(0.5),
            bottomRightOuter: getCurvePoints(x + bottomWidth, y + rightHeight, brh, brv).bottomRight.subdivide(0.5),
            bottomRightInner: getCurvePoints(x + Math.min(bottomWidth, width - borders[3].width), y + Math.min(rightHeight, height + borders[0].width), Math.max(0, brh - borders[1].width),  brv - borders[2].width).bottomRight.subdivide(0.5),
            bottomLeftOuter: getCurvePoints(x, y + leftHeight, blh, blv).bottomLeft.subdivide(0.5),
            bottomLeftInner: getCurvePoints(x + borders[3].width, y + leftHeight, Math.max(0, blh - borders[3].width), blv - borders[2].width).bottomLeft.subdivide(0.5)
        };
    }

    function bezierCurve(start, startControl, endControl, end) {
        var lerp = function (a, b, t) {
            return {
                x: a.x + (b.x - a.x) * t,
                y: a.y + (b.y - a.y) * t
            };
        };

        return {
            start: start,
            startControl: startControl,
            endControl: endControl,
            end: end,
            subdivide: function(t) {
                var ab = lerp(start, startControl, t),
                    bc = lerp(startControl, endControl, t),
                    cd = lerp(endControl, end, t),
                    abbc = lerp(ab, bc, t),
                    bccd = lerp(bc, cd, t),
                    dest = lerp(abbc, bccd, t);
                return [bezierCurve(start, ab, abbc, dest), bezierCurve(dest, bccd, cd, end)];
            },
            curveTo: function(borderArgs) {
                borderArgs.push(["bezierCurve", startControl.x, startControl.y, endControl.x, endControl.y, end.x, end.y]);
            },
            curveToReversed: function(borderArgs) {
                borderArgs.push(["bezierCurve", endControl.x, endControl.y, startControl.x, startControl.y, start.x, start.y]);
            }
        };
    }

    function drawSide(borderData, radius1, radius2, outer1, inner1, outer2, inner2) {
        var borderArgs = [];

        if (radius1[0] > 0 || radius1[1] > 0) {
            borderArgs.push(["line", outer1[1].start.x, outer1[1].start.y]);
            outer1[1].curveTo(borderArgs);
        } else {
            borderArgs.push([ "line", borderData.c1[0], borderData.c1[1]]);
        }

        if (radius2[0] > 0 || radius2[1] > 0) {
            borderArgs.push(["line", outer2[0].start.x, outer2[0].start.y]);
            outer2[0].curveTo(borderArgs);
            borderArgs.push(["line", inner2[0].end.x, inner2[0].end.y]);
            inner2[0].curveToReversed(borderArgs);
        } else {
            borderArgs.push(["line", borderData.c2[0], borderData.c2[1]]);
            borderArgs.push(["line", borderData.c3[0], borderData.c3[1]]);
        }

        if (radius1[0] > 0 || radius1[1] > 0) {
            borderArgs.push(["line", inner1[1].end.x, inner1[1].end.y]);
            inner1[1].curveToReversed(borderArgs);
        } else {
            borderArgs.push(["line", borderData.c4[0], borderData.c4[1]]);
        }

        return borderArgs;
    }

    function parseCorner(borderArgs, radius1, radius2, corner1, corner2, x, y) {
        if (radius1[0] > 0 || radius1[1] > 0) {
            borderArgs.push(["line", corner1[0].start.x, corner1[0].start.y]);
            corner1[0].curveTo(borderArgs);
            corner1[1].curveTo(borderArgs);
        } else {
            borderArgs.push(["line", x, y]);
        }

        if (radius2[0] > 0 || radius2[1] > 0) {
            borderArgs.push(["line", corner2[0].start.x, corner2[0].start.y]);
        }
    }

    function negativeZIndex(container) {
        return container.cssInt("zIndex") < 0;
    }

    function positiveZIndex(container) {
        return container.cssInt("zIndex") > 0;
    }

    function zIndex0(container) {
        return container.cssInt("zIndex") === 0;
    }

    function inlineLevel(container) {
        return ["inline", "inline-block", "inline-table"].indexOf(container.css("display")) !== -1;
    }

    function isStackingContext(container) {
        return (container instanceof StackingContext);
    }

    function hasText(container) {
        return container.node.data.trim().length > 0;
    }

    function noLetterSpacing(container) {
        return (/^(normal|none|0px)$/.test(container.parent.css("letterSpacing")));
    }

    function getBorderRadiusData(container) {
        return ["TopLeft", "TopRight", "BottomRight", "BottomLeft"].map(function(side) {
            var value = container.css('border' + side + 'Radius');
            var arr = value.split(" ");
            if (arr.length <= 1) {
                arr[1] = arr[0];
            }
            return arr.map(asInt);
        });
    }

    function renderableNode(node) {
        return (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.ELEMENT_NODE);
    }

    function isPositionedForStacking(container) {
        var position = container.css("position");
        var zIndex = (["absolute", "relative", "fixed"].indexOf(position) !== -1) ? container.css("zIndex") : "auto";
        return zIndex !== "auto";
    }

    function isPositioned(container) {
        return container.css("position") !== "static";
    }

    function isFloating(container) {
        return container.css("float") !== "none";
    }

    function isInlineBlock(container) {
        return ["inline-block", "inline-table"].indexOf(container.css("display")) !== -1;
    }

    function not(callback) {
        var context = this;
        return function() {
            return !callback.apply(context, arguments);
        };
    }

    function isElement(container) {
        return container.node.nodeType === Node.ELEMENT_NODE;
    }

    function isPseudoElement(container) {
        return container.isPseudoElement === true;
    }

    function isTextNode(container) {
        return container.node.nodeType === Node.TEXT_NODE;
    }

    function zIndexSort(contexts) {
        return function(a, b) {
            return (a.cssInt("zIndex") + (contexts.indexOf(a) / contexts.length)) - (b.cssInt("zIndex") + (contexts.indexOf(b) / contexts.length));
        };
    }

    function hasOpacity(container) {
        return container.getOpacity() < 1;
    }

    function asInt(value) {
        return parseInt(value, 10);
    }

    function getWidth(border) {
        return border.width;
    }

    function nonIgnoredElement(nodeContainer) {
        return (nodeContainer.node.nodeType !== Node.ELEMENT_NODE || ["SCRIPT", "HEAD", "TITLE", "OBJECT", "BR", "OPTION"].indexOf(nodeContainer.node.nodeName) === -1);
    }

    function flatten(arrays) {
        return [].concat.apply([], arrays);
    }

    function stripQuotes(content) {
        var first = content.substr(0, 1);
        return (first === content.substr(content.length - 1) && first.match(/'|"/)) ? content.substr(1, content.length - 2) : content;
    }

    function getWords(characters) {
        var words = [], i = 0, onWordBoundary = false, word;
        while(characters.length) {
            if (isWordBoundary(characters[i]) === onWordBoundary) {
                word = characters.splice(0, i);
                if (word.length) {
                    words.push(punycode.ucs2.encode(word));
                }
                onWordBoundary =! onWordBoundary;
                i = 0;
            } else {
                i++;
            }

            if (i >= characters.length) {
                word = characters.splice(0, i);
                if (word.length) {
                    words.push(punycode.ucs2.encode(word));
                }
            }
        }
        return words;
    }

    function isWordBoundary(characterCode) {
        return [
                32, // <space>
                13, // \r
                10, // \n
                9, // \t
                45 // -
            ].indexOf(characterCode) !== -1;
    }

    function hasUnicode(string) {
        return (/[^\u0000-\u00ff]/).test(string);
    }

    module.exports = NodeParser;

},{"./color":3,"./fontmetrics":7,"./log":13,"./nodecontainer":14,"./pseudoelementcontainer":18,"./stackingcontext":21,"./textcontainer":25,"./utils":26,"punycode":1}],16:[function(_dereq_,module,exports){
    var XHR = _dereq_('./xhr');
    var utils = _dereq_('./utils');
    var log = _dereq_('./log');
    var createWindowClone = _dereq_('./clone');
    var decode64 = utils.decode64;

    function Proxy(src, proxyUrl, document) {
        var supportsCORS = ('withCredentials' in new XMLHttpRequest());
        if (!proxyUrl) {
            return Promise.reject("No proxy configured");
        }
        var callback = createCallback(supportsCORS);
        var url = createProxyUrl(proxyUrl, src, callback);

        return supportsCORS ? XHR(url) : (jsonp(document, url, callback).then(function(response) {
            return decode64(response.content);
        }));
    }
    var proxyCount = 0;

    function ProxyURL(src, proxyUrl, document) {
        var supportsCORSImage = ('crossOrigin' in new Image());
        var callback = createCallback(supportsCORSImage);
        var url = createProxyUrl(proxyUrl, src, callback);
        return (supportsCORSImage ? Promise.resolve(url) : jsonp(document, url, callback).then(function(response) {
            return "data:" + response.type + ";base64," + response.content;
        }));
    }

    function jsonp(document, url, callback) {
        return new Promise(function(resolve, reject) {
            var s = document.createElement("script");
            var cleanup = function() {
                delete window.html2canvas.proxy[callback];
                document.body.removeChild(s);
            };
            window.html2canvas.proxy[callback] = function(response) {
                cleanup();
                resolve(response);
            };
            s.src = url;
            s.onerror = function(e) {
                cleanup();
                reject(e);
            };
            document.body.appendChild(s);
        });
    }

    function createCallback(useCORS) {
        return !useCORS ? "html2canvas_" + Date.now() + "_" + (++proxyCount) + "_" + Math.round(Math.random() * 100000) : "";
    }

    function createProxyUrl(proxyUrl, src, callback) {
        return proxyUrl + "?url=" + encodeURIComponent(src) + (callback.length ? "&callback=html2canvas.proxy." + callback : "");
    }

    function documentFromHTML(src) {
        return function(html) {
            var parser = new DOMParser(), doc;
            try {
                doc = parser.parseFromString(html, "text/html");
            } catch(e) {
                log("DOMParser not supported, falling back to createHTMLDocument");
                doc = document.implementation.createHTMLDocument("");
                try {
                    doc.open();
                    doc.write(html);
                    doc.close();
                } catch(ee) {
                    log("createHTMLDocument write not supported, falling back to document.body.innerHTML");
                    doc.body.innerHTML = html; // ie9 doesnt support writing to documentElement
                }
            }

            var b = doc.querySelector("base");
            if (!b || !b.href.host) {
                var base = doc.createElement("base");
                base.href = src;
                doc.head.insertBefore(base, doc.head.firstChild);
            }

            return doc;
        };
    }

    function loadUrlDocument(src, proxy, document, width, height, options) {
        return new Proxy(src, proxy, window.document).then(documentFromHTML(src)).then(function(doc) {
            return createWindowClone(doc, document, width, height, options, 0, 0);
        });
    }

    exports.Proxy = Proxy;
    exports.ProxyURL = ProxyURL;
    exports.loadUrlDocument = loadUrlDocument;

},{"./clone":2,"./log":13,"./utils":26,"./xhr":28}],17:[function(_dereq_,module,exports){
    var ProxyURL = _dereq_('./proxy').ProxyURL;

    function ProxyImageContainer(src, proxy) {
        var link = document.createElement("a");
        link.href = src;
        src = link.href;
        this.src = src;
        this.image = new Image();
        var self = this;
        this.promise = new Promise(function(resolve, reject) {
            self.image.crossOrigin = "Anonymous";
            self.image.onload = resolve;
            self.image.onerror = reject;

            new ProxyURL(src, proxy, document).then(function(url) {
                self.image.src = url;
            })['catch'](reject);
        });
    }

    module.exports = ProxyImageContainer;

},{"./proxy":16}],18:[function(_dereq_,module,exports){
    var NodeContainer = _dereq_('./nodecontainer');

    function PseudoElementContainer(node, parent, type) {
        NodeContainer.call(this, node, parent);
        this.isPseudoElement = true;
        this.before = type === ":before";
    }

    PseudoElementContainer.prototype.cloneTo = function(stack) {
        PseudoElementContainer.prototype.cloneTo.call(this, stack);
        stack.isPseudoElement = true;
        stack.before = this.before;
    };

    PseudoElementContainer.prototype = Object.create(NodeContainer.prototype);

    PseudoElementContainer.prototype.appendToDOM = function() {
        if (this.before) {
            this.parent.node.insertBefore(this.node, this.parent.node.firstChild);
        } else {
            this.parent.node.appendChild(this.node);
        }
        this.parent.node.className += " " + this.getHideClass();
    };

    PseudoElementContainer.prototype.cleanDOM = function() {
        this.node.parentNode.removeChild(this.node);
        this.parent.node.className = this.parent.node.className.replace(this.getHideClass(), "");
    };

    PseudoElementContainer.prototype.getHideClass = function() {
        return this["PSEUDO_HIDE_ELEMENT_CLASS_" + (this.before ? "BEFORE" : "AFTER")];
    };

    PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    PseudoElementContainer.prototype.PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";

    module.exports = PseudoElementContainer;

},{"./nodecontainer":14}],19:[function(_dereq_,module,exports){
    var log = _dereq_('./log');

    function Renderer(width, height, images, options, document) {
        this.width = width;
        this.height = height;
        this.images = images;
        this.options = options;
        this.document = document;
    }

    Renderer.prototype.renderImage = function(container, bounds, borderData, imageContainer) {
        var paddingLeft = container.cssInt('paddingLeft'),
            paddingTop = container.cssInt('paddingTop'),
            paddingRight = container.cssInt('paddingRight'),
            paddingBottom = container.cssInt('paddingBottom'),
            borders = borderData.borders;

        var width = bounds.width - (borders[1].width + borders[3].width + paddingLeft + paddingRight);
        var height = bounds.height - (borders[0].width + borders[2].width + paddingTop + paddingBottom);
        this.drawImage(
            imageContainer,
            0,
            0,
            imageContainer.image.width || width,
            imageContainer.image.height || height,
            bounds.left + paddingLeft + borders[3].width,
            bounds.top + paddingTop + borders[0].width,
            width,
            height
        );
    };

    Renderer.prototype.renderBackground = function(container, bounds, borderData) {
        if (bounds.height > 0 && bounds.width > 0) {
            this.renderBackgroundColor(container, bounds);
            this.renderBackgroundImage(container, bounds, borderData);
        }
    };

    Renderer.prototype.renderBackgroundColor = function(container, bounds) {
        var color = container.color("backgroundColor");
        if (!color.isTransparent()) {
            this.rectangle(bounds.left, bounds.top, bounds.width, bounds.height, color);
        }
    };

    Renderer.prototype.renderBorders = function(borders) {
        borders.forEach(this.renderBorder, this);
    };

    Renderer.prototype.renderBorder = function(data) {
        if (!data.color.isTransparent() && data.args !== null) {
            this.drawShape(data.args, data.color);
        }
    };

    Renderer.prototype.renderBackgroundImage = function(container, bounds, borderData) {
        var backgroundImages = container.parseBackgroundImages();
        backgroundImages.reverse().forEach(function(backgroundImage, index, arr) {
            switch(backgroundImage.method) {
                case "url":
                    var image = this.images.get(backgroundImage.args[0]);
                    if (image) {
                        this.renderBackgroundRepeating(container, bounds, image, arr.length - (index+1), borderData);
                    } else {
                        log("Error loading background-image", backgroundImage.args[0]);
                    }
                    break;
                case "linear-gradient":
                case "gradient":
                    var gradientImage = this.images.get(backgroundImage.value);
                    if (gradientImage) {
                        this.renderBackgroundGradient(gradientImage, bounds, borderData);
                    } else {
                        log("Error loading background-image", backgroundImage.args[0]);
                    }
                    break;
                case "none":
                    break;
                default:
                    log("Unknown background-image type", backgroundImage.args[0]);
            }
        }, this);
    };

    Renderer.prototype.renderBackgroundRepeating = function(container, bounds, imageContainer, index, borderData) {
        var size = container.parseBackgroundSize(bounds, imageContainer.image, index);
        var position = container.parseBackgroundPosition(bounds, imageContainer.image, index, size);
        var repeat = container.parseBackgroundRepeat(index);
        switch (repeat) {
            case "repeat-x":
            case "repeat no-repeat":
                this.backgroundRepeatShape(imageContainer, position, size, bounds, bounds.left + borderData[3], bounds.top + position.top + borderData[0], 99999, size.height, borderData);
                break;
            case "repeat-y":
            case "no-repeat repeat":
                this.backgroundRepeatShape(imageContainer, position, size, bounds, bounds.left + position.left + borderData[3], bounds.top + borderData[0], size.width, 99999, borderData);
                break;
            case "no-repeat":
                this.backgroundRepeatShape(imageContainer, position, size, bounds, bounds.left + position.left + borderData[3], bounds.top + position.top + borderData[0], size.width, size.height, borderData);
                break;
            default:
                this.renderBackgroundRepeat(imageContainer, position, size, {top: bounds.top, left: bounds.left}, borderData[3], borderData[0]);
                break;
        }
    };

    module.exports = Renderer;

},{"./log":13}],20:[function(_dereq_,module,exports){
    var Renderer = _dereq_('../renderer');
    var LinearGradientContainer = _dereq_('../lineargradientcontainer');
    var log = _dereq_('../log');

    function CanvasRenderer(width, height) {
        Renderer.apply(this, arguments);
        this.canvas = this.options.canvas || this.document.createElement("canvas");
        if (!this.options.canvas) {
            this.canvas.width = width;
            this.canvas.height = height;
        }
        this.ctx = this.canvas.getContext("2d");
        this.taintCtx = this.document.createElement("canvas").getContext("2d");
        this.ctx.textBaseline = "bottom";
        this.variables = {};
        log("Initialized CanvasRenderer with size", width, "x", height);
    }

    CanvasRenderer.prototype = Object.create(Renderer.prototype);

    CanvasRenderer.prototype.setFillStyle = function(fillStyle) {
        this.ctx.fillStyle = typeof(fillStyle) === "object" && !!fillStyle.isColor ? fillStyle.toString() : fillStyle;
        return this.ctx;
    };

    CanvasRenderer.prototype.rectangle = function(left, top, width, height, color) {
        this.setFillStyle(color).fillRect(left, top, width, height);
    };

    CanvasRenderer.prototype.circle = function(left, top, size, color) {
        this.setFillStyle(color);
        this.ctx.beginPath();
        this.ctx.arc(left + size / 2, top + size / 2, size / 2, 0, Math.PI*2, true);
        this.ctx.closePath();
        this.ctx.fill();
    };

    CanvasRenderer.prototype.circleStroke = function(left, top, size, color, stroke, strokeColor) {
        this.circle(left, top, size, color);
        this.ctx.strokeStyle = strokeColor.toString();
        this.ctx.stroke();
    };

    CanvasRenderer.prototype.drawShape = function(shape, color) {
        this.shape(shape);
        this.setFillStyle(color).fill();
    };

    CanvasRenderer.prototype.taints = function(imageContainer) {
        if (imageContainer.tainted === null) {
            this.taintCtx.drawImage(imageContainer.image, 0, 0);
            try {
                this.taintCtx.getImageData(0, 0, 1, 1);
                imageContainer.tainted = false;
            } catch(e) {
                this.taintCtx = document.createElement("canvas").getContext("2d");
                imageContainer.tainted = true;
            }
        }

        return imageContainer.tainted;
    };

    CanvasRenderer.prototype.drawImage = function(imageContainer, sx, sy, sw, sh, dx, dy, dw, dh) {
        if (!this.taints(imageContainer) || this.options.allowTaint) {
            this.ctx.drawImage(imageContainer.image, sx, sy, sw, sh, dx, dy, dw, dh);
        }
    };

    CanvasRenderer.prototype.clip = function(shapes, callback, context) {
        this.ctx.save();
        shapes.filter(hasEntries).forEach(function(shape) {
            this.shape(shape).clip();
        }, this);
        callback.call(context);
        this.ctx.restore();
    };

    CanvasRenderer.prototype.shape = function(shape) {
        this.ctx.beginPath();
        shape.forEach(function(point, index) {
            if (point[0] === "rect") {
                this.ctx.rect.apply(this.ctx, point.slice(1));
            } else {
                this.ctx[(index === 0) ? "moveTo" : point[0] + "To" ].apply(this.ctx, point.slice(1));
            }
        }, this);
        this.ctx.closePath();
        return this.ctx;
    };

    CanvasRenderer.prototype.font = function(color, style, variant, weight, size, family) {
        this.setFillStyle(color).font = [style, variant, weight, size, family].join(" ").split(",")[0];
    };

    CanvasRenderer.prototype.fontShadow = function(color, offsetX, offsetY, blur) {
        this.setVariable("shadowColor", color.toString())
            .setVariable("shadowOffsetY", offsetX)
            .setVariable("shadowOffsetX", offsetY)
            .setVariable("shadowBlur", blur);
    };

    CanvasRenderer.prototype.clearShadow = function() {
        this.setVariable("shadowColor", "rgba(0,0,0,0)");
    };

    CanvasRenderer.prototype.setOpacity = function(opacity) {
        this.ctx.globalAlpha = opacity;
    };

    CanvasRenderer.prototype.setTransform = function(transform) {
        this.ctx.translate(transform.origin[0], transform.origin[1]);
        this.ctx.transform.apply(this.ctx, transform.matrix);
        this.ctx.translate(-transform.origin[0], -transform.origin[1]);
    };

    CanvasRenderer.prototype.setVariable = function(property, value) {
        if (this.variables[property] !== value) {
            this.variables[property] = this.ctx[property] = value;
        }

        return this;
    };

    CanvasRenderer.prototype.text = function(text, left, bottom) {
        this.ctx.fillText(text, left, bottom);
    };

    CanvasRenderer.prototype.backgroundRepeatShape = function(imageContainer, backgroundPosition, size, bounds, left, top, width, height, borderData) {
        var shape = [
            ["line", Math.round(left), Math.round(top)],
            ["line", Math.round(left + width), Math.round(top)],
            ["line", Math.round(left + width), Math.round(height + top)],
            ["line", Math.round(left), Math.round(height + top)]
        ];
        this.clip([shape], function() {
            this.renderBackgroundRepeat(imageContainer, backgroundPosition, size, bounds, borderData[3], borderData[0]);
        }, this);
    };

    CanvasRenderer.prototype.renderBackgroundRepeat = function(imageContainer, backgroundPosition, size, bounds, borderLeft, borderTop) {
        var offsetX = Math.round(bounds.left + backgroundPosition.left + borderLeft), offsetY = Math.round(bounds.top + backgroundPosition.top + borderTop);
        this.setFillStyle(this.ctx.createPattern(this.resizeImage(imageContainer, size), "repeat"));
        this.ctx.translate(offsetX, offsetY);
        this.ctx.fill();
        this.ctx.translate(-offsetX, -offsetY);
    };

    CanvasRenderer.prototype.renderBackgroundGradient = function(gradientImage, bounds) {
        if (gradientImage instanceof LinearGradientContainer) {
            var gradient = this.ctx.createLinearGradient(
                bounds.left + bounds.width * gradientImage.x0,
                bounds.top + bounds.height * gradientImage.y0,
                bounds.left +  bounds.width * gradientImage.x1,
                bounds.top +  bounds.height * gradientImage.y1);
            gradientImage.colorStops.forEach(function(colorStop) {
                gradient.addColorStop(colorStop.stop, colorStop.color.toString());
            });
            this.rectangle(bounds.left, bounds.top, bounds.width, bounds.height, gradient);
        }
    };

    CanvasRenderer.prototype.resizeImage = function(imageContainer, size) {
        var image = imageContainer.image;
        if(image.width === size.width && image.height === size.height) {
            return image;
        }

        var ctx, canvas = document.createElement('canvas');
        canvas.width = size.width;
        canvas.height = size.height;
        ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, size.width, size.height );
        return canvas;
    };

    function hasEntries(array) {
        return array.length > 0;
    }

    module.exports = CanvasRenderer;

},{"../lineargradientcontainer":12,"../log":13,"../renderer":19}],21:[function(_dereq_,module,exports){
    var NodeContainer = _dereq_('./nodecontainer');

    function StackingContext(hasOwnStacking, opacity, element, parent) {
        NodeContainer.call(this, element, parent);
        this.ownStacking = hasOwnStacking;
        this.contexts = [];
        this.children = [];
        this.opacity = (this.parent ? this.parent.stack.opacity : 1) * opacity;
    }

    StackingContext.prototype = Object.create(NodeContainer.prototype);

    StackingContext.prototype.getParentStack = function(context) {
        var parentStack = (this.parent) ? this.parent.stack : null;
        return parentStack ? (parentStack.ownStacking ? parentStack : parentStack.getParentStack(context)) : context.stack;
    };

    module.exports = StackingContext;

},{"./nodecontainer":14}],22:[function(_dereq_,module,exports){
    function Support(document) {
        this.rangeBounds = this.testRangeBounds(document);
        this.cors = this.testCORS();
        this.svg = this.testSVG();
    }

    Support.prototype.testRangeBounds = function(document) {
        var range, testElement, rangeBounds, rangeHeight, support = false;

        if (document.createRange) {
            range = document.createRange();
            if (range.getBoundingClientRect) {
                testElement = document.createElement('boundtest');
                testElement.style.height = "123px";
                testElement.style.display = "block";
                document.body.appendChild(testElement);

                range.selectNode(testElement);
                rangeBounds = range.getBoundingClientRect();
                rangeHeight = rangeBounds.height;

                if (rangeHeight === 123) {
                    support = true;
                }
                document.body.removeChild(testElement);
            }
        }

        return support;
    };

    Support.prototype.testCORS = function() {
        return typeof((new Image()).crossOrigin) !== "undefined";
    };

    Support.prototype.testSVG = function() {
        var img = new Image();
        var canvas = document.createElement("canvas");
        var ctx =  canvas.getContext("2d");
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";

        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch(e) {
            return false;
        }
        return true;
    };

    module.exports = Support;

},{}],23:[function(_dereq_,module,exports){
    var XHR = _dereq_('./xhr');
    var decode64 = _dereq_('./utils').decode64;

    function SVGContainer(src) {
        this.src = src;
        this.image = null;
        var self = this;

        this.promise = this.hasFabric().then(function() {
            return (self.isInline(src) ? Promise.resolve(self.inlineFormatting(src)) : XHR(src));
        }).then(function(svg) {
            return new Promise(function(resolve) {
                window.html2canvas.svg.fabric.loadSVGFromString(svg, self.createCanvas.call(self, resolve));
            });
        });
    }

    SVGContainer.prototype.hasFabric = function() {
        return !window.html2canvas.svg || !window.html2canvas.svg.fabric ? Promise.reject(new Error("html2canvas.svg.js is not loaded, cannot render svg")) : Promise.resolve();
    };

    SVGContainer.prototype.inlineFormatting = function(src) {
        return (/^data:image\/svg\+xml;base64,/.test(src)) ? this.decode64(this.removeContentType(src)) : this.removeContentType(src);
    };

    SVGContainer.prototype.removeContentType = function(src) {
        return src.replace(/^data:image\/svg\+xml(;base64)?,/,'');
    };

    SVGContainer.prototype.isInline = function(src) {
        return (/^data:image\/svg\+xml/i.test(src));
    };

    SVGContainer.prototype.createCanvas = function(resolve) {
        var self = this;
        return function (objects, options) {
            var canvas = new window.html2canvas.svg.fabric.StaticCanvas('c');
            self.image = canvas.lowerCanvasEl;
            canvas
                .setWidth(options.width)
                .setHeight(options.height)
                .add(window.html2canvas.svg.fabric.util.groupSVGElements(objects, options))
                .renderAll();
            resolve(canvas.lowerCanvasEl);
        };
    };

    SVGContainer.prototype.decode64 = function(str) {
        return (typeof(window.atob) === "function") ? window.atob(str) : decode64(str);
    };

    module.exports = SVGContainer;

},{"./utils":26,"./xhr":28}],24:[function(_dereq_,module,exports){
    var SVGContainer = _dereq_('./svgcontainer');

    function SVGNodeContainer(node, _native) {
        this.src = node;
        this.image = null;
        var self = this;

        this.promise = _native ? new Promise(function(resolve, reject) {
            self.image = new Image();
            self.image.onload = resolve;
            self.image.onerror = reject;
            self.image.src = "data:image/svg+xml," + (new XMLSerializer()).serializeToString(node);
            if (self.image.complete === true) {
                resolve(self.image);
            }
        }) : this.hasFabric().then(function() {
            return new Promise(function(resolve) {
                window.html2canvas.svg.fabric.parseSVGDocument(node, self.createCanvas.call(self, resolve));
            });
        });
    }

    SVGNodeContainer.prototype = Object.create(SVGContainer.prototype);

    module.exports = SVGNodeContainer;

},{"./svgcontainer":23}],25:[function(_dereq_,module,exports){
    var NodeContainer = _dereq_('./nodecontainer');

    function TextContainer(node, parent) {
        NodeContainer.call(this, node, parent);
    }

    TextContainer.prototype = Object.create(NodeContainer.prototype);

    TextContainer.prototype.applyTextTransform = function() {
        this.node.data = this.transform(this.parent.css("textTransform"));
    };

    TextContainer.prototype.transform = function(transform) {
        var text = this.node.data;
        switch(transform){
            case "lowercase":
                return text.toLowerCase();
            case "capitalize":
                return text.replace(/(^|\s|:|-|\(|\))([a-z])/g, capitalize);
            case "uppercase":
                return text.toUpperCase();
            default:
                return text;
        }
    };

    function capitalize(m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
    }

    module.exports = TextContainer;

},{"./nodecontainer":14}],26:[function(_dereq_,module,exports){
    exports.smallImage = function smallImage() {
        return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    };

    exports.bind = function(callback, context) {
        return function() {
            return callback.apply(context, arguments);
        };
    };

    /*
     * base64-arraybuffer
     * https://github.com/niklasvh/base64-arraybuffer
     *
     * Copyright (c) 2012 Niklas von Hertzen
     * Licensed under the MIT license.
     */

    exports.decode64 = function(base64) {
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var len = base64.length, i, encoded1, encoded2, encoded3, encoded4, byte1, byte2, byte3;

        var output = "";

        for (i = 0; i < len; i+=4) {
            encoded1 = chars.indexOf(base64[i]);
            encoded2 = chars.indexOf(base64[i+1]);
            encoded3 = chars.indexOf(base64[i+2]);
            encoded4 = chars.indexOf(base64[i+3]);

            byte1 = (encoded1 << 2) | (encoded2 >> 4);
            byte2 = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            byte3 = ((encoded3 & 3) << 6) | encoded4;
            if (encoded3 === 64) {
                output += String.fromCharCode(byte1);
            } else if (encoded4 === 64 || encoded4 === -1) {
                output += String.fromCharCode(byte1, byte2);
            } else{
                output += String.fromCharCode(byte1, byte2, byte3);
            }
        }

        return output;
    };

    exports.getBounds = function(node) {
        if (node.getBoundingClientRect) {
            var clientRect = node.getBoundingClientRect();
            var width = node.offsetWidth == null ? clientRect.width : node.offsetWidth;
            return {
                top: clientRect.top,
                bottom: clientRect.bottom || (clientRect.top + clientRect.height),
                right: clientRect.left + width,
                left: clientRect.left,
                width:  width,
                height: node.offsetHeight == null ? clientRect.height : node.offsetHeight
            };
        }
        return {};
    };

    exports.offsetBounds = function(node) {
        var parent = node.offsetParent ? exports.offsetBounds(node.offsetParent) : {top: 0, left: 0};

        return {
            top: node.offsetTop + parent.top,
            bottom: node.offsetTop + node.offsetHeight + parent.top,
            right: node.offsetLeft + parent.left + node.offsetWidth,
            left: node.offsetLeft + parent.left,
            width: node.offsetWidth,
            height: node.offsetHeight
        };
    };

    exports.parseBackgrounds = function(backgroundImage) {
        var whitespace = ' \r\n\t',
            method, definition, prefix, prefix_i, block, results = [],
            mode = 0, numParen = 0, quote, args;
        var appendResult = function() {
            if(method) {
                if (definition.substr(0, 1) === '"') {
                    definition = definition.substr(1, definition.length - 2);
                }
                if (definition) {
                    args.push(definition);
                }
                if (method.substr(0, 1) === '-' && (prefix_i = method.indexOf('-', 1 ) + 1) > 0) {
                    prefix = method.substr(0, prefix_i);
                    method = method.substr(prefix_i);
                }
                results.push({
                    prefix: prefix,
                    method: method.toLowerCase(),
                    value: block,
                    args: args,
                    image: null
                });
            }
            args = [];
            method = prefix = definition = block = '';
        };
        args = [];
        method = prefix = definition = block = '';
        backgroundImage.split("").forEach(function(c) {
            if (mode === 0 && whitespace.indexOf(c) > -1) {
                return;
            }
            switch(c) {
                case '"':
                    if(!quote) {
                        quote = c;
                    } else if(quote === c) {
                        quote = null;
                    }
                    break;
                case '(':
                    if(quote) {
                        break;
                    } else if(mode === 0) {
                        mode = 1;
                        block += c;
                        return;
                    } else {
                        numParen++;
                    }
                    break;
                case ')':
                    if (quote) {
                        break;
                    } else if(mode === 1) {
                        if(numParen === 0) {
                            mode = 0;
                            block += c;
                            appendResult();
                            return;
                        } else {
                            numParen--;
                        }
                    }
                    break;

                case ',':
                    if (quote) {
                        break;
                    } else if(mode === 0) {
                        appendResult();
                        return;
                    } else if (mode === 1) {
                        if (numParen === 0 && !method.match(/^url$/i)) {
                            args.push(definition);
                            definition = '';
                            block += c;
                            return;
                        }
                    }
                    break;
            }

            block += c;
            if (mode === 0) {
                method += c;
            } else {
                definition += c;
            }
        });

        appendResult();
        return results;
    };

},{}],27:[function(_dereq_,module,exports){
    var GradientContainer = _dereq_('./gradientcontainer');

    function WebkitGradientContainer(imageData) {
        GradientContainer.apply(this, arguments);
        this.type = imageData.args[0] === "linear" ? GradientContainer.TYPES.LINEAR : GradientContainer.TYPES.RADIAL;
    }

    WebkitGradientContainer.prototype = Object.create(GradientContainer.prototype);

    module.exports = WebkitGradientContainer;

},{"./gradientcontainer":9}],28:[function(_dereq_,module,exports){
    function XHR(url) {
        return new Promise(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url);

            xhr.onload = function() {
                if (xhr.status === 200) {
                    resolve(xhr.responseText);
                } else {
                    reject(new Error(xhr.statusText));
                }
            };

            xhr.onerror = function() {
                reject(new Error("Network Error"));
            };

            xhr.send();
        });
    }

    module.exports = XHR;

},{}]},{},[4])(4)
});
(function(){

    'use strict';




    var inputFields = {
        TextOnly:{
            pattern:'/^[a-zA-Z .]*$/',
            errorValidation:{
                pattern:'Can not contain digits.'
            }
        },
        ContactNumber:{
            pattern:'/^([0-9\(\)\/\+ \-]*)$/',
            errorValidation:{
                required:'Contact Number is invalid.'
            }
        },
        PrimaryContact:{
            errorValidation:{
                required:'Primary Contact Number not provided.'
            }
        },
        SecondaryContact:{
            errorValidation:{
                required:'Secondary Contact Number not provided.'
            }
        },
        Email:{
            placeholder:'Enter Email',
            pattern:'/^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i',
            errorValidations:{
                required:'Email not provided.'
            }
        },
        FirstName:{
            placeholder:'Enter First Name',
            errorValidations:{
                required:'First Name not provided.'
            }
        },
        LastName:{
            placeholder:'Enter Last Name',
            errorValidations:{
                required:'Last Name not provided.'
            }
        },
        Designation:{
            placeholder:'Enter Designation',
            errorValidations:{
                required: 'Designation not provided.'
            }
        },
        OldPassword:{
            placeholder:'******',
            errorValidations:{
                required: 'Old Password not provided.'
            }
        },
        NewPassword:{
            placeholder:'******',
            minLength:8,
            maxLength:32,
            errorValidations:{
                required: 'New Password not provided.',
                pattern:'Password should be at least 8 characters and must contain letters, a number & a special character.',
                maxLength: 'Password should be less than 32 characters',
                minLength: 'Password should be less than '
            }
        },
        ConfirmPassword:{
            placeholder:'******',
            errorValidations:{
                required: 'Re-type given password.',
                validator: 'Passwords do not match.'
            }
        }


    };

    angular
        .module('app.core')
        .constant('inputFields', inputFields)

}());

/**
 * @ngdoc overview
 * @name app.core
 * @description Configuration block for restangular
 */

(function(){

  'use strict';

  angular.module('app.core')
    .config(configuration);

  /* @ngInject */
  function configuration(RestangularProvider){
    RestangularProvider.setBaseUrl('/api');
    RestangularProvider.setRequestSuffix('/');
  }

}());

/**
 * @ngdoc overview
 * @name app.core
 * @description Configuration block for routing
 */

(function(){

    'use strict';

    angular.module('app.core')
        .config(configuration)
        .run(routingEvents);

    /* @ngInject */
    function configuration($urlRouterProvider){
        $urlRouterProvider.otherwise('/login');
    }

    /* @ngInject */
    function routingEvents($rootScope, $uibModalStack){
        //on routing error
        $rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams){
            //do some logging and toasting
        });

        //on routing error
        $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
            $uibModalStack.dismissAll();
            //do some title setting
            $rootScope.pageTitle = toState.title || 'Doni Enterprises';
            $rootScope.bgBackgroundClass = toState.bgBackgroundClass || '';
            if(toState.pageHeader){
                if(toState.pageHeader.title){
                    $rootScope.headerTitle = toState.pageHeader.title;
                }
                if(toState.pageHeader.subTitle){
                    $rootScope.headerSubTitle = toState.pageHeader.subTitle;
                }
                $rootScope.headerAnchor = (toState.pageHeader.headerAnchor) ? toState.pageHeader.headerAnchor : [];
                $rootScope.goBack = toState.pageHeader.goBack || false;
            }
            else{
                $rootScope.headerAnchor = [];
                $rootScope.goBack = false;
            }
            fromState.wentTo = toState.name;
            toState.params = toParams;
            if(toState.wentTo !== fromState.name){

                toState.prevState = fromState.name;
                toState.prevParam = fromParams;
            }
        });
    }

}());

(function () {

    'use strict';

    angular.module('app.core')
        .config(selectizeDecorator);


    function selectizeDecorator($provide){
        $provide.decorator('selectizeDirective', function($delegate, selectizeConfig) {
            var directive = $delegate[0];

            var link = myLinkFnOverride;

            function myLinkFnOverride(scope, element, attrs, modelCtrl) {
                var selectize,
                    settings = angular.extend({}, Selectize.defaults, selectizeConfig, scope.config);

                scope.options = scope.options || [];
                scope.config = scope.config || {};

                var toggle = function(disabled) {
                    disabled ? selectize.disable() : selectize.enable();
                };

                var isEmpty = function (val) {
                    return (val === undefined) || (val === null) || ((val.constructor === Array) && !val.length); //support checking empty arrays
                };

                var validate = function validate() {
                    var isInvalid = (scope.ngRequired() || attrs.required || settings.required) && !isEmpty(scope.ngModel);
                    modelCtrl.$setValidity('required', isInvalid);
                };

                var setSelectizeOptions = function(curr, prev) {
                    angular.forEach(prev, function(opt){
                        if(curr.indexOf(opt) === -1){
                            var value = opt[settings.valueField];
                            selectize.removeOption(value, true);
                        }
                    });

                    selectize.addOption(curr, true);

                    setSelectizeValue();
                }

                var setSelectizeValue = function() {
                    validate();

                    selectize.$control.toggleClass('ng-valid', modelCtrl.$valid);
                    selectize.$control.toggleClass('ng-invalid', modelCtrl.$invalid);
                    selectize.$control.toggleClass('ng-dirty', modelCtrl.$dirty);
                    selectize.$control.toggleClass('ng-pristine', modelCtrl.$pristine);

                    if (!angular.equals(selectize.items, scope.ngModel)) {
                        selectize.setValue(scope.ngModel, true);
                    }
                }

                settings.onChange = function(value) {
                    var value = angular.copy(selectize.items);
                    if (settings.maxItems == 1) {
                        value = value[0]
                    }
                    modelCtrl.$setViewValue( value );

                    if (scope.config.onChange) {
                        scope.config.onChange.apply(this, arguments);
                    }
                };

                settings.onOptionAdd = function(value, data) {
                    if( scope.options.indexOf(data) === -1 ) {
                        scope.options.push(data);

                        if (scope.config.onOptionAdd) {
                            scope.config.onOptionAdd.apply(this, arguments);
                        }
                    }
                };

                settings.onInitialize = function() {
                    selectize = element[0].selectize;

                    setSelectizeOptions(scope.options);

                    //provides a way to access the selectize element from an
                    //angular controller
                    if (scope.config.onInitialize) {
                        scope.config.onInitialize(selectize);
                    }

                    scope.$watchCollection('options', setSelectizeOptions);
                    scope.$watch('ngModel', setSelectizeValue);
                    scope.$watch('ngDisabled', toggle);
                };

                element.selectize(settings);

                element.on('$destroy', function() {
                    if (selectize) {
                        selectize.destroy();
                        element = null;
                    }
                });
            }

            directive.compile = function() {
                return function(scope, element, attrs) {
                    link.apply(this, arguments);
                };
            };

            return $delegate;
        });
    }

}());
/**
 * @ngdoc service
 * @name app.common.navigation
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.common')
        .factory('utilities', utilities);

    /* @ngInject */
    function utilities($state, toastr, moment, appFormats, $filter, crud){
        var months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul','Aug','Sep','Oct', 'Nov', 'Dec'
        ];

        var colors = [
            "#f47414", "#1691AC", "#A53860", "#4C3B4D",
            "#ADA8B6", "#36C4BB", "#7EAAAF", "#A5C5C9", "#B4E6ED", "#E88D67",
            "#BAA298", "#C1A397", "#DD977A", "#E5CABE", "#424B54", "#79ACE0",
            "#B2CEEA", "#AEB9C4"
        ];

        return {
            chartColors: chartColors,
            getCurrentUser: getCurrentUser,
            getTime: getTime,
            internalServerError: internalServerError,
            successMessage: successMessage,
            initialDateRange: initialDateRange,
            todayDateRange: todayDateRange,
            getDateRangeArray: getDateRangeArray,
            getYearsInDateRange: getYearsInDateRange,
            getMonthsInDateRange: getMonthsInDateRange,
            getWeeksInDateRange: getWeeksInDateRange,
            getMonthTitle: getMonthTitle,
            getWeekTitle: getWeekTitle,
            filterDate: filterDate,
            lastThirtyDaysDateRange: lastThirtyDaysDateRange,
            resetFormValidation: resetFormValidation,
            colors: colors,
            dashboardDateRange: dashboardDateRange,
            getChildStates: getChildStates,
            getStatesForAccordian: getStatesForAccordian,
            setupCRUD: setupCRUD,
            cloneIntoEmptyObject: cloneIntoEmptyObject,
            cloneObjectInToObject: cloneObjectInToObject,
            convertMomentDateRange: convertMomentDateRange,
            goBackState: goBackState,
            prepareGraphData: prepareGraphData,
            manageTextOverFlow: manageTextOverFlow,
            evalMathExpressionInString: evalMathExpressionInString,

            sortTableBySortType: sortTableBySortType,
            stripHtml: stripHtml
        };

        function stripHtml(html){
            // Create a new div element
            var temporalDivElement = document.createElement("div");
            // Set the HTML content with the providen
            temporalDivElement.innerHTML = html;
            // Retrieve the text property of the element (cross-browser support)
            return temporalDivElement.textContent || temporalDivElement.innerText || "";
        }

        function evalMathExpressionInString(str){
            var expression = str.replace(/[^0-9.*+-]/g, "")
            return eval(expression)
        }

        function sortTableBySortType(tableData, type, reverse){
            var digitInString = ['fileNo'];
            var filter_type = (_.indexOf(digitInString,type) > -1) ? 'digitInString': 'orderBy';
            return $filter(filter_type)(tableData, type, reverse);
        }

        function manageTextOverFlow(string, size){
            if (string.length > size)
                return string.substring(0,size)+'...';
            else
                return string;
        }

        function prepareGraphData(graphData){
            _.forEach(graphData, function(value, key){
                value['date'] = new Date(value['date']);
            });
            return $filter('orderBy')(graphData, 'date')
        }

        function goBackState(){
            if($state.current.prevState){
                $state.go($state.current.prevState,$state.current.prevParam);
            }
            else{
                try{
                    $state.go('^');
                }
                catch(err){
                    $state.go('dashboard.main');
                }

            }
        };

        function cloneObjectInToObject(clone, sample){
            for(var key in clone){
                delete clone[key]
            }
            for(var key in sample){
                clone[key] = sample[key]
            }
            return clone;
        }

        function cloneIntoEmptyObject(emptyObj, sample){
            if(sample instanceof Array){
                emptyObj['list'] = sample;
            }
            else{
                for(var key in sample)
                    emptyObj[key] = sample[key];
            }
            return emptyObj;
        }

        function setupCRUD(create, read, update, del){
            var crudObj = {};
            crudObj[crud.CREATE] = create;
            crudObj[crud.UPDATE] = update;
            crudObj[crud.DELETE] = del;
            crudObj[crud.READ] = read;
            return crudObj;
        }

        function getCurrentUser(){
            return currentUser;
        }

        function getTime(){
            return (new Date()).getTime();
        }

        function filterDate(datetime){
            return $filter('date')(datetime, appFormats.Date);
        }

        function getChildStates(state){
            var routeName=state.name;
            var secondRouteOnlyRegex = new RegExp(routeName + "\.[a-z]+$", "i");
            var states = $state.get();
            var navLinks = _.filter(states, function(state){
                return secondRouteOnlyRegex.test(state.name) && !state.abstract;
            });
            return navLinks;
        }

        function getStatesForAccordian(state){
            var allStates = getChildStates(state);
            _.filter(allStates, function(state){
                if(state.hasAccordianDropDown){
                    state.children = getChildStates(state);
                }
            });
            return allStates
        }





        function chartColors(){
            return this.colors;
        }

        function internalServerError(data,text){
            toastr.error(data,text);
        }

        function todayDateRange(){
            var datePicker = {};
            datePicker.startDate = moment().startOf('day');
            datePicker.endDate = moment().endOf('day');
            return datePicker;
        }

        function lastThirtyDaysDateRange(){
            var datePicker = {};
            datePicker.startDate = moment().subtract(30,'days').startOf('day');
            datePicker.endDate = moment().endOf('day');
            return datePicker;
        }

        function initialDateRange(days){
            days = (days) ? days : 14;
            var datePicker = {};
            datePicker.startDate = moment().subtract(days,'days').startOf('day');
            datePicker.endDate = moment().endOf('day');
            return datePicker;
        }

        function dashboardDateRange(){
            var datePicker = {};
            datePicker.startDate = moment().subtract(30,'days').startOf('day');
            datePicker.endDate = moment().add(14,'days').endOf('day');
            return datePicker;
        }


        function successMessage(msg,title){
            toastr.success(msg,title);
        }

        function getYearsInDateRange(startDate,endDate){
            var currentYear = parseInt(new Date(startDate).getFullYear());
            var endYear = parseInt(new Date(endDate).getFullYear());
            var years = [];
            while(currentYear <= endYear){
                years.push(currentYear);
                currentYear++;
            }
            return years;
        }

        function getMonthTitle(date){
            return months[date.getMonth()]+', '+date.getFullYear();
        }

        function getWeeksInDateRange(startDate,endDate){
            var sDate = new Date(startDate);
            var eDate = new Date(endDate);
            sDate = new Date( sDate.getFullYear()+'-'+ (sDate.getMonth()+1)+'-'+sDate.getDate());
            eDate = new Date( eDate.getFullYear()+'-'+(eDate.getMonth()+1)+'-'+eDate.getDate());
            var weekList = [];
            while(sDate<eDate){
                var temp = new Date(sDate);
                weekList.push(temp);
                var dayToAdd = (sDate.getDay() === 0) ? 7 : sDate.getDay()+1;
                sDate.setDate(sDate.getDate()+dayToAdd);
            }
            weekList.push(eDate);
            return weekList;

        }

        function getWeekTitle(weekStart, weekEnd){
            return  weekStart.getDate()+' '+months[weekStart.getMonth()]+', '+weekStart.getFullYear() + ' - '+ weekEnd.getDate()+' '+months[weekEnd.getMonth()]+', '+weekEnd.getFullYear();
        }



        function getMonthsInDateRange(startDate,endDate){
            var sDate = new Date(startDate);
            var eDate = new Date(endDate);
            sDate = new Date( sDate.getFullYear()+'-'+ (sDate.getMonth()+1));
            eDate = new Date( eDate.getFullYear()+'-'+(eDate.getMonth()+1));
            var monthList = [];
            if(sDate.toString() === eDate.toString()){
                var temp = new Date(sDate);
                monthList.push(temp);
                eDate = new Date(sDate.setMonth(sDate.getMonth()+1));
                monthList.push(eDate);
            }
            else{
                while(sDate<=eDate){
                    var temp = new Date(sDate);
                    monthList.push(temp);
                    sDate = new Date(sDate.setMonth(sDate.getMonth()+1));
                }
                sDate = new Date(sDate.setMonth(sDate.getMonth()+1));
                monthList.push(sDate);
            }
            return monthList;
        }

        function getDateRangeArray(startDate, endDate){
            var dateArray = new Array();
            var currentDate = new Date(startDate);
            endDate = new Date (endDate);
            while (currentDate <= endDate) {
                dateArray.push(currentDate);
                currentDate = currentDate.addDays(1);
            }
            return dateArray;
        }

        function convertMomentDateRange(dateRange){
            var range = angular.copy(dateRange);
            range.startDate = range.startDate._d;
            range.endDate = range.endDate._d;
            return range;
        }

        function resetFormValidation(formObj){
            for (var att in formObj.$error) {
                if (formObj.$error.hasOwnProperty(att)) {
                    formObj.$setValidity(att, true);
                }
            }
            formObj.$setSubmitted(false);
            formObj.$setPristine(true);
        }
    }

}());

(function() {

    'use strict';

    angular
        .module('app.dashboard')
        .factory('dashboard', dashboard);

    /* @ngInject */
    function dashboard(Restangular, apiEndPoints, utilities) {

        var dashboardAPI = Restangular.all(apiEndPoints.dashboard.main);
        var notificationAPI = Restangular.all(apiEndPoints.notification.main);

        return {
            getCompleteDashboardReport: getCompleteDashboardReport,
            refreshCurrentDollarRate: refreshCurrentDollarRate,
            searchQueryPageTop: searchQueryPageTop,
            getNotificationCount: getNotificationCount,
            getUnReadNotificationList: getUnReadNotificationList
        };

        function getNotificationCount(){
            return notificationAPI.customGET(apiEndPoints.notification.unreadCount);
        }

        function getUnReadNotificationList(markRead){
            return notificationAPI.customGET(apiEndPoints.notification.unreadList, {
                mark_as_read: markRead
            });
        }

        function getCompleteDashboardReport(){
            return dashboardAPI.customGET('',{

            });
        }

        function searchQueryPageTop(queryObj){
            return dashboardAPI.customGET(apiEndPoints.dashboard.searchPageTop, queryObj);
        }

        function refreshCurrentDollarRate(){

        }
    }

})();
/**
 * @ngdoc service
 * @name app.modal.alertModalFactory
 * @description < description placeholder >
 */

(function(){

  'use strict';

	angular
		.module('app.modal')
		.factory('modalFactory', modalFactory);

  /* @ngInject */
  function modalFactory($uibModal){
		return {
            alertModal: alertModal,
            changePassword: changePassword
		};

		////////////////////

    /**
     * @ngdoc
     * @name app.modal.alertModalFactory#testFunction
     * @methodOf app.modal.alertModalFactory
     *
     * @description < description placeholder >
     * @example
     * <pre>
     * alertModalFactory.testFunction(id);
     * </pre>
     * @param {int} entity id
     */

        function changePassword(userId){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'src/setup/changePassword/changePassword.template.html',
                controller: 'ChangePasswordModal as vm',
                size: 'md',
                windowClass: 'marginTopPlus150px',
                resolve:{
                    userId: function(){
                        return userId;
                    }
                }

            });
        }

		function alertModal(name, type, action){
            var modalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: 'app/modal/alertmodal.template.html',
                    controller: function ($uibModalInstance, name, type, action){
                        var vm = this;
                        vm.confirm = false;
                        vm.name = name;
                        vm.type = type;
                        vm.action = action;
                        vm.testFunction = testFunction;

                        /////////////////////

                        /**
                         * @ngdoc method
                         * @name testFunction
                         * @param {number} num number is the number of the number
                         * @methodOf app.modal.controller:AlertModal
                         * @description
                         * My Description rules
                         */
                        vm.ok = function () {
                            vm.confirm = true;
                            $uibModalInstance.close(vm.confirm);
                        };

                        vm.cancel = function () {
                            vm.confirm = false;
                            $uibModalInstance.close(vm.confirm);
                        };

                        function testFunction(num){
                            console.info('This is a test function');
                        }
                    },
                    size: 'sm',
                    windowClass: 'marginTopPlus150px',
                    resolve: {
                        name: function () {
                            return name;
                        },
                        type: function(){
                            return type
                        },
                        action: function(){
                           return action
                        }

                    }
                });
            return modalInstance.result.then(function (confirm) {
                return confirm;
            }, function () {
                //$log.info('Modal dismissed at: ' + new Date());
            });

        }

	}

}());

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
  }


})();

(function () {
    'use strict';

    angular.module('app.dashboard.modals')
        .factory('loaderModal', loaderModal);


    /** @ngInject */
    function loaderModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/modals/modalTemplates/loaderModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    // throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    // throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
(function(){

    'use strict';
    var modalTemplates = {
        CR_UP_BASIC_DROP_DOWN: 'app/modals/modalTemplates/basicDropDown.html',
        IMAGE_CROP_WINDOW: 'app/modals/modalTemplates/imageCropper.html',
        PRODUCT_SPECS: 'app/dashboard/tradeBook/transaction/templates/productSpecs.html',
        WRAPPER: 'app/modals/modalTemplates/basicWrapper.html',
        TRADE_COMMISSION_FLOW: 'app/modals/modalTemplates/transactionCashFlow.html',
        TRADE_COMPLETION: 'app/modals/modalTemplates/transactionComplete.html',
        LOCAL_PAYMENT: 'app/modals/modalTemplates/localPayment.html'
    };

    angular
        .module('app.dashboard.modals')
        .constant('modalTemplates', modalTemplates);

}());

/**
 * @ngdoc service
 * @name app.modal.alertModalFactory
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.modals')
        .factory('deModal', deModal);

    /* @ngInject */
    function deModal($uibModal, modalTemplates, fileReader, tradeBook){
        return {
            openProgressModal: openProgressModal,
            openModal: openModal,
            dismissModal: dismissModal,
            openImageCropper: openImageCropper,
            getFile: getFile,
            openProductSpecificationModal: openProductSpecificationModal,
            openTransactionCashFlowModal: openTransactionCashFlowModal,
            openTransactionCompleteModel: openTransactionCompleteModel,
            openLocalTransactionPaymentModal: openLocalTransactionPaymentModal
        };


        ////////////////////




        function openLocalTransactionPaymentModal(fileId){
            var modalInstance = $uibModal.open({
                animation:true,
                templateUrl: modalTemplates.LOCAL_PAYMENT,
                controller: function($scope, fileId, authentication){
                    $scope.userData = authentication.getUserData();
                    $scope.currency = $scope.userData.data.currency;
                },
                size: 'sm',
                backdrop: 'static',
                resolve:{
                    fileId: function(){
                        return fileId
                    }
                }
            });
        }

        function openTransactionCashFlowModal(fileId){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: modalTemplates.TRADE_COMMISSION_FLOW,
                controller: function($scope, tradeCashFlowData, $uibModalInstance){
                    $scope.tradeCashFlowData = tradeCashFlowData;
                    $scope.tradeSum  = _.sumBy(tradeCashFlowData.cashFlow, function(flow) {
                        return (flow.active) ? flow.amount : 0.00;
                    });
                    $scope.saveSpecs = function(){
                        $uibModalInstance.close();
                    };
                },
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    tradeCashFlowData: function(tradeBook){
                        return tradeBook.getCommissionCashFlow(fileId).then(function(res){
                            return res.data
                        });
                    }
                }
            });

        }


        function openTransactionCompleteModel(completeObj, transactionId, callback){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: modalTemplates.TRADE_COMPLETION,
                controller: function($scope, $uibModalInstance, completeObj){
                    $scope.completeObj = completeObj ? completeObj : {'complete': true};
                    $scope.changeCompletion = function(completeObj){
                        $uibModalInstance.close(completeObj);
                    };
                },
                size: 'md',
                backdrop: 'static',
                resolve: {
                    completeObj: function(){
                        return completeObj;
                    }
                }


            });

            modalInstance.result.then(function(completeObj){
                callback(completeObj);
            });
        }


        function openProductSpecificationModal(defaultSpecs, callback){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: modalTemplates.PRODUCT_SPECS,
                controller: function($scope, productSpecs, $uibModalInstance){
                    $scope.productSpecs = productSpecs;
                    $scope.saveSpecs = function(productSpecs){
                        $uibModalInstance.close({
                            'productSpecs': productSpecs
                        });
                    };
                },
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    productSpecs: function(){
                        return defaultSpecs;
                    }
                }


            });

            modalInstance.result.then(function(productSpecs){
                callback(productSpecs.productSpecs);
            });
        }

        function openProgressModal(){

        }


        function getFile(picture, scope, aspectRatio, sizeArray, resultSize, callBack){
            fileReader.readAsDataUrl(picture, scope)
                .then(function (result) {
                    openImageCropper(result, aspectRatio, sizeArray, resultSize, callBack);
                });
        }

        function dismissModal(modalInstance){
            modalInstance.dismiss('cancel');
        }

        function openModal(page, size, controller, resolve) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                controller: controller,
                size: size,
                backdrop: 'static',
                resolve: resolve
            });

        }

        function openImageCropper(image, aspectRatio, imageSizes, cropSize, callback){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: modalTemplates.IMAGE_CROP_WINDOW,
                controller: function($scope, image, aspectRatio, $uibModalInstance){
                    if(aspectRatio){
                        $scope.aspectRatio = aspectRatio;
                    }
                    if(cropSize){
                        $scope.cropper = {
                            w: cropSize.width,
                            h: cropSize.height
                        };
                    }
                    if(imageSizes){
                        $scope.resultImageSizes=imageSizes[0];
                    }

                    $scope.croppedImages = [];
                    $scope.croppedImage = '';
                    $scope.image = image;

                    $scope.saveImage = function () {
                        console.log($scope.croppedImages, $scope.blob);
                        $uibModalInstance.close({
                            'croppedImages':$scope.croppedImages,
                            'resultBlob': $scope.blob,
                            'croppedImage': $scope.croppedImage
                        });
                    };

                },
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    image: function(){
                        return image
                    },
                    aspectRatio: function(){
                        return aspectRatio
                    }
                }
            });

            modalInstance.result.then(function(images){
                callback(images);
            });
        }

    }

}());

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    angular.module('app.theme')
        .config(config);

    /** @ngInject */
    function config(baConfigProvider, colorHelper) {
        baConfigProvider.changeTheme({blur: true});

        baConfigProvider.changeColors({
            default: '#4e4e55',
            defaultText: '#e2e2e2',
        });
    }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#009688',
    info: '#FF5733',
    success: '#4392aa',
    warning: '#C70039',
    danger: '#6A6A6A',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('app.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('app.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        // whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('app.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function() {

    'use strict';

    angular
        .module('app.dashboard.accounts')
        .factory('accounts', accounts);

    /* @ngInject */
    function accounts(Restangular, apiEndPoints, utilities) {

        var accountsAPI = Restangular.all(apiEndPoints.accounts.main);

        return {
            getDashboardData: getDashboardData,
            getInvoiceObj: getInvoiceObj,
            createInvoice: createInvoice,
            updateInvoice: updateInvoice
        };

        function updateInvoice(fileId, invoiceObj, callback){
            accountsAPI.customPUT({
                'fileId':fileId,
                'invoiceObj': invoiceObj
            }, apiEndPoints.accounts.invoice).then(function(res){
                callback(res)
            });
        }

        function createInvoice(fileId, invoiceObj, callback){
            accountsAPI.customPOST({
                'fileId':fileId,
                'invoiceObj': invoiceObj
            }, apiEndPoints.accounts.invoice).then(function(res){
                callback(res);
            });

        }

        function getDashboardData(){

        }

        function getInvoiceObj(fileId, invoiceId){
            return accountsAPI.customGET(apiEndPoints.accounts.invoice, {
                'fileId': fileId,
                'invoiceId': invoiceId
            })
        }


    }


})();
/**
 * @ngdoc service
 * @name app.businessPartner.businessPartner
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.businessPartner')
        .factory('businessPartner', businessPartner);

    /* @ngInject */
    function businessPartner(Restangular, apiEndPoints, modalFactory){

        var businessPartner = {};
        var businessPartnerListIndex = { index: 'A'};
        var bpAPI = Restangular.all(apiEndPoints.bp.main);

        return {
            getBusinessPartnerListIndex: getBusinessPartnerListIndex,
            setBusinessPartnerListIndex: setBusinessPartnerListIndex,
            addBusinessBasic: addBusinessBasic,
            deleteBusinessPartner: deleteBusinessPartner,
            updateBusinessBasic: updateBusinessBasic,
            deleteBusiness: deleteBusiness,
            saveBusinessLocations: saveBusinessLocations,
            saveBusinessContactPersons: saveBusinessContactPersons,
            saveBusinessContacts: saveBusinessContacts,
            saveBusinessBanks: saveBusinessBanks,


            setBusinessPartner: setBusinessPartner,
            addBPContactPerson: addBPContactPerson,
            addNewBankAccount: addNewBankAccount,
            addBusinessPartnerContact: addBusinessPartnerContact,
            addBusinessPartnerProduct: addBusinessPartnerProduct,
            editBPContactPerson: editBPContactPerson,
            editBankAccount: editBankAccount,

            getBusinessPartner: getBusinessPartner,
            getBusinessPartnerList: getBusinessPartnerList,
            getBusinessComplete: getBusinessComplete,
            getBusinessPartnerLocation: getBusinessPartnerLocation,


            deleteBusinessPartnerContact: deleteBusinessPartnerContact,
            deleteBusinessPartnerBankDetail: deleteBusinessPartnerBankDetail,
            deleteBusinessPartnerContactNumber: deleteBusinessPartnerContactNumber,

            getNewBusinessObj: getNewBusinessObj,
            getNewBusinessBankObj: getNewBusinessBankObj,
            getNewBusinessAddressObj: getNewBusinessAddressObj,
            getNewBusinessContactObj: getNewBusinessContactObj,
            getNewBusinessContactPersonObj: getNewBusinessContactPersonObj,

            saveBusinessSettings: saveBusinessSettings,
            getBusinessSettings: getBusinessSettings,
            getBusinessReport: getBusinessReport


        };

        function getBusinessReport(businessId){
            console.log(businessId);
            return bpAPI.one(apiEndPoints.bp.report, businessId).customGET();
        }

        function getBusinessPartnerListIndex(){
            return businessPartnerListIndex.index;
        }

        function setBusinessPartnerListIndex(index){
            return businessPartnerListIndex.index = index
        }



        function getBusinessSettings(){
            return bpAPI.customGET(apiEndPoints.bp.self)
        }

        function saveBusinessSettings(obj){
            return bpAPI.customPOST(obj, apiEndPoints.bp.self)
        }

        // Business Location

        function saveBusinessLocations(businessId, locations){
            return bpAPI.customPOST({
                'locations': locations,
                'bpId': businessId
            }, apiEndPoints.bp.location);
        }

        // Business Contact Person

        function saveBusinessContactPersons(businessId, contactPersons){
            return bpAPI.customPOST({
               'contactPersons': contactPersons,
                'bpId': businessId
            }, apiEndPoints.bp.contactPerson);
        }

        // Business Contacts

        function saveBusinessContacts(businessId, contacts){
            return bpAPI.customPOST({
                'contacts': contacts,
                'bpId': businessId
            }, apiEndPoints.bp.contactNumber);
        }

        // Business Banks

        function saveBusinessBanks(businessId, banks){
            return bpAPI.customPOST({
                'banks': banks,
                'bpId': businessId
            }, apiEndPoints.bp.bank);
        }


        // Business Basic

        function getNewBusinessAddressObj(business){

            return {
                'address': '',
                'city': '',
                'state': '',
                'country': '',
                'isPrimary': (business.locations.length === 0)
            }
        }

        function getNewBusinessObj(){
            var businessObj = {
                'name': '',
                'website': '',
                'databaseId': '',
                'ntn': '',
                'bpType': [],
                'banks': [],
                'locations': [],
                'contacts': [],
                'contactPersons': []
            };
            businessObj.banks.push(getNewBusinessBankObj());
            businessObj.locations.push(getNewBusinessAddressObj(businessObj));
            businessObj.contacts.push(getNewBusinessContactObj());
            businessObj.contactPersons.push(getNewBusinessContactPersonObj());
            return businessObj;
        }

        function getNewBusinessBankObj(){
            return {
                'accountTitle': '',
                'accountNumber': '',
                'accountCountry': '',
                'accountCity': '',
                'accountAddress': '',
                'bankName': ''
            }
        }

        function getNewBusinessContactObj(){
            return {
                'contactNumber': '',
                'contactType': ''
            }
        }

        function getNewBusinessContactPersonObj(){
            return {
                'isPrimary': false,
                'fullName': '',
                'designation': '',
                'email': null,
                'primaryNumber': '',
                'secondaryNumber': ''
            }
        }

        ////////////////////

        /**
         * @ngdoc
         * @name app.businessPartner.businessPartner#testFunction
         * @methodOf app.businessPartner.businessPartner
         *
         * @description < description placeholder >
         * @example
         * <pre>
         * businessPartner.testFunction(id);
         * </pre>
         * @param {int} entity id
         */
        function setBusinessPartner(bp){
            businessPartner = bp;
        }

        function getBusinessPartner(){
            return businessPartner;
        }



        function deleteBusinessPartnerContact(bpName, contactName, id, callback){
            modalFactory.alertModal(bpName,'Contact Person ' + contactName + 'Contact Person of Business Partner', 'Delete').then(function(res){
                if(res){
                    bpAPI.remove({'contact_id':id}).then(callback);
                }
            });
        }

        function deleteBusinessPartnerBankDetail(bpName, accountTitle, accountNumber, id, callback){
            modalFactory.alertModal(bpName,'Bank Account ' + accountNumber + ' of title ' +accountTitle + ' of Business Partner ' , 'Delete').then(function(res){
                if(res){
                    bpAPI.remove({'bank_id':id}).then(callback);
                }
            });
        }

        function deleteBusinessPartnerContactNumber(bpName, contactNumber, contactType, id, callback){
            modalFactory.alertModal(bpName, contactType + ' Number ' + contactNumber + ' of Business Partner' , 'Delete').then(function(res){
                if(res){
                    bpAPI.remove({'cont_num_id':id}).then(callback);
                }
            });
        }

        function addNewBankAccount(bankDetails){
            return bpAPI.customPOST({bankDetails: bankDetails});
        }

        function editBankAccount(bankDetails){
            return bpAPI.customPUT({bankDetails: bankDetails})
        }

        function addBusinessPartnerContact(contact){
            return bpAPI.customPOST({contact: contact});
        }

        function addBPContactPerson(contactPerson){
            return bpAPI.customPOST({contactPerson: contactPerson});
        }

        function editBPContactPerson(contactPerson){
            return bpAPI.customPUT({contactPerson: contactPerson});
        }


        function addBusinessPartnerProduct(bpProduct)
        {
            return bpAPI.customPOST({bpProduct: bpProduct});
        }

        function deleteBusinessPartnerProduct(bpProduct)
        {
            return bpAPI.customPUT({bpProduct: bpProduct});
        }


        // Business Partner Basic

        function getBusinessComplete(id){
            return bpAPI.customGET(apiEndPoints.bp.basic, {'bpId': id});
        }


        function deleteBusinessPartner(businessId){
            return bpAPI.customDELETE(apiEndPoints.bp.basic+'/'+businessId)
        }

        function addBusinessBasic(imagesData, business){
            var body = new FormData();
            if(imagesData){
                var file = new File([imagesData.resultBlob], "logo.png");
                body.append('logo', file);
            }
            body.append('data', JSON.stringify({
                'name': business.name,
                'website': business.website,
                'ntn': business.ntn,
                'bpType': business.bpType,
                'databaseId': business.databaseId
            }));

            return bpAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPOST(
                body,
                apiEndPoints.bp.basic,
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function updateBusinessBasic(imagesData, business){
            var body = new FormData();
            if(imagesData){
                var file = new File([imagesData.resultBlob], "logo.png");
                body.append('logo', file);
            }
            body.append('data', JSON.stringify({
                'bpId': business.bpId,
                'name': business.name,
                'website': business.website,
                'ntn': business.ntn,
                'bpType': business.bpType,
                'databaseId': business.databaseId
            }));

            return bpAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPUT(
                body,
                apiEndPoints.bp.basic,
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function deleteBusiness(name, id ,callback){
            modalFactory.alertModal(name,'Business Partner', 'Delete').then(function(res){
                if(res){
                    bpAPI.remove({'bp_id':id}, apiEndPoints.bp.basic).then(callback);
                }
            });
        }

        function getBusinessPartnerList(alpha){
            return bpAPI.customGET(apiEndPoints.bp.list, {
                'alpha': alpha
            });
        }

        function getBusinessPartnerLocation(query){
            return bpAPI.customGET(apiEndPoints.bp.location,{'q':query})
        }

    }

}());

(function() {

    'use strict';

    angular
        .module('app.dashboard.currencyExchange')
        .factory('currencyExchange', currencyExchange);

    /* @ngInject */
    function currencyExchange(Restangular, apiEndPoints, utilities) {

        var currencyExchangeAPI = Restangular.all(apiEndPoints.currencyExchange.main);

        return {
            getDashboardData: getDashboardData
        };

        function getDashboardData(dateRange, currencyIn, currencyOut){

            return currencyExchangeAPI.customPOST(angular.merge(dateRange, {
                'currencyIn': currencyIn,
                'currencyOut': currencyOut
            }),apiEndPoints.currencyExchange.dashboard);
        }
    }


})();
(function() {

    'use strict';

    angular
        .module('app.dashboard.inventory')
        .factory('inventory', inventory);

    /* @ngInject */
    function inventory(Restangular, apiEndPoints, utilities, $uibModal, loaderModal) {
        var inventoryAPI = Restangular.all(apiEndPoints.inventory.main);

        return {
            getDashboardData: getDashboardData,
            createWarehouse: createWarehouse,
            updateWarehouse: updateWarehouse,
            createWarehouseTransaction: createWarehouseTransaction,
            getWarehouseList: getWarehouseList,
            getWarehouseDetails: getWarehouseDetails,
            getNewWarehouseObj: getNewWarehouseObj,
            changeCurrentWarehouseRent: changeCurrentWarehouseRent,
            saveNewWarehouseRent: saveNewWarehouseRent,
            getNewInventoryRecordObj: getNewInventoryRecordObj,
            saveTruckInInventoryRecord: saveTruckInInventoryRecord,
            getNewInventoryTruckObj: getNewInventoryTruckObj,

            createInventoryRecord: createInventoryRecord,
            updateInventoryRecord: updateInventoryRecord,

            getInventoryRecordList: getInventoryRecordList,
            getInventoryRecord: getInventoryRecord,
            openWarehouseProductStockReport:openWarehouseProductStockReport,
            openWarehouseBusinessStockReport: openWarehouseBusinessStockReport,
            getWarehouseProductReport: getWarehouseProductReport


        };



        function getWarehouseProductReport(warehouseId){
            return inventoryAPI.customGET(apiEndPoints.inventory.warehouseProductReport, {
                    warehouseId: warehouseId
                })
        }

        function getWarehouseBusinessReport(warehouseId){
            return inventoryAPI.customGET(apiEndPoints.inventory.warehouseBusinessReport, {
                warehouseId: warehouseId
            })
        }


        function getInventoryRecordList(dateRange){
            return inventoryAPI.customGET(apiEndPoints.inventory.transaction+'/list', dateRange);
        }

        function getInventoryRecord(id){
            return inventoryAPI.customGET(apiEndPoints.inventory.transaction,{
                id: id
            });
        }

        function createInventoryRecord(inventoryRecord){
            return inventoryAPI.customPOST(inventoryRecord, apiEndPoints.inventory.transaction);
        }

        function updateInventoryRecord(inventoryRecord){
            return inventoryAPI.customPUT(inventoryRecord, apiEndPoints.inventory.transaction)
        }




        function getNewInventoryTruckObj(){
            return {
                'id': 'new',
                'date': null,
                'truckNo': '',
                'weightInKg': 0.00,
                'remarks': ''
            }
        }

        function getNewInventoryRecordObj(){
            return {
                'warehouseId': null,
                'lotNo': '',
                'date': null,
                'businessId': '',
                'portClearingNo': '',
                'fclQuantity': 0,
                'productId': '',
                'positive': 'True',
                'trucks': [],
                'removedTrucks': []
            }
        }

        function getWarehouseDetails(id, rentDetails){
            return inventoryAPI.customGET(apiEndPoints.inventory.warehouse, {
                'id': id,
                'rent': rentDetails
            })
        }

        function saveNewWarehouseRent(id, warehouseObj){
            var warehouseObj = angular.extend(warehouseObj, {'warehouseId': id});
            return inventoryAPI.customPOST(warehouseObj, apiEndPoints.inventory.warehouseRent);
        }

        function openWarehouseBusinessStockReport(warehouseId, warehouseName, warehouseQuantity){
            var modelsInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/dashboard/inventory/warehouseBusinessStockReport.html',
                controller: function($scope, businessReport){
                    $scope.businessReport = businessReport;
                    $scope.warehouseName = warehouseName;
                    $scope.warehouseQuantity = warehouseQuantity;
                    $scope.totalInFlow = _.sumBy(businessReport, function(report){
                        report.showDetails = false;
                        return report.businessInFlow;
                    });
                    $scope.totalOutFlow= _.sumBy(businessReport, function(report){
                        return report.businessOutFlow;
                    });
                    $scope.toggleProductDetails = function(business){
                        console.log(business);

                        business.showDetails=!business.showDetails;
                    }
                },
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    businessReport: function(){
                        loaderModal.open();
                        return getWarehouseBusinessReport(warehouseId).then(function(res){
                            loaderModal.close();
                            return res.businessReport;
                        })
                    },
                    warehouseName: function(){
                        return warehouseName;
                    },
                    warehouseQuantity: function(){
                        return warehouseQuantity;
                    }

                }
            });
        }

        function openWarehouseProductStockReport(warehouseId, warehouseName, warehouseQuantity){
            var modelsInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/dashboard/inventory/warehouseProductStockReport.html',
                controller: function($scope, productReport){
                    $scope.productReport = productReport;
                    $scope.warehouseName = warehouseName;
                    $scope.warehouseQuantity = warehouseQuantity;
                    $scope.totalSelfQuantity = _.sumBy(productReport, function(report){
                        return report.selfQuantity;
                    });
                    $scope.totalOtherQuantity = _.sumBy(productReport, function(report){
                        return report.otherBusinessQuantityInStock;
                    });
                },
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    productReport: function(){
                        loaderModal.open();
                        return getWarehouseProductReport(warehouseId).then(function(res){
                            loaderModal.close();
                            console.log(res);
                            return res.productReport;
                        })
                    },
                    warehouseName: function(){
                        return warehouseName;
                    },
                    warehouseQuantity: function(){
                        return warehouseQuantity;
                    }

                }
            });
        }

        function getWarehouseLotReport(warehouseId){
            var modelsInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/dashboard/inventory/lotNumberFormModal.html',
                controller: function($scope, warehouseId, $state){

                },
                size: 'lg',
                backdrop: 'static',
                resolve:{
                    warehouseId: function(){
                        return warehouseId;
                    }
                }
            });
        }

        function saveTruckInInventoryRecord(inventoryRecordId, callback, inventoryTruckObj, toastr){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/dashboard/inventory/inventoryTruckForm.html',
                controller: function($scope){
                    $scope.inventoryRecordId = inventoryRecordId;
                    $scope.inventoryTruckObj = inventoryTruckObj;
                    $scope.saveNewInventoryTruck = function(inventoryTruckForm, inventoryTruckId, inventoryTruckObj){
                        if(inventoryTruckForm.$valid){
                            modalInstance.close($scope.inventoryTruckObj);
                        }
                        else{
                            toastr.error('Please Enter mandatory fields');
                        }

                    }
                },
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    inventoryRecordId: function(){
                        return inventoryRecordId;
                    },
                    callback: function(){
                        return callback;
                    },
                    inventoryTruckObj: function(){
                        return inventoryTruckObj
                    }
                }
            });

            modalInstance.result.then(function(inventoryTruckObj){
                callback(inventoryTruckObj);
            });
        }

        function changeCurrentWarehouseRent(warehouseId, callback){
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/dashboard/inventory/warehouseRentForm.html',
                controller: 'WarehousesRentForm as vm',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    warehouseId: function(){
                        return warehouseId;
                    },
                    callback: function(){
                        return callback;
                    }
                }


            });

            modalInstance.result.then(function(response){
                callback(response);
            });
        }

        function getNewWarehouseObj(){
            return {
                name: '',
                lots: 1,
                totalCapacityKgs: 0.00,
                selfWarehouse:false,
                contact: '',
                address: ''
            }
        }

        function getDashboardData(){
            return inventoryAPI.customGET(apiEndPoints.inventory.dashboard);
        }

        function getWarehouseList(){
            return inventoryAPI.customGET(apiEndPoints.inventory.warehouse+'/list');
        }

        function createWarehouse(warehouseObj){
            return inventoryAPI.customPOST(warehouseObj, apiEndPoints.inventory.warehouse);
        }

        function updateWarehouse(warehouseObj){
            return inventoryAPI.customPUT(warehouseObj, apiEndPoints.inventory.warehouse);
        }

        function createWarehouseTransaction(){

        }
    }

})();

(function() {

    'use strict';

    var paymentTerms = {
        ADVANCE: 'advance',
        PRODUCT_DELIVERY: 'product_delivery',
        ON_DATE: 'on_date'

    };

    angular
        .module('app.dashboard.localTradeBook')
        .constant('paymentTerms', paymentTerms)
        .factory('localTradeBook', localTradeBook);



    /* @ngInject */
    function localTradeBook(Restangular, apiEndPoints, utilities, paymentTerms){
        var localAPI = Restangular.all(apiEndPoints.localTrade.main);
        var localTradeAPI = localAPI.all(apiEndPoints.localTrade.trade);
        var locatTradeListAPI = localAPI.all(apiEndPoints.localTrade.tradeList);
        var localTradeStatusAPI = localAPI.all(apiEndPoints.localTrade.tradeStatus);
        var localTradeDeliverySlipAPI = localAPI.all(apiEndPoints.localTrade.deliverySlip);
        var localTradeDashboardAPI = localAPI.all(apiEndPoints.localTrade.deliverySlip);


        return {
            getNewLocalTrade: getNewLocalTrade,
            addLocalTrade: addLocalTrade,
            updateLocalTrade: updateLocalTrade,
            getTransactionList: getTransactionList,
            getTransactionDetail: getTransactionDetail
        };

        function getTransactionList(dateRange, pageType){
            var queryParams = angular.copy(dateRange);
            queryParams =  angular.extend(queryParams, {
                'pageType': pageType
            });
            return locatTradeListAPI.customGET('',queryParams);
        }

        function addLocalTrade(trade){
            return localTradeAPI.customPOST(trade);
        }

        function updateLocalTrade(trade){
            return localTradeAPI.customPUT(trade);
        }

        function getTransactionDetail(tradeId, full){
            return localTradeAPI.customGET('',{
                'tradeId': tradeId,
                'full': full
            });
        }

        function getNewLocalTrade(){
            return {
                date: null,
                buyerId: null,
                sellerId: null,
                productItemId: null,
                quantityFCL: 0,
                quantity: 0.00,
                price: 0.00,
                fileId: null,
                contractId: '',
                deliveryDueDate: null,
                fundsDueDate:null,
                internationalFileId: null,
                otherInfo: '',
                paymentDate: null,
                paymentTerm: paymentTerms.ADVANCE
            };
        }
    }


})();
(function(){

    'use strict';

    angular
        .module('app.dashboard.pricing')
        .factory('manifest', manifest);

    /* @ngInject */
    function manifest(Restangular, apiEndPoints, utilities){

        var manifestAPI = Restangular.all(apiEndPoints.manifest);
        var manifestDashboardAPI = Restangular.all(apiEndPoints.manifestDashboard);

        return {
            getNewManifestItemObj: getNewManifestItemObj,
            addManifestItem: addManifestItem,
            updateManifestItem: updateManifestItem,
            deleteManifestItem: deleteManifestItem,
            getAllManifestItems: getAllManifestItems,
            getManifestDashboardReport: getManifestDashboardReport
        };

        function getNewManifestItemObj(date){
            return {
                'date': (date) ? date : new Date(),
                'buyerId': null,
                'sellerId': null,
                'productId': null,
                'quantity': null,
                'quantityMetricId': 'FCL',
                'containerNo': null,
                'comments': null
            }
        }

        function getManifestDashboardReport(dateRange, selectedBuyer, selectedSeller, selectedProduct){
            var dateRangeCopy = angular.copy(dateRange);
            // dateRangeCopy.startDate = dateRangeCopy.startDate.addTimeZoneOffset();
            // dateRangeCopy.endDate = dateRangeCopy.endDate.addTimeZoneOffset();
            var postData = dateRangeCopy;
            postData = angular.extend({
                'selectedBuyer': selectedBuyer.join(),
                'selectedSeller': selectedSeller.join(),
                'selectedProduct': selectedProduct.join()
            }, postData);
            return manifestDashboardAPI.customPOST(postData);
        }

        function deleteManifestItem(manifestId){
            return manifestAPI.customDELETE(manifestId)
        }

        function getAllManifestItems(dataRange){
            return manifestAPI.get('', dataRange)
        }

        function updateManifestItem(manifestItem){
            return manifestAPI.customPUT({'manifestItem': manifestItem});
        }

        function addManifestItem(manifestItem){
            return manifestAPI.customPOST({'manifestItem': manifestItem});
        }

    }

}());

/**
 * @ngdoc service
 * @name app.dashboard.pricing.pricing
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.pricing')
        .factory('pricing', pricing);

    /* @ngInject */
    function pricing(Restangular, apiEndPoints, utilities){

        var pricingAPI = Restangular.all(apiEndPoints.pricing);

        return {
            getAllPriceMarkets: getAllPriceMarkets,
            getNewPriceMarkets: getNewPriceMarkets,
            addPriceMarket: addPriceMarket,
            updatePriceMarket: updatePriceMarket,
            getNewMarketPriceObj: getNewMarketPriceObj,
            getNewMarketPriceItemObj: getNewMarketPriceItemObj,

            getAllProductItemPrice: getAllProductItemPrice,
            addProductItemPrice: addProductItemPrice,
            updateProductItemPrice: updateProductItemPrice,
            deleteProductItemPrice: deleteProductItemPrice,
            getAllProductPriceSummary: getAllProductPriceSummary,

            getProductPricingAnalytics: getProductPricingAnalytics
        };

        function getProductPricingAnalytics(dateRange, productItemId){
            return pricingAPI.customPOST(angular.merge(dateRange, {
                'productItemId': productItemId
            }), apiEndPoints.productItem+'/analytics')
        }

        function getAllProductPriceSummary(){
            return pricingAPI.customGET(apiEndPoints.pricingSummary);
        }

        function getAllProductItemPrice(dataRange){
            return pricingAPI.customGET(apiEndPoints.productItem, dataRange)
        }

        function addProductItemPrice(marketPriceObj, callback){
            pricingAPI.customPOST(marketPriceObj, apiEndPoints.productItem).then(function(res){
                callback(res);
            });
        }

        function updateProductItemPrice(marketPriceObj, callback){
            pricingAPI.customPUT(marketPriceObj, apiEndPoints.productItem).then(function(res){
                callback(res);
            });
        }

        function deleteProductItemPrice(marketPriceObj){
            return pricingAPI.customDELETE(apiEndPoints.productItem+'/'+marketPriceObj.id);
        }

        function getNewMarketPriceItemObj(isCurrent){
            return {
                'shipmentMonths':null,
                'priceValue': '',
                'currentValue': (isCurrent) ? isCurrent : false
            }
        }

        function getNewMarketPriceObj(){
            var marketPriceObj =  {
                'comments': '',
                'priceMarketId': null,
                'productItemId': null,
                'priceTime': new Date(),
                'priceItems': [

                ]
            };
            marketPriceObj.priceItems.push(getNewMarketPriceItemObj(true));
            return marketPriceObj;
        }


        function getAllPriceMarkets(){
            return pricingAPI.customGET(apiEndPoints.pricingMarket)
        }

        function addPriceMarket(priceMarket, callBack){
            pricingAPI.customPOST(priceMarket, apiEndPoints.pricingMarket).then(function(res){
                callBack(res, 'Added Price Market', false);
            })
        }

        function updatePriceMarket(priceMarket, callBack){
            pricingAPI.customPUT(priceMarket, apiEndPoints.pricingMarket).then(function(res){
                callBack(res, 'Updated Price Market', true);
            })
        }

        function getNewPriceMarkets(){
            return {
                'country': null,
                'currency': null,
                'description': '',
                'isInternational': true
            }
        }
    }

}());


/**
 /**
 * @ngdoc service
 * @name app.dashboard.tradeBook.tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.products')
        .factory('product', product);

    /* @ngInject */
    function product(Restangular, apiEndPoints, utilities){



        var productAPI = Restangular.all(apiEndPoints.product);
        var productItemAPI = Restangular.all(apiEndPoints.productItem);

        return {
            getAllProductList: getAllProductList,
            getProductObj:getProductObj,
            setProductInfo: setProductInfo,

            getAllProductCategories: getAllProductCategories,
            getNewProductCategoryObj: getNewProductCategoryObj,
            addProductCategory: addProductCategory,
            updateProductCategory: updateProductCategory,
            getProductCategorySpecification: getProductCategorySpecification,
            saveProductCategorySpecification: saveProductCategorySpecification,


            addProduct: addProduct,
            updateProduct: updateProduct,
            deleteProduct: deleteProduct,
            getProduct: getProduct,

            getNewProductItem: getNewProductItem,
            addProductItem: addProductItem,
            updateProductItem: updateProductItem,
            getAllProductItems: getAllProductItems,
            getProductSpecification: getProductSpecification,

            getNewKeywordObj: getNewKeywordObj,
            addProductKeyword: addProductKeyword,
            updateProductKeyword: updateProductKeyword,
            getAllKeywords: getAllKeywords,

            resetProductObj: resetProductObj,
            saveProductOrigin: saveProductOrigin,

            getPriceReport: getPriceReport,
            displayOnWebsite: displayOnWebsite,
            productItemPriceOnWebsite: productItemPriceOnWebsite,

            loadRelatedProducts: loadRelatedProducts
        };

        function loadRelatedProducts(query, productId){
            return productAPI.customGET(apiEndPoints.productTags, {
                'productId': productId,
                'query': query
            });
        }

        function displayOnWebsite(productId, state){
            return productAPI.customPOST({
                'productId': productId,
                'status': state
            }, apiEndPoints.productWebsiteStatus);
        }

        function getPriceReport(dateRange, productItemId){
            var data = angular.copy(dateRange);
            data = angular.extend(data, {
                'productItemId': productItemId
            });
            return productItemAPI.customGET(apiEndPoints.productPriceReport, data);
        }

        function getProductSpecification(productItemId){
            return productItemAPI.customGET('specs',{
                'productItemId': productItemId
            })
        }

        function updateProductKeyword(keywordObj, callback){
            return productAPI.customPUT(keywordObj, apiEndPoints.productKeywords).then(function(res){
                callback(res);
            })
        }

        function addProductKeyword(keywordObj, callback){
            return productAPI.customPOST(keywordObj, apiEndPoints.productKeywords).then(function(res){
                callback(res);
            });
        }

        function getAllKeywords(){
            return productAPI.customGET(apiEndPoints.productKeywords);
        }

        function getNewKeywordObj(){
            return {
                keyword: '',
                categoryId: null
            }
        }

        // Start Product Category

        function getAllProductCategories(){
            return productAPI.customGET(apiEndPoints.productCategory)
        }

        function getNewProductCategoryObj(){
            return {
                name:'',
                description: ''
            }
        }

        function addProductCategory(categoryObj, callback){
            return productAPI.customPOST(categoryObj, apiEndPoints.productCategory).then(function(res){
                callback(res);
            })
        }
        
        function getProductCategorySpecification(categoryId){
            return productAPI.customGET(apiEndPoints.productCategorySpecification, {
                'categoryId': categoryId
            });
        }

        function saveProductCategorySpecification(specsObj){
            return productAPI.customPOST(specsObj, apiEndPoints.productCategorySpecification)
        }

        function updateProductCategory(categoryObj, callback){
            return productAPI.customPUT(categoryObj, apiEndPoints.productCategory).then(function(res){
                callback(res);
            })
        }

        // End Product Category



        function getAllProductList(){
            return productAPI.customGET()
        }


        function resetProductObj(){
            product.info = {};
            product.growingConditions = {};
            product.growingAreas = {};
        }

        function getNewProductItem(){
            return {
                'keywords':[],
                'productId': null,
                'productOrigin': null,
                'specification': {
                    'moisture': 0,
                    'purity': 0,
                    'foreignMatter': 0,
                    'brokenSplits': 0,
                    'damaged': 0,
                    'greenDamaged': 0,
                    'weevilied': 0,
                    'otherColor': 0,
                    'wrinkled': 0
                }
            }
        }

        function addProductItem(productItem, callback){
            console.log(productItem);
            productItemAPI.customPOST(productItem).then(function(res){
                callback(res);
            });
        }

        function updateProductItem(productItem, callback){
            console.log(productItem);
            productItemAPI.customPUT(productItem).then(function(res){
                callback(res);
            });
        }

        function productItemPriceOnWebsite(productItemId, priceOnWebsite){
            return productItemAPI.customPOST({
                'productItemId': productItemId,
                'priceOnWebsite': priceOnWebsite
            }, apiEndPoints.productItemPriceOnWebsite)
        }

        function getAllProductItems(){
            return productItemAPI.customGET();
        }



        function getProduct(productId){

        }

        function prepareProduct(productObj, imagesData){
            var body = new FormData();
            if(imagesData){
                var file = new File([imagesData.resultBlob], productObj.info.name+'.png');
                body.append('image', file);
            }
            body.append('product', JSON.stringify(productObj.info));
            return body
        }

        function updateProduct(productObj, imagesData){
            return productAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPUT(
                prepareProduct(productObj, imagesData),
                '',
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function addProduct(productObj, imagesData){
            return productAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPOST(
                prepareProduct(productObj, imagesData),
                '',
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function saveProductOrigin(productObj){
            return productAPI.customPOST({
                'origins': productObj.origins,
                'product_id': productObj.id
            }, apiEndPoints.productOrigin);
        }



        function deleteProduct(productId){
            return productAPI.customDELETE(productId);
        }




        function setProductInfo(productInfo){
            product.info = productInfo;
        }

        function getProductObj(){
            return {
                info:{},
                growingConditions:{},
                growingAreas:{},
                origins:null
            };
        }
    }

}());


/**
 * @ngdoc service
 * @name app.dashboard.tradeBook.tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.settings')
        .factory('settings', settings);

    /* @ngInject */
    function settings(Restangular, apiEndPoints, utilities){
        
        var dropDownAPI = Restangular.all(apiEndPoints.dropDown.main);

        return {
            dropDownAPI: dropDownAPI,
            getChangePasswordObj: getChangePasswordObj,
            dropDown: utilities.setupCRUD(
                dropDownCreate,
                dropDownRead,
                dropDownUpdate,
                dropDownDelete
            )
        };

        function getChangePasswordObj(){
            return {
                'confirmPassword': '',
                'oldPassword': '',
                'newPassword': ''
            }
        }

        function dropDownCreate(endPoint, name){
            return dropDownAPI.customPOST({name:name}, endPoint)
        }

        function dropDownRead(endPoint, query, tabFilter){
            if(typeof query === 'object' ){
                return dropDownAPI.customGET(endPoint, query, {
                    tabFilter:tabFilter
                })
            }
            else{
                query = (query) ? query : 'all';
                return dropDownAPI.customGET(endPoint, {q: query, tabFilter:tabFilter})
            }
        }

        function dropDownDelete(endPoint, id){
            return dropDownAPI
        }

        function dropDownUpdate(endPoint, name, id){
            return dropDownAPI.customPUT({
                name: name,
                id: id
            }, endPoint);
        }
        
        

        
    }

}());



(function() {

    'use strict';

    angular
        .module('app.dashboard.products')
        .factory('shipping', shipping);

    /* @ngInject */
    function shipping(Restangular, apiEndPoints, utilities) {
        var shippingAPI = Restangular.all(apiEndPoints.shipping.main);
        var port = {
            list:[]
        };

        return {
            //shipping port
            getShippingPortList: getShippingPortList,
            deleteShippingPort: deleteShippingPort,
            addShippingPort: addShippingPort,
            updateShippingPort: updateShippingPort,
            getPortItemObj: getPortItemObj,
            getNewPortItemObj: getNewPortItemObj,
            shippingPortList: shippingPortList,
            setShippingPortList: setShippingPortList,
            addPortToPortList: addPortToPortList,

            //shipping vessel

            getShippingVesselList: getShippingVesselList,
            getShippingVesselObj: getShippingVesselObj,
            updateShippingVesselObj: updateShippingVesselObj,
            deleteShippingVesselObj: deleteShippingVesselObj,
            createShippingVesselObj: createShippingVesselObj,

            //shipping line

            getShippingLineList: getShippingLineList,
            addShippingLine: addShippingLine,
            updateShippingLine: updateShippingLine,
            deleteShippingLine: deleteShippingLine,
            getNewShippingLineObj: getNewShippingLineObj,
            getShippingLineObj: getShippingLineObj,
            getNewShippingVesselObj: getNewShippingVesselObj,

            getPortTags: getPortTags,
            getVesselTags: getVesselTags




        };

        function getNewShippingVesselObj(){
            return {
                id: null,
                name: '',
                shippingLineId: '',
                mmsi: null,
                imoNumber: null
            }
        }

        function getShippingVesselObj(id){
            return shippingAPI.customGET(apiEndPoints.shipping.shippingVessel, {
                id: id
            });
        }

        function updateShippingVesselObj(vesselObj){
            return shippingAPI.customPUT({
                'vesselObj': vesselObj
            }, apiEndPoints.shipping.shippingVessel);
        }

        function createShippingVesselObj(vesselObj){
            return shippingAPI.customPOST({
                'vesselObj': vesselObj
            }, apiEndPoints.shipping.shippingVessel);
        }

        function deleteShippingVesselObj(id){
            return shippingAPI.customDELETE(apiEndPoints.shipping.shippingVessel+'/'+id);
        }


        function getPortTags(query){
            return shippingAPI.customGET(apiEndPoints.shipping.portTag, {'query': query});
        }

        function getVesselTags(query){
            return shippingAPI.customGET(apiEndPoints.shipping.shippingVesselTag, {'query': query});
        }


        function getNewShippingLineObj(){
            return {
                'id': null,
                'codeName': '',
                'name': '',
                'website': '',
                'trackingWebsite': '',
                'logo': null,
            }

        }

        function prepareShippingLine(lineObj, imagesData){
            var body = new FormData();
            if(imagesData){
                var file = new File([imagesData.resultBlob], lineObj.name+'.png');
                body.append('logo', file);
            }
            body.append('lineData', JSON.stringify(lineObj));
            return body
        }

        function updateShippingLine(lineObj, imagesData){
            return shippingAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPUT(
                prepareShippingLine(lineObj, imagesData),
                apiEndPoints.shipping.shippingLine,
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function deleteShippingLine(lineId){
            return shippingAPI.customDELETE(apiEndPoints.shipping.shippingLine+'/'+lineId);
        }

        function addShippingLine(lineObj, imagesData){
            return shippingAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPOST(
                prepareShippingLine(lineObj, imagesData),
                apiEndPoints.shipping.shippingLine,
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function getShippingLineObj(shippingLineId){
            console.log(shippingLineId);
            return shippingAPI.customGET(apiEndPoints.shipping.shippingLine,
                {'shippingLineId': shippingLineId});
        }

        function getShippingLineList(){
            return shippingAPI.customGET(apiEndPoints.shipping.shippingLine+'/list');
        }


        function getShippingVesselList(searchObj){
            return shippingAPI.customPOST({'searchObj': searchObj}, apiEndPoints.shipping.shippingVessel+'/list');
        }


        function addPortToPortList(portObj){
            port.list.push(portObj)
        }

        function setShippingPortList(portList){
            port.list = portList;
        }

        function shippingPortList(){
            return port.list;
        }

        function getPortItemObj(portId){
            return shippingAPI.customGET(apiEndPoints.shipping.ports+'/'+portId);
        }

        function addShippingPort(portObj){
            return shippingAPI.customPOST({'portObj':portObj},apiEndPoints.shipping.ports);
        }

        function updateShippingPort(portObj){
            return shippingAPI.customPUT({'portObj': portObj}, apiEndPoints.shipping.ports);
        }


        function getNewPortItemObj(){
            return {
                'name': null,
                'loCode': null,
                'contactNo': null,
                'website': null,
                'country': null,
                'countryCode': null
            }
        }

        function getShippingPortList(){
            return shippingAPI.customGET(apiEndPoints.shipping.ports+'/list');
        }

        function deleteShippingPort(portId){
            return shippingAPI.customDELETE(apiEndPoints.shipping.ports+'/'+portId);
        }
    };

})();


/**
 * @ngdoc service
 * @name app.dashboard.tradeBook.tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.tradeBook')
        .factory('tradeBook', tradeBook);

    /* @ngInject */
    function tradeBook(apiEndPoints, Restangular, $state, appFormats, FileSaver, Blob, utilities, $http, $uibModal){

        var transactionAPI = Restangular.all(apiEndPoints.transaction.main);

        var productItemAPI = Restangular.all(apiEndPoints.productItem);

        // var transactionAPI =

        return {
            getNewTransaction: getNewTransaction,
            getTransactionList: getTransactionList,
            calculateCommission: calculateCommission,
            addTransaction: addTransaction,
            updateTransaction: updateTransaction,
            getTransactionDetail: getTransactionDetail,

            addTradeNote: addTradeNote,
            editTradeNote: editTradeNote,
            deleteTradeNote: deleteTradeNote,
            getAllNotesForTrade: getAllNotesForTrade,
            deleteTransactionDocument: deleteTransactionDocument,
            downloadTradeDocument: downloadTradeDocument,
            activateShipmentStatus: activateShipmentStatus,
            changeCompleteStatus: changeCompleteStatus,
            changeWashoutStatus: changeWashoutStatus,


            updateShippedInfo: updateShippedInfo,
            updateNotShippedInfo: updateNotShippedInfo,
            updateApprobationReceivedInfo: updateApprobationReceivedInfo,
            updateArrivedAtPortInfo: updateArrivedAtPortInfo,


            getCommissionCashFlow: getCommissionCashFlow,
            getTradebookDashbordData: getTradebookDashboardData,
            getTradeBusinessAnalytics: getTradeBusinessAnalytics,

            openTradeBookModal: openTradeBookModal,
            saveDisputeData: saveDisputeData


        };

        function saveDisputeData(disputeData, fileId, activate){
            var disputeDataPost = angular.extend(disputeData, {
                'fileId': fileId,
                'activate': activate
            });
            console.log(disputeDataPost);
            return transactionAPI.customPOST(disputeDataPost, apiEndPoints.transaction.dispute);
        }

        function getTradebookDashboardData(){
            return transactionAPI.customGET(apiEndPoints.transaction.dashboard)
        }

        function getCommissionCashFlow(fileId){
            return transactionAPI.customGET(apiEndPoints.transaction.cashFlow, {
                'fileId': fileId
            })
        }

        function getTradeBusinessAnalytics(dateRange){
            var data = angular.copy(dateRange);
            data = angular.extend(data, {
                'pageType': 'businessAnalytics'
            });
            return transactionAPI.customGET(apiEndPoints.transaction.analytics, data);
        }

        function updateShippedInfo(dataObj, transactionId){
            return transactionAPI.customPUT({
                'dataObj':dataObj,
                'transactionId': transactionId
            }, apiEndPoints.transaction.shippedInfo);
        }

        function updateNotShippedInfo(dataObj, transactionId){
            return transactionAPI.customPUT({
                'dataObj':dataObj,
                'transactionId': transactionId
            }, apiEndPoints.transaction.notShippedInfo);
        }

        function updateApprobationReceivedInfo(dataObj, transactionId){
            return transactionAPI.customPUT({
                'dataObj':dataObj,
                'transactionId': transactionId

            }, apiEndPoints.transaction.approbationReceivedInfo);
        }

        function updateArrivedAtPortInfo(dataObj, transactionId, earnedCommission){
            return transactionAPI.customPUT({
                'dataObj':dataObj,
                'transactionId': transactionId,
                'earnedCommission': earnedCommission
            }, apiEndPoints.transaction.arrivedAtPortInfo);
        }

        function changeWashoutStatus(transactionId, status, washOut){
            washOut.isWashout = status;
            return transactionAPI.customPOST({
                'transactionId': transactionId,
                'washOut': washOut
            }, apiEndPoints.transaction.washout);
        }

        function changeCompleteStatus(transactionId, completeObj){
            return transactionAPI.customPOST({
                'transactionId': transactionId,
                'completeObj': completeObj
            }, apiEndPoints.transaction.completeStatus);
        }

        function activateShipmentStatus(shipmentStatus, status, transactionId){
            return transactionAPI.customPOST({
                'shipmentStatus': shipmentStatus,
                'status': status,
                'transactionId': transactionId
            }, apiEndPoints.transaction.shipmentStatus)
        }

        function downloadTradeDocument(docId, fileName, fileType){
            return transactionAPI.withHttpConfig({responseType: 'arraybuffer'}).customGET(apiEndPoints.transaction.document+'/'+docId).then(function(response){
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.style = 'display: none';
                var file = new Blob([response], {type: fileType});
                var fileURL = (window.URL || window.webkitURL).createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                a.remove();
                (window.URL || window.webkitURL).revokeObjectURL(file);
            })
        }

        function deleteTransactionDocument(docId){
            return transactionAPI.customDELETE(apiEndPoints.transaction.document+'/'+docId);
        }

        function getTransactionDetail(tradeId, full){
            return transactionAPI.customGET(apiEndPoints.transaction.basic,{
                'tradeId': tradeId,
                'full': full
            });
        }

        function getAllNotesForTrade(tradeId){
            return transactionAPI.customGET(apiEndPoints.transaction.note+'/'+tradeId)
        }

        function addTradeNote(tradeId, note){
            return transactionAPI.customPOST({
                'note': note,
                'tradeId': tradeId
            }, apiEndPoints.transaction.note);
        }

        function deleteTradeNote(tradeId, noteId){
            return transactionAPI.customDELETE(apiEndPoints.transaction.note+'/'+tradeId+'/'+noteId);
        }

        function editTradeNote(tradeId, noteId, note){
            return transactionAPI.customPUT({
                'note': note,
                'noteId': noteId,
                'tradeId': tradeId
            }, apiEndPoints.transaction.note)

        }

        function getTransactionList(dateRange, pageType){
            var dateRangeCopy = angular.copy(dateRange);

            dateRangeCopy =  angular.extend(dateRangeCopy, {
                'pageType': pageType
            });
            return transactionAPI.customGET(apiEndPoints.transaction.list, dateRangeCopy);
        }

        function addTransaction(transactionObj){
            return transactionAPI.customPOST(transactionObj, apiEndPoints.transaction.basic);
        }

        function updateTransaction(transactionObj){
            return transactionAPI.customPUT(transactionObj, apiEndPoints.transaction.basic);
        }

        function calculateCommission(transactionObj, quantity){
            var type = transactionObj.commission.typeId;
            var price = parseFloat(transactionObj.basic.price);
            var quantity = (quantity) ? parseFloat(quantity) : parseFloat(transactionObj.basic.quantity);
            var comm =  transactionObj.commission.commission;
            var commIntoPrice = 0;
            var brokerCommType = transactionObj.commission.buyerBrokerCommissionTypeId;
            var brokerIntoPrice = 0;
            var differance = parseFloat(transactionObj.commission.difference);
            var discount = parseFloat(transactionObj.commission.discount);
            var bComm = parseFloat(transactionObj.commission.buyerBrokerCommission);
            if(type){
                commIntoPrice = (parseInt(type) === 1) ? (comm) : (comm*0.01)*price;
            }
            if(brokerCommType){
                brokerIntoPrice = (parseInt(brokerCommType)===1) ? bComm : (bComm*0.01)*price;
            }
            var netCommission = (commIntoPrice - brokerIntoPrice + differance  - discount);

            return (netCommission * quantity);
        }

        function getNewTransaction(){
            return {
                id: null,
                basic:{
                    date: new Date(),
                    quantity: 0.00,
                    quantityFcl: 0.0,
                    buyerId: null,
                    sellerId: null,
                    productItemId: null,
                    contractualBuyerId: null,
                    price: 0.00,
                    fileId: null,
                    contractId: null,
                    packagingId: null,
                    shipmentEnd: (new Date()).addDays(30),
                    shipmentStart: null,
                    otherInfo: ''
                },
                commission:{
                    typeId: 1,
                    commission: 0,
                    difference: 0,
                    discount: 0,
                    buyerBrokerId: null,
                    buyerBrokerCommissionTypeId: 1,
                    buyerBrokerCommission: 0,
                    sellerBrokerId: null

                },
                productSpecification:{
                    moisture: null,
                    purity: null,
                    foreignMatter: null,
                    brokenSplits: null,
                    damaged: null,
                    greenDamaged: null,
                    weevilied: null,
                    otherColor: null,
                    wrinkled: null
                }
            }
        }


        function openTradeBookModal(reportType){
            $state.go('dashboard.transactionList', {reportType:reportType})

        }


    }

}());

/**
 * @ngdoc service
 * @name app.dashboard.tradeBook.tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.user')
        .factory('user', user);

    /* @ngInject */
    function user(Restangular, apiEndPoints, utilities){

        var userAPI = Restangular.all(apiEndPoints.user);

        return {
            getUserProfile: getUserProfile,
            getAllUserProfile: getAllUserProfile,
            addUserProfile: addUserProfile,
            updateUserProfile: updateUserProfile,
            addProfilePic: addProfilePic,
            updateProfilePic: updateProfilePic,
            deleteProfilePic: deleteProfilePic,
            getNewUserObj: getNewUserObj,
            changePassword: changePassword,
            changeUserActive: changeUserActive,
            changeUserReadOnly: changeUserReadOnly

        };

        function changePassword(passwordObj){
            return userAPI.customPOST(passwordObj, apiEndPoints.changePassword);
        }

        function changeUserActive(userId, activeStatus){
            var obj = {
                'userId':userId,
                'activeStatus':activeStatus
            };
            return userAPI.customPOST(obj, apiEndPoints.userActiveStatus);
        }

        function changeUserReadOnly(userId, readOnlyStatus){
            var obj = {
                'userId':userId,
                'readOnlyStatus':readOnlyStatus
            };

            return userAPI.customPOST(obj, apiEndPoints.userReadOnlyStatus);
        }

        function getNewUserObj(){
            return {
                'profilePic': null,
                'username': '',
                'firstName': '',
                'lastName': '',
                'email': '',
                'designationId': null,
                'businessLocationId': null,
                'notify': {
                    'newTransaction': false,
                    'shipmentArrival': false,
                    'messages': false,
                    'monthlyReports': false,
                    'weeklyReports': false,
                    'dailyReports': false
                }
            }
        }

        function getUserProfile(id){
            return userAPI.customGET('',{
                'q': id
            })
        }

        function getAllUserProfile(){
            return userAPI.customGET('', {
                'q': 'all'
            })
        }

        function addProfilePic(imagesData, userId){
            var body = new FormData();
            var file = new File([imagesData.resultBlob], "profile.png");
            body.append('profile', file);
            return userAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPOST(
                body,
                userId+'/profilePic',
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function updateProfilePic(images, userId){
            var fd = new FormData();
            fd.append('file', images);
            return userAPI.customPUT(fd, userId+'/profilePic', {
                'Content-Type': undefined
            });
        }

        function deleteProfilePic(userId){
            return userAPI.customDELETE({}, userId+'/profilePic', {
                'Content-Type': undefined
            });
        }

        function updateUserProfile(updatedUser){
            return userAPI.customPUT({user:updatedUser}, '');
        }

        function addUserProfile(newUser){
            return userAPI.customPOST({user:newUser})
        }
    }

}());


/**
 * @ngdoc service
 * @name app.dashboard.tradeBook.tradeBook
 * @description < description placeholder >
 */

(function(){

    'use strict';

    angular
        .module('app.dashboard.website')
        .factory('website', website);

    /* @ngInject */
    function website(Restangular, apiEndPoints, utilities){

        var websiteAPI = Restangular.all(apiEndPoints.website.basic);

        return {
            getResearchList: getResearchList,
            getResearchObj: getResearchObj,
            updateResearch: updateResearch,
            addResearch: addResearch,
            deleteResearch: deleteResearch,
            displayResearchOnWebsite: displayResearchOnWebsite,
            getNewResearchObj: getNewResearchObj,
            getResearchTags: getResearchTags,
            getCompleteResearch: getCompleteResearch,
            getWebsiteDashboard: getWebsiteDashboard
        };

        function getWebsiteDashboard(){
            return websiteAPI.customGET(apiEndPoints.website.dashboard);
        }

        function getNewResearchObj(){
            return {
                title: '',
                slug: '',
                tags: [],
                image: null,
                height: 400,
                width: 400,
                content: ''
            }
        }

        function getCompleteResearch(researchId){
            return websiteAPI.customGET(apiEndPoints.website.research, {'researchId': researchId});
        }

        function getResearchTags(query){
            return websiteAPI.customGET(apiEndPoints.website.researchTags, {'query': query});
        }

        function getResearchList(){
            return websiteAPI.customGET(apiEndPoints.website.research);
        }

        function getResearchObj(){
            return websiteAPI.customGET(apiEndPoints.website.research);
        }

        function prepareResearchObj(researchObj, imagesData){
            var body = new FormData();
            if(imagesData){
                var file = new File([imagesData.resultBlob], researchObj.slug+'.png');
                body.append('image', file);
            }
            body.append('research', JSON.stringify(researchObj));
            return body
        }

        function updateResearch(researchObj, imagesData){
            return websiteAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPUT(
                prepareResearchObj(researchObj, imagesData),
                apiEndPoints.website.research,
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function addResearch(researchObj, imagesData){
            return websiteAPI.withHttpConfig({
                transformRequest: angular.identity
            }).customPOST(
                prepareResearchObj(researchObj, imagesData),
                apiEndPoints.website.research,
                undefined, {
                    'Content-Type': undefined
                }
            );
        }

        function deleteResearch(researchId){
            return websiteAPI.customDELETE(apiEndPoints.website.research+'/'+researchId);
        }

        function displayResearchOnWebsite(researchId){
            return websiteAPI.customPOST({
                'researchId': researchId
            }, apiEndPoints.website.research+'/display');
        }

    }

}());


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        ngModel: '=',
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {

        $element.ionRangeSlider({
          min: $scope.min,
          max: $scope.max,
          type: $scope.type,
          prefix: $scope.prefix,
          maxPostfix: $scope.maxPostfix,
          prettify_enabled: $scope.prettify,
          prettify_separator: $scope.prettifySeparator,
          grid: $scope.grid,
          gridMargin: $scope.gridMargin,
          postfix: $scope.postfix,
          step: $scope.step,
          hideMinMax: $scope.hideMinMax,
          hideFromTo: $scope.hideFromTo,
          from: $scope.from,
          to: $scope.to,
          disable: $scope.disable,
          onChange: function(data){
            console.log('change',data);
            $scope.ngModel = data.from;
          },
          onFinish: function(data){
            var scope = $element.scope();
            scope.$apply(function(){
              scope.ngModel = data.from;
            });
          },
          values: $scope.values
        });



        $scope.$watch('min', function (value) {
          $timeout(function () {
            $element.data("ionRangeSlider").update({min: value});
          });
        }, true);
        $scope.$watch('max', function (value) {
          $timeout(function () {
            $element.data("ionRangeSlider").update({max: value});
          });
        });
        $scope.$watch('from', function (value) {
          $timeout(function () {
            $element.data("ionRangeSlider").update({from: value});
          });
        });
        $scope.$watch('to', function (value) {
          $timeout(function () {
            $element.data("ionRangeSlider").update({to: value});
          });
        });
        $scope.$watch('disable', function (value) {
          $timeout(function () {
            $element.data("ionRangeSlider").update({disable: value});
          });
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.vm.getFile($scope.file);
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('app.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('app.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('blogCard', blogCard);

  /** @ngInject */
  function blogCard(appFormats) {
    return {
      restrict: 'E',
      templateUrl: 'app/widgets/blogCard/blogCard.html',
      scope:{
        researchId:'=',
        imageUrl: '=',
        canEdit:'=',
        canDelete:'=',
        isDraft: '=',
        displayWeb: '=',
        onDisplayWeb: '&',
        onDelete:'&',
        title:'=',
        createdOn: '=',
        comments: '=',
        reads: '=',
        userPic: '=',
        author:'=',
        onEdit:'&',
        visitors: '='
      },
      link: link
    };

    function link(scope){
      scope.edit = function(researchId){
        scope.onEdit({'researchId': researchId});
      };
      scope.changeWebDisplay = function(researchId){
        scope.onDisplayWeb({'researchId': researchId})
      };
      scope.delete=function(researchId){
        scope.onDelete({'researchId': researchId});
      };
      scope.appFormats = appFormats;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/widgets/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('businessCard', businessCard);

    /* @ngInject */
    function businessCard($state, utilities, $filter, appConstants){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/businessCard/businessCard.html',
            scope: {
                colSize:'@',
                business:'=',
                businessType: '@'
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.colSize = scope.colSize ? scope.colSize : '4';
                scope.appConstants = appConstants;
                scope.businessLogo = $filter('businessLogo')(scope.business ? scope.business.logo : null);
            }

        }
    }

}());

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();

(function(){

    'use strict';
    angular
        .module('app.widgets')
        .directive('clickOff', clickOff);

    function clickOff($parse, $document) {
        var dir = {
            compile: function($element, attr) {
                // Parse the expression to be executed
                // whenever someone clicks _off_ this element.
                var fn = $parse(attr["clickOff"]);
                return function(scope, element, attr) {
                    // add a click handler to the element that
                    // stops the event propagation.
                    element.bind("click", function(event) {
                        event.stopPropagation();
                    });
                    angular.element($document[0].body).bind("click",                                                                 function(event) {
                        scope.$apply(function() {
                            fn(scope, {$event:event});
                        });
                    });
                };
            }
        };
        return dir;
    }


}());

/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('commissionCard', commissionCard);

    /* @ngInject */
    function commissionCard($state, utilities, $filter, appConstants){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/commissionCard/commissionCard.html',
            scope: {
                commission:'='
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.appConstants = appConstants;
            }

        }
    }

}());

/**
 * @ngdoc directive
 * @name app.widgets.directive:customFilter
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

  'use strict';

  angular
      .module('app.widgets')
      .directive('customFilter', customFilter);

  /* @ngInject */
  function customFilter(tabFilter, apiEndPoints, appConstants){

    return {
      link: link,
      restrict: 'E',
      templateUrl: 'app/widgets/customFilter/customFilter.template.html',
      scope: {
        page: '@',
        title:'@',
        endPoint: '@',
        heading: '@',
        subheading: '@',
        onSelectedValuesChanged:'&'
      },
      replace:true
    };

    /////////////////////



    function link(scope, elem, attrs){
      scope.dropDownValues = [];
      scope.intialized = true;
      console.log('is loading False');
      function onFilterSuccessCallBack(response){
        scope.appConstants = appConstants;
        scope.apiEndPoints = apiEndPoints;
        scope.noneSelected = response.list;
        scope.allSelected = angular.copy(scope.noneSelected);
        angular.forEach(scope.allSelected, function(value, key){
          value.selected = true;
        });
        scope.dropDownValues = angular.copy(scope.allSelected);
        scope.selectedValues = angular.copy(scope.dropDownValues);
        scope.onSelectedValuesChanged({selectedList:scope.selectedValues, initialized: scope.intialized});
        console.log('is loading False');
        scope.isLoading = false;
        scope.intialized = false;
      }

      initiateFilterType(scope.title);

      function initiateFilterType(title){
        scope.isLoading = true;
        if(scope.endPoint === apiEndPoints.dropDown.business){
          return tabFilter.getTabFilters(scope.endPoint, {'type': title, 'page': scope.page}).then(onFilterSuccessCallBack);
        }
        else{
          return tabFilter.getTabFilters(scope.endPoint).then(onFilterSuccessCallBack);
        }
      }


      scope.dropDownCallBack = function(res){
        if(res.success === false ){
          toastr.error(res.message,'Error '+bpType);
        }
      };


      scope.onSelectAll = onSelectAll;
      scope.onSingleSelectChange = onSingleSelectChange;
      scope.selectAll = true;
      scope.showOptions = false;
      scope.dropDownValues={};
      scope.textFilter = '';
      scope.selectedValues = [];
      scope.invertShowOptions = function(){
        scope.showOptions = !scope.showOptions;
      };
      scope.closeFilter = function(){
        if(scope.showOptions){
          scope.showOptions = false;
          scope.onSelectedValuesChanged({selectedList:scope.selectedValues});
        }
      };



      function onSelectAll(selectAll){
        if(selectAll){
          scope.dropDownValues = angular.copy(scope.allSelected);
          scope.selectedValues = angular.copy(scope.dropDownValues);
        }
        else{
          scope.dropDownValues = angular.copy(scope.noneSelected);
          scope.selectedValues = [];

        }
      }

      function onSingleSelectChange(value,change,property){
        scope.selectAll = false;
        if(change){
          scope.selectedValues.push(value);
        }
        else{
          _.remove(scope.selectedValues, function(obj){
            return (obj[property]==value[property]);
          });
        }
      }

    }
  }

}());

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/widgets/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/widgets/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/widgets/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/widgets/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('datePickerInput', datePickerInput);

    /** @ngInject */
    function datePickerInput() {
        return {
            restrict: 'E',
            link: link,
            templateUrl: 'app/widgets/datePickerInput/datePickerInput.html',
            replace:true,
            scope:{
                date: '=',
                name: '@',
                blank: '=',
                required: '=?',
                position: '@?',
                utc: '=?'

            }
        };
    }

    function link(scope, elem, attrs){
       scope.isOpen = false;
       var date = new Date();
       scope.timezone = (scope.utc) ? {'timezone': 'utc'} : {'timezone' : ((date.getTimezoneOffset() / 60) * -100)};
       console.log(scope.timezone);
       scope.required = (scope.required === undefined) ? false : scope.required;
       scope.position = (scope.position === undefined) ? 'bottom-left': scope.position;
       if(!scope.date && !scope.blank){
           scope.date = new Date();
       }
       else if((typeof scope.date)==='string'){
           scope.date = new Date(scope.date);
       }
       scope.dateFormat = 'dd-MMMM-yyyy';
       scope.open = function(){
           scope.isOpen = !scope.isOpen;
       }


    }
})();
/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('deAccordian', deAccordian);

    /* @ngInject */
    function deAccordian($state, utilities){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/deAccordian/deAccordian.html',
            scope: {
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.tabs = utilities.getStatesForAccordian($state.current);
                scope.tabClicked = tabClicked;
            }
            function tabClicked(event,tab, parentTab, index){
                if(!tab.hasAccordianDropDown){
                    tab.active=index;
                    if(parentTab){
                        parentTab.active=index;
                    }
                    console.log(tab.name);
                    $state.go(tab.name);
                }
                else{
                    event.stopPropagation();
                }
            }
        }
    }

}());

/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('docCard', docCard);

    /* @ngInject */
    function docCard($state, utilities){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/docCard/docCard.html',
            scope: {
                docInfo:'='
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){

            }

        }
    }

}());

/**
 * @ngdoc directive
 * @name app.widgets.directive:filterBar
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('filterBar', filterBar);

    /* @ngInject */
    function filterBar(appFormats, appTabFilter, apiEndPoints){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/filterBar/filterBar.template.html',
            scope: {
                page: '@',
                test: '=',
                datePickerNeeded:'=',
                warehouse: '=',
                localTrader: '=',
                localBuyer:'=',
                localSeller:'=',
                seller:'=',
                buyer:'=',
                product:'=',
                tranStatus:'=',
                bpTypes:'=',
                country:'=',
                productItems: '=',
                priceMarket: '=',
                datePicker: '=',
                onProductItemSelectedChanged: '&',
                onPriceMarketSelectedChanged: '&',
                onBpTypesSelectedChanged:'&',
                onLocalBuyerSelectedChanged:'&',
                onLocalSellerSelectedChanged:'&',
                onBuyersSelectedChanged:'&',
                onSellersSelectedChanged:'&',
                onProductsSelectedChanged:'&',
                onCountrySelectedChanged:'&',
                onTranStatusSelectedChanged:'&',
                onLocalTraderSelectedChanged:'&',
                onWarehouseSelectedChanged:'&',
                onDateChange:'&'
            }

        };

        /////////////////////

        function link(scope, elem, attrs){
            scope.apiEndPoints = apiEndPoints;
            scope.appTabFilter = appTabFilter;
            scope.appFormats = appFormats;
            scope.maxDate = moment();
            scope.ranges= {
                'Today': [moment().startOf('day'), moment().endOf('day').subtract(1, 'seconds')],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(7, 'days'), moment()],
                'Last 2 Weeks': [moment().subtract(14,'days').startOf('day'),moment().endOf('day')],
                'Last 30 Days': [moment().subtract(30, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment()],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'This Year': [moment().startOf('year'), moment()],
                'Last 1 Year': [moment().subtract(1, 'year'),moment()]
            };
            scope.seperator = ' to ';
            scope.datePickerChanged = function(dateRange){
                dateRange.startDate = dateRange.startDate.removeTime();
                dateRange.endDate = dateRange.endDate.removeTime();
                scope.onDateChange({dateRange: dateRange});
            };
        }
    }

}());

// /**
//  * @author v.lugovksy
//  * created on 16.12.2015
//  */
// (function () {
//     'use strict';
//
//     angular.module('app.widgets')
//         .directive('limitTags', limitTags);
//
//     /** @ngInject */
//     function limitTags() {
//         return {
//             require: 'ngModel',
//             link: function(scope, elem, attrs, ngModel) {
//                 var maxTags = parseInt(attrs.maxTags, 10);
//                 ngModel.$parsers.unshift(function(value) {
//                     if (value && value.length > maxTags) {
//                         value.splice(value.length - 1, 1);
//                     }
//                     return value;
//                 });
//             }
//         };
//     }
// })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('lineChart', lineChart);

  /** @ngInject */
  function lineChart() {
    return {
      restrict: 'E',
      controller: 'LineChartCtrl',
      templateUrl: 'app/widgets/lineChart/lineChart.html',
      scope:{
        chartData: '=',
        chartValues: '=',
        chartType: '='
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('LineChartCtrl', lineChartCtrl);

  /** @ngInject */
  function lineChartCtrl($scope, baConfig, layoutPaths, baUtil, utilities) {
    var chartType = ($scope.chartType) ? $scope.chartType : 'column';
    var layoutColors = baConfig.colors;
    var chartColors = utilities.chartColors();
    var graphColor = baConfig.theme.blur ? '#21b799' : layoutColors.primary;
    
    var chart = makeChart();

    $scope.$watch('chartData', function(){
      chart = makeChart();
    });




    function makeChart(){
      var graphs = [];
      angular.forEach($scope.chartValues, function(val, key){
        graphs.push({
          id: 'g'+key,
          bullet: (chartType==='line') ? "round" :'none',
          useLineColorForBulletBorder: true,
          lineColor: chartColors[key],
          lineThickness: (chartType==='line') ? 2 : 1,
          negativeLineColor: layoutColors.danger,
          type: chartType,
          valueField: val,
          fillAlphas: (chartType==='line') ? 0 : 1,
          fillColorsField:  'lineColor',

          balloon:{
            "drop":true,
            "adjustBorderColor":false,
            "color":"#ffffff"
          },
          bulletBorderAlpha: 1,
          bulletColor: "#FFFFFF",
          bulletSize: 5,
          hideBulletsCount: 50,
          balloonText: "<span style='font-size:18px;'>[[value]]</span>"

        });
      });

      return AmCharts.makeChart('amchart', {
        type: 'serial',
        theme: 'blur',
        marginTop: 15,
        marginRight: 15,
        dataProvider: $scope.chartData,
        categoryField: 'date',
        categoryAxis: {
          parseDates: true,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        },
        valueAxes: [
          {
            minVerticalGap: 50,
            gridAlpha: 0,
            color: layoutColors.defaultText,
            axisColor: layoutColors.defaultText
          }
        ],
        graphs: graphs,
        chartCursor: {
          categoryBalloonDateFormat: 'DD MMM YYYY',
          categoryBalloonColor: '#684D61',
          categoryBalloonAlpha: 0.7,
          cursorAlpha: 0,
          valueLineEnabled: true,
          valueLineBalloonEnabled: true,
          valueLineAlpha: 0.5
        },
        dataDateFormat: 'DD MMM YYYY',
        export: {
          enabled: true
        },
        creditsPosition: 'bottom-right',
        zoomOutButton: {
          backgroundColor: '#fff',
          backgroundAlpha: 0
        },
        zoomOutText: '',
        pathToImages: layoutPaths.images.amChart
      });
    }


    // function zoomChart() {
    //   chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    // }
    //
    // chart.addListener('rendered', zoomChart);
    // zoomChart();
    // if (chart.zoomChart) {
    //   chart.zoomChart();
    // }
  }
})();
(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('localTradeDelivery', LocalTradeDelivery);

    /* @ngInject */
    function LocalTradeDelivery($state, utilities, $filter, appConstants){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/localTradeDelivery/localTradeDelivery.html',
            scope: {
                colSize:'@',
                deliveryObj:'='
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
            }

        }
    }

}());
(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('localTradePayment', localTradePayment);

    /* @ngInject */
    function localTradePayment($state, utilities, $filter, appConstants){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/localTradePayment/localTradePayment.html',
            scope: {
                colSize:'@',
                paymentObj:'='
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){

            }
        }
    }

}());
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(utilities, $scope, baConfig, $timeout, layoutPaths) {
    // var layoutColors = baConfig.colors;
    var colors = utilities.chartColors();
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    angular.forEach($scope.mapChartData, function(val, key){
      if(val){
        val.color = colors[key];
      }
    });

    var mapData = $scope.mapChartData;

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    // map.addTitle($scope.heading, 14);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 3 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 3 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;
      if(id){
        dataProvider.images.push({
          type: 'circle',
          width: size,
          height: size,
          color: dataItem.color,
          longitude: latlong[id].longitude,
          latitude: latlong[id].latitude,
          title: dataItem.name,
          value: value
        });
      }
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('app.widgets')
        .directive('mapBubbles', lineChart);

    /** @ngInject */
    function lineChart() {
        return {
            restrict: 'E',
            controller: 'MapBubblePageCtrl',
            templateUrl: 'app/widgets/mapBubbles/mapBubbles.html',
            scope:{
                chartData: '=',
                chartValues: '=',
                heading: '@',
                mapChartData: '='
            }
        };
    }
})();
/*!
 * ngTagsInput v3.1.2
 * http://mbenford.github.io/ngTagsInput
 *
 * Copyright (c) 2013-2017 Michael Benford
 * License: MIT
 *
 * Generated at 2017-03-31 01:12:33 -0300
 */
(function() {
    'use strict';

    var KEYS = {
        backspace: 8,
        tab: 9,
        enter: 13,
        escape: 27,
        space: 32,
        up: 38,
        down: 40,
        left: 37,
        right: 39,
        delete: 46,
        comma: 188
    };

    var MAX_SAFE_INTEGER = 9007199254740991;
    var SUPPORTED_INPUT_TYPES = ['text', 'email', 'url'];

    var tagsInput = angular.module('app.widgets');

    /**
     * @ngdoc directive
     * @name tagsInput
     * @module ngTagsInput
     *
     * @description
     * Renders an input box with tag editing support.
     *
     * @param {string} ngModel Assignable Angular expression to data-bind to.
     * @param {string=} [template=NA] URL or id of a custom template for rendering each tag.
     * @param {string=} [templateScope=NA] Scope to be passed to custom templates - of both tagsInput and
     *    autoComplete directives - as $scope.
     * @param {string=} [displayProperty=text] Property to be rendered as the tag label.
     * @param {string=} [keyProperty=text] Property to be used as a unique identifier for the tag.
     * @param {string=} [type=text] Type of the input element. Only 'text', 'email' and 'url' are supported values.
     * @param {string=} [text=NA] Assignable Angular expression for data-binding to the element's text.
     * @param {number=} tabindex Tab order of the control.
     * @param {string=} [placeholder=Add a tag] Placeholder text for the control.
     * @param {number=} [minLength=3] Minimum length for a new tag.
     * @param {number=} [maxLength=MAX_SAFE_INTEGER] Maximum length allowed for a new tag.
     * @param {number=} [minTags=0] Sets minTags validation error key if the number of tags added is less than minTags.
     * @param {number=} [maxTags=MAX_SAFE_INTEGER] Sets maxTags validation error key if the number of tags added is greater
     *    than maxTags.
     * @param {boolean=} [allowLeftoverText=false] Sets leftoverText validation error key if there is any leftover text in
     *    the input element when the directive loses focus.
     * @param {string=} [removeTagSymbol=×] (Obsolete) Symbol character for the remove tag button.
     * @param {boolean=} [addOnEnter=true] Flag indicating that a new tag will be added on pressing the ENTER key.
     * @param {boolean=} [addOnSpace=false] Flag indicating that a new tag will be added on pressing the SPACE key.
     * @param {boolean=} [addOnComma=true] Flag indicating that a new tag will be added on pressing the COMMA key.
     * @param {boolean=} [addOnBlur=true] Flag indicating that a new tag will be added when the input field loses focus.
     * @param {boolean=} [addOnPaste=false] Flag indicating that the text pasted into the input field will be split into tags.
     * @param {string=} [pasteSplitPattern=,] Regular expression used to split the pasted text into tags.
     * @param {boolean=} [replaceSpacesWithDashes=true] Flag indicating that spaces will be replaced with dashes.
     * @param {string=} [allowedTagsPattern=.+] Regular expression that determines whether a new tag is valid.
     * @param {boolean=} [enableEditingLastTag=false] Flag indicating that the last tag will be moved back into the new tag
     *    input box instead of being removed when the backspace key is pressed and the input box is empty.
     * @param {boolean=} [addFromAutocompleteOnly=false] Flag indicating that only tags coming from the autocomplete list
     *    will be allowed. When this flag is true, addOnEnter, addOnComma, addOnSpace and addOnBlur values are ignored.
     * @param {boolean=} [spellcheck=true] Flag indicating whether the browser's spellcheck is enabled for the input field or not.
     * @param {expression=} [tagClass=NA] Expression to evaluate for each existing tag in order to get the CSS classes to be used.
     *    The expression is provided with the current tag as $tag, its index as $index and its state as $selected. The result
     *    of the evaluation must be one of the values supported by the ngClass directive (either a string, an array or an object).
     *    See https://docs.angularjs.org/api/ng/directive/ngClass for more information.
     * @param {expression=} [onTagAdding=NA] Expression to evaluate that will be invoked before adding a new tag. The new
     *    tag is available as $tag. This method must return either a boolean value or a promise. If either a false value or a rejected
     *    promise is returned, the tag will not be added.
     * @param {expression=} [onTagAdded=NA] Expression to evaluate upon adding a new tag. The new tag is available as $tag.
     * @param {expression=} [onInvalidTag=NA] Expression to evaluate when a tag is invalid. The invalid tag is available as $tag.
     * @param {expression=} [onTagRemoving=NA] Expression to evaluate that will be invoked before removing a tag. The tag
     *    is available as $tag. This method must return either a boolean value or a promise. If either a false value or a rejected
     *    promise is returned, the tag will not be removed.
     * @param {expression=} [onTagRemoved=NA] Expression to evaluate upon removing an existing tag. The removed tag is available as $tag.
     * @param {expression=} [onTagClicked=NA] Expression to evaluate upon clicking an existing tag. The clicked tag is available as $tag.
     */
    tagsInput.directive('tagsInput', ["$timeout", "$document", "$window", "$q", "tagsInputConfig", "tiUtil", function($timeout, $document, $window, $q, tagsInputConfig, tiUtil) {
        function TagList(options, events, onTagAdding, onTagRemoving) {
            var self = {}, getTagText, setTagText, canAddTag, canRemoveTag;

            getTagText = function(tag) {
                return tiUtil.safeToString(tag[options.displayProperty]);
            };

            setTagText = function(tag, text) {
                tag[options.displayProperty] = text;
            };

            canAddTag = function(tag) {
                var tagText = getTagText(tag);
                var valid = tagText &&
                    tagText.length >= options.minLength &&
                    tagText.length <= options.maxLength &&
                    options.allowedTagsPattern.test(tagText) &&
                    !tiUtil.findInObjectArray(self.items, tag, options.keyProperty || options.displayProperty);

                return $q.when(valid && onTagAdding({ $tag: tag })).then(tiUtil.promisifyValue);
            };

            canRemoveTag = function(tag) {
                return $q.when(onTagRemoving({ $tag: tag })).then(tiUtil.promisifyValue);
            };

            self.items = [];

            self.addText = function(text) {
                var tag = {};
                setTagText(tag, text);
                return self.add(tag);
            };

            self.add = function(tag) {
                var tagText = getTagText(tag);

                if (options.replaceSpacesWithDashes) {
                    tagText = tiUtil.replaceSpacesWithDashes(tagText);
                }

                setTagText(tag, tagText);

                return canAddTag(tag)
                    .then(function() {
                        self.items.push(tag);
                        events.trigger('tag-added', { $tag: tag });
                    })
                    .catch(function() {
                        if (tagText) {
                            events.trigger('invalid-tag', { $tag: tag });
                        }
                    });
            };

            self.remove = function(index) {
                var tag = self.items[index];

                return canRemoveTag(tag).then(function() {
                    self.items.splice(index, 1);
                    self.clearSelection();
                    events.trigger('tag-removed', { $tag: tag });
                    return tag;
                });
            };

            self.select = function(index) {
                if (index < 0) {
                    index = self.items.length - 1;
                }
                else if (index >= self.items.length) {
                    index = 0;
                }

                self.index = index;
                self.selected = self.items[index];
            };

            self.selectPrior = function() {
                self.select(--self.index);
            };

            self.selectNext = function() {
                self.select(++self.index);
            };

            self.removeSelected = function() {
                return self.remove(self.index);
            };

            self.clearSelection = function() {
                self.selected = null;
                self.index = -1;
            };

            self.clearSelection();

            return self;
        }

        function validateType(type) {
            return SUPPORTED_INPUT_TYPES.indexOf(type) !== -1;
        }

        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                tags: '=ngModel',
                text: '=?',
                templateScope: '=?',
                tagClass: '&',
                onTagAdding: '&',
                onTagAdded: '&',
                onInvalidTag: '&',
                onTagRemoving: '&',
                onTagRemoved: '&',
                onTagClicked: '&',
            },
            replace: false,
            transclude: true,
            templateUrl: 'ngTagsInput/tags-input.html',
            controller: ["$scope", "$attrs", "$element", function($scope, $attrs, $element) {
                $scope.events = tiUtil.simplePubSub();

                tagsInputConfig.load('tagsInput', $scope, $attrs, {
                    template: [String, 'ngTagsInput/tag-item.html'],
                    type: [String, 'text', validateType],
                    placeholder: [String, 'Add a tag'],
                    tabindex: [Number, null],
                    removeTagSymbol: [String, String.fromCharCode(215)],
                    replaceSpacesWithDashes: [Boolean, true],
                    minLength: [Number, 3],
                    maxLength: [Number, MAX_SAFE_INTEGER],
                    addOnEnter: [Boolean, true],
                    addOnSpace: [Boolean, false],
                    addOnComma: [Boolean, true],
                    addOnBlur: [Boolean, true],
                    addOnPaste: [Boolean, false],
                    pasteSplitPattern: [RegExp, /,/],
                    allowedTagsPattern: [RegExp, /.+/],
                    enableEditingLastTag: [Boolean, false],
                    minTags: [Number, 0],
                    maxTags: [Number, MAX_SAFE_INTEGER],
                    displayProperty: [String, 'text'],
                    keyProperty: [String, ''],
                    allowLeftoverText: [Boolean, false],
                    addFromAutocompleteOnly: [Boolean, false],
                    spellcheck: [Boolean, true]
                });

                $scope.tagList = new TagList($scope.options, $scope.events,
                    tiUtil.handleUndefinedResult($scope.onTagAdding, true),
                    tiUtil.handleUndefinedResult($scope.onTagRemoving, true));

                this.registerAutocomplete = function() {
                    var input = $element.find('input');

                    return {
                        addTag: function(tag) {
                            return $scope.tagList.add(tag);
                        },
                        getTags: function() {
                            return $scope.tagList.items;
                        },
                        getCurrentTagText: function() {
                            return $scope.newTag.text();
                        },
                        getOptions: function() {
                            return $scope.options;
                        },
                        getTemplateScope: function() {
                            return $scope.templateScope;
                        },
                        on: function(name, handler) {
                            $scope.events.on(name, handler, true);
                            return this;
                        }
                    };
                };

                this.registerTagItem = function() {
                    return {
                        getOptions: function() {
                            return $scope.options;
                        },
                        removeTag: function(index) {
                            if ($scope.disabled) {
                                return;
                            }
                            $scope.tagList.remove(index);
                        }
                    };
                };
            }],
            link: function(scope, element, attrs, ngModelCtrl) {
                var hotkeys = [KEYS.enter, KEYS.comma, KEYS.space, KEYS.backspace, KEYS.delete, KEYS.left, KEYS.right],
                    tagList = scope.tagList,
                    events = scope.events,
                    options = scope.options,
                    input = element.find('input'),
                    validationOptions = ['minTags', 'maxTags', 'allowLeftoverText'],
                    setElementValidity,
                    focusInput;

                setElementValidity = function() {
                    ngModelCtrl.$setValidity('maxTags', tagList.items.length <= options.maxTags);
                    ngModelCtrl.$setValidity('minTags', tagList.items.length >= options.minTags);
                    ngModelCtrl.$setValidity('leftoverText', scope.hasFocus || options.allowLeftoverText ? true : !scope.newTag.text());
                };

                focusInput = function() {
                    $timeout(function() { input[0].focus(); });
                };

                ngModelCtrl.$isEmpty = function(value) {
                    return !value || !value.length;
                };

                scope.newTag = {
                    text: function(value) {
                        if (angular.isDefined(value)) {
                            scope.text = value;
                            events.trigger('input-change', value);
                        }
                        else {
                            return scope.text || '';
                        }
                    },
                    invalid: null
                };

                scope.track = function(tag) {
                    return tag[options.keyProperty || options.displayProperty];
                };

                scope.getTagClass = function(tag, index) {
                    var selected = tag === tagList.selected;
                    return [
                        scope.tagClass({$tag: tag, $index: index, $selected: selected}),
                        { selected: selected }
                    ];
                };

                scope.$watch('tags', function(value) {
                    if (value) {
                        tagList.items = tiUtil.makeObjectArray(value, options.displayProperty);
                        scope.tags = tagList.items;
                    }
                    else {
                        tagList.items = [];
                    }
                });

                scope.$watch('tags.length', function() {
                    setElementValidity();

                    // ngModelController won't trigger validators when the model changes (because it's an array),
                    // so we need to do it ourselves. Unfortunately this won't trigger any registered formatter.
                    ngModelCtrl.$validate();
                });

                attrs.$observe('disabled', function(value) {
                    scope.disabled = value;
                });

                scope.eventHandlers = {
                    input: {
                        keydown: function($event) {
                            events.trigger('input-keydown', $event);
                        },
                        focus: function() {
                            if (scope.hasFocus) {
                                return;
                            }

                            scope.hasFocus = true;
                            events.trigger('input-focus');
                        },
                        blur: function() {
                            $timeout(function() {
                                var activeElement = $document.prop('activeElement'),
                                    lostFocusToBrowserWindow = activeElement === input[0],
                                    lostFocusToChildElement = element[0].contains(activeElement);

                                if (lostFocusToBrowserWindow || !lostFocusToChildElement) {
                                    scope.hasFocus = false;
                                    events.trigger('input-blur');
                                }
                            });
                        },
                        paste: function($event) {
                            $event.getTextData = function() {
                                var clipboardData = $event.clipboardData || ($event.originalEvent && $event.originalEvent.clipboardData);
                                return clipboardData ? clipboardData.getData('text/plain') : $window.clipboardData.getData('Text');
                            };
                            events.trigger('input-paste', $event);
                        }
                    },
                    host: {
                        click: function() {
                            if (scope.disabled) {
                                return;
                            }
                            focusInput();
                        }
                    },
                    tag: {
                        click: function(tag) {
                            events.trigger('tag-clicked', { $tag: tag });
                        }
                    }
                };

                events
                    .on('tag-added', scope.onTagAdded)
                    .on('invalid-tag', scope.onInvalidTag)
                    .on('tag-removed', scope.onTagRemoved)
                    .on('tag-clicked', scope.onTagClicked)
                    .on('tag-added', function() {
                        scope.newTag.text('');
                    })
                    .on('tag-added tag-removed', function() {
                        scope.tags = tagList.items;
                        // Ideally we should be able call $setViewValue here and let it in turn call $setDirty and $validate
                        // automatically, but since the model is an array, $setViewValue does nothing and it's up to us to do it.
                        // Unfortunately this won't trigger any registered $parser and there's no safe way to do it.
                        ngModelCtrl.$setDirty();
                        focusInput();
                    })
                    .on('invalid-tag', function() {
                        scope.newTag.invalid = true;
                    })
                    .on('option-change', function(e) {
                        if (validationOptions.indexOf(e.name) !== -1) {
                            setElementValidity();
                        }
                    })
                    .on('input-change', function() {
                        tagList.clearSelection();
                        scope.newTag.invalid = null;
                    })
                    .on('input-focus', function() {
                        element.triggerHandler('focus');
                        ngModelCtrl.$setValidity('leftoverText', true);
                    })
                    .on('input-blur', function() {
                        if (options.addOnBlur && !options.addFromAutocompleteOnly) {
                            tagList.addText(scope.newTag.text());
                        }
                        element.triggerHandler('blur');
                        setElementValidity();
                    })
                    .on('input-keydown', function(event) {
                        var key = event.keyCode,
                            addKeys = {},
                            shouldAdd, shouldRemove, shouldSelect, shouldEditLastTag;

                        if (tiUtil.isModifierOn(event) || hotkeys.indexOf(key) === -1) {
                            return;
                        }

                        addKeys[KEYS.enter] = options.addOnEnter;
                        addKeys[KEYS.comma] = options.addOnComma;
                        addKeys[KEYS.space] = options.addOnSpace;

                        shouldAdd = !options.addFromAutocompleteOnly && addKeys[key];
                        shouldRemove = (key === KEYS.backspace || key === KEYS.delete) && tagList.selected;
                        shouldEditLastTag = key === KEYS.backspace && scope.newTag.text().length === 0 && options.enableEditingLastTag;
                        shouldSelect = (key === KEYS.backspace || key === KEYS.left || key === KEYS.right) && scope.newTag.text().length === 0 && !options.enableEditingLastTag;

                        if (shouldAdd) {
                            tagList.addText(scope.newTag.text());
                        }
                        else if (shouldEditLastTag) {
                            tagList.selectPrior();
                            tagList.removeSelected().then(function(tag) {
                                if (tag) {
                                    scope.newTag.text(tag[options.displayProperty]);
                                }
                            });
                        }
                        else if (shouldRemove) {
                            tagList.removeSelected();
                        }
                        else if (shouldSelect) {
                            if (key === KEYS.left || key === KEYS.backspace) {
                                tagList.selectPrior();
                            }
                            else if (key === KEYS.right) {
                                tagList.selectNext();
                            }
                        }

                        if (shouldAdd || shouldSelect || shouldRemove || shouldEditLastTag) {
                            event.preventDefault();
                        }
                    })
                    .on('input-paste', function(event) {
                        if (options.addOnPaste) {
                            var data = event.getTextData();
                            var tags = data.split(options.pasteSplitPattern);

                            if (tags.length > 1) {
                                tags.forEach(function(tag) {
                                    tagList.addText(tag);
                                });
                                event.preventDefault();
                            }
                        }
                    });
            }
        };
    }]);


    /**
     * @ngdoc directive
     * @name tiTagItem
     * @module ngTagsInput
     *
     * @description
     * Represents a tag item. Used internally by the tagsInput directive.
     */
    tagsInput.directive('tiTagItem', ["tiUtil", function(tiUtil) {
        return {
            restrict: 'E',
            require: '^tagsInput',
            template: '<ng-include src="$$template"></ng-include>',
            scope: {
                $scope: '=scope',
                data: '='
            },
            link: function(scope, element, attrs, tagsInputCtrl) {
                var tagsInput = tagsInputCtrl.registerTagItem(),
                    options = tagsInput.getOptions();

                scope.$$template = options.template;
                scope.$$removeTagSymbol = options.removeTagSymbol;

                scope.$getDisplayText = function() {
                    return tiUtil.safeToString(scope.data[options.displayProperty]);
                };
                scope.$removeTag = function() {
                    tagsInput.removeTag(scope.$index);
                };

                scope.$watch('$parent.$index', function(value) {
                    scope.$index = value;
                });
            }
        };
    }]);


    /**
     * @ngdoc directive
     * @name autoComplete
     * @module ngTagsInput
     *
     * @description
     * Provides autocomplete support for the tagsInput directive.
     *
     * @param {expression} source Expression to evaluate upon changing the input content. The input value is available as
     *    $query. The result of the expression must be a promise that eventually resolves to an array of strings.
     * @param {string=} [template=NA] URL or id of a custom template for rendering each element of the autocomplete list.
     * @param {string=} [displayProperty=tagsInput.displayText] Property to be rendered as the autocomplete label.
     * @param {number=} [debounceDelay=100] Amount of time, in milliseconds, to wait before evaluating the expression in
     *    the source option after the last keystroke.
     * @param {number=} [minLength=3] Minimum number of characters that must be entered before evaluating the expression
     *    in the source option.
     * @param {boolean=} [highlightMatchedText=true] Flag indicating that the matched text will be highlighted in the
     *    suggestions list.
     * @param {number=} [maxResultsToShow=10] Maximum number of results to be displayed at a time.
     * @param {boolean=} [loadOnDownArrow=false] Flag indicating that the source option will be evaluated when the down arrow
     *    key is pressed and the suggestion list is closed. The current input value is available as $query.
     * @param {boolean=} [loadOnEmpty=false] Flag indicating that the source option will be evaluated when the input content
     *    becomes empty. The $query variable will be passed to the expression as an empty string.
     * @param {boolean=} [loadOnFocus=false] Flag indicating that the source option will be evaluated when the input element
     *    gains focus. The current input value is available as $query.
     * @param {boolean=} [selectFirstMatch=true] Flag indicating that the first match will be automatically selected once
     *    the suggestion list is shown.
     * @param {expression=} [matchClass=NA] Expression to evaluate for each match in order to get the CSS classes to be used.
     *    The expression is provided with the current match as $match, its index as $index and its state as $selected. The result
     *    of the evaluation must be one of the values supported by the ngClass directive (either a string, an array or an object).
     *    See https://docs.angularjs.org/api/ng/directive/ngClass for more information.
     */
    tagsInput.directive('autoComplete', ["$document", "$timeout", "$sce", "$q", "tagsInputConfig", "tiUtil", function($document, $timeout, $sce, $q, tagsInputConfig, tiUtil) {
        function SuggestionList(loadFn, options, events) {
            var self = {}, getDifference, lastPromise, getTagId;

            getTagId = function() {
                return options.tagsInput.keyProperty || options.tagsInput.displayProperty;
            };

            getDifference = function(array1, array2) {
                return array1.filter(function(item) {
                    return !tiUtil.findInObjectArray(array2, item, getTagId(), function(a, b) {
                        if (options.tagsInput.replaceSpacesWithDashes) {
                            a = tiUtil.replaceSpacesWithDashes(a);
                            b = tiUtil.replaceSpacesWithDashes(b);
                        }
                        return tiUtil.defaultComparer(a, b);
                    });
                });
            };

            self.reset = function() {
                lastPromise = null;

                self.items = [];
                self.visible = false;
                self.index = -1;
                self.selected = null;
                self.query = null;
            };
            self.show = function() {
                if (options.selectFirstMatch) {
                    self.select(0);
                }
                else {
                    self.selected = null;
                }
                self.visible = true;
            };
            self.load = tiUtil.debounce(function(query, tags) {
                self.query = query;

                var promise = $q.when(loadFn({ $query: query }));
                lastPromise = promise;

                promise.then(function(items) {
                    if (promise !== lastPromise) {
                        return;
                    }

                    items = tiUtil.makeObjectArray(items.data || items, getTagId());
                    items = getDifference(items, tags);
                    self.items = items.slice(0, options.maxResultsToShow);

                    if (self.items.length > 0) {
                        self.show();
                    }
                    else {
                        self.reset();
                    }
                });
            }, options.debounceDelay);

            self.selectNext = function() {
                self.select(++self.index);
            };
            self.selectPrior = function() {
                self.select(--self.index);
            };
            self.select = function(index) {
                if (index < 0) {
                    index = self.items.length - 1;
                }
                else if (index >= self.items.length) {
                    index = 0;
                }
                self.index = index;
                self.selected = self.items[index];
                events.trigger('suggestion-selected', index);
            };

            self.reset();

            return self;
        }

        function scrollToElement(root, index) {
            var element = root.find('li').eq(index),
                parent = element.parent(),
                elementTop = element.prop('offsetTop'),
                elementHeight = element.prop('offsetHeight'),
                parentHeight = parent.prop('clientHeight'),
                parentScrollTop = parent.prop('scrollTop');

            if (elementTop < parentScrollTop) {
                parent.prop('scrollTop', elementTop);
            }
            else if (elementTop + elementHeight > parentHeight + parentScrollTop) {
                parent.prop('scrollTop', elementTop + elementHeight - parentHeight);
            }
        }

        return {
            restrict: 'E',
            require: '^tagsInput',
            scope: {
                source: '&',
                matchClass: '&'
            },
            templateUrl: 'ngTagsInput/auto-complete.html',
            controller: ["$scope", "$element", "$attrs", function($scope, $element, $attrs) {
                $scope.events = tiUtil.simplePubSub();

                tagsInputConfig.load('autoComplete', $scope, $attrs, {
                    template: [String, 'ngTagsInput/auto-complete-match.html'],
                    debounceDelay: [Number, 100],
                    minLength: [Number, 3],
                    highlightMatchedText: [Boolean, true],
                    maxResultsToShow: [Number, 10],
                    loadOnDownArrow: [Boolean, false],
                    loadOnEmpty: [Boolean, false],
                    loadOnFocus: [Boolean, false],
                    selectFirstMatch: [Boolean, true],
                    displayProperty: [String, '']
                });

                $scope.suggestionList = new SuggestionList($scope.source, $scope.options, $scope.events);

                this.registerAutocompleteMatch = function() {
                    return {
                        getOptions: function() {
                            return $scope.options;
                        },
                        getQuery: function() {
                            return $scope.suggestionList.query;
                        }
                    };
                };
            }],
            link: function(scope, element, attrs, tagsInputCtrl) {
                var hotkeys = [KEYS.enter, KEYS.tab, KEYS.escape, KEYS.up, KEYS.down],
                    suggestionList = scope.suggestionList,
                    tagsInput = tagsInputCtrl.registerAutocomplete(),
                    options = scope.options,
                    events = scope.events,
                    shouldLoadSuggestions;

                options.tagsInput = tagsInput.getOptions();

                shouldLoadSuggestions = function(value) {
                    return value && value.length >= options.minLength || !value && options.loadOnEmpty;
                };

                scope.templateScope = tagsInput.getTemplateScope();

                scope.addSuggestionByIndex = function(index) {
                    suggestionList.select(index);
                    scope.addSuggestion();
                };

                scope.addSuggestion = function() {
                    var added = false;

                    if (suggestionList.selected) {
                        tagsInput.addTag(angular.copy(suggestionList.selected));
                        suggestionList.reset();
                        added = true;
                    }
                    return added;
                };

                scope.track = function(item) {
                    return item[options.tagsInput.keyProperty || options.tagsInput.displayProperty];
                };

                scope.getSuggestionClass = function(item, index) {
                    var selected = item === suggestionList.selected;
                    return [
                        scope.matchClass({$match: item, $index: index, $selected: selected}),
                        { selected: selected }
                    ];
                };

                tagsInput
                    .on('tag-added tag-removed invalid-tag input-blur', function() {
                        suggestionList.reset();
                    })
                    .on('input-change', function(value) {
                        if (shouldLoadSuggestions(value)) {
                            suggestionList.load(value, tagsInput.getTags());
                        }
                        else {
                            suggestionList.reset();
                        }
                    })
                    .on('input-focus', function() {
                        var value = tagsInput.getCurrentTagText();
                        if (options.loadOnFocus && shouldLoadSuggestions(value)) {
                            suggestionList.load(value, tagsInput.getTags());
                        }
                    })
                    .on('input-keydown', function(event) {
                        var key = event.keyCode,
                            handled = false;

                        if (tiUtil.isModifierOn(event) || hotkeys.indexOf(key) === -1) {
                            return;
                        }

                        if (suggestionList.visible) {

                            if (key === KEYS.down) {
                                suggestionList.selectNext();
                                handled = true;
                            }
                            else if (key === KEYS.up) {
                                suggestionList.selectPrior();
                                handled = true;
                            }
                            else if (key === KEYS.escape) {
                                suggestionList.reset();
                                handled = true;
                            }
                            else if (key === KEYS.enter || key === KEYS.tab) {
                                handled = scope.addSuggestion();
                            }
                        }
                        else {
                            if (key === KEYS.down && scope.options.loadOnDownArrow) {
                                suggestionList.load(tagsInput.getCurrentTagText(), tagsInput.getTags());
                                handled = true;
                            }
                        }

                        if (handled) {
                            event.preventDefault();
                            event.stopImmediatePropagation();
                            return false;
                        }
                    });

                events.on('suggestion-selected', function(index) {
                    scrollToElement(element, index);
                });
            }
        };
    }]);


    /**
     * @ngdoc directive
     * @name tiAutocompleteMatch
     * @module ngTagsInput
     *
     * @description
     * Represents an autocomplete match. Used internally by the autoComplete directive.
     */
    tagsInput.directive('tiAutocompleteMatch', ["$sce", "tiUtil", function($sce, tiUtil) {
        return {
            restrict: 'E',
            require: '^autoComplete',
            template: '<ng-include src="$$template"></ng-include>',
            scope: {
                $scope: '=scope',
                data: '='
            },
            link: function(scope, element, attrs, autoCompleteCtrl) {
                var autoComplete = autoCompleteCtrl.registerAutocompleteMatch(),
                    options = autoComplete.getOptions();

                scope.$$template = options.template;
                scope.$index = scope.$parent.$index;

                scope.$highlight = function(text) {
                    if (options.highlightMatchedText) {
                        text = tiUtil.safeHighlight(text, autoComplete.getQuery());
                    }
                    return $sce.trustAsHtml(text);
                };
                scope.$getDisplayText =  function() {
                    return tiUtil.safeToString(scope.data[options.displayProperty || options.tagsInput.displayProperty]);
                };
            }
        };
    }]);


    /**
     * @ngdoc directive
     * @name tiTranscludeAppend
     * @module ngTagsInput
     *
     * @description
     * Re-creates the old behavior of ng-transclude. Used internally by tagsInput directive.
     */
    tagsInput.directive('tiTranscludeAppend', function() {
        return function(scope, element, attrs, ctrl, transcludeFn) {
            transcludeFn(function(clone) {
                element.append(clone);
            });
        };
    });

    /**
     * @ngdoc directive
     * @name tiAutosize
     * @module ngTagsInput
     *
     * @description
     * Automatically sets the input's width so its content is always visible. Used internally by tagsInput directive.
     */
    tagsInput.directive('tiAutosize', ["tagsInputConfig", function(tagsInputConfig) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function(scope, element, attrs, ctrl) {
                var threshold = tagsInputConfig.getTextAutosizeThreshold(),
                    span, resize;

                span = angular.element('<span class="input"></span>');
                span.css('display', 'none')
                    .css('visibility', 'hidden')
                    .css('width', 'auto')
                    .css('white-space', 'pre');

                element.parent().append(span);

                resize = function(originalValue) {
                    var value = originalValue, width;

                    if (angular.isString(value) && value.length === 0) {
                        value = attrs.placeholder;
                    }

                    if (value) {
                        span.text(value);
                        span.css('display', '');
                        width = span.prop('offsetWidth');
                        span.css('display', 'none');
                    }

                    element.css('width', width ? width + threshold + 'px' : '');

                    return originalValue;
                };

                ctrl.$parsers.unshift(resize);
                ctrl.$formatters.unshift(resize);

                attrs.$observe('placeholder', function(value) {
                    if (!ctrl.$modelValue) {
                        resize(value);
                    }
                });
            }
        };
    }]);

    /**
     * @ngdoc directive
     * @name tiBindAttrs
     * @module ngTagsInput
     *
     * @description
     * Binds attributes to expressions. Used internally by tagsInput directive.
     */
    tagsInput.directive('tiBindAttrs', function() {
        return function(scope, element, attrs) {
            scope.$watch(attrs.tiBindAttrs, function(value) {
                angular.forEach(value, function(value, key) {
                    attrs.$set(key, value);
                });
            }, true);
        };
    });

    /**
     * @ngdoc service
     * @name tagsInputConfig
     * @module ngTagsInput
     *
     * @description
     * Sets global configuration settings for both tagsInput and autoComplete directives. It's also used internally to parse and
     *  initialize options from HTML attributes.
     */
    tagsInput.provider('tagsInputConfig', function() {
        var globalDefaults = {},
            interpolationStatus = {},
            autosizeThreshold = 3;

        /**
         * @ngdoc method
         * @name tagsInputConfig#setDefaults
         * @description Sets the default configuration option for a directive.
         *
         * @param {string} directive Name of the directive to be configured. Must be either 'tagsInput' or 'autoComplete'.
         * @param {object} defaults Object containing options and their values.
         *
         * @returns {object} The service itself for chaining purposes.
         */
        this.setDefaults = function(directive, defaults) {
            globalDefaults[directive] = defaults;
            return this;
        };

        /**
         * @ngdoc method
         * @name tagsInputConfig#setActiveInterpolation
         * @description Sets active interpolation for a set of options.
         *
         * @param {string} directive Name of the directive to be configured. Must be either 'tagsInput' or 'autoComplete'.
         * @param {object} options Object containing which options should have interpolation turned on at all times.
         *
         * @returns {object} The service itself for chaining purposes.
         */
        this.setActiveInterpolation = function(directive, options) {
            interpolationStatus[directive] = options;
            return this;
        };

        /**
         * @ngdoc method
         * @name tagsInputConfig#setTextAutosizeThreshold
         * @description Sets the threshold used by the tagsInput directive to re-size the inner input field element based on its contents.
         *
         * @param {number} threshold Threshold value, in pixels.
         *
         * @returns {object} The service itself for chaining purposes.
         */
        this.setTextAutosizeThreshold = function(threshold) {
            autosizeThreshold = threshold;
            return this;
        };

        this.$get = ["$interpolate", function($interpolate) {
            var converters = {};
            converters[String] = function(value) { return value; };
            converters[Number] = function(value) { return parseInt(value, 10); };
            converters[Boolean] = function(value) { return value.toLowerCase() === 'true'; };
            converters[RegExp] = function(value) { return new RegExp(value); };

            return {
                load: function(directive, scope, attrs, options) {
                    var defaultValidator = function() { return true; };

                    scope.options = {};

                    angular.forEach(options, function(value, key) {
                        var type, localDefault, validator, converter, getDefault, updateValue;

                        type = value[0];
                        localDefault = value[1];
                        validator = value[2] || defaultValidator;
                        converter = converters[type];

                        getDefault = function() {
                            var globalValue = globalDefaults[directive] && globalDefaults[directive][key];
                            return angular.isDefined(globalValue) ? globalValue : localDefault;
                        };

                        updateValue = function(value) {
                            scope.options[key] = value && validator(value) ? converter(value) : getDefault();
                        };

                        if (interpolationStatus[directive] && interpolationStatus[directive][key]) {
                            attrs.$observe(key, function(value) {
                                updateValue(value);
                                scope.events.trigger('option-change', { name: key, newValue: value });
                            });
                        }
                        else {
                            updateValue(attrs[key] && $interpolate(attrs[key])(scope.$parent));
                        }
                    });
                },
                getTextAutosizeThreshold: function() {
                    return autosizeThreshold;
                }
            };
        }];
    });


    /***
     * @ngdoc service
     * @name tiUtil
     * @module ngTagsInput
     *
     * @description
     * Helper methods used internally by the directive. Should not be called directly from user code.
     */
    tagsInput.factory('tiUtil', ["$timeout", "$q", function($timeout, $q) {
        var self = {};

        self.debounce = function(fn, delay) {
            var timeoutId;
            return function() {
                var args = arguments;
                $timeout.cancel(timeoutId);
                timeoutId = $timeout(function() { fn.apply(null, args); }, delay);
            };
        };

        self.makeObjectArray = function(array, key) {
            if (!angular.isArray(array) || array.length === 0 || angular.isObject(array[0])) {
                return array;
            }

            var newArray = [];
            array.forEach(function(item) {
                var obj = {};
                obj[key] = item;
                newArray.push(obj);
            });
            return newArray;
        };

        self.findInObjectArray = function(array, obj, key, comparer) {
            var item = null;
            comparer = comparer || self.defaultComparer;

            array.some(function(element) {
                if (comparer(element[key], obj[key])) {
                    item = element;
                    return true;
                }
            });

            return item;
        };

        self.defaultComparer = function(a, b) {
            // I'm aware of the internationalization issues regarding toLowerCase()
            // but I couldn't come up with a better solution right now
            return self.safeToString(a).toLowerCase() === self.safeToString(b).toLowerCase();
        };

        self.safeHighlight = function(str, value) {
            str = self.encodeHTML(str);
            value = self.encodeHTML(value);

            if (!value) {
                return str;
            }

            function escapeRegexChars(str) {
                return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
            }

            var expression = new RegExp('&[^;]+;|' + escapeRegexChars(value), 'gi');
            return str.replace(expression, function(match) {
                return match.toLowerCase() === value.toLowerCase() ? '<em>' + match + '</em>' : match;
            });
        };

        self.safeToString = function(value) {
            return angular.isUndefined(value) || value == null ? '' : value.toString().trim();
        };

        self.encodeHTML = function(value) {
            return self.safeToString(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
        };

        self.handleUndefinedResult = function(fn, valueIfUndefined) {
            return function() {
                var result = fn.apply(null, arguments);
                return angular.isUndefined(result) ? valueIfUndefined : result;
            };
        };

        self.replaceSpacesWithDashes = function(str) {
            return self.safeToString(str).replace(/\s/g, '-');
        };

        self.isModifierOn = function(event) {
            return event.shiftKey || event.ctrlKey || event.altKey || event.metaKey;
        };

        self.promisifyValue = function(value) {
            value = angular.isUndefined(value) ? true : value;
            return $q[value ? 'when' : 'reject']();
        };

        self.simplePubSub = function() {
            var events = {};
            return {
                on: function(names, handler, first) {
                    names.split(' ').forEach(function(name) {
                        if (!events[name]) {
                            events[name] = [];
                        }
                        var method = first ? [].unshift : [].push;
                        method.call(events[name], handler);
                    });
                    return this;
                },
                trigger: function(name, args) {
                    var handlers = events[name] || [];
                    handlers.every(function(handler) {
                        return self.handleUndefinedResult(handler, true)(args);
                    });
                    return this;
                }
            };
        };

        return self;
    }]);


    /* HTML templates */
    tagsInput.run(["$templateCache", function($templateCache) {
        $templateCache.put('ngTagsInput/tags-input.html',
            "<div class=\"host\" tabindex=\"-1\" ng-click=\"eventHandlers.host.click()\" ti-transclude-append><div class=\"tags\" ng-class=\"{focused: hasFocus}\"><ul class=\"tag-list\"><li class=\"tag-item\" ng-repeat=\"tag in tagList.items track by track(tag)\" ng-class=\"getTagClass(tag, $index)\" ng-click=\"eventHandlers.tag.click(tag)\"><ti-tag-item scope=\"templateScope\" data=\"::tag\"></ti-tag-item></li></ul><input class=\"input\" autocomplete=\"off\" ng-model=\"newTag.text\" ng-model-options=\"{getterSetter: true}\" ng-keydown=\"eventHandlers.input.keydown($event)\" ng-focus=\"eventHandlers.input.focus($event)\" ng-blur=\"eventHandlers.input.blur($event)\" ng-paste=\"eventHandlers.input.paste($event)\" ng-trim=\"false\" ng-class=\"{'invalid-tag': newTag.invalid}\" ng-disabled=\"disabled\" ti-bind-attrs=\"{type: options.type, placeholder: options.placeholder, tabindex: options.tabindex, spellcheck: options.spellcheck}\" ti-autosize></div></div>"
        );

        $templateCache.put('ngTagsInput/tag-item.html',
            "<span ng-bind=\"$getDisplayText()\"></span> <a class=\"remove-button\" ng-click=\"$removeTag()\" ng-bind=\"::$$removeTagSymbol\"></a>"
        );

        $templateCache.put('ngTagsInput/auto-complete.html',
            "<div class=\"autocomplete\" ng-if=\"suggestionList.visible\"><ul class=\"suggestion-list\"><li class=\"suggestion-item\" ng-repeat=\"item in suggestionList.items track by track(item)\" ng-class=\"getSuggestionClass(item, $index)\" ng-click=\"addSuggestionByIndex($index)\" ng-mouseenter=\"suggestionList.select($index)\"><ti-autocomplete-match scope=\"templateScope\" data=\"::item\"></ti-autocomplete-match></li></ul></div>"
        );

        $templateCache.put('ngTagsInput/auto-complete-match.html',
            "<span ng-bind-html=\"$highlight($getDisplayText())\"></span>"
        );
    }]);

}());
/**
 * @ngdoc directive
 * @name app.widgets.directive:numberOnlyInput
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('numberOnlyInput', numberOnlyInput);

    /* @ngInject */
    function numberOnlyInput ($filter) {
        return {
            restrict: 'EA',
            replace: true,
            templateUrl: 'app/widgets/numberOnlyInput/numberOnlyInput.template.html',
            scope: {
                required: '=',
                inputValue: '=',
                inputName: '@',
                inputPlace: '@',
                noBorder: '=',
                currency: '='
            },
            link: function (scope) {

                scope.onFocus = function(){
                    scope.oldValue = scope.inputValue;
                };

                scope.onBlur = function(){
                    if(scope.inputValue === ''){
                        scope.inputValue = 0.00
                    }
                    else if(/[a-zA-Z!@#$%^&*()_+=/\\,]/i.test(scope.inputValue)){
                        scope.inputValue = scope.oldValue;
                    }
                };


            }
        };
    }


}());

/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('pageHeader', pageHeader);

    /* @ngInject */
    function pageHeader($state, $rootScope, utilities){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/pageHeader/pageHeader.template.html',
            scope: {
                subHeading: '@',
                heading: '@',
                buttonList: '=',
                goBack:'='
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){

            _init();
            function _init(){
                scope.rootScope = $rootScope;
                scope.goToState = goToState;
                scope.goToBack = utilities.goBackState;
            }

            function goToState(state){
                $state.go(state);
            }
        }
    }

}());


/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

  'use strict';

  angular
      .module('app.widgets')
      .directive('pieChart', pieChart);

  /* @ngInject */
  function pieChart($state, $rootScope, utilities, baConfig, layoutPaths){

    return {
      link: link,
      restrict: 'E',
      templateUrl: 'app/widgets/pieChart/pieChart.template.html',
      scope: {
        id: '@',
        data: '=',
        valueField: '@'
      },
      replace: true
    };

    /////////////////////

    function link(scope, elem, attrs){
      _init();
      function _init(){
        var layoutColors = baConfig.colors;
        var id = elem[0].getAttribute('id');

        var pieChart = AmCharts.makeChart(id, {
          type: 'pie',
          startDuration: 0,
          theme: 'blur',
          addClassNames: true,
          color: layoutColors.defaultText,
          labelTickColor: layoutColors.borderDark,
          legend: {
            position: 'right',
            marginRight: 100,
            autoMargins: false
          },
          innerRadius: '40%',
          defs: {
            filter: [
              {
                id: 'shadow',
                width: '200%',
                height: '200%',
                feOffset: {
                  result: 'offOut',
                  in: 'SourceAlpha',
                  dx: 0,
                  dy: 0
                },
                feGaussianBlur: {
                  result: 'blurOut',
                  in: 'offOut',
                  stdDeviation: 5
                },
                feBlend: {
                  in: 'SourceGraphic',
                  in2: 'blurOut',
                  mode: 'normal'
                }
              }
            ]
          },
          dataProvider: scope.data,
          valueField: scope.valueField,
          titleField: 'transaction__product__name',
          export: {
            enabled: true
          },
          creditsPosition: 'bottom-left',
          autoMargins: false,
          marginTop: 10,
          alpha: 0.8,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          pullOutRadius: 0,
          pathToImages: layoutPaths.images.amChart,
          responsive: {
            enabled: true,
            rules: [
              // at 900px wide, we hide legend
              {
                maxWidth: 900,
                overrides: {
                  legend: {
                    enabled: false
                  }
                }
              },

              // at 200 px we hide value axis labels altogether
              {
                maxWidth: 200,
                overrides: {
                  valueAxes: {
                    labelsEnabled: false
                  },
                  marginTop: 30,
                  marginBottom: 30,
                  marginLeft: 30,
                  marginRight: 30
                }
              }
            ]
          }
        });

        pieChart.addListener('init', handleInit);

        pieChart.addListener('rollOverSlice', function (e) {
          handleRollOver(e);
        });

        function handleInit() {
          pieChart.legend.addListener('rollOverItem', handleRollOver);
        }

        function handleRollOver(e) {
          var wedge = e.dataItem.wedge.node;
          wedge.parentNode.appendChild(wedge);
        }
      }

    }
  }

}());

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('productCard', productCard);

    /* @ngInject */
    function productCard($state, utilities, $filter, appConstants){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/productCard/productCard.html',
            scope: {
                productItem:'=',
                colSize:'@'
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.colSize = scope.colSize ?  scope.colSize  : '4';
                scope.appConstants = appConstants;
                scope.productImage = $filter('productPicture')(scope.productItem.image);
                console.log(scope.business);
            }

        }
    }

}());

/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('shippingLineCard', shippingLineCard);

    /* @ngInject */
    function shippingLineCard($state, utilities, $filter, appConstants, shipping,toastr){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/shippingLineCard/shippingLineCard.template.html',
            scope: {
                shippingLine:'=',
                colSize: '@',
                delete: '&'
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.hide=false;
                scope.appConstants = appConstants;
                scope.editShippingLine = editShippingLine;
                scope.deleteShippingLine = deleteShippingLine;
                scope.logo = $filter('shippingLineLogo')(scope.shippingLine.logo);
            }

            function editShippingLine(id){
                $state.go('dashboard.shipping.lines.form', {id:id })
            }

            function deleteShippingLine(id){
                shipping.deleteShippingLine(id).then(function(res){
                    if(res.success){
                        toastr.success(res.message, 'Shipping Line Deleted');
                        console.log(scope.delete);
                        scope.delete({id: id});
                    }
                    else{
                        toastr.error(res.message, 'Delete Failed')
                    }
                })
            }

        }
    }

}());
/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('sparkLine', sparkLine);

    /* @ngInject */
    function sparkLine($rootScope){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/sparklines/sparkline.template.html',
            scope: {
                chartData:'='
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                prepareSparkLine();
            }

            function prepareSparkLine(){
                scope.chartData[scope.chartData.length-1]['bullet'] = 'round';
                AmCharts.makeChart( "line1", {
                    "type": "serial",
                    "theme": "light",
                    "dataProvider": scope.chartData,
                    "categoryField": "date",
                    "autoMargins": false,
                    "marginLeft": 0,
                    "marginRight": 5,
                    "marginTop": 0,
                    "marginBottom": 0,
                    "graphs": [ {
                        "valueField": "rate",
                        "bulletField": "bullet",
                        "showBalloon": false,
                        "lineColor": "greenyellow",
                        "lineThickness":5
                    } ],
                    "valueAxes": [ {
                        "gridAlpha": 0,
                        "axisAlpha": 0
                    } ],
                    "categoryAxis": {
                        "gridAlpha": 0,
                        "axisAlpha": 0,
                        "startOnAxis": true
                    }
                } );
            }
        }
    }

}());




/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

(function() {

    'use strict';

    angular
        .module('app.widgets')
        .directive('tradeDisputeCard', tradeDisputeCard);

    /* @ngInject */
    function tradeDisputeCard($filter, tradeBook, toastr, appFormats, utilities, loaderModal) {
        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/tradeDisputeCard/tradeDisputeCard.template.html',
            scope: {
                trade:'='
            },
            replace: true
        };

        function link(scope){
            _init();

            function _init(){
                scope.appFormats = appFormats;
                if(!scope.trade.dispute){
                    scope.trade.dispute = getNewDisputeObj();
                }
                scope.getNewDisputeObj = getNewDisputeObj;
                scope.showDisputeForm = showDisputeForm;
                scope.saveDisputeDetails = saveDisputeDetails;
                scope.cancelDisputingTrade = cancelDisputingTrade;
            }


            function cancelDisputingTrade(){
                scope.showForm = false;
                scope.trade.dispute = scope.disputeCopy;
            }


            function getNewDisputeObj(){
                return {
                    'isDisputed': false,
                    'qualityComplain': false,
                    'weightShortage': false,
                    'other': false,
                    'disputeResolved': false,
                    'disputeResolvedDate': null,
                    'details': '',
                    'disputeDate': null
                }
            }

            function showDisputeForm(action){
                // scope.washOutValue = (action==='add') ? scope.trade.commission.price : scope.trade.washOut.isWashOutAt;
                // scope.washOutValue = $filter('number')(scope.washOutValue, 2);
                scope.addMode = true;
                scope.showForm = true;
                scope.disputeCopy = angular.copy(scope.trade.dispute);
            }

            function saveDisputeDetails(disputeForm, trade, activate){
                if(disputeForm.$valid){
                    tradeBook.saveDisputeData(trade.dispute, trade.basic.fileNo, activate).then(function(res){
                        if(res.success){
                            scope.trade = res.transactionObj;
                            toastr.success(res.message);
                            scope.showForm = false;
                        }
                    })
                }
                else{
                    toastr.error('Please enter missing fields');
                }
            }
        }
    }

})();
(function() {

    'use strict';

    angular
        .module('app.widgets')
        .directive('tradeTable', tradeTable);

    /* @ngInject */
    function tradeTable($rootScope, appConstants, tradeBook, toastr, appFormats, utilities, loaderModal, documentExporter) {
        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/tradeTable/tradeTable.template.html',
            scope: {
                type:'@',
                listData: '=',
                itemsPerPage: '@',
                columnHeader: '='
            },
            replace: true
        };

        function link(scope){
            _init();

            scope.toggleNotes = function(row){
                if(row.showNotes){
                    row.showNotes = false;
                }
                else{
                    row.showNotes = true;
                    row.noteListLoading = true;
                    loaderModal.open();
                    tradeBook.getAllNotesForTrade(row.id).then(function(res){
                        row.noteList = res.notesList;
                        row.noteListLoading = false;
                        loaderModal.close();
                    });
                    angular.forEach(scope.listData, function(val,key){
                        if(val.id !== row.id){
                            val.showNotes = false;
                        }
                    });
                }

            };

            scope.editTradeNote = function(trade, noteText, note){
                trade.note = noteText;
                note.editing = true;
                scope.updateNote = true;
            };

            scope.deleteTradeNote = function(tradeId, noteId, note, noteList){
                return tradeBook.deleteTradeNote(tradeId, noteId).then(function(res){
                    if(res.success){
                        var index = _.indexOf(noteList, note);
                        noteList.splice(index, 1);
                        toastr.success(res.message, 'Note Deleted');
                    }
                    else{
                        toastr.error(res.message);
                    }
                });
            };

            scope.addTradeNote = function(tradeId, note, noteList, trade, formObj){
                if(formObj.$valid){
                    trade.note = '';
                    if(note === ''){
                        toastr.error('Please add a note');
                    }
                    else{
                        scope.addingNote = false;
                        if(!scope.updateNote){
                            tradeBook.addTradeNote(tradeId, note).then(function(res){
                                if(res.success){
                                    toastr.success(res.message, 'Note Added');
                                    noteList.push(res.note);
                                }
                                else{
                                    toastr.error(res.message);
                                }
                                utilities.resetFormValidation(formObj);
                            })
                        }
                        else{
                            var noteEdited = _.find(noteList, function(n) { return (n.editing == true); });
                            var index = _.indexOf(noteList, noteEdited);
                            tradeBook.editTradeNote(tradeId, noteEdited.noteId, note).then(function(res){
                                if(res.success){
                                    scope.updateNote = false;
                                    noteList[index] = res.note;
                                    toastr.success(res.meesage, 'Note Updated')
                                }
                                else{
                                    toastr.error(res.message);
                                }
                                utilities.resetFormValidation(formObj);


                            })
                        }

                    }
                }

            };

            function sortTable(sortType, column){
                column.reverse = column.reverse ? true : false;
                scope.sortType = sortType;
                scope.tableData = utilities.sortTableBySortType(scope.listData, sortType, !column.reverse);
                if(!scope.hidePaging){
                    scope.setPagingData(scope.currentPage, scope.tableData, scope.itemsPerPage);
                }
                else{
                    scope.displayList = scope.tableData;
                }
                column.reverse = !column.reverse;
            }

            function _init(){
                scope.totalQuantity = 0.00;
                scope.hidePaging = false;
                if(scope.type==='arrivedList'){
                    $rootScope.headerTitle = 'International Trades';
                    $rootScope.headerSubTitle = 'Arrived At Port';
                }
                if(scope.type==='expectedArrival'){
                    $rootScope.headerTitle = 'International Trades';
                    $rootScope.headerSubTitle = 'Expected Arrival';
                }
                if(scope.type==='expiredShipment'){
                    $rootScope.headerTitle = 'International Trades';
                    $rootScope.headerSubTitle = 'Expired Shipment';
                }
                scope.searchTransactionByFileID = '';
                scope.displayList = [];
                scope.tableData = [];
                scope.appConstants = appConstants;
                scope.appFormats = appFormats;
                scope.currentPage = 1;
                scope.sortType='fileNo';
                var intTradeHeading = [
                    'Date',
                    'File No',
                    'Buyer',
                    'Product',
                    'Origin',
                    'Quantity',
                    'Rate',
                    'Seller',
                    'Shipment Start',
                    'Shipment End',
                    'Expected Commission',
                    'Actual Commission'
                ];
                scope.heading = intTradeHeading;
                angular.forEach(scope.listData, function(val,key){
                    val.showNotes = false;
                    val.note = '';
                });

                scope.sortTable = sortTable;

                scope.pageChanged = function(page){
                    scope.setPagingData(page, scope.tableData, scope.itemsPerPage);
                };

                scope.setPagingData = function(page, list, itemsPerPage) {
                    scope.totalItems = list.length;
                    scope.currentPage = page;
                    scope.pagedData = list.slice((page - 1) * itemsPerPage, page * itemsPerPage);
                    scope.displayList = scope.pagedData;
                };

                function calculateTotalQuantity(list){
                    return _.sumBy(list, function(trade){
                        return trade.quantity;
                    });
                }

                scope.$watch('listData', function(newVal, oldVal){
                    if(newVal.length > 0) {
                        scope.tableData = utilities.sortTableBySortType(newVal, scope.sortType, true);
                        scope.setPagingData(scope.currentPage, scope.tableData, scope.itemsPerPage);
                        scope.totalQuantity = calculateTotalQuantity(newVal)
                    }
                });

                scope.exportToPDF = function(tradeList, columnHeader){
                    var header = _.filter(columnHeader, function(header) { return (header.sort !== null); });
                    var heading = _.map(header, 'name');
                    var heading = _.forEach(heading, function(value, key){
                        heading[key] = utilities.stripHtml(value);
                    });
                    var keys = _.map(header, 'sort');
                    documentExporter.printPDF(angular.copy(heading), angular.copy(keys), tradeList);
                };

                scope.exportToExcel = function(tradeList, columnHeader){
                    var header = _.filter(columnHeader, function(header) { return (header.sort !== null); });
                    var heading = _.map(header, 'name');
                    var keys = _.map(header, 'sort');
                    var heading = _.forEach(heading, function(value, key){
                        heading[key] = utilities.stripHtml(value);
                    });
                    documentExporter.getTableInExcelSheet(angular.copy(heading), angular.copy(keys), tradeList, scope.type);
                };

                scope.unpagedView = function(flag){
                    scope.hidePaging = !flag;
                    scope.displayList = (scope.hidePaging) ? scope.tableData : scope.pagedData;

                }
            }

        }
    }
})();
(function() {

    'use strict';

    angular
        .module('app.widgets')
        .directive('tradeWashOutCard', tradeWashOutCard);

    /* @ngInject */
    function tradeWashOutCard($filter, tradeBook, toastr, appFormats, utilities, loaderModal) {
        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/tradeWashOutCard/tradeWashOutCard.template.html',
            scope: {
                trade:'='
            },
            replace: true
        };

        function link(scope){
            _init();

            function _init(){
                scope.appFormats = appFormats;
                if(!scope.trade.washOut){
                    scope.trade.washOut = getNewWashoutObj();
                }
                scope.getNewWashoutObj = getNewWashoutObj;
                scope.showWashOutForm = showWashOutForm;
                scope.saveWashOutDetails = saveWashOutDetails;
                scope.cancelWashingOut = cancelWashingOut;
            }


            function cancelWashingOut(){
                scope.showForm = false;
            }


            function getNewWashoutObj(){
                return {
                    'isWashout': false,
                    'initialCommissionPayable': true,
                    'washoutDate': null,
                    'washoutDueDate': null,
                    'buyerWashoutPrice': $filter('number')(scope.trade.commission.price, '2'),
                    'sellerWashoutPrice': $filter('number')(scope.trade.commission.price, '2'),
                    'brokerDifference': $filter('number')('0.00', '2')
                }
            }

            function showWashOutForm(action){
                // scope.washOutValue = (action==='add') ? scope.trade.commission.price : scope.trade.washOut.isWashOutAt;
                // scope.washOutValue = $filter('number')(scope.washOutValue, 2);
                scope.addMode = true;
                scope.showForm = true;
            }

            function saveWashOutDetails(washOutForm, trade, status, washOutValue, activate){
                if(washOutForm.$valid || !activate){
                    loaderModal.open();
                    tradeBook.changeWashoutStatus(trade.id, status, washOutValue).then(function(res){
                        if(res.success){
                            scope.trade = res.transactionObj;
                            toastr.success(res.message, 'Washout Status Changed');
                            scope.showForm = false;
                            if(!status){
                                scope.trade.washOut = getNewWashoutObj();
                            }
                        }
                        else{
                            toastr.error(res.message, 'Error!');
                        }
                        loaderModal.close();
                    })
                }
                else{
                    toastr.error('Please enter washout value', 'Error')
                }

            }
        }
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    $scope.doughnutData = [
      {
        value: 2000,
        color: dashboardColors.white,
        highlight: colorHelper.shade(dashboardColors.white, 15),
        label: 'Other',
        percentage: 87,
        order: 1,
      }, {
        value: 1500,
        color: dashboardColors.blueStone,
        highlight: colorHelper.shade(dashboardColors.blueStone, 15),
        label: 'Search engines',
        percentage: 22,
        order: 4,
      }, {
        value: 1000,
        color: dashboardColors.surfieGreen,
        highlight: colorHelper.shade(dashboardColors.surfieGreen, 15),
        label: 'Referral Traffic',
        percentage: 70,
        order: 3,
      }, {
        value: 1200,
        color: dashboardColors.silverTree,
        highlight: colorHelper.shade(dashboardColors.silverTree, 15),
        label: 'Direct Traffic',
        percentage: 38,
        order: 2,
      }, {
        value: 400,
        color: dashboardColors.gossip,
        highlight: colorHelper.shade(dashboardColors.gossip, 15),
        label: 'Ad Campaigns',
        percentage: 17,
        order: 0,
      },
    ];

    var ctx = document.getElementById('chart-area').getContext('2d');
    window.myDoughnut = new Chart(ctx).Doughnut($scope.doughnutData, {
      segmentShowStroke: false,
      percentageInnerCutout : 64,
      responsive: true
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    console.log('sex');
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/widgets/trafficChart/trafficChart.html'
    };
  }
})();
(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('vesselCard', vesselCard);

    /* @ngInject */
    function vesselCard($state, utilities, $filter, appConstants){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/vesselCard/vesselCard.template.html',
            scope: {
                vessel:'=',
                colSize: '@'
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.editVesselDetails = editVesselDetails;
                scope.appConstants = appConstants;
                if(scope.shippingLine){
                    scope.logo = $filter('shippingLineLogo')(scope.shippingLine.logo);
                }
                else{
                    scope.logo = $filter('shippingLineLogo')(scope.shippingLine)
                }

            }

            function editVesselDetails(id){
                $state.go('dashboard.shipping.vessel.form', {'id': id})
            }

        }
    }

}());
/**
 * @ngdoc directive
 * @name app.widgets.directive:pageHeader
 * @scope true
 * @param {object} test test object
 * @restrict E
 *
 * @description < description placeholder >
 *
 */

(function(){

    'use strict';

    angular
        .module('app.widgets')
        .directive('warehouseCard', warehouseCard);

    /* @ngInject */
    function warehouseCard($state, utilities, $filter, baConfig, inventory){

        return {
            link: link,
            restrict: 'E',
            templateUrl: 'app/widgets/warehouseCard/warehouseCard.html',
            scope: {
                warehouse:'=',
                colSize:'@'
            },
            replace: true
        };

        /////////////////////

        function link(scope, elem, attrs){
            _init();
            function _init(){
                scope.dashboardColors = baConfig;
                scope.openWarehouseProductStockReport = inventory.openWarehouseProductStockReport;
                scope.openWarehouseBusinessStockReport = inventory.openWarehouseBusinessStockReport;
            }

        }


    }

}());
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/widgets/weather/weather.html'
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('app.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('app.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('app.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    this.itemAlreadyInItems = function(item){
      return (staticMenuItems.indexOf(item) > -1);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.addStaticItem = function() {
          staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        this.itemAlreadyInItems = function(item){
          return (staticMenuItems.indexOf(item) > -1);
        };

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('app.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl',
      scope:{
        'onCancel': '&'
      }
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope, toastr) {
    var vm = this;

    vm.tabs = [];
    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.tabNum = 0;
      vm.tabs.forEach(function (t, tIndex) {
        tIndex == 0 ? t.select(true) : t.select(false);
      });
    };

    vm.onCancel = function(){
      $scope.onCancel({});
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      var promise = vm.tabs[vm.tabNum].submit();
      if(promise){
        promise.then(function(res){
          if(res.success){
            if(vm.tabs[vm.tabNum].onSubmitCallback){
              vm.tabs[vm.tabNum].onSubmitCallback({'response':res});
            }
            if (vm.tabs[tabNum+1].isAvailiable()) {
              vm.tabNum = tabNum+1;
              vm.tabs.forEach(function (t, tIndex) {
                tIndex == vm.tabNum ? t.select(true) : t.select(false);
              });
            }
            toastr.success(res.message);
          }
          else{
            toastr.error(res.message);
          }
        });
      }

    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTabAndExit = function(){
      vm.tabs[vm.tabNum].submit().then(function(res){
        if(res.success){
          toastr.success(res.message);
          $scope.onCancel({});
        }
        else{
          toastr.error(res.message);
        }
      });
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum)
    };

    vm.previousTab = function () {
      vm.tabs[vm.tabNum].select(false);
      vm.tabNum = vm.tabNum - 1;
      vm.tabs[vm.tabNum].select(true);
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('app.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep(toastr) {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '=',
        submitButtonTitle: '@',
        skip: '=',
        onNext: '&',
        onNextCallback: '&'
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          onSubmitCallback: $scope.onNextCallback ? $scope.onNextCallback : null,
          title: $attrs.title,
          submitButtonTitle: $scope.submitButtonTitle,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if(isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          console.log('hello');
          $scope.form && $scope.form.$setSubmitted(true);
          if($scope.form && $scope.form.$valid){
            return $scope.onNext({form: $scope.form});
          }
          else if($scope.form){
            toastr.error('Please enter missing fields', 'Invalid Form')
          }
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce, dashboard, $state) {

    _init();

    function _init(){
      $scope.notificationObj={};
      getUnReadNotificationList(true);
    }

    function getUnReadNotificationList(markRead){
      dashboard.getUnReadNotificationList(markRead).then(function(res){
        angular.forEach(res.unread_list, function(val, key){
          try{
            val.data = JSON.parse(val.data)
          } catch (e) {

          }

        });
        console.log(res);
        $scope.notificationObj = {
          count: res.unread_count,
          list: res.unread_list
        }
      })
    }

    $scope.goToState = function(state, stateParams){
      $state.go(state, stateParams);
    };


    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop(authentication, $state, $timeout, dashboard) {
    return {
      restrict: 'E',
      replace: true,
      link: link,
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };

    function link(scope, elem, attrs){
      _init();

      function _init(){

        scope.loading=false;
        scope.searchResults = [];
        scope.resultType = '';
        scope.searchOptions = [
          {name: 'International Trade By File Id', id: 'int_trade_file_id'},
          {name: 'International Trade By BL/No.', id: 'int_trade_bl_no'},
          {name: 'International Trade By Contract Number', id: 'int_trade_contract_id'}
          // {name: 'International Trade By Invoice No.', id: 'int_trade_invoice_no'}
        ];
        scope.searchObj = {
          query: '',
          queryType: 'int_trade_file_id'
        };
        scope.lastSearch = {
          query:''
        };
        scope.searchQuery = searchQuery;
        scope.goToSearchItem = goToSearchItem;


      }


      
      function goToSearchItem(stateName, stateParams){
        scope.searchResults = [];
        scope.searchObj.query='';
        $state.go(stateName, stateParams);
      }

      function searchQuery(searchObj, lastSearch){
        $timeout(function () {
          if (searchObj.query.length >= 4) {
              lastSearch.query = searchObj.query;
              scope.loading = true;
              dashboard.searchQueryPageTop(searchObj).then(function(res){
                scope.loading = false;
                scope.searchResults = res.resultList;
                scope.resultType = res.resultType
              });
          }
          else{
            scope.searchResults = [];
          }
        }, 500);
      }

      scope.goToSettings = function(){
        $state.go('dashboard.settings.transactionStatus');
      };
      scope.userData = authentication.getUserData();
      scope.logout = function(){
        authentication.logout();
      }
    }
  }

})();
(function () {
    'use strict';

    angular.module('app.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
      .filter('profilePicture', profilePicture)
      .filter('productPicture', productPicture)
      .filter('itemImage', itemImage)
      .filter('businessLogo', businessLogo)
      .filter('countryLogo', countryLogo)
      .filter('shippingLineLogo', shippingLineLogo);

  function itemImage(layoutPaths){
    return function(input, ext) {
      return (input) ? input : layoutPaths.images.root+'/theme/no-picture.png'
    };
  }

  /** @ngInject */
  function shippingLineLogo(layoutPaths) {
    return function(input, ext) {
      return (input) ? input : layoutPaths.images.root+'/theme/no-shipping-logo.png'
    };
  }

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      return (input) ? input : layoutPaths.images.root+'/theme/no-photo.png'
    };
  }

  function countryLogo(layoutPaths){
    return function(input, ext) {
      return (input) ? input : layoutPaths.images.root+'/theme/no-business.png'
    };
  }

  function businessLogo(layoutPaths){
    return function(input, ext) {
      return (input) ? input : layoutPaths.images.root+'/theme/no-business.png'
    };
  }

  function productPicture(layoutPaths){
    return function(input, ext){
      return (input) ? input : layoutPaths.images.root+'/theme/no-product.png'
    }
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('app.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope) {

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      segmentShowStroke : false
    };

    $scope.polarOptions = {
      scaleShowLabelBackdrop : false,
      segmentShowStroke : false
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "June", "Jule", "August", "September", "October", "November"];
    $scope.data = [
      [65, 59, 90, 81, 56, 55, 40],
      [28, 48, 40, 19, 88, 27, 45]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["April", "May", "June", "Jule", "August", "September", "October", "November", "December"];
    $scope.data = [[1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    })];

    stopableInterval.start($interval, function(){
      $scope.data[0].unshift($scope.data[0].pop());
    }, 300)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
(function () {
  'use strict';

  angular.module('app.widgets.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 22.04.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.form')
      .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('app.widgets.form')
      .controller('SwitchPanelCtrl', SwitchPanelCtrl);

  /** @ngInject */
  function SwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('app.widgets.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        $timeout(function(){
          var input = $(elem).find('input');
          input.bootstrapSwitch({
            size: 'small',
            onColor: attr.color
          });
          input.on('switchChange.bootstrapSwitch', function(event, state) {
            scope.ngModel = state;
            scope.$apply();
          });

        });
      }
    };
  }
})();

// /**
//  * @author v.lugovksy
//  * created on 16.12.2015
//  */
// (function () {
//   'use strict';
//
//   angular.module('app.widgets.form')
//       .directive('tagInput', tagInput);
//
//   /** @ngInject */
//   function tagInput() {
//     return {
//       restrict: 'A',
//       link: function( $scope, elem, attr) {
//         $(elem).tagsinput({
//           tagClass:  'label label-' + attr.tagInput
//         });
//       }
//     };
//   }
// })();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/authentication/auth.html","<main class=\"auth-main\"><div class=\"auth-block\"><div class=\"auth-header\"><img src=\"../../assets/img/favicon-32x32.png\"><h2>Sign in to Doni & Company</h2></div><form class=\"form-horizontal\" name=\"vm.signIn\" novalidate=\"\"><div class=\"form-group\"><div class=\"col-sm-12\"><input type=\"text\" ng-model=\"vm.username\" name=\"username\" class=\"form-control\" required=\"\" id=\"inputEmail3\" placeholder=\"Username\"><ng-messages for=\"vm.signIn.username.$error\" ng-if=\"(vm.signIn.$submitted && vm.signIn.username.$invalid) || (vm.signIn.username.$dirty && vm.signIn.username.$invalid)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter your username.</div></ng-messages></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><input type=\"password\" ng-model=\"vm.password\" class=\"form-control\" required=\"\" name=\"password\" id=\"inputPassword3\" placeholder=\"Password\"><ng-messages for=\"vm.signIn.password.$error\" ng-if=\"(vm.signIn.$submitted && vm.signIn.password.$invalid) || (vm.signIn.password.$invalid && vm.signIn.password.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter your password.</div></ng-messages></div></div><div class=\"form-group\"><div class=\"col-sm-10\"><button type=\"submit\" class=\"btn btn-primary btn-auth\" ng-click=\"vm.login(vm.signIn, vm.username, vm.password)\">Sign in</button> <a href=\"\" class=\"forgot-pass\">Forgot password?</a></div></div></form></div></main>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"row\"><div class=\"col-lg-4\"><div ba-panel=\"\" class=\"col-lg-12 col-xs-12 currency-exchange-card\"><div class=\"sparkLine\"><spark-line chart-data=\"vm.completeReport.usdExchange.sevenDays\"></spark-line></div><div class=\"details\"><div class=\"heading\">USD Exchange Rate</div><div class=\"card-refresh\"><i class=\"fa fa-refresh\" aria-hidden=\"true\"></i></div><div class=\"value cursor-pointer\" ng-click=\"vm.goToCurrencyDashboard(\'USD\', \'PKR\')\"><div class=\"currency\" ng-bind=\"vm.completeReport.usdExchange.outCurrency\"></div><div class=\"rate\" ng-bind=\"vm.completeReport.usdExchange.currentValue | number: 2\"></div><div class=\"change\"><i class=\"fa\" ng-class=\"{\'fa-caret-up\': vm.completeReport.usdExchange.change>0, \'fa-caret-down\': vm.completeReport.usdExchange.change<0}\"></i><div class=\"change-rate\" ng-bind=\"(vm.completeReport.usdExchange.change | number: 2)+ \' %\'\"></div></div><div class=\"last-update\" ng-bind=\"vm.completeReport.usdExchange.lastUpdate | date: vm.appFormat.date\"></div></div></div></div><div ba-panel=\"\" class=\"col-lg-12\" ng-if=\"vm.allArrived.length>0\"><div class=\"panel-content\" style=\"height: 300px; overflow-y: scroll\"><div class=\"feed-messages-container\" ui-sref=\"dashboard.transactionView({id:trade.fileId})\" track-width=\"smallContainerWidth\" min-width=\"360\" ng-repeat=\"trade in vm.allArrived\"><div class=\"feed-message\"><div class=\"message-icon\"><img class=\"photo-icon\" ng-src=\"assets/img/theme/icon/kameleon/Bell.svg\"></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\">{{ ::trade.fileId }} {{ ::trade.contractId}}</span></div><div class=\"message-content line-clamp\"><span ng-if=\"message.preview\">{{trade.fileId}}</span> Arrived At Port But Not Yet Updated in the System</div></div></div></div></div></div><br><div ba-panel=\"\" class=\"col-lg-12 col-xs-12 single-number-card\" ba-panel-title=\"Last 24 Hours Price Updates\"><div class=\"panel-content\"><div class=\"single-number col-xs-12\" ng-bind=\"vm.completeReport.priceUpdate.count\"></div><div class=\"last-update-time col-xs-12\">Last Updated: {{vm.completeReport.priceUpdate.lastUpdate | date: vm.appFormat.DBDate}}</div></div></div><div ba-panel=\"\" class=\"col-lg-12 col-xs-12 manifest-item-updates\" ba-panel-title=\"Last 24 Hours Manifest Updates\"><div class=\"panel-content row\"><div class=\"col-lg-3 col-xs-12 row\"><div class=\"single-number\" ng-bind=\"vm.completeReport.manifestUpdate.count\"></div></div><div class=\"col-lg-9 col-xs-12 row\"><div class=\"heading col-lg-12\">Top Three Data Entry</div><div class=\"col-lg-12 no-data\" ng-if=\"vm.completeReport.manifestUpdate.topThreeContributors.length === 0\">No manifest data has been entered in last 24 hours.</div><div class=\"col-lg-12 col-xs-12\"><div class=\"col-xs-12 col-lg-4 contributor-card\" ng-repeat=\"contrib in vm.completeReport.manifestUpdate.topThreeContributors\"><div class=\"col-xs-12 number\" ng-bind=\"contrib.updates\"></div><div class=\"col-xs-12 username\" ng-bind=\"contrib.username\"></div><div class=\"col-xs-12 last-update-time\">Last Updated: {{contrib.lastUpdate | date: vm.appFormat.DBDate}}</div></div></div></div></div></div></div><div class=\"col-lg-8\"><div ba-panel=\"\" ba-panel-title=\"All Trackable Expected Shipments ({{vm.shipmentTracking.length}})\" class=\"viewport100\"><div id=\"leaflet-map\"></div></div></div></div>");
$templateCache.put("app/modal/alertmodal.template.html","<div class=\"modal-header\"><h3 class=\"modal-title\">{{vm.action}}</h3></div><div class=\"modal-body\"><div>Are you sure you want to {{vm.action.toLowerCase()}} {{vm.type.toLowerCase()}} <b>{{vm.name}}</b>?</div></div><div class=\"modal-footer\"><button class=\"btn btn-default submitBtn\" type=\"button\" ng-click=\"vm.ok()\">{{vm.action}}</button> <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.cancel()\">Cancel</button></div>");
$templateCache.put("app/modals/modals.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons clearfix\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')\">Default modal</button> <button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')\">Large modal</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')\">Small modal</button></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Message Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons same-width clearfix\"><button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/successModal.html\')\">Success Message</button> <button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')\">Info Message</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')\">Warning Message</button> <button type=\"button\" class=\"btn btn-danger\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')\">Danger Message</button></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Notifications\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/modals/notifications/notifications.html\'\"></div></div></div></div>");
$templateCache.put("app/dashboard/accounts/dashboard.html","<div>Account Dashbaord</div>");
$templateCache.put("app/dashboard/businessPartner/businessPartner.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addBusinessPartner()\">Add New Business</button></div></div><br><filter-bar ng-show=\"!vm.showForm\" bp-types=\"true\" country=\"true\" on-bp-types-selected-changed=\"vm.onBpTypesSelectedChanged(selectedList)\" on-country-selected-changed=\"vm.onCountrySelectedChanged(selectedList)\"></filter-bar><div class=\"row\" ng-show=\"!vm.showForm\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"row index-container\"><ul class=\"alphaIndex\"><li ng-class=\"{\'active\': (vm.currentIndex === alpha)}\" class=\"alphaIndexItem\" ng-repeat=\"alpha in vm.alphabet\" ng-bind=\"alpha\" ng-click=\"vm.setCurrentIndex(alpha)\"></li></ul><div class=\"totalBusiness\"><span class=\"title\">Total Business</span> <span class=\"count\" ng-bind=\"vm.allBusinessCount\"></span></div></div><div class=\"horizontal-scroll\"><table class=\"table\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\"><th><span class=\"count\">{{vm.allBusiness.length - vm.businessToRemove.length}}</span></th><th st-sort=\"{{heading.stSort}}\" ng-repeat=\"heading in vm.tableHeadings\" ng-bind=\"heading.name\"></th></tr></thead><tbody><tr ng-repeat=\"business in vm.allBusiness | selectedRows:vm.businessToRemove:\'bpId\'\"><td></td><td class=\"titled\" ng-bind=\"business.name\"></td><td ng-if=\"business.contactPerson\">{{business.contactPerson}}</td><td ng-if=\"!business.contactPerson\">No Primary Contact</td><td ng-bind=\"business.country\"></td><td ng-bind=\"business.bpTypeStr\"></td><td ng-if=\"row.tr_transactionID\"><a ui-sref=\"shell.tradeBook.Transaction({tran:row.tr_transactionID})\">{{row.tr_date | date:vm.vm.appFormats.Date}}</a></td><td ng-if=\"!row.tr_transactionID\">No Transaction Done</td><td><div class=\"buttons\"><button class=\"btn btn-success editable-table-button btn-xs\" ng-click=\"vm.goToBusinessReport(business.bpId)\">Report</button> <button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editBusinessPartner(business)\">Edit</button> <button ng-if=\"vm.deleteRights\" class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"vm.deleteBusinessPartner(business)\">Delete</button></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/dashboard/businessPartner/businessPartnerForm.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"with-scroll\"><ba-wizard on-cancel=\"vm.cancel()\"><ba-wizard-step title=\"Basic Information\" form=\"vm.basicInfoForm\" on-next=\"vm.saveBusiness(vm.imagesData, vm.business, form)\" on-next-callback=\"vm.onSaveBusinessCallBack(response)\" submit-button-title=\"Save Business\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\" include-with-scope=\"app/dashboard/businessPartner/template/basicInfo.html\"></div></div></div></ba-wizard-step><ba-wizard-step title=\"Locations\" form=\"vm.locationInfoForm\" on-next=\"vm.saveBusinessLocations(vm.business)\" submit-button-title=\"Save Locations\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\" include-with-scope=\"app/dashboard/businessPartner/template/location.html\"></div></div></div></ba-wizard-step><ba-wizard-step title=\"Contact Persons\" form=\"vm.contactPersonInfoForm\" on-next=\"vm.saveBusinessContactPersons(vm.business)\" submit-button-title=\"Save Contact Persons\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\" include-with-scope=\"app/dashboard/businessPartner/template/contactPerson.html\"></div></div></div></ba-wizard-step><ba-wizard-step title=\"Contact Numbers\" form=\"vm.contactInfoForm\" on-next=\"vm.saveBusinessContactNumbers(vm.business)\" submit-button-title=\"Save Contacts\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\" include-with-scope=\"app/dashboard/businessPartner/template/contactInfo.html\"></div></div></div></ba-wizard-step><ba-wizard-step title=\"Bank Information\" form=\"vm.bankInfoForm\" on-next=\"vm.saveBusinessBanks(vm.business)\" submit-button-title=\"Save Banks\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\" include-with-scope=\"app/dashboard/businessPartner/template/bankInfo.html\"></div></div></div></ba-wizard-step></ba-wizard></div></div></div></div>");
$templateCache.put("app/dashboard/currencyExchange/currencyDashboard.html","<filter-bar date-picker-needed=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\"></filter-bar><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\"><div class=\"row\"><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-7 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Exchange Rate Graph\" ba-panel-class=\"medium-panel\"><line-chart ng-if=\"vm.showGraph\" chart-data=\"vm.graphData\" chart-values=\"vm.chartValues\" chart-type=\"vm.chartType\"></line-chart></div></div></div>");
$templateCache.put("app/dashboard/documentCreator/documentCreator.html","<div class=\"col-lg-12\"><div ba-panel=\"\"><div id=\"document\"><div class=\"col-md-12\"><h3 class=\"with-line\">Document Content</h3><div class=\"form-group\"><text-angular ng-model=\"vm.documentContent\" id=\"documentContent\"></text-angular></div></div></div><div><button class=\"btn btn-success\" ng-click=\"vm.createA4Document(vm.documentContent)\">Export to PDF</button></div></div></div>");
$templateCache.put("app/dashboard/inventory/inventoryDashboard.html","<div class=\"row\"><div class=\"col-md-4\" ba-panel=\"\" ba-panel-title=\"All Warehouse Products Stock\"><pie-chart id=\"allWarehouses\" value-field=\"totalQuantity\" data=\"vm.dashboardData.allWarehousesProduct\"></pie-chart></div><div class=\"col-md-4\" ba-panel=\"\" ba-panel-title=\"Self Warehouse Products Stock\"><pie-chart id=\"selfWarehouses\" value-field=\"totalQuantity\" data=\"vm.dashboardData.ownWarehouseProduct\"></pie-chart></div><div class=\"col-md-4\" ba-panel=\"\" ba-panel-title=\"Business Products Stock\"><pie-chart id=\"bpProduct\" value-field=\"totalQuantity\" data=\"vm.dashboardData.businessProductReport\"></pie-chart></div><div ba-panel=\"\" class=\"col-lg-12 col-xs-12\" ba-panel-title=\"All Warehouses\"><div class=\"panel-content\"><div class=\"row\"><div class=\"col-xs-12\"><h3 class=\"with-line\"></h3><warehouse-card ng-repeat=\"warehouse in vm.allWarehouses\" col-size=\"4\" warehouse=\"warehouse\"></warehouse-card></div></div></div></div></div>");
$templateCache.put("app/dashboard/inventory/inventoryTransactionForm.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\"><div class=\"panel-content\"><form name=\"vm.inventoryRecordForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-md-12 clearfix\"><div class=\"input-demo radio-demo row\"><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" ng-model=\"vm.inventoryRecord.positive\" id=\"inflow\" value=\"True\"> <span>In Flow</span></label></div><div class=\"col-md-2\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" ng-model=\"vm.inventoryRecord.positive\" id=\"outflow\" value=\"False\"> <span>Out Flow</span></label></div></div></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">Date</label><date-picker-input date=\"vm.inventoryRecord.date\" blank=\"false\" name=\"dateChange\"></date-picker-input><ng-messages for=\"vm.inventoryRecordForm.dateChange.$error\" ng-show=\"(vm.inventoryRecordForm.$submitted || vm.inventoryRecordForm.dateChange.$dirty)\"><ng-message class=\"errorValidation\" when=\"required\">Please enter warehouse name.</ng-message></ng-messages></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">Warehouse</label><selectize ng-required=\"true\" name=\"warehouse\" placeholder=\"Warehouse\" id=\"warehouse\" config=\"vm.warehouseConfig\" options=\"vm.warehouseOptions.list\" ng-model=\"vm.inventoryRecord.warehouseId\"></selectize><ng-messages for=\"vm.inventoryRecordForm.warehouse.$error\" ng-if=\"(vm.inventoryRecordForm.$submitted || vm.inventoryRecordForm.warehouse.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select warehouse.</div></ng-messages></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">Product</label><selectize ng-required=\"true\" name=\"product\" placeholder=\"Product\" id=\"product\" config=\"vm.productConfig\" options=\"vm.productOptions.list\" ng-model=\"vm.inventoryRecord.productId\"></selectize><ng-messages for=\"vm.inventoryRecordForm.product.$error\" ng-if=\"(vm.inventoryRecordForm.$submitted || vm.inventoryRecordForm.product.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter product item.</div></ng-messages></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">Business</label><selectize ng-required=\"true\" name=\"business\" placeholder=\"Business\" id=\"business\" config=\"vm.businessConfig\" options=\"vm.businessOptions.list\" ng-model=\"vm.inventoryRecord.businessId\"></selectize><ng-messages for=\"vm.inventoryRecordForm.business.$error\" ng-if=\"(vm.inventoryRecordForm.$submitted || vm.inventoryRecordForm.business.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select Business.</div></ng-messages></div><div class=\"form-group col-md-3 clearfix\"><label class=\"with-line control-label\">Quantity <span class=\"titled\">FCL</span></label> <input ng-required=\"true\" ng-pattern=\"/^[0-9]+$/i\" ng-model=\"vm.inventoryRecord.fclQuantity\" class=\"form-control\" name=\"fclQuantity\" placeholder=\"Warehouse Lots\"><ng-messages for=\"vm.inventoryRecordForm.fclQuantity.$error\" ng-show=\"(vm.inventoryRecordForm.$submitted || vm.inventoryRecordForm.fclQuantity.$dirty)\"><ng-message class=\"errorValidation\" when=\"required\">Please enter quantity in fcl.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">FCL Quantity can only have number as input</ng-message></ng-messages></div><div class=\"form-group col-md-3 clearfix\"><label class=\"with-line control-label\"><span class=\"titled\">Lot</span> No</label> <input ng-required=\"true\" ng-pattern=\"/^[0-9]+$/i\" ng-model=\"vm.inventoryRecord.lotNo\" class=\"form-control\" name=\"wh_lots\" placeholder=\"Warehouse Lots\"><ng-messages for=\"vm.inventoryRecordForm.wh_lots.$error\" ng-show=\"(vm.inventoryRecordForm.$submitted || vm.inventoryRecordForm.wh_lots.$dirty)\"><ng-message class=\"errorValidation\" when=\"required\">Please enter warehouse lots.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Warehouse Lot No. can only have number as input</ng-message></ng-messages></div><div class=\"form-group col-md-3 clearfix\"><label class=\"with-line control-label\"><span class=\"titled\">Port Clearing</span> No</label> <input ng-model=\"vm.inventoryRecord.portClearingNo\" class=\"form-control\" name=\"portClearingNo\" placeholder=\"Port Clearing Number\"></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><h3 class=\"with-line\">Trucks Details <button type=\"button\" ng-click=\"vm.saveTruckInInventoryRecord(vm.inventoryRecordId, vm.inventoryTruckCallback,vm.getNewInventoryTruckObj())\" class=\"btn btn-xs btn-success\">Add Truck</button></h3><table class=\"table table-striped\"><thead><tr class=\"sortable table-header\"><th>Date</th><th>Truck No</th><th>Weight <span class=\"titled\">Kgs</span></th><th>Remarks</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"truck in vm.inventoryRecord.trucks | orderBy: [\'-date\', \'truckNo\']\"><td>{{truck.date | date:vm.appFormats.Date}}</td><td>{{truck.truckNo | uppercase}}</td><td>{{truck.weightInKg | number : \'2\'}}</td><td>{{truck.remarks}}</td><td><div class=\"buttons\"><button class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"vm.removeTruck(truck, vm.inventoryRecord)\">Delete</button></div></td></tr></tbody><tbody><tr><td colspan=\"1\"></td><td>Total Weight in Kgs</td><td>{{vm.totalWeight| number:\'2\'}}</td><td colspan=\"2\"></td></tr></tbody></table></div></div><br><div class=\"row\"><div class=\"col-xs-12\"><button type=\"submit\" ng-click=\"vm.saveInventoryRecord(vm.inventoryRecordForm, vm.inventoryRecord)\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>{{vm.isNew ? \'Add New Inventory Record\': \'Update Inventory Record\'}}</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></form></div></div></div></div>");
$templateCache.put("app/dashboard/inventory/inventoryTransactions.html","<filter-bar warehouse=\"true\" date-picker-needed=\"true\" product=\"true\" local-trader=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\" on-local-trader-selected-changed=\"vm.onLocalTradeSelectedChanged(selectedList, initialized)\" on-products-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\" on-warehouse-selected-changed=\"vm.onWarehouseSelectedChanged(selectedList, initialized)\"></filter-bar><div class=\"row stats-row\"><div ba-panel=\"\" class=\"col-md-12 panel-content\"><div class=\"col-md-1 col-xs-12\"></div><div class=\"col-md-2 col-xs-12 stats-item\"><div class=\"icon\"><i class=\"fa fa-arrow-down positive\" aria-hidden=\"true\"></i></div><div class=\"stat\"><div class=\"title\">Weight In Flow</div><div class=\"number\" ng-bind-html=\"(vm.weightInFlow | weight)\"></div></div></div><div class=\"col-md-2 col-xs-12 stats-item\"><div class=\"icon\"><i class=\"fa fa-arrow-up negative\" aria-hidden=\"true\"></i></div><div class=\"stat\"><div class=\"title\">Weight Out Flow</div><div class=\"number\" ng-bind-html=\"(vm.weightOutFlow | weight)\"></div></div></div><div class=\"col-md-2 col-xs-12 stats-item\"><div class=\"icon\"><i class=\"fa fa-truck positive\" aria-hidden=\"true\"></i></div><div class=\"stat\"><div class=\"title\">Truck In flow</div><div class=\"number\" ng-bind=\"vm.trucksInFlow\"></div></div></div><div class=\"col-md-2 col-xs-12 stats-item\"><div class=\"icon\"><i class=\"fa fa-truck negative\" aria-hidden=\"true\"></i></div><div class=\"stat\"><div class=\"title\">Truck Out Flow</div><div class=\"number\" ng-bind=\"vm.trucksOutFlow\"></div></div></div><div class=\"col-md-2 col-xs-12 stats-item\"><div class=\"icon\"><i class=\"fa fa-cubes\" aria-hidden=\"true\"></i></div><div class=\"stat\"><div class=\"title\">Weight Difference</div><div class=\"number\" ng-class=\"{\'positive\': (vm.weightDifferance > 0), \'negative\':(vm.weightDifferance < 0)}\" ng-bind-html=\"(vm.weightDifferance | weight)\"></div></div></div><div class=\"col-md-1 col-xs-12\"></div></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.inventoryRecords.length!==0\"><th>Flow</th><th>Date</th><th>Warehouse</th><th><span class=\"titled\">Lot No</span></th><th>Product</th><th>Business</th><th>Truck</th><th>Total Quantity <span class=\"titled\">Kgs</span></th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.inventoryRecords.length===0\"><th>No Inventory Records have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.filteredRecords\"><td class=\"titled\"><i class=\"fa\" ng-class=\"{\'fa-arrow-up\':!row.positive, \'negative\':!row.positive,\'fa-arrow-down\':row.positive, \'positive\': row.positive}\" aria-hidden=\"true\"></i></td><td ng-bind=\"row.date | date:appFormats.Date\"></td><td ng-bind=\"row.warehouse__name\"></td><td ng-bind=\"row.lot_no\"></td><td ng-bind=\"row.product__name\"></td><td ng-bind=\"row.transaction_business__bp_name\"></td><td ng-bind=\"row.total_trucks\"></td><td ng-bind=\"row.total_weight_in_kgs | number: \'2\'\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editRecord(row.id)\">Edit</button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/dashboard/inventory/inventoryTruckForm.html","<div class=\"modal-content\"><form name=\"inventoryTruckForm\" novalidate=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">Inventory Truck Form</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><h3 class=\"with-line\">Date</h3><date-picker-input date=\"inventoryTruckObj.date\" blank=\"false\" name=\"dateChange\"></date-picker-input><ng-messages for=\"inventoryTruckForm.dateChange.$error\" ng-show=\"(inventoryTruckForm.$submitted || inventoryTruckForm.dateChange.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter date.</ng-message></ng-messages></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><h3 class=\"with-line\">Truck No.</h3><input required=\"\" ng-model=\"inventoryTruckObj.truckNo\" class=\"form-control\" name=\"rent\" placeholder=\"Truck No\"><ng-messages for=\"inventoryTruckForm.rent.$error\" ng-show=\"(inventoryTruckForm.$submitted || inventoryTruckForm.rent.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter truck no.</ng-message></ng-messages></div></div><div class=\"col-md-4 col-xs-12\"><div class=\"form-group\"><h3 class=\"with-line\">Weight In <span class=\"titled\">Kgs</span></h3><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"inventoryTruckObj.weightInKg\" class=\"form-control\" name=\"weightInKg\" placeholder=\"Weight in Kgs\"><ng-messages for=\"inventoryTruckForm.weightInKg.$error\" ng-show=\"(inventoryTruckForm.$submitted || inventoryTruckForm.weightInKg.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter weight in kg.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Weight in Kg can only have numbers.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><h3 class=\"with-line\">Remarks</h3><textarea ng-model=\"inventoryTruckObj.remarks\" class=\"form-control\" name=\"remarks\" placeholder=\"Remarks\">\n                    </textarea></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"saveNewInventoryTruck(inventoryTruckForm, inventoryRecordId, inventoryTruckObj)\">Save Truck</button></div></form></div>");
$templateCache.put("app/dashboard/inventory/lotNumberFormModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">Transaction Completion</h4></div><div class=\"modal-body\"><div class=\"row\"><form name=\"completionForm\" novalidate=\"\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"completeObj.complete\"> <span>Complete</span></label></div></div></div><div class=\"col-md-12 col-xs-12\" ng-show=\"completeObj.complete\"><div class=\"form-group\"><label class=\"with-line\">Washout Date</label><date-picker-input date=\"completeObj.completionDate\" blank=\"false\" name=\"washoutDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout date.</ng-message></ng-messages></div></div></form></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"changeCompletion(completeObj)\">Complete Transaction</button></div></div>");
$templateCache.put("app/dashboard/inventory/warehouseBusinessStockReport.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h1 class=\"modal-title\" id=\"myModalLabel\" ng-bind=\"warehouseName\"></h1></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-striped\"><thead><tr class=\"table-header\"><th></th><th>Business</th><th><i class=\"fa fa-arrow-down positive\" aria-hidden=\"true\"></i> Total In Flow <span class=\"titled\">Kg</span></th><th><i class=\"fa fa-arrow-up negative\" aria-hidden=\"true\"></i> Total Out Flow <span class=\"titled\">Kg</span></th><th>Current Stock <span class=\"titled\">Kg</span></th><th>Current Stock <span class=\"titled\">Percentage</span></th></tr></thead><tbody ng-repeat=\"business in businessReport\"><tr><td ng-click=\"toggleProductDetails(business)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!business.showDetails\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"business.showDetails\"></i></td><td class=\"titled\" ng-bind=\"business.business_name\"></td><td ng-bind=\"business.businessInFlow | number:\'2\'\"></td><td ng-bind=\"business.businessOutFlow | number:\'2\'\"></td><td ng-bind=\"business.quantityInStock | number:\'2\'\"></td><td class=\"titled\" ng-bind=\"(business.quantityPercentage | number:\'2\')+\'%\'\"></td></tr><tr ng-show=\"business.showDetails\"><td colspan=\"6\"><table class=\"table table-striped\"><thead><tr class=\"table-header\"><th>Product Name</th><th><i class=\"fa fa-arrow-down positive\" aria-hidden=\"true\"></i> Product In Flow <span class=\"titled\">Kg</span></th><th><i class=\"fa fa-arrow-up negative\" aria-hidden=\"true\"></i> Product Out Flow <span class=\"titled\">Kg</span></th><th>Current Stock <span class=\"titled\">Kg</span></th><th>Current Stock <span class=\"titled\">Percentage</span></th></tr></thead><tbody><tr ng-repeat=\"product in business.productFlow\"><td class=\"titled\" ng-bind=\"product.product__name\"></td><td ng-bind=\"product.truckInFlow | number:\'2\'\"></td><td ng-bind=\"product.truckOutFlow | number:\'2\'\"></td><td ng-bind=\"product.currentQuantity | number:\'2\'\"></td><td ng-bind=\"(product.quantityPercentage| number:\'2\')+\'%\'\"></td></tr></tbody></table></td></tr></tbody><tr><td></td><td class=\"titled\">Total</td><td class=\"titled\" ng-bind=\"totalInFlow| number:\'2\'\"></td><td class=\"titled\" ng-bind=\"totalOutFlow| number:\'2\'\"></td><td class=\"titled\" ng-bind=\"warehouseQuantity| number:\'2\'\"></td><td></td></tr></table></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Close</button></div></div>");
$templateCache.put("app/dashboard/inventory/warehouseDetails.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\"><div class=\"panel-content\"><div class=\"row warehouse-details\"><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\"><button style=\"margin-left: 10px\" ng-click=\"vm.changeCurrentWarehouseRent(vm.warehouseObj.id, vm.onrentSaveCallBack)\" class=\"btn btn-xs btn-primary pull-right\">{{(vm.warehouseObj.rentList.length===0) ? \'Add Current Rent\' : \'Change Current Rent\'}}</button> <button ng-click=\"vm.editWarehouseDetails(vm.warehouseObj.id)\" class=\"btn btn-xs btn-success pull-right\">Edit</button></h3></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Warehouse Name</h3><div ng-bind=\"vm.warehouseObj.name\"></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Total Capacity</h3><div ng-bind=\"vm.warehouseObj.totalCapacity\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Consumed Capacity <span class=\"titled\">Kgs</span></h3><div ng-bind=\"vm.warehouseObj.consumedCapacity\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Own Warehouse</h3><div></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Current Rent per <span class=\"titled\">Kgs</span> per <span class=\"titled\">Month</span></h3><div ng-bind=\"vm.warehouseObj.rentPer50Kg\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Address</h3><div ng-bind=\"vm.warehouseObj.address\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Contact Details</h3><div ng-bind=\"vm.warehouseObj.contact\" class=\"number\"></div></div></div><div class=\"row warehouse-rent-details\" ng-if=\"vm.warehouseObj.rentList.length!==0\"><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Warehouse Rent Details</h3><div></div></div><div class=\"col-xs-12\"><table class=\"table table-striped\"><thead><tr class=\"sortable table-header\"><th>Rent Applicable Till</th><th>Rent Applicable From</th><th>Rent Per Kg Per Month <span ng-bind=\"vm.warehouseObj.rentCurrency\"></span></th></tr></thead><tbody><tr ng-repeat=\"row in vm.warehouseObj.rentList | orderBy:\'-dateChange\'\"><td class=\"titled\" ng-bind=\"row.dateEnd ? (row.dateEnd | date:vm.appFormats.Date) : \'Present\'\"></td><td class=\"titled\" ng-bind=\"row.dateChange | date:vm.appFormats.Date\"></td><td class=\"titled\" ng-bind=\"row.rent | number : \'2\'\"></td></tr></tbody></table></div><div class=\"col-xs-12\"><button ng-click=\"vm.backToWarehouseList()\" class=\"btn btn-primary\">Back to Warehouse List</button></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/inventory/warehouseForm.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\"><div class=\"panel-content\"><form name=\"vm.warehouseForm\" novalidate=\"\"><div class=\"row\"><div class=\"form-group col-md-12 clearfix\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"vm.warehouseObj.selfWarehouse\"> <span>Own Warehouse</span></label></div></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">Warehouse Name</label> <input ng-required=\"true\" ng-model=\"vm.warehouseObj.name\" class=\"form-control\" name=\"wh_name\" placeholder=\"Warehouse Name\"><ng-messages for=\"vm.warehouseForm.wh_name.$error\" ng-show=\"(vm.warehouseForm.$submitted || vm.warehouseForm.wh_name.$dirty)\"><ng-message class=\"errorValidation\" when=\"required\">Please enter warehouse name.</ng-message></ng-messages></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">No. of <span class=\"titled\">Lots</span></label> <input ng-required=\"true\" ng-pattern=\"/^[0-9]+$/i\" ng-model=\"vm.warehouseObj.lots\" class=\"form-control\" name=\"wh_lots\" placeholder=\"Warehouse Lots\"><ng-messages for=\"vm.warehouseForm.wh_lots.$error\" ng-show=\"(vm.warehouseForm.$submitted || vm.warehouseForm.wh_lots.$dirty)\"><ng-message class=\"errorValidation\" when=\"required\">Please enter warehouse lots.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Warehouse Lot No. can only have number as input</ng-message></ng-messages></div><div class=\"form-group col-md-6 clearfix\"><label class=\"with-line control-label\">Address</label> <textarea ng-model=\"vm.warehouseObj.address\" class=\"form-control\" name=\"name\" placeholder=\"Warehouse Address\">\n                            <br>\n                            <label class=\"with-line control-label\">Contact Details</label>\n                            </textarea><textarea ng-model=\"vm.warehouseObj.contact\" class=\"form-control\" name=\"name\" placeholder=\"Warehouse Contact Details\">\n                        </textarea></div><div class=\"form-group col-md-6\"><label class=\"with-line control-label\">Total Capacity <span class=\"titled\">Kgs</span></label> <input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.warehouseObj.totalCapacity\" class=\"form-control\" name=\"totalCapacity\" placeholder=\"Warehouse Total Capacity\"><ng-messages for=\"vm.warehouseForm.totalCapacity.$error\" ng-show=\"(vm.warehouseForm.$submitted || vm.warehouseForm.totalCapacity.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter warehouse total capacity in kgs.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Total Quantity in Kgs can only aceept numbers</ng-message></ng-messages></div><div class=\"form-group col-md-6 col-md-offset-6\"></div></div><div class=\"row\"><button type=\"submit\" ng-click=\"vm.saveWarehouse(vm.isNew, vm.warehouseForm, vm.warehouseObj)\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>{{vm.isNew ? \'Add New Warehouse\': \'Update Warehouse\'}}</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div></div></div>");
$templateCache.put("app/dashboard/inventory/warehouseLotReport.html","<div>Warehouse Lot Report</div>");
$templateCache.put("app/dashboard/inventory/warehouseProductStockReport.html","<div class=\"modal-content\"><form name=\"inventoryTruckForm\" novalidate=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h1 class=\"modal-title\" id=\"myModalLabel\" ng-bind=\"warehouseName\"></h1></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><table class=\"table table-striped\"><thead><tr class=\"table-header\"><th colspan=\"2\">Product</th><th>Total Quantity <span class=\"titled\">Kg</span></th><th>Self Quantity <span class=\"titled\">Kg</span></th><th>Other Business Quantity <span class=\"titled\">Kg</span></th></tr></thead><tbody><tr ng-repeat=\"product in productReport\"><td class=\"titled\" ng-bind=\"product.productName\"></td><td class=\"titled\" ng-bind=\"(product.stockPercentage | number:\'2\')+\'%\'\"></td><td ng-bind=\"product.quantityInStock | number:\'2\'\"></td><td ng-bind=\"product.selfQuantity | number:\'2\'\"></td><td ng-bind=\"product.otherBusinessQuantityInStock | number:\'2\'\"></td></tr></tbody><tfoot><tr><td></td><td class=\"titled\">Total</td><td class=\"titled\" ng-bind=\"warehouseQuantity| number:\'2\'\"></td><td class=\"titled\" ng-bind=\"totalSelfQuantity| number:\'2\'\"></td><td class=\"titled\" ng-bind=\"totalOtherQuantity| number:\'2\'\"></td></tr></tfoot></table></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Close</button></div></form></div>");
$templateCache.put("app/dashboard/inventory/warehouseRentForm.html","<div class=\"modal-content\"><form name=\"warehouseRentChange\" novalidate=\"\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">New Warehouse Rent</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><h3 class=\"with-line\">Rent Applicable From</h3><date-picker-input date=\"vm.warehouseRentObj.dateChange\" blank=\"false\" name=\"dateChange\"></date-picker-input><ng-messages for=\"warehouseRentChange.dateChange.$error\" ng-show=\"(warehouseRentChange.$submitted || warehouseRentChange.dateChange.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter date since rent is applicable.</ng-message></ng-messages></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><h3 class=\"with-line\">Rent Per <span class=\"titled\">50 Kg</span> Per <span class=\"titled\">Month</span></h3><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.warehouseRentObj.rent\" class=\"form-control\" name=\"rent\" placeholder=\"Rent per 50 kg per month\"><ng-messages for=\"warehouseRentChange.rent.$error\" ng-show=\"(warehouseRentChange.$submitted || warehouseRentChange.rent.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter current rent per 50 kg per month.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Rent can only have numbers.</ng-message></ng-messages></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.saveNewCurrentRent(warehouseRentChange, vm.warehouseId, vm.warehouseRentObj)\">Save Current Rent</button></div></form></div>");
$templateCache.put("app/dashboard/inventory/warehouses.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allWarehouses.length!==0\"><th colspan=\"2\">Warehouse Name</th><th>Owned</th><th>Total Capacity <span class=\"titled\">Kg</span></th><th>Consumed Capacity <span class=\"titled\">Kg</span></th><th>Current Rent Per <strong>Kg</strong> per <strong>Month</strong></th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"row in vm.allWarehouses | orderBy:\'name\'\"><td colspan=\"2\" class=\"titled\" ng-bind=\"row.name\"></td><td class=\"titled\" ng-class=\"{\'positive\':row.selfWarehouse, \'negative\':!row.selfWarehouse}\"><i class=\"fa fa-check-square\" aria-hidden=\"true\"></i></td><td ng-bind=\"row.totalCapacity\"></td><td ng-bind=\"row.consumedCapacity\"></td><td ng-bind=\"row.rentPer50Kg\"></td><td><div class=\"buttons\"><button ng-click=\"vm.lotReport(row.id)\" class=\"btn btn-success editable-table-button btn-xs\">Detail</button> <button ng-click=\"vm.goToWarehouseDetails(row.id)\" class=\"btn btn-primary editable-table-button btn-xs\">Lot Report</button></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/dashboard/localTradeBook/localTradeBook.html","<filter-bar date-picker-needed=\"true\" page=\"localTradeBook\" local-buyer=\"true\" local-seller=\"true\" product-items=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\" on-local-buyers-selected-changed=\"vm.onBuyersSelectedChanged(selectedList, initialized)\" on-local-sellers-selected-changed=\"vm.onSellersSelectedChanged(selectedList, initialized)\" on-product-item-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\"></filter-bar><trade-table type=\"localTradeBook\" column-header=\"vm.columnHeader\" list-data=\"vm.allTransactions\" items-per-page=\"10\"></trade-table>");
$templateCache.put("app/dashboard/manifest/manifest.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addNewManifestItem()\">Add New Manifest Item</button></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-if=\"vm.showForm\"><div class=\"panel-content\" include-with-scope=\"app/dashboard/manifest/template/itemForm.html\"></div></div><filter-bar ng-show=\"!vm.showForm\" date-picker-needed=\"true\" product=\"true\" buyer=\"true\" seller=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\" on-buyers-selected-changed=\"vm.onBuyersSelectedChanged(selectedList, initialized)\" on-sellers-selected-changed=\"vm.onSellersSelectedChanged(selectedList, initialized)\" on-products-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\"></filter-bar><div ba-panel=\"\" ba-panel-class=\"with-scroll min-height-500px\" ng-show=\"!vm.showForm\"><div class=\"row table-options\"><div class=\"col-md-6 manifest-quantity\"><div class=\"box title\">Total Quantity</div><div class=\"number box\">{{vm.totalQuantity}} FCL</div></div><div class=\"col-md-6 button-bar\"><button class=\"btn btn-xs\" data-toggle=\"modal\" ng-class=\"{\'btn-success\': !vm.hidePaging, \'btn-danger\': vm.hidePaging}\" ng-click=\"vm.unpagedView(vm.allManifestList, vm.hidePaging)\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> &nbsp; Unpaged View</button> <button class=\"btn excel-btn btn-xs\" data-toggle=\"modal\" ng-click=\"vm.exportToExcel(vm.allManifestList)\"><i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i> &nbsp; Export to Excel</button> <button class=\"btn pdf-btn btn-xs\" data-toggle=\"modal\" ng-click=\"vm.exportToPDF(vm.allManifestList)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> &nbsp; Export to PDF</button></div></div><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allManifestList.length!==0\"><th><span class=\"count\">{{vm.allManifestList.length}}</span></th><th>Date</th><th>Buyer</th><th>Seller</th><th>Product</th><th>Metric</th><th>Quantity</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allManifestList.length===0\"><th>No Manifest Items have been added for selected filters</th></tr></thead><tbody ng-repeat=\"row in vm.displayList\"><tr><td colspan=\"2\" ng-bind=\"row.date | date:vm.appFormats.DBDate\"></td><td class=\"business\"><div class=\"name\" ng-bind=\"row.buyerName\"></div><div class=\"contact\">{{row.buyerPrimaryContact ? row.buyerPrimaryContact : \'No Primary Contact\'}}</div><div class=\"country\"><img ng-if=\"row.buyerCountryFlag\" width=\"15\" src=\"{{vm.appConstants.STATIC_URL + \'/\' + row.buyerCountryFlag}}\"> {{row.buyerCountry ? row.buyerCountry : \'No Origin\' }}</div></td><td class=\"business\"><div class=\"name\" ng-bind=\"row.sellerName\"></div><div class=\"contact\">{{row.sellerPrimaryContact ? row.sellerPrimaryContact : \'No Primary Contact\'}}</div><div class=\"country\"><img ng-if=\"row.sellerCountryFlag\" width=\"15\" src=\"{{vm.appConstants.STATIC_URL + \'/\' + row.sellerCountryFlag}}\"> {{row.sellerCountry ? row.sellerCountry : \'No Origin\' }}</div></td><td ng-bind=\"row.productName\"></td><td ng-bind=\"row.quantityMetric\"></td><td ng-bind=\"row.quantity\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editManifestItem(row)\">Edit</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-if=\"row.deleteable\" ng-click=\"vm.deleteManifestItem(row)\">Delete</button></div></td></tr></tbody></table></div><div ng-show=\"!vm.hidePaging\"><ul ng-show=\"vm.totalItems > 0\" uib-pagination=\"\" ng-change=\"vm.pageChanged()\" total-items=\"vm.totalItems\" ng-model=\"vm.currentPage\" max-size=\"vm.itemsPerPage\" class=\"pagination-sm push-left\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div>");
$templateCache.put("app/dashboard/manifest/manifestDashboard.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.goToManifestItems()\">Manifest Items</button></div></div><div class=\"row\"><div class=\"col-lg-12\"><filter-bar ng-show=\"!vm.showForm\" date-picker-needed=\"true\" product=\"true\" buyer=\"true\" seller=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\" on-buyers-selected-changed=\"vm.onBuyersSelectedChanged(selectedList, initialized)\" on-sellers-selected-changed=\"vm.onSellersSelectedChanged(selectedList, initialized)\" on-products-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\"></filter-bar></div></div><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\"><div class=\"row\"><div class=\"row pie-charts\" ng-if=\"vm.showCharts\"><div class=\"pie-chart-item-container\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::vm.dashboardColors.colors.success }}\" data-percent=\"{{vm.sumData.sumPercentage}}\"><span class=\"percent\"></span></div><div class=\"description\"><div>Total Containers</div><div class=\"description-stats\">{{::vm.sumData.filteredSum}}<span class=\"metric\">FCL</span></div></div></div></div></div></div><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-7 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Container FCL\" ba-panel-class=\"medium-panel\"><line-chart chart-data=\"vm.graphData\" chart-values=\"vm.chartValues\"></line-chart></div></div></div>");
$templateCache.put("app/dashboard/pricing/priceAnalytics.html","<filter-bar date-picker-needed=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\"></filter-bar><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\"><div class=\"row\"><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-7 col-xs-12\" ba-panel=\"\" ba-panel-title=\"Product Pricing\" ba-panel-class=\"medium-panel\"><line-chart ng-if=\"vm.showGraph\" chart-data=\"vm.graphData\" chart-values=\"vm.chartValues\" chart-type=\"vm.chartType\"></line-chart></div></div></div>");
$templateCache.put("app/dashboard/pricing/priceMarket.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addPriceMarket()\">Add New Price Market</button></div></div><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-if=\"vm.showForm\"><div class=\"panel-content\"><form><h3 class=\"with-line\"></h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"productItem\" class=\"col-sm-2 control-label\">Country</label><div class=\"col-sm-6\"><selectize ng-disabled=\"vm.priceMarket.isInternational\" id=\"productItem\" config=\"vm.countryConfig\" options=\"vm.countryOptions.list\" ng-model=\"vm.priceMarket.country\"></selectize></div><label class=\"col-sm-2\">International</label><div class=\"col-sm-2\"><switch color=\"primary\" ng-model=\"vm.priceMarket.isInternational\"></switch></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"priceMarketCurrency\" class=\"col-sm-3 control-label\">Currency</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" id=\"priceMarketCurrency\" config=\"vm.currencyConfig\" options=\"vm.currencyOptions.list\" ng-model=\"vm.priceMarket.currency\"></selectize></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group row clearfix\"><label for=\"marketDescription\" class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-12\"><textarea placeholder=\"Market Description\" ng-model=\"vm.priceMarket.description\" class=\"form-control\" id=\"marketDescription\"></textarea></div></div></div></div><button type=\"button\" ng-if=\"!vm.priceMarket.id\" ng-click=\"vm.addNewPriceMarket(vm.priceMarket)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Pricing</button> <button type=\"button\" ng-if=\"vm.priceMarket.id\" ng-click=\"vm.updatePriceMarket(vm.priceMarket)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Pricing</button> <button type=\"button\" ng-click=\"vm.cancelPriceMarket()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></form></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allMarkets.length!==0\"><th>Country</th><th>Currency</th><th>Description</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allMarkets.length===0\"><th>No values have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.allMarkets\"><td class=\"titled\" ng-bind=\"row.countryName\"></td><td ng-bind=\"row.currency\"></td><td ng-bind=\"row.description\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editPriceMarket(row)\">Edit</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/pricing/pricing.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addProductPricing(\'dashboard.pricing.productItems\')\">Product Pricing</button> <button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addProductPricing(\'dashboard.pricing.market\')\">Pricing Market</button></div></div><filter-bar country=\"true\" product=\"true\" on-products-selected-changed=\"vm.onProductsSelectedChanged(selectedList)\" on-country-selected-changed=\"vm.onCountrySelectedChanged(selectedList)\"></filter-bar><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><div class=\"priceItemList col-lg-12\"><div class=\"priceContainer col-lg-4 col-sm-12\" ng-repeat=\"row in vm.allProductPriceSummary | selectedRows:vm.priceSummaryToRemove:\'productItemId\'\"><div class=\"priceItem\"><div class=\"col-lg-12 col-xs-12\"><div class=\"productName\"><div class=\"name\" ng-bind=\"row.productName\"></div><div><div class=\"productKeyword\" ng-bind=\"row.keywords\"></div><div class=\"productOrigin\">{{row.productOriginName}}</div><img width=\"60\" src=\"{{vm.appConstants.HOST + row.originFlag}}\">&nbsp;</div></div></div><div ng-if=\"row.internationalPrice!==\'NA\'\" class=\"col-lg-6 col-sm-6 priceDetails\"><div class=\"currency\">International</div><div class=\"change\" ng-if=\"row.internationalPercentangeChange==\'NA\' || row.internationalPercentangeChange==0\"><i class=\"icon fa fa-minus\"></i></div><div class=\"change\" ng-if=\"row.internationalPercentangeChange !== 0 && row.internationalPercentangeChange!==\'NA\'\"><div class=\"number\" ng-bind=\"row.internationalPercentangeChange + \' %\'\"></div><i ng-if=\"row.internationalPercentangeChange > 0\" class=\"icon fa fa-caret-up\"></i> <i ng-if=\"row.internationalPercentangeChange < 0\" class=\"icon fa fa-caret-down\"></i></div><div class=\"currency\" ng-bind=\"row.internationalCurrency\"></div><div class=\"price-number\" ng-bind=\"row.internationalPrice\"></div><div class=\"metric\" ng-bind=\"\'per \' +row.internationalMetric\"></div><div class=\"high-lows\"><div class=\"heading\">Weekly</div><div class=\"info\"><div class=\"info-label\">High</div><div class=\"number\" ng-if=\"row.weeklyInternational.high!==\'NA\'\">{{row.internationalCurrency + \' \' + row.weeklyInternational.high + \' / \' + row.internationalMetric}}</div></div><div class=\"info\"><div class=\"info-label\">Low</div><div class=\"number\" ng-if=\"row.weeklyInternational.low!==\'NA\'\">{{row.internationalCurrency + \' \' + row.weeklyInternational.low + \' / \' + row.internationalMetric}}</div></div><div class=\"heading\">Monthly</div><div class=\"info\"><div class=\"info-label\">High</div><div class=\"number\" ng-if=\"row.monthlyInternational.high!==\'NA\'\">{{row.internationalCurrency + \' \' + row.monthlyInternational.high + \' / \' + row.internationalMetric}}</div></div><div class=\"info\"><div class=\"info-label\">Low</div><div class=\"number\" ng-if=\"row.monthlyInternational.low!==\'NA\'\">{{row.internationalCurrency + \' \' + row.monthlyInternational.low + \' / \' + row.internationalMetric}}</div></div></div><div class=\"lastUpdated\" ng-bind=\"(row.intlastUpdated !== \'NA\') ? (row.intlastUpdated | date: vm.appFormats.Time) : \'NA\'\"></div></div><div ng-if=\"row.internationalPrice===\'NA\'\" class=\"col-lg-6 col-sm-6 priceDetails\"><div class=\"currency\">International</div><div class=\"price-number-na\">NA</div></div><div ng-if=\"row.localCurrency!==\'NA\'\" class=\"col-lg-6 col-sm-6 priceDetails\"><div class=\"currency\">Local</div><div class=\"change\" ng-if=\"row.localPercentangeChange==\'NA\' || row.localPercentangeChange==0\"><i class=\"icon fa fa-minus\"></i></div><div class=\"change\" ng-if=\"row.localPercentangeChange !== 0 && row.localPercentangeChange!==\'NA\'\"><div class=\"number\" ng-bind=\"row.localPercentangeChange + \' %\'\"></div><i ng-if=\"row.localPercentangeChange > 0\" class=\"icon fa fa-caret-up\"></i> <i ng-if=\"row.localPercentangeChange < 0\" class=\"icon fa fa-caret-down\"></i></div><div class=\"currency\" ng-bind=\"row.localCurrency\"></div><div class=\"price-number\" ng-bind=\"row.localPrice\"></div><div class=\"metric\" ng-bind=\"\'per \' +row.localMetric\"></div><div class=\"high-lows\"><div class=\"heading\">Weekly</div><div class=\"info\"><div class=\"info-label\">High</div><div class=\"number\" ng-if=\"row.weeklyInternational.high!==\'NA\'\">{{row.localCurrency + \' \' + row.weeklyLocal.high + \' / \' + row.localMetric}}</div></div><div class=\"info\"><div class=\"info-label\">Low</div><div class=\"number\" ng-if=\"row.weeklyInternational.low!==\'NA\'\">{{row.localCurrency + \' \' + row.weeklyLocal.low + \' / \' + row.localMetric}}</div></div><div class=\"heading\">Monthly</div><div class=\"info\"><div class=\"info-label\">High</div><div class=\"number\" ng-if=\"row.monthlyLocal.high!==\'NA\'\">{{row.localCurrency + \' \' + row.monthlyLocal.high + \' / \' + row.localMetric}}</div></div><div class=\"info\"><div class=\"info-label\">Low</div><div class=\"number\" ng-if=\"row.monthlyLocal.low!==\'NA\'\">{{row.localCurrency + \' \' + row.monthlyLocal.low + \' / \' + row.localMetric}}</div></div></div><div class=\"lastUpdated\" ng-bind=\"(row.locallastUpdated !== \'NA\') ? (row.locallastUpdated | date: vm.appFormats.Time) : \'NA\'\"></div></div><div ng-if=\"row.localCurrency===\'NA\'\" class=\"col-lg-6 col-sm-6 priceDetails\"><div class=\"currency\">Local</div><div class=\"price-number-na\">NA</div></div><button class=\"btn btn-primary col-lg-8 analytics-button\" ng-click=\"vm.productPriceReport(row.productItemId)\">Price Analytics</button></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/pricing/productPricing.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addNewProductItemPrice()\">Add New Product Price</button></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-if=\"vm.showForm\"><div class=\"panel-content\"><form name=\"vm.marketPriceForm\" novalidate=\"\"><h3 class=\"with-line\"></h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"productItem\" class=\"col-sm-3 control-label\">Product Item</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" name=\"productItem\" id=\"productItem\" config=\"vm.productItemConfig\" options=\"vm.productItemOptions.list\" ng-model=\"vm.marketPriceObj.productItemId\"></selectize><ng-messages for=\"vm.marketPriceForm.productItem.$error\" ng-if=\"(vm.marketPriceForm.$submitted || vm.marketPriceForm.productItem.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter product item.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"priceMarket\" class=\"col-sm-3 control-label\">Price Date</label><div class=\"col-sm-9\"><div uib-datepicker=\"\" ng-model=\"vm.marketPriceObj.priceTime\" ng-change=\"vm.onPriceDateChange()\" class=\"calender margin-top-10px\" datepicker-options=\"options\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"priceMarket\" class=\"col-sm-3 control-label\">Price Market</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" name=\"priceMarket\" on-change=\"vm.onPriceMarketChange()\" id=\"priceMarket\" config=\"vm.priceMarketConfig\" options=\"vm.priceMarketOptions.list\" ng-model=\"vm.marketPriceObj.priceMarketId\"></selectize><ng-messages for=\"vm.marketPriceForm.priceMarket.$error\" ng-if=\"(vm.marketPriceForm.$submitted || vm.marketPriceForm.priceMarket.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter price market.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"priceMarket\" class=\"col-sm-3 control-label\">Price Time</label><div class=\"col-sm-9\"><div uib-timepicker=\"\" ng-model=\"vm.marketPriceObj.priceTime\" ng-change=\"changed()\" hour-step=\"1\" minute-step=\"1\" show-meridian=\"true\"></div></div></div><div class=\"form-group row clearfix\"><label for=\"priceMarket\" class=\"col-sm-3 control-label\">Price Metric</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" name=\"priceMetric\" id=\"priceMetric\" config=\"vm.priceMetricConfig\" options=\"vm.priceMetricOptions.list\" ng-model=\"vm.marketPriceObj.priceMetricId\"></selectize><ng-messages for=\"vm.marketPriceForm.priceMarket.$error\" ng-if=\"(vm.marketPriceForm.$submitted || vm.marketPriceForm.priceMetric.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter price metric.</div></ng-messages></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group row clearfix\"><label for=\"priceComments\" class=\"col-sm-3 control-label\">Comments</label><div class=\"col-sm-12\"><textarea ng-model=\"vm.marketPriceObj.comments\" placeholder=\"Price comments\" class=\"form-control\" id=\"priceComments\">\n                        </textarea></div></div></div></div><h3 class=\"with-line\">Pricing Details &nbsp; <i ng-click=\"vm.addMarketPriceItemObj(vm.marketPriceObj)\" class=\"fa fa-plus primary-font cursor-pointer\"></i></h3><div ng-repeat=\"price in vm.marketPriceObj.priceItems\" class=\"notification row clearfix margin-top-10px\"><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-3\" for=\"shipmentMonth_{{index}}\">Shipment</label><div class=\"col-xs-9\"><selectize name=\"{{\'shipmentMonth_\'+$index}}\" ng-required=\"true\" id=\"shipmentMonth_{{index}}\" config=\"vm.shipmentMonthConfig\" options=\"vm.shipmentMonthOptions.list\" ng-model=\"price.shipmentMonths\"></selectize><div ng-messages=\"vm.marketPriceForm[\'shipmentMonth_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.marketPriceForm.$submitted || vm.marketPriceForm[\"shipmentMonth_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter shipment month.</div></div></div></div></div><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Price ({{vm.currentCurrency}} / {{vm.marketPriceObj.priceMetricId ? vm.marketPriceObj.priceMetricId : \'FCL\' }})</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-pattern=\"/^[0-9]+(\\.[0-9][0-9])$/i\" ng-model=\"price.priceValue\" class=\"form-control\" name=\"{{\'priceValue_\'+$index}}\" placeholder=\"Market price in {{vm.currentCurrency}}\"><div ng-messages=\"vm.marketPriceForm[\'priceValue_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.marketPriceForm.$submitted || vm.marketPriceForm[\"priceValue_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter price value.</div><div class=\"errorValidation\" ng-message=\"pattern\">Price should be number in two decimals.</div></div></div></div></div><div class=\"col-sm-2\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-change=\"vm.currentValueChange(vm.marketPriceObj, price, price.currentValue)\" ng-model=\"price.currentValue\"> <span>Current Market Value</span></label></div></div><div class=\"col-sm-2\"><i ng-click=\"vm.removeMarketPriceItemObj(vm.marketPriceObj, price)\" class=\"fa fa-trash primary-font cursor-pointer\" style=\"padding-top: 10px;\"></i></div><br><br><h3 class=\"with-line margin-top-10px margin-bottom-10px\" style=\"width:98%; margin-left: auto; margin-right: auto;\"></h3></div><button type=\"submit\" ng-if=\"!vm.marketPriceObj.id\" ng-click=\"vm.addMarketPrice(vm.marketPriceForm, vm.marketPriceObj, true)\" class=\"btn btn-success btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Pricing And Add Another</button> <button type=\"submit\" ng-if=\"!vm.marketPriceObj.id\" ng-click=\"vm.addMarketPrice(vm.marketPriceForm, vm.marketPriceObj, false)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Pricing And Exit</button> <button type=\"submit\" ng-if=\"vm.marketPriceObj.id\" ng-click=\"vm.updateMarketPrice(vm.marketPriceForm, vm.marketPriceObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Pricing</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></form></div></div><filter-bar ng-show=\"!vm.showForm\" date-picker-needed=\"true\" country=\"true\" price-market=\"true\" product=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\" on-products-selected-changed=\"vm.onProductsSelectedChanged(selectedList)\" on-country-selected-changed=\"vm.onCountrySelectedChanged(selectedList)\" on-price-market-selected-changed=\"vm.onPriceMarketSelectedChanged(selectedList)\"></filter-bar><div ba-panel=\"\" ba-panel-class=\"with-scroll min-height-500px\" ng-show=\"!vm.showForm\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allPriceItems.length!==0\"><th><span class=\"count\">{{vm.allPriceItems.length}}</span></th><th>Price Time</th><th>Product</th><th>Origin</th><th>Keywords</th><th>Price Market</th><th>Market Currency</th><th>Price Metric</th><th>Price</th><th>Updated By</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allPriceItems.length===0\"><th>No Price Items have been added for this date.</th></tr></thead><tbody ng-repeat=\"row in vm.allPriceItems | selectedRows:vm.priceItemsToRemove:\'id\'\"><tr><td ng-click=\"vm.toggleDetailDisplay(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showDetails\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showDetails\"></i></td><td ng-bind=\"row.priceTime | date:vm.appFormats.Time\"></td><td ng-bind=\"row.productName\"></td><td ng-bind=\"row.productOriginName\"></td><td ng-bind=\"row.keywords\"></td><td ng-bind=\"row.marketCountry\"></td><td ng-bind=\"row.marketCurrency\"></td><td ng-bind=\"row.priceMetric\"></td><td class=\"titled\" ng-bind=\"row.marketCurrency + \' \' + row.currentPrice\"></td><td class=\"titled\" ng-bind=\"row.updatedBy ? row.updatedBy : row.createdBy\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editProductItemPrice(row)\">Edit</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"vm.deleteMarketPrice(row)\">Delete</button></div></td></tr><tr><td colspan=\"12\"><div class=\"priceDetails row\" ng-show=\"row.showDetails\"><div class=\"col-md-4 comments\"><div class=\"label col-md-12\">Comments</div><div class=\"label col-md-12 comment\" ng-bind=\"row.comments\"></div></div><div class=\"col-md-8\"><div class=\"col-md-12 priceInfo\" ng-repeat=\"price in row.priceItems\"><div class=\"col-md-8\" ng-repeat=\"month in price.shipmentMonths\"><div ng-bind=\"month | date: vm.appFormats.ShipmentMonth\"></div></div><div class=\"col-md-4\" ng-bind=\"row.marketCurrency + \' \' + price.priceValue\"></div></div></div></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/products/priceAnalytics.html","<filter-bar ng-show=\"!vm.showForm\" date-picker-needed=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange)\"></filter-bar><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ba-panel=\"\"><div class=\"row\"><div class=\"row pie-charts\" ng-if=\"vm.showCharts\"><div class=\"pie-chart-item-container\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::vm.dashboardColors.colors.success }}\" data-percent=\"{{vm.sumData.sumPercentage}}\"><span class=\"percent\"></span></div><div class=\"description\"><div>Average Price</div><div class=\"description-stats\">{{::vm.sumData.filteredSum}}<span class=\"metric\">FCL</span></div></div></div></div></div></div><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-7 col-xs-12\" ba-panel=\"\" ba-panel-class=\"medium-panel\"><line-chart chart-data=\"vm.graphData\"></line-chart></div></div></div>");
$templateCache.put("app/dashboard/products/productCategories.html","<div class=\"row\"><div class=\"col-md-12 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" ng-click=\"vm.addNewCategory()\">Add New Category</button></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-if=\"vm.showForm\"><div class=\"panel-content\"><form name=\"vm.productCategoryForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Category</label> <input type=\"text\" ng-model=\"vm.categoryObj.name\" ng-required=\"true\" name=\"categoryName\" class=\"form-control\" id=\"categoryName\" placeholder=\"Category\"><ng-messages for=\"vm.productCategoryForm.productName.$error\" ng-if=\"(vm.productCategoryForm.$submitted && vm.productCategoryForm.categoryName.$invalid) || (vm.productCategoryForm.categoryName.$invalid && vm.productCategoryForm.categoryName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a category name</div></ng-messages><span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label>Description</label> <textarea placeholder=\"Category Description\" ng-model=\"vm.categoryObj.description\" class=\"form-control\" id=\"priceComments\"></textarea></div></div><button type=\"submit\" ng-if=\"!vm.categoryObj.id\" ng-click=\"vm.addCategory(vm.productCategoryForm, vm.categoryObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Product Category</button> <button type=\"submit\" ng-if=\"vm.categoryObj.id\" ng-click=\"vm.updateCategory(vm.productCategoryForm, vm.categoryObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Product Category</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allCategories.length!==0\"><th>Product Category</th><th>Description</th><th>Number of Keywords</th><th>Number of Products</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allCategories.length===0\"><th>No values have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.allCategories\"><td class=\"titled\" ng-bind=\"row.name\"></td><td ng-if=\"row.description\" ng-bind=\"row.description\"></td><td ng-if=\"!row.description\">No Description Provided</td><td ng-bind=\"row.keywordCount\"></td><td ng-bind=\"row.productCount\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editCategory(row)\">Edit</button> <button style=\"width: 115px;\" class=\"btn btn-success editable-table-button btn-xs\" ng-click=\"vm.specification(row.id)\">Specification</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/products/productItems.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addNewProductItem()\">Add New Product Item</button></div></div><filter-bar ng-show=\"!vm.showForm\" country=\"true\" product=\"true\" on-products-selected-changed=\"vm.onProductsSelectedChanged(selectedList)\" on-country-selected-changed=\"vm.onCountrySelectedChanged(selectedList)\"></filter-bar><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-if=\"vm.showForm\"><div class=\"panel-content\"><form name=\"vm.productItemForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Product</label><selectize ng-required=\"true\" name=\"product\" config=\"vm.productConfig\" options=\"vm.productOptions.list\" ng-model=\"vm.productItem.productId\"></selectize><ng-messages for=\"vm.productItemForm.productName.$error\" ng-if=\"(vm.productItemForm.$submitted && vm.productItemForm.productName.$invalid) || (vm.productItemForm.productName.$invalid && vm.productItemForm.productName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select a product.</div></ng-messages><span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Product Origin</label><selectize ng-disabled=\"!vm.productItem.productId\" id=\"product-origin\" ng-required=\"true\" name=\"productOrigin\" config=\"vm.originConfig\" options=\"vm.originOptions.list\" ng-model=\"vm.productItem.origin\"></selectize><ng-messages for=\"vm.productItemForm.productOrigin.$error\" ng-if=\"(vm.productItemForm.$submitted && vm.productItemForm.productOrigin.$invalid) || (vm.productItemForm.productOrigin.$invalid && vm.productItemForm.productOrigin.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select a product origin.</div></ng-messages><span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-lg-12\"><div class=\"form-group\"><label>Product Keywords</label><selectize ng-disabled=\"!vm.productItem.productId\" ng-required=\"true\" name=\"productKeyword\" config=\"vm.keywordConfig\" options=\"vm.keywordOptions.list\" ng-model=\"vm.productItem.keywords\"></selectize></div><div class=\"form-group\"><label>Import Expense</label> <input type=\"text\" ng-model=\"vm.productItem.importExpense\" name=\"importExpense\" required=\"true\" class=\"form-control\" id=\"importExpense\" placeholder=\"Import Expense\"><ng-messages for=\"vm.productItemForm.importExpense.$error\" ng-if=\"(vm.productItemForm.$submitted && vm.productItemForm.importExpense.$invalid) || (vm.productItemForm.importExpense.$invalid && vm.productItemForm.importExpense.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter import Expense.</div></ng-messages></div><div class=\"form-group\"><label>System Database Ids</label> <input type=\"text\" ng-model=\"vm.productItem.databaseIds\" name=\"keywordName\" class=\"form-control\" id=\"databaseIds\" placeholder=\"Database Ids\"></div></div><div class=\"col-sm-12\"><div class=\"slider-box col-sm-12 col-md-4\" ng-repeat=\"spec in vm.productItem.specification | orderBy:\'name\'\"><h5 ng-bind=\"spec.name\" style=\"padding-top: 20px\"></h5><input style=\"margin-top: 25px;\" class=\"form-control\" ng-model=\"spec.value\" ng-if=\"spec.type==\'text\'\"><ion-slider ng-if=\"spec.type==\'percentage\'\" type=\"single\" grid=\"true\" from=\"spec.value\" ng-model=\"spec.value\" min=\"0\" max=\"100\" prefix=\"%\" disable=\"false\"></ion-slider></div></div><button type=\"button\" ng-if=\"!vm.productItem.id\" ng-click=\"vm.addProductItem(vm.productItemForm, vm.productItem)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Product Item</button> <button type=\"button\" ng-if=\"vm.productItem.id\" ng-click=\"vm.updateProductItem(vm.productItemForm, vm.productItem)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Product Item</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div><div ba-panel=\"\" ng-if=\"!vm.showForm\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allProductItems.length!==0\"><th>Product</th><th>Origin</th><th>Keyword</th><th>Import Expense</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allProductItems.length===0\"><th>No from have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.allProductItems | orderBy:\'productName\' | selectedRows:vm.productItemToRemove:\'id\'\"><td class=\"titled\" ng-bind=\"row.productName\"></td><td><img width=\"18\" src=\"{{vm.appConstants.HOST + row.productOriginFlag}}\">&nbsp; {{row.productOriginName}}</td><td ng-if=\"row.keywordsString\" ng-bind=\"row.keywordsString\"></td><td ng-if=\"!row.keywordsString\">No Keyword attached</td><td ng-bind=\"row.importExpense\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editProductItem(row)\">Edit</button> <button style=\"width: 115px;\" ng-class=\"{\'btn-danger\': !row.priceOnWebsite, \'btn-success\':row.priceOnWebsite}\" class=\"btn editable-table-button btn-xs\" ng-click=\"vm.displayPriceOnWebsite(row)\">Price On Website</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/products/productKeyword.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addNewKeyword()\">Add New Product Keyword</button></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-if=\"vm.showForm\"><div class=\"panel-content\"><form name=\"vm.productKeywordForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Keyword Name</label> <input type=\"text\" ng-model=\"vm.keywordObj.name\" ng-required=\"true\" name=\"keywordName\" class=\"form-control\" id=\"keywordName\" placeholder=\"Keyword Name\"><ng-messages for=\"vm.productKeywordForm.productName.$error\" ng-if=\"(vm.productKeywordForm.$submitted && vm.productKeywordForm.keywordName.$invalid) || (vm.productKeywordForm.keywordName.$invalid && vm.productKeywordForm.keywordName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a keyword name</div></ng-messages><span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Product Category</label><selectize id=\"category\" ng-required=\"true\" name=\"category\" placeholder=\"Keyword Product Category\" config=\"vm.categoryConfig\" options=\"vm.categoryOptions.list\" ng-model=\"vm.keywordObj.categoryId\"></selectize><ng-messages for=\"vm.productKeywordForm.productOrigin.$error\" ng-if=\"(vm.productKeywordForm.$submitted && vm.productKeywordForm.category.$invalid) || (vm.productKeywordForm.category.$invalid && vm.productKeywordForm.category.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select category</div></ng-messages></div></div><button type=\"submit\" ng-if=\"!vm.keywordObj.id\" ng-click=\"vm.addKeyword(vm.productKeywordForm, vm.keywordObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Product Item</button> <button type=\"submit\" ng-if=\"vm.keywordObj.id\" ng-click=\"vm.updateKeyword(vm.productKeywordForm, vm.keywordObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Product Item</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allKeywords.length!==0\"><th>Keywords</th><th>Category</th><th>No. of Product Items</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allKeywords.length===0\"><th>No keywords have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.allKeywords\"><td class=\"titled\" ng-bind=\"row.name\"></td><td ng-if=\"row.categoryName\" ng-bind=\"row.categoryName\"></td><td ng-if=\"!row.categoryName\">No category assigned</td><td ng-bind=\"row.noOfProductItems\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editKeyword(row)\">Edit</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/products/productSpecification.html","<div ba-panel=\"\" ba-panel-title=\"{{vm.categoryName}} Specification\" ba-panel-class=\"profile-page\" class=\"row\"><div><div class=\"panel-content\"><form name=\"vm.productSpecificationForm\" novalidate=\"\"><h3 class=\"with-line\">Add Specification Item <i ng-click=\"vm.addSpecificationItem(vm.marketPriceObj)\" class=\"fa fa-plus primary-font cursor-pointer\"></i></h3><div ng-repeat=\"spec in vm.specificationData.specs\" class=\"notification row clearfix margin-top-10px\"><div class=\"col-sm-4 col-xs-12\"><div class=\"form-group row clearfix\"><label class=\"col-xs-12 col-sm-4\" for=\"specName_{{$index}}\">Specification Name</label><div class=\"col-xs-12 col-sm-8\"><input class=\"form-control\" name=\"{{\'specName_\'+$index}}\" ng-required=\"true\" id=\"specName_{{$index}}\" ng-model=\"spec.name\"><ng-messages for=\"vm.productSpecificationForm[\'specName_\'+$index].$error\" ng-if=\'(vm.productSpecificationForm.$submitted && vm.productSpecificationForm[\"specName_\"+$index].$invalid) || (vm.productSpecificationForm[\"specName_\"+$index].$invalid && vm.productSpecificationForm[\"specName_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter specification name.</div></ng-messages></div></div></div><div class=\"col-sm-6 col-xs-12\"><div class=\"form-group row clearfix\"><label class=\"col-xs-12 col-sm-3\">Specification Type</label><div class=\"col-xs-12 col-sm-9\"><div class=\"input-demo radio-demo row\"><div class=\"col-md-2 col-xs-12\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"spec.type\" name=\"{{\'specType_\'+$index}}\" required=\"\" value=\"percentage\"> <span>Percentage</span></label></div><div class=\"col-md-2 col-xs-12\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" ng-model=\"spec.type\" name=\"{{\'specType_\'+$index}}\" required=\"\" value=\"text\"> <span>Text</span></label></div><div class=\"col-sm-12\"><ng-messages for=\"vm.productSpecificationForm[\'specType_\'+$index].$error\" ng-if=\'(vm.productSpecificationForm.$submitted && vm.productSpecificationForm[\"specType_\"+$index].$invalid) || (vm.productSpecificationForm[\"specType_\"+$index].$invalid && vm.productSpecificationForm[\"specType_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter specification type.</div></ng-messages></div></div></div></div></div><div class=\"col-sm-2\"><i ng-click=\"vm.removeSpecItem(vm.specificationData.specs, spec)\" class=\"fa fa-trash primary-font cursor-pointer\" style=\"padding-top: 10px;\"></i></div></div><div class=\"row\"><button type=\"submit\" ng-click=\"vm.saveSpecs(vm.productSpecificationForm, vm.specificationData)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Save Product Category Specification</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div></div>");
$templateCache.put("app/dashboard/products/products.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" ng-click=\"vm.addNewProduct()\">Add New Product</button></div><div class=\"col-md-12\"><div ng-if=\"vm.showForm\" class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"with-scroll\"><ba-wizard on-cancel=\"vm.cancel()\"><ba-wizard-step title=\"Product Info\" form=\"vm.productInfoForm\" on-next=\"vm.saveProduct(vm.productObj, vm.imagesData)\" on-next-callback=\"vm.onSaveProductCallback(response)\" submit-button-title=\"{{vm.stepTitle[0]}}\"><form name=\"vm.productInfoForm\" novalidate=\"\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"product-pic col-xs-6 col-xs-offset-3\"><div class=\"product-pic-wrapper\"><img ng-src=\"{{ vm.productImage }}\" ng-click=\"vm.uploadProductImage(event)\"></div><i class=\"ion-ios-close-outline\" ng-click=\"vm.removeProductPicture()\" ng-if=\"!vm.noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"vm.uploadProductImage(event)\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadProductFile\" ng-file-select=\"vm.onFileSelect($files)\"></div></div></div><div class=\"col-md-12 distance-10px\"></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"productName\">Product Name</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"productName\" name=\"productName\" placeholder=\"Product Name\" ng-model=\"vm.productObj.info.name\" required=\"\"><ng-messages for=\"vm.productInfoForm.productName.$error\" ng-if=\"(vm.productInfoForm.$submitted && vm.productInfoForm.productName.$invalid) || (vm.productInfoForm.productName.$invalid && vm.productInfoForm.productName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter product name.</div></ng-messages><span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"productName\">Product Code</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"productCode\" name=\"productCode\" placeholder=\"Product Code\" ng-model=\"vm.productObj.info.productCode\" required=\"\"><ng-messages for=\"vm.productInfoForm.productName.$error\" ng-if=\"(vm.productInfoForm.$submitted && vm.productInfoForm.productCode.$invalid) || (vm.productInfoForm.productCode.$invalid && vm.productInfoForm.productCode.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter product name.</div></ng-messages></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"productName\">Product Category</label><selectize ng-required=\"true\" name=\"productCategory\" config=\"vm.categoryConfig\" options=\"vm.categoryOptions.list\" ng-model=\"vm.productObj.info.categoryId\"></selectize><ng-messages for=\"vm.productInfoForm.productCategory.$error\" ng-if=\"(vm.productInfoForm.$submitted && vm.productInfoForm.productCategory.$invalid) || (vm.productInfoForm.productCategory.$invalid && vm.productInfoForm.productCategory.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter select a product category.</div></ng-messages><span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label>Related Products</label><tags-input ng-model=\"vm.productObj.info.relatedProduct\" display-property=\"name\" template=\"tag-template\" add-on-paste=\"false\"><auto-complete source=\"vm.loadRelatedProducts($query, vm.productObj.info.id)\" template=\"autocomplete-template\"></auto-complete></tags-input></div></div><script type=\"text/ng-template\" id=\"tag-template\"><div class=\"tag-template\"> <div class=\"right-panel\"> <span>{{$getDisplayText()}} - {{data.category}}</span> <a class=\"remove-button\" ng-click=\"$removeTag()\">&#10006;</a> </div> </div></script><script type=\"text/ng-template\" id=\"autocomplete-template\"><div class=\"autocomplete-template\"> <div class=\"right-panel\"> <span>{{$getDisplayText()}} - {{data.category}}</span> <a class=\"remove-button\" ng-click=\"$removeTag()\">&#10006;</a> </div> </div></script><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"productDescription\">Product Description</label><text-angular ng-model=\"vm.productObj.info.description\" id=\"productDescription\"></text-angular></div></div></div></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Product Origin\" form=\"vm.productOriginForm\" on-next=\"vm.saveProductOrigin(vm.productObj)\" on-next-callback=\"vm.onSaveProductOriginCallback(response)\" submit-button-title=\"{{vm.stepTitle[1]}}\"><form name=\"vm.productOriginForm\"><div class=\"product-wizard\"><div class=\"row\" style=\"min-height: 300px;\"><div class=\"col-lg-12\"><div class=\"form-group\"><label>Origins</label><selectize ng-required=\"true\" name=\"productOrigins\" config=\"vm.countryConfig\" options=\"vm.countryOptions.list\" ng-model=\"vm.productObj.origins\"></selectize><ng-messages for=\"vm.productOriginForm.productOrigins.$error\" ng-if=\"(vm.productOriginForm.$submitted && vm.productOriginForm.productOrigins.$invalid) || (vm.productOriginForm.productOrigins.$invalid && vm.productOriginForm.productOrigins.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter atleast one product origin.</div></ng-messages></div></div></div></div></form></ba-wizard-step></ba-wizard></div></div></div></div><div ba-panel=\"\" ba-panel-class=\"with-scroll\" ng-if=\"!vm.showForm\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.allProducts.length!==0\"><th>Product Name</th><th>Product Catrgory</th><th colspan=\"2\">Product Items</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.allProducts.length===0\"><th>No values have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.allProducts | orderBy:\'info.name\'\"><td class=\"titled\" ng-bind=\"row.info.name\"></td><td ng-bind=\"row.info.categoryName\"></td><td colspan=\"2\" ng-if=\"row.productItems.length > 0\"><div class=\"productItemsColumn\" ng-repeat=\"item in row.productItems\"><div class=\"origin\"><img width=\"18\" src=\"{{vm.appConstants.HOST + item.originFlag}}\"> {{item.origin}}</div><div class=\"keywords\" ng-bind=\"item.keywords\"></div></div></td><td colspan=\"2\" ng-if=\"row.productItems.length === 0\"><div class=\"productItemsColumn\"><div class=\"keywords\">No product items</div></div></td><td><div class=\"buttons\"><button class=\"btn btn-success editable-table-button btn-xs\" ng-click=\"vm.productReport($index)\">Report</button> <button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editProduct(row)\">Edit</button> <button class=\"btn editable-table-button btn-xs\" ng-class=\"{\'btn-danger\': !row.info.onWebsite, \'btn-success\': row.info.onWebsite}\" ng-click=\"vm.displayOnWebsite(row)\">Website</button> <button ng-if=\"row.isDeletable\" class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"vm.deleteProduct(vm.allProducts, row)\">Delete</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/settings/settings.html","<uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"Change Password\"><div ng-include=\"\'app/dashboard/settings/templates/changePassword.html\'\"></div></uib-tab><uib-tab heading=\"Application Drop Downs\"><div ng-include=\"\'app/dashboard/settings/templates/appDropDown.html\'\"></div></uib-tab><uib-tab heading=\"Business Details\" ng-click=\"vm.getBusinessSettings()\"><div ng-include=\"\'app/dashboard/settings/templates/businessDetails.html\'\"></div></uib-tab></uib-tabset>");
$templateCache.put("app/dashboard/shell/shell.html","<div class=\"body-bg\"></div><main ng-if=\"$pageFinishedLoading\" ng-class=\"{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }\"><ba-sidebar ng-mouseover=\"vm.invertSideBar(false)\"></ba-sidebar><page-top></page-top><div class=\"al-main\"><div class=\"al-content\"><page-header go-back=\"true\"></page-header><div ui-view=\"content\" ng-mouseover=\"vm.invertSideBar(true)\"></div></div></div><back-top></back-top></main><div id=\"preloader\" ng-show=\"!$pageFinishedLoading\"><div></div></div>");
$templateCache.put("app/dashboard/shipping/portForm.html","<div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"vm.portForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Country</label><selectize placeholder=\"Country\" name=\"country\" ng-required=\"true\" config=\"vm.countryConfig\" options=\"vm.countryOptions.list\" ng-model=\"vm.portObj.countryCode\"></selectize><ng-messages for=\"vm.portForm.country.$error\" ng-if=\"(vm.portForm.$submitted || vm.portForm.country.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select a country</div></ng-messages></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label>Lo Code</label> <input type=\"text\" ng-model=\"vm.portObj.loCode\" ng-required=\"true\" name=\"loCode\" class=\"form-control\" id=\"loCode\" placeholder=\"Lo Code\"><ng-messages for=\"vm.portForm.loCode.$error\" ng-if=\"(vm.portForm.$submitted || vm.portForm.loCode.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter Port LO Code</div></ng-messages></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Name</label> <input type=\"text\" ng-model=\"vm.portObj.name\" ng-required=\"true\" name=\"name\" class=\"form-control\" id=\"name\" placeholder=\"Name\"><ng-messages for=\"vm.portForm.name.$error\" ng-if=\"(vm.portForm.$submitted || vm.portForm.name.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter port Name</div></ng-messages></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Contact No.</label> <input type=\"text\" ng-model=\"vm.portObj.contactNo\" name=\"contactNo\" class=\"form-control\" id=\"contactNo\" placeholder=\"Contact No\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label>Website</label> <input type=\"text\" ng-model=\"vm.portObj.website\" name=\"loCode\" class=\"form-control\" id=\"website\" placeholder=\"Website\"></div></div><div class=\"row\"><button type=\"submit\" ng-if=\"!vm.portObj.id\" ng-click=\"vm.addPort(vm.portForm, vm.portObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Shipment Port</button> <button type=\"submit\" ng-if=\"vm.portObj.id\" ng-click=\"vm.updatePort(vm.portForm, vm.portObj)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Shipment Port</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></form></div></div></div>");
$templateCache.put("app/dashboard/shipping/ports.html","<filter-bar country=\"true\" on-country-selected-changed=\"vm.onCountrySelectedChanged(selectedList)\"></filter-bar><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"All Ports\" ba-panel-class=\"with-scroll\"><table class=\"table\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.portsList.length!==0\"><th><span class=\"count\">{{vm.portsList.length}}</span></th><th ng-repeat=\"name in vm.heading\" ng-bind=\"name\"></th></tr><tr class=\"table-header\" ng-if=\"vm.portsList.length===0\"><th>No ports have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in vm.portsList | selectedRows:vm.portsToRemove:\'id\' | orderBy: \'loCode\'\"><td></td><td ng-bind=\"row.loCode\"></td><td ng-bind=\"row.name\"></td><td ng-bind=\"row.country\"></td><td ng-bind=\"row.contactNo === \'n/a\' ? \'N/A\' : row.contactNo\"></td><td ng-if=\"row.website!==\'n/a\'\"><a class=\"titled\" target=\"_blank\" href=\"{{row.website}}\">{{row.website}}</a></td><td ng-if=\"row.website===\'n/a\'\">N/A</td><td ng-bind=\"row.addedBy\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.goToShipmentPortForm(\'dashboard.shipping.ports.form\', row.id)\">Edit</button> <button class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"vm.deletePort(row, vm.portsList)\">Delete</button></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/dashboard/shipping/shipping.html","<div ba-panel=\"\"><div>Shipping</div></div>");
$templateCache.put("app/dashboard/shipping/shippingLine.html","<div ba-panel=\"\" ba-panel-title=\"All Shipping Line ({{vm.shippingLineList.length}})\"><div><shipping-line-card ng-repeat=\"line in vm.shippingLineList | orderBy:\'codeName\'\" col-size=\"4\" delete=\"vm.deleteCallback(id)\" shipping-line=\"line\"></shipping-line-card></div></div>");
$templateCache.put("app/dashboard/shipping/shippingLineForm.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"vm.shippingLineForm\" novalidate=\"\"><h3 class=\"with-line\">Shipping Line Information</h3><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group row clearfix\"><div class=\"col-sm-12\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ vm.shippingLineLogo }}\" ng-click=\"vm.uploadPicture(event)\"></div><i class=\"ion-ios-close-outline\" ng-click=\"vm.removeLogo()\" ng-if=\"!vm.noLogo\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"vm.uploadLogo(event)\">Change Shipping Line Logo</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"vm.onFileSelect($files)\"></div></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"lineCode\">Shipping Line Code</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"lineCode\" name=\"lineCode\" placeholder=\"Shipping Line Code\" ng-model=\"vm.shippingObj.codeName\" required=\"\"><ng-messages for=\"vm.shippingLineForm.lineCode.$error\" ng-if=\"(vm.shippingLineForm.$submitted || vm.shippingLineForm.lineCode.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter line code name.</div></ng-messages></div><div class=\"form-group\"><label for=\"lineCode\">Shipping Line Name</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"lineName\" name=\"lineName\" placeholder=\"Shipping Line Name\" ng-model=\"vm.shippingObj.name\" required=\"\"><ng-messages for=\"vm.shippingLineForm.lineName.$error\" ng-if=\"(vm.shippingLineForm.$submitted || vm.shippingLineForm.lineName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter line name.</div></ng-messages></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"lineCode\">Shipping Line Website</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"lineWebsite\" name=\"lineWebsite\" placeholder=\"Shipping Line Website\" ng-model=\"vm.shippingObj.website\"></div><div class=\"form-group\"><label for=\"lineCode\">Shipping Line Tracking URL</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"lineTrackingWebsite\" name=\"lineTrackingWebsite\" placeholder=\"Shipping Line Tracking URL\" ng-model=\"vm.shippingObj.trackingWebsite\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-success\" type=\"submit\" ng-if=\"!vm.shippingObj.id\" ng-click=\"vm.saveShippingLine(vm.shippingLineForm, vm.shippingObj, vm.imagesData, true)\">Add New Shipping Line And Add Another</button> <button class=\"btn btn-primary\" type=\"submit\" ng-click=\"vm.saveShippingLine(vm.shippingLineForm, vm.shippingObj, vm.imagesData, false)\">{{(!vm.shippingObj.id ? \'Add New Shipping Line\' : \'Update Shipping Line\')}}</button> <button class=\"btn btn-danger\" ng-click=\"vm.cancel()\">Cancel</button></div></div></form></div></div>");
$templateCache.put("app/dashboard/shipping/vessel.html","<div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"All Vessels ({{vm.vesselList.length}})\"><div class=\"searchFormContainer\"><form name=\"vm.vesselSearch\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><h3 class=\"with-line\" for=\"vesselName\">Search Type</h3><selectize name=\"searchType\" config=\"vm.searchTypeConfig\" options=\"vm.searchOptions\" ng-model=\"vm.searchObj.queryType\"></selectize></div></div><div class=\"col-md-6\"><div class=\"form-group\"><h3 class=\"with-line\" for=\"vesselName\">Search Query</h3><input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"vesselName\" name=\"vesselName\" placeholder=\"Vessel Query\" ng-model=\"vm.searchObj.query\" required=\"\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary\" ng-click=\"vm.getVesselList(vm.searchObj)\">Search Vessel</button> <button class=\"btn btn-danger\">Clear</button></div></div></form></div></div><div class=\"col-md-12\" ng-if=\"vm.vesselList.length>0\"><div ba-panel=\"\" ba-panel-title=\"All Vessels\"><vessel-card ng-repeat=\"vessel in vm.vesselList\" col-size=\"4\" vessel=\"vessel\"></vessel-card></div></div>");
$templateCache.put("app/dashboard/shipping/vesselForm.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"vm.vesselForm\" novalidate=\"\"><h3 class=\"with-line\">Vessel Basic Information</h3><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"imoNumber\">Vessel IMO Number</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"imoNumber\" name=\"imoNumber\" placeholder=\"IMO Number\" ng-model=\"vm.vesselObj.imoNumber\" required=\"\"><ng-messages for=\"vm.vesselForm.imoNumber.$error\" ng-if=\"(vm.vesselForm.$submitted || vm.vesselForm.imoNumber.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter IMO Number.</div></ng-messages></div><div class=\"form-group\"><label for=\"mmsi\">MMSI Number</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"mmsi\" name=\"mmsi\" placeholder=\"MMSI Number\" ng-model=\"vm.vesselObj.mmsi\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"vesselName\">Vessel Name</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"vesselName\" name=\"vesselName\" placeholder=\"Vessel Name\" ng-model=\"vm.vesselObj.name\" required=\"\"><ng-messages for=\"vm.vesselForm.vesselName.$error\" ng-if=\"(vm.vesselForm.$submitted || vm.vesselForm.vesselName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter vessel name.</div></ng-messages></div><div class=\"form-group\"><label>Vessel Operator</label><selectize required=\"true\" name=\"operator\" placeholder=\"Select Shipping Line\" config=\"vm.shippingLineConfig\" options=\"vm.shippingLineOptions.list\" ng-model=\"vm.vesselObj.shippingLineId\"></selectize><ng-messages for=\"vm.vesselForm.operator.$error\" ng-if=\"(vm.vesselForm.$submitted || vm.vesselForm.operator.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter vessel operator shipping line.</div></ng-messages></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button class=\"btn btn-primary\" type=\"submit\" ng-click=\"vm.saveShippingVessel(vm.vesselForm, vm.vesselObj)\">{{(vm.vesselObj.id ? \'Update Vessel Information\' : \'Add New Shipping Vessel\')}}</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.cancel()\">Cancel</button></div></div></form></div></div>");
$templateCache.put("app/dashboard/tradeBook/tradeBook.html","<filter-bar date-picker-needed=\"true\" page=\"tradeBook\" buyer=\"true\" seller=\"true\" product-items=\"true\" tran-status=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange, false)\" on-buyers-selected-changed=\"vm.onBuyersSelectedChanged(selectedList, initialized)\" on-sellers-selected-changed=\"vm.onSellersSelectedChanged(selectedList, initialized)\" on-product-item-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\" on-tran-status-selected-changed=\"vm.onTranStatusSelectedChanged(selectedList, initialized)\"></filter-bar><trade-table type=\"{{vm.pageType}}\" column-header=\"vm.columnHeader\" list-data=\"vm.allTransactionsList\" items-per-page=\"10\"></trade-table>");
$templateCache.put("app/dashboard/tradeBook/tradeList.html","<filter-bar page=\"tradeBook\" buyer=\"true\" seller=\"true\" product-items=\"true\" on-buyers-selected-changed=\"vm.onBuyersSelectedChanged(selectedList, initialized)\" on-sellers-selected-changed=\"vm.onSellersSelectedChanged(selectedList, initialized)\" on-product-item-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\"></filter-bar><trade-table type=\"{{vm.reportType}}\" column-header=\"vm.columnHeader\" list-data=\"vm.transactions\" items-per-page=\"10\"></trade-table>");
$templateCache.put("app/dashboard/user/allUsers.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addNewUser()\">Add New User</button></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"<small>Total {{vm.allUsers.length}} System Users</small>\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\"><th>Username</th><th>Full Name</th><th>Email</th><th>Designation</th><th>Last Login</th><th class=\"center-align\">Is Active</th><th class=\"center-align\">Read Only</th><th>Actions</th></tr></thead><tbody><tr ng-repeat=\"user in vm.allUsers\"><td><a class=\"email-link\">{{user.userName}}</a></td><td>{{user.firstName + \' \' + user.lastName}}</td><td>{{user.email}}</td><td>{{user.designation}}</td><td>{{user.lastLogin | date:vm.appFormats.Time}}</td><td class=\"center-align\"><i ng-if=\"user.active\" ng-click=\"vm.setUserActive(user)\" class=\"fa fa-unlock cursor-pointer\"></i> <i ng-if=\"!user.active\" ng-click=\"vm.setUserActive(user)\" class=\"fa fa-lock cursor-pointer\"></i></td><td class=\"center-align\"><span class=\"fa-stack fa-lg cursor-pointer\" ng-click=\"vm.setUserReadOnly(user)\"><i class=\"fa fa-pencil fa-stack-1x\"></i> <i ng-if=\"user.readOnly\" class=\"fa fa-ban fa-stack-2x fa-rotate-90 text-danger\"></i></span></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.editUser(user.id)\">Edit</button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/dashboard/website/blog.html","<div class=\"row\"><div class=\"col-md-6 marginBottom10px\" ng-if=\"!vm.showForm\"><button class=\"btn btn-primary\" ng-click=\"vm.addNewResearch()\">Add New Research</button></div><div class=\"col-md-12\" ba-panel=\"\" ng-show=\"!vm.showForm\"><div ng-repeat=\"research in vm.researchList\" ng-if=\"vm.researchList.length > 0\" class=\"col-xlg-4 col-lg-4 col-md-4 col-sm-12 col-xs-12\" ba-panel=\"\" ba-panel-class=\"popular-app medium-panel\"><blog-card visitors=\"research.visitors\" research-id=\"research.id\" can-edit=\"research.canEdit\" can-delete=\"research.canDelete\" display-web=\"research.displayOnWeb\" is-draft=\"research.isDraft\" on-edit=\"vm.editResearch(researchId)\" author=\"research.createdBy\" user-pic=\"research.createdByImage\" comments=\"research.comments\" reads=\"research.reads\" created-on=\"research.createdOn\" title=\"research.title\" on-display-web=\"vm.displayResearchOnWeb(researchId)\" on-delete=\"vm.deleteResearch(researchId)\" image-url=\"research.image\"></blog-card></div><div ng-if=\"vm.researchList.length == 0\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"table-header\"><th>No Research have been added.</th></tr></thead></table></div></div><div ba-panel=\"\" ba-panel-class=\"profile-page\" ng-show=\"vm.showForm\"><div class=\"panel-content\"><h3 class=\"with-line\">Research</h3><form name=\"vm.researchForm\" novalidate=\"\"><div class=\"product-wizard\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><div class=\"product-pic col-xs-6 col-xs-offset-3\"><div class=\"product-pic-wrapper\"><img ng-src=\"{{ vm.blogImage }}\" ng-click=\"vm.uploadResearchImage(event)\"></div><i class=\"ion-ios-close-outline\" ng-click=\"vm.removeResearchImage()\" ng-if=\"!vm.noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"vm.uploadResearchImage(event)\">Change Blog Image</a> <input type=\"file\" ng-show=\"false\" id=\"uploadResearchFile\" ng-file-select=\"vm.onFileSelect($files)\"></div></div></div><div class=\"col-md-12 distance-10px\"></div><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"researchTitle\">Research Title</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"researchTitle\" name=\"researchTitle\" placeholder=\"Title\" ng-model=\"vm.researchObj.title\" ng-maxlength=\"120\" required=\"\"><ng-messages for=\"vm.researchForm.researchTitle.$error\" ng-if=\"(vm.researchForm.$submitted && vm.researchForm.researchTitle.$invalid) || (vm.researchForm.researchTitle.$invalid && vm.researchForm.researchTitle.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter research title.</div><div ng-message=\"maxlength\" class=\"errorValidation\">Can only have 120 characters.</div></ng-messages></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"researchTitle\">Research Slug</label> <input autocomplete=\"false\" type=\"text\" class=\"form-control\" id=\"researchSlug\" name=\"researchSlug\" placeholder=\"URL Slug\" ng-model=\"vm.researchObj.slug\" required=\"\"><ng-messages for=\"vm.researchForm.researchSlug.$error\" ng-if=\"(vm.researchForm.$submitted && vm.researchForm.slug.$invalid) || (vm.researchForm.slug.$invalid && vm.researchForm.slug.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter research slug.</div></ng-messages></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"researchTitle\">Research Tags</label><tags-input ng-model=\"vm.researchObj.tags\" add-on-paste=\"true\"><auto-complete source=\"vm.loadTags($query)\"></auto-complete></tags-input></div></div><div class=\"col-md-12\"><h3 class=\"with-line\">Research</h3><div class=\"form-group\"><text-angular ng-model=\"vm.researchObj.content\" id=\"productDescription\"></text-angular></div></div><button type=\"button\" ng-click=\"vm.saveResearch(vm.researchForm, vm.researchObj, vm.imagesData, false)\" class=\"btn btn-success btn-with-icon save-profile\"><i class=\"ion-android-add-circle\"></i>Save & Publish</button> <button type=\"button\" ng-click=\"vm.saveResearch(vm.researchForm, vm.researchObj, vm.imagesData, true)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-add-circle\"></i>Save As Draft</button> <button type=\"button\" ng-click=\"vm.cancel(vm.researchForm)\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></div></div></form></div></div></div>");
$templateCache.put("app/dashboard/website/website.html","<div class=\"row\"><div class=\"col-md-6\"><button class=\"btn btn-primary\" ng-click=\"vm.goToWebsiteBlogs()\">Website Blogs</button></div></div><br><div class=\"row\" ba-panel=\"\" ba-panel-title=\"Last 30 Days Report\"><div class=\"row pie-charts\" ng-if=\"vm.dashboardData.googleAnalyticsConnected\"><div class=\"dash-cards col-xs-4\"><div ba-panel=\"\"><div class=\"card-item\"><div class=\"details row\"><div class=\"col-xs-4 item\"><div class=\"title\">Total Users</div><div class=\"number\" ng-bind=\"vm.cardsTotalData.visits\"></div></div><div class=\"col-xs-4 item\"><div class=\"title\">Page Views</div><div class=\"number\" ng-bind=\"vm.cardsTotalData.pageViews\"></div></div><div class=\"col-xs-4 item\"><div class=\"title\">Hits</div><div class=\"number\" ng-bind=\"vm.cardsTotalData.hits\"></div></div></div></div></div></div><div class=\"dash-cards col-xs-4\"><div ba-panel=\"\"><div class=\"card-item\"><div class=\"details col-xs-12\"><div class=\"col-xs-12 item\"><div class=\"title\">Bounce Rate</div><div class=\"number\" ng-bind=\"vm.cardsTotalData.bounceRate | percentage: 2\"></div></div></div></div></div></div><div class=\"dash-cards col-xs-4\"><div ba-panel=\"\"><div class=\"card-item\"><div class=\"details col-xs-12\"><div class=\"col-xs-6 item\"><div class=\"title\">Sessions</div><div class=\"number\" ng-bind=\"vm.cardsTotalData.sessions\"></div></div><div class=\"col-xs-6 item\"><div class=\"title\">Average Session Duration</div><div class=\"number\" ng-bind=\"vm.cardsTotalData.avgSessionDuration | secondsToDateTime | date:\'HH:mm:ss\'\"></div></div></div></div></div></div></div><div class=\"col-md-12\" ba-panel=\"\" ba-panel-class=\"medium-panel\"><button class=\"col-md-offset-3 col-md-6 btn btn-success\" ng-if=\"!vm.dashboardData.googleAnalyticsConnected\" ng-click=\"vm.connectGoogleAnalytics()\">Connect with Google Analytics to create website dashboard</button><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.dashboardData.googleAnalyticsConnected\" ba-panel=\"\" ba-panel-class=\"medium-panel\"><line-chart chart-data=\"vm.trafficChartData\" chart-values=\"vm.trafficChartValues\"></line-chart></div><div class=\"col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12\" ng-if=\"vm.dashboardData.googleAnalyticsConnected\" ba-panel=\"\" ba-panel-class=\"medium-panel\"><map-bubbles heading=\"Traffic By Country\" map-chart-data=\"vm.mapData\"></map-bubbles></div></div></div>");
$templateCache.put("app/landing/home/home.html","<section id=\"story-home\"><div class=\"story\" style=\"padding-top: 0px; !important\"><div class=\"wrapper\"><div class=\"tp-homeSlider2016\"><section class=\"newSlide intro clearfix\" id=\"tpSlide1\"><div class=\"homeSliderContent\"><h1>Enabling Business Transformation</h1><p>Development Acceleration<br>Modernization, Mobility, Experience<br>Speed-to-market</p></div><div class=\"homeSliderArtwork\"><img src=\"assets/img/landing/slider1.jpg\" alt=\"\"></div></section><div class=\"slider2016Nav\"><a id=\"slideNavLeft\"></a> <a id=\"slideNavRight\"></a></div><ul class=\"sliderPagination\"><li data-slide=\"1\" class=\"\"></li><li data-slide=\"2\" class=\"active\"></li></ul></div></div></div></section>");
$templateCache.put("app/landing/shell/header.html","<header id=\"mainHeader\" class=\"homeNavbar homeNavStickey\"><nav id=\"mainNavWrap\" class=\"navbar navbar-default navbar-fixed-top\"><div class=\"container\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#mainNav\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button> <a class=\"pull-left\" href=\"http://10pearls.com\"><img src=\"assets/img/favicon-32x32.png\" alt=\"10Pearls\" class=\"img-responsive\"></a></div><div class=\"collapse navbar-collapse\" id=\"mainNav\"><ul class=\"nav navbar-nav\"><div class=\"menu-new-white-menu-container\"><ul id=\"menu-new-white-menu\" class=\"nav-menu\"><li id=\"menu-item-2129\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-2129\"><a title=\"Company\" href=\"http://10pearls.com/company/\">Company</a></li><li id=\"menu-item-2286\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-2286 dropdown\"><a title=\"Works\" href=\"#\" data-toggle=\"dropdown\" class=\"dropdown-toggle\" aria-haspopup=\"true\">Works</a><ul role=\"menu\" class=\"dropdown-menu\"><li id=\"menu-item-2231\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2231\"><a title=\"Time Warner Cable\" href=\"http://10pearls.com/time-warner-cable/\">Time Warner Cable</a></li><li id=\"menu-item-2134\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2134\"><a title=\"MBO\" href=\"http://10pearls.com/mbo-partners/\">MBO</a></li><li id=\"menu-item-2138\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2138\"><a title=\"Social Radar\" href=\"http://10pearls.com/social-radar/\">Social Radar</a></li><li id=\"menu-item-2139\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2139\"><a title=\"Zubie\" href=\"http://10pearls.com/zubie/\">Zubie</a></li><li id=\"menu-item-2136\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2136\"><a title=\"Nextel Brazil\" href=\"http://10pearls.com/nextel-brazil/\">Nextel Brazil</a></li><li id=\"menu-item-2133\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2133\"><a title=\"Discovery\" href=\"http://10pearls.com/discovery-nfl/\">Discovery</a></li><li id=\"menu-item-2137\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2137\"><a title=\"Razorsight\" href=\"http://10pearls.com/razorsight/\">Razorsight</a></li><li id=\"menu-item-2135\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2135\"><a title=\"National Geographic\" href=\"http://10pearls.com/national-geographic/\">National Geographic</a></li><li id=\"menu-item-2132\" class=\"menu-item menu-item-type-post_type menu-item-object-post menu-item-2132\"><a title=\"Brightline\" href=\"http://10pearls.com/brightline/\">Brightline</a></li></ul></li><li id=\"menu-item-2142\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-2142\"><a title=\"What We Do\" href=\"http://10pearls.com/what-we-do/\">What We Do</a></li><li id=\"menu-item-2140\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-2140\"><a title=\"News\" href=\"http://10pearls.com/news/\">News</a></li><li id=\"menu-item-2144\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-2144\"><a title=\"Blog\" href=\"http://10pearls.com/our-blog/\">Blog</a></li><li id=\"menu-item-2143\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-2143\"><a title=\"Contact\" href=\"http://10pearls.com/get-in-touch/\">Contact</a></li><li id=\"menu-item-2141\" class=\"menu-item menu-item-type-post_type menu-item-object-page menu-item-2141\"><a title=\"Join Our Team\" href=\"http://10pearls.com/join-our-team/\">Join Our Team</a></li></ul></div></ul></div></div></nav></header>");
$templateCache.put("app/landing/shell/shell.html","<div ui-view=\"header\"></div><div ui-view=\"content\"></div>");
$templateCache.put("app/modals/modalTemplates/basicDropDown.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">{{title}}</h4></div><div class=\"modal-body\"><form class=\"row form-inline\" name=\"transactionStatus\"><div class=\"form-group col-sm-12 col-xs-12\"><input type=\"text\" class=\"form-control\" ng-model=\"name\" id=\"exampleInputName2\" placeholder=\"Drop Down Value\"></div></form></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveDropDown(endPoint, name, id)\">Save Drop Down Value</button></div></div>");
$templateCache.put("app/modals/modalTemplates/basicWrapper.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Modal title</h4></div><div class=\"modal-body\" ng-transclude=\"\"></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/modals/modalTemplates/imageCropper.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">Image Cropper</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"cropArea\"><ui-cropper image=\"image\" area-type=\"rectangle\" area-init-size=\"{w:cropper.cropWidth,h:cropper.cropHeight}\" result-image-quality=\"1.0\" aspect-ratio=\"aspectRatio\" result-blob=\"blob\" result-image=\"croppedImage\" result-array-image=\"croppedImages\" result-image-size=\"resultImageSizes\" area-min-size=\"{w:100, h:100}\" init-max-area=\"true\"></ui-cropper></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveImage()\">Done</button></div></div>");
$templateCache.put("app/modals/modalTemplates/loaderModal.html","<div id=\"preloader\"><div></div></div>");
$templateCache.put("app/modals/modalTemplates/localPayment.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">Local Payment</h4></div><div class=\"modal-body\"><div class=\"row\"><form name=\"localPaymentForm\" novalidate=\"\"><div class=\"form-group col-md-12 clearfix\"><label class=\"with-line control-label\">Payment Amount <span class=\"titled\">{{businessCurrency}}</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.localTransaction.quantity\" class=\"form-control\" name=\"quantity\" placeholder=\"Payment Amount\"><ng-messages for=\"vm.localTransactionForm.quantity.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.quantity.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter quantity value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Quantity can only have numbers.</ng-message></ng-messages></div></div></form></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"changeCompletion(completeObj)\">Complete Transaction</button></div></div>");
$templateCache.put("app/modals/modalTemplates/transactionCashFlow.html","<div class=\"modal-body\"><div ba-panel=\"\" ba-panel-title=\"Transaction Commission Cash Flow\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\"><th>Active</th><th>Business</th><th>Description</th><th>Profit</th><th>Loss</th></tr></thead><tbody><tr ng-repeat=\"flow in tradeCashFlowData.cashFlow\"><td><i class=\"fa\" ng-class=\"{\'fa-check\': flow.active, \'fa-times\': !flow.active}\" aria-hidden=\"true\"></i></td><td ng-bind=\"flow.business.name + \' | \' + (flow.business.country ? flow.business.country : \'No Origin\')\"></td><td ng-bind=\"flow.description\"></td><td ng-bind=\"(!flow.payable ? \'USD \' + (flow.amount | positive | number: \'2\' ) : \'\')\"></td><td ng-bind=\"(flow.payable ? \'USD \' + (flow.amount | positive | number: \'2\' ) : \'\')\"></td></tr></tbody><tbody><tr><td></td><td></td><td></td><td>Net Total</td><td ng-class=\"{\'negative\': (tradeSum<0), \'positive\': (tradeSum>0)}\">{{\'USD \' + (tradeSum | number:\'2\')}}</td></tr></tbody></table></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Close</button></div>");
$templateCache.put("app/modals/modalTemplates/transactionComplete.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\" ng-bing=\"title\">Transaction Completion</h4></div><div class=\"modal-body\"><div class=\"row\"><form name=\"completionForm\" novalidate=\"\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"completeObj.complete\"> <span>Complete</span></label></div></div></div><div class=\"col-md-12 col-xs-12\" ng-show=\"completeObj.complete\"><div class=\"form-group\"><label class=\"with-line\">Completion Date</label><date-picker-input date=\"completeObj.completionDate\" blank=\"false\" name=\"washoutDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout date.</ng-message></ng-messages></div></div></form></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"changeCompletion(completeObj)\">Complete Transaction</button></div></div>");
$templateCache.put("app/modals/notifications/notifications.html","<div class=\"modal-buttons same-width clearfix\" ng-controller=\"NotificationsCtrl\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"showSuccessMsg()\">Success Notification</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"showInfoMsg()\">Info Notification</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"showWarningMsg()\">Warning Notification</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"showErrorMsg()\">Danger Notification</button></div>");
$templateCache.put("app/widgets/blogCard/blogCard.html","<div class=\"popular-app-img-container\"><div class=\"popular-app-img\"><img height=\"360\" ng-src=\"{{imageUrl}}\"></div><div class=\"userPic\"><img ng-src=\"{{( userPic | profilePicture )}}\"><div class=\"name\" ng-bind=\"author\"></div></div></div><div class=\"buttons-bar\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-if=\"canEdit\" ng-click=\"edit(researchId)\">Edit</button> <button class=\"btn display-web editable-table-button btn-xs\" ng-if=\"canDelete\" ng-class=\"{\'btn-danger\': !displayWeb, \'btn-success\': displayWeb}\" ng-click=\"changeWebDisplay(researchId)\">Display On Website</button> <button class=\"btn btn-warning editable-table-button btn-xs\" ng-if=\"canDelete\" ng-click=\"delete(researchId)\">Delete</button></div><div class=\"status\" ng-class=\"{\'published\': !isDraft}\" ng-bind=\"(isDraft) ? \'Draft\' : \'Published\'\"></div><div class=\"popular-app-cost row\"><div class=\"col-xs-9\" ng-bind=\"title\"></div></div><div class=\"popular-app-info row\"><div class=\"col-xs-3 text-left\"><div class=\"info-label\">Created On</div><div class=\"info-text\">{{ createdOn | date:appFormats.Date}}</div></div><div class=\"col-xs-3 text-center\"><div class=\"info-label\">Read Time</div><div class=\"info-text\">{{reads | number : fractionSize}}</div></div><div class=\"col-xs-3 text-right\"><div class=\"info-label\">Comment</div><div class=\"info-text\">{{comments | number : fractionSize}}</div></div><div class=\"col-xs-3 text-right\"><div class=\"info-label\">Visitors</div><div class=\"info-text\">{{visitors | number : fractionSize}}</div></div></div>");
$templateCache.put("app/widgets/blurFeed/blurFeed.html","<div class=\"feed-messages-container\" track-width=\"smallContainerWidth\" min-width=\"360\"><div class=\"feed-message\" ng-repeat=\"message in feed\" ng-click=\"expandMessage(message)\"><div class=\"message-icon\" ng-if=\"message.type == \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"></div><div class=\"message-icon\" ng-if=\"message.type != \'text-message\'\"><img class=\"photo-icon\" ng-src=\"{{::( message.author | profilePicture )}}\"> <span class=\"sub-photo-icon\" ng-class=\"::message.type\"></span></div><div class=\"text-block text-message\"><div class=\"message-header\"><span class=\"author\">{{ ::message.author }} {{ ::message.surname}}</span></div><div class=\"message-content line-clamp\" ng-class=\"{\'line-clamp-2\' : !message.expanded}\"><span ng-if=\"message.preview\">{{message.header}}</span>{{::message.text}}</div><div class=\"preview\" ng-show=\"message.expanded\" ng-if=\"message.preview\"><a href=\"{{::message.link}}\" target=\"_blank\"><img ng-src=\"{{ ::( message.preview | appImage )}}\"></a></div><div ng-show=\"message.expanded\" class=\"message-time\"><div class=\"post-time\">{{::message.time}}</div><div class=\"ago-time\">{{::message.ago}}</div></div></div></div></div>");
$templateCache.put("app/widgets/businessCard/businessCard.html","<div class=\"col-xs-12 col-md-{{colSize}} business-card\"><div class=\"content\"><div class=\"detail-heading\" ng-bind=\"businessType\"></div><div ng-if=\"!business\"><div class=\"notApplicable\">NA</div></div><div ng-if=\"business\"><div class=\"col-xs-8\"><div class=\"logo\"><img width=\"60\" height=\"60\" ng-src=\"{{businessLogo}}\"></div><div class=\"details\"><div class=\"name\">{{business.name}}</div><div class=\"country\"><div class=\"flag\"><img width=\"20\" src=\"{{appConstants.STATIC_URL + \'/\' +business.countryFlag}}\"></div><div class=\"name\">{{business.country}}</div></div></div></div><div class=\"col-xs-4\"><div class=\"website\"><div class=\"label\">Website</div><div class=\"url\" ng-if=\"business.website\"><a href=\"{{business.website}}\" target=\"_blank\">{{business.website}}</a></div><div class=\"url\" ng-if=\"!business.website\">NA</div></div><div class=\"primary-contact\"><div class=\"label\">Primary Contact</div><div class=\"contact\">{{(business.primaryContact) ? business.primaryContact : \'NA\'}}</div></div></div></div></div></div>");
$templateCache.put("app/widgets/commissionCard/commissionCard.html","<div class=\"commissionCard\"><div class=\"detail-heading\">Commission Details</div><div class=\"content\"><div class=\"col-xs-12 col-md-6 quantity\"><div class=\"heading-2\">Quanity</div><div class=\"value\">{{commission.quantity | number : 2}} <span class=\"quantityMetric\">MT</span></div></div><div class=\"col-xs-12 col-md-6 price\"><div class=\"heading-2\">Price</div><div class=\"value\"><span class=\"currency\">USD</span> {{commission.price | number : 2}}</div></div><div class=\"col-md-6 col-xs-12 detail\"><div class=\"heading-2\">Commission Type</div><div class=\"value\" ng-bind=\"commission.commissionType\"></div></div><div class=\"col-md-6 col-xs-12 detail\"><div class=\"heading-2\">Commission</div><div class=\"value\" ng-bind=\"commission.commission | number : 2\"></div></div><div class=\"col-md-6 col-xs-12 detail\"><div class=\"heading-2\">Buyer Broker Commission Type</div><div class=\"value\" ng-bind=\"commission.buyerBrokerCommissionType ? commission.buyerBrokerCommissionType : \'NA\'\"></div></div><div class=\"col-md-6 col-xs-12 detail\"><div class=\"heading-2\">Buyer Broker Commission</div><div class=\"value\" ng-bind=\"commission.buyerBrokerCommission ? commission.buyerBrokerCommission : \'NA\'\"></div></div><div class=\"col-md-offset-6 col-md-6 col-xs-12 detail\"><div class=\"heading-2\">Discount</div><div class=\"value\" ng-bind=\"commission.discount | number : 2\"></div></div><div class=\"col-md-offset-6 col-md-6 col-xs-12 detail\"><div class=\"heading-2\">Difference</div><div class=\"value\" ng-bind=\"commission.difference | number : 2\"></div></div><div class=\"col-md-offset-6 col-md-6 col-xs-12 expectedCommission detail\"><div class=\"heading-2\">Expected Commission</div><div class=\"value\"><span class=\"currency\">USD</span> {{commission.expectedCommission | number : 2}}</div></div></div></div>");
$templateCache.put("app/widgets/customFilter/customFilter.template.html","<div class=\"col-sm-3\" click-off=\"closeFilter();\"><div class=\"dg-filterDropdown\"><div class=\"dg-filterDropdownField\" ng-click=\"invertShowOptions();\"><i class=\"fa fa-filter\">&nbsp;&nbsp;</i>{{title}} <span class=\"caret\"></span> <span ng-show=\"!isLoading\" class=\"pull-right filter-count\" ng-bind=\"selectedValues.length\"></span> <span ng-show=\"isLoading\" class=\"pull-right filter-count\"><i class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></span></div><div class=\"dg-filterDropdownMenu\" id=\"main-menu{{title}}\" ng-show=\"showOptions\"><ul class=\"dg-head\"><li ng-show=\"dropDownValues.length !== 0\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-click=\"onSelectAll(selectAll)\" ng-model=\"selectAll\"> <span class=\"dg-value\"><input ng-model=\"textFilter\" type=\"text\" class=\"form-control\"></span></li><li ng-show=\"dropDownValues.length === 0\"><span class=\"dg-value\">No values has been entered in to the system</span></li></ul><ul style=\"overflow-y: scroll;\"><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"endPoint===apiEndPoints.dropDown.product\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'id\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value filterHeading titled-text\">{{value.name}}</span> <span class=\"dg-value\">{{value.category}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"endPoint===apiEndPoints.dropDown.productItem\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'id\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value filterHeading titled-text\">{{value.name}}</span> <span class=\"dg-value\">{{value.origin}} | {{value.keywords ? value.keywords : \'No keywords\'}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'origin\'\" ng-if=\"endPoint===apiEndPoints.dropDown.priceMarket\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'id\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value filterHeading\">{{value.origin}}</span> <span class=\"dg-value\">{{value.currency}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"endPoint===apiEndPoints.dropDown.country\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'name\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value filterHeading\"><img width=\"18\" src=\"{{appConstants.STATIC_URL + value.image}}\">&nbsp;{{value.name}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"endPoint===apiEndPoints.dropDown.warehouses\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'name\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value filterHeading\">{{value.name}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"(endPoint===apiEndPoints.dropDown.transactionStatus)\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'name\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value singleFilterHeading titled-text\">{{value.name}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"(endPoint===apiEndPoints.dropDown.bpType)\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'name\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value singleFilterHeading titled-text\">{{value.name}}</span></li><li ng-repeat=\"value in dropDownValues | selectFilterDropDown: textFilter:\'name\'\" ng-if=\"(endPoint === apiEndPoints.dropDown.business)\"><input ng-change=\"onSingleSelectChange(value,value.selected,\'id\')\" type=\"checkbox\" ng-model=\"value.selected\"> <span class=\"dg-value filterHeading titled-text\">{{value.name}}</span> <span class=\"dg-value\">{{value.country ? value.country : \'No Origin\'}} | {{value.contactPerson ? value.contactPerson : \'No Primary Contact\' }}</span></li></ul></div></div></div>");
$templateCache.put("app/widgets/dashboardCalendar/dashboardCalendar.html","<div id=\"calendar\" class=\"blurCalendar\"></div>");
$templateCache.put("app/widgets/dashboardMap/dashboardMap.html","<div id=\"amChartMap\"></div>");
$templateCache.put("app/widgets/dashboardPieChart/dashboardPieChart.html","<div class=\"row pie-charts\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::chart.color }}\" data-percent=\"60\"><span class=\"percent\"></span></div><div class=\"description\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ ::chart.stats }}</div></div><i class=\"chart-icon i-{{ ::chart.icon }}\"></i></div></div></div></div>");
$templateCache.put("app/widgets/dashboardTodo/dashboardTodo.html","<div class=\"task-todo-container\" ng-class=\"{\'transparent\': transparent}\"><input type=\"text\" value=\"\" class=\"form-control task-todo\" placeholder=\"Task to do..\" ng-keyup=\"addToDoItem($event)\" ng-model=\"newTodoText\"> <i ng-click=\"addToDoItem(\'\',true)\" class=\"add-item-icon ion-plus-round\"></i><div class=\"box-shadow-border\"></div><ul class=\"todo-list\" ui-sortable=\"\" ng-model=\"todoList\"><li ng-repeat=\"item in todoList\" ng-if=\"!item.deleted\" ng-init=\"activeItem=false\" ng-class=\"{checked: isChecked, active: activeItem}\" ng-mouseenter=\"activeItem=true\" ng-mouseleave=\"activeItem=false\"><div class=\"blur-container\"><div class=\"blur-box\"></div></div><i class=\"mark\" style=\"background-color: {{::item.color}}\"></i> <label class=\"todo-checkbox custom-checkbox custom-input-success\"><input type=\"checkbox\" ng-model=\"isChecked\"> <span class=\"cut-with-dots\">{{ item.text }}</span></label> <i class=\"remove-todo ion-ios-close-empty\" ng-click=\"item.deleted = true\"></i></li></ul></div>");
$templateCache.put("app/widgets/datePickerInput/datePickerInput.html","<div class=\"datePickerInput\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{dateFormat}}\" name=\"{{name}}\" ng-model=\"date\" is-open=\"isOpen\" ng-model-options=\"{timezone: \'utc\'}\" datepicker-options=\"dateOptions\" ng-required=\"{{required}}\" close-text=\"Close\" popup-placement=\"{{position}}\" alt-input-formats=\"altInputFormats\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div>");
$templateCache.put("app/widgets/deAccordian/deAccordian.html","<div><uib-tabset class=\"de-tabs\"><uib-tab index=\"$index + 1\" ng-repeat=\"tab in tabs\" active=\"tab.active\"><uib-tab-heading uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" style=\"cursor:pointer\" ng-click=\"tabClicked($event, tab, null , $index)\">{{tab.title}} <i ng-if=\"tab.hasAccordianDropDown\" class=\"caret\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\" ng-if=\"tab.hasAccordianDropDown\"><li ng-repeat=\"subtab in tab.children\"><a ng-click=\"tabClicked($event, subtab, tab, $index)\">{{subtab.title}}</a></li></ul></uib-tab-heading><div ui-view=\"content\"></div></uib-tab></uib-tabset></div>");
$templateCache.put("app/widgets/docCard/docCard.html","<div class=\"col-xs-12 col-md-4 docCard\"><div class=\"docCardContainer\"><div class=\"details\"><div class=\"fileIcon\"><i class=\"fa fa-file\" aria-hidden=\"true\"></i></div><div class=\"filename\" ng-bind=\"docInfo.fileName\"></div><div class=\"uploadedBy\" ng-bind=\"docInfo.uploadedBy\"></div><div class=\"uploadedAt\" ng-bind=\"docInfo.uploadedAt | date\"></div></div><div class=\"buttons\"><button class=\"btn btn-success btn-xs\">Open</button> <button class=\"btn btn-primary btn-xs\">Download</button> <button class=\"btn btn-warning btn-xs\">Delete</button></div></div></div>");
$templateCache.put("app/widgets/filterBar/filterBar.template.html","<div ba-panel=\"\" class=\"dg-filterPanel\" ng-if=\"buyer || seller || product || productItems ||bpTypes || country || priceMarket || datePickerNeeded\"><div class=\"row\"><div ng-if=\"datePickerNeeded\" class=\"col-sm-6 col-sm-offset-6\"><div class=\"dg-datePicker\"><input type=\"daterange\" opens=\"left\" ng-change=\"datePickerChanged(datePicker)\" format=\"{{appFormats.FullDate}}\" ranges=\"ranges\" max-date=\"maxDate\" readonly=\"true\" separator=\"{{seperator}}\" class=\"form-control date-picker dg-filterDropdown\" ng-model=\"datePicker\"></div></div><custom-filter on-selected-values-changed=\"onLocalBuyerSelectedChanged({selectedList:selectedList, initialized: initialized})\" page=\"{{page}}\" ng-if=\"localBuyer\" title=\"Local Buyer\" end-point=\"{{apiEndPoints.dropDown.business}}\" filtersubtype=\"{{appTabFilter.LOCAL_BUYER}}\"></custom-filter><custom-filter on-selected-values-changed=\"onLocalSellerSelectedChanged({selectedList:selectedList, initialized: initialized})\" page=\"{{page}}\" ng-if=\"localSeller\" title=\"Local Seller\" end-point=\"{{apiEndPoints.dropDown.business}}\" filtersubtype=\"{{appTabFilter.LOCAL_BUYER}}\"></custom-filter><custom-filter on-selected-values-changed=\"onBuyersSelectedChanged({selectedList:selectedList, initialized: initialized})\" page=\"{{page}}\" ng-if=\"buyer\" title=\"Buyer\" end-point=\"{{apiEndPoints.dropDown.business}}\" filtersubtype=\"{{appTabFilter.BUYER}}\"></custom-filter><custom-filter on-selected-values-changed=\"onProductItemSelectedChanged({selectedList:selectedList, initialized: initialized})\" page=\"{{page}}\" ng-if=\"productItems\" title=\"Product Items\" end-point=\"{{apiEndPoints.dropDown.productItem}}\"></custom-filter><custom-filter on-selected-values-changed=\"onSellersSelectedChanged({selectedList:selectedList, initialized: initialized})\" page=\"{{page}}\" ng-if=\"seller\" end-point=\"{{apiEndPoints.dropDown.business}}\" title=\"Seller\"></custom-filter><custom-filter on-selected-values-changed=\"onProductsSelectedChanged({selectedList:selectedList, initialized: initialized})\" ng-if=\"product\" page=\"{{page}}\" title=\"Products\" end-point=\"{{apiEndPoints.dropDown.product}}\"></custom-filter><custom-filter on-selected-values-changed=\"onLocalTraderSelectedChanged({selectedList:selectedList, initialized: initialized})\" ng-if=\"localTrader\" page=\"{{page}}\" title=\"Local Trader\" end-point=\"{{apiEndPoints.dropDown.business}}\" filtersubtype=\"{{appTabFilter.LOCAL_TRADER}}\"></custom-filter><custom-filter on-selected-values-changed=\"onBpTypesSelectedChanged({selectedList:selectedList, initialized: initialized})\" title=\"Business Type\" ng-if=\"bpTypes\" end-point=\"{{apiEndPoints.dropDown.bpType}}\"></custom-filter><custom-filter on-selected-values-changed=\"onCountrySelectedChanged({selectedList:selectedList, initialized: initialized})\" title=\"Country\" ng-if=\"country\" end-point=\"{{apiEndPoints.dropDown.country}}\"></custom-filter><custom-filter on-selected-values-changed=\"onWarehouseSelectedChanged({selectedList:selectedList, initialized: initialized})\" title=\"Warehouse\" ng-if=\"warehouse\" end-point=\"{{apiEndPoints.dropDown.warehouses}}\"></custom-filter><custom-filter on-selected-values-changed=\"onPriceMarketSelectedChanged({selectedList:selectedList, initialized: initialized})\" title=\"Price Market\" ng-if=\"priceMarket\" end-point=\"{{apiEndPoints.dropDown.priceMarket}}\"></custom-filter><custom-filter on-selected-values-changed=\"onTranStatusSelectedChanged({selectedList:selectedList, initialized: initialized})\" title=\"Transaction Status\" ng-if=\"tranStatus\" end-point=\"{{apiEndPoints.dropDown.transactionStatus}}\"></custom-filter></div></div>");
$templateCache.put("app/widgets/lineChart/lineChart.html","<div id=\"amchart\"></div>");
$templateCache.put("app/widgets/localTradeDelivery/localTradeDelivery.html","<div class=\"commissionCard\"><div class=\"detail-heading\">Transaction Delivery <button class=\"btn-xs btn btn-warning\" ng-show=\"!trade.washOut.isWashout && !showForm\" ng-click=\"showWashOutForm(\'add\')\">Delivery Dispatched</button> <button class=\"btn-xs btn btn-warning\" ng-show=\"!trade.washOut.isWashout && !showForm\" ng-click=\"showWashOutForm(\'add\')\">Delivery Dispatched</button></div><div class=\"content\"><div class=\"col-md-12 col-xs-12 detail\"><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Due Date.</div><div class=\"value\" ng-bind=\"(trade.washOut.initialCommissionPayable) ? \'Yes\': \'No\'\"></div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Order Issued</div><div class=\"value\">{{trade.washOut.washoutDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Order Number</div><div class=\"value\">{{trade.washOut.washoutDueDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Challan</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.sellerWashoutPrice}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Actual Weight</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.buyerWashoutPrice}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Actual Amount</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.brokerDifference}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Slip <button style=\"margin-top: -5px;\" class=\"btn btn-xs btn-primary pull-right\">Add Slip</button></div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.totalDifference}}</div></div><div class=\"detail col-md-12\"><button class=\"btn btn-xs btn-success\" ng-click=\"vm.createWashoutInvoice()\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Delivery Reached</button></div></div><div ng-show=\"showForm\" class=\"col-md-12 col-xs-12\"><form name=\"transactionDelivery\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.washOut.initialCommissionPayable\"> <span>Initial Commission Payable</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Date</label><date-picker-input date=\"trade.washOut.washoutDate\" blank=\"false\" name=\"washoutDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout date.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Due Date</label><date-picker-input date=\"trade.washOut.washoutDueDate\" blank=\"false\" name=\"washoutDueDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDueDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDueDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout due date.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Seller Price in <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.sellerWashoutPrice\" ng-required=\"true\" name=\"sellerWashoutPrice\" class=\"form-control\" id=\"sellerWashoutPrice\" placeholder=\"Washout Price in USD\"><ng-messages for=\"washOutForm.sellerWashoutPrice.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.sellerWashoutPrice.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout price.</div></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Buyer Price in <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.buyerWashoutPrice\" ng-required=\"true\" name=\"buyerWashoutPrice\" class=\"form-control\" id=\"loCode\" placeholder=\"Washout Price in USD\"><ng-messages for=\"washOutForm.buyerWashoutPrice.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.buyerWashoutPrice.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout price.</div></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Difference <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.brokerDifference\" ng-required=\"true\" name=\"difference\" class=\"form-control\" id=\"difference\" placeholder=\"Washout Difference in USD\"><ng-messages for=\"washOutForm.washOutValue.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.washOutValue.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout difference</div></ng-messages></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"saveWashOutDetails(washOutForm, trade, true, trade.washOut, true)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> {{trade.washOut.isWashout ? \'Updated Washout value\' : \'Washout Transaction\'}}</button> <button type=\"button\" ng-click=\"cancelWashingOut()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></form></div></div></div>");
$templateCache.put("app/widgets/localTradePayment/localTradePayment.html","<div class=\"commissionCard\"><div class=\"detail-heading\">Transaction Payments <button class=\"btn-xs btn btn-warning\" ng-show=\"!trade.washOut.isWashout && !showForm\" ng-click=\"showWashOutForm(\'add\')\">Delivery Dispatched</button> <button class=\"btn-xs btn btn-warning\" ng-show=\"!trade.washOut.isWashout && !showForm\" ng-click=\"showWashOutForm(\'add\')\">Delivery Dispatched</button></div><div class=\"content\"><div class=\"col-md-12 col-xs-12 detail\"><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Due Date.</div><div class=\"value\" ng-bind=\"(trade.washOut.initialCommissionPayable) ? \'Yes\': \'No\'\"></div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Order Issued</div><div class=\"value\">{{trade.washOut.washoutDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Order Number</div><div class=\"value\">{{trade.washOut.washoutDueDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Challan</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.sellerWashoutPrice}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Actual Weight</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.buyerWashoutPrice}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Actual Amount</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.brokerDifference}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Delivery Slip <button style=\"margin-top: -5px;\" class=\"btn btn-xs btn-primary pull-right\">Add Slip</button></div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.totalDifference}}</div></div><div class=\"detail col-md-12\"><button class=\"btn btn-xs btn-success\" ng-click=\"vm.createWashoutInvoice()\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Delivery Reached</button></div></div><div ng-show=\"showForm\" class=\"col-md-12 col-xs-12\"><form name=\"transactionDelivery\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.washOut.initialCommissionPayable\"> <span>Initial Commission Payable</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Date</label><date-picker-input date=\"trade.washOut.washoutDate\" blank=\"false\" name=\"washoutDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout date.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Due Date</label><date-picker-input date=\"trade.washOut.washoutDueDate\" blank=\"false\" name=\"washoutDueDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDueDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDueDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout due date.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Seller Price in <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.sellerWashoutPrice\" ng-required=\"true\" name=\"sellerWashoutPrice\" class=\"form-control\" id=\"sellerWashoutPrice\" placeholder=\"Washout Price in USD\"><ng-messages for=\"washOutForm.sellerWashoutPrice.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.sellerWashoutPrice.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout price.</div></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Buyer Price in <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.buyerWashoutPrice\" ng-required=\"true\" name=\"buyerWashoutPrice\" class=\"form-control\" id=\"loCode\" placeholder=\"Washout Price in USD\"><ng-messages for=\"washOutForm.buyerWashoutPrice.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.buyerWashoutPrice.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout price.</div></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Difference <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.brokerDifference\" ng-required=\"true\" name=\"difference\" class=\"form-control\" id=\"difference\" placeholder=\"Washout Difference in USD\"><ng-messages for=\"washOutForm.washOutValue.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.washOutValue.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout difference</div></ng-messages></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"saveWashOutDetails(washOutForm, trade, true, trade.washOut, true)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> {{trade.washOut.isWashout ? \'Updated Washout value\' : \'Washout Transaction\'}}</button> <button type=\"button\" ng-click=\"cancelWashingOut()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></form></div></div></div>");
$templateCache.put("app/widgets/mapBubbles/mapBubbles.html","<div id=\"map-bubbles\" heading=\"Traffic By Country\"></div>");
$templateCache.put("app/widgets/maps/maps.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ui-view=\"\"></div></div></div>");
$templateCache.put("app/widgets/numberOnlyInput/numberOnlyInput.template.html","<input ng-class=\"{\'currency\': currency}\" style=\"cursor:default\" ng-required=\"{{required}}\" type=\"number\" step=\"0.01\" ng-blur=\"onBlur()\" ng-focus=\"onFocus()\" class=\"form-control\" placeholder=\"{{inputPlace}}\" name=\"{{inputName}}\" ng-model=\"inputValue\">");
$templateCache.put("app/widgets/pageHeader/pageHeader.template.html","<div class=\"dg-pageHeader\"><a ng-if=\"rootScope.goBack\" ng-click=\"goToBack()\" class=\"dg-backToLink\"><i class=\"fa fa-chevron-circle-left\"></i></a><div class=\"dg-pageHeaderTop clearfix\"><h1 class=\"dg-pageTitle\"><span class=\"dg-pageMiniTitle\">{{rootScope.headerSubTitle}}</span>{{rootScope.headerTitle}}</h1><div class=\"row button-bar\"><button class=\"btn btn-primary\" ui-sref=\"{{button.state}}\" ng-repeat=\"button in rootScope.headerAnchor\">{{button.text}}</button></div></div></div>");
$templateCache.put("app/widgets/pieChart/pieChart.template.html","<div id=\"{{id}}\" class=\"admin-chart\"></div>");
$templateCache.put("app/widgets/productCard/productCard.html","<div class=\"col-xs-12 col-md-{{colSize}} product-card\"><div class=\"content\"><div class=\"detail-heading\">Product Item</div><div><div class=\"row\"><div class=\"logo\" style=\"padding-left: 35px;\"><img width=\"60\" height=\"60\" ng-src=\"{{productImage}}\"></div><div class=\"details\"><div class=\"name\">{{productItem.name}}</div><div class=\"country\"><div class=\"flag\"><img width=\"20\" src=\"{{appConstants.HOST +productItem.countryFlag}}\"></div><div class=\"name\">{{productItem.country}}</div></div></div></div></div></div></div>");
$templateCache.put("app/widgets/profile/profile.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><div class=\"progress-info\">Your profile is 70% Complete</div><div class=\"progress\"><div class=\"progress-bar progress-bar-primary progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"70\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 70%\"></div></div><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ picture }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"uploadPicture()\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"\" value=\"Anastasiya\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"\" value=\"\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Department</label><div class=\"col-sm-9\"><select class=\"form-control\" selectpicker=\"\"><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputOccupation\" class=\"col-sm-3 control-label\">Occupation</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputOccupation\" placeholder=\"\" value=\"Front End Web Developer\"></div></div></div></div><h3 class=\"with-line\">Change Password</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputPassword\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputPassword\" placeholder=\"\" value=\"12345678\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputConfirmPassword\" class=\"col-sm-3 control-label\">Confirm Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"inputConfirmPassword\" placeholder=\"\"></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"\" value=\"contact@akveo.com\"></div></div><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">Phone</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputPhone\" placeholder=\"\" value=\"+1 (23) 456 7890\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Office Location</label><div class=\"col-sm-9\"><select class=\"form-control\" title=\"Standard Select\" selectpicker=\"\"><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class=\"form-group row clearfix\"><label for=\"inputRoom\" class=\"col-sm-3 control-label\">Room</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"inputRoom\" placeholder=\"\" value=\"303\"></div></div></div></div><h3 class=\"with-line\">Social Profiles</h3><div class=\"social-profiles row clearfix\"><div class=\"col-md-3 col-sm-4\" ng-repeat=\"item in socialProfiles\"><a class=\"sn-link\" href=\"\" ng-click=\"showModal(item)\" ng-if=\"!item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span></a> <a class=\"sn-link connected\" href=\"{{ item.href }}\" target=\"_blank\" ng-if=\"item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span> <em class=\"ion-ios-close-empty sn-link-close\" ng-mousedown=\"unconnect(item)\"></em></a></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I receive a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[0]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When Someone sends me an invitation</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[1]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When profile information changes</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[2]\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When anyone logs into your account from a new device or browser</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[3]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[4]\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"switches[5]\"></switch></div></div></div></div><button type=\"button\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Profile</button></div></div>");
$templateCache.put("app/widgets/profile/profileModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/widgets/shippingLineCard/shippingLineCard.template.html","<div class=\"shippingLineCard col-md-{{colSize}}\" ng-class=\"{\'hidden\':hide}\"><div class=\"content\"><div class=\"detail\"><div class=\"logo\"><img width=\"100\" height=\"100\" ng-src=\"{{logo}}\"></div><div class=\"row\"><div class=\"col-xs-6\"><div class=\"label-text\">Name</div><div class=\"detail-text\" ng-bind=\"shippingLine.name\"></div></div><div class=\"col-xs-6\"><div class=\"label-text\">Code Name</div><div class=\"detail-text\" ng-bind=\"shippingLine.codeName\"></div></div><div class=\"col-xs-6\"><div class=\"label-text\">Website</div><div ng-if=\"!shippingLine.website\" class=\"detail-text\" ng-bind=\"\'No website entered\'\"></div><div ng-if=\"shippingLine.website\" class=\"detail-text\"><a target=\"_blank\" href=\"shippingLine.website\">{{shippingLine.website}}</a></div></div><div class=\"col-xs-6\"><div class=\"label-text\">Vessel Count</div><div class=\"detail-text\" ng-bind=\"shippingLine.vesselCount\"></div></div></div><div class=\"button-row col-xs-12\"><button class=\"btn btn-xs btn-primary\" ng-click=\"editShippingLine(shippingLine.id)\">Edit</button> <button class=\"btn btn-xs btn-warning\" ng-click=\"deleteShippingLine(shippingLine.id)\">Delete</button></div></div></div></div>");
$templateCache.put("app/widgets/sparklines/sparkline.template.html","<div class=\"chart-block\" style=\"padding:28px\"><div id=\"line1\" style=\"vertical-align: middle; display: inline-block; width: 100px; height: 30px;\"></div></div>");
$templateCache.put("app/widgets/tradeDisputeCard/tradeDisputeCard.template.html","<div class=\"commissionCard\"><div class=\"detail-heading\">Dispute <button class=\"btn-xs btn btn-warning\" ng-show=\"!trade.dispute.isDisputed && !showForm\" ng-click=\"showDisputeForm()\">Dispute Trade</button> <button class=\"btn-xs btn btn-success\" ng-show=\"trade.dispute.isDisputed && !showForm\" ng-click=\"saveDisputeDetails(disputeForm, trade,false)\">Remove Dispute</button> <button class=\"btn-xs btn btn-primary\" ng-show=\"trade.dispute.isDisputed && !showForm\" ng-click=\"showDisputeForm(\'edit\')\">Edit</button></div><div class=\"content\"><div ng-if=\"!trade.dispute.isDisputed && !showForm\" class=\"col-md-12 col-xs-12 detail\"><div class=\"heading-2\">Status</div><div class=\"value\">Undisputed Transaction</div></div><div ng-if=\"trade.dispute.isDisputed && !showForm\" class=\"col-md-12 col-xs-12 detail\"><div class=\"detail col-md-12\"><div class=\"heading-2\">Disputed On</div><div class=\"value\">{{trade.dispute.disputeDate | date: appFormats.FullDate2}}</div></div><div class=\"detail col-md-12\"><div class=\"heading-2\">Trade Dispute</div><div class=\"value\"><i class=\"fa fa-check\" ng-class=\"{\'success\': trade.dispute.qualityComplain, \'negative\': !trade.dispute.qualityComplain}\" aria-hidden=\"true\"></i> Quality Complain</div><div class=\"value\"><i class=\"fa fa-check\" ng-class=\"{\'success\': trade.dispute.weightShortage, \'negative\': !trade.dispute.weightShortage}\" aria-hidden=\"true\"></i> Weight Shortage</div><div class=\"value\"><i class=\"fa fa-check\" ng-class=\"{\'success\': trade.dispute.other, \'negative\': !trade.dispute.other}\" aria-hidden=\"true\"></i> Other</div></div><div class=\"detail col-md-12\"><div class=\"heading-2\">Details</div><div class=\"value\">{{trade.dispute.details ? trade.dispute.details : \'NA\'}}</div></div><div class=\"detail col-md-12\"><div class=\"heading-2\">Dispute Resolved</div><div class=\"value\">{{trade.dispute.disputeResolved ? \'Dispute Resolved On \' + (trade.dispute.disputeResolvedDate | date: appFormats.FullDate2) : \'No\'}}</div></div></div><div ng-if=\"showForm\" class=\"col-md-12 col-xs-12\"><form name=\"disputeForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Dispute Date</label><date-picker-input date=\"trade.dispute.disputeDate\" required=\"true\" name=\"washoutDate\"></date-picker-input></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.dispute.qualityComplain\"> <span>Quality Complain</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.dispute.weightShortage\"> <span>Weight Shortage</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.dispute.other\"> <span>Other</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line control-label\">Details</label> <textarea ng-model=\"trade.dispute.details\" class=\"form-control\">\n                            </textarea></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.dispute.disputeResolved\"> <span>Dispute Resolved</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Dispute Resolved Date</label><date-picker-input required=\"false\" date=\"trade.dispute.disputeResolvedDate\" blank=\"true\" name=\"disputeResolvedDate\"></date-picker-input></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"saveDisputeDetails(disputeForm, trade, true)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Save Dispute Details</button> <button type=\"button\" ng-click=\"cancelDisputingTrade()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></form></div></div></div>");
$templateCache.put("app/widgets/tradeTable/tradeTable.template.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"row table-options\"><div class=\"col-md-6 manifest-quantity\"><div class=\"box title\">Total Quantity</div><div class=\"number box\">{{totalQuantity | number : \'2\'}} MT</div></div><div class=\"col-md-6 button-bar\"><button class=\"btn btn-xs\" data-toggle=\"modal\" ng-class=\"{\'btn-success\': !hidePaging, \'btn-danger\': hidePaging}\" ng-click=\"unpagedView(hidePaging)\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i> &nbsp; Unpaged View</button> <button class=\"btn excel-btn btn-xs\" data-toggle=\"modal\" ng-click=\"exportToExcel(tableData, columnHeader)\"><i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i> &nbsp; Export to Excel</button> <button class=\"btn pdf-btn btn-xs\" data-toggle=\"modal\" ng-click=\"exportToPDF(tableData, columnHeader)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> &nbsp; Export to PDF</button></div></div><div class=\"horizontal-scroll-table-wrapper\"><table class=\"table table-striped\"><thead><tr class=\"sortable table-header\" ng-if=\"listData.length!==0\"><th><span class=\"count\">{{listData.length}}</span></th><th ng-click=\"sortTable(column.sort, column)\" ng-class=\"{\'sorted\': (sortType === column.sort), \'up\': !column.reverse && (sortType === column.sort), \'down\': column.reverse && (sortType === column.sort)}\" ng-repeat=\"column in columnHeader\" ng-bind-html=\"column.name\"></th></tr><tr class=\"table-header\" ng-if=\"listData.length===0\"><th>No transaction have been added with in the given date range and filters.</th></tr></thead><tbody ng-repeat=\"row in displayList\" ng-if=\"listData.length!==0\"><tr ng-if=\"type===\'tradeBook\'\" ng-class=\"{\'has-secondary\': row.hasSecondary, \'is-secondary\': row.isSecondary}\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.date | date:appFormats.Date}}</td><td><a class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.fileNo})\">{{row.fileNo}}</a></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td class=\"date\">{{row.shipmentStart | date:appFormats.Date}}</td><td class=\"date\">{{row.shipmentEnd | date:appFormats.Date}}</td><td class=\"titled\" ng-if=\"row.expectedCommission\">{{row.expectedCommission | number: 2}}</td><td class=\"titled\" ng-if=\"row.actualCommission !== undefined\">{{(row.actualCommission) ? (row.actualCommission | number: 2 ) : \'NA\'}}</td></tr><tr ng-if=\"type===\'arrivedList\'\" ng-class=\"{\'has-secondary\': row.hasSecondary, \'is-secondary\': row.isSecondary}\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.dateArrived | date:appFormats.Date}}</td><td>{{row.dateArrived | amDifference : null : \'days\'}}</td><td><a class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.fileNo})\">{{row.fileNo}}</a></td><td ng-bind=\"row.blNo\"></td><td ng-bind=\"row.contractNo\"></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td></tr><tr ng-if=\"type===\'expectedArrival\'\" ng-class=\"{\'has-secondary\': row.hasSecondary, \'is-secondary\': row.isSecondary}\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.expectedArrival | date:appFormats.Date}}</td><td>{{row.expectedArrival | amDifference : null : \'days\'}}</td><td><a class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.fileNo})\">{{row.fileNo}}</a></td><td ng-bind=\"row.blNo\"></td><td ng-bind=\"row.contractNo\"></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td></tr><tr ng-if=\"type===\'expiredShipment\'\" ng-class=\"{\'has-secondary\': row.hasSecondary, \'is-secondary\': row.isSecondary}\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.shipmentExpiration | date:appFormats.Date}}</td><td>{{row.shipmentExpiration | amDifference : null : \'days\'}}</td><td><a class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.fileNo})\">{{row.fileNo}}</a></td><td ng-bind=\"row.blNo\"></td><td ng-bind=\"row.contractNo\"></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td></tr><tr ng-if=\"type===\'next30DaysExpiration\'\" ng-class=\"{\'has-secondary\': row.hasSecondary, \'is-secondary\': row.isSecondary}\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.shipmentExpiration | date:appFormats.Date}}</td><td>{{row.shipmentExpiration | amDifference : null : \'days\'}}</td><td><a class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.fileNo})\">{{row.fileNo}}</a></td><td ng-bind=\"row.blNo\"></td><td ng-bind=\"row.contractNo\"></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td></tr><tr ng-if=\"type===\'tradeDispute\'\" ng-class=\"{\'has-secondary\': row.hasSecondary, \'is-secondary\': row.isSecondary}\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.disputedOn | date:appFormats.Date}}</td><td>{{row.disputedOn | amDifference : null : \'days\'}}</td><td><a class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.fileNo})\">{{row.fileNo}}</a></td><td ng-bind=\"row.contractNo\"></td><td ng-bind=\"row.completedOn | date:appFormats.Date\"></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td></tr><tr ng-if=\"type===\'localTradeBook\'\"><td ng-click=\"toggleNotes(row)\"><i class=\"fa fa-plus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"!row.showNotes\"></i> <i class=\"fa fa-minus-square cursor-pointer\" aria-hidden=\"true\" ng-if=\"row.showNotes\"></i></td><td class=\"titled date\">{{row.date | date:appFormats.Date}}</td><td><a class=\"titled\" ui-sref=\"dashboard.localTransactionView({fileId:row.fileNo})\">{{row.fileNo}}</a></td><td><a ng-if=\"row.internationalFileNo\" class=\"titled\" ui-sref=\"dashboard.transactionView({id:row.internationalFileNo})\">{{row.internationalFileNo}}</a><span ng-if=\"!row.internationalFileNo\">NA</span></td><td class=\"business titled\" ng-bind=\"row.buyerName + \' | \' + (row.buyerCountry ? row.buyerCountry : \'No Origin\')\"></td><td class=\"product\">{{row.productName}}</td><td>{{row.productOriginName}}</td><td>{{row.quantity | number: 2}}</td><td>{{row.price | number: 2}}</td><td class=\"business titled\" ng-bind=\"row.sellerName + \' | \' + (row.sellerCountry ? row.sellerCountry : \'No Origin\')\"></td><td class=\"titled date\">{{row.deliveryDueDate | date:appFormats.Date}}</td><td class=\"titled date\">{{row.fundsDueDate | date:appFormats.Date}}</td></tr><tr ng-show=\"row.showNotes\"><td colspan=\"{{columnHeader.length +1}}\"><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"noteList\"><img ng-if=\"noteListLoading\" width=\"60\" height=\"60\" src=\"assets/img/loader.svg\"><div ng-if=\"!noteListLoading && (row.noteList.length === 0)\">No trade notes.</div><div class=\"col-xs-12\" ng-repeat=\"nte in row.noteList | orderBy: \'-createdAt\'\"><div class=\"col-xs-6 note\" ng-class=\"{\'pull-right\':nte.self, \'self\':nte.self, \'other\': !nte.self, \'editing\': nte.editing}\"><div class=\"col-xs-12 userData\"><img class=\"userImage\" ng-src=\"{{( nte.createdByPic | profilePicture )}}\"><div class=\"details\"><div class=\"name\">{{nte.createdBy}}</div><div class=\"date\">Note on: {{nte.createdAt | date:appFormats.Time }}</div><div class=\"date\" ng-if=\"nte.updatedAt\">Note Updated On: {{nte.updatedAt | date:appFormats.Time }}</div></div></div><div class=\"col-xs-12\">{{nte.note}}</div><div class=\"col-xs-12 button-bar\"><button class=\"btn btn-danger btn-xs pull-right\" ng-if=\"nte.self\" ng-click=\"editTradeNote(row, nte.note, nte)\">Edit</button> <button class=\"btn btn-warning btn-xs pull-right\" ng-click=\"deleteTradeNote(row.id, nte.noteId, nte, row.noteList)\" ng-if=\"nte.isDeleteAble\">Delete</button></div></div></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group col-md-12 clearfix\"><form name=\"vm.trade_note_form_{{row.id}}\" novalidate=\"\"><label class=\"col-sm-12 control-label\">Notes</label><div class=\"col-sm-12\"><textarea ng-if=\"!addingNote\" ng-required=\"true\" name=\"tradeNote_{{row.id}}\" ng-model=\"row.note\" class=\"form-control\">\n                                                </textarea><ng-messages for=\"vm[\'trade_note_form_\'+row.id][\'tradeNote_\'+row.id].$error\" ng-if=\'(vm[\"trade_note_form_\"+row.id].$submitted || vm[\"trade_note_form_\"+row.id][\"tradeNote_\"+row.id].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter a trade note.</div></ng-messages></div><div class=\"col-sm-12\"><button class=\"btn btn-success editable-table-button btn-xs\" type=\"submit\" style=\"min-width: 115px;\" ng-click=\"addTradeNote(row.id, row.note, row.noteList, row, vm[\'trade_note_form_\'+row.id])\"><span ng-if=\"addingNote\"><i class=\"fa fa-spinner fa-pulse fa-spin fa-3x fa-fw\"></i> <span class=\"sr-only\">Loading...</span> &nbsp;</span> <span ng-if=\"!addingNote && !updateNote\">Add Note</span> <span ng-if=\"updateNote\">Update Note</span></button></div></form></div></div></div></td></tr></tbody></table></div><div ng-show=\"!hidePaging\"><ul ng-show=\"listData.length > 0\" uib-pagination=\"\" ng-change=\"pageChanged(currentPage)\" total-items=\"listData.length\" ng-model=\"currentPage\" max-size=\"itemsPerPage\" class=\"pagination-sm push-left\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div></div>");
$templateCache.put("app/widgets/tradeWashOutCard/tradeWashOutCard.template.html","<div class=\"commissionCard\"><div class=\"detail-heading\">Washout Status <button class=\"btn-xs btn btn-warning\" ng-show=\"!trade.washOut.isWashout && !showForm\" ng-click=\"showWashOutForm(\'add\')\">Washout Transaction</button> <button class=\"btn-xs btn btn-success\" ng-show=\"trade.washOut.isWashout && !showForm\" ng-click=\"saveWashOutDetails(washOutForm, trade,false, getNewWashoutObj(), false)\">Un Washout Transaction</button> <button class=\"btn-xs btn btn-primary\" ng-show=\"trade.washOut.isWashout && !showForm\" ng-click=\"showWashOutForm(\'edit\')\">Edit</button></div><div class=\"content\"><div ng-if=\"!trade.washOut.isWashout && !showForm\" class=\"col-md-12 col-xs-12 detail\"><div class=\"heading-2\">Status</div><div class=\"value\">Washout Status Deactivated</div></div><div ng-if=\"trade.washOut.isWashout && !showForm\" class=\"col-md-12 col-xs-12 detail\"><div class=\"detail col-md-12\"><div class=\"heading-2\">Initial Commission Payable</div><div class=\"value\" ng-bind=\"(trade.washOut.initialCommissionPayable) ? \'Yes\': \'No\'\"></div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Washout Date</div><div class=\"value\">{{trade.washOut.washoutDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Washout Due Date</div><div class=\"value\">{{trade.washOut.washoutDueDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Seller Washout Price</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.sellerWashoutPrice}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Buyer Washout Price</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.buyerWashoutPrice}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Washout Difference</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.brokerDifference}}</div></div><div class=\"detail col-md-6\"><div class=\"heading-2\">Total Difference</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.totalDifference}}</div></div><div class=\"detail col-md-12\"><div class=\"heading-2\">Washout Commission</div><div class=\"value\"><span class=\"currency\">USD</span> {{trade.washOut.washOutCommission}}</div></div><div class=\"detail col-md-12\"><button class=\"btn btn-xs btn-success\" ng-click=\"vm.createWashoutInvoice()\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Create Invoice</button></div></div><div ng-show=\"showForm\" class=\"col-md-12 col-xs-12\"><form name=\"washOutForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-model=\"trade.washOut.initialCommissionPayable\"> <span>Initial Commission Payable</span></label></div></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Date</label><date-picker-input date=\"trade.washOut.washoutDate\" blank=\"false\" name=\"washoutDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout date.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Due Date</label><date-picker-input date=\"trade.washOut.washoutDueDate\" blank=\"false\" name=\"washoutDueDate\"></date-picker-input><ng-messages for=\"washOutForm.washoutDueDate.$error\" ng-show=\"(washOutForm.$submitted || washOutForm.washoutDueDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter washout due date.</ng-message></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Seller Price in <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.sellerWashoutPrice\" ng-required=\"true\" name=\"sellerWashoutPrice\" class=\"form-control\" id=\"sellerWashoutPrice\" placeholder=\"Washout Price in USD\"><ng-messages for=\"washOutForm.sellerWashoutPrice.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.sellerWashoutPrice.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout price.</div></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Buyer Price in <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.buyerWashoutPrice\" ng-required=\"true\" name=\"buyerWashoutPrice\" class=\"form-control\" id=\"loCode\" placeholder=\"Washout Price in USD\"><ng-messages for=\"washOutForm.buyerWashoutPrice.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.buyerWashoutPrice.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout price.</div></ng-messages></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Washout Difference <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"trade.washOut.brokerDifference\" ng-required=\"true\" name=\"difference\" class=\"form-control\" id=\"difference\" placeholder=\"Washout Difference in USD\"><ng-messages for=\"washOutForm.washOutValue.$error\" ng-if=\"(washOutForm.$submitted || washOutForm.washOutValue.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter a washout difference</div></ng-messages></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"saveWashOutDetails(washOutForm, trade, true, trade.washOut, true)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> {{trade.washOut.isWashout ? \'Updated Washout value\' : \'Washout Transaction\'}}</button> <button type=\"button\" ng-click=\"cancelWashingOut()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></div></form></div></div></div>");
$templateCache.put("app/widgets/trafficChart/trafficChart.html","<div class=\"channels-block\" ng-class=\"{\'transparent\': transparent}\"><div class=\"chart-bg\"></div><div class=\"traffic-chart\" id=\"trafficChart\"><div class=\"canvas-holder\"><canvas id=\"chart-area\" width=\"300\" height=\"300\"></canvas><div class=\"traffic-text\">1,900,128 <span>Views Total</span></div></div><div class=\"traffic-legend\"></div></div><div class=\"channels-info\"><div><div class=\"channels-info-item\" ng-repeat=\"item in doughnutData | orderBy:\'order\'\"><div class=\"legend-color\" style=\"background-color: {{::item.color}}\"></div><p>{{::item.label}}<span class=\"channel-number\">+{{item.percentage}}%</span></p><div class=\"progress progress-sm channel-progress\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{item.percentage}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: {{item.percentage}}%\"></div></div></div></div></div></div>");
$templateCache.put("app/widgets/vesselCard/vesselCard.template.html","<div class=\"vesselCard col-md-{{colSize}}\" ng-class=\"{\'isBroken\': vessel.broken}\"><div class=\"content\"><div class=\"details col-xs-12\"><div class=\"name\" ng-bind=\"vessel.first_name\"></div><div class=\"imo\" ng-bind=\"vessel.imoNumber\"></div><div ng-if=\"!vessel.shippingLine\" class=\"operator\" ng-bind=\"vessel.operator\"></div><div ng-if=\"vessel.shippingLine\"><div class=\"logo\"><img width=\"100\" height=\"100\" ng-src=\"{{logo}}\"></div><div ng-bind=\"vessel.shippingLine.name\"></div><div ng-bind=\"vessel.shippingLine.code\"></div></div></div><div class=\"button-row col-xs-12\"><button class=\"btn btn-xs btn-primary\" ng-click=\"editVesselDetails(vessel.id)\">Edit</button> <button class=\"btn btn-xs btn-warning\">Delete</button></div></div></div>");
$templateCache.put("app/widgets/warehouseCard/warehouseCard.html","<div class=\"col-md-{{colSize}} warehouseCard\"><div class=\"content\"><div class=\"row\"><div class=\"col-xs-12 name\" ng-bind=\"warehouse.name\"></div></div><div class=\"section-row\"><div class=\"col-md-4 col-xs-12 section\"><div class=\"heading\">Consumed Capacity</div><div class=\"number\" ng-bind-html=\"warehouse.currentKgs | weight\"></div></div><div class=\"col-md-4 col-xs-12 section\"><div class=\"heading\">Total Capacity</div><div class=\"number\" ng-bind-html=\"warehouse.totalCapacity | weight\"></div></div><div class=\"col-md-4 col-xs-12 section\"><div class=\"heading\">Consumed Percentage</div><div class=\"pie-chart-item\"><div class=\"number\" ng-bind-html=\"(warehouse.percentageConsumed | number:\'2\')+\'<span class=\\\'titled\\\'>%</span>\'\"></div></div></div></div><br><div class=\"row button-row\"><div><button class=\"btn btn-warning\" ng-click=\"openWarehouseProductStockReport(warehouse.id, warehouse.name, warehouse.currentKgs)\">Product Stock Summary</button></div><div class=\"\"><button class=\"btn btn-success\" ng-click=\"openWarehouseBusinessStockReport(warehouse.id, warehouse.name, warehouse.currentKgs)\">Business Stock Summary</button></div></div></div></div>");
$templateCache.put("app/widgets/weather/weather.html","<div class=\"weather-wrapper\"><div class=\"weather-main-info\"><h5 class=\"city-date font-x1dot5\"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class=\"weather-description font-x1dot5\"><i class=\"font-x3 {{weatherIcons[weather.days[weather.current].icon]}}\"></i><div class=\"weather-info\">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class=\"weather-temp font-x1dot5\"><i class=\"font-x2 ion-thermometer\"></i><div class=\"weather-info\" ng-switch=\"\" on=\"units\"><span ng-switch-when=\"metric\">{{weather.days[weather.current].temp}} °C | <a ng-click=\"switchUnits(\'imperial\')\" href=\"\">°F</a></span> <span ng-switch-when=\"imperial\">{{weather.days[weather.current].temp}} °F | <a ng-click=\"switchUnits(\'metric\')\" href=\"\">°C</a></span></div></div></div><div id=\"tempChart\" class=\"temp-by-time\"></div><div class=\"select-day\"><div class=\"day\" ng-repeat=\"day in weather.days\" ng-click=\"switchDay($index)\"><div><span class=\"font-x1dot25\">{{day.temp}}</span></div><div><i class=\"weatherIcon font-x2 {{weatherIcons[day.icon]}}\"></i> <span class=\"select-day-info\">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>");
$templateCache.put("app/dashboard/accounts/invoice/invoice.html","");
$templateCache.put("app/dashboard/accounts/invoice/invoiceForm.html","<div class=\"row\"><form name=\"vm.invoiceForm\"><div class=\"col-md-6 pull-left\"><div ba-panel=\"\"><div class=\"row\"><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Date</label><date-picker-input date=\"vm.invoiceObj.date\" blank=\"false\" name=\"invoiceDate\"></date-picker-input><ng-messages for=\"vm.invoiceForm.invoiceDate.$error\" ng-show=\"(vm.invoiceForm.$submitted || vm.invoiceForm.invoiceDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter invoice date.</ng-message></ng-messages></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Invoice No.</label> <input type=\"text\" ng-model=\"vm.invoiceObj.invoiceNo\" ng-required=\"true\" name=\"invoiceNo\" class=\"form-control\" id=\"invoiceNo\" placeholder=\"Invoice No.\"><ng-messages for=\"vm.invoiceForm.invoiceDate.$error\" ng-show=\"(vm.invoiceForm.$submitted || vm.invoiceForm.invoiceNo.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter invoice date.</ng-message></ng-messages></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">File No.</label> <input type=\"text\" ng-model=\"vm.invoiceObj.fileNo\" ng-required=\"true\" ng-disabled=\"true\" name=\"quantity\" class=\"form-control\" id=\"fileNo\" placeholder=\"File No.\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Contract No.</label> <input type=\"text\" ng-model=\"vm.invoiceObj.contractNo\" ng-required=\"true\" ng-disabled=\"true\" name=\"contractNo\" class=\"form-control\" id=\"contractNo\" placeholder=\"Contract No.\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">BL No.</label> <input type=\"text\" ng-model=\"vm.invoiceObj.blNo\" ng-required=\"true\" ng-disabled=\"true\" name=\"blNo\" class=\"form-control\" id=\"blNo\" placeholder=\"BL No.\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Quantity <span class=\"titled\">FCL</span></label> <input type=\"text\" ng-model=\"vm.invoiceObj.quantityFCL\" ng-required=\"true\" name=\"quantityFCL\" class=\"form-control\" id=\"quantityFCL\" placeholder=\"Quantity FCL\"></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Quantity <span class=\"titled\">MT</span></label> <input type=\"text\" ng-model=\"vm.invoiceObj.quantity\" ng-required=\"true\" name=\"quantity\" class=\"form-control\" id=\"quantity\" placeholder=\"Quantity\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Rate <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"vm.invoiceObj.price\" ng-required=\"true\" ng-disabled=\"true\" name=\"quantity\" class=\"form-control\" id=\"rate\" placeholder=\"Rate\"></div></div><div class=\"col-md-6 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\"><span class=\"titled\" ng-bind=\"vm.invoiceObj.currency\"></span> / <span class=\"titled\">USD</span></label> <input type=\"text\" ng-model=\"vm.invoiceObj.currencyRate\" ng-required=\"true\" name=\"quantity\" class=\"form-control\" id=\"conversionRate\" placeholder=\"Currency Rate\"></div></div></div></div></div><div class=\"col-md-4 pull-right\"><business-card col-size=\"12\" business=\"vm.invoiceObj.invoiceTo\" business-type=\"Invoice To\"></business-card><product-card col-size=\"12\" product-item=\"vm.invoiceObj.productItem\"></product-card></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Invoice Details\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-table=\"editableTableData\"><thead><tr class=\"sortable\"><th class=\"table-id\"></th><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">S.No</th><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">Description</th><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">Amount <span class=\"titled\" ng-bind=\"vm.invoiceObj.currency\"></span></th><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">Remarks</th></tr></thead><tbody><tr ng-repeat=\"item in vm.invoiceObj.invoiceItems track by $index\"><td></td><td ng-bind=\"$index+1\"></td><td>{{item.name}}</td><td><input class=\"form-control\" type=\"text\" ng-model=\"item.amount\"></td><td><input class=\"form-control\" type=\"text\" ng-model=\"item.remarks\"></td></tr></tbody><tbody><tr><td></td><td></td><td></td><td><strong>Total</strong></td><td><span class=\"titled\" ng-bind=\"vm.invoiceObj.currency\"></span> {{vm.invoiceObj.invoiceAmount | number : \'2\'}}</td></tr><tr><td></td><td></td><td></td><td><strong>FCL Weight(KG)</strong></td><td><span class=\"titled\" ng-bind=\"vm.invoiceObj.currency\"></span> {{(vm.invoiceObj.quantity * 1000) | number : \'2\'}}</td></tr><tr><td></td><td></td><td></td><td><strong>Average Rate(<span class=\"titled\" ng-bind=\"vm.invoiceObj.currency +\' / KG\'\"></span>)</strong></td><td><span class=\"titled\" ng-bind=\"vm.invoiceObj.currency\"></span> {{((vm.invoiceObj.invoiceAmount / (vm.invoiceObj.quantity* 1000) ) | number : \'2\')}}</td></tr></tbody></table></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Notes\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><textarea type=\"text\" ng-model=\"vm.invoiceObj.note\" name=\"notes\" class=\"form-control\" id=\"notes\">\n\n                        </textarea></div></div></div><div class=\"col-md-12\" ba-panel=\"\"><button type=\"submit\" ng-click=\"vm.createInvoice(vm.fileId, vm.invoiceObj)\" ng-if=\"vm.invoiceId ===\'new\'\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Create Invoice</button> <button type=\"submit\" ng-click=\"vm.updateInvoice(vm.fileId, vm.invoiceObj)\" ng-if=\"vm.invoiceId !==\'new\'\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Update Invoice</button> <button type=\"button\" ng-click=\"vm.cancel(vm.fileId)\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div>");
$templateCache.put("app/dashboard/accounts/taccounts/taccounts.html","<div>Commission Flow</div>");
$templateCache.put("app/dashboard/businessPartner/report/businessReport.html","<div></div>");
$templateCache.put("app/dashboard/businessPartner/template/bankInfo.html","<form name=\"vm.bankInfoForm\"><div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addBusinessBank(vm.business)\">Add Bank Account</button></div></div><h3 class=\"with-line\">All Banks</h3><div ng-repeat=\"bank in vm.business.banks\" class=\"notification row clearfix margin-top-10px\"><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Bank Name</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-model=\"bank.bankName\" class=\"form-control\" name=\"bankName_{{$index}}\" placeholder=\"Bank Name\"><div ng-messages=\"vm.bankInfoForm[\'bankName_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.bankInfoForm.$submitted || vm.bankInfoForm[\"bankName_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter bank name.</div></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Account Title</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-model=\"bank.accountTitle\" class=\"form-control\" name=\"accountTitle_{{$index}}\" placeholder=\"Account Title\"><div ng-messages=\"vm.bankInfoForm[\'accountTitle_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.bankInfoForm.$submitted || vm.bankInfoForm[\"accountTitle_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter account title.</div></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Country</label><div class=\"col-xs-8\"><selectize placeholder=\"Bank Country\" name=\"bankCountry_{{$index}}\" ng-required=\"true\" config=\"vm.bankCountryConfig\" options=\"vm.countryOptions.list\" ng-model=\"bank.accountCountry\"></selectize><div ng-messages=\"vm.bankInfoForm[\'bankCountry_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.bankInfoForm.$submitted || vm.bankInfoForm[\"bankCountry_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please select a country.</div></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Branch Address</label><div class=\"col-xs-8\"><textarea ng-model=\"bank.accountAddress\" class=\"form-control\" name=\"accountAddress_{{$index}}\" placeholder=\"Account Address\">\n                </textarea></div></div></div><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Account Number</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-model=\"bank.accountNumber\" class=\"form-control\" name=\"accountNumber_{{$index}}\" placeholder=\"Account Number\"><div ng-messages=\"vm.bankInfoForm[\'accountNumber_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.bankInfoForm.$submitted || vm.bankInfoForm[\"accountNumber_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter account number.</div></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">City</label><div class=\"col-xs-8\"><selectize placeholder=\"City\" id=\"bankCity_{{$index}}\" name=\"bankCity_{{$index}}\" config=\"vm.cityConfig\" options=\"bank.cityOptions.list\" ng-model=\"bank.accountCity\"></selectize></div></div></div><div class=\"col-sm-2 col-sm-offset-2\"><i ng-click=\"vm.removeBusinessBank(vm.business.banks, bank)\" class=\"fa fa-trash primary-font cursor-pointer\" style=\"padding-top: 10px;\"></i></div><br></div></form>");
$templateCache.put("app/dashboard/businessPartner/template/basicInfo.html","<form name=\"vm.basicInfoForm\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Business Logo</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ vm.businessLogo }}\" ng-click=\"vm.uploadBusinessLogo(event)\"></div><i class=\"ion-ios-close-outline\" ng-click=\"vm.removeBusinessLogo()\" ng-if=\"!vm.business.logo\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"vm.uploadBusinessLogo(event)\">Change Business Logo</a> <input type=\"file\" ng-show=\"false\" id=\"uploadBusinessLogo\" ng-file-select=\"vm.onFileSelect($files)\"></div></div></div></div><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label for=\"businessName\" class=\"col-sm-3 control-label\">Business</label><div class=\"col-sm-9\"><input type=\"text\" ng-required=\"true\" name=\"businessName\" ng-model=\"vm.business.name\" class=\"form-control\" id=\"businessName\" placeholder=\"Business Name\"><ng-messages for=\"vm.basicInfoForm.businessName.$error\" ng-if=\"(vm.basicInfoForm.$submitted && vm.basicInfoForm.businessName.$invalid) || (vm.basicInfoForm.businessName.$invalid && vm.basicInfoForm.businessName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter business name.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Website</label><div class=\"col-sm-9\"><input type=\"text\" name=\"businessWebsite\" ng-model=\"vm.business.website\" class=\"form-control\" id=\"businessWebsite\" placeholder=\"Business Website\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">NTN No.</label><div class=\"col-sm-9\"><input type=\"text\" name=\"businessNtn\" ng-model=\"vm.business.ntn\" class=\"form-control\" id=\"businessNtn\" placeholder=\"Business NTN\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Business Type</label><div class=\"col-md-9\"><selectize placeholder=\"Business Type\" name=\"businessType\" ng-required=\"true\" config=\"vm.bpTypeConfig\" options=\"vm.bpTypeOptions.list\" ng-model=\"vm.business.bpType\"></selectize><ng-messages for=\"vm.basicInfoForm.businessType.$error\" ng-if=\"(vm.basicInfoForm.$submitted && vm.basicInfoForm.businessType.$invalid) || (vm.basicInfoForm.businessType.$invalid && vm.basicInfoForm.businessType.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">A Business should at least have one type.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Business Partner Database Id</label><div class=\"col-md-9\"><input type=\"text\" name=\"businessDatabaseId\" ng-model=\"vm.business.databaseId\" class=\"form-control\" id=\"businessDatabaseId\" placeholder=\"Business Partner Database Id\"></div></div></div></div></form>");
$templateCache.put("app/dashboard/businessPartner/template/contactInfo.html","<form name=\"vm.contactInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addBusinessContact(vm.business)\">Add Contact Person</button></div></div><h3 class=\"with-line\">All Contacts</h3><div ng-repeat=\"contact in vm.business.contacts\" class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Contact Number</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-pattern=\"/^[0-9+\\(\\)-]+$/i\" ng-model=\"contact.contactNumber\" class=\"form-control\" name=\"{{\'contactNumber_\'+$index}}\" placeholder=\"Contact Number\"><ng-messages for=\"vm.contactInfoForm[\'contactNumber_{{$index}}\'].$error\" ng-if=\'(vm.contactInfoForm.$submitted && vm.businessForm[\"contactNumber_\"+$index].$invalid) || (vm.contactInfoForm[\"contactNumber_\"+$index].$invalid && vm.contactInfoForm[\"contactNumber_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter contact number.</div><div ng-message=\"pattern\" class=\"errorValidation\">Contact Number can not have alphabets.</div></ng-messages></div></div></div><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Contact Type</label><div class=\"col-xs-8\"><selectize placeholder=\"Contact Type\" name=\"{{\'contactType_\'+$index}}\" ng-required=\"true\" config=\"vm.contactTypeConfig\" options=\"vm.contactTypeOptions.list\" ng-model=\"contact.contactType\"></selectize><ng-messages for=\"vm.contactInfoForm[\'contactNumber_{{$index}}\'].$error\" ng-if=\'(vm.contactInfoForm.$submitted && vm.contactInfoForm[\"contactType_\"+$index].$invalid) || (vm.contactInfoForm[\"contactType_\"+$index].$invalid && vm.contactInfoForm[\"contactType_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter contact type.</div></ng-messages></div></div></div><div class=\"col-sm-2 col-sm-offset-2\"><i ng-click=\"vm.removeBusinessContact(vm.business.contacts, contact)\" class=\"fa fa-trash primary-font cursor-pointer\" style=\"padding-top: 10px;\"></i></div><br><br><h3 class=\"with-line margin-top-10px margin-bottom-10px\" style=\"width:98%; margin-left: auto; margin-right: auto;\"></h3></div></form>");
$templateCache.put("app/dashboard/businessPartner/template/contactPerson.html","<form name=\"vm.contactPersonInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addContactPerson(vm.business)\">Add Contact Person</button></div></div><h3 class=\"with-line\">All Contact Persons</h3><div ng-repeat=\"contPerson in vm.business.contactPersons\" class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Full Name</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-pattern=\"/^[a-zA-Z ]+$/i\" ng-model=\"contPerson.fullName\" class=\"form-control\" name=\"{{\'personName_\'+$index}}\" placeholder=\"Full Name\"><ng-messages for=\"vm.contactPersonInfoForm[\'personName_{{$index}}\'].$error\" ng-if=\'(vm.contactPersonInfoForm.$submitted && vm.contactPersonInfoForm[\"personName_\"+$index].$invalid) || (vm.contactPersonInfoForm[\"personName_\"+$index].$invalid && vm.contactPersonInfoForm[\"personName_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter contact person name.</div><div ng-message=\"pattern\" class=\"errorValidation\">Name can only have alphabets.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Designation</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-pattern=\"/^[a-zA-Z ]+$/i\" ng-model=\"contPerson.designation\" class=\"form-control\" name=\"{{\'personDesignation_\'+$index}}\" placeholder=\"Designation\"><ng-messages for=\"vm.contactPersonInfoForm[\'personDesignation_{{$index}}\'].$error\" ng-if=\'(vm.contactPersonInfoForm.$submitted && vm.contactPersonInfoForm[\"personDesignation_\"+$index].$invalid) || (vm.contactPersonInfoForm[\"personDesignation_\"+$index].$invalid && vm.contactPersonInfoForm[\"personDesignation_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter designation.</div><div ng-message=\"pattern\" class=\"errorValidation\">Designation can only have alphabets.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Email</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-model=\"contPerson.email\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/i\" class=\"form-control\" name=\"{{\'personEmail_\'+$index}}\" placeholder=\"Email\"><ng-messages for=\"vm.contactPersonInfoForm[\'personEmail_{{$index}}\'].$error\" ng-if=\'(vm.contactPersonInfoForm.$submitted && vm.contactPersonInfoForm[\"personEmail_\"+$index].$invalid) || (vm.contactPersonInfoForm[\"personEmail_\"+$index].$invalid && vm.contactPersonInfoForm[\"personEmail_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter email.</div><div ng-message=\"pattern\" class=\"errorValidation\">Please enter valid person email.</div></ng-messages></div></div></div><div class=\"col-sm-4\"><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Primary Contact</label><div class=\"col-xs-8\"><input ng-required=\"true\" ng-pattern=\"/^[0-9-\\(\\)]+$/i\" ng-model=\"contPerson.primaryNumber\" class=\"form-control\" name=\"{{\'contPrimary_\'+$index}}\" placeholder=\"Primary Contact\"></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-4\">Secondary Contact</label><div class=\"col-xs-8\"><input ng-pattern=\"/^[0-9-\\(\\)]+$/i\" ng-model=\"contPerson.secondaryNumber\" class=\"form-control\" name=\"{{\'contSecondary_\'+$index}}\" placeholder=\"Secondary Contact\"></div></div></div><div class=\"col-sm-2\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" ng-change=\"vm.isPrimaryChange(vm.business.contactPersons, contPerson, contPerson.isPrimary, \'isPrimary\')\" id=\"checkboxSuccess\" ng-model=\"contPerson.isPrimary\"> <span>Is Primary Contact</span></label></div></div><div class=\"col-sm-2\"><i ng-click=\"vm.removeContactPerson(vm.business.contactPersons, contPerson)\" class=\"fa fa-trash primary-font cursor-pointer\" style=\"padding-top: 10px;\"></i></div><br><br><h3 class=\"with-line margin-top-10px margin-bottom-10px\" style=\"margin-top:110px; width:98%; margin-left: auto; margin-right: auto;\"></h3></div></form>");
$templateCache.put("app/dashboard/businessPartner/template/location.html","<form name=\"vm.locationInfoForm\"><div class=\"row\"><div class=\"col-md-6 marginBottom10px\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.addBusinessAddress(vm.business)\">Add New Address</button></div></div><h3 class=\"with-line\">All Locations</h3><div ng-repeat=\"location in vm.business.locations\" class=\"row\"><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label for=\"locationAddress_{{$index}}\" class=\"col-sm-3 control-label\">Address</label><div class=\"col-sm-9\"><textarea ng-model=\"location.address\" style=\"height: 140px\" rows=\"10\" placeholder=\"Address\" class=\"form-control\" name=\"locationAddress_{{$index}}\" id=\"locationAddress_{{$index}}\">\n                            </textarea><ng-messages for=\"vm.locationInfoForm[\'locationAddress_{{$index}}\'].$error\" ng-if=\'(vm.locationInfoForm.$submitted && vm.locationInfoForm[\"locationAddress_\"+$index].$invalid) || (vm.locationInfoForm[\"locationAddress_\"+$index].$invalid && vm.locationInfoForm[\"locationAddress_\"+$index].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter valid address.</div></ng-messages></div></div></div><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Country</label><div class=\"col-sm-9\"><selectize placeholder=\"Country\" name=\"{{\'locationCountry_\'+$index}}\" ng-required=\"true\" config=\"vm.countryConfig\" options=\"vm.countryOptions.list\" ng-model=\"location.country\"></selectize><div ng-messages=\"vm.locationInfoForm[\'locationCountry_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.locationInfoForm.$submitted || vm.locationInfoForm[\"locationCountry_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter location country.</div></div></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">State</label><div class=\"col-sm-9\"><selectize placeholder=\"State\" ng-disabled=\"!location.country\" id=\"locationState_{{$index}}\" name=\"locationState_{{$index}}\" ng-required=\"true\" config=\"vm.stateConfig\" options=\"location.stateOptions.list\" ng-model=\"location.state\"></selectize><div ng-messages=\"vm.locationInfoForm[\'locationState_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.locationInfoForm.$submitted || vm.locationInfoForm[\"locationState_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter location state.</div></div></div></div><div class=\"form-group row clearfix\"><label for=\"locationCity_{{$index}}\" class=\"col-sm-3 control-label\">City</label><div class=\"col-sm-9\"><selectize placeholder=\"City\" ng-disabled=\"!location.country\" id=\"locationCity_{{$index}}\" name=\"locationCity_{{$index}}\" ng-required=\"true\" config=\"vm.cityConfig\" options=\"location.cityOptions.list\" ng-model=\"location.city\"></selectize><div ng-messages=\"vm.locationInfoForm[\'locationCity_\'+$index].$error\" class=\"ng-messages\" ng-show=\'(vm.locationInfoForm.$submitted || vm.locationInfoForm[\"locationCity_{{$index}}\"].$dirty)\'><div class=\"errorValidation\" ng-message=\"required\">Please enter location city.</div></div></div></div></div><div class=\"col-sm-2\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" ng-change=\"vm.isPrimaryChange(vm.business.locations, location, location.isPrimary, \'isPrimary\')\" ng-model=\"location.isPrimary\"> <span>Is Primary Address</span></label></div></div><div class=\"col-sm-2\"><i ng-click=\"vm.removeBusinessLocation(vm.business.locations, location)\" class=\"fa fa-trash primary-font cursor-pointer\" style=\"padding-top: 10px;\"></i></div><br><br><h3 class=\"with-line margin-top-10px margin-bottom-10px\" style=\"margin-top:100px; width:98%; margin-left: auto; margin-right: auto;\"></h3></div></form>");
$templateCache.put("app/dashboard/businessPartner/template/view.html","");
$templateCache.put("app/dashboard/localTradeBook/transaction/localTradebookForm.html","<div ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"with-scroll\"><form name=\"vm.localTransactionForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"with-line\">Transaction Information</h3><div class=\"row wizard-containers\"><div class=\"row\"><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Date</label><div class=\"\"><date-picker-input date=\"vm.localTransaction.date\" name=\"date\" required=\"true\"></date-picker-input><ng-messages for=\"vm.localTransactionForm.date.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.date.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter local trade date.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Buyer</label><div class=\"\"><selectize ng-required=\"true\" placeholder=\"Buyer\" name=\"buyer\" id=\"buyer\" config=\"vm.buyerConfig\" options=\"vm.buyerOptions.list\" ng-model=\"vm.localTransaction.buyerId\"></selectize><ng-messages for=\"vm.localTransactionForm.buyer.$error\" ng-if=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.buyer.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select Buyer</div><div class=\"errorValidation\" ng-message=\"validator\">Buyer and Seller can not be same</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Seller</label><div class=\"\"><selectize placeholder=\"Seller\" ng-required=\"true\" name=\"seller\" id=\"seller\" config=\"vm.sellerConfig\" options=\"vm.sellerOptions.list\" ng-model=\"vm.localTransaction.sellerId\"></selectize><ng-messages for=\"vm.localTransactionForm.seller.$error\" ng-if=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.seller.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select seller.</div><div class=\"errorValidation\" ng-message=\"validator\">Buyer and Seller can not be same</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Product Item</label><div class=\"\"><selectize ng-required=\"true\" name=\"productItem\" placeholder=\"Product Item\" id=\"productItem\" config=\"vm.productItemConfig\" options=\"vm.productItemOptions.list\" ng-model=\"vm.localTransaction.productItemId\"></selectize><ng-messages for=\"vm.localTransactionForm.productItem.$error\" ng-if=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.productItem.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter product item.</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Quantity <span class=\"titled\">FCL</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.localTransaction.quantityFCL\" class=\"form-control\" name=\"quantityFCL\" placeholder=\"Quantity\"><ng-messages for=\"vm.localTransactionForm.quantityFCL.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.quantityFCL.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter quantity FCL value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Quantity FCL can only have numbers.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Quantity <span class=\"titled\">MT</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.localTransaction.quantity\" class=\"form-control\" name=\"quantity\" placeholder=\"Quantity\"><ng-messages for=\"vm.localTransactionForm.quantity.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.quantity.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter quantity value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Quantity can only have numbers.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Price <span class=\"titled\">{{vm.currency + \' / MT\'}}</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.localTransaction.price\" class=\"form-control\" name=\"price\" placeholder=\"Price {{vm.currency}} / MT\"><ng-messages for=\"vm.localTransactionForm.price.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.price.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter price value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Price can only have numbers.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\">File ID</label><div class=\"\"><input ng-model=\"vm.localTransaction.fileId\" ng-required=\"true\" class=\"form-control\" name=\"fileId\" placeholder=\"Local Trade File Id\"><ng-messages for=\"vm.localTransactionForm.fileId.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.fileId.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter local trade file id.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\">Contract ID</label><div class=\"\"><input ng-model=\"vm.localTransaction.contractId\" class=\"form-control\" placeholder=\"Local Trade Contract Id\"></div></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\"><span class=\"titled\">Delivery Due</span> Date</label><div class=\"\"><date-picker-input date=\"vm.localTransaction.deliveryDueDate\" name=\"deliveryDueDate\" required=\"true\"></date-picker-input><ng-messages for=\"vm.localTransactionForm.deliveryDueDate.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.deliveryDueDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter local trade date.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\"><span class=\"titled\">Funds Due</span> Date</label><div class=\"\"><date-picker-input date=\"vm.localTransaction.fundsDueDate\" name=\"fundsDueDate\" required=\"true\"></date-picker-input><ng-messages for=\"vm.localTransactionForm.fundsDueDate.$error\" ng-show=\"(vm.localTransactionForm.$submitted || vm.localTransactionForm.fundsDueDate.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter funds due date.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\">International <span class=\"titled\">File ID</span></label><div class=\"\"><selectize ng-required=\"true\" name=\"internationalFileId\" placeholder=\"International File Id\" config=\"vm.internationalTradeConfig\" options=\"vm.internationalTradeOptions.list\" ng-model=\"vm.localTransaction.internationalFileId\"></selectize></div></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\">Local <span class=\"titled\">File ID</span></label><div class=\"\"><selectize ng-required=\"false\" name=\"internationalFileId\" placeholder=\"Local File Id\" config=\"vm.localTradeConfig\" options=\"vm.localTradeOptions.list\" ng-model=\"vm.localTransaction.localFileId\"></selectize></div></div><div class=\"form-group col-md-12 clearfix\"><label class=\"with-line control-label\">Other Information</label><div class=\"\"><textarea ng-model=\"vm.localTransaction.otherInfo\" class=\"form-control\">\n                                </textarea></div></div></div></div></div><div class=\"col-md-12\"><h3 class=\"with-line\">Payment Condition</h3><div class=\"row wizard-containers\"><div class=\"row\"><div class=\"form-group col-md-12 clearfix\"><div class=\"input-demo radio-demo row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" ng-model=\"vm.localTransaction.paymentTerm\" id=\"advance\" value=\"{{vm.paymentTerms.ADVANCE}}\"> <span>Advance</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" value=\"{{vm.paymentTerms.PRODUCT_DELIVERY}}\" ng-model=\"vm.localTransaction.paymentTerm\" id=\"productDelivery\"> <span>On Product Delivery</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" value=\"{{vm.paymentTerms.ON_DATE}}\" ng-model=\"vm.localTransaction.paymentTerm\" id=\"On Date\"> <span>On Specified Date</span><div class=\"form-group\" ng-show=\"vm.localTransaction.paymentTerms===vm.paymentTerms.ON_DATE\"><date-picker-input position=\"top-left\" date=\"vm.localTransaction.paymentDate\" name=\"paymentDate\"></date-picker-input></div></label></div></div></div></div></div></div></div><div class=\"row\"><button type=\"submit\" ng-click=\"vm.saveLocalTrade(vm.localTransactionForm, vm.localTransaction)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Save Local Trade</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div>");
$templateCache.put("app/dashboard/localTradeBook/transaction/localTransactionDelivery.html","");
$templateCache.put("app/dashboard/localTradeBook/transaction/localTransactionView.html","<div class=\"row\"><div class=\"col-md-12 marginBottom10px\"><button class=\"btn btn-primary\" ng-click=\"vm.createWatsappCopy(vm.transaction)\"><i class=\"fa fa-whatsapp\" aria-hidden=\"true\"></i> &nbsp;Copy for Whatsapp</button></div></div><div class=\"col-md-12 transactionView\"><div ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"with-scroll\"><div class=\"row transactionNo\"><div class=\"col-xs-12 col-md-12\"><br><button class=\"btn btn-xs btn-success pull-right\" ng-click=\"vm.editTransactionDetails(vm.transaction.fileId)\">Edit</button></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Transaction Date</h3><div ng-bind=\"vm.transaction.date | date: vm.appFormats.FullDate2\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">File No</h3><div ng-bind=\"vm.transaction.fileId\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Contract No</h3><div class=\"number\" ng-bind=\"vm.transaction.contractId ? vm.transaction.contractId : \'NA\'\"></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Price <span class=\"titled\">USD</span></h3><div ng-bind=\"vm.transaction.price | number: \'2\'\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Quantity <span class=\"titled\">FCL</span></h3><div ng-bind=\"vm.transaction.quantityFCL | number: \'2\'\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Quantity <span class=\"titled\">MT</span></h3><div ng-bind=\"vm.transaction.quantity | number: \'2\'\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Delivery Due Date</h3><div class=\"number\">{{vm.transaction.deliveryDueDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Funds Due Date</h3><div class=\"number\">{{vm.transaction.fundsDueDate | date: vm.appFormats.FullDate2}}</div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Buyer</h3><div class=\"countryFlag\"><div class=\"flag\"><img ng-if=\"vm.transaction.buyer.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.buyer.countryFlag}}\"> <img ng-if=\"!vm.transaction.buyer.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.buyer.countryFlag | countryLogo}}\"></div></div><div class=\"details\"><div class=\"number\">{{vm.transaction.buyer.name}}</div><div class=\"name\">{{vm.transaction.buyer.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Seller</h3><div class=\"countryFlag\"><img ng-if=\"vm.transaction.seller.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.seller.countryFlag}}\"> <img ng-if=\"!vm.transaction.seller.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.seller.countryFlag | countryLogo}}\"></div><div class=\"details\"><div class=\"number\">{{vm.transaction.seller.name}}</div><div class=\"name\">{{vm.transaction.seller.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Product</h3><div class=\"countryFlag\"><div class=\"flag\"><img width=\"45\" height=\"45\" src=\"{{vm.appConstants.HOST + \'/\' +vm.transaction.productItem.countryFlag}}\"></div></div><div class=\"details\"><div class=\"number\">{{vm.transaction.productItem.name}}</div><div class=\"name\">{{vm.transaction.productItem.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Buyer Broker</h3><div class=\"number number-space\" ng-if=\"!vm.transaction.commission.buyerBroker\">NA</div><div class=\"countryFlag\" ng-if=\"vm.transaction.commission.buyerBroker\"><div class=\"flag\"><img ng-if=\"vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.commission.buyerBroker.countryFlag}}\"> <img ng-if=\"!vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.commission.buyerBroker.countryFlag | countryLogo}}\"></div></div><div class=\"details\" ng-if=\"vm.transaction.commission.buyerBroker\"><div class=\"number\">{{vm.transaction.commission.buyerBroker.name}}</div><div class=\"name\">{{vm.transaction.commission.buyerBroker.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Seller Broker</h3><div class=\"number-space number\" ng-if=\"!vm.transaction.commission.sellerBroker\">NA</div><div class=\"countryFlag\" ng-if=\"vm.transaction.commission.sellerBroker\"><img ng-if=\"vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.commission.sellerBroker.countryFlag}}\"> <img ng-if=\"!vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.commission.sellerBroker.countryFlag | countryLogo}}\"></div><div class=\"details\" ng-if=\"vm.transaction.commission.sellerBroker\"><div class=\"number\">{{vm.transaction.commission.sellerBroker.name}}</div><div class=\"name\">{{vm.transaction.commission.sellerBroker.country}}</div></div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Status</h3><div class=\"number pull-right\" style=\"float:left;\" ng-if=\"vm.transaction.completeObj.isComplete\">{{vm.transaction.completeObj.completionDate | date: vm.appFormats.FullDate2}}</div><button class=\"btn btn-xs\" ng-class=\"{\'btn-danger\':!vm.transaction.completeObj.isComplete, \'btn-primary\':vm.transaction.completeObj.isComplete}\" ng-click=\"vm.changeCompleteStatus(vm.transactionId.completeObj, vm.transactionId)\">Complete</button></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Associated Local Trade</h3><div></div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Associated Internation Trades</h3><div></div></div><div class=\"col-xs-12 col-md-4\" ng-if=\"vm.transaction.onOurContract\"><h3 class=\"with-line\">Invoice</h3><button class=\"btn btn-xs btn-success pull-left cursor-pointer\" ng-click=\"vm.goToInvoice(vm.transaction.fileNo, vm.transaction.invoice.invoiceNo)\" ng-if=\"vm.transaction.invoice\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Invoice No:{{ vm.transaction.invoice.invoiceNo}}</button><div class=\"number pull-right\" ng-if=\"vm.transaction.invoice\"><span class=\"titled\" ng-bind=\"vm.transaction.businessCurrency\"></span> {{vm.transaction.invoice.invoiceAmount}}</div><button ng-if=\"vm.transaction.invoiceCreation\" class=\"btn btn-xs btn-success\" ng-click=\"vm.createTransactionInvoice(vm.transaction.fileNo)\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Create Invoice</button></div><div class=\"col-md-12 col-md-12\"><h3 class=\"with-line\">Other Information</h3><div class=\"number\" ng-bind=\"vm.transaction.otherInfo ? vm.transaction.otherInfo : \'NA\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"with-line\">Payments <button class=\"btn btn-xs btn-success\" ng-click=\"vm.addLocalPayment(vm.transaction.fileId)\">Add New</button></h3></div></div><div class=\"row\"><div class=\"col-md-8 col-xs-12\"><local-trade-delivery></local-trade-delivery></div><div class=\"col-md-4 col-xs-12\"><local-trade-payment></local-trade-payment></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Transaction Documents <button class=\"btn btn-xs btn-success\" ng-click=\"vm.addNewDocument()\">Add New</button></h3><div ng-show=\"vm.addingDocument\" class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group col-lg-4 col-xs-12\"><label>Document Name</label> <input class=\"form-control\" ng-model=\"vm.newDocumentName\" type=\"text\"><br><button class=\"btn btn-success btn-xs\" type=\"file\" ngf-select=\"vm.uploadTradeDocument($file, $invalidFiles)\" accept=\"*\"><i class=\"fa fa-upload\"></i> Upload</button></div></div></div><div class=\"row\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.transaction.files.length!==0\"><th><span class=\"count\">{{vm.transaction.files.length}}</span></th><th>Document Name</th><th>Uploaded By</th><th>Uploaded At</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.transaction.files.length===0\"><th>No Documents have been added for this transaction.</th></tr></thead><tbody><tr ng-repeat=\"doc in vm.transaction.files\"><td></td><td ng-bind=\"doc.fileName\"></td><td ng-bind=\"doc.uploadedBy\"></td><td ng-bind=\"doc.uploadedAt | date: vm.appFormats.date\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.downloadTradeDoc(doc.fileId, doc.fileName, doc.extension)\">Download</button> <button class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"vm.deleteTradeDoc(doc.fileId)\">Delete</button></div></td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Notes</h3><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"noteList\"><img ng-if=\"noteListLoading\" width=\"60\" height=\"60\" src=\"assets/img/loader.svg\"><div ng-if=\"!noteListLoading && (vm.transaction.notes.length === 0)\">No trade notes.</div><div class=\"col-xs-12\" ng-repeat=\"nte in vm.transaction.notes | orderBy: \'-createdAt\'\"><div class=\"col-xs-6 note\" ng-class=\"{\'pull-right\':nte.self, \'self\':nte.self, \'other\': !nte.self, \'editing\': nte.editing}\"><div class=\"col-xs-12 userData\"><img class=\"userImage\" ng-src=\"{{( nte.createdByPic | profilePicture )}}\"><div class=\"details\"><div class=\"name\">{{nte.createdBy}}</div><div class=\"date\">Note on: {{nte.createdAt | date:appFormats.Time }}</div><div class=\"date\" ng-if=\"nte.updatedAt\">Note Updated On: {{nte.updatedAt | date:appFormats.Time }}</div></div></div><div class=\"col-xs-12\">{{nte.note}}</div><div class=\"col-xs-12 button-bar\"><button class=\"btn btn-danger btn-xs pull-right\" ng-if=\"nte.self\" ng-click=\"vm.editTradeNote(nte.note, nte)\">Edit</button> <button class=\"btn btn-warning btn-xs pull-right\" ng-click=\"vm.deleteTradeNote(vm.transactionId, nte.noteId, nte, vm.transaction.notes)\" ng-if=\"nte.isDeleteAble\">Delete</button></div></div></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group col-md-12 clearfix\"><form name=\"vm.trade_note_form\" novalidate=\"\"><label class=\"col-sm-12 control-label\">Notes</label><div class=\"col-sm-12\"><textarea ng-if=\"!addingNote\" ng-required=\"true\" name=\"tradeNote\" ng-model=\"vm.noteText\" class=\"form-control\">\n                                                </textarea><ng-messages for=\"vm[\'trade_note_form_\'+row.id][\'tradeNote_\'+row.id].$error\" ng-if=\'(vm[\"trade_note_form_\"+row.id].$submitted || vm[\"trade_note_form_\"+row.id][\"tradeNote_\"+row.id].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter a trade note.</div></ng-messages></div><div class=\"col-sm-12\"><br><button class=\"btn btn-success editable-table-button btn-xs\" type=\"submit\" style=\"min-width: 115px;\" ng-click=\"vm.addTradeNote(vm.transactionId, vm.noteText, vm.transaction.notes, vm.trade_note_form)\"><span ng-if=\"addingNote\"><i class=\"fa fa-spinner fa-pulse fa-spin fa-3x fa-fw\"></i> <span class=\"sr-only\">Loading...</span> &nbsp;</span> <span ng-if=\"!vm.addingNote && !vm.updateNote\">Add Note</span> <span ng-if=\"vm.updateNote\">Update Note</span></button></div></form></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Change Logs</h3><div class=\"row\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\"><th><span class=\"count\">{{vm.transaction.changeLogs.length}}</span></th><th>Log Time</th><th>Change By</th><th>Log</th></tr></thead><tbody><tr ng-repeat=\"log in vm.transaction.changeLogs\"><td></td><td ng-bind=\"log.changeTime | date:vm.appFormats.Time\"></td><td ng-bind=\"log.changeByUserName\"></td><td ng-bind-html=\"log.description\"></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/manifest/template/itemForm.html","<form name=\"vm.manifestForm\" novalidate=\"\"><h3 class=\"with-line\"></h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"productItem\" class=\"col-sm-3 control-label\">Buyer</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" placeholder=\"Buyer\" name=\"buyer\" id=\"buyer\" config=\"vm.buyerConfig\" options=\"vm.buyerOptions.list\" ng-model=\"vm.manifestItem.buyerId\"></selectize><ng-messages for=\"vm.manifestForm.buyer.$error\" ng-if=\"(vm.manifestForm.$submitted && vm.manifestForm.buyer.$invalid) || (vm.manifestForm.buyer.$invalid && vm.manifestForm.buyer.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select Buyer</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"productItem\" class=\"col-sm-3 control-label\">Product Item</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" name=\"product\" placeholder=\"Product Item\" id=\"product\" config=\"vm.productConfig\" options=\"vm.productOptions.list\" ng-model=\"vm.manifestItem.productId\"></selectize><ng-messages for=\"vm.manifestForm.product.$error\" ng-if=\"(vm.manifestForm.$submitted && vm.manifestForm.product.$invalid) || (vm.manifestForm.product.$invalid && vm.manifestForm.product.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select product.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Date</label><div class=\"col-sm-9\"><div uib-datepicker=\"\" ng-model=\"vm.manifestItem.date\" class=\"calender margin-top-10px\" datepicker-options=\"options\"></div></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"productItem\" class=\"col-sm-3 control-label\">Seller</label><div class=\"col-sm-9\"><selectize placeholder=\"Seller\" ng-required=\"true\" name=\"productItem\" id=\"productItem\" config=\"vm.sellerConfig\" options=\"vm.sellerOptions.list\" ng-model=\"vm.manifestItem.sellerId\"></selectize><ng-messages for=\"vm.manifestForm.productItem.$error\" ng-if=\"(vm.manifestForm.$submitted && vm.manifestForm.productItem.$invalid) || (vm.manifestForm.productItem.$invalid && vm.manifestForm.productItem.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select seller.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"quantityMetric\" class=\"col-sm-3 control-label\">Quantity Metric</label><div class=\"col-sm-9\"><selectize ng-required=\"true\" placeholder=\"Quantity Metric\" name=\"quantityMetric\" id=\"quantityMetric\" config=\"vm.quantityMetricConfig\" options=\"vm.quantityMetricOptions.list\" ng-model=\"vm.manifestItem.quantityMetricId\"></selectize><ng-messages for=\"vm.manifestForm.quantityMetric.$error\" ng-if=\"(vm.manifestForm.$submitted && vm.manifestForm.quantityMetric.$invalid) || (vm.manifestForm.quantityMetric.$invalid && vm.manifestForm.quantityMetric.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter quantity metric.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Quantity ({{vm.marketPriceObj.priceMetricId ? vm.marketPriceObj.priceMetricId : \'FCL\' }})</label><div class=\"col-sm-9\"><input required=\"\" ng-pattern=\"/^[0-9]+$/i\" ng-model=\"vm.manifestItem.quantity\" class=\"form-control\" name=\"quantity\" placeholder=\"Quantity in {{vm.manifestItem.quantityMetricId}}\"><ng-messages for=\"vm.manifestForm.quantity.$error\" ng-show=\"(vm.manifestForm.$submitted && vm.manifestForm.quantity.$invalid) || (vm.manifestForm.quantity.$invalid && vm.manifestForm.quantity.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter price value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Quantity can only have numbers.</ng-message></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Container No.</label><div class=\"col-sm-9\"><input ng-model=\"vm.manifestItem.containerNo\" class=\"form-control\" name=\"containerNo\" placeholder=\"Container No.\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group row clearfix\"><label for=\"priceComments\" class=\"col-sm-3 control-label\">Comments</label><div class=\"col-sm-12\"><textarea ng-model=\"vm.manifestItem.comments\" placeholder=\"Comments\" class=\"form-control\" id=\"priceComments\">\n                        </textarea></div></div></div></div><button type=\"submit\" ng-if=\"!vm.manifestItem.id\" ng-click=\"vm.saveManifestItem(vm.manifestItem, vm.manifestForm, true)\" class=\"btn btn-success btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Manifest Item & Add Another</button> <button type=\"submit\" ng-if=\"!vm.manifestItem.id\" ng-click=\"vm.saveManifestItem(vm.manifestItem, vm.manifestForm)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add Manifest Item & Exit</button> <button type=\"submit\" ng-if=\"vm.manifestItem.id\" ng-click=\"vm.saveManifestItem(vm.manifestItem, vm.manifestForm)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Manifest Item</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></form>");
$templateCache.put("app/dashboard/settings/dashboardProducts/dashboardProducts.html","<div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Add New Transaction Status\" ba-panel-class=\"with-scroll\"><div><form class=\"row form-inline\" name=\"transactionStatus\"><div class=\"form-group col-sm-6 col-xs-6\"><input type=\"text\" class=\"form-control\" id=\"exampleInputName2\" placeholder=\"Name\"></div><button type=\"submit\" class=\"btn btn-primary\">Add</button> <button type=\"submit\" class=\"btn btn-default\">Clear</button></form></div></div><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"All Transaction Status\" ba-panel-class=\"with-scroll\"><div class=\"horizontal-scroll\"><table class=\"table\" st-table=\"smartTableData\"></table></div></div></div></div>");
$templateCache.put("app/dashboard/settings/templates/appDropDown.html","<div ba-panel=\"\" ba-panel-class=\"tabs-panel with-scroll\"><uib-tabset class=\"tabs-left\"><uib-tab ng-repeat=\"dropDown in vm.appDropDowns\" heading=\"{{dropDown.title}}\" ng-click=\"vm.getDropDownList(dropDown)\"><button class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"vm.openDropDownModal(\'Add New \' + dropDown.title, dropDown.endPoint, vm.page, \'md\', vm.modalController, null, null)\">Add New {{dropDown.title}}</button><br><br><table class=\"table\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"dropDown.list.length!==0\"><th>Drop Down Value</th><th>Created By</th><th>Created On</th><th>Updated By</th><th>Updated On</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"dropDown.list.length===0\"><th>No values have been added.</th></tr></thead><tbody><tr ng-repeat=\"row in dropDown.list\"><td ng-bind=\"row.name\"></td><td ng-bind=\"row.createdBy\"></td><td ng-bind=\"row.createdAt | date:vm.appFormats.Date\"></td><td>{{(!row.updatedBy) && \'Not Updated\' || row.updatedBy}}</td><td>{{(!row.updatedOn) && \'Not Updated\' || (row.updatedOn | date:vm.appFormats.Date)}}</td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.openDropDownModal(\'Edit \' + dropDown.title, dropDown.endPoint, vm.page, \'md\', vm.modalController, row.name, row.id)\">Edit</button></div></td></tr></tbody></table></uib-tab></uib-tabset></div>");
$templateCache.put("app/dashboard/settings/templates/businessDetails.html","<div><div class=\"panel-content\"><form name=\"vm.businessSettingsForm\"><div class=\"row\"><div class=\"container\"><div class=\"col-md-12\"><label>Website</label> <input type=\"text\" name=\"businessWebsite\" ng-pattern=\"/^(http:\\/\\/|https:\\/\\/)?[_a-z0-9]+(\\.[_a-z0-9]+)*[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,7})$/\" ng-model=\"vm.businessSettings.website\" class=\"form-control\" id=\"businessWebsite\" placeholder=\"Business Website\"><ng-messages for=\"vm.businessSettingsForm.businessWebsite.$error\" ng-if=\"(vm.businessSettingsForm.$submitted && vm.businessSettingsForm.businessWebsite.$invalid) || (vm.businessSettingsForm.businessWebsite.$invalid && vm.businessSettingsForm.businessWebsite.$dirty)\"><div ng-message=\"pattern\" class=\"errorValidation\">Please enter a valid website.</div></ng-messages></div></div><br><div class=\"container\"><div class=\"col-md-12\"><div class=\"form-group\"><button type=\"submit\" ng-click=\"vm.saveBusinessSettings(vm.businessSettingsForm, vm.businessSettings)\" class=\"btn btn-primary\">Save Business Settings</button></div></div></div></div></form></div></div>");
$templateCache.put("app/dashboard/settings/templates/changePassword.html","<div><div class=\"panel-content\"><form name=\"vm.changePassword\"><div class=\"row\"><div class=\"container\"><div class=\"col-md-12\"><label>Old Password</label> <input name=\"oldPassword\" type=\"password\" ng-model-options=\"{ updateOn: \'default blur\' }\" ng-model=\"vm.passwordDetails.oldPassword\" class=\"form-control\" oncopy=\"return false\" ondrag=\"return false\" ondrop=\"return false\" onpaste=\"return false\" placeholder=\"{{vm.inputFields.OldPassword.placeholder}}\" ng-required=\"true\"><ng-messages for=\"vm.changePassword.oldPassword.$error\" ng-if=\"vm.changePassword.oldPassword.$dirty || vm.changePassword.$submitted\"><div ng-message=\"required\" class=\"errorValidation\">{{::vm.inputFields.OldPassword.errorValidations.required}}</div></ng-messages></div></div><br><div class=\"container\"><div class=\"col-md-12\"><label>New Password</label> <input name=\"newPassword\" type=\"password\" ng-model-options=\"{ updateOn: \'default blur\' }\" ng-model=\"vm.passwordDetails.newPassword\" ng-pattern=\"/^(?=^.{8,32}$)(?=.*\\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&amp;*()_+}{&quot;:;\'?/&gt;.&lt;,])(?!.*\\s).*$/\" ng-minlength=\"{{vm.inputFields.NewPassword.minLength}}\" ng-maxlength=\"{{vm.inputFields.NewPassword.maxLength}}\" class=\"form-control\" oncopy=\"return false\" ondrag=\"return false\" ondrop=\"return false\" onpaste=\"return false\" placeholder=\"{{vm.inputFields.NewPassword.placeholder}}\" ng-required=\"true\"><ng-messages for=\"vm.changePassword.newPassword.$error\" ng-if=\"vm.changePassword.newPassword.$dirty || vm.changePassword.$submitted\"><div ng-message=\"required\" class=\"errorValidation\">{{::vm.inputFields.NewPassword.errorValidations.required}}</div><div class=\"errorValidation\" ng-message=\"pattern\">{{::vm.inputFields.NewPassword.errorValidations.pattern}}</div></ng-messages></div></div><br><div class=\"container\"><div class=\"col-md-12\"><label>Confirm Password</label> <input name=\"confirmPassword\" type=\"password\" ng-model-options=\"{ updateOn: \'default blur\' }\" ng-model=\"vm.passwordDetails.confirmPassword\" class=\"form-control\" oncopy=\"return false\" ondrag=\"return false\" ondrop=\"return false\" onpaste=\"return false\" ui-validate=\"\'$value===vm.changePassword.newPassword.$viewValue\'\" ui-validate-watch=\"\'vm.passwordDetails.newPassword\'\" placeholder=\"{{vm.inputFields.ConfirmPassword.placeholder}}\" ng-required=\"true\"><ng-messages for=\"vm.changePassword.confirmPassword.$error\" ng-if=\"vm.changePassword.confirmPassword.$dirty || vm.changePassword.$submitted\"><div ng-message=\"required\" class=\"errorValidation\">{{::vm.inputFields.ConfirmPassword.errorValidations.required}}</div><div class=\"errorValidation\" ng-message=\"validator\">{{::vm.inputFields.ConfirmPassword.errorValidations.validator}}</div></ng-messages></div></div><br><div class=\"container\"><div class=\"col-md-12\"><div class=\"form-group\"><button type=\"submit\" ng-click=\"vm.changePasswordSubmit(vm.changePassword, vm.passwordDetails)\" class=\"btn btn-primary\">Change Password</button></div></div></div></div></form></div></div>");
$templateCache.put("app/dashboard/tradeBook/businessAnalytics/businessAnalytics.html","<filter-bar date-picker-needed=\"true\" page=\"tradeBook\" buyer=\"true\" seller=\"true\" product-items=\"true\" date-picker=\"vm.dateRange\" on-date-change=\"vm.onDateRangeChanged(dateRange, false)\" on-buyers-selected-changed=\"vm.onBuyersSelectedChanged(selectedList, initialized)\" on-sellers-selected-changed=\"vm.onSellersSelectedChanged(selectedList, initialized)\" on-product-item-selected-changed=\"vm.onProductsSelectedChanged(selectedList, initialized)\"></filter-bar><div class=\"tradeDashboard\"><div ba-panel=\"\"><div ba-panel=\"\" class=\"number-count col-lg-4 col-sm-12\"><div class=\"description\"><div class=\"title\">Quantity</div><div class=\"big-number\" ng-bind=\"\"></div></div></div><div ba-panel=\"\" class=\"number-count col-lg-4 col-sm-12\"><div class=\"description\"><div class=\"title\">Volume</div><div class=\"big-number\" ng-bind=\"\"></div></div></div><div ba-panel=\"\" class=\"number-count col-lg-4 col-sm-12\"><div class=\"description\"><div class=\"title\">Expected Commission</div><div class=\"big-number\" ng-bind=\"\"></div></div></div></div><div ba-panel=\"\"><div class=\"col-md-12\"><pie-chart id=\"bpProduct\" data=\"vm.dashboardData.businessProductReport\"></pie-chart></div><div class=\"col-md-12\"><pie-chart id=\"bpProduct\" data=\"vm.dashboardData.businessProductReport\"></pie-chart></div><div class=\"col-md-12\"><pie-chart id=\"bpProduct\" data=\"vm.dashboardData.businessProductReport\"></pie-chart></div></div></div>");
$templateCache.put("app/dashboard/tradeBook/tradeDashboard/tradeDashboard.html","<div class=\"row tradeDashboard\"><div ba-panel=\"\" class=\"col-lg-12 col-xs-12\" ba-panel-title=\"International Trades Dashboard\"><div class=\"panel-content\"><div class=\"col-md-12\"><div class=\"trade-count\"><div ba-panel=\"\"><div class=\"col-md-2 col-md-offset-1 item\"><div class=\"chart\" id=\"chart1\" rel=\"{{ ::vm.dashboardColors.colors.success }}\" data-percent=\"{{vm.dashboardData.tradesCount.percentageCompleted}}\"><span class=\"percent\"></span></div><div class=\"description col-xs-12\"><div class=\"title\">Total Trades</div><div class=\"description-stats\">{{::vm.dashboardData.tradesCount.total}}</div><div class=\"title\">Completed</div><div class=\"description-stats success\">{{::vm.dashboardData.tradesCount.completed}}</div></div></div><div class=\"col-md-2 item\"><div class=\"chart\" id=\"chart1\" rel=\"{{ ::vm.dashboardColors.colors.warning }}\" data-percent=\"{{vm.dashboardData.washoutCount.washoutPercentage}}\"><span class=\"percent\"></span></div><div class=\"description col-xs-12\"><div class=\"title\">Washout at X</div><div class=\"description-stats\">{{::vm.dashboardData.washoutCount.washoutAtXCount}}</div><div class=\"title\">Washout</div><div class=\"description-stats warning\">{{::vm.dashboardData.washoutCount.washoutCount}}</div></div></div><div class=\"col-md-2 item\"><div class=\"chart\" id=\"chart1\" rel=\"{{ ::vm.dashboardColors.colors.primary }}\" data-percent=\"{{vm.dashboardData.contractCount.percentageOwnContractCount}}\"><span class=\"percent\"></span></div><div class=\"description col-xs-12\"><div class=\"title\">Self Contract</div><div class=\"description-stats\">{{::vm.dashboardData.contractCount.selfContractCount}}</div><div class=\"title\">Buyer Contract</div><div class=\"description-stats primary\">{{::vm.dashboardData.contractCount.ownContractCount}}</div></div></div><div class=\"col-md-2 item\"><div class=\"chart\" id=\"chart1\" rel=\"{{ ::vm.dashboardColors.colors.info }}\" data-percent=\"{{vm.dashboardData.commissionCount.percentagePercentageCommission}}\"><span class=\"percent\"></span></div><div class=\"description col-xs-12\"><div class=\"title\">Fixed Commission</div><div class=\"description-stats\">{{::vm.dashboardData.commissionCount.fixedCount}}</div><div class=\"title\">Percentage Commission</div><div class=\"description-stats info\">{{::vm.dashboardData.commissionCount.percentageCount}}</div></div></div><div class=\"col-md-2 item\"><div class=\"chart\" id=\"chart1\" rel=\"{{ ::vm.dashboardColors.colors.danger }}\" data-percent=\"{{vm.dashboardData.subTrades.secondaryTradePercentage}}\"><span class=\"percent\"></span></div><div class=\"description col-xs-12\"><div class=\"title\">Partial Shipments</div><div class=\"description-stats\">{{::vm.dashboardData.subTrades.partialShipmentCount}}</div><div class=\"title\">Secondary Transactions</div><div class=\"description-stats danger\">{{::vm.dashboardData.subTrades.secondaryTradeCount}}</div></div></div></div></div></div><div class=\"col-md-12\"><div ba-panel=\"\" class=\"number-count col-md-3\"><div class=\"description\"><div class=\"title\">Un Resolved Trade Disputes</div><div class=\"big-number\" ng-bind=\"vm.dashboardData.tradeDisputeCount\"></div><div class=\"button-row\"><button ng-click=\"vm.showTrades(\'tradeDispute\', \'Un Resolved Trade Disputes\')\" class=\"btn btn-xs btn-danger\">Show Trades</button></div></div></div><div ba-panel=\"\" class=\"number-count col-md-3\"><div class=\"description\"><div class=\"title\">Arrived But Not Completed</div><div class=\"big-number\" ng-bind=\"vm.dashboardData.arrivedNotCompletedCount\"></div><div class=\"button-row\"><button ng-click=\"vm.showTrades(\'arrivedList\', \'Arrived at Port\')\" class=\"btn btn-xs btn-danger\">Show Trades</button></div></div></div><div ba-panel=\"\" class=\"number-count col-md-3\"><div class=\"description\"><div class=\"title\">Expected Arrival</div><div class=\"big-number\" ng-bind=\"vm.dashboardData.expectedArrivalCount\"></div><div class=\"button-row\"><button ng-click=\"vm.showTrades(\'expectedArrival\', \'Expected Arrival\')\" class=\"btn btn-xs btn-danger\">Show Trades</button></div></div></div><div ba-panel=\"\" class=\"number-count col-md-3\"><div class=\"description\"><div class=\"title\">Shipment Expiration</div><div class=\"big-number\" ng-bind=\"vm.dashboardData.notShippedCount\"></div><div class=\"button-row\"><button ng-click=\"vm.showTrades(\'next30DaysExpiration\', \'Next 30 Days\')\" class=\"btn btn-xs btn-warning\">In Next 30 Days</button> <button ng-click=\"vm.showTrades(\'expiredShipment\', \'Shipment Expired At Port\')\" class=\"btn btn-xs btn-danger\">Expired</button></div></div></div></div><div class=\"col-md-12 chartist\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div id=\"multi-bar\" class=\"ct-chart\"></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/tradeBook/transaction/transaction.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"with-scroll\" ng-if=\"vm.showForm\"><form name=\"vm.transactionForm\" novalidate=\"\"><div ng-include=\"\'app/dashboard/tradeBook/transaction/templates/basic.html\'\"></div><div ng-include=\"\'app/dashboard/tradeBook/transaction/templates/commission.html\'\"></div><div class=\"row\"><button type=\"submit\" ng-if=\"!vm.transaction.id\" ng-click=\"vm.addTransaction(vm.transactionForm, vm.transaction)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Add New Transaction</button> <button type=\"submit\" ng-if=\"vm.transaction.id\" ng-click=\"vm.updateTransaction(vm.transactionForm, vm.transaction)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Update Transaction</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div></div></div>");
$templateCache.put("app/dashboard/tradeBook/transaction/transactionView.html","<div class=\"row\"><div class=\"col-md-12 marginBottom10px\"><button class=\"btn btn-primary\" ng-click=\"vm.createWatsappCopy(vm.transaction)\"><i class=\"fa fa-whatsapp\" aria-hidden=\"true\"></i> &nbsp;Copy for Watsapp</button> <button class=\"btn btn-primary\" ng-click=\"vm.showTradeCashFlow(vm.transaction.basic.fileNo)\"><i class=\"fa fa-money\" aria-hidden=\"true\"></i> &nbsp;Cash Flow</button></div></div><div class=\"col-md-12 transactionView\"><div ba-panel=\"\" ba-panel-title=\"\" ba-panel-class=\"with-scroll\"><div class=\"row transactionNo\"><div class=\"col-xs-12 col-md-12\"><br><button class=\"btn btn-xs btn-success pull-right\" style=\"margin-left: 10px\" ng-click=\"vm.editTransactionDetails(vm.transaction.basic.fileNo)\">Edit</button></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Transaction Date</h3><div ng-bind=\"vm.transaction.basic.date | date: vm.appFormats.FullDate2\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">File No</h3><div ng-bind=\"vm.transaction.basic.fileNo\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Contract No</h3><div class=\"number\" ng-bind=\"vm.transaction.basic.contractNo ? vm.transaction.basic.contractNo : \'NA\'\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Price <span class=\"titled\">USD</span></h3><div ng-bind=\"vm.transaction.basic.price | number: \'2\'\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Quantity <span class=\"titled\">MT</span></h3><div ng-bind=\"vm.transaction.commission.quantity | number: \'2\'\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-2\"><h3 class=\"with-line\">Expected Commission</h3><div ng-bind=\"\'USD \' + (vm.transaction.commission.expectedCommission | number : 2)\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-1\"><h3 class=\"with-line\">Actual Commission</h3><div class=\"number\" ng-if=\"!vm.transaction.commission.quantityShipped\">NA</div><div ng-if=\"vm.transaction.commission.quantityShipped\" ng-bind=\"\'USD \' + (vm.transaction.commission.actualCommission | number : 2)\" class=\"number\"></div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Shipment</h3><div class=\"number\">{{vm.transaction.basic.shipmentStart | date: vm.appFormats.FullDate2}} - {{vm.transaction.basic.shipmentEnd | date: vm.appFormats.FullDate2}}</div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Buyer</h3><div class=\"countryFlag\"><div class=\"flag\"><img ng-if=\"vm.transaction.basic.buyer.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.basic.buyer.countryFlag}}\"> <img ng-if=\"!vm.transaction.basic.buyer.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.basic.buyer.countryFlag | countryLogo}}\"></div></div><div class=\"details\"><div class=\"number\">{{vm.transaction.basic.buyer.name}}</div><div class=\"name\">{{vm.transaction.basic.buyer.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Seller</h3><div class=\"countryFlag\"><img ng-if=\"vm.transaction.basic.seller.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.basic.seller.countryFlag}}\"> <img ng-if=\"!vm.transaction.basic.seller.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.basic.seller.countryFlag | countryLogo}}\"></div><div class=\"details\"><div class=\"number\">{{vm.transaction.basic.seller.name}}</div><div class=\"name\">{{vm.transaction.basic.seller.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Contractual Buyer</h3><div class=\"countryFlag\"><div class=\"flag\"><img ng-if=\"vm.transaction.basic.contractualBuyer.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.basic.contractualBuyer.countryFlag}}\"> <img ng-if=\"!vm.transaction.basic.contractualBuyer.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.basic.contractualBuyer.countryFlag | countryLogo}}\"></div></div><div class=\"details\"><div class=\"number\">{{vm.transaction.basic.contractualBuyer.name}}</div><div class=\"name\">{{vm.transaction.basic.contractualBuyer.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Product</h3><div class=\"countryFlag\"><div class=\"flag\"><img width=\"45\" height=\"45\" src=\"{{vm.appConstants.HOST + \'/\' +vm.transaction.basic.productItem.countryFlag}}\"></div></div><div class=\"details\"><div class=\"number\">{{vm.transaction.basic.productItem.name}}</div><div class=\"name\">{{vm.transaction.basic.productItem.country}} | {{vm.transaction.basic.productItem.keyword}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Buyer Broker</h3><div class=\"number number-space\" ng-if=\"!vm.transaction.commission.buyerBroker\">NA</div><div class=\"countryFlag\" ng-if=\"vm.transaction.commission.buyerBroker\"><div class=\"flag\"><img ng-if=\"vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.commission.buyerBroker.countryFlag}}\"> <img ng-if=\"!vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.commission.buyerBroker.countryFlag | countryLogo}}\"></div></div><div class=\"details\" ng-if=\"vm.transaction.commission.buyerBroker\"><div class=\"number\">{{vm.transaction.commission.buyerBroker.name}}</div><div class=\"name\">{{vm.transaction.commission.buyerBroker.country}}</div></div></div><div class=\"col-xs-12 col-md-2 height-120px\"><h3 class=\"with-line\">Seller Broker</h3><div class=\"number-space number\" ng-if=\"!vm.transaction.commission.sellerBroker\">NA</div><div class=\"countryFlag\" ng-if=\"vm.transaction.commission.sellerBroker\"><img ng-if=\"vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.appConstants.STATIC_URL + \'/\' +vm.transaction.commission.sellerBroker.countryFlag}}\"> <img ng-if=\"!vm.transaction.commission.buyerBroker.countryFlag\" width=\"45\" height=\"45\" src=\"{{vm.transaction.commission.sellerBroker.countryFlag | countryLogo}}\"></div><div class=\"details\" ng-if=\"vm.transaction.basic.commission.sellerBroker\"><div class=\"number\">{{vm.transaction.commission.sellerBroker.name}}</div><div class=\"name\">{{vm.transaction.commission.sellerBroker.country}}</div></div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Status</h3><div class=\"number pull-right\" style=\"float:left;\" ng-if=\"vm.transaction.completeObj.isComplete\">{{vm.transaction.completeObj.completionDate | date: vm.appFormats.FullDate2}}</div><button class=\"btn btn-xs\" ng-class=\"{\'btn-danger\':!vm.transaction.completeObj.isComplete, \'btn-primary\':vm.transaction.completeObj.isComplete}\" ng-click=\"vm.changeCompleteStatus(vm.transactionId.completeObj, vm.transactionId)\">Complete</button></div><div class=\"col-xs-12 col-md-4\" ng-if=\"vm.transaction.onOurContract\"><h3 class=\"with-line\">Invoice</h3><button class=\"btn btn-xs btn-success pull-left cursor-pointer\" ng-click=\"vm.goToInvoice(vm.transaction.basic.fileNo, vm.transaction.invoice.invoiceNo)\" ng-if=\"vm.transaction.invoice\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Invoice No:{{ vm.transaction.invoice.invoiceNo}}</button><div class=\"number pull-right\" ng-if=\"vm.transaction.invoice\"><span class=\"titled\" ng-bind=\"vm.transaction.businessCurrency\"></span> {{vm.transaction.invoice.invoiceAmount}}</div><button ng-if=\"vm.transaction.invoiceCreation\" class=\"btn btn-xs btn-success\" ng-click=\"vm.createTransactionInvoice(vm.transaction.basic.fileNo)\"><i class=\"fa fa-list-alt\" aria-hidden=\"true\"></i> Create Invoice</button></div><div class=\"col-md-12 col-md-12\"><h3 class=\"with-line\">Other Information</h3><div class=\"number\" ng-bind=\"vm.transaction.basic.otherInfo ? vm.transaction.basic.otherInfo : \'NA\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><div class=\"row\"><div class=\"col-md-4 col-xs-12\"><trade-wash-out-card trade=\"vm.transaction\"></trade-wash-out-card><br><trade-dispute-card trade=\"vm.transaction\"></trade-dispute-card></div><div class=\"col-md-8 col-xs-12\"><commission-card commission=\"vm.transaction.commission\"></commission-card></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Transaction Documents <button class=\"btn btn-xs btn-success\" ng-click=\"vm.addNewDocument()\">Add New</button></h3><div ng-show=\"vm.addingDocument\" class=\"row\"><div class=\"col-lg-12\"><div class=\"form-group col-lg-4 col-xs-12\"><label>Document Name</label> <input class=\"form-control\" ng-model=\"vm.newDocumentName\" type=\"text\"><br><button class=\"btn btn-success btn-xs\" type=\"file\" ngf-select=\"vm.uploadTradeDocument($file, $invalidFiles)\" accept=\"*\"><i class=\"fa fa-upload\"></i> Upload</button></div></div></div><div class=\"row\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\" ng-if=\"vm.transaction.files.length!==0\"><th><span class=\"count\">{{vm.transaction.files.length}}</span></th><th>Document Name</th><th>Uploaded By</th><th>Uploaded At</th><th>Actions</th></tr><tr class=\"table-header\" ng-if=\"vm.transaction.files.length===0\"><th>No Documents have been added for this transaction.</th></tr></thead><tbody><tr ng-repeat=\"doc in vm.transaction.files\"><td></td><td ng-bind=\"doc.fileName\"></td><td ng-bind=\"doc.uploadedBy\"></td><td ng-bind=\"doc.uploadedAt | date: vm.appFormats.date\"></td><td><div class=\"buttons\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"vm.downloadTradeDoc(doc.fileId, doc.fileName, doc.extension)\">Download</button> <button class=\"btn btn-warning editable-table-button btn-xs\" ng-click=\"vm.deleteTradeDoc(doc.fileId)\">Delete</button></div></td></tr></tbody></table></div></div></div></div></div><div class=\"row shipment\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Shipment</h3><div class=\"row shipmentCard\"><div class=\"tab-container\"><div class=\"col-md-3 col-xs-12\"><div class=\"button tab\" ng-class=\"{\'active\': vm.transaction.shipment.notShipped.active}\"><button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.NOT_SHIPPED, true, vm.transactionId)\" ng-show=\"!vm.transaction.shipment.notShipped.active\" class=\"btn btn-xs btn-success activate\">Activate</button> <button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.NOT_SHIPPED, false, vm.transactionId)\" ng-show=\"vm.transaction.shipment.notShipped.active\" class=\"btn btn-xs btn-warning activate\">Deactivate</button> Not Shipped&nbsp;<i class=\"fa fa-ship\" aria-hidden=\"true\"></i> <button class=\"btn-xs btn btn-primary edit-button\" ng-show=\"!vm.showNotShippedForm\" ng-click=\"vm.showNotShippedForm = true;\">Edit</button></div><div class=\"detail\" ng-show=\"!vm.showNotShippedForm\"><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">Reason</h3><div class=\"number\">{{vm.transaction.shipment.notShipped.reason ? vm.transaction.shipment.notShipped.reason : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">Shipment Extension</h3><div class=\"number\">{{vm.transaction.shipment.notShipped.shipmentExtension ? (vm.transaction.shipment.notShipped.shipmentExtension | date: vm.appFormats.FullDate2) : \'NA\'}}</div></div></div><div class=\"form\" ng-if=\"vm.showNotShippedForm\"><form name=\"vm.notShippedForm\" novalidate=\"\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Shipment Extension</label><date-picker-input date=\"vm.transaction.shipment.notShipped.shipmentExtension\" name=\"date\"></date-picker-input></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Reason</label> <textarea type=\"text\" rows=\"3\" class=\"form-control\" ng-model=\"vm.transaction.shipment.notShipped.reason\" placeholder=\"Reason for Not Shipped\">\n                                            </textarea></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"vm.editNotShipped(vm.notShippedForm, vm.transaction.shipment.notShipped, vm.transactionId)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Update Not Shipped Info</button> <button type=\"button\" ng-click=\"vm.cancelShipmentForm(\'showNotShippedForm\')\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"button tab\" ng-class=\"{\'active\': vm.transaction.shipment.approbationReceived.active }\"><button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.APPROBATION_RECEIVED, true, vm.transactionId)\" ng-show=\"!vm.transaction.shipment.approbationReceived.active\" class=\"btn btn-xs btn-success activate\">Activate</button> <button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.APPROBATION_RECEIVED, false, vm.transactionId)\" ng-show=\"vm.transaction.shipment.approbationReceived.active\" class=\"btn btn-xs btn-warning activate\">Deactivate</button> Approbation Received &nbsp;<i class=\"fa fa-ship\" aria-hidden=\"true\"></i> <button class=\"btn-xs btn btn-primary edit-button\" ng-show=\"!vm.showApprobationRecievedForm\" ng-click=\"vm.showApprobationRecievedForm = true;\">Edit</button></div><div class=\"detail\" ng-show=\"!vm.showApprobationRecievedForm\"><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">Expected Shipment</h3><div class=\"number\">{{vm.transaction.shipment.approbationReceived.expectedShipment ? (vm.transaction.shipment.approbationReceived.expectedShipment | date: vm.appFormats.FullDate2) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">In Transit</h3><div class=\"number\">{{vm.transaction.shipment.approbationReceived.inTransit ? (vm.transaction.shipment.approbationReceived.inTransit | date: vm.appFormats.FullDate2) : \'NA\'}}</div></div></div><div class=\"form\" ng-if=\"vm.showApprobationRecievedForm\"><form name=\"vm.approbationRecievedForm\" novalidate=\"\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Expected Shipment</label><date-picker-input blank=\"true\" date=\"vm.transaction.shipment.approbationReceived.expectedShipment\" name=\"date\"></date-picker-input></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">In Transit</label><date-picker-input blank=\"true\" date=\"vm.transaction.shipment.approbationReceived.inTransit\" name=\"date\"></date-picker-input></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"vm.editApprobationReceived(vm.approbationRecievedForm, vm.transaction.shipment.approbationReceived, vm.transactionId)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Update Approbation Recieved Info</button> <button type=\"button\" ng-click=\"vm.cancelShipmentForm(\'showApprobationRecievedForm\')\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"button tab\" ng-class=\"{\'active\': vm.transaction.shipment.shipped.active }\"><button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.SHIPPED, true, vm.transactionId)\" ng-show=\"!vm.transaction.shipment.shipped.active\" class=\"btn btn-xs btn-success activate\">Activate</button> <button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.SHIPPED, false, vm.transactionId)\" ng-show=\"vm.transaction.shipment.shipped.active\" class=\"btn btn-xs btn-warning activate\">Deactivate</button> Shipped <i class=\"fa fa-ship\" aria-hidden=\"true\"></i> <button ng-click=\"vm.showShippedForm = true;\" ng-show=\"!vm.showShippedForm\" class=\"btn-xs btn btn-primary edit-button\">Edit</button></div><div class=\"detail\" ng-show=\"!vm.showShippedForm\"><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">Shipper</h3><div class=\"number\">{{vm.transaction.shipment.shipped.shipper ? (vm.transaction.shipment.shipped.shipper.name + \' - \' + vm.transaction.shipment.shipped.shipper.country ) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Seller Invoice No.</h3><div class=\"number\">{{vm.transaction.shipment.shipped.sellerInvoiceNo ? ( vm.transaction.shipment.shipped.sellerInvoiceNo | uppercase) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Invoice Amount <span class=\"titled\">USD</span></h3><div class=\"number\">{{vm.transaction.shipment.shipped.sellerInvoiceAmount ? ( vm.transaction.shipment.shipped.sellerInvoiceAmount | number: \'2\') : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Date Shipped</h3><div class=\"number\">{{vm.transaction.shipment.shipped.shippedOn ? (vm.transaction.shipment.shipped.shippedOn | date: vm.appFormats.FullDate2) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Expected Arrival</h3><div class=\"number\">{{vm.transaction.shipment.shipped.expectedArrival ? (vm.transaction.shipment.shipped.expectedArrival | date: vm.appFormats.FullDate2) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">Transit Ports</h3><div class=\"port-transit\" ng-if=\"vm.transaction.shipment.shipped.transitPorts.length===0\">NA</div><div class=\"port-transit\" ng-if=\"vm.transaction.shipment.shipped.transitPorts.length!==0\" ng-repeat=\"port in vm.transaction.shipment.shipped.transitPorts | orderBy : \'-date\'\">{{port.lo_code + \' - \' + port.name + \' - \' + port.country + \' - \' + ( port.date | date: vm.appFormats.FullDate2)}}</div></div><div class=\"col-xs-12 col-md-6\"></div></div><div class=\"form\" ng-if=\"vm.showShippedForm\"><form name=\"vm.shippedForm\" novalidate=\"\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Seller Invoice No.</label> <input class=\"form-control\" placeholder=\"Seller Invoice No.\" ng-model=\"vm.transaction.shipment.shipped.sellerInvoiceNo\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Invoice Amount <span class=\"titled\">USD</span></label> <input class=\"form-control\" placeholder=\"Seller Invoice Amount\" ng-model=\"vm.transaction.shipment.shipped.sellerInvoiceAmount\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Shipper</label><selectize placeholder=\"Shipper\" name=\"shipper\" id=\"shipper\" config=\"vm.shipperConfig\" options=\"vm.shipperOptions.list\" ng-model=\"vm.transaction.shipment.shipped.shipper.id\"></selectize></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Date Shipped</label><date-picker-input blank=\"false\" date=\"vm.transaction.shipment.shipped.shippedOn\" name=\"date\"></date-picker-input></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Expected Arrival</label><date-picker-input blank=\"false\" date=\"vm.transaction.shipment.shipped.expectedArrival\" name=\"date\"></date-picker-input></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"with-line\">Transit Ports</label><tags-input ng-model=\"vm.transaction.shipment.shipped.transitPorts\" placeholder=\"Add a port\" template=\"port-tag-template\" key-property=\"id\" display-property=\"name\" text=\"name\" add-from-autocomplete-only=\"true\" add-on-paste=\"false\"><auto-complete template=\"port-auto-complete-template\" source=\"vm.loadPorts($query)\"></auto-complete></tags-input></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"vm.editShipped(vm.shippedForm, vm.transaction.shipment.shipped, vm.transactionId)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Update Shipped Info</button> <button type=\"button\" ng-click=\"vm.cancelShipmentForm(\'showShippedForm\')\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div><div class=\"col-md-3 col-xs-12\"><div class=\"button tab\" ng-class=\"{\'active\': vm.transaction.shipment.arrivedAtPort.active }\"><button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.ARRIVED_AT_PORT, true, vm.transactionId)\" ng-show=\"!vm.transaction.shipment.arrivedAtPort.active\" class=\"btn btn-xs btn-success activate\">Activate</button> <button ng-click=\"vm.activateShipmentStatus(vm.shipmentStatus.ARRIVED_AT_PORT, false, vm.transactionId)\" ng-show=\"vm.transaction.shipment.arrivedAtPort.active\" class=\"btn btn-xs btn-warning activate\">Deactivate</button> Arrived at Port &nbsp;<i class=\"fa fa-ship\" aria-hidden=\"true\"></i> <button ng-show=\"!vm.showArrivedAtPort\" ng-click=\"vm.showArrivedAtPort=true;\" class=\"btn-xs btn btn-primary edit-button\">Edit</button></div><div class=\"detail\" ng-show=\"!vm.showArrivedAtPort\"><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">B/L No.</h3><div class=\"number\">{{vm.transaction.shipment.arrivedAtPort.blNo ? vm.transaction.shipment.arrivedAtPort.blNo : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Date Arrived</h3><div class=\"number\">{{vm.transaction.shipment.arrivedAtPort.dateArrived ? (vm.transaction.shipment.arrivedAtPort.dateArrived | date: vm.appFormats.FullDate2) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Quantity Shipped</h3><div class=\"number\">{{vm.transaction.shipment.arrivedAtPort.quantityShipped ? (vm.transaction.shipment.arrivedAtPort.quantityShipped | number : \'2\') + \' MT\' : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Shipping Line</h3><div class=\"number\">{{vm.transaction.shipment.arrivedAtPort.shippingLine.id ? vm.transaction.shipment.arrivedAtPort.shippingLine.name : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Vessel No.</h3><div class=\"number\">{{(vm.transaction.shipment.arrivedAtPort.vessel.length > 0) ? (vm.transaction.shipment.arrivedAtPort.vessel[0].imo_number +\' - \' + vm.transaction.shipment.arrivedAtPort.vessel[0].first_name) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-4\"><h3 class=\"with-line\">Voyage No.</h3><div class=\"number\">{{(vm.transaction.shipment.arrivedAtPort.voyageNo) ? vm.transaction.shipment.arrivedAtPort.voyageNo : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-12\"><h3 class=\"with-line\">Containers <span class=\"count\" ng-bind=\"vm.transaction.shipment.arrivedAtPort.containers ? vm.transaction.shipment.arrivedAtPort.containers.length : 0\"></span></h3><div class=\"number\" ng-if=\"vm.transaction.shipment.arrivedAtPort.containers.length===0\">NA</div><div class=\"port-transit\" ng-if=\"vm.transaction.shipment.arrivedAtPort.containers.length!==0\" ng-repeat=\"container in vm.transaction.shipment.arrivedAtPort.containers\">Container No. {{ container.containerNo}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Port of Loading</h3><div class=\"number\">{{vm.transaction.shipment.arrivedAtPort.loadingPort.id ? (vm.transaction.shipment.arrivedAtPort.loadingPort.name + \', \' + vm.transaction.shipment.arrivedAtPort.loadingPort.country) : \'NA\'}}</div></div><div class=\"col-xs-12 col-md-6\"><h3 class=\"with-line\">Port of Destination</h3><div class=\"number\">{{vm.transaction.shipment.arrivedAtPort.destinationPort.id ? (vm.transaction.shipment.arrivedAtPort.destinationPort.name + \', \' + vm.transaction.shipment.arrivedAtPort.destinationPort.country) : \'NA\'}}</div></div></div><div class=\"form\" ng-if=\"vm.showArrivedAtPort\"><form name=\"vm.arrivedAtPortForm\" novalidate=\"\"><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">B/L No.</label> <input type=\"text\" rows=\"3\" class=\"form-control\" ng-model=\"vm.transaction.shipment.arrivedAtPort.blNo\" placeholder=\"Enter BL No.\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Date Arrived</label><date-picker-input required=\"false\" blank=\"false\" date=\"vm.transaction.shipment.arrivedAtPort.dateArrived\" name=\"date\"></date-picker-input></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Quantity Shipped <span class=\"titled\">MT</span></label> <input type=\"text\" rows=\"3\" class=\"form-control\" ng-model=\"vm.transaction.shipment.arrivedAtPort.quantityShipped\" placeholder=\"Enter Quantity Shipped.\"></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Shipping Line</label><selectize placeholder=\"Shipping Line\" config=\"vm.shippingLineConfig\" options=\"vm.shippingLineOptions.list\" ng-model=\"vm.transaction.shipment.arrivedAtPort.shippingLine.id\"></selectize></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Port of Loading</label><selectize placeholder=\"Port of Loading\" config=\"vm.portConfig\" options=\"vm.portOptions.list\" ng-model=\"vm.transaction.shipment.arrivedAtPort.loadingPort.id\"></selectize></div></div><div class=\"col-md-12 col-xs-12\"><div class=\"form-group\"><label class=\"with-line\">Port of Destination</label><selectize placeholder=\"Port of Destination\" config=\"vm.portConfig\" options=\"vm.portOptions.list\" ng-model=\"vm.transaction.shipment.arrivedAtPort.destinationPort.id\"></selectize></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"with-line\">Vessel No.</label><tags-input ng-model=\"vm.transaction.shipment.arrivedAtPort.vessel\" placeholder=\"Enter Vessel/Voyage No.\" max-tags=\"1\" ng-class=\"{\'has-tags\': vm.transaction.shipment.arrivedAtPort.vessel.length>0}\" key-property=\"id\" display-property=\"imo_number\" text=\"imo_number\" template=\"vessel-tag-template\" add-from-autocomplete-only=\"true\" add-on-paste=\"false\"><auto-complete template=\"vessel-auto-complete-template\" source=\"vm.loadVessel($query)\"></auto-complete></tags-input></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"with-line\">Voyage No.</label> <input type=\"text\" rows=\"3\" class=\"form-control\" ng-model=\"vm.transaction.shipment.arrivedAtPort.voyageNo\" placeholder=\"Enter Voyage No.\"></div></div><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"with-line\">Container No.</label><tags-input ng-model=\"vm.transaction.shipment.arrivedAtPort.containers\" display-property=\"containerNo\" placeholder=\"Enter Container No.\" add-on-paste=\"true\"></tags-input></div></div><div class=\"form-group\"><button type=\"submit\" ng-click=\"vm.editArrivedAtPort(vm.arrivedAtPortForm, vm.transaction.shipment.arrivedAtPort, vm.transaction, vm.transactionId)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i> Update Arrived At Port Info</button> <button type=\"button\" ng-click=\"vm.cancelShipmentForm(\'showArrivedAtPort\')\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></div></form></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Notes</h3><div class=\"row\"><div class=\"col-xs-12 col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"noteList\"><img ng-if=\"noteListLoading\" width=\"60\" height=\"60\" src=\"assets/img/loader.svg\"><div ng-if=\"!noteListLoading && (vm.transaction.notes.length === 0)\">No trade notes.</div><div class=\"col-xs-12\" ng-repeat=\"nte in vm.transaction.notes | orderBy: \'-createdAt\'\"><div class=\"col-xs-6 note\" ng-class=\"{\'pull-right\':nte.self, \'self\':nte.self, \'other\': !nte.self, \'editing\': nte.editing}\"><div class=\"col-xs-12 userData\"><img class=\"userImage\" ng-src=\"{{( nte.createdByPic | profilePicture )}}\"><div class=\"details\"><div class=\"name\">{{nte.createdBy}}</div><div class=\"date\">Note on: {{nte.createdAt | date:appFormats.Time }}</div><div class=\"date\" ng-if=\"nte.updatedAt\">Note Updated On: {{nte.updatedAt | date:appFormats.Time }}</div></div></div><div class=\"col-xs-12\">{{nte.note}}</div><div class=\"col-xs-12 button-bar\"><button class=\"btn btn-danger btn-xs pull-right\" ng-if=\"nte.self\" ng-click=\"vm.editTradeNote(nte.note, nte)\">Edit</button> <button class=\"btn btn-warning btn-xs pull-right\" ng-click=\"vm.deleteTradeNote(vm.transactionId, nte.noteId, nte, vm.transaction.notes)\" ng-if=\"nte.isDeleteAble\">Delete</button></div></div></div></div></div><div class=\"col-xs-12 col-md-6\"><div class=\"form-group col-md-12 clearfix\"><form name=\"vm.trade_note_form\" novalidate=\"\"><label class=\"col-sm-12 control-label\">Notes</label><div class=\"col-sm-12\"><textarea ng-if=\"!addingNote\" ng-required=\"true\" name=\"tradeNote\" ng-model=\"vm.noteText\" class=\"form-control\">\n                                                </textarea><ng-messages for=\"vm[\'trade_note_form_\'+row.id][\'tradeNote_\'+row.id].$error\" ng-if=\'(vm[\"trade_note_form_\"+row.id].$submitted || vm[\"trade_note_form_\"+row.id][\"tradeNote_\"+row.id].$dirty)\'><div ng-message=\"required\" class=\"errorValidation\">Please enter a trade note.</div></ng-messages></div><div class=\"col-sm-12\"><br><button class=\"btn btn-success editable-table-button btn-xs\" type=\"submit\" style=\"min-width: 115px;\" ng-click=\"vm.addTradeNote(vm.transactionId, vm.noteText, vm.transaction.notes, vm.trade_note_form)\"><span ng-if=\"addingNote\"><i class=\"fa fa-spinner fa-pulse fa-spin fa-3x fa-fw\"></i> <span class=\"sr-only\">Loading...</span> &nbsp;</span> <span ng-if=\"!vm.addingNote && !vm.updateNote\">Add Note</span> <span ng-if=\"vm.updateNote\">Update Note</span></button></div></form></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Change Logs</h3><div class=\"row\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-table=\"smartTableData\"><thead><tr class=\"sortable table-header\"><th><span class=\"count\">{{vm.transaction.changeLogs.length}}</span></th><th>Log Time</th><th>Change By</th><th>Log</th></tr></thead><tbody><tr ng-repeat=\"log in vm.transaction.changeLogs\"><td></td><td ng-bind=\"log.changeTime | date:vm.appFormats.Time\"></td><td ng-bind=\"log.changeByUserName\"></td><td ng-bind-html=\"log.description\"></td></tr></tbody></table></div></div></div></div></div></div></div><script type=\"text/ng-template\" id=\"vessel-tag-template\"><div class=\"tag-template\"> <div class=\"right-panel\"> <span class=\"titled\">{{$getDisplayText()}}</span> <span>{{data.first_name}}</span> <span>{{data.mmsi_number ? data.mmsi_number : \'NA\' }}</span> <a class=\"remove-button\" ng-click=\"$removeTag()\">&#10006;</a> </div> </div></script><script type=\"text/ng-template\" id=\"vessel-auto-complete-template\"><div class=\"autocomplete-template\"> <div class=\"right-panel\"> <span class=\"titled\" ng-bind-html=\"$highlight($getDisplayText())\"></span> <span>{{data.first_name}}</span> <span>{{data.mmsi_number ? data.mmsi_number : \'NA\' }}</span> </div> </div></script><script type=\"text/ng-template\" id=\"port-tag-template\"><div class=\"tag-template\"> <div class=\"right-panel\"> <span>{{$getDisplayText()}}</span> <span>{{data.lo_code}}</span> <span>{{data.country}}</span> <a class=\"remove-button\" ng-click=\"$removeTag()\">&#10006;</a> </div> </div></script><script type=\"text/ng-template\" id=\"port-auto-complete-template\"><div class=\"autocomplete-template\"> <div class=\"right-panel\"> <span class=\"titled\">{{data.lo_code}}</span> <span>{{data.name}}</span> <span>{{data.country}}</span> </div> </div></script>");
$templateCache.put("app/dashboard/user/profile/profile.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><form name=\"vm.profileForm\" novalidate=\"\"><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ vm.picture }}\" ng-click=\"vm.uploadPicture(event)\"></div><i class=\"ion-ios-close-outline\" ng-click=\"vm.removePicture()\" ng-if=\"!vm.noPicture\"></i> <a href=\"\" class=\"change-userpic\" ng-click=\"vm.uploadPicture(event)\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"vm.onFileSelect($files)\"></div></div></div></div><div class=\"col-md-6\"></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" ng-required=\"true\" name=\"firstName\" ng-pattern=\"/^[a-zA-Z]*$/\" ng-model=\"vm.userProfile.firstName\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"First Name\"><ng-messages for=\"vm.profileForm.firstName.$error\" ng-if=\"(vm.profileForm.$submitted && vm.profileForm.firstName.$invalid) || (vm.profileForm.firstName.$invalid && vm.profileForm.firstName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter first name.</div><div ng-message=\"pattern\" class=\"errorValidation\">First Name can only have alphabets.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"lastName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" ng-model=\"vm.userProfile.lastName\" class=\"form-control\" name=\"lastName\" ng-pattern=\"/^[a-zA-Z]*$/\" ng-required=\"true\" id=\"lastName\" placeholder=\"Last Name\"><ng-messages for=\"vm.profileForm.lastName.$error\" ng-if=\"(vm.profileForm.$submitted && vm.profileForm.lastName.$invalid) || (vm.profileForm.lastName.$invalid && vm.profileForm.lastName.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter last name.</div><div ng-message=\"pattern\" class=\"errorValidation\">Last Name can only have alphabets.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Designation</label><div class=\"col-sm-9\"><selectize name=\"designation\" required=\"true\" placeholder=\"Designation\" config=\"vm.designationConfig\" options=\"vm.designationOptions.list\" ng-model=\"vm.userProfile.designationId\"></selectize><ng-messages for=\"vm.profileForm.designation.$error\" ng-if=\"(vm.profileForm.$submitted && vm.profileForm.designation.$invalid) || (vm.profileForm.designation.$invalid && vm.profileForm.designation.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select a designation.</div></ng-messages></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Office Location</label><div class=\"col-sm-9\"><selectize placeholder=\"Office Location\" name=\"officeLocation\" required=\"true\" config=\"vm.locationConfig\" options=\"vm.locationOptions.list\" ng-model=\"vm.userProfile.businessLocationId\"></selectize><ng-messages for=\"vm.profileForm.officeLocation.$error\" ng-if=\"(vm.profileForm.$submitted && vm.profileForm.officeLocation.$invalid) || (vm.profileForm.officeLocation.$invalid && vm.profileForm.officeLocation.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select an office Location.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"email\" ng-required=\"true\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\"><input type=\"email\" class=\"form-control\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/i\" name=\"email\" ng-model=\"vm.userProfile.email\" ng-required=\"true\" id=\"email\" placeholder=\"\"><ng-messages for=\"vm.profileForm.email.$error\" ng-if=\"(vm.profileForm.$submitted && vm.profileForm.email.$invalid) || (vm.profileForm.email.$invalid && vm.profileForm.email.$dirty)\"><div ng-message=\"pattern\" class=\"errorValidation\">Invalid email.</div><div ng-message=\"required\" class=\"errorValidation\">Please enter user email.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label for=\"username\" class=\"col-sm-3 control-label\">User Name</label><div class=\"col-sm-9\"><input type=\"text\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" ng-model=\"vm.userProfile.username\" name=\"username\" class=\"form-control\" id=\"username\" placeholder=\"User Name\"><ng-messages for=\"vm.profileForm.username.$error\" ng-if=\"(vm.profileForm.$submitted && vm.profileForm.username.$invalid) || (vm.profileForm.username.$invalid && vm.profileForm.username.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter user username.</div><div ng-message=\"required\" class=\"errorValidation\">User Name can only be alphanumeric.</div></ng-messages></div></div></div></div><h3 class=\"with-line\">Send Email Notifications</h3><div class=\"notification row clearfix\" ng-if=\"vm.isCurrentUserSuperUser\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When a new transaction is added</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.notify.newTransaction\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When shipment arrives</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.notify.shipmentArrival\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">When I recieve a message</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.notify.messages\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Monthly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.notify.monthlyReports\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Weekly Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.notify.weeklyReports\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Daily Reports</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.notify.dailyReports\"></switch></div></div></div></div><div ng-if=\"vm.isCurrentUserSuperUser\"><h3 class=\"with-line\">User Access Right</h3><div class=\"notification row clearfix\"><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Business Commission</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.rights.businessCommission\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Business Analytics</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.rights.businessAnalytics\"></switch></div></div></div><div class=\"col-sm-6\"><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">Warehouse Module</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.rights.warehouseModule\"></switch></div></div><div class=\"form-group row clearfix\"><label class=\"col-xs-8\">User Management</label><div class=\"col-xs-4\"><switch color=\"primary\" ng-model=\"vm.userProfile.rights.userManagement\"></switch></div></div></div></div></div><button type=\"submit\" ng-if=\"vm.userProfile.id\" ng-click=\"vm.updateUser(vm.profileForm, vm.userProfile, vm.imagesData)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Update Profile</button> <button type=\"submit\" ng-if=\"!vm.userProfile.id\" ng-click=\"vm.addUser(vm.profileForm, vm.userProfile, vm.imagesData)\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>Add New Profile</button> <button type=\"button\" ng-click=\"vm.cancel()\" class=\"btn btn-danger btn-with-icon save-profile\"><i class=\"ion-android-cancel\"></i>Cancel</button></form></div></div>");
$templateCache.put("app/dashboard/user/profile/profileModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in menuItems | orderBy : \'priority\' : false\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div><nav><ul class=\"pager ba-wizard-pager\"><li class=\"previous\"><button ng-show=\"!$baWizardController.isFirstTab()\" ng-click=\"$baWizardController.previousTab()\" type=\"button\" class=\"btn btn-primary\"><span aria-hidden=\"true\">&larr;</span>Previous</button></li><li class=\"next margin-left-20px\"><button ng-click=\"$baWizardController.onCancel()\" type=\"button\" class=\"btn btn-danger\">Cancel <span aria-hidden=\"true\"></span></button></li><li class=\"next margin-left-20px\"><button ng-click=\"$baWizardController.nextTab()\" type=\"button\" class=\"btn btn-primary\">{{$baWizardController.tabs[$baWizardController.tabNum].submitButtonTitle}} <span aria-hidden=\"true\">&rarr;</span></button></li><li class=\"next\"><button ng-click=\"$baWizardController.nextTabAndExit()\" type=\"button\" class=\"btn btn-success\">{{$baWizardController.tabs[$baWizardController.tabNum].submitButtonTitle}} & exit <span aria-hidden=\"true\">&rarr;</span></button></li></ul></nav></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><ul class=\"breadcrumb al-breadcrumb\"><li><a href=\"#/dashboard\">Home</a></li><li>{{ activePageTitle }}</li></ul></div>");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>{{notificationObj.list.length}}</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong></div><div class=\"msg-list\"><a class=\"clearfix\" ng-if=\"notificationObj.list.length===0\"><div class=\"msg-area\"><div>No Update Notifications</div></div></a> <a class=\"clearfix\" ng-repeat=\"msg in notificationObj.list\" ng-click=\"goToState(msg.data.state, {id: msg.data.state_id})\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.data.user_image}\" ng-src=\"{{::( msg.data.user_image|| (msg.data.user_image | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"msg.verb\"></div><span am-time-ago=\"msg.timestamp\"></span></div></a></div></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard\" class=\"al-logo clearfix\"><img src=\"assets/img/favicon-32x32.png\" alt=\"Doni & Company\"></a><a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"search search-dropdown\"><i class=\"ion-ios-search-strong\" ng-click=\"startSearch()\"></i><select class=\"form-control\" placeholder=\"Search Type\" name=\"searchType\" ng-model=\"searchObj.queryType\"><option ng-repeat=\"opt in searchOptions\" value=\"{{opt.id}}\">{{opt.name}}</option></select></div><div class=\"search\"><input id=\"searchInput\" type=\"text\" class=\"form-control\" style=\"background: #6A6A6A !important;\" ng-model=\"searchObj.query\" placeholder=\"\" ng-change=\"searchQuery(searchObj, lastSearch)\"> <i ng-show=\"loading\" class=\"fa fa-spinner fa-pulse fa-3x fa-fw\"></i></div><div class=\"search-result\" ng-show=\"searchResults.length > 0\"><div class=\"search-item\" ng-repeat=\"result in searchResults\" ng-if=\"resultType===\'intFile\'\" ng-click=\"goToSearchItem(\'dashboard.transactionView\', {\'id\': result.file_id})\"><div class=\"detail\"><div class=\"label\">FileId</div><div class=\"value\" ng-bind=\"result.file_id\"></div></div><div class=\"detail\"><div class=\"label\">Contract No</div><div class=\"value\" ng-bind=\"(result.contract_id ? result.contract_id : \'NA\')\"></div></div><div class=\"detail\"><div class=\"label\">BL No</div><div class=\"value\" ng-bind=\"(result.shipment__bl_no ? result.shipment__bl_no : \'NA\')\"></div></div></div></div><div class=\"user-profile clearfix\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img ng-src=\"{{( userData.data.smallProfilePic | profilePicture )}}\"></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a ui-sref=\"dashboard.user.profile({id:userData.data.id})\"><i class=\"fa fa-user\"></i>{{userData.data.firstName + \' \' + userData.data.lastName}}</a></li><li><a ui-sref=\"dashboard.settings\"><i class=\"fa fa-cog\"></i>Settings</a></li><li ng-click=\"logout()\"><a href=\"\" class=\"signout\"><i class=\"fa fa-power-off\"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>");
$templateCache.put("app/theme/components/progressBarRound/progressBarRound.html","<svg class=\"center-block progress-bar-round\" width=\"200\" height=\"200\"><circle cx=\"100\" cy=\"100\" r=\"90\" fill=\"none\" stroke=\"#F8F8FF\" stroke-width=\"8\"></circle><circle cx=\"100\" cy=\"100\" r=\"90\" fill=\"none\" id=\"loader\" class=\"\" stroke=\"#209e91\" stroke-width=\"8\" stroke-dasharray=\"0,20000\" transform=\"rotate(-90,100,100)\" stroke-linecap=\"round\"></circle><text text-anchor=\"middle\" class=\"loading\" x=\"100\" y=\"90\">Loading...</text><text class=\"percentage\" text-anchor=\"middle\" x=\"100\" y=\"130\">{{progress}}%</text></svg>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/widgets/charts/amCharts/charts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\" ba-panel=\"\" ba-panel-title=\"Bar Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/barChart/barChart.html\'\"></div></div><div class=\"col-lg-4 col-md-6\" ba-panel=\"\" ba-panel-title=\"Area Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/areaChart/areaChart.html\'\"></div></div><div class=\"col-lg-4 col-md-12\" ba-panel=\"\" ba-panel-title=\"Line Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/lineChart/lineChart.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Pie Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/pieChart/pieChart.html\'\"></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Funnel Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Combined bullet/column and line graphs with multiple value axes\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'\"></div></div></div></div>");
$templateCache.put("app/widgets/charts/chartJs/chartJs.html","<div class=\"row\"><div class=\"col-md-4\" ng-controller=\"chartJs1DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Pie\" ba-panel-class=\"with-scroll\"><canvas id=\"pie\" class=\"chart chart-pie\" chart-legend=\"true\" chart-options=\"options\" chart-data=\"data\" chart-labels=\"labels\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-md-4\" ng-controller=\"chartJs1DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Doughnut\" ba-panel-class=\"with-scroll\"><canvas id=\"doughnut\" chart-options=\"options\" class=\"chart chart-doughnut\" chart-legend=\"true\" chart-data=\"data\" chart-labels=\"labels\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-md-4\" ng-controller=\"chartJs1DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Polar\" ba-panel-class=\"with-scroll\"><canvas id=\"polar-area\" class=\"chart chart-polar-area\" chart-data=\"data\" chart-options=\"polarOptions\" chart-labels=\"labels\" chart-legend=\"true\" chart-click=\"changeData\"></canvas></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-controller=\"chartJsWaveCtrl\"><div ba-panel=\"\" ba-panel-title=\"Animated Radar\" ba-panel-class=\"with-scroll col-eq-height\"><canvas id=\"waveLine\" class=\"chart chart-radar\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\"></canvas></div></div><div class=\"col-md-6\" ng-controller=\"chartJsWaveCtrl\"><div ba-panel=\"\" ba-panel-title=\"Animated Bars\" ba-panel-class=\"with-scroll col-eq-height\"><canvas id=\"waveBars\" class=\"chart chart-bar\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\"></canvas></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6\" ng-controller=\"chartJs2DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Radar\" ba-panel-class=\"with-scroll\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-legend=\"false\" chart-series=\"series\" chart-data=\"data\" chart-labels=\"labels\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-lg-4 col-md-6\" ng-controller=\"chartJs2DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Line\" ba-panel-class=\"with-scroll\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\" chart-series=\"series\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-lg-4 col-md-12\" ng-controller=\"chartJs2DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Bars\" ba-panel-class=\"with-scroll\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"data\" chart-labels=\"labels\" chart-series=\"series\" chart-click=\"changeData\"></canvas></div></div></div>");
$templateCache.put("app/widgets/charts/chartist/chartist.html","<section ng-controller=\"chartistCtrl\" class=\"chartist\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Lines\" ba-panel-class=\"with-scroll\"><h5>Simple line chart</h5><div id=\"line-chart\" class=\"ct-chart\"></div><h5>Line chart with area</h5><div id=\"area-chart\" class=\"ct-chart\"></div><h5>Bi-polar line chart with area only</h5><div id=\"bi-chart\" class=\"ct-chart\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Bars\" ba-panel-class=\"with-scroll\"><h5>Simple bar chart</h5><div id=\"simple-bar\" class=\"ct-chart\"></div><h5>Multi-line labels bar chart</h5><div id=\"multi-bar\" class=\"ct-chart\"></div><h5>Stacked bar chart</h5><div id=\"stacked-bar\" class=\"ct-chart stacked-bar\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Pies & Donuts\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><h5>Simple Pie</h5><div id=\"simple-pie\" class=\"ct-chart\"></div></div><div class=\"col-md-12 col-lg-4\"><h5>Pie with labels</h5><div id=\"label-pie\" class=\"ct-chart\"></div></div><div class=\"col-md-12 col-lg-4\"><h5>Donut</h5><div id=\"donut\" class=\"ct-chart\"></div></div></div></div></div></div></section>");
$templateCache.put("app/widgets/charts/morris/morris.html","<section ng-controller=\"morrisCtrl\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Line Chart\" ba-panel-class=\"with-scroll\"><div line-chart=\"\" line-data=\"lineData\" line-xkey=\"y\" line-ykeys=\'[\"a\", \"b\"]\' line-labels=\'[\"Serie A\", \"Serie B\"]\' line-colors=\"colors\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div ba-panel=\"\" ba-panel-title=\"Donut\" ba-panel-class=\"with-scroll\"><div donut-chart=\"\" donut-data=\"donutData\" donut-colors=\"colors\" donut-formatter=\'\"currency\"\'></div></div></div><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-title=\"Bar Chart\" ba-panel-class=\"with-scroll\"><div bar-chart=\"\" bar-data=\"barData\" bar-x=\"y\" bar-y=\'[\"a\", \"b\"]\' bar-labels=\'[\"Series A\", \"Series B\"]\' bar-colors=\"colors\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Area Chart\" ba-panel-class=\"with-scroll\"><div area-chart=\"\" area-data=\"areaData\" area-xkey=\"y\" area-ykeys=\'[\"a\", \"b\"]\' %=\"\" area-labels=\'[\"Serie A\", \"Serie B\"]\' line-colors=\"colors\"></div></div></div></div></section>");
$templateCache.put("app/widgets/components/mail/mail.html","<div class=\"row mail-client-container transparent\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-class=\"xmedium-panel mail-panel\"><div class=\"letter-layout\"><div class=\"mail-navigation-container\" ng-class=\"{\'expanded\' : !tabCtrl.navigationCollapsed}\"><div class=\"text-center\"><button type=\"button\" class=\"btn btn-default compose-button\" ng-click=\"tabCtrl.showCompose(\'\',\'\',\'\')\">Compose</button></div><div ng-repeat=\"t in tabCtrl.tabs\" ui-sref-active=\"active\" class=\"mail-navigation\" ui-sref=\"components.mail.label({label: t.label})\" ng-click=\"selectTab(t.label)\">{{t.name}}<span class=\"new-mails\" ng-show=\"t.newMails\">{{t.newMails}}</span></div><div class=\"labels\"><div class=\"labels-title\"></div><div class=\"labels-container\"><div class=\"label-item\"><span class=\"tag label work\">Work</span></div><div class=\"label-item\"><span class=\"tag label family\">Family</span></div><div class=\"label-item\"><span class=\"tag label friend\">Friend</span></div><div class=\"label-item\"><span class=\"tag label study\">Study</span></div></div></div><div class=\"add-label-container\"><i class=\"ion-plus-round\"></i><span class=\"label-input-stub\">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>");
$templateCache.put("app/widgets/components/timeline/timeline.html","<div ba-panel=\"\"><section id=\"cd-timeline\" class=\"cd-container cssanimations\" ng-controller=\"TimelineCtrl\"><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Euro-Coin\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content warning\"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class=\"cd-date\">Jan 14</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Laptop-Signal\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content danger\"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class=\"cd-date\">Jan 18</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg primary\"><img ng-src=\"{{::( \'Checklist\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content primary\"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class=\"cd-date\">Feb 18</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Boss-3\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content warning\"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class=\"cd-date\">Feb 20</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Online-Shopping\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content danger\"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class=\"cd-date\">Feb 21</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg primary\"><img ng-src=\"{{::( \'Money-Increase\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content primary\"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class=\"cd-date\">Feb 23</span></div></div><div class=\"cd-timeline-block\"><div class=\"cd-timeline-img\"><div class=\"kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Vector\' | kameleonImg )}}\"></div></div><div class=\"cd-timeline-content warning\"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class=\"cd-date\">Feb 24</span></div></div></section></div>");
$templateCache.put("app/widgets/components/tree/tree.html","<div class=\"row\" ng-controller=\"treeCtrl\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic Action\" ba-panel-class=\"with-scroll tree-panel\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"control-side text-center\"><div><button class=\"btn btn-primary\" ng-click=\"addNewNode()\">Add</button></div><div><button class=\"btn btn-primary\" ng-click=\"collapse()\">Collapse All</button></div><div><button class=\"btn btn-primary\" ng-click=\"expand()\">Expand All</button></div><div><button class=\"btn btn-primary\" ng-click=\"refresh()\">Refresh</button></div></div></div><div class=\"col-sm-8\"><div js-tree=\"basicConfig\" ng-model=\"treeData\" should-apply=\"applyModelChanges()\" tree=\"basicTree\" tree-events=\"ready:readyCB\"></div></div></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Drag & Drop\" ba-panel-class=\"with-scroll tree-panel\"><div js-tree=\"dragConfig\" ng-model=\"dragData\"></div></div></div></div>");
$templateCache.put("app/widgets/form/inputs/inputs.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Standard Fields\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/standardFields.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Tags Input\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Input Groups\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/inputGroups.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Checkboxes & Radios\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/checkboxesRadios.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Validation States\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/validationStates.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Selects\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/select/select.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"On/Off Switches\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/switch/switch.html\'\"></div></div></div></div></div>");
$templateCache.put("app/widgets/form/layouts/layouts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Inline Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/inlineForm.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/basicForm.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Horizontal Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/horizontalForm.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Form Without Labels\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/formWithoutLabels.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Block Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/blockForm.html\'\"></div></div></div></div></div>");
$templateCache.put("app/widgets/form/wizard/wizard.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Form Wizard\" ba-panel-class=\"with-scroll\"><ba-wizard><ba-wizard-step title=\"Personal info\" form=\"vm.personalInfoForm\"><form name=\"vm.personalInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleUsername1\">Username</label> <input type=\"text\" class=\"form-control\" id=\"exampleUsername1\" name=\"username\" placeholder=\"Username\" ng-model=\"vm.personalInfo.username\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputEmail1\">Email address</label> <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" name=\"email\" placeholder=\"Email\" ng-model=\"vm.personalInfo.email\" required=\"\"> <span class=\"help-block error-block basic-block\">Proper email required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputPassword1\">Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" name=\"password\" placeholder=\"Password\" ng-model=\"vm.personalInfo.password\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputConfirmPassword1\">Confirm Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputConfirmPassword1\" name=\"confirmPassword\" placeholder=\"Confirm Password\" ng-model=\"vm.personalInfo.confirmPassword\" required=\"\"> <span class=\"help-block error-block basic-block\">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Product Info\" form=\"vm.productInfoForm\"><form name=\"vm.productInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productName\">Product name</label> <input type=\"text\" class=\"form-control\" id=\"productName\" name=\"productName\" placeholder=\"Product name\" ng-model=\"vm.productInfo.productName\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productId\">Product id</label> <input type=\"text\" class=\"form-control\" id=\"productId\" name=\"productId\" placeholder=\"productId\" ng-model=\"vm.productInfo.productId\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"productName\">Category</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Shipment\" form=\"vm.addressForm\"><form name=\"vm.addressForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}\"><label for=\"productName\">Shipment address</label> <input type=\"text\" class=\"form-control\" id=\"address\" name=\"address\" placeholder=\"Shipment address\" ng-model=\"vm.shipment.address\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"productName\">Shipment method</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title=\"Finish\"><form class=\"form-horizontal\" name=\"vm.finishForm\" novalidate=\"\">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>");
$templateCache.put("app/widgets/maps/google-maps/google-maps.html","<div ba-panel=\"\" ba-panel-title=\"Google Maps\" class=\"viewport100\"><div id=\"google-maps\"></div></div>");
$templateCache.put("app/widgets/maps/leaflet/leaflet.html","<div ba-panel=\"\" ba-panel-title=\"Leaflet\" class=\"viewport100\"><div id=\"leaflet-map\"></div></div>");
$templateCache.put("app/widgets/maps/map-bubbles/map-bubbles.html","<div ba-panel=\"\" ba-panel-title=\"Map with Bubbles\" class=\"viewport100\"><div id=\"map-bubbles\"></div></div>");
$templateCache.put("app/widgets/maps/map-lines/map-lines.html","<div ba-panel=\"\" ba-panel-title=\"Line Map\" class=\"viewport100\"><div id=\"map-lines\"></div></div>");
$templateCache.put("app/widgets/tables/basic/tables.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Hover Rows\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/hoverRows.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Bordered Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/borderedTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Condensed Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/condensedTable.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Striped Rows\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/stripedRows.html\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Contextual Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/contextualTable.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Responsive Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/responsiveTable.html\"></div></div></div></div></div>");
$templateCache.put("app/widgets/tables/smart/tables.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Rows\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/editableRowTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Cells\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/editableTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Smart Table With Filtering, Sorting And Pagination\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/smartTable.html\"></div></div></div></div></div>");
$templateCache.put("app/widgets/tables/widgets/basicTable.html","<div class=\"horizontal-scroll\"><table class=\"table\"><thead><tr><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Downloads</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">DAU</th><th class=\"table-arr\"></th><th class=\"align-right\">MAU</th><th class=\"table-arr\"></th><th class=\"align-right\">LTV</th><th class=\"table-arr\"></th><th class=\"align-right\">Users %</th><th class=\"table-arr\"></th></tr></thead><tbody><tr><td><img src=\"img/chrome.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Google Chrome</td><td class=\"align-right\">10,392</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">3,822</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">4,214</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">899</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">7,098</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">178</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">45%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr><tr><td><img src=\"img/firefox.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Mozilla Firefox</td><td class=\"align-right\">7,873</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">6,003</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,031</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">897</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">8,997</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">102</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">28%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr><tr><td><img src=\"img/ie.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Internet Explorer</td><td class=\"align-right\">5,890</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,492</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">2,102</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">27</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">4,039</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">99</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">17%</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td></tr><tr><td><img src=\"img/safari.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Safari</td><td class=\"align-right\">4,001</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">2,039</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">1,001</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">104</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,983</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">209</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">14%</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td></tr><tr><td><img src=\"img/opera.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Opera</td><td class=\"align-right\">1,833</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">983</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">83</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">19</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">1,099</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">103</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">5%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/widgets/tables/widgets/borderedTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-bordered\"><thead><tr><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"align-right\">Purchases</th><th class=\"align-right\">%</th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"align-right\">{{item.purchases}}</td><td class=\"align-right\">{{item.percent}}</td></tr></tbody></table></div>");
$templateCache.put("app/widgets/tables/widgets/condensedTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-condensed\"><thead><tr><th class=\"table-id\">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"item in peopleTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td><button class=\"status-button btn btn-xs btn-{{item.status}}\">{{item.status}}</button></td></tr></tbody></table></div>");
$templateCache.put("app/widgets/tables/widgets/contextualTable.html","<table class=\"table\"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class=\"primary\"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class=\"email-link\" ng-href=\"mailto:mdo@gmail.com\" href=\"mailto:mdo@gmail.com\">mdo@gmail.com</a></td><td>28</td></tr><tr class=\"success\"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class=\"email-link\" ng-href=\"mailto:fat@yandex.ru\" href=\"mailto:fat@yandex.ru\">fat@yandex.ru</a></td><td>45</td></tr><tr class=\"warning\"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class=\"email-link\" ng-href=\"mailto:twitter@outlook.com\" href=\"mailto:twitter@outlook.com\">twitter@outlook.com</a></td><td>18</td></tr><tr class=\"danger\"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class=\"email-link\" ng-href=\"mailto:snow@gmail.com\" href=\"mailto:snow@gmail.com\">snow@gmail.com</a></td><td>20</td></tr><tr class=\"info\"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class=\"email-link\" ng-href=\"mailto:jack@yandex.ru\" href=\"mailto:jack@yandex.ru\">jack@yandex.ru</a></td><td>30</td></tr></table>");
$templateCache.put("app/widgets/tables/widgets/editableRowTable.html","<div class=\"add-row-editable-table\"><button class=\"btn btn-primary\" ng-click=\"addUser()\">Add row</button></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat=\"user in users\" class=\"editable-row\"><td>{{$index}}</td><td><span editable-text=\"user.name\" e-name=\"name\" e-form=\"rowform\" e-required=\"\">{{ user.name || \'empty\' }}</span></td><td class=\"select-td\"><span editable-select=\"user.status\" e-name=\"status\" e-form=\"rowform\" e-selectpicker=\"\" e-ng-options=\"s.value as s.text for s in statuses\">{{ showStatus(user) }}</span></td><td class=\"select-td\"><span editable-select=\"user.group\" e-name=\"group\" onshow=\"loadGroups()\" e-form=\"rowform\" e-selectpicker=\"\" e-ng-options=\"g.id as g.text for g in groups\">{{ showGroup(user) }}</span></td><td><form editable-form=\"\" name=\"rowform\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == user\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary editable-table-button btn-xs\">Save</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default editable-table-button btn-xs\">Cancel</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"rowform.$show()\">Edit</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"removeUser($index)\">Delete</button></div></td></tr></table>");
$templateCache.put("app/widgets/tables/widgets/editableTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-table=\"editableTableData\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"firstName\">First Name</th><th st-sort=\"lastName\">Last Name</th><th st-sort=\"username\">Username</th><th st-sort=\"email\">Email</th><th st-sort=\"age\">Age</th></tr></thead><tbody><tr ng-repeat=\"item in editableTableData\" class=\"editable-tr-wrap\"><td class=\"table-id\">{{item.id}}</td><td><span editable-text=\"item.firstName\" blur=\"cancel\">{{item.firstName}}</span></td><td><span editable-text=\"item.lastName\" blur=\"cancel\">{{item.lastName}}</span></td><td><span editable-text=\"item.username\" blur=\"cancel\">{{item.username}}</span></td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td><span editable-text=\"item.age\" blur=\"cancel\">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"12\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div>");
$templateCache.put("app/widgets/tables/widgets/hoverRows.html","<div class=\"horizontal-scroll\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">%</th><th class=\"table-arr\"></th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\" class=\"no-top-border\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }\"></i></td><td class=\"align-right\">{{item.purchases}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }\"></i></td><td class=\"align-right\">{{item.percent}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/widgets/tables/widgets/responsiveTable.html","<div class=\"table-responsive\"><table class=\"table\"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class=\"email-link\" ng-href=\"mailto:mdo@gmail.com\" href=\"mailto:mdo@gmail.com\">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class=\"email-link\" ng-href=\"mailto:fat@yandex.ru\" href=\"mailto:fat@yandex.ru\">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class=\"email-link\" ng-href=\"mailto:twitter@outlook.com\" href=\"mailto:twitter@outlook.com\">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class=\"email-link\" ng-href=\"mailto:snow@gmail.com\" href=\"mailto:snow@gmail.com\">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class=\"email-link\" ng-href=\"mailto:jack@yandex.ru\" href=\"mailto:jack@yandex.ru\">jack@yandex.ru</a></td><td>30</td></tr></table></div>");
$templateCache.put("app/widgets/tables/widgets/smartTable.html","<div class=\"horizontal-scroll\"><div class=\"form-group select-page-size-wrap\"><label>Rows on page<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></label></div><table class=\"table\" st-table=\"smartTableData\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"firstName\">First Name</th><th st-sort=\"lastName\">Last Name</th><th st-sort=\"username\">Username</th><th st-sort=\"email\">Email</th><th st-sort=\"age\">Age</th></tr><tr><th></th><th><input st-search=\"firstName\" placeholder=\"Search First Name\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"lastName\" placeholder=\"Search Last Name\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"username\" placeholder=\"Search Username\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"email\" placeholder=\"Search Email\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"age\" placeholder=\"Search Age\" class=\"input-sm form-control search-input\" type=\"search\"></th></tr></thead><tbody><tr ng-repeat=\"item in smartTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div>");
$templateCache.put("app/widgets/tables/widgets/stripedRows.html","<div class=\"vertical-scroll\"><table class=\"table table-striped\"><thead><tr><th class=\"table-id\">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat=\"item in smartTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>");
$templateCache.put("app/widgets/ui/alerts/alerts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Basic\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success\"><strong>Well done!</strong> You successfully read this important alert message.</div><div class=\"alert bg-info\"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class=\"alert bg-warning\"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class=\"alert bg-danger\"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Dismissible alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class=\"alert bg-info closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class=\"alert bg-warning closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class=\"alert bg-danger closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Links in alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success\"><strong>Well done!</strong> You successfully read <a href=\"\" class=\"alert-link\">this important alert message</a>.</div><div class=\"alert bg-info\"><strong>Heads up!</strong> This <a href=\"\" class=\"alert-link\">alert needs your attention</a>, but it\'s not super important.</div><div class=\"alert bg-warning\"><strong>Warning!</strong> Better check yourself, you\'re <a href=\"\" class=\"alert-link\">not looking too good</a>.</div><div class=\"alert bg-danger\"><strong>Oh snap!</strong> <a href=\"\" class=\"alert-link\">Change a few things up</a> and try submitting again.</div></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Composite alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-warning\"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class=\"control-alert\"><button type=\"button\" class=\"btn btn-danger\">Pay Attention</button> <button type=\"button\" class=\"btn btn-primary\">Ignore</button></div></div></div></div></div></div>");
$templateCache.put("app/widgets/ui/buttons/buttons.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Flat Buttons\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Raised Buttons\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-raised\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-raised\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success btn-raised\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-raised\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-raised\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger btn-raised\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Different sizes\" ba-panel-class=\"with-scroll button-panel df-size-button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-xs\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-sm\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success btn-mm\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-md\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-xm\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger btn-lg\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Disabled\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary\" disabled=\"disabled\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success\" disabled=\"disabled\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info\" disabled=\"disabled\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning\" disabled=\"disabled\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger\" disabled=\"disabled\">Danger</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Icon Buttons\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/iconButtons.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Large Buttons\" ba-panel-class=\"with-scroll large-buttons-panel\"><div ng-include=\"\'app/pages/ui/buttons/widgets/largeButtons.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Button Dropdowns\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/dropdowns.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Button Groups\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/buttonGroups.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Progress Buttons\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/progressButtons.html\'\"></div></div></div></div>");
$templateCache.put("app/widgets/ui/grid/baseGrid.html","<h4 class=\"grid-h\">Stacked to horizontal</h4><div class=\"row show-grid\"><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div></div><div class=\"row show-grid\"><div class=\"col-md-8\"><div>.col-md-8</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-6\"><div>.col-md-6</div></div><div class=\"col-md-6\"><div>.col-md-6</div></div></div><h4 class=\"grid-h\">Mobile and desktop</h4><div class=\"row show-grid\"><div class=\"col-xs-12 col-md-8\"><div>xs-12 .col-md-8</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6\"><div>.col-xs-6</div></div><div class=\"col-xs-6\"><div>.col-xs-6</div></div></div><h4 class=\"grid-h\">Mobile, tablet, desktop</h4><div class=\"row show-grid\"><div class=\"col-xs-12 col-sm-6 col-md-8\"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class=\"col-xs-6 col-md-4\"><div>.col-xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class=\"grid-h\">Column wrapping</h4><div class=\"row show-grid\"><div class=\"col-xs-9\"><div>.col-xs-9</div></div><div class=\"col-xs-4\"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class=\"col-xs-6\"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class=\"grid-h\">Responsive column resets</h4><div class=\"row show-grid\"><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class=\"grid-h\">Offsetting columns</h4><div class=\"row show-grid\"><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4 col-md-offset-4\"><div>.col-md-4 .col-md-offset-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-3 col-md-offset-3\"><div>.col-md-3 .col-md-offset-3</div></div><div class=\"col-md-3 col-md-offset-3\"><div>.col-md-3 .col-md-offset-3</div></div></div><div class=\"row show-grid\"><div class=\"col-md-6 col-md-offset-3\"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class=\"grid-h\">Grid options</h4><div class=\"table-responsive\"><table class=\"table table-bordered table-striped\"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (≥768px)</small></th><th>Medium devices <small>Desktops (≥992px)</small></th><th>Large devices <small>Desktops (≥1200px)</small></th></tr></thead><tbody><tr><th class=\"text-nowrap\" scope=\"row\">Grid behavior</th><td>Horizontal at all times</td><td colspan=\"3\">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class=\"text-nowrap\" scope=\"row\"># of columns</th><td colspan=\"4\">12</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Column width</th><td class=\"text-muted\">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Gutter width</th><td colspan=\"4\">30px (15px on each side of a column)</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Nestable</th><td colspan=\"4\">Yes</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Offsets</th><td colspan=\"4\">Yes</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Column ordering</th><td colspan=\"4\">Yes</td></tr></tbody></table></div>");
$templateCache.put("app/widgets/ui/grid/grid.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Inline Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/grid/baseGrid.html\'\"></div></div></div></div>");
$templateCache.put("app/widgets/ui/icons/icons.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Kameleon SVG Icons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/kameleon.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"Socicon\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/socicon.html\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Icons With Rounded Background\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/kameleonRounded.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"ionicons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/ionicons.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"Font Awesome Icons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/fontAwesomeIcons.html\"></div></div></div></div></div>");
$templateCache.put("app/widgets/ui/modals/modals.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons clearfix\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')\">Default modal</button> <button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')\">Large modal</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')\">Small modal</button></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Message Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons same-width clearfix\"><button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/successModal.html\')\">Success Message</button> <button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')\">Info Message</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')\">Warning Message</button> <button type=\"button\" class=\"btn btn-danger\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')\">Danger Message</button></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Notifications\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/modals/notifications/notifications.html\'\"></div></div></div></div>");
$templateCache.put("app/widgets/ui/notifications/notifications.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll notification-panel\"><div class=\"row\"><div class=\"col-md-3 col-sm-4\"><div class=\"control\"><label for=\"title\">Title</label> <input ng-model=\"options.title\" type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"Enter a title ...\"></div><div class=\"control\"><label for=\"message\">Message</label> <textarea ng-model=\"options.msg\" class=\"form-control\" id=\"message\" rows=\"3\" placeholder=\"Enter a message ...\"></textarea></div><div class=\"control-group\"><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.closeButton\" type=\"checkbox\" id=\"closeButton\"> <span>Close Button</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.allowHtml\" type=\"checkbox\" id=\"html\"> <span>Allow html</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.progressBar\" type=\"checkbox\" id=\"progressBar\"> <span>Progress bar</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.preventDuplicates\" type=\"checkbox\" id=\"preventDuplicates\"> <span>Prevent duplicates</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.preventOpenDuplicates\" type=\"checkbox\" id=\"preventOpenDuplicates\"> <span>Prevent open duplicates</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.tapToDismiss\" type=\"checkbox\" id=\"tapToDismiss\"> <span>Tap to dismiss</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.newestOnTop\" type=\"checkbox\" id=\"newestOnTop\"> <span>Newest on top</span></label></div></div></div><div class=\"col-md-2 col-sm-3 toastr-radio-setup\"><div id=\"toastTypeGroup\"><div class=\"controls radio-controls\"><label class=\"radio-header\">Toast Type</label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"success\"><span>Success</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"info\"><span>Info</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"warning\"><span>Warning</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"error\"><span>Error</span></label></div></div><div id=\"positionGroup\"><div class=\"controls radio-controls\"><label class=\"radio-header position-header\">Position</label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-right\"> <span>Top Right</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-right\"> <span>Bottom Right</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-left\"> <span>Bottom Left</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-left\"> <span>Top Left</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-full-width\"> <span>Top Full Width</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-full-width\"> <span>Bottom Full Width</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-center\"> <span>Top Center</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-center\"> <span>Bottom Center</span></label></div></div></div><div class=\"col-md-2 col-sm-3\"><div class=\"control\"><label for=\"timeOut\">Time out</label> <input type=\"text\" class=\"form-control\" id=\"timeOut\" ng-model=\"options.timeOut\" placeholder=\"ms\"> <label class=\"sub-label\" for=\"timeOut\">If you set it to 0, it will stick</label></div><div class=\"control\"><label for=\"extendedTimeOut\">Extended time out</label> <input type=\"text\" class=\"form-control\" id=\"extendedTimeOut\" ng-model=\"options.extendedTimeOut\" placeholder=\"ms\"></div><div class=\"control\"><label for=\"maxOpened\">Maximum number of toasts</label> <input type=\"text\" class=\"form-control\" id=\"maxOpened\" ng-model=\"options.maxOpened\" value=\"0\"> <label for=\"maxOpened\" class=\"sub-label\">0 means no limit</label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.autoDismiss\" type=\"checkbox\" id=\"autoDismiss\"> <span>Auto dismiss</span></label></div></div><div class=\"col-md-5 col-sm-12\"><label>Result:</label><pre class=\"result-toastr\" id=\"toastrOptions\">{{optionsStr}}</pre></div></div><div class=\"row\"><div class=\"col-md-12 button-row\"><button ng-click=\"openToast()\" class=\"btn btn-primary\">Open Toast</button> <button ng-click=\"openRandomToast()\" class=\"btn btn-primary\">Random Toast</button> <button ng-click=\"clearToasts()\" class=\"btn btn-danger\">Clear Toasts</button> <button ng-click=\"clearLastToast()\" class=\"btn btn-danger\">Clear Last Toast</button></div></div></div>");
$templateCache.put("app/widgets/ui/panels/panels.html","<h2>Default panels</h2><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-class=\"xsmall-panel light-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-title=\"Panel with header\" ba-panel-class=\"xsmall-panel light-text\">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-title=\"Panel with header & scroll\" ba-panel-class=\"xsmall-panel with-scroll light-text\"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel xsmall-panel\"><div class=\"panel-body\"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class=\"p-with-code\">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel xsmall-panel\"><div class=\"panel-heading\">Panel Heading</div><div class=\"panel-body\"><p class=\"p-with-code\">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-body footer-panel\"><p class=\"p-with-code\">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class=\"panel-footer\">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class=\"row\"><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-default contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-default class</div><div class=\"panel-body\">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-primary contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-primary class</div><div class=\"panel-body\">Sample <code>.panel-primary</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-success contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-success class</div><div class=\"panel-body\">Sample <code>.panel-success</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-info contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-info class</div><div class=\"panel-body\">Sample <code>.panel-info</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-warning contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-warning class</div><div class=\"panel-body\">Sample <code>.panel-warning</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-danger contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-danger class</div><div class=\"panel-body\">Sample <code>.panel-danger</code> panel</div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h2>Panel Group</h2><div class=\"panel-group\"><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-heading\">Panel group 1</div><div class=\"panel-body\"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-heading\">Panel group 2</div><div class=\"panel-body\"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>");
$templateCache.put("app/widgets/ui/progressBars/progressBars.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/basic.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Striped\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/striped.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"With label\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/label.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Animated\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/animated.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Stacked\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/stacked.html\'\"></div></div></div></div>");
$templateCache.put("app/widgets/ui/slider/slider.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Ion Range Slider\" ba-panel-class=\"with-scroll\"><div class=\"slider-box\"><h5>Basic</h5><ion-slider type=\"single\" grid=\"false\" min=\"0\" max=\"100\" from=\"45\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With prefix</h5><ion-slider type=\"single\" grid=\"true\" min=\"100\" max=\"1200\" prefix=\"$\" from=\"420\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With postfix</h5><ion-slider type=\"single\" grid=\"true\" min=\"-90\" max=\"90\" postfix=\"°\" from=\"36\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Two way range</h5><ion-slider type=\"double\" grid=\"true\" min=\"100\" max=\"1200\" from=\"420\" to=\"900\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With Steps</h5><ion-slider type=\"single\" grid=\"true\" min=\"0\" max=\"1000\" from=\"300\" step=\"50\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Decorating numbers</h5><ion-slider type=\"single\" grid=\"true\" min=\"0\" max=\"1000000\" from=\"300000\" step=\"1000\" prettify-separator=\".\" prettify=\"true\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Using custom values array</h5><ion-slider type=\"single\" grid=\"true\" from=\"5\" step=\"1000\" values=\"[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Disabled</h5><ion-slider type=\"single\" grid=\"false\" min=\"0\" max=\"100\" from=\"45\" disable=\"true\"></ion-slider></div></div></div></div>");
$templateCache.put("app/widgets/ui/tabs/contextualAccordion.html","<uib-accordion><uib-accordion-group heading=\"Primary\" panel-class=\"panel-primary bootstrap-panel accordion-panel\">Primary <i class=\"ion-heart\"></i></uib-accordion-group><uib-accordion-group heading=\"Success\" panel-class=\"panel-success bootstrap-panel accordion-panel\">Success <i class=\"ion-checkmark-round\"></i></uib-accordion-group><uib-accordion-group heading=\"Info\" panel-class=\"panel-info bootstrap-panel accordion-panel\">Info <i class=\"ion-information-circled\"></i></uib-accordion-group><uib-accordion-group heading=\"Warning\" panel-class=\"panel-warning bootstrap-panel accordion-panel\">Warning <i class=\"ion-alert\"></i></uib-accordion-group><uib-accordion-group heading=\"Danger\" panel-class=\"panel-danger bootstrap-panel accordion-panel\">Danger <i class=\"ion-nuclear\"></i></uib-accordion-group></uib-accordion>");
$templateCache.put("app/widgets/ui/tabs/mainTabs.html","<uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"Start\"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class=\"text-center\"><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Shop\' | kameleonImg )}}\"></div><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Programming\' | kameleonImg )}}\"></div><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Dna\' | kameleonImg )}}\"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Getting Done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init=\"$dropdownTabActive = 1\" class=\"with-dropdown\"><uib-tab-heading uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" ng-click=\"$event.stopPropagation()\">Dropdown tab <i class=\"caret\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a ng-click=\"$dropdownTabActive = 1; $tabSetStatus.activeTab = 3\">Tab 1</a></li><li><a ng-click=\"$dropdownTabActive = 2; $tabSetStatus.activeTab = 3\">Tab 2</a></li></ul></uib-tab-heading><div ng-show=\"$dropdownTabActive == 1\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show=\"$dropdownTabActive == 2\"><p class=\"text-center\"><button class=\"btn btn-danger\">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>");
$templateCache.put("app/widgets/ui/tabs/sampleAccordion.html","<uib-accordion><uib-accordion-group is-open=\"true\" heading=\"Static Header, initially expanded\" panel-class=\"bootstrap-panel accordion-panel panel-default\">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading=\"Dynamic Body Content\" panel-class=\"bootstrap-panel accordion-panel panel-default\"><p>The body of the uib-accordion group grows to fit the contents</p><button type=\"button\" class=\"btn btn-primary btn-sm\">Add Item</button></uib-accordion-group><uib-accordion-group heading=\"Custom template\" panel-class=\"bootstrap-panel accordion-panel panel-default\">Hello</uib-accordion-group><uib-accordion-group panel-class=\"bootstrap-panel accordion-panel panel-default\"><uib-accordion-heading>I can have markup, too! <i class=\"fa pull-right ion-settings\"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>");
$templateCache.put("app/widgets/ui/tabs/sideTabs.html","<div ba-panel=\"\" ba-panel-class=\"tabs-panel xsmall-panel with-scroll\"><uib-tabset class=\"tabs-left\"><uib-tab heading=\"Start\"><p class=\"text-center\">Take up one idea.</p><div class=\"kameleon-icon-tabs kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Key\' | kameleonImg )}}\"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading=\"Get it done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Achieve\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel=\"\" ba-panel-class=\"tabs-panel xsmall-panel with-scroll\"><uib-tabset class=\"tabs-right\"><uib-tab heading=\"Start\"><p class=\"text-center\">Take up one idea.</p><div class=\"kameleon-icon-tabs kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Phone-Booth\' | kameleonImg )}}\"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading=\"Get it done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Achieve\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>");
$templateCache.put("app/widgets/ui/tabs/tabs.html","<div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll horizontal-tabs tabs-panel medium-panel\"><div ng-include=\"\'app/pages/ui/tabs/mainTabs.html\'\"></div></div></div><div class=\"col-md-6 tabset-group\" ng-include=\"\'app/pages/ui/tabs/sideTabs.html\'\"></div></div><div class=\"row accordions-row\"><div class=\"col-md-6\" ng-include=\"\'app/pages/ui/tabs/sampleAccordion.html\'\"></div><div class=\"col-md-6\" ng-include=\"\'app/pages/ui/tabs/contextualAccordion.html\'\"></div></div></div>");
$templateCache.put("app/widgets/ui/typography/typography.html","<div class=\"typography-document-samples row-fluid\"><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll heading-widget\" ba-panel-title=\"Text Size\"><div class=\"section-block\"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class=\"section-block\"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll more-text-widget\" ba-panel-title=\"Some more text\"><div class=\"section-block light-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class=\"section-block regular-text\"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class=\"section-block upper-text bold-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class=\"section-block bold-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class=\"section-block small-text\"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll lists-widget\" ba-panel-title=\"Lists\"><div class=\"section-block\"><h5 class=\"list-header\">Unordered list:</h5><ul class=\"blur\"><li>Lorem ipsum dolor sit amet</li><li>Сlacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class=\"list-header\">Ordered Lists:</h5><ol class=\"blur\"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class=\"accent\">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll color-widget\" ba-panel-title=\"Text Color\"><div class=\"section-block red-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class=\"section-block yellow-text\"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class=\"section-block links\"><p>Lorem ipsum <a href=\"\">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href=\"\">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href=\"\">mattis</a> vel eros. In sed ornare nulla.</p></div><div class=\"section-block links\"><p><a href=\"\">Active link — #209e91</a></p><p class=\"hovered\"><a href=\"\">Hover link — #17857a</a></p></div></div></div></div><div class=\"row-fluid\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><div ba-panel=\"\" ba-panel-class=\"banner-column-panel\"><div class=\"banner\"><div class=\"large-banner-wrapper\"><img ng-src=\"{{::( \'app/typography/banner.png\' | appImage )}}\" alt=\"\"></div><div class=\"banner-text-wrapper\"><div class=\"banner-text\"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class=\"section\"><h2>Columns</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo03.png\' | appImage )}}\" alt=\"\" title=\"\"></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href=\"\">dapibus</a> magna rutrum. Ornare neque suspendisse <a href=\"\">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href=\"\">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class=\"col-sm-6\"><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo01.png\' | appImage )}}\" alt=\"\" title=\"\"></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class=\"separator\"></div><div class=\"row\"><div class=\"col-sm-4\"><h4>Column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo04.png\' | appImage )}}\" alt=\"\"></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href=\"\" class=\"learn-more\">Lean more</a></div><div class=\"col-sm-4\"><h4>Yet another column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo05.png\' | appImage )}}\" alt=\"\"></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href=\"\" class=\"learn-more\">Lean more</a></div><div class=\"col-sm-4\"><h4>Third column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo06.png\' | appImage )}}\" alt=\"\"></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href=\"\" class=\"learn-more\">Lean more</a></div></div><div class=\"separator\"></div></div></div></div></div>");
$templateCache.put("app/dashboard/tradeBook/transaction/templates/basic.html","<div class=\"row\"><div class=\"col-md-12\"><h3 class=\"with-line\">Transaction Information <button type=\"button\" ng-if=\"vm.transaction.basic.productItemId\" ng-click=\"vm.changeProductSpecs()\" class=\"btn pull-right btn-xs btn-success\">Change Product Specs</button></h3><div class=\"row wizard-containers\"><div class=\"row\"><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Date</label><div class=\"\"><date-picker-input date=\"vm.transaction.basic.date\" name=\"date\"></date-picker-input><ng-messages for=\"vm.transactionForm.date.$error\" ng-show=\"(vm.transactionForm.$submitted && vm.transactionForm.date.$invalid) || (vm.transactionForm.date.$invalid && vm.transactionForm.date.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter transaction date.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label for=\"buyer\" class=\"with-line control-label\">Buyer</label><div class=\"\"><selectize ng-required=\"true\" placeholder=\"Buyer\" name=\"buyer\" id=\"buyer\" ng-change=\"vm.transaction.basic.contractualBuyerId = (vm.transaction.basic.contractualBuyerId) ? (vm.transaction.basic.contractualBuyerId) : vm.transaction.basic.buyerId\" config=\"vm.buyerConfig\" options=\"vm.buyerOptions.list\" ng-model=\"vm.transaction.basic.buyerId\"></selectize><ng-messages for=\"vm.transactionForm.buyer.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.buyer.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select Buyer</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label for=\"seller\" class=\"with-line control-label\">Seller</label><div class=\"\"><selectize placeholder=\"Seller\" ng-required=\"true\" name=\"seller\" id=\"seller\" config=\"vm.sellerConfig\" options=\"vm.sellerOptions.list\" ng-model=\"vm.transaction.basic.sellerId\"></selectize><ng-messages for=\"vm.transactionForm.seller.$error\" ng-if=\"(vm.transactionForm.$submitted && vm.transactionForm.seller.$invalid) || (vm.transactionForm.seller.$invalid && vm.transactionForm.seller.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select seller.</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label for=\"productItem\" class=\"control-label with-line\">Product Item</label><div class=\"\"><selectize ng-required=\"true\" name=\"productItem\" id=\"productItem\" config=\"vm.productItemConfig\" options=\"vm.productItemOptions.list\" ng-model=\"vm.transaction.basic.productItemId\"></selectize><ng-messages for=\"vm.transactionForm.productItem.$error\" ng-if=\"(vm.transactionForm.$submitted && vm.transactionForm.productItem.$invalid) || (vm.transactionForm.productItem.$invalid && vm.transactionForm.productItem.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter product item.</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label for=\"productItem\" class=\"with-line control-label\">Contractual</label><div class=\"\"><selectize ng-required=\"true\" placeholder=\"Contractual Buyer\" name=\"contractbuyer\" id=\"contractbuyer\" config=\"vm.buyerConfig\" options=\"vm.buyerOptions.list\" ng-model=\"vm.transaction.basic.contractualBuyerId\"></selectize><ng-messages for=\"vm.transactionForm.contractbuyer.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.contractbuyer.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter contractual buyer.</div></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Packaging</label><div class=\"\"><selectize placeholder=\"Packaging\" ng-required=\"true\" name=\"packaging\" id=\"packaging\" config=\"vm.packagingConfig\" options=\"vm.packagingOptions.list\" ng-model=\"vm.transaction.basic.packagingId\"></selectize><ng-messages for=\"vm.transactionForm.packaging.$error\" ng-show=\"(vm.transactionForm.$submitted && vm.transactionForm.packaging.$invalid) || (vm.transactionForm.packaging.$invalid && vm.transactionForm.packaging.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter product packaging.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Quantity <span class=\"titled\">FCL</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.transaction.basic.quantityFcl\" class=\"form-control\" name=\"quantityFCL\" placeholder=\"Quantity in FCL\"><ng-messages for=\"vm.transactionForm.quantityFCL.$error\" ng-show=\"(vm.transactionForm.$submitted || vm.transactionForm.quantityFCL.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter quantity in FCL.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Quantity in FCL can only have numbers.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Quantity <span class=\"titled\">MT</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.transaction.basic.quantity\" class=\"form-control\" name=\"quantity\" placeholder=\"Quantity in MT\"><ng-messages for=\"vm.transactionForm.quantity.$error\" ng-show=\"(vm.transactionForm.$submitted || vm.transactionForm.quantity.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter quantity value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Quantity can only have numbers.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line\">Price <span class=\"titled\">US$ / MT</span></label><div class=\"\"><input required=\"\" ng-pattern=\"/^[0-9.]+$/i\" ng-model=\"vm.transaction.basic.price\" class=\"form-control\" name=\"price\" placeholder=\"Price US$ / {{vm.transaction.basic.quantityMetricId ? vm.transaction.basic.quantityMetricId : \'MT\'}}\"><ng-messages for=\"vm.transactionForm.price.$error\" ng-show=\"(vm.transactionForm.$submitted && vm.transactionForm.price.$invalid) || (vm.transactionForm.price.$invalid && vm.transactionForm.price.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter price value.</ng-message><ng-message class=\"errorValidation\" when=\"pattern\">Price can only have numbers.</ng-message></ng-messages></div></div><div class=\"col-md-2\"><label class=\"with-line control-label\">Primary Transaction File ID</label><selectize allowemptyoption=\"true\" placeholder=\"Primary Transaction\" ng-required=\"true\" config=\"vm.primaryFileConfig\" options=\"vm.primaryFileOptions.list\" ng-model=\"vm.transaction.basic.primaryTransaction\"></selectize></div><div class=\"col-md-2\"><label class=\"with-line control-label\">Primary Shipment File Id</label><selectize allowemptyoption=\"true\" placeholder=\"Primary Shipment\" ng-required=\"true\" config=\"vm.partialShipConfig\" options=\"vm.partialShipOptions.list\" ng-model=\"vm.transaction.basic.primaryShipment\"></selectize></div><div class=\"form-group col-md-4\"><label class=\"with-line control-label\">File ID</label><div class=\"\"><input required=\"\" ng-model=\"vm.transaction.basic.fileId\" class=\"form-control\" name=\"fileId\" placeholder=\"File Id\"><ng-messages for=\"vm.transactionForm.fileId.$error\" ng-show=\"(vm.transactionForm.$submitted || vm.transactionForm.fileId.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter a valid file Id.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Contract ID</label><div class=\"\"><input ng-model=\"vm.transaction.basic.contractId\" class=\"form-control\" name=\"contractId\" placeholder=\"Contract Id\"></div></div><div class=\"form-group col-md-4 col-md-offset-4 clearfix\"><label class=\"with-line control-label\">Shipment Start</label><div class=\"\"><date-picker-input date=\"vm.transaction.basic.shipmentStart\" name=\"shipmentStart\"></date-picker-input><ng-messages for=\"vm.transactionForm.shipmentStart.$error\" ng-show=\"(vm.transactionForm.$submitted || vm.transactionForm.shipmentStart.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter shipment start date.</ng-message></ng-messages></div></div><div class=\"form-group col-md-4 clearfix\"><label class=\"with-line control-label\">Shipment End</label><div class=\"\"><date-picker-input date=\"vm.transaction.basic.shipmentEnd\" name=\"shipmentEnd\"></date-picker-input><ng-messages for=\"vm.transactionForm.shipmentEnd.$error\" ng-show=\"(vm.transactionForm.$submitted || vm.transactionForm.shipmentEnd.$dirty)\" role=\"alert\"><ng-message class=\"errorValidation\" when=\"required\">Please enter shipment start date.</ng-message></ng-messages></div></div><div class=\"form-group col-md-12 clearfix\"><label class=\"with-line control-label\">Other Information</label><div class=\"\"><textarea ng-model=\"vm.transaction.basic.otherInfo\" class=\"form-control\">\n\n                            </textarea></div></div></div></div><div class=\"row wizard-containers\"><div class=\"col-xs-12\"></div></div></div></div>");
$templateCache.put("app/dashboard/tradeBook/transaction/templates/commission.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Commission Details</h3><div class=\"row wizard-containers\"><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Commission Type</label><div class=\"col-sm-9\"><selectize placeholder=\"Commission Type\" ng-required=\"true\" name=\"commissionType\" id=\"commissionType\" config=\"vm.commissionTypeConfig\" options=\"vm.commissionTypeOptions.list\" ng-model=\"vm.transaction.commission.typeId\"></selectize><ng-messages for=\"vm.transactionForm.commissionType.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.commissionType.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please select commission type.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Commission</label><div class=\"col-sm-9\"><input required=\"\" ng-model=\"vm.transaction.commission.commission\" class=\"form-control\" name=\"commission\" ng-pattern=\"/^[0-9.]+$/i\" placeholder=\"Commission\"><ng-messages for=\"vm.transactionForm.commission.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.commission.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter commission.</div><div ng-message=\"pattern\" class=\"errorValidation\">Commission can only have number.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Differance</label><div class=\"col-sm-9\"><input required=\"\" ng-model=\"vm.transaction.commission.difference\" class=\"form-control\" name=\"difference\" ng-pattern=\"/^[0-9.]+$/i\" placeholder=\"Difference\"><ng-messages for=\"vm.transactionForm.difference.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.difference.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter commission difference.</div><div ng-message=\"pattern\" class=\"errorValidation\">Commission difference can only have number.</div></ng-messages></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Discount</label><div class=\"col-sm-9\"><input required=\"\" ng-model=\"vm.transaction.commission.discount\" class=\"form-control\" name=\"discount\" ng-pattern=\"/^[0-9.]+$/i\" placeholder=\"Discount\"><ng-messages for=\"vm.transactionForm.discount.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.discount.$dirty)\"><div ng-message=\"required\" class=\"errorValidation\">Please enter commission discount.</div><div ng-message=\"pattern\" class=\"errorValidation\">Commission discount can only have numbers.</div></ng-messages></div></div></div><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label for=\"buyerBroker\" class=\"col-sm-3 control-label\">Buyer Broker</label><div class=\"col-sm-9\"><selectize placeholder=\"Buyer Broker\" name=\"buyerBroker\" id=\"buyerBroker\" config=\"vm.brokerConfig\" options=\"vm.brokerOptions.list\" ng-model=\"vm.transaction.commission.buyerBrokerId\"></selectize></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Buyer Broker Commission Type</label><div class=\"col-sm-9\"><selectize ng-disabled=\"!vm.transaction.commission.buyerBrokerId\" placeholder=\"Commission Type\" name=\"buyerBrokerCommissionType\" id=\"buyerBrokerCommissionType\" config=\"vm.commissionTypeConfig\" options=\"vm.commissionTypeOptions.list\" ng-model=\"vm.transaction.commission.buyerBrokerCommissionTypeId\"></selectize></div></div><div class=\"form-group row clearfix\"><label class=\"col-sm-3 control-label\">Buyer Broker Commission</label><div class=\"col-sm-9\"><input ng-model=\"vm.transaction.commission.buyerBrokerCommission\" class=\"form-control\" ng-pattern=\"/^[0-9.]+$/i\" ng-disabled=\"!vm.transaction.commission.buyerBrokerId\" name=\"buyerBrokerCommission\" placeholder=\"Buyer Broker Commission\"><ng-messages for=\"vm.transactionForm.buyerBrokerCommission.$error\" ng-if=\"(vm.transactionForm.$submitted || vm.transactionForm.buyerBrokerCommission.$dirty)\"><div ng-message=\"pattern\" class=\"errorValidation\">Please enter valid commission value.</div></ng-messages></div></div></div><div class=\"col-md-4\"><div class=\"form-group row clearfix\"><label for=\"sellerBroker\" class=\"col-sm-3 control-label\">Seller Broker</label><div class=\"col-sm-9\"><selectize placeholder=\"Seller Broker\" name=\"sellerBroker\" id=\"sellerBroker\" config=\"vm.brokerConfig\" options=\"vm.brokerOptions.list\" ng-model=\"vm.transaction.commission.sellerBrokerId\"></selectize></div></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/tradeBook/transaction/templates/documents.html","<form name=\"vm.transactionDocumentForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Documents</h3></div></div></div></form>");
$templateCache.put("app/dashboard/tradeBook/transaction/templates/notes.html","<form name=\"vm.transactionDocumentForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Notes</h3></div></div></div></form>");
$templateCache.put("app/dashboard/tradeBook/transaction/templates/productSpecs.html","<div class=\"modal-content\"><div class=\"modal-header\"><h3 class=\"with-line\">Product Specification</h3></div><div class=\"modal-body\"><div class=\"row productSpecs\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><div ng-repeat=\"spec in productSpecs\" class=\"slider-box col-sm-12 col-md-4\"><h5 ng-bind=\"spec.name\"></h5><input style=\"margin-top: 25px;\" class=\"form-control\" ng-model=\"spec.value\" ng-if=\"spec.type==\'text\'\"><ion-slider ng-if=\"spec.type==\'percentage\'\" type=\"single\" grid=\"true\" from=\"spec.value\" ng-model=\"spec.value\" min=\"0\" max=\"100\" prefix=\"%\" disable=\"false\"></ion-slider></div></div></div></div></div><div class=\"modal-footer\"><button type=\"submit\" class=\"btn btn-default\" ng-click=\"$dismiss()\">Cancel</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"saveSpecs(productSpecs)\">Done</button></div></div>");
$templateCache.put("app/dashboard/tradeBook/transaction/templates/shipment.html","<form name=\"vm.transactionShipmentForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"row wizard-containers\"><h3 class=\"with-line\">Shipment</h3></div></div></div></form>");
$templateCache.put("app/widgets/charts/amCharts/areaChart/areaChart.html","<div id=\"areaChart\" class=\"admin-chart\" ng-controller=\"AreaChartCtrl\"></div>");
$templateCache.put("app/widgets/charts/amCharts/barChart/barChart.html","<div id=\"barChart\" class=\"admin-chart\" ng-controller=\"BarChartCtrl\"></div>");
$templateCache.put("app/widgets/charts/amCharts/combinedChart/combinedChart.html","<div id=\"zoomAxisChart\" class=\"admin-chart\" ng-controller=\"combinedChartCtrl\"></div>");
$templateCache.put("app/widgets/charts/amCharts/funnelChart/funnelChart.html","<div id=\"funnelChart\" class=\"admin-chart\" ng-controller=\"FunnelChartCtrl\"></div>");
$templateCache.put("app/widgets/charts/amCharts/ganttChart/ganttChart.html","<div id=\"gnattChart\" class=\"admin-chart\" ng-controller=\"ganttChartCtrl\"></div>");
$templateCache.put("app/widgets/charts/amCharts/lineChart/lineChart.html","<div id=\"lineChart\" class=\"admin-chart\" ng-controller=\"LineChartCtrl\"></div>");
$templateCache.put("app/widgets/charts/amCharts/pieChart/pieChart.html","<div id=\"pieChart\" class=\"admin-chart\" ng-controller=\"PieChartCtrl\"></div>");
$templateCache.put("app/widgets/components/mail/composeBox/compose.html","<div class=\"compose-header\"><span>New message</span> <span class=\"header-controls\"><i class=\"ion-minus-round\"></i> <i class=\"ion-arrow-resize\"></i> <i ng-click=\"$dismiss()\" class=\"ion-close-round\"></i></span></div><div><input type=\"text\" class=\"form-control compose-input default-color\" placeholder=\"To\" ng-model=\"boxCtrl.to\"> <input type=\"text\" class=\"form-control compose-input default-color\" placeholder=\"Subject\" ng-model=\"boxCtrl.subject\"><div class=\"compose-container\"><text-angular-toolbar ta-toolbar-class=\"toolbarMain\" name=\"toolbarMain\" ta-toolbar=\"[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]\"></text-angular-toolbar><text-angular name=\"htmlcontent\" ta-target-toolbars=\"toolbarMain,toolbarFooter\" ng-model=\"boxCtrl.text\"></text-angular></div></div><div class=\"compose-footer clearfix\"><button type=\"button\" ng-click=\"$dismiss()\" class=\"btn btn-send\">Send</button><text-angular-toolbar ta-toolbar-class=\"toolbarFooter\" name=\"toolbarFooter\" ta-toolbar=\"[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]\"></text-angular-toolbar><div class=\"footer-controls\"><i class=\"footer-control-first compose-footer-icon ion-arrow-down-b\"></i> <i ng-click=\"$dismiss()\" class=\"compose-footer-icon ion-android-delete\"></i></div></div>");
$templateCache.put("app/widgets/components/mail/detail/mailDetail.html","<div class=\"message-container\" ng-class=\"{\'expanded\': tabCtrl.navigationCollapsed}\"><div class=\"message\"><div class=\"row\"><div class=\"toggle-navigation-container detail-page\"><a href=\"\" class=\"collapse-navigation-link ion-navicon\" ng-click=\"tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed\"></a></div><button ui-sref=\"components.mail.label({label : detailCtrl.label})\" type=\"button\" class=\"back-button btn btn-default btn-with-icon\"><i class=\"ion-chevron-left\"></i>Back</button></div><div class=\"person-info row\"><div class=\"col-lg-4 col-md-12 no-padding\"><img ng-src=\"{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}\" class=\"human-picture\"><div class=\"name\"><h2 class=\"name-h\">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class=\"name-h second-name\">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class=\"mail-tag tag label {{detailCtrl.mail.tag}}\">{{detailCtrl.mail.tag}}</span></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12 no-padding\"><div class=\"contact-info phone-email\"><div><i class=\"ion-iphone\"></i> <span class=\"phone\">777-777-7777</span></div><div><i class=\"ion-email\"></i> <span class=\"email\">{{detailCtrl.mail.email}}</span></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12 no-padding\"><div class=\"contact-info position-address\"><div><span class=\"position\">{{detailCtrl.mail.position}}</span></div><div><span class=\"address\">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class=\"row\"></div><div class=\"line\"></div><div class=\"message-details\"><span class=\"subject\">{{detailCtrl.mail.subject}}</span> <span class=\"date\">• {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class=\"line\"></div><div ng-bind-html=\"detailCtrl.mail.body\" class=\"message-body\"></div><div class=\"line\"></div><div class=\"attachment\" ng-show=\"detailCtrl.mail.attachment\"><span class=\"file-links\">1 Attachment - <a href=\"\">View</a> | <a href=\"\">Download</a></span><div><i class=\"file-icon ion-document\"></i> <span class=\"file-name\">{{detailCtrl.mail.attachment}}</span></div></div><div class=\"line\" ng-show=\"detailCtrl.mail.attachment\"></div><div class=\"answer-container\"><button type=\"button\" class=\"btn btn-with-icon\" ng-click=\"tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')\"><i class=\"ion-reply\"></i>Reply</button> <button type=\"button\" class=\"btn btn-with-icon\" ng-click=\"tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)\"><i class=\"ion-forward\"></i>Forward</button> <button type=\"button\" class=\"btn btn-with-icon\"><i class=\"ion-printer\"></i>Print</button> <button type=\"button\" class=\"btn btn-with-icon\"><i class=\"ion-android-remove-circle\"></i>Spam</button> <button type=\"button\" class=\"btn btn-with-icon\"><i class=\"ion-android-delete\"></i>Delete</button></div></div><div ng-show=\"!detailCtrl.mail\"><h5 ng-class=\"text-center\">Nothing to show</h5></div></div>");
$templateCache.put("app/widgets/components/mail/list/mailList.html","<div class=\"side-message-navigation\" ng-class=\"{\'expanded\': tabCtrl.navigationCollapsed}\"><div class=\"mail-messages-control side-message-navigation-item\"><div class=\"toggle-navigation-container\"><a href=\"\" class=\"collapse-navigation-link ion-navicon\" ng-click=\"tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed\"></a></div><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"option1\"> <span class=\"select-all-label\">Select All</span></label> <button type=\"button\" class=\"btn btn-icon refresh-button\"><i class=\"ion-refresh\"></i></button><div class=\"btn-group\" uib-dropdown=\"\"><button type=\"button\" class=\"btn more-button\" uib-dropdown-toggle=\"\">More <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"messages\"><table><tr ng-repeat=\"m in listCtrl.messages track by m.id | orderBy:\'-date\'\" class=\"side-message-navigation-item little-human shineHover {{m.tag}}\"><td class=\"check-td\"><div class=\"mail-checkbox\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\"> <span></span></label></div></td><td class=\"photo-td\" ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><img ng-src=\"{{m.name.split(\' \')[0] | profilePicture}}\" class=\"little-human-picture\"></td><td ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><div class=\"name-container\"><div><span class=\"name\">{{m.name}}</span></div><div><span class=\"tag label label-primary {{m.tag}}\">{{m.tag}}</span></div></div></td><td ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><div class=\"additional-info\"><span class=\"subject\">{{m.subject}}</span></div></td><td ui-sref=\"components.mail.detail({id: m.id, label: listCtrl.label})\"><div class=\"mail-body-part\">{{m.body | plainText}}</div></td><td class=\"date\"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>");
$templateCache.put("app/widgets/form/inputs/widgets/checkboxesRadios.html","<div class=\"checkbox-demo-row\"><div class=\"input-demo checkbox-demo row\"><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"option1\"> <span>Check 1</span></label></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox02\" value=\"option2\"> <span>Check 2</span></label></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox03\" value=\"option3\"> <span>Check 3</span></label></div></div><div class=\"input-demo radio-demo row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio1\" value=\"option1\"> <span>Option 1</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio2\" value=\"option2\"> <span>Option 2</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio3\" value=\"option3\"> <span>Option3</span></label></div></div></div><div><div class=\"checkbox disabled\"><label class=\"custom-checkbox nowrap\"><input type=\"checkbox\" value=\"\" disabled=\"\"> <span>Checkbox is disabled</span></label></div><div class=\"radio disabled\"><label class=\"custom-radio nowrap\"><input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios3\" value=\"option3\" disabled=\"\"> <span>Disabled option</span></label></div></div>");
$templateCache.put("app/widgets/form/inputs/widgets/inputGroups.html","<div class=\"input-group\"><span class=\"input-group-addon input-group-addon-primary addon-left\" id=\"basic-addon1\">@</span> <input type=\"text\" class=\"form-control with-primary-addon\" placeholder=\"Username\" aria-describedby=\"basic-addon1\"></div><div class=\"input-group\"><input type=\"text\" class=\"form-control with-warning-addon\" placeholder=\"Recipient\'s username\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-addon input-group-addon-warning addon-right\" id=\"basic-addon2\">@example.com</span></div><div class=\"input-group\"><span class=\"input-group-addon addon-left input-group-addon-success\">$</span> <input type=\"text\" class=\"form-control with-success-addon\" aria-label=\"Amount (to the nearest dollar)\"> <span class=\"input-group-addon addon-right input-group-addon-success\">.00</span></div><div class=\"input-group\"><input type=\"text\" class=\"form-control with-danger-addon\" placeholder=\"Search for...\"> <span class=\"input-group-btn\"><button class=\"btn btn-danger\" type=\"button\">Go!</button></span></div>");
$templateCache.put("app/widgets/form/inputs/widgets/standardFields.html","<form><div class=\"form-group\"><label for=\"input01\">Text</label> <input type=\"text\" class=\"form-control\" id=\"input01\" placeholder=\"Text\"></div><div class=\"form-group\"><label for=\"input02\">Password</label> <input type=\"password\" class=\"form-control\" id=\"input02\" placeholder=\"Password\"></div><div class=\"form-group\"><label for=\"input03\">Rounded Corners</label> <input type=\"text\" class=\"form-control form-control-rounded\" id=\"input03\" placeholder=\"Rounded Corners\"></div><div class=\"form-group\"><label for=\"input04\">With help</label> <input type=\"text\" class=\"form-control\" id=\"input04\" placeholder=\"With help\"> <span class=\"help-block sub-little-text\">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class=\"form-group\"><label for=\"input05\">Disabled Input</label> <input type=\"text\" class=\"form-control\" id=\"input05\" placeholder=\"Disabled Input\" disabled=\"\"></div><div class=\"form-group\"><label for=\"textarea01\">Textarea</label> <textarea placeholder=\"Default Input\" class=\"form-control\" id=\"textarea01\"></textarea></div><div class=\"form-group\"><input type=\"text\" class=\"form-control input-sm\" id=\"input2\" placeholder=\"Small Input\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control input-lg\" id=\"input4\" placeholder=\"Large Input\"></div></form>");
$templateCache.put("app/widgets/form/inputs/widgets/validationStates.html","<div class=\"form-group has-success\"><label class=\"control-label\" for=\"inputSuccess1\">Input with success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess1\"></div><div class=\"form-group has-warning\"><label class=\"control-label\" for=\"inputWarning1\">Input with warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning1\"></div><div class=\"form-group has-error\"><label class=\"control-label\" for=\"inputError1\">Input with error</label> <input type=\"text\" class=\"form-control\" id=\"inputError1\"></div><div class=\"has-success\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" value=\"option1\"> <span>Checkbox with success</span></label></div></div><div class=\"has-warning\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxWarning\" value=\"option1\"> <span>Checkbox with warning</span></label></div></div><div class=\"has-error\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxError\" value=\"option1\"> <span>Checkbox with error</span></label></div></div><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputSuccess2\">Input with success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess2\" aria-describedby=\"inputSuccess2Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputSuccess2Status\" class=\"sr-only\">(success)</span></div><div class=\"form-group has-warning has-feedback\"><label class=\"control-label\" for=\"inputWarning2\">Input with warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning2\" aria-describedby=\"inputWarning2Status\"> <i class=\"ion-alert-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputWarning2Status\" class=\"sr-only\">(warning)</span></div><div class=\"form-group has-error has-feedback\"><label class=\"control-label\" for=\"inputError2\">Input with error</label> <input type=\"text\" class=\"form-control\" id=\"inputError2\" aria-describedby=\"inputError2Status\"> <i class=\"ion-android-cancel form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputError2Status\" class=\"sr-only\">(error)</span></div><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Input group with success</label><div class=\"input-group\"><span class=\"input-group-addon addon-left\">@</span> <input type=\"text\" class=\"form-control\" id=\"inputGroupSuccess1\" aria-describedby=\"inputGroupSuccess1Status\"></div><i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div>");
$templateCache.put("app/widgets/form/layouts/widgets/basicForm.html","<form><div class=\"form-group\"><label for=\"exampleInputEmail1\">Email address</label> <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"Email\"></div><div class=\"form-group\"><label for=\"exampleInputPassword1\">Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" placeholder=\"Password\"></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Check me out</span></label></div><button type=\"submit\" class=\"btn btn-danger\">Submit</button></form>");
$templateCache.put("app/widgets/form/layouts/widgets/blockForm.html","<div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">First Name</label> <input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"First Name\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputLastName\">Last Name</label> <input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"Last Name\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">Email</label> <input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">Website</label> <input type=\"text\" class=\"form-control\" id=\"inputWebsite\" placeholder=\"Website\"></div></div></div><button type=\"submit\" class=\"btn btn-primary\">Submit</button>");
$templateCache.put("app/widgets/form/layouts/widgets/formWithoutLabels.html","<form><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Recipients\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Subject\"></div><div class=\"form-group\"><textarea class=\"form-control\" placeholder=\"Message\"></textarea></div><button type=\"submit\" class=\"btn btn-success\">Send</button></form>");
$templateCache.put("app/widgets/form/layouts/widgets/horizontalForm.html","<form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"Email\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"Password\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Remember me</span></label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-warning\">Sign in</button></div></div></form>");
$templateCache.put("app/widgets/form/layouts/widgets/inlineForm.html","<form class=\"row form-inline\"><div class=\"form-group col-sm-3 col-xs-6\"><input type=\"text\" class=\"form-control\" id=\"exampleInputName2\" placeholder=\"Name\"></div><div class=\"form-group col-sm-3 col-xs-6\"><input type=\"email\" class=\"form-control\" id=\"exampleInputEmail2\" placeholder=\"Email\"></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\">Send invitation</button></form>");
$templateCache.put("app/widgets/ui/buttons/widgets/buttonGroups.html","<div class=\"btn-group-example\"><div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\"><button type=\"button\" class=\"btn btn-danger\">Left</button> <button type=\"button\" class=\"btn btn-danger\">Middle</button> <button type=\"button\" class=\"btn btn-danger\">Right</button></div></div><div class=\"btn-toolbar-example\"><div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Toolbar with button groups\"><div class=\"btn-group\" role=\"group\" aria-label=\"First group\"><button type=\"button\" class=\"btn btn-primary\">1</button> <button type=\"button\" class=\"btn btn-primary\">2</button> <button type=\"button\" class=\"btn btn-primary\">3</button> <button type=\"button\" class=\"btn btn-primary\">4</button></div><div class=\"btn-group\" role=\"group\" aria-label=\"Second group\"><button type=\"button\" class=\"btn btn-primary\">5</button> <button type=\"button\" class=\"btn btn-primary\">6</button> <button type=\"button\" class=\"btn btn-primary\">7</button></div><div class=\"btn-group\" role=\"group\" aria-label=\"Third group\"><button type=\"button\" class=\"btn btn-primary\">8</button></div></div></div>");
$templateCache.put("app/widgets/ui/buttons/widgets/buttons.html","<div class=\"basic-btns\"><div class=\"row\"><div class=\"col-md-2\"><h5>Default button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5 class=\"row-sm\">Small button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary btn-sm\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-sm\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-sm\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info btn-sm\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning btn-sm\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-sm\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5 class=\"row-xs\">Extra small button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary btn-xs\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-xs\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-xs\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info btn-xs\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning btn-xs\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-xs\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5>Disabled button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary\" disabled=\"disabled\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success\" disabled=\"disabled\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info\" disabled=\"disabled\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning\" disabled=\"disabled\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger\" disabled=\"disabled\">Danger</button></div></div></div></div></div>");
$templateCache.put("app/widgets/ui/buttons/widgets/dropdowns.html","<div class=\"row btns-row\"><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\">Primary <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle=\"\">Success <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-info\" uib-dropdown-toggle=\"\">Info <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\">Default <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-warning\" uib-dropdown-toggle=\"\">Warning <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\">Danger <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div></div><h5 class=\"panel-subtitle\">Split button dropdowns</h5><div class=\"row btns-row\"><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-primary\">Primary</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-success\">Success</button> <button type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-info\">Info</button> <button type=\"button\" class=\"btn btn-info\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-default\">Default</button> <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-warning\">Warning</button> <button type=\"button\" class=\"btn btn-warning\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-danger\">Danger</button> <button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div></div>");
$templateCache.put("app/widgets/ui/buttons/widgets/iconButtons.html","<ul class=\"btn-list clearfix\"><li><button type=\"button\" class=\"btn btn-primary btn-icon\"><i class=\"ion-android-download\"></i></button></li><li><button type=\"button\" class=\"btn btn-default btn-icon\"><i class=\"ion-stats-bars\"></i></button></li><li><button type=\"button\" class=\"btn btn-success btn-icon\"><i class=\"ion-android-checkmark-circle\"></i></button></li><li><button type=\"button\" class=\"btn btn-info btn-icon\"><i class=\"ion-information\"></i></button></li><li><button type=\"button\" class=\"btn btn-warning btn-icon\"><i class=\"ion-android-warning\"></i></button></li><li><button type=\"button\" class=\"btn btn-danger btn-icon\"><i class=\"ion-nuclear\"></i></button></li></ul><h5 class=\"panel-subtitle\">Buttons with icons</h5><ul class=\"btn-list clearfix\"><li><button type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-download\"></i>Primary</button></li><li><button type=\"button\" class=\"btn btn-default btn-with-icon\"><i class=\"ion-stats-bars\"></i>Default</button></li><li><button type=\"button\" class=\"btn btn-success btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Success</button></li><li><button type=\"button\" class=\"btn btn-info btn-with-icon\"><i class=\"ion-information\"></i>Info</button></li><li><button type=\"button\" class=\"btn btn-warning btn-with-icon\"><i class=\"ion-android-warning\"></i>Warning</button></li><li><button type=\"button\" class=\"btn btn-danger btn-with-icon\"><i class=\"ion-nuclear\"></i>Danger</button></li></ul>");
$templateCache.put("app/widgets/ui/buttons/widgets/largeButtons.html","<div class=\"row btns-row btns-same-width-lg\"><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-primary btn-lg\">Primary</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-success btn-lg\">Success</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-info btn-lg\">Info</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-lg\">Default</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-warning btn-lg\">Warning</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-danger btn-lg\">Danger</button></div></div>");
$templateCache.put("app/widgets/ui/buttons/widgets/progressButtons.html","<div class=\"progress-buttons-container text-center default-text\"><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">fill horizontal</span> <button progress-button=\"progressFunction()\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">fill vertical</span> <button progress-button=\"progressFunction()\" pb-direction=\"vertical\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">shrink horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"shrink\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">shrink vertical</span> <button progress-button=\"progressFunction()\" pb-style=\"shrink\" pb-direction=\"vertical\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-bottom<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-bottom\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-top<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-top\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-left<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-left\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-right<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-right\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-down<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-down\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-up<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-up\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-left<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-left\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-right<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-right\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-back<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-back\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">flip-open<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"flip-open\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">slide-down<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"slide-down\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">move-up<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"move-up\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6\"><span class=\"button-title\">top-line<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"top-line\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6\"><span class=\"button-title\">lateral-lines<br>vertical</span> <button progress-button=\"progressFunction()\" pb-style=\"lateral-lines\" class=\"btn btn-info\">Submit</button></section></div></div>");
$templateCache.put("app/widgets/ui/icons/widgets/fontAwesomeIcons.html","<div class=\"row icons-list success awesomeIcons\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.fontAwesomeIcons\"><i class=\"fa {{icon}}\"></i></div></div><a href=\"http://fortawesome.github.io/Font-Awesome/icons/\" target=\"_blank\" class=\"see-all-icons\">See all Font Awesome icons</a>");
$templateCache.put("app/widgets/ui/icons/widgets/ionicons.html","<div class=\"row icons-list primary\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.ionicons\"><i class=\"{{icon}}\"></i></div></div><a href=\"http://ionicons.com/\" target=\"_blank\" class=\"see-all-icons\">See all ionicons icons</a>");
$templateCache.put("app/widgets/ui/icons/widgets/kameleon.html","<div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"icon in icons.kameleonIcons\"><div class=\"kameleon-icon\"><img ng-src=\"{{:: (icon.img | kameleonImg )}}\"><span>{{icon.name}}</span></div></div></div><a href=\"http://www.kameleon.pics/\" target=\"_blank\" class=\"see-all-icons\">See all Kamaleon icons</a>");
$templateCache.put("app/widgets/ui/icons/widgets/kameleonRounded.html","<div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"icon in icons.kameleonRoundedIcons\"><div class=\"kameleon-icon with-round-bg {{icon.color}}\"><img ng-src=\"{{::( icon.img | kameleonImg )}}\"><span>{{ icon.name }}</span></div></div></div><a href=\"http://www.kameleon.pics/\" target=\"_blank\" class=\"see-all-icons\">See all Kamaleon icons</a>");
$templateCache.put("app/widgets/ui/icons/widgets/socicon.html","<div class=\"row icons-list danger\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.socicon\"><i class=\"socicon\">{{ icon }}</i></div></div><a href=\"http://www.socicon.com/chart.php\" target=\"_blank\" class=\"see-all-icons\">See all Socicon icons</a>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/basicModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/dangerModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-danger\"><i class=\"ion-flame modal-icon\"></i><span>Error</span></div><div class=\"modal-body text-center\">Your information hasn\'t been saved!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/infoModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Information</span></div><div class=\"modal-body text-center\">You\'ve got a new email!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/largeModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/smallModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/successModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-success\"><i class=\"ion-checkmark modal-icon\"></i><span>Success</span></div><div class=\"modal-body text-center\">Your information has been saved successfully</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/widgets/ui/modals/modalTemplates/warningModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-android-warning modal-icon\"></i><span>Warning</span></div><div class=\"modal-body text-center\">Your computer is about to explode!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/widgets/ui/modals/notifications/notifications.html","<div class=\"modal-buttons same-width clearfix\" ng-controller=\"NotificationsCtrl\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"showSuccessMsg()\">Success Notification</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"showInfoMsg()\">Info Notification</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"showWarningMsg()\">Warning Notification</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"showErrorMsg()\">Danger Notification</button></div>");
$templateCache.put("app/widgets/ui/progressBars/widgets/animated.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/widgets/ui/progressBars/widgets/basic.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/widgets/ui/progressBars/widgets/label.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\">40% Complete (success)</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\">20% Complete</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\">60% Complete (warning)</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\">80% Complete (danger)</div></div>");
$templateCache.put("app/widgets/ui/progressBars/widgets/stacked.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" style=\"width: 35%\"><span class=\"sr-only\">35% Complete (success)</span></div><div class=\"progress-bar progress-bar-warning progress-bar-striped\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete (warning)</span></div><div class=\"progress-bar progress-bar-danger\" style=\"width: 10%\"><span class=\"sr-only\">10% Complete (danger)</span></div><div class=\"progress-bar progress-bar-info progress-bar-striped active\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete (warning)</span></div></div>");
$templateCache.put("app/widgets/ui/progressBars/widgets/striped.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/widgets/form/inputs/widgets/select/select.html","<div ng-controller=\"SelectpickerPanelCtrl as selectpickerVm\"><div class=\"form-group\"><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"Standard Select\" ng-model=\"selectpickerVm.standardSelected\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"></select></div><div class=\"form-group\"><select class=\"form-control selectpicker with-search\" data-live-search=\"true\" title=\"Select With Search\" selectpicker=\"\" ng-model=\"selectpickerVm.searchSelectedItem\" ng-options=\"item as item.label for item in selectpickerVm.selectWithSearchItems\"></select></div><div class=\"form-group\"><select class=\"form-control selectpicker\" title=\"Option Types\" selectpicker=\"\"><option>Standard option</option><option data-subtext=\"option subtext\">Option with subtext</option><option disabled=\"\">Disabled Option</option><option data-icon=\"glyphicon-heart\">Option with cion</option></select></div><div class=\"form-group\"><select class=\"form-control selectpicker\" disabled=\"\" title=\"Disabled Select\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Select with Option Groups\" selectpicker=\"\" ng-model=\"selectpickerVm.groupedSelectedItem\" ng-options=\"item as item.label group by item.group for item in selectpickerVm.groupedSelectItems\"></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Select with Divider\" selectpicker=\"\"><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider=\"true\"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class=\"form-group\"><select class=\"form-control\" title=\"Multiple Select\" multiple=\"\" selectpicker=\"\" ng-model=\"selectpickerVm.multipleSelectedItems\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Multiple Select with Limit\" multiple=\"\" data-max-options=\"2\" selectpicker=\"\" ng-model=\"selectpickerVm.multipleSelectedItems2\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Primary Select\" data-style=\"btn-primary\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Success Select\" data-style=\"btn-success\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Warning Select\" data-style=\"btn-warning\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Info Select\" data-style=\"btn-info\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Danger Select\" data-style=\"btn-danger\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Inverse Select\" data-style=\"btn-inverse\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>");
$templateCache.put("app/widgets/form/inputs/widgets/switch/switch.html","<div ng-controller=\"SwitchPanelCtrl as switchPanelVm\" class=\"switches clearfix\"><switch color=\"primary\" ng-model=\"switchPanelVm.switcherValues.primary\"></switch><switch color=\"warning\" ng-model=\"switchPanelVm.switcherValues.warning\"></switch><switch color=\"danger\" ng-model=\"switchPanelVm.switcherValues.danger\"></switch><switch color=\"info\" ng-model=\"switchPanelVm.switcherValues.info\"></switch><switch color=\"success\" ng-model=\"switchPanelVm.switcherValues.success\"></switch></div>");
$templateCache.put("app/widgets/form/inputs/widgets/tagsInput/tagsInput.html","<div class=\"form-group\"><div class=\"form-group\"><input type=\"text\" tag-input=\"primary\" value=\"Amsterdam,Washington,Sydney,Beijing,Cairo\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div><div class=\"form-group\"><input type=\"text\" tag-input=\"warning\" value=\"Minsk,Prague,Vilnius,Warsaw\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div><div class=\"form-group\"><input type=\"text\" tag-input=\"danger\" value=\"London,Berlin,Paris,Rome,Munich\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div></div>");}]);